
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref931"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref931"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("88YbF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MergeKeyStore = module.exports.BrowserLocalStorageKeyStore = module.exports.InMemoryKeyStore = module.exports.KeyStore = void 0;

var $kELc4 = parcelRequire("kELc4");
Object.defineProperty(module.exports, "KeyStore", {
    enumerable: true,
    get: function() {
        return $kELc4.KeyStore;
    }
});

var $kWbvD = parcelRequire("kWbvD");
Object.defineProperty(module.exports, "InMemoryKeyStore", {
    enumerable: true,
    get: function() {
        return $kWbvD.InMemoryKeyStore;
    }
});

var $8OBr1 = parcelRequire("8OBr1");
Object.defineProperty(module.exports, "BrowserLocalStorageKeyStore", {
    enumerable: true,
    get: function() {
        return $8OBr1.BrowserLocalStorageKeyStore;
    }
});

var $gFytt = parcelRequire("gFytt");
Object.defineProperty(module.exports, "MergeKeyStore", {
    enumerable: true,
    get: function() {
        return $gFytt.MergeKeyStore;
    }
});

});
parcelRegister("kELc4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyStore = void 0;
/**
 * KeyStores are passed to {@link Near} via {@link NearConfig}
 * and are used by the {@link InMemorySigner} to sign transactions.
 *
 * @example {@link connect}
 */ class $f09c26c2b800fad8$var$KeyStore {
}
module.exports.KeyStore = $f09c26c2b800fad8$var$KeyStore;

});

parcelRegister("kWbvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InMemoryKeyStore = void 0;

var $kELc4 = parcelRequire("kELc4");

var $lsY0f = parcelRequire("lsY0f");
/**
 * Simple in-memory keystore for mainly for testing purposes.
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#key-store}
 * @example
 * ```js
 * import { connect, keyStores, utils } from 'near-api-js';
 *
 * const privateKey = '.......';
 * const keyPair = utils.KeyPair.fromString(privateKey);
 *
 * const keyStore = new keyStores.InMemoryKeyStore();
 * keyStore.setKey('testnet', 'example-account.testnet', keyPair);
 *
 * const config = {
 *   keyStore, // instance of InMemoryKeyStore
 *   networkId: 'testnet',
 *   nodeUrl: 'https://rpc.testnet.near.org',
 *   walletUrl: 'https://wallet.testnet.near.org',
 *   helperUrl: 'https://helper.testnet.near.org',
 *   explorerUrl: 'https://explorer.testnet.near.org'
 * };
 *
 * // inside an async function
 * const near = await connect(config)
 * ```
 */ class $f3e226eda898b10e$var$InMemoryKeyStore extends $kELc4.KeyStore {
    constructor(){
        super();
        this.keys = {};
    }
    /**
     * Stores a {@KeyPair} in in-memory storage item
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @param keyPair The key pair to store in local storage
     */ async setKey(networkId, accountId, keyPair) {
        this.keys[`${accountId}:${networkId}`] = keyPair.toString();
    }
    /**
     * Gets a {@link KeyPair} from in-memory storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @returns {Promise<KeyPair>}
     */ async getKey(networkId, accountId) {
        const value = this.keys[`${accountId}:${networkId}`];
        if (!value) return null;
        return $lsY0f.KeyPair.fromString(value);
    }
    /**
     * Removes a {@link KeyPair} from in-memory storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     */ async removeKey(networkId, accountId) {
        delete this.keys[`${accountId}:${networkId}`];
    }
    /**
     * Removes all {@link KeyPairs} from in-memory storage
     */ async clear() {
        this.keys = {};
    }
    /**
     * Get the network(s) from in-memory storage
     * @returns {Promise<string[]>}
     */ async getNetworks() {
        const result = new Set();
        Object.keys(this.keys).forEach((key)=>{
            const parts = key.split(":");
            result.add(parts[1]);
        });
        return Array.from(result.values());
    }
    /**
     * Gets the account(s) from in-memory storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns{Promise<string[]>}
     */ async getAccounts(networkId) {
        const result = new Array();
        Object.keys(this.keys).forEach((key)=>{
            const parts = key.split(":");
            if (parts[parts.length - 1] === networkId) result.push(parts.slice(0, parts.length - 1).join(":"));
        });
        return result;
    }
    /** @hidden */ toString() {
        return "InMemoryKeyStore";
    }
}
module.exports.InMemoryKeyStore = $f3e226eda898b10e$var$InMemoryKeyStore;

});
parcelRegister("lsY0f", function(module, exports) {
"use strict";
var $fa0ac1d3a6bc4099$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyPairEd25519 = module.exports.KeyPair = module.exports.PublicKey = module.exports.KeyType = void 0;

const $fa0ac1d3a6bc4099$var$tweetnacl_1 = $fa0ac1d3a6bc4099$var$__importDefault((parcelRequire("1CYxK")));

var $11V5S = parcelRequire("11V5S");

var $kVMwJ = parcelRequire("kVMwJ");
/** All supported key types */ var $fa0ac1d3a6bc4099$var$KeyType;
(function(KeyType) {
    KeyType[KeyType["ED25519"] = 0] = "ED25519";
})($fa0ac1d3a6bc4099$var$KeyType = module.exports.KeyType || (module.exports.KeyType = {}));
function $fa0ac1d3a6bc4099$var$key_type_to_str(keyType) {
    switch(keyType){
        case $fa0ac1d3a6bc4099$var$KeyType.ED25519:
            return "ed25519";
        default:
            throw new Error(`Unknown key type ${keyType}`);
    }
}
function $fa0ac1d3a6bc4099$var$str_to_key_type(keyType) {
    switch(keyType.toLowerCase()){
        case "ed25519":
            return $fa0ac1d3a6bc4099$var$KeyType.ED25519;
        default:
            throw new Error(`Unknown key type ${keyType}`);
    }
}
/**
 * PublicKey representation that has type and bytes of the key.
 */ class $fa0ac1d3a6bc4099$var$PublicKey extends $kVMwJ.Assignable {
    static from(value) {
        if (typeof value === "string") return $fa0ac1d3a6bc4099$var$PublicKey.fromString(value);
        return value;
    }
    static fromString(encodedKey) {
        const parts = encodedKey.split(":");
        if (parts.length === 1) return new $fa0ac1d3a6bc4099$var$PublicKey({
            keyType: $fa0ac1d3a6bc4099$var$KeyType.ED25519,
            data: $11V5S.base_decode(parts[0])
        });
        else if (parts.length === 2) return new $fa0ac1d3a6bc4099$var$PublicKey({
            keyType: $fa0ac1d3a6bc4099$var$str_to_key_type(parts[0]),
            data: $11V5S.base_decode(parts[1])
        });
        else throw new Error("Invalid encoded key format, must be <curve>:<encoded key>");
    }
    toString() {
        return `${$fa0ac1d3a6bc4099$var$key_type_to_str(this.keyType)}:${$11V5S.base_encode(this.data)}`;
    }
    verify(message, signature) {
        switch(this.keyType){
            case $fa0ac1d3a6bc4099$var$KeyType.ED25519:
                return $fa0ac1d3a6bc4099$var$tweetnacl_1.default.sign.detached.verify(message, signature, this.data);
            default:
                throw new Error(`Unknown key type ${this.keyType}`);
        }
    }
}
module.exports.PublicKey = $fa0ac1d3a6bc4099$var$PublicKey;
class $fa0ac1d3a6bc4099$var$KeyPair {
    /**
     * @param curve Name of elliptical curve, case-insensitive
     * @returns Random KeyPair based on the curve
     */ static fromRandom(curve) {
        switch(curve.toUpperCase()){
            case "ED25519":
                return $fa0ac1d3a6bc4099$var$KeyPairEd25519.fromRandom();
            default:
                throw new Error(`Unknown curve ${curve}`);
        }
    }
    static fromString(encodedKey) {
        const parts = encodedKey.split(":");
        if (parts.length === 1) return new $fa0ac1d3a6bc4099$var$KeyPairEd25519(parts[0]);
        else if (parts.length === 2) switch(parts[0].toUpperCase()){
            case "ED25519":
                return new $fa0ac1d3a6bc4099$var$KeyPairEd25519(parts[1]);
            default:
                throw new Error(`Unknown curve: ${parts[0]}`);
        }
        else throw new Error("Invalid encoded key format, must be <curve>:<encoded key>");
    }
}
module.exports.KeyPair = $fa0ac1d3a6bc4099$var$KeyPair;
/**
 * This class provides key pair functionality for Ed25519 curve:
 * generating key pairs, encoding key pairs, signing and verifying.
 */ class $fa0ac1d3a6bc4099$var$KeyPairEd25519 extends $fa0ac1d3a6bc4099$var$KeyPair {
    /**
     * Construct an instance of key pair given a secret key.
     * It's generally assumed that these are encoded in base58.
     * @param {string} secretKey
     */ constructor(secretKey){
        super();
        const keyPair = $fa0ac1d3a6bc4099$var$tweetnacl_1.default.sign.keyPair.fromSecretKey($11V5S.base_decode(secretKey));
        this.publicKey = new $fa0ac1d3a6bc4099$var$PublicKey({
            keyType: $fa0ac1d3a6bc4099$var$KeyType.ED25519,
            data: keyPair.publicKey
        });
        this.secretKey = secretKey;
    }
    /**
     * Generate a new random keypair.
     * @example
     * const keyRandom = KeyPair.fromRandom();
     * keyRandom.publicKey
     * // returns [PUBLIC_KEY]
     *
     * keyRandom.secretKey
     * // returns [SECRET_KEY]
     */ static fromRandom() {
        const newKeyPair = $fa0ac1d3a6bc4099$var$tweetnacl_1.default.sign.keyPair();
        return new $fa0ac1d3a6bc4099$var$KeyPairEd25519($11V5S.base_encode(newKeyPair.secretKey));
    }
    sign(message) {
        const signature = $fa0ac1d3a6bc4099$var$tweetnacl_1.default.sign.detached(message, $11V5S.base_decode(this.secretKey));
        return {
            signature: signature,
            publicKey: this.publicKey
        };
    }
    verify(message, signature) {
        return this.publicKey.verify(message, signature);
    }
    toString() {
        return `ed25519:${this.secretKey}`;
    }
    getPublicKey() {
        return this.publicKey;
    }
}
module.exports.KeyPairEd25519 = $fa0ac1d3a6bc4099$var$KeyPairEd25519;

});
parcelRegister("1CYxK", function(module, exports) {

(function(nacl) {
    "use strict";
    // Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
    // Public domain.
    //
    // Implementation derived from TweetNaCl version 20140427.
    // See for details: http://tweetnacl.cr.yp.to/
    var gf = function(init) {
        var i, r = new Float64Array(16);
        if (init) for(i = 0; i < init.length; i++)r[i] = init[i];
        return r;
    };
    //  Pluggable, initialized in high-level API below.
    var randombytes = function() {
        throw new Error("no PRNG");
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf(), gf1 = gf([
        1
    ]), _121665 = gf([
        0xdb41,
        1
    ]), D = gf([
        0x78a3,
        0x1359,
        0x4dca,
        0x75eb,
        0xd8ab,
        0x4141,
        0x0a4d,
        0x0070,
        0xe898,
        0x7779,
        0x4079,
        0x8cc7,
        0xfe73,
        0x2b6f,
        0x6cee,
        0x5203
    ]), D2 = gf([
        0xf159,
        0x26b2,
        0x9b94,
        0xebd6,
        0xb156,
        0x8283,
        0x149a,
        0x00e0,
        0xd130,
        0xeef3,
        0x80f2,
        0x198e,
        0xfce7,
        0x56df,
        0xd9dc,
        0x2406
    ]), X = gf([
        0xd51a,
        0x8f25,
        0x2d60,
        0xc956,
        0xa7b2,
        0x9525,
        0xc760,
        0x692c,
        0xdc5c,
        0xfdd6,
        0xe231,
        0xc0a4,
        0x53fe,
        0xcd6e,
        0x36d3,
        0x2169
    ]), Y = gf([
        0x6658,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666
    ]), I = gf([
        0xa0b0,
        0x4a0e,
        0x1b27,
        0xc4ee,
        0xe478,
        0xad2f,
        0x1806,
        0x2f43,
        0xd7a7,
        0x3dfb,
        0x0099,
        0x2b4d,
        0xdf0b,
        0x4fc1,
        0x2480,
        0x2b83
    ]);
    function ts64(x, i, h, l) {
        x[i] = h >> 24 & 0xff;
        x[i + 1] = h >> 16 & 0xff;
        x[i + 2] = h >> 8 & 0xff;
        x[i + 3] = h & 0xff;
        x[i + 4] = l >> 24 & 0xff;
        x[i + 5] = l >> 16 & 0xff;
        x[i + 6] = l >> 8 & 0xff;
        x[i + 7] = l & 0xff;
    }
    function vn(x, xi, y, yi, n) {
        var i, d = 0;
        for(i = 0; i < n; i++)d |= x[xi + i] ^ y[yi + i];
        return (1 & d - 1 >>> 8) - 1;
    }
    function crypto_verify_16(x, xi, y, yi) {
        return vn(x, xi, y, yi, 16);
    }
    function crypto_verify_32(x, xi, y, yi) {
        return vn(x, xi, y, yi, 32);
    }
    function core_salsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        x0 = x0 + j0 | 0;
        x1 = x1 + j1 | 0;
        x2 = x2 + j2 | 0;
        x3 = x3 + j3 | 0;
        x4 = x4 + j4 | 0;
        x5 = x5 + j5 | 0;
        x6 = x6 + j6 | 0;
        x7 = x7 + j7 | 0;
        x8 = x8 + j8 | 0;
        x9 = x9 + j9 | 0;
        x10 = x10 + j10 | 0;
        x11 = x11 + j11 | 0;
        x12 = x12 + j12 | 0;
        x13 = x13 + j13 | 0;
        x14 = x14 + j14 | 0;
        x15 = x15 + j15 | 0;
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x1 >>> 0 & 0xff;
        o[5] = x1 >>> 8 & 0xff;
        o[6] = x1 >>> 16 & 0xff;
        o[7] = x1 >>> 24 & 0xff;
        o[8] = x2 >>> 0 & 0xff;
        o[9] = x2 >>> 8 & 0xff;
        o[10] = x2 >>> 16 & 0xff;
        o[11] = x2 >>> 24 & 0xff;
        o[12] = x3 >>> 0 & 0xff;
        o[13] = x3 >>> 8 & 0xff;
        o[14] = x3 >>> 16 & 0xff;
        o[15] = x3 >>> 24 & 0xff;
        o[16] = x4 >>> 0 & 0xff;
        o[17] = x4 >>> 8 & 0xff;
        o[18] = x4 >>> 16 & 0xff;
        o[19] = x4 >>> 24 & 0xff;
        o[20] = x5 >>> 0 & 0xff;
        o[21] = x5 >>> 8 & 0xff;
        o[22] = x5 >>> 16 & 0xff;
        o[23] = x5 >>> 24 & 0xff;
        o[24] = x6 >>> 0 & 0xff;
        o[25] = x6 >>> 8 & 0xff;
        o[26] = x6 >>> 16 & 0xff;
        o[27] = x6 >>> 24 & 0xff;
        o[28] = x7 >>> 0 & 0xff;
        o[29] = x7 >>> 8 & 0xff;
        o[30] = x7 >>> 16 & 0xff;
        o[31] = x7 >>> 24 & 0xff;
        o[32] = x8 >>> 0 & 0xff;
        o[33] = x8 >>> 8 & 0xff;
        o[34] = x8 >>> 16 & 0xff;
        o[35] = x8 >>> 24 & 0xff;
        o[36] = x9 >>> 0 & 0xff;
        o[37] = x9 >>> 8 & 0xff;
        o[38] = x9 >>> 16 & 0xff;
        o[39] = x9 >>> 24 & 0xff;
        o[40] = x10 >>> 0 & 0xff;
        o[41] = x10 >>> 8 & 0xff;
        o[42] = x10 >>> 16 & 0xff;
        o[43] = x10 >>> 24 & 0xff;
        o[44] = x11 >>> 0 & 0xff;
        o[45] = x11 >>> 8 & 0xff;
        o[46] = x11 >>> 16 & 0xff;
        o[47] = x11 >>> 24 & 0xff;
        o[48] = x12 >>> 0 & 0xff;
        o[49] = x12 >>> 8 & 0xff;
        o[50] = x12 >>> 16 & 0xff;
        o[51] = x12 >>> 24 & 0xff;
        o[52] = x13 >>> 0 & 0xff;
        o[53] = x13 >>> 8 & 0xff;
        o[54] = x13 >>> 16 & 0xff;
        o[55] = x13 >>> 24 & 0xff;
        o[56] = x14 >>> 0 & 0xff;
        o[57] = x14 >>> 8 & 0xff;
        o[58] = x14 >>> 16 & 0xff;
        o[59] = x14 >>> 24 & 0xff;
        o[60] = x15 >>> 0 & 0xff;
        o[61] = x15 >>> 8 & 0xff;
        o[62] = x15 >>> 16 & 0xff;
        o[63] = x15 >>> 24 & 0xff;
    }
    function core_hsalsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x5 >>> 0 & 0xff;
        o[5] = x5 >>> 8 & 0xff;
        o[6] = x5 >>> 16 & 0xff;
        o[7] = x5 >>> 24 & 0xff;
        o[8] = x10 >>> 0 & 0xff;
        o[9] = x10 >>> 8 & 0xff;
        o[10] = x10 >>> 16 & 0xff;
        o[11] = x10 >>> 24 & 0xff;
        o[12] = x15 >>> 0 & 0xff;
        o[13] = x15 >>> 8 & 0xff;
        o[14] = x15 >>> 16 & 0xff;
        o[15] = x15 >>> 24 & 0xff;
        o[16] = x6 >>> 0 & 0xff;
        o[17] = x6 >>> 8 & 0xff;
        o[18] = x6 >>> 16 & 0xff;
        o[19] = x6 >>> 24 & 0xff;
        o[20] = x7 >>> 0 & 0xff;
        o[21] = x7 >>> 8 & 0xff;
        o[22] = x7 >>> 16 & 0xff;
        o[23] = x7 >>> 24 & 0xff;
        o[24] = x8 >>> 0 & 0xff;
        o[25] = x8 >>> 8 & 0xff;
        o[26] = x8 >>> 16 & 0xff;
        o[27] = x8 >>> 24 & 0xff;
        o[28] = x9 >>> 0 & 0xff;
        o[29] = x9 >>> 8 & 0xff;
        o[30] = x9 >>> 16 & 0xff;
        o[31] = x9 >>> 24 & 0xff;
    }
    function crypto_core_salsa20(out, inp, k, c) {
        core_salsa20(out, inp, k, c);
    }
    function crypto_core_hsalsa20(out, inp, k, c) {
        core_hsalsa20(out, inp, k, c);
    }
    var sigma = new Uint8Array([
        101,
        120,
        112,
        97,
        110,
        100,
        32,
        51,
        50,
        45,
        98,
        121,
        116,
        101,
        32,
        107
    ]);
    // "expand 32-byte k"
    function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = m[mpos + i] ^ x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
            mpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = m[mpos + i] ^ x[i];
        }
        return 0;
    }
    function crypto_stream_salsa20(c, cpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = x[i];
        }
        return 0;
    }
    function crypto_stream(c, cpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20(c, cpos, d, sn, s);
    }
    function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
    }
    /*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/ var poly1305 = function(key) {
        this.buffer = new Uint8Array(16);
        this.r = new Uint16Array(10);
        this.h = new Uint16Array(10);
        this.pad = new Uint16Array(8);
        this.leftover = 0;
        this.fin = 0;
        var t0, t1, t2, t3, t4, t5, t6, t7;
        t0 = key[0] & 0xff | (key[1] & 0xff) << 8;
        this.r[0] = t0 & 0x1fff;
        t1 = key[2] & 0xff | (key[3] & 0xff) << 8;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        t2 = key[4] & 0xff | (key[5] & 0xff) << 8;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        t3 = key[6] & 0xff | (key[7] & 0xff) << 8;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        t4 = key[8] & 0xff | (key[9] & 0xff) << 8;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        t5 = key[10] & 0xff | (key[11] & 0xff) << 8;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        t6 = key[12] & 0xff | (key[13] & 0xff) << 8;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        t7 = key[14] & 0xff | (key[15] & 0xff) << 8;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
        this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
        this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
        this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
        this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
        this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
        this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
        this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes) {
        var hibit = this.fin ? 0 : 2048;
        var t0, t1, t2, t3, t4, t5, t6, t7, c;
        var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
        var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
        var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
        while(bytes >= 16){
            t0 = m[mpos + 0] & 0xff | (m[mpos + 1] & 0xff) << 8;
            h0 += t0 & 0x1fff;
            t1 = m[mpos + 2] & 0xff | (m[mpos + 3] & 0xff) << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            t2 = m[mpos + 4] & 0xff | (m[mpos + 5] & 0xff) << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            t3 = m[mpos + 6] & 0xff | (m[mpos + 7] & 0xff) << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            t4 = m[mpos + 8] & 0xff | (m[mpos + 9] & 0xff) << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            t5 = m[mpos + 10] & 0xff | (m[mpos + 11] & 0xff) << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            t6 = m[mpos + 12] & 0xff | (m[mpos + 13] & 0xff) << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            t7 = m[mpos + 14] & 0xff | (m[mpos + 15] & 0xff) << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            c = 0;
            d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this.h[0] = h0;
        this.h[1] = h1;
        this.h[2] = h2;
        this.h[3] = h3;
        this.h[4] = h4;
        this.h[5] = h5;
        this.h[6] = h6;
        this.h[7] = h7;
        this.h[8] = h8;
        this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
        var g = new Uint16Array(10);
        var c, mask, f, i;
        if (this.leftover) {
            i = this.leftover;
            this.buffer[i++] = 1;
            for(; i < 16; i++)this.buffer[i] = 0;
            this.fin = 1;
            this.blocks(this.buffer, 0, 16);
        }
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this.h[i] += c;
            c = this.h[i] >>> 13;
            this.h[i] &= 0x1fff;
        }
        this.h[0] += c * 5;
        c = this.h[0] >>> 13;
        this.h[0] &= 0x1fff;
        this.h[1] += c;
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        this.h[2] += c;
        g[0] = this.h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this.h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this.h[i] = this.h[i] & mask | g[i];
        this.h[0] = (this.h[0] | this.h[1] << 13) & 0xffff;
        this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 0xffff;
        this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 0xffff;
        this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 0xffff;
        this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 0xffff;
        this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 0xffff;
        this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 0xffff;
        this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 0xffff;
        f = this.h[0] + this.pad[0];
        this.h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
            this.h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this.h[0] >>> 0 & 0xff;
        mac[macpos + 1] = this.h[0] >>> 8 & 0xff;
        mac[macpos + 2] = this.h[1] >>> 0 & 0xff;
        mac[macpos + 3] = this.h[1] >>> 8 & 0xff;
        mac[macpos + 4] = this.h[2] >>> 0 & 0xff;
        mac[macpos + 5] = this.h[2] >>> 8 & 0xff;
        mac[macpos + 6] = this.h[3] >>> 0 & 0xff;
        mac[macpos + 7] = this.h[3] >>> 8 & 0xff;
        mac[macpos + 8] = this.h[4] >>> 0 & 0xff;
        mac[macpos + 9] = this.h[4] >>> 8 & 0xff;
        mac[macpos + 10] = this.h[5] >>> 0 & 0xff;
        mac[macpos + 11] = this.h[5] >>> 8 & 0xff;
        mac[macpos + 12] = this.h[6] >>> 0 & 0xff;
        mac[macpos + 13] = this.h[6] >>> 8 & 0xff;
        mac[macpos + 14] = this.h[7] >>> 0 & 0xff;
        mac[macpos + 15] = this.h[7] >>> 8 & 0xff;
    };
    poly1305.prototype.update = function(m, mpos, bytes) {
        var i, want;
        if (this.leftover) {
            want = 16 - this.leftover;
            if (want > bytes) want = bytes;
            for(i = 0; i < want; i++)this.buffer[this.leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this.leftover += want;
            if (this.leftover < 16) return;
            this.blocks(this.buffer, 0, 16);
            this.leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this.blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(i = 0; i < bytes; i++)this.buffer[this.leftover + i] = m[mpos + i];
            this.leftover += bytes;
        }
    };
    function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
        var s = new poly1305(k);
        s.update(m, mpos, n);
        s.finish(out, outpos);
        return 0;
    }
    function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
        var x = new Uint8Array(16);
        crypto_onetimeauth(x, 0, m, mpos, n, k);
        return crypto_verify_16(h, hpos, x, 0);
    }
    function crypto_secretbox(c, m, d, n, k) {
        var i;
        if (d < 32) return -1;
        crypto_stream_xor(c, 0, m, 0, d, n, k);
        crypto_onetimeauth(c, 16, c, 32, d - 32, c);
        for(i = 0; i < 16; i++)c[i] = 0;
        return 0;
    }
    function crypto_secretbox_open(m, c, d, n, k) {
        var i;
        var x = new Uint8Array(32);
        if (d < 32) return -1;
        crypto_stream(x, 0, 32, n, k);
        if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0) return -1;
        crypto_stream_xor(m, 0, c, 0, d, n, k);
        for(i = 0; i < 32; i++)m[i] = 0;
        return 0;
    }
    function set25519(r, a) {
        var i;
        for(i = 0; i < 16; i++)r[i] = a[i] | 0;
    }
    function car25519(o) {
        var i, v, c = 1;
        for(i = 0; i < 16; i++){
            v = o[i] + c + 65535;
            c = Math.floor(v / 65536);
            o[i] = v - c * 65536;
        }
        o[0] += c - 1 + 37 * (c - 1);
    }
    function sel25519(p, q, b) {
        var t, c = ~(b - 1);
        for(var i = 0; i < 16; i++){
            t = c & (p[i] ^ q[i]);
            p[i] ^= t;
            q[i] ^= t;
        }
    }
    function pack25519(o, n) {
        var i, j, b;
        var m = gf(), t = gf();
        for(i = 0; i < 16; i++)t[i] = n[i];
        car25519(t);
        car25519(t);
        car25519(t);
        for(j = 0; j < 2; j++){
            m[0] = t[0] - 0xffed;
            for(i = 1; i < 15; i++){
                m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
                m[i - 1] &= 0xffff;
            }
            m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
            b = m[15] >> 16 & 1;
            m[14] &= 0xffff;
            sel25519(t, m, 1 - b);
        }
        for(i = 0; i < 16; i++){
            o[2 * i] = t[i] & 0xff;
            o[2 * i + 1] = t[i] >> 8;
        }
    }
    function neq25519(a, b) {
        var c = new Uint8Array(32), d = new Uint8Array(32);
        pack25519(c, a);
        pack25519(d, b);
        return crypto_verify_32(c, 0, d, 0);
    }
    function par25519(a) {
        var d = new Uint8Array(32);
        pack25519(d, a);
        return d[0] & 1;
    }
    function unpack25519(o, n) {
        var i;
        for(i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
        o[15] &= 0x7fff;
    }
    function A(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
    }
    function Z(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
    }
    function M(o, a, b) {
        var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
        v = a[0];
        t0 += v * b0;
        t1 += v * b1;
        t2 += v * b2;
        t3 += v * b3;
        t4 += v * b4;
        t5 += v * b5;
        t6 += v * b6;
        t7 += v * b7;
        t8 += v * b8;
        t9 += v * b9;
        t10 += v * b10;
        t11 += v * b11;
        t12 += v * b12;
        t13 += v * b13;
        t14 += v * b14;
        t15 += v * b15;
        v = a[1];
        t1 += v * b0;
        t2 += v * b1;
        t3 += v * b2;
        t4 += v * b3;
        t5 += v * b4;
        t6 += v * b5;
        t7 += v * b6;
        t8 += v * b7;
        t9 += v * b8;
        t10 += v * b9;
        t11 += v * b10;
        t12 += v * b11;
        t13 += v * b12;
        t14 += v * b13;
        t15 += v * b14;
        t16 += v * b15;
        v = a[2];
        t2 += v * b0;
        t3 += v * b1;
        t4 += v * b2;
        t5 += v * b3;
        t6 += v * b4;
        t7 += v * b5;
        t8 += v * b6;
        t9 += v * b7;
        t10 += v * b8;
        t11 += v * b9;
        t12 += v * b10;
        t13 += v * b11;
        t14 += v * b12;
        t15 += v * b13;
        t16 += v * b14;
        t17 += v * b15;
        v = a[3];
        t3 += v * b0;
        t4 += v * b1;
        t5 += v * b2;
        t6 += v * b3;
        t7 += v * b4;
        t8 += v * b5;
        t9 += v * b6;
        t10 += v * b7;
        t11 += v * b8;
        t12 += v * b9;
        t13 += v * b10;
        t14 += v * b11;
        t15 += v * b12;
        t16 += v * b13;
        t17 += v * b14;
        t18 += v * b15;
        v = a[4];
        t4 += v * b0;
        t5 += v * b1;
        t6 += v * b2;
        t7 += v * b3;
        t8 += v * b4;
        t9 += v * b5;
        t10 += v * b6;
        t11 += v * b7;
        t12 += v * b8;
        t13 += v * b9;
        t14 += v * b10;
        t15 += v * b11;
        t16 += v * b12;
        t17 += v * b13;
        t18 += v * b14;
        t19 += v * b15;
        v = a[5];
        t5 += v * b0;
        t6 += v * b1;
        t7 += v * b2;
        t8 += v * b3;
        t9 += v * b4;
        t10 += v * b5;
        t11 += v * b6;
        t12 += v * b7;
        t13 += v * b8;
        t14 += v * b9;
        t15 += v * b10;
        t16 += v * b11;
        t17 += v * b12;
        t18 += v * b13;
        t19 += v * b14;
        t20 += v * b15;
        v = a[6];
        t6 += v * b0;
        t7 += v * b1;
        t8 += v * b2;
        t9 += v * b3;
        t10 += v * b4;
        t11 += v * b5;
        t12 += v * b6;
        t13 += v * b7;
        t14 += v * b8;
        t15 += v * b9;
        t16 += v * b10;
        t17 += v * b11;
        t18 += v * b12;
        t19 += v * b13;
        t20 += v * b14;
        t21 += v * b15;
        v = a[7];
        t7 += v * b0;
        t8 += v * b1;
        t9 += v * b2;
        t10 += v * b3;
        t11 += v * b4;
        t12 += v * b5;
        t13 += v * b6;
        t14 += v * b7;
        t15 += v * b8;
        t16 += v * b9;
        t17 += v * b10;
        t18 += v * b11;
        t19 += v * b12;
        t20 += v * b13;
        t21 += v * b14;
        t22 += v * b15;
        v = a[8];
        t8 += v * b0;
        t9 += v * b1;
        t10 += v * b2;
        t11 += v * b3;
        t12 += v * b4;
        t13 += v * b5;
        t14 += v * b6;
        t15 += v * b7;
        t16 += v * b8;
        t17 += v * b9;
        t18 += v * b10;
        t19 += v * b11;
        t20 += v * b12;
        t21 += v * b13;
        t22 += v * b14;
        t23 += v * b15;
        v = a[9];
        t9 += v * b0;
        t10 += v * b1;
        t11 += v * b2;
        t12 += v * b3;
        t13 += v * b4;
        t14 += v * b5;
        t15 += v * b6;
        t16 += v * b7;
        t17 += v * b8;
        t18 += v * b9;
        t19 += v * b10;
        t20 += v * b11;
        t21 += v * b12;
        t22 += v * b13;
        t23 += v * b14;
        t24 += v * b15;
        v = a[10];
        t10 += v * b0;
        t11 += v * b1;
        t12 += v * b2;
        t13 += v * b3;
        t14 += v * b4;
        t15 += v * b5;
        t16 += v * b6;
        t17 += v * b7;
        t18 += v * b8;
        t19 += v * b9;
        t20 += v * b10;
        t21 += v * b11;
        t22 += v * b12;
        t23 += v * b13;
        t24 += v * b14;
        t25 += v * b15;
        v = a[11];
        t11 += v * b0;
        t12 += v * b1;
        t13 += v * b2;
        t14 += v * b3;
        t15 += v * b4;
        t16 += v * b5;
        t17 += v * b6;
        t18 += v * b7;
        t19 += v * b8;
        t20 += v * b9;
        t21 += v * b10;
        t22 += v * b11;
        t23 += v * b12;
        t24 += v * b13;
        t25 += v * b14;
        t26 += v * b15;
        v = a[12];
        t12 += v * b0;
        t13 += v * b1;
        t14 += v * b2;
        t15 += v * b3;
        t16 += v * b4;
        t17 += v * b5;
        t18 += v * b6;
        t19 += v * b7;
        t20 += v * b8;
        t21 += v * b9;
        t22 += v * b10;
        t23 += v * b11;
        t24 += v * b12;
        t25 += v * b13;
        t26 += v * b14;
        t27 += v * b15;
        v = a[13];
        t13 += v * b0;
        t14 += v * b1;
        t15 += v * b2;
        t16 += v * b3;
        t17 += v * b4;
        t18 += v * b5;
        t19 += v * b6;
        t20 += v * b7;
        t21 += v * b8;
        t22 += v * b9;
        t23 += v * b10;
        t24 += v * b11;
        t25 += v * b12;
        t26 += v * b13;
        t27 += v * b14;
        t28 += v * b15;
        v = a[14];
        t14 += v * b0;
        t15 += v * b1;
        t16 += v * b2;
        t17 += v * b3;
        t18 += v * b4;
        t19 += v * b5;
        t20 += v * b6;
        t21 += v * b7;
        t22 += v * b8;
        t23 += v * b9;
        t24 += v * b10;
        t25 += v * b11;
        t26 += v * b12;
        t27 += v * b13;
        t28 += v * b14;
        t29 += v * b15;
        v = a[15];
        t15 += v * b0;
        t16 += v * b1;
        t17 += v * b2;
        t18 += v * b3;
        t19 += v * b4;
        t20 += v * b5;
        t21 += v * b6;
        t22 += v * b7;
        t23 += v * b8;
        t24 += v * b9;
        t25 += v * b10;
        t26 += v * b11;
        t27 += v * b12;
        t28 += v * b13;
        t29 += v * b14;
        t30 += v * b15;
        t0 += 38 * t16;
        t1 += 38 * t17;
        t2 += 38 * t18;
        t3 += 38 * t19;
        t4 += 38 * t20;
        t5 += 38 * t21;
        t6 += 38 * t22;
        t7 += 38 * t23;
        t8 += 38 * t24;
        t9 += 38 * t25;
        t10 += 38 * t26;
        t11 += 38 * t27;
        t12 += 38 * t28;
        t13 += 38 * t29;
        t14 += 38 * t30;
        // t15 left as is
        // first car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        // second car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        o[0] = t0;
        o[1] = t1;
        o[2] = t2;
        o[3] = t3;
        o[4] = t4;
        o[5] = t5;
        o[6] = t6;
        o[7] = t7;
        o[8] = t8;
        o[9] = t9;
        o[10] = t10;
        o[11] = t11;
        o[12] = t12;
        o[13] = t13;
        o[14] = t14;
        o[15] = t15;
    }
    function S(o, a) {
        M(o, a, a);
    }
    function inv25519(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 253; a >= 0; a--){
            S(c, c);
            if (a !== 2 && a !== 4) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function pow2523(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 250; a >= 0; a--){
            S(c, c);
            if (a !== 1) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function crypto_scalarmult(q, n, p) {
        var z = new Uint8Array(32);
        var x = new Float64Array(80), r, i;
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
        for(i = 0; i < 31; i++)z[i] = n[i];
        z[31] = n[31] & 127 | 64;
        z[0] &= 248;
        unpack25519(x, p);
        for(i = 0; i < 16; i++){
            b[i] = x[i];
            d[i] = a[i] = c[i] = 0;
        }
        a[0] = d[0] = 1;
        for(i = 254; i >= 0; --i){
            r = z[i >>> 3] >>> (i & 7) & 1;
            sel25519(a, b, r);
            sel25519(c, d, r);
            A(e, a, c);
            Z(a, a, c);
            A(c, b, d);
            Z(b, b, d);
            S(d, e);
            S(f, a);
            M(a, c, a);
            M(c, b, e);
            A(e, a, c);
            Z(a, a, c);
            S(b, a);
            Z(c, d, f);
            M(a, c, _121665);
            A(a, a, d);
            M(c, c, a);
            M(a, d, f);
            M(d, b, x);
            S(b, e);
            sel25519(a, b, r);
            sel25519(c, d, r);
        }
        for(i = 0; i < 16; i++){
            x[i + 16] = a[i];
            x[i + 32] = c[i];
            x[i + 48] = b[i];
            x[i + 64] = d[i];
        }
        var x32 = x.subarray(32);
        var x16 = x.subarray(16);
        inv25519(x32, x32);
        M(x16, x16, x32);
        pack25519(q, x16);
        return 0;
    }
    function crypto_scalarmult_base(q, n) {
        return crypto_scalarmult(q, n, _9);
    }
    function crypto_box_keypair(y, x) {
        randombytes(x, 32);
        return crypto_scalarmult_base(y, x);
    }
    function crypto_box_beforenm(k, y, x) {
        var s = new Uint8Array(32);
        crypto_scalarmult(s, x, y);
        return crypto_core_hsalsa20(k, _0, s, sigma);
    }
    var crypto_box_afternm = crypto_secretbox;
    var crypto_box_open_afternm = crypto_secretbox_open;
    function crypto_box(c, m, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_afternm(c, m, d, n, k);
    }
    function crypto_box_open(m, c, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_open_afternm(m, c, d, n, k);
    }
    var K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    function crypto_hashblocks_hl(hh, hl, m, n) {
        var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
        var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
        var pos = 0;
        while(n >= 128){
            for(i = 0; i < 16; i++){
                j = 8 * i + pos;
                wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
                wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
            }
            for(i = 0; i < 80; i++){
                bh0 = ah0;
                bh1 = ah1;
                bh2 = ah2;
                bh3 = ah3;
                bh4 = ah4;
                bh5 = ah5;
                bh6 = ah6;
                bh7 = ah7;
                bl0 = al0;
                bl1 = al1;
                bl2 = al2;
                bl3 = al3;
                bl4 = al4;
                bl5 = al5;
                bl6 = al6;
                bl7 = al7;
                // add
                h = ah7;
                l = al7;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma1
                h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
                l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Ch
                h = ah4 & ah5 ^ ~ah4 & ah6;
                l = al4 & al5 ^ ~al4 & al6;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // K
                h = K[i * 2];
                l = K[i * 2 + 1];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // w
                h = wh[i % 16];
                l = wl[i % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                th = c & 0xffff | d << 16;
                tl = a & 0xffff | b << 16;
                // add
                h = th;
                l = tl;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma0
                h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
                l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Maj
                h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
                l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh7 = c & 0xffff | d << 16;
                bl7 = a & 0xffff | b << 16;
                // add
                h = bh3;
                l = bl3;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = th;
                l = tl;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh3 = c & 0xffff | d << 16;
                bl3 = a & 0xffff | b << 16;
                ah1 = bh0;
                ah2 = bh1;
                ah3 = bh2;
                ah4 = bh3;
                ah5 = bh4;
                ah6 = bh5;
                ah7 = bh6;
                ah0 = bh7;
                al1 = bl0;
                al2 = bl1;
                al3 = bl2;
                al4 = bl3;
                al5 = bl4;
                al6 = bl5;
                al7 = bl6;
                al0 = bl7;
                if (i % 16 === 15) for(j = 0; j < 16; j++){
                    // add
                    h = wh[j];
                    l = wl[j];
                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;
                    h = wh[(j + 9) % 16];
                    l = wl[(j + 9) % 16];
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma0
                    th = wh[(j + 1) % 16];
                    tl = wl[(j + 1) % 16];
                    h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                    l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma1
                    th = wh[(j + 14) % 16];
                    tl = wl[(j + 14) % 16];
                    h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                    l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;
                    wh[j] = c & 0xffff | d << 16;
                    wl[j] = a & 0xffff | b << 16;
                }
            }
            // add
            h = ah0;
            l = al0;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[0];
            l = hl[0];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[0] = ah0 = c & 0xffff | d << 16;
            hl[0] = al0 = a & 0xffff | b << 16;
            h = ah1;
            l = al1;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[1];
            l = hl[1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[1] = ah1 = c & 0xffff | d << 16;
            hl[1] = al1 = a & 0xffff | b << 16;
            h = ah2;
            l = al2;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[2];
            l = hl[2];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[2] = ah2 = c & 0xffff | d << 16;
            hl[2] = al2 = a & 0xffff | b << 16;
            h = ah3;
            l = al3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[3];
            l = hl[3];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[3] = ah3 = c & 0xffff | d << 16;
            hl[3] = al3 = a & 0xffff | b << 16;
            h = ah4;
            l = al4;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[4];
            l = hl[4];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[4] = ah4 = c & 0xffff | d << 16;
            hl[4] = al4 = a & 0xffff | b << 16;
            h = ah5;
            l = al5;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[5];
            l = hl[5];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[5] = ah5 = c & 0xffff | d << 16;
            hl[5] = al5 = a & 0xffff | b << 16;
            h = ah6;
            l = al6;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[6];
            l = hl[6];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[6] = ah6 = c & 0xffff | d << 16;
            hl[6] = al6 = a & 0xffff | b << 16;
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[7];
            l = hl[7];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[7] = ah7 = c & 0xffff | d << 16;
            hl[7] = al7 = a & 0xffff | b << 16;
            pos += 128;
            n -= 128;
        }
        return n;
    }
    function crypto_hash(out, m, n) {
        var hh = new Int32Array(8), hl = new Int32Array(8), x = new Uint8Array(256), i, b = n;
        hh[0] = 0x6a09e667;
        hh[1] = 0xbb67ae85;
        hh[2] = 0x3c6ef372;
        hh[3] = 0xa54ff53a;
        hh[4] = 0x510e527f;
        hh[5] = 0x9b05688c;
        hh[6] = 0x1f83d9ab;
        hh[7] = 0x5be0cd19;
        hl[0] = 0xf3bcc908;
        hl[1] = 0x84caa73b;
        hl[2] = 0xfe94f82b;
        hl[3] = 0x5f1d36f1;
        hl[4] = 0xade682d1;
        hl[5] = 0x2b3e6c1f;
        hl[6] = 0xfb41bd6b;
        hl[7] = 0x137e2179;
        crypto_hashblocks_hl(hh, hl, m, n);
        n %= 128;
        for(i = 0; i < n; i++)x[i] = m[b - n + i];
        x[n] = 128;
        n = 256 - 128 * (n < 112 ? 1 : 0);
        x[n - 9] = 0;
        ts64(x, n - 8, b / 0x20000000 | 0, b << 3);
        crypto_hashblocks_hl(hh, hl, x, n);
        for(i = 0; i < 8; i++)ts64(out, 8 * i, hh[i], hl[i]);
        return 0;
    }
    function add(p, q) {
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
        Z(a, p[1], p[0]);
        Z(t, q[1], q[0]);
        M(a, a, t);
        A(b, p[0], p[1]);
        A(t, q[0], q[1]);
        M(b, b, t);
        M(c, p[3], q[3]);
        M(c, c, D2);
        M(d, p[2], q[2]);
        A(d, d, d);
        Z(e, b, a);
        Z(f, d, c);
        A(g, d, c);
        A(h, b, a);
        M(p[0], e, f);
        M(p[1], h, g);
        M(p[2], g, f);
        M(p[3], e, h);
    }
    function cswap(p, q, b) {
        var i;
        for(i = 0; i < 4; i++)sel25519(p[i], q[i], b);
    }
    function pack(r, p) {
        var tx = gf(), ty = gf(), zi = gf();
        inv25519(zi, p[2]);
        M(tx, p[0], zi);
        M(ty, p[1], zi);
        pack25519(r, ty);
        r[31] ^= par25519(tx) << 7;
    }
    function scalarmult(p, q, s) {
        var b, i;
        set25519(p[0], gf0);
        set25519(p[1], gf1);
        set25519(p[2], gf1);
        set25519(p[3], gf0);
        for(i = 255; i >= 0; --i){
            b = s[i / 8 | 0] >> (i & 7) & 1;
            cswap(p, q, b);
            add(q, p);
            add(p, p);
            cswap(p, q, b);
        }
    }
    function scalarbase(p, s) {
        var q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        set25519(q[0], X);
        set25519(q[1], Y);
        set25519(q[2], gf1);
        M(q[3], X, Y);
        scalarmult(p, q, s);
    }
    function crypto_sign_keypair(pk, sk, seeded) {
        var d = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        var i;
        if (!seeded) randombytes(sk, 32);
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        scalarbase(p, d);
        pack(pk, p);
        for(i = 0; i < 32; i++)sk[i + 32] = pk[i];
        return 0;
    }
    var L = new Float64Array([
        0xed,
        0xd3,
        0xf5,
        0x5c,
        0x1a,
        0x63,
        0x12,
        0x58,
        0xd6,
        0x9c,
        0xf7,
        0xa2,
        0xde,
        0xf9,
        0xde,
        0x14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0x10
    ]);
    function modL(r, x) {
        var carry, i, j, k;
        for(i = 63; i >= 32; --i){
            carry = 0;
            for(j = i - 32, k = i - 12; j < k; ++j){
                x[j] += carry - 16 * x[i] * L[j - (i - 32)];
                carry = Math.floor((x[j] + 128) / 256);
                x[j] -= carry * 256;
            }
            x[j] += carry;
            x[i] = 0;
        }
        carry = 0;
        for(j = 0; j < 32; j++){
            x[j] += carry - (x[31] >> 4) * L[j];
            carry = x[j] >> 8;
            x[j] &= 255;
        }
        for(j = 0; j < 32; j++)x[j] -= carry * L[j];
        for(i = 0; i < 32; i++){
            x[i + 1] += x[i] >> 8;
            r[i] = x[i] & 255;
        }
    }
    function reduce(r) {
        var x = new Float64Array(64), i;
        for(i = 0; i < 64; i++)x[i] = r[i];
        for(i = 0; i < 64; i++)r[i] = 0;
        modL(r, x);
    }
    // Note: difference from C - smlen returned, not passed as argument.
    function crypto_sign(sm, m, n, sk) {
        var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
        var i, j, x = new Float64Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        var smlen = n + 64;
        for(i = 0; i < n; i++)sm[64 + i] = m[i];
        for(i = 0; i < 32; i++)sm[32 + i] = d[32 + i];
        crypto_hash(r, sm.subarray(32), n + 32);
        reduce(r);
        scalarbase(p, r);
        pack(sm, p);
        for(i = 32; i < 64; i++)sm[i] = sk[i];
        crypto_hash(h, sm, n + 64);
        reduce(h);
        for(i = 0; i < 64; i++)x[i] = 0;
        for(i = 0; i < 32; i++)x[i] = r[i];
        for(i = 0; i < 32; i++)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
        modL(sm.subarray(32), x);
        return smlen;
    }
    function unpackneg(r, p) {
        var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
        set25519(r[2], gf1);
        unpack25519(r[1], p);
        S(num, r[1]);
        M(den, num, D);
        Z(num, num, r[2]);
        A(den, r[2], den);
        S(den2, den);
        S(den4, den2);
        M(den6, den4, den2);
        M(t, den6, num);
        M(t, t, den);
        pow2523(t, t);
        M(t, t, num);
        M(t, t, den);
        M(t, t, den);
        M(r[0], t, den);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) M(r[0], r[0], I);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) return -1;
        if (par25519(r[0]) === p[31] >> 7) Z(r[0], gf0, r[0]);
        M(r[3], r[0], r[1]);
        return 0;
    }
    function crypto_sign_open(m, sm, n, pk) {
        var i;
        var t = new Uint8Array(32), h = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ], q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        if (n < 64) return -1;
        if (unpackneg(q, pk)) return -1;
        for(i = 0; i < n; i++)m[i] = sm[i];
        for(i = 0; i < 32; i++)m[i + 32] = pk[i];
        crypto_hash(h, m, n);
        reduce(h);
        scalarmult(p, q, h);
        scalarbase(q, sm.subarray(32));
        add(p, q);
        pack(t, p);
        n -= 64;
        if (crypto_verify_32(sm, 0, t, 0)) {
            for(i = 0; i < n; i++)m[i] = 0;
            return -1;
        }
        for(i = 0; i < n; i++)m[i] = sm[i + 64];
        return n;
    }
    var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
    nacl.lowlevel = {
        crypto_core_hsalsa20: crypto_core_hsalsa20,
        crypto_stream_xor: crypto_stream_xor,
        crypto_stream: crypto_stream,
        crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
        crypto_stream_salsa20: crypto_stream_salsa20,
        crypto_onetimeauth: crypto_onetimeauth,
        crypto_onetimeauth_verify: crypto_onetimeauth_verify,
        crypto_verify_16: crypto_verify_16,
        crypto_verify_32: crypto_verify_32,
        crypto_secretbox: crypto_secretbox,
        crypto_secretbox_open: crypto_secretbox_open,
        crypto_scalarmult: crypto_scalarmult,
        crypto_scalarmult_base: crypto_scalarmult_base,
        crypto_box_beforenm: crypto_box_beforenm,
        crypto_box_afternm: crypto_box_afternm,
        crypto_box: crypto_box,
        crypto_box_open: crypto_box_open,
        crypto_box_keypair: crypto_box_keypair,
        crypto_hash: crypto_hash,
        crypto_sign: crypto_sign,
        crypto_sign_keypair: crypto_sign_keypair,
        crypto_sign_open: crypto_sign_open,
        crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
        crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
        crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
        crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
        crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
        crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
        crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
        crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
        crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
        crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
        crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
        crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
        crypto_sign_BYTES: crypto_sign_BYTES,
        crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
        crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
        crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
        crypto_hash_BYTES: crypto_hash_BYTES,
        gf: gf,
        D: D,
        L: L,
        pack25519: pack25519,
        unpack25519: unpack25519,
        M: M,
        A: A,
        S: S,
        Z: Z,
        pow2523: pow2523,
        add: add,
        set25519: set25519,
        modL: modL,
        scalarmult: scalarmult,
        scalarbase: scalarbase
    };
    /* High-level API */ function checkLengths(k, n) {
        if (k.length !== crypto_secretbox_KEYBYTES) throw new Error("bad key size");
        if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error("bad nonce size");
    }
    function checkBoxLengths(pk, sk) {
        if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error("bad public key size");
        if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
    }
    function checkArrayTypes() {
        for(var i = 0; i < arguments.length; i++){
            if (!(arguments[i] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
        }
    }
    function cleanup(arr) {
        for(var i = 0; i < arr.length; i++)arr[i] = 0;
    }
    nacl.randomBytes = function(n) {
        var b = new Uint8Array(n);
        randombytes(b, n);
        return b;
    };
    nacl.secretbox = function(msg, nonce, key) {
        checkArrayTypes(msg, nonce, key);
        checkLengths(key, nonce);
        var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
        var c = new Uint8Array(m.length);
        for(var i = 0; i < msg.length; i++)m[i + crypto_secretbox_ZEROBYTES] = msg[i];
        crypto_secretbox(c, m, m.length, nonce, key);
        return c.subarray(crypto_secretbox_BOXZEROBYTES);
    };
    nacl.secretbox.open = function(box, nonce, key) {
        checkArrayTypes(box, nonce, key);
        checkLengths(key, nonce);
        var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
        var m = new Uint8Array(c.length);
        for(var i = 0; i < box.length; i++)c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
        if (c.length < 32) return null;
        if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
        return m.subarray(crypto_secretbox_ZEROBYTES);
    };
    nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
    nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
    nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
    nacl.scalarMult = function(n, p) {
        checkArrayTypes(n, p);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        if (p.length !== crypto_scalarmult_BYTES) throw new Error("bad p size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult(q, n, p);
        return q;
    };
    nacl.scalarMult.base = function(n) {
        checkArrayTypes(n);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult_base(q, n);
        return q;
    };
    nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
    nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
    nacl.box = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox(msg, nonce, k);
    };
    nacl.box.before = function(publicKey, secretKey) {
        checkArrayTypes(publicKey, secretKey);
        checkBoxLengths(publicKey, secretKey);
        var k = new Uint8Array(crypto_box_BEFORENMBYTES);
        crypto_box_beforenm(k, publicKey, secretKey);
        return k;
    };
    nacl.box.after = nacl.secretbox;
    nacl.box.open = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox.open(msg, nonce, k);
    };
    nacl.box.open.after = nacl.secretbox.open;
    nacl.box.keyPair = function() {
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
        crypto_box_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.box.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        crypto_scalarmult_base(pk, secretKey);
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
    nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
    nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
    nacl.box.nonceLength = crypto_box_NONCEBYTES;
    nacl.box.overheadLength = nacl.secretbox.overheadLength;
    nacl.sign = function(msg, secretKey) {
        checkArrayTypes(msg, secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
        crypto_sign(signedMsg, msg, msg.length, secretKey);
        return signedMsg;
    };
    nacl.sign.open = function(signedMsg, publicKey) {
        checkArrayTypes(signedMsg, publicKey);
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var tmp = new Uint8Array(signedMsg.length);
        var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
        if (mlen < 0) return null;
        var m = new Uint8Array(mlen);
        for(var i = 0; i < m.length; i++)m[i] = tmp[i];
        return m;
    };
    nacl.sign.detached = function(msg, secretKey) {
        var signedMsg = nacl.sign(msg, secretKey);
        var sig = new Uint8Array(crypto_sign_BYTES);
        for(var i = 0; i < sig.length; i++)sig[i] = signedMsg[i];
        return sig;
    };
    nacl.sign.detached.verify = function(msg, sig, publicKey) {
        checkArrayTypes(msg, sig, publicKey);
        if (sig.length !== crypto_sign_BYTES) throw new Error("bad signature size");
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
        var m = new Uint8Array(crypto_sign_BYTES + msg.length);
        var i;
        for(i = 0; i < crypto_sign_BYTES; i++)sm[i] = sig[i];
        for(i = 0; i < msg.length; i++)sm[i + crypto_sign_BYTES] = msg[i];
        return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
    };
    nacl.sign.keyPair = function() {
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        crypto_sign_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        for(var i = 0; i < pk.length; i++)pk[i] = secretKey[32 + i];
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.sign.keyPair.fromSeed = function(seed) {
        checkArrayTypes(seed);
        if (seed.length !== crypto_sign_SEEDBYTES) throw new Error("bad seed size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        for(var i = 0; i < 32; i++)sk[i] = seed[i];
        crypto_sign_keypair(pk, sk, true);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
    nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
    nacl.sign.seedLength = crypto_sign_SEEDBYTES;
    nacl.sign.signatureLength = crypto_sign_BYTES;
    nacl.hash = function(msg) {
        checkArrayTypes(msg);
        var h = new Uint8Array(crypto_hash_BYTES);
        crypto_hash(h, msg, msg.length);
        return h;
    };
    nacl.hash.hashLength = crypto_hash_BYTES;
    nacl.verify = function(x, y) {
        checkArrayTypes(x, y);
        // Zero length arguments are considered not equal.
        if (x.length === 0 || y.length === 0) return false;
        if (x.length !== y.length) return false;
        return vn(x, 0, y, 0, x.length) === 0 ? true : false;
    };
    nacl.setPRNG = function(fn) {
        randombytes = fn;
    };
    (function() {
        // Initialize PRNG if environment provides CSPRNG.
        // If not, methods calling randombytes will throw.
        var crypto = typeof self !== "undefined" ? self.crypto || self.msCrypto : null;
        if (crypto && crypto.getRandomValues) {
            // Browsers.
            var QUOTA = 65536;
            nacl.setPRNG(function(x, n) {
                var i, v = new Uint8Array(n);
                for(i = 0; i < n; i += QUOTA)crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        } else {
            // Node.js.
            crypto = (parcelRequire("kjyEk"));
            if (crypto && crypto.randomBytes) nacl.setPRNG(function(x, n) {
                var i, v = crypto.randomBytes(n);
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        }
    })();
})((0, module.exports) ? module.exports : self.nacl = self.nacl || {});

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("11V5S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $75BJw = parcelRequire("75BJw");
Object.defineProperty(module.exports, "base_encode", {
    enumerable: true,
    get: function() {
        return $75BJw.baseEncode;
    }
});
Object.defineProperty(module.exports, "base_decode", {
    enumerable: true,
    get: function() {
        return $75BJw.baseDecode;
    }
});
Object.defineProperty(module.exports, "serialize", {
    enumerable: true,
    get: function() {
        return $75BJw.serialize;
    }
});
Object.defineProperty(module.exports, "deserialize", {
    enumerable: true,
    get: function() {
        return $75BJw.deserialize;
    }
});
Object.defineProperty(module.exports, "BorshError", {
    enumerable: true,
    get: function() {
        return $75BJw.BorshError;
    }
});
Object.defineProperty(module.exports, "BinaryWriter", {
    enumerable: true,
    get: function() {
        return $75BJw.BinaryWriter;
    }
});
Object.defineProperty(module.exports, "BinaryReader", {
    enumerable: true,
    get: function() {
        return $75BJw.BinaryReader;
    }
});

});
parcelRegister("75BJw", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $5296450c35a171ab$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $5296450c35a171ab$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5296450c35a171ab$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5296450c35a171ab$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $5296450c35a171ab$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $5296450c35a171ab$var$__createBinding(result, mod, k);
    }
    $5296450c35a171ab$var$__setModuleDefault(result, mod);
    return result;
};
var $5296450c35a171ab$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeUnchecked = module.exports.deserialize = module.exports.serialize = module.exports.BinaryReader = module.exports.BinaryWriter = module.exports.BorshError = module.exports.baseDecode = module.exports.baseEncode = void 0;

const $5296450c35a171ab$var$bn_js_1 = $5296450c35a171ab$var$__importDefault((parcelRequire("dEXSZ")));

const $5296450c35a171ab$var$bs58_1 = $5296450c35a171ab$var$__importDefault((parcelRequire("bYkMz")));

// TODO: Make sure this polyfill not included when not required
const $5296450c35a171ab$var$encoding = $5296450c35a171ab$var$__importStar((parcelRequire("kOaA4")));
const $5296450c35a171ab$var$TextDecoder = typeof $parcel$global.TextDecoder !== "function" ? $5296450c35a171ab$var$encoding.TextDecoder : $parcel$global.TextDecoder;
const $5296450c35a171ab$var$textDecoder = new $5296450c35a171ab$var$TextDecoder("utf-8", {
    fatal: true
});
function $5296450c35a171ab$var$baseEncode(value) {
    if (typeof value === "string") value = $5296450c35a171ab$require$Buffer.from(value, "utf8");
    return $5296450c35a171ab$var$bs58_1.default.encode($5296450c35a171ab$require$Buffer.from(value));
}
module.exports.baseEncode = $5296450c35a171ab$var$baseEncode;
function $5296450c35a171ab$var$baseDecode(value) {
    return $5296450c35a171ab$require$Buffer.from($5296450c35a171ab$var$bs58_1.default.decode(value));
}
module.exports.baseDecode = $5296450c35a171ab$var$baseDecode;
const $5296450c35a171ab$var$INITIAL_LENGTH = 1024;
class $5296450c35a171ab$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
module.exports.BorshError = $5296450c35a171ab$var$BorshError;
/// Binary encoder.
class $5296450c35a171ab$var$BinaryWriter {
    constructor(){
        this.buf = $5296450c35a171ab$require$Buffer.alloc($5296450c35a171ab$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $5296450c35a171ab$require$Buffer.concat([
            this.buf,
            $5296450c35a171ab$require$Buffer.alloc($5296450c35a171ab$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(new $5296450c35a171ab$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $5296450c35a171ab$require$Buffer.concat([
            $5296450c35a171ab$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $5296450c35a171ab$require$Buffer.alloc($5296450c35a171ab$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $5296450c35a171ab$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($5296450c35a171ab$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
module.exports.BinaryWriter = $5296450c35a171ab$var$BinaryWriter;
function $5296450c35a171ab$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $5296450c35a171ab$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $5296450c35a171ab$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $5296450c35a171ab$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $5296450c35a171ab$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $5296450c35a171ab$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $5296450c35a171ab$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU8", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU16", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU32", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU64", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU128", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU256", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readU512", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readString", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readFixedArray", null);
$5296450c35a171ab$var$__decorate([
    $5296450c35a171ab$var$handlingRangeError
], $5296450c35a171ab$var$BinaryReader.prototype, "readArray", null);
module.exports.BinaryReader = $5296450c35a171ab$var$BinaryReader;
function $5296450c35a171ab$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $5296450c35a171ab$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$5296450c35a171ab$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $5296450c35a171ab$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $5296450c35a171ab$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$5296450c35a171ab$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $5296450c35a171ab$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $5296450c35a171ab$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            default:
                throw new $5296450c35a171ab$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $5296450c35a171ab$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $5296450c35a171ab$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $5296450c35a171ab$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $5296450c35a171ab$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $5296450c35a171ab$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $5296450c35a171ab$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $5296450c35a171ab$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $5296450c35a171ab$var$serialize(schema, obj, Writer = $5296450c35a171ab$var$BinaryWriter) {
    const writer = new Writer();
    $5296450c35a171ab$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
module.exports.serialize = $5296450c35a171ab$var$serialize;
function $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$5296450c35a171ab$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($5296450c35a171ab$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        return $5296450c35a171ab$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $5296450c35a171ab$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $5296450c35a171ab$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $5296450c35a171ab$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $5296450c35a171ab$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $5296450c35a171ab$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $5296450c35a171ab$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $5296450c35a171ab$var$deserialize(schema, classType, buffer, Reader = $5296450c35a171ab$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $5296450c35a171ab$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $5296450c35a171ab$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
module.exports.deserialize = $5296450c35a171ab$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $5296450c35a171ab$var$deserializeUnchecked(schema, classType, buffer, Reader = $5296450c35a171ab$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $5296450c35a171ab$var$deserializeStruct(schema, classType, reader);
}
module.exports.deserializeUnchecked = $5296450c35a171ab$var$deserializeUnchecked;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("bYkMz", function(module, exports) {

var $0DhcF = parcelRequire("0DhcF");
var $8b756b3b8ee97947$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $0DhcF($8b756b3b8ee97947$var$ALPHABET);

});
parcelRegister("0DhcF", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $001e77b0dfd1bf3d$require$_Buffer = $1U9GM.Buffer;
function $001e77b0dfd1bf3d$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $001e77b0dfd1bf3d$require$_Buffer.from(source);
        if (!$001e77b0dfd1bf3d$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $001e77b0dfd1bf3d$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $001e77b0dfd1bf3d$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $001e77b0dfd1bf3d$var$base;

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});



parcelRegister("kOaA4", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", () => $f260af419b27244f$export$88fb0cfd153261a7, (v) => $f260af419b27244f$export$88fb0cfd153261a7 = v);
$parcel$export(module.exports, "TextDecoder", () => $f260af419b27244f$export$9c6b53e35bc51b5c, (v) => $f260af419b27244f$export$9c6b53e35bc51b5c = v);
var $f260af419b27244f$export$88fb0cfd153261a7;
var $f260af419b27244f$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $f260af419b27244f$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $f260af419b27244f$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $f260af419b27244f$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $f260af419b27244f$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $f260af419b27244f$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $f260af419b27244f$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$f260af419b27244f$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $f260af419b27244f$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $f260af419b27244f$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $f260af419b27244f$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $f260af419b27244f$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $f260af419b27244f$var$TextDecoder(encoding, options) {
    if (!(this instanceof $f260af419b27244f$var$TextDecoder)) return new $f260af419b27244f$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $f260af419b27244f$var$DEFAULT_ENCODING;
    if (encoding !== $f260af419b27244f$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $f260af419b27244f$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$f260af419b27244f$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $f260af419b27244f$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $f260af419b27244f$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $f260af419b27244f$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $f260af419b27244f$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $f260af419b27244f$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $f260af419b27244f$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $f260af419b27244f$var$TextEncoder(encoding, options) {
    if (!(this instanceof $f260af419b27244f$var$TextEncoder)) return new $f260af419b27244f$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $f260af419b27244f$var$DEFAULT_ENCODING;
    if (encoding !== $f260af419b27244f$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $f260af419b27244f$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$f260af419b27244f$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $f260af419b27244f$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $f260af419b27244f$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $f260af419b27244f$var$Stream($f260af419b27244f$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $f260af419b27244f$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $f260af419b27244f$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $f260af419b27244f$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $f260af419b27244f$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $f260af419b27244f$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $f260af419b27244f$var$end_of_stream) return $f260af419b27244f$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($f260af419b27244f$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($f260af419b27244f$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($f260af419b27244f$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($f260af419b27244f$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $f260af419b27244f$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$f260af419b27244f$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $f260af419b27244f$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $f260af419b27244f$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $f260af419b27244f$var$end_of_stream) return $f260af419b27244f$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($f260af419b27244f$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($f260af419b27244f$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($f260af419b27244f$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($f260af419b27244f$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$f260af419b27244f$export$88fb0cfd153261a7 = $f260af419b27244f$var$TextEncoder;
$f260af419b27244f$export$9c6b53e35bc51b5c = $f260af419b27244f$var$TextDecoder;

});



parcelRegister("kVMwJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Assignable = module.exports.Enum = void 0;
/** @hidden @module */ class $f3cec5f3f44b5edc$var$Enum {
    constructor(properties){
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map((key)=>{
            this[key] = properties[key];
            this.enum = key;
        });
    }
}
module.exports.Enum = $f3cec5f3f44b5edc$var$Enum;
class $f3cec5f3f44b5edc$var$Assignable {
    constructor(properties){
        Object.keys(properties).map((key)=>{
            this[key] = properties[key];
        });
    }
}
module.exports.Assignable = $f3cec5f3f44b5edc$var$Assignable;

});



parcelRegister("8OBr1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserLocalStorageKeyStore = void 0;

var $kELc4 = parcelRequire("kELc4");

var $lsY0f = parcelRequire("lsY0f");
const $66b0080b4bfca06a$var$LOCAL_STORAGE_KEY_PREFIX = "near-api-js:keystore:";
/**
 * This class is used to store keys in the browsers local storage.
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#key-store}
 * @example
 * ```js
 * import { connect, keyStores } from 'near-api-js';
 *
 * const keyStore = new keyStores.BrowserLocalStorageKeyStore();
 * const config = {
 *   keyStore, // instance of BrowserLocalStorageKeyStore
 *   networkId: 'testnet',
 *   nodeUrl: 'https://rpc.testnet.near.org',
 *   walletUrl: 'https://wallet.testnet.near.org',
 *   helperUrl: 'https://helper.testnet.near.org',
 *   explorerUrl: 'https://explorer.testnet.near.org'
 * };
 *
 * // inside an async function
 * const near = await connect(config)
 * ```
 */ class $66b0080b4bfca06a$var$BrowserLocalStorageKeyStore extends $kELc4.KeyStore {
    /**
     * @param localStorage defaults to window.localStorage
     * @param prefix defaults to `near-api-js:keystore:`
     */ constructor(localStorage = window.localStorage, prefix = $66b0080b4bfca06a$var$LOCAL_STORAGE_KEY_PREFIX){
        super();
        this.localStorage = localStorage;
        this.prefix = prefix;
    }
    /**
     * Stores a {@link KeyPair} in local storage.
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @param keyPair The key pair to store in local storage
     */ async setKey(networkId, accountId, keyPair) {
        this.localStorage.setItem(this.storageKeyForSecretKey(networkId, accountId), keyPair.toString());
    }
    /**
     * Gets a {@link KeyPair} from local storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @returns {Promise<KeyPair>}
     */ async getKey(networkId, accountId) {
        const value = this.localStorage.getItem(this.storageKeyForSecretKey(networkId, accountId));
        if (!value) return null;
        return $lsY0f.KeyPair.fromString(value);
    }
    /**
     * Removes a {@link KeyPair} from local storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     */ async removeKey(networkId, accountId) {
        this.localStorage.removeItem(this.storageKeyForSecretKey(networkId, accountId));
    }
    /**
     * Removes all items that start with `prefix` from local storage
     */ async clear() {
        for (const key of this.storageKeys())if (key.startsWith(this.prefix)) this.localStorage.removeItem(key);
    }
    /**
     * Get the network(s) from local storage
     * @returns {Promise<string[]>}
     */ async getNetworks() {
        const result = new Set();
        for (const key of this.storageKeys())if (key.startsWith(this.prefix)) {
            const parts = key.substring(this.prefix.length).split(":");
            result.add(parts[1]);
        }
        return Array.from(result.values());
    }
    /**
     * Gets the account(s) from local storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns{Promise<string[]>}
     */ async getAccounts(networkId) {
        const result = new Array();
        for (const key of this.storageKeys())if (key.startsWith(this.prefix)) {
            const parts = key.substring(this.prefix.length).split(":");
            if (parts[1] === networkId) result.push(parts[0]);
        }
        return result;
    }
    /**
     * @hidden
     * Helper function to retrieve a local storage key
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the storage keythat's sought
     * @returns {string} An example might be: `near-api-js:keystore:near-friend:default`
     */ storageKeyForSecretKey(networkId, accountId) {
        return `${this.prefix}${accountId}:${networkId}`;
    }
    /** @hidden */ *storageKeys() {
        for(let i = 0; i < this.localStorage.length; i++)yield this.localStorage.key(i);
    }
}
module.exports.BrowserLocalStorageKeyStore = $66b0080b4bfca06a$var$BrowserLocalStorageKeyStore;

});

parcelRegister("gFytt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MergeKeyStore = void 0;

var $kELc4 = parcelRequire("kELc4");
class $c22b378fc4b45b38$var$MergeKeyStore extends $kELc4.KeyStore {
    /**
     * @param keyStores read calls are attempted from start to end of array
     * @param options.writeKeyStoreIndex the keystore index that will receive all write calls
     */ constructor(keyStores, options = {
        writeKeyStoreIndex: 0
    }){
        super();
        this.options = options;
        this.keyStores = keyStores;
    }
    /**
     * Store a {@link KeyPain} to the first index of a key store array
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @param keyPair The key pair to store in local storage
     */ async setKey(networkId, accountId, keyPair) {
        await this.keyStores[this.options.writeKeyStoreIndex].setKey(networkId, accountId, keyPair);
    }
    /**
     * Gets a {@link KeyPair} from the array of key stores
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @returns {Promise<KeyPair>}
     */ async getKey(networkId, accountId) {
        for (const keyStore of this.keyStores){
            const keyPair = await keyStore.getKey(networkId, accountId);
            if (keyPair) return keyPair;
        }
        return null;
    }
    /**
     * Removes a {@link KeyPair} from the array of key stores
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     */ async removeKey(networkId, accountId) {
        for (const keyStore of this.keyStores)await keyStore.removeKey(networkId, accountId);
    }
    /**
     * Removes all items from each key store
     */ async clear() {
        for (const keyStore of this.keyStores)await keyStore.clear();
    }
    /**
     * Get the network(s) from the array of key stores
     * @returns {Promise<string[]>}
     */ async getNetworks() {
        const result = new Set();
        for (const keyStore of this.keyStores)for (const network of (await keyStore.getNetworks()))result.add(network);
        return Array.from(result);
    }
    /**
     * Gets the account(s) from the array of key stores
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns{Promise<string[]>}
     */ async getAccounts(networkId) {
        const result = new Set();
        for (const keyStore of this.keyStores)for (const account of (await keyStore.getAccounts(networkId)))result.add(account);
        return Array.from(result);
    }
    /** @hidden */ toString() {
        return `MergeKeyStore(${this.keyStores.join(", ")})`;
    }
}
module.exports.MergeKeyStore = $c22b378fc4b45b38$var$MergeKeyStore;

});


parcelRegister("dyqiS", function(module, exports) {
"use strict";
var $9de2daa993895bc8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9de2daa993895bc8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9de2daa993895bc8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $9de2daa993895bc8$var$__createBinding(result, mod, k);
    }
    $9de2daa993895bc8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletConnection = module.exports.WalletAccount = module.exports.ConnectedWalletAccount = module.exports.Near = module.exports.KeyPair = module.exports.Signer = module.exports.InMemorySigner = module.exports.Contract = module.exports.Connection = module.exports.Account = module.exports.multisig = module.exports.validators = module.exports.transactions = module.exports.utils = module.exports.providers = module.exports.accountCreator = void 0;

/** @hidden @module */ const $9de2daa993895bc8$var$providers = $9de2daa993895bc8$var$__importStar((parcelRequire("2EqIG")));
module.exports.providers = $9de2daa993895bc8$var$providers;

const $9de2daa993895bc8$var$utils = $9de2daa993895bc8$var$__importStar((parcelRequire("gphuu")));
module.exports.utils = $9de2daa993895bc8$var$utils;

const $9de2daa993895bc8$var$transactions = $9de2daa993895bc8$var$__importStar((parcelRequire("9v9vF")));
module.exports.transactions = $9de2daa993895bc8$var$transactions;

const $9de2daa993895bc8$var$validators = $9de2daa993895bc8$var$__importStar((parcelRequire("hjq28")));
module.exports.validators = $9de2daa993895bc8$var$validators;

var $2As4n = parcelRequire("2As4n");
Object.defineProperty(module.exports, "Account", {
    enumerable: true,
    get: function() {
        return $2As4n.Account;
    }
});

const $9de2daa993895bc8$var$multisig = $9de2daa993895bc8$var$__importStar((parcelRequire("iJiDq")));
module.exports.multisig = $9de2daa993895bc8$var$multisig;

const $9de2daa993895bc8$var$accountCreator = $9de2daa993895bc8$var$__importStar((parcelRequire("7lsXa")));
module.exports.accountCreator = $9de2daa993895bc8$var$accountCreator;

var $aRlce = parcelRequire("aRlce");
Object.defineProperty(module.exports, "Connection", {
    enumerable: true,
    get: function() {
        return $aRlce.Connection;
    }
});

var $9BnjH = parcelRequire("9BnjH");
Object.defineProperty(module.exports, "Signer", {
    enumerable: true,
    get: function() {
        return $9BnjH.Signer;
    }
});
Object.defineProperty(module.exports, "InMemorySigner", {
    enumerable: true,
    get: function() {
        return $9BnjH.InMemorySigner;
    }
});

var $jVkqH = parcelRequire("jVkqH");
Object.defineProperty(module.exports, "Contract", {
    enumerable: true,
    get: function() {
        return $jVkqH.Contract;
    }
});

var $lsY0f = parcelRequire("lsY0f");
Object.defineProperty(module.exports, "KeyPair", {
    enumerable: true,
    get: function() {
        return $lsY0f.KeyPair;
    }
});

var $bfxBf = parcelRequire("bfxBf");
Object.defineProperty(module.exports, "Near", {
    enumerable: true,
    get: function() {
        return $bfxBf.Near;
    }
});

var $DUo3W = parcelRequire("DUo3W");
Object.defineProperty(module.exports, "ConnectedWalletAccount", {
    enumerable: true,
    get: function() {
        return $DUo3W.ConnectedWalletAccount;
    }
});
Object.defineProperty(module.exports, "WalletAccount", {
    enumerable: true,
    get: function() {
        return $DUo3W.WalletAccount;
    }
});
Object.defineProperty(module.exports, "WalletConnection", {
    enumerable: true,
    get: function() {
        return $DUo3W.WalletConnection;
    }
});

});
parcelRegister("2EqIG", function(module, exports) {
"use strict";
/** @hidden @module */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorContext = module.exports.TypedError = module.exports.getTransactionLastResult = module.exports.FinalExecutionStatusBasic = module.exports.JsonRpcProvider = module.exports.Provider = void 0;

var $DbQq1 = parcelRequire("DbQq1");
Object.defineProperty(module.exports, "Provider", {
    enumerable: true,
    get: function() {
        return $DbQq1.Provider;
    }
});
Object.defineProperty(module.exports, "getTransactionLastResult", {
    enumerable: true,
    get: function() {
        return $DbQq1.getTransactionLastResult;
    }
});
Object.defineProperty(module.exports, "FinalExecutionStatusBasic", {
    enumerable: true,
    get: function() {
        return $DbQq1.FinalExecutionStatusBasic;
    }
});

var $fEfLd = parcelRequire("fEfLd");
Object.defineProperty(module.exports, "JsonRpcProvider", {
    enumerable: true,
    get: function() {
        return $fEfLd.JsonRpcProvider;
    }
});
Object.defineProperty(module.exports, "TypedError", {
    enumerable: true,
    get: function() {
        return $fEfLd.TypedError;
    }
});
Object.defineProperty(module.exports, "ErrorContext", {
    enumerable: true,
    get: function() {
        return $fEfLd.ErrorContext;
    }
});

});
parcelRegister("DbQq1", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $075cd4b2496dba3b$require$Buffer = $6ZWSX.Buffer;
"use strict";
/**
 * NEAR RPC API request types and responses
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTransactionLastResult = module.exports.Provider = module.exports.IdType = module.exports.FinalExecutionStatusBasic = module.exports.ExecutionStatusBasic = void 0;
var $075cd4b2496dba3b$var$ExecutionStatusBasic;
(function(ExecutionStatusBasic) {
    ExecutionStatusBasic["Unknown"] = "Unknown";
    ExecutionStatusBasic["Pending"] = "Pending";
    ExecutionStatusBasic["Failure"] = "Failure";
})($075cd4b2496dba3b$var$ExecutionStatusBasic = module.exports.ExecutionStatusBasic || (module.exports.ExecutionStatusBasic = {}));
var $075cd4b2496dba3b$var$FinalExecutionStatusBasic;
(function(FinalExecutionStatusBasic) {
    FinalExecutionStatusBasic["NotStarted"] = "NotStarted";
    FinalExecutionStatusBasic["Started"] = "Started";
    FinalExecutionStatusBasic["Failure"] = "Failure";
})($075cd4b2496dba3b$var$FinalExecutionStatusBasic = module.exports.FinalExecutionStatusBasic || (module.exports.FinalExecutionStatusBasic = {}));
var $075cd4b2496dba3b$var$IdType;
(function(IdType) {
    IdType["Transaction"] = "transaction";
    IdType["Receipt"] = "receipt";
})($075cd4b2496dba3b$var$IdType = module.exports.IdType || (module.exports.IdType = {}));
/** @hidden */ class $075cd4b2496dba3b$var$Provider {
}
module.exports.Provider = $075cd4b2496dba3b$var$Provider;
/** @hidden */ function $075cd4b2496dba3b$var$getTransactionLastResult(txResult) {
    if (typeof txResult.status === "object" && typeof txResult.status.SuccessValue === "string") {
        const value = $075cd4b2496dba3b$require$Buffer.from(txResult.status.SuccessValue, "base64").toString();
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    }
    return null;
}
module.exports.getTransactionLastResult = $075cd4b2496dba3b$var$getTransactionLastResult;

});

parcelRegister("fEfLd", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b646d12b59930ab4$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $b646d12b59930ab4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonRpcProvider = module.exports.ErrorContext = module.exports.TypedError = void 0;

/**
 * This module contains the {@link JsonRpcProvider} client class
 * which can be used to interact with the NEAR RPC API.
 * @see {@link providers/provider} for a list of request and response types
 */ const $b646d12b59930ab4$var$depd_1 = $b646d12b59930ab4$var$__importDefault((parcelRequire("6TCoX")));

var $DbQq1 = parcelRequire("DbQq1");

var $9lI55 = parcelRequire("9lI55");

var $hR4Jw = parcelRequire("hR4Jw");
Object.defineProperty(module.exports, "TypedError", {
    enumerable: true,
    get: function() {
        return $hR4Jw.TypedError;
    }
});
Object.defineProperty(module.exports, "ErrorContext", {
    enumerable: true,
    get: function() {
        return $hR4Jw.ErrorContext;
    }
});

var $75BJw = parcelRequire("75BJw");

const $b646d12b59930ab4$var$exponential_backoff_1 = $b646d12b59930ab4$var$__importDefault((parcelRequire("f0qo0")));

var $1Z4jS = parcelRequire("1Z4jS");
// Default number of retries before giving up on a request.
const $b646d12b59930ab4$var$REQUEST_RETRY_NUMBER = 12;
// Default wait until next retry in millis.
const $b646d12b59930ab4$var$REQUEST_RETRY_WAIT = 500;
// Exponential back off for waiting to retry.
const $b646d12b59930ab4$var$REQUEST_RETRY_WAIT_BACKOFF = 1.5;
/// Keep ids unique across all connections.
let $b646d12b59930ab4$var$_nextId = 123;
/**
 * Client class to interact with the NEAR RPC API.
 * @see {@link https://github.com/near/nearcore/tree/master/chain/jsonrpc}
 */ class $b646d12b59930ab4$var$JsonRpcProvider extends $DbQq1.Provider {
    /**
     * @param connectionInfoOrUrl ConnectionInfo or RPC API endpoint URL (deprecated)
     */ constructor(connectionInfoOrUrl){
        super();
        if (connectionInfoOrUrl != null && typeof connectionInfoOrUrl == "object") this.connection = connectionInfoOrUrl;
        else {
            const deprecate = $b646d12b59930ab4$var$depd_1.default("JsonRpcProvider(url?: string)");
            deprecate("use `JsonRpcProvider(connectionInfo: ConnectionInfo)` instead");
            this.connection = {
                url: connectionInfoOrUrl
            };
        }
    }
    /**
     * Gets the RPC's status
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#general-validator-status}
     */ async status() {
        return this.sendJsonRpc("status", []);
    }
    /**
     * Sends a signed transaction to the RPC and waits until transaction is fully complete
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#send-transaction-await}
     *
     * @param signedTransaction The signed transaction being sent
     */ async sendTransaction(signedTransaction) {
        const bytes = signedTransaction.encode();
        return this.sendJsonRpc("broadcast_tx_commit", [
            $b646d12b59930ab4$require$Buffer.from(bytes).toString("base64")
        ]);
    }
    /**
     * Sends a signed transaction to the RPC and immediately returns transaction hash
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#send-transaction-async)
     * @param signedTransaction The signed transaction being sent
     * @returns {Promise<FinalExecutionOutcome>}
     */ async sendTransactionAsync(signedTransaction) {
        const bytes = signedTransaction.encode();
        return this.sendJsonRpc("broadcast_tx_async", [
            $b646d12b59930ab4$require$Buffer.from(bytes).toString("base64")
        ]);
    }
    /**
     * Gets a transaction's status from the RPC
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#transaction-status}
     *
     * @param txHash A transaction hash as either a Uint8Array or a base58 encoded string
     * @param accountId The NEAR account that signed the transaction
     */ async txStatus(txHash, accountId) {
        if (typeof txHash === "string") return this.txStatusString(txHash, accountId);
        else return this.txStatusUint8Array(txHash, accountId);
    }
    async txStatusUint8Array(txHash, accountId) {
        return this.sendJsonRpc("tx", [
            $75BJw.baseEncode(txHash),
            accountId
        ]);
    }
    async txStatusString(txHash, accountId) {
        return this.sendJsonRpc("tx", [
            txHash,
            accountId
        ]);
    }
    /**
     * Gets a transaction's status from the RPC with receipts
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#transaction-status-with-receipts)
     * @param txHash The hash of the transaction
     * @param accountId The NEAR account that signed the transaction
     * @returns {Promise<FinalExecutionOutcome>}
     */ async txStatusReceipts(txHash, accountId) {
        return this.sendJsonRpc("EXPERIMENTAL_tx_status", [
            $75BJw.baseEncode(txHash),
            accountId
        ]);
    }
    /**
     * Query the RPC as [shown in the docs](https://docs.near.org/docs/develop/front-end/rpc#accounts--contracts)
     * Query the RPC by passing an {@link RpcQueryRequest}
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#accounts--contracts}
     *
     * @typeParam T the shape of the returned query response
     */ async query(...args) {
        let result;
        if (args.length === 1) result = await this.sendJsonRpc("query", args[0]);
        else {
            const [path, data] = args;
            result = await this.sendJsonRpc("query", [
                path,
                data
            ]);
        }
        if (result && result.error) throw new $hR4Jw.TypedError(`Querying ${args} failed: ${result.error}.\n${JSON.stringify(result, null, 2)}`, $1Z4jS.getErrorTypeFromErrorMessage(result.error));
        return result;
    }
    /**
     * Query for block info from the RPC
     * pass block_id OR finality as blockQuery, not both
     * @see {@link https://docs.near.org/docs/interaction/rpc#block}
     *
     * @param blockQuery {@link BlockReference} (passing a {@link BlockId} is deprecated)
     */ async block(blockQuery) {
        const { finality: finality } = blockQuery;
        let { blockId: blockId } = blockQuery;
        if (typeof blockQuery !== "object") {
            const deprecate = $b646d12b59930ab4$var$depd_1.default("JsonRpcProvider.block(blockId)");
            deprecate("use `block({ blockId })` or `block({ finality })` instead");
            blockId = blockQuery;
        }
        return this.sendJsonRpc("block", {
            block_id: blockId,
            finality: finality
        });
    }
    /**
     * Query changes in block from the RPC
     * pass block_id OR finality as blockQuery, not both
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#block-details)
     */ async blockChanges(blockQuery) {
        const { finality: finality } = blockQuery;
        const { blockId: blockId } = blockQuery;
        return this.sendJsonRpc("EXPERIMENTAL_changes_in_block", {
            block_id: blockId,
            finality: finality
        });
    }
    /**
     * Queries for details about a specific chunk appending details of receipts and transactions to the same chunk data provided by a block
     * @see {@link https://docs.near.org/docs/interaction/rpc#chunk}
     *
     * @param chunkId Hash of a chunk ID or shard ID
     */ async chunk(chunkId) {
        return this.sendJsonRpc("chunk", [
            chunkId
        ]);
    }
    /**
     * Query validators of the epoch defined by the given block id.
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#detailed-validator-status}
     *
     * @param blockId Block hash or height, or null for latest.
     */ async validators(blockId) {
        return this.sendJsonRpc("validators", [
            blockId
        ]);
    }
    /**
     * @deprecated
     * Gets the genesis config from RPC
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#genesis-config}
     */ async experimental_genesisConfig() {
        const deprecate = $b646d12b59930ab4$var$depd_1.default("JsonRpcProvider.experimental_protocolConfig()");
        deprecate("use `experimental_protocolConfig({ sync_checkpoint: 'genesis' })` to fetch the up-to-date or genesis protocol config explicitly");
        return await this.sendJsonRpc("EXPERIMENTAL_protocol_config", {
            sync_checkpoint: "genesis"
        });
    }
    /**
     * Gets the protocol config at a block from RPC
     * @see {@link }
     *
     * @param blockReference specifies the block to get the protocol config for
     */ async experimental_protocolConfig(blockReference) {
        return await this.sendJsonRpc("EXPERIMENTAL_protocol_config", blockReference);
    }
    /**
     * @deprecated Use {@link lightClientProof} instead
     */ async experimental_lightClientProof(request) {
        const deprecate = $b646d12b59930ab4$var$depd_1.default("JsonRpcProvider.experimental_lightClientProof(request)");
        deprecate("use `lightClientProof` instead");
        return await this.lightClientProof(request);
    }
    /**
     * Gets a light client execution proof for verifying execution outcomes
     * @see {@link https://github.com/nearprotocol/NEPs/blob/master/specs/ChainSpec/LightClient.md#light-client-proof}
     */ async lightClientProof(request) {
        return await this.sendJsonRpc("EXPERIMENTAL_light_client_proof", request);
    }
    /**
     * Gets access key changes for a given array of accountIds
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-access-key-changes-all)
     * @returns {Promise<ChangeResult>}
     */ async accessKeyChanges(accountIdArray, blockQuery) {
        const { finality: finality } = blockQuery;
        const { blockId: blockId } = blockQuery;
        return this.sendJsonRpc("EXPERIMENTAL_changes", {
            changes_type: "all_access_key_changes",
            account_ids: accountIdArray,
            block_id: blockId,
            finality: finality
        });
    }
    /**
     * Gets single access key changes for a given array of access keys
     * pass block_id OR finality as blockQuery, not both
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-access-key-changes-single)
     * @returns {Promise<ChangeResult>}
     */ async singleAccessKeyChanges(accessKeyArray, blockQuery) {
        const { finality: finality } = blockQuery;
        const { blockId: blockId } = blockQuery;
        return this.sendJsonRpc("EXPERIMENTAL_changes", {
            changes_type: "single_access_key_changes",
            keys: accessKeyArray,
            block_id: blockId,
            finality: finality
        });
    }
    /**
     * Gets account changes for a given array of accountIds
     * pass block_id OR finality as blockQuery, not both
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-account-changes)
     * @returns {Promise<ChangeResult>}
     */ async accountChanges(accountIdArray, blockQuery) {
        const { finality: finality } = blockQuery;
        const { blockId: blockId } = blockQuery;
        return this.sendJsonRpc("EXPERIMENTAL_changes", {
            changes_type: "account_changes",
            account_ids: accountIdArray,
            block_id: blockId,
            finality: finality
        });
    }
    /**
     * Gets contract state changes for a given array of accountIds
     * pass block_id OR finality as blockQuery, not both
     * Note: If you pass a keyPrefix it must be base64 encoded
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-contract-state-changes)
     * @returns {Promise<ChangeResult>}
     */ async contractStateChanges(accountIdArray, blockQuery, keyPrefix = "") {
        const { finality: finality } = blockQuery;
        const { blockId: blockId } = blockQuery;
        return this.sendJsonRpc("EXPERIMENTAL_changes", {
            changes_type: "data_changes",
            account_ids: accountIdArray,
            key_prefix_base64: keyPrefix,
            block_id: blockId,
            finality: finality
        });
    }
    /**
     * Gets contract code changes for a given array of accountIds
     * pass block_id OR finality as blockQuery, not both
     * Note: Change is returned in a base64 encoded WASM file
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-contract-code-changes)
     * @returns {Promise<ChangeResult>}
     */ async contractCodeChanges(accountIdArray, blockQuery) {
        const { finality: finality } = blockQuery;
        const { blockId: blockId } = blockQuery;
        return this.sendJsonRpc("EXPERIMENTAL_changes", {
            changes_type: "contract_code_changes",
            account_ids: accountIdArray,
            block_id: blockId,
            finality: finality
        });
    }
    /**
     * Returns gas price for a specific block_height or block_hash.
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#gas-price}
     *
     * @param blockId Block hash or height, or null for latest.
     */ async gasPrice(blockId) {
        return await this.sendJsonRpc("gas_price", [
            blockId
        ]);
    }
    /**
     * Directly call the RPC specifying the method and params
     *
     * @param method RPC method
     * @param params Parameters to the method
     */ async sendJsonRpc(method, params) {
        const response = await $b646d12b59930ab4$var$exponential_backoff_1.default($b646d12b59930ab4$var$REQUEST_RETRY_WAIT, $b646d12b59930ab4$var$REQUEST_RETRY_NUMBER, $b646d12b59930ab4$var$REQUEST_RETRY_WAIT_BACKOFF, async ()=>{
            try {
                const request = {
                    method: method,
                    params: params,
                    id: $b646d12b59930ab4$var$_nextId++,
                    jsonrpc: "2.0"
                };
                const response = await $9lI55.fetchJson(this.connection, JSON.stringify(request));
                if (response.error) {
                    if (typeof response.error.data === "object") {
                        if (typeof response.error.data.error_message === "string" && typeof response.error.data.error_type === "string") // if error data has error_message and error_type properties, we consider that node returned an error in the old format
                        throw new $hR4Jw.TypedError(response.error.data.error_message, response.error.data.error_type);
                        throw $1Z4jS.parseRpcError(response.error.data);
                    } else {
                        const errorMessage = `[${response.error.code}] ${response.error.message}: ${response.error.data}`;
                        // NOTE: All this hackery is happening because structured errors not implemented
                        // TODO: Fix when https://github.com/nearprotocol/nearcore/issues/1839 gets resolved
                        if (response.error.data === "Timeout" || errorMessage.includes("Timeout error") || errorMessage.includes("query has timed out")) throw new $hR4Jw.TypedError(errorMessage, "TimeoutError");
                        throw new $hR4Jw.TypedError(errorMessage, $1Z4jS.getErrorTypeFromErrorMessage(response.error.data));
                    }
                }
                // Success when response.error is not exist
                return response;
            } catch (error) {
                if (error.type === "TimeoutError") {
                    console.warn(`Retrying request to ${method} as it has timed out`, params);
                    return null;
                }
                throw error;
            }
        });
        const { result: result } = response;
        // From jsonrpc spec:
        // result
        //   This member is REQUIRED on success.
        //   This member MUST NOT exist if there was an error invoking the method.
        if (typeof result === "undefined") throw new $hR4Jw.TypedError(`Exceeded ${$b646d12b59930ab4$var$REQUEST_RETRY_NUMBER} attempts for request to ${method}.`, "RetriesExceeded");
        return result;
    }
}
module.exports.JsonRpcProvider = $b646d12b59930ab4$var$JsonRpcProvider;

});
parcelRegister("6TCoX", function(module, exports) {
/*!
 * depd
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";
/**
 * Module exports.
 * @public
 */ module.exports = $5055aaddce11faec$var$depd;
/**
 * Create deprecate for namespace in caller.
 */ function $5055aaddce11faec$var$depd(namespace) {
    if (!namespace) throw new TypeError("argument namespace is required");
    function deprecate(message) {
    // no-op in browser
    }
    deprecate._file = undefined;
    deprecate._ignored = true;
    deprecate._namespace = namespace;
    deprecate._traced = false;
    deprecate._warned = Object.create(null);
    deprecate.function = $5055aaddce11faec$var$wrapfunction;
    deprecate.property = $5055aaddce11faec$var$wrapproperty;
    return deprecate;
}
/**
 * Return a wrapped function in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $5055aaddce11faec$var$wrapfunction(fn, message) {
    if (typeof fn !== "function") throw new TypeError("argument fn must be a function");
    return fn;
}
/**
 * Wrap property in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $5055aaddce11faec$var$wrapproperty(obj, prop, message) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new TypeError("argument obj must be object");
    var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
    if (!descriptor) throw new TypeError("must call property on owner object");
    if (!descriptor.configurable) throw new TypeError("property must be configurable");
}

});

parcelRegister("9lI55", function(module, exports) {
"use strict";
var $6ce844cffcc78cdb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchJson = void 0;

const $6ce844cffcc78cdb$var$http_errors_1 = $6ce844cffcc78cdb$var$__importDefault((parcelRequire("58x2d")));

const $6ce844cffcc78cdb$var$exponential_backoff_1 = $6ce844cffcc78cdb$var$__importDefault((parcelRequire("f0qo0")));

var $2EqIG = parcelRequire("2EqIG");

var $hR4Jw = parcelRequire("hR4Jw");
const $6ce844cffcc78cdb$var$START_WAIT_TIME_MS = 1000;
const $6ce844cffcc78cdb$var$BACKOFF_MULTIPLIER = 1.5;
const $6ce844cffcc78cdb$var$RETRY_NUMBER = 10;
async function $6ce844cffcc78cdb$var$fetchJson(connectionInfoOrUrl, json) {
    let connectionInfo = {
        url: null
    };
    if (typeof connectionInfoOrUrl === "string") connectionInfo.url = connectionInfoOrUrl;
    else connectionInfo = connectionInfoOrUrl;
    const response = await $6ce844cffcc78cdb$var$exponential_backoff_1.default($6ce844cffcc78cdb$var$START_WAIT_TIME_MS, $6ce844cffcc78cdb$var$RETRY_NUMBER, $6ce844cffcc78cdb$var$BACKOFF_MULTIPLIER, async ()=>{
        try {
            const response = await fetch(connectionInfo.url, {
                method: json ? "POST" : "GET",
                body: json ? json : undefined,
                headers: {
                    ...connectionInfo.headers,
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) {
                if (response.status === 503) {
                    $hR4Jw.logWarning(`Retrying HTTP request for ${connectionInfo.url} as it's not available now`);
                    return null;
                }
                throw $6ce844cffcc78cdb$var$http_errors_1.default(response.status, await response.text());
            }
            return response;
        } catch (error) {
            if (error.toString().includes("FetchError") || error.toString().includes("Failed to fetch")) {
                $hR4Jw.logWarning(`Retrying HTTP request for ${connectionInfo.url} because of error: ${error}`);
                return null;
            }
            throw error;
        }
    });
    if (!response) throw new $2EqIG.TypedError(`Exceeded ${$6ce844cffcc78cdb$var$RETRY_NUMBER} attempts for ${connectionInfo.url}.`, "RetriesExceeded");
    return await response.json();
}
module.exports.fetchJson = $6ce844cffcc78cdb$var$fetchJson;

});
parcelRegister("58x2d", function(module, exports) {
/*!
 * http-errors
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";

/**
 * Module dependencies.
 * @private
 */ var $3bd75317c7f07a31$var$deprecate = (parcelRequire("X3KGm"))("http-errors");

var $3nZY5 = parcelRequire("3nZY5");

var $d99DW = parcelRequire("d99DW");

var $dlqwk = parcelRequire("dlqwk");

var $23DWx = parcelRequire("23DWx");
/**
 * Module exports.
 * @public
 */ module.exports = $3bd75317c7f07a31$var$createError;
module.exports.HttpError = $3bd75317c7f07a31$var$createHttpErrorConstructor();
module.exports.isHttpError = $3bd75317c7f07a31$var$createIsHttpErrorFunction(module.exports.HttpError);
// Populate exports for all constructors
$3bd75317c7f07a31$var$populateConstructorExports(module.exports, $d99DW.codes, module.exports.HttpError);
/**
 * Get the code class of a status code.
 * @private
 */ function $3bd75317c7f07a31$var$codeClass(status) {
    return Number(String(status).charAt(0) + "00");
}
/**
 * Create a new HTTP Error.
 *
 * @returns {Error}
 * @public
 */ function $3bd75317c7f07a31$var$createError() {
    // so much arity going on ~_~
    var err;
    var msg;
    var status = 500;
    var props = {};
    for(var i = 0; i < arguments.length; i++){
        var arg = arguments[i];
        if (arg instanceof Error) {
            err = arg;
            status = err.status || err.statusCode || status;
            continue;
        }
        switch(typeof arg){
            case "string":
                msg = arg;
                break;
            case "number":
                status = arg;
                if (i !== 0) $3bd75317c7f07a31$var$deprecate("non-first-argument status code; replace with createError(" + arg + ", ...)");
                break;
            case "object":
                props = arg;
                break;
        }
    }
    if (typeof status === "number" && (status < 400 || status >= 600)) $3bd75317c7f07a31$var$deprecate("non-error status code; use only 4xx or 5xx status codes");
    if (typeof status !== "number" || !$d99DW[status] && (status < 400 || status >= 600)) status = 500;
    // constructor
    var HttpError = $3bd75317c7f07a31$var$createError[status] || $3bd75317c7f07a31$var$createError[$3bd75317c7f07a31$var$codeClass(status)];
    if (!err) {
        // create error
        err = HttpError ? new HttpError(msg) : new Error(msg || $d99DW[status]);
        Error.captureStackTrace(err, $3bd75317c7f07a31$var$createError);
    }
    if (!HttpError || !(err instanceof HttpError) || err.status !== status) {
        // add properties to generic error
        err.expose = status < 500;
        err.status = err.statusCode = status;
    }
    for(var key in props)if (key !== "status" && key !== "statusCode") err[key] = props[key];
    return err;
}
/**
 * Create HTTP error abstract base class.
 * @private
 */ function $3bd75317c7f07a31$var$createHttpErrorConstructor() {
    function HttpError() {
        throw new TypeError("cannot construct abstract class");
    }
    $dlqwk(HttpError, Error);
    return HttpError;
}
/**
 * Create a constructor for a client error.
 * @private
 */ function $3bd75317c7f07a31$var$createClientErrorConstructor(HttpError, name, code) {
    var className = $3bd75317c7f07a31$var$toClassName(name);
    function ClientError(message) {
        // create the error object
        var msg = message != null ? message : $d99DW[code];
        var err = new Error(msg);
        // capture a stack trace to the construction point
        Error.captureStackTrace(err, ClientError);
        // adjust the [[Prototype]]
        $3nZY5(err, ClientError.prototype);
        // redefine the error message
        Object.defineProperty(err, "message", {
            enumerable: true,
            configurable: true,
            value: msg,
            writable: true
        });
        // redefine the error name
        Object.defineProperty(err, "name", {
            enumerable: false,
            configurable: true,
            value: className,
            writable: true
        });
        return err;
    }
    $dlqwk(ClientError, HttpError);
    $3bd75317c7f07a31$var$nameFunc(ClientError, className);
    ClientError.prototype.status = code;
    ClientError.prototype.statusCode = code;
    ClientError.prototype.expose = true;
    return ClientError;
}
/**
 * Create function to test is a value is a HttpError.
 * @private
 */ function $3bd75317c7f07a31$var$createIsHttpErrorFunction(HttpError) {
    return function isHttpError(val) {
        if (!val || typeof val !== "object") return false;
        if (val instanceof HttpError) return true;
        return val instanceof Error && typeof val.expose === "boolean" && typeof val.statusCode === "number" && val.status === val.statusCode;
    };
}
/**
 * Create a constructor for a server error.
 * @private
 */ function $3bd75317c7f07a31$var$createServerErrorConstructor(HttpError, name, code) {
    var className = $3bd75317c7f07a31$var$toClassName(name);
    function ServerError(message) {
        // create the error object
        var msg = message != null ? message : $d99DW[code];
        var err = new Error(msg);
        // capture a stack trace to the construction point
        Error.captureStackTrace(err, ServerError);
        // adjust the [[Prototype]]
        $3nZY5(err, ServerError.prototype);
        // redefine the error message
        Object.defineProperty(err, "message", {
            enumerable: true,
            configurable: true,
            value: msg,
            writable: true
        });
        // redefine the error name
        Object.defineProperty(err, "name", {
            enumerable: false,
            configurable: true,
            value: className,
            writable: true
        });
        return err;
    }
    $dlqwk(ServerError, HttpError);
    $3bd75317c7f07a31$var$nameFunc(ServerError, className);
    ServerError.prototype.status = code;
    ServerError.prototype.statusCode = code;
    ServerError.prototype.expose = false;
    return ServerError;
}
/**
 * Set the name of a function, if possible.
 * @private
 */ function $3bd75317c7f07a31$var$nameFunc(func, name) {
    var desc = Object.getOwnPropertyDescriptor(func, "name");
    if (desc && desc.configurable) {
        desc.value = name;
        Object.defineProperty(func, "name", desc);
    }
}
/**
 * Populate the exports object with constructors for every error class.
 * @private
 */ function $3bd75317c7f07a31$var$populateConstructorExports(exports, codes, HttpError) {
    codes.forEach(function forEachCode(code) {
        var CodeError;
        var name = $23DWx($d99DW[code]);
        switch($3bd75317c7f07a31$var$codeClass(code)){
            case 400:
                CodeError = $3bd75317c7f07a31$var$createClientErrorConstructor(HttpError, name, code);
                break;
            case 500:
                CodeError = $3bd75317c7f07a31$var$createServerErrorConstructor(HttpError, name, code);
                break;
        }
        if (CodeError) {
            // export the constructor
            exports[code] = CodeError;
            exports[name] = CodeError;
        }
    });
    // backwards-compatibility
    exports["I'mateapot"] = $3bd75317c7f07a31$var$deprecate.function(exports.ImATeapot, '"I\'mateapot"; use "ImATeapot" instead');
}
/**
 * Get a class name from a name identifier.
 * @private
 */ function $3bd75317c7f07a31$var$toClassName(name) {
    return name.substr(-5) !== "Error" ? name + "Error" : name;
}

});
parcelRegister("X3KGm", function(module, exports) {
/*!
 * depd
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";
/**
 * Module exports.
 * @public
 */ module.exports = $0b186bdc1ad4c3f3$var$depd;
/**
 * Create deprecate for namespace in caller.
 */ function $0b186bdc1ad4c3f3$var$depd(namespace) {
    if (!namespace) throw new TypeError("argument namespace is required");
    function deprecate(message) {
    // no-op in browser
    }
    deprecate._file = undefined;
    deprecate._ignored = true;
    deprecate._namespace = namespace;
    deprecate._traced = false;
    deprecate._warned = Object.create(null);
    deprecate.function = $0b186bdc1ad4c3f3$var$wrapfunction;
    deprecate.property = $0b186bdc1ad4c3f3$var$wrapproperty;
    return deprecate;
}
/**
 * Return a wrapped function in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $0b186bdc1ad4c3f3$var$wrapfunction(fn, message) {
    if (typeof fn !== "function") throw new TypeError("argument fn must be a function");
    return fn;
}
/**
 * Wrap property in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $0b186bdc1ad4c3f3$var$wrapproperty(obj, prop, message) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new TypeError("argument obj must be object");
    var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
    if (!descriptor) throw new TypeError("must call property on owner object");
    if (!descriptor.configurable) throw new TypeError("property must be configurable");
}

});

parcelRegister("3nZY5", function(module, exports) {
"use strict";
/* eslint no-proto: 0 */ module.exports = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $277396adfd87479d$var$setProtoOf : $277396adfd87479d$var$mixinProperties);
function $277396adfd87479d$var$setProtoOf(obj, proto) {
    obj.__proto__ = proto;
    return obj;
}
function $277396adfd87479d$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) obj[prop] = proto[prop];
    return obj;
}

});

parcelRegister("d99DW", function(module, exports) {
/*!
 * statuses
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";

var $12Y8A = parcelRequire("12Y8A");
/**
 * Module exports.
 * @public
 */ module.exports = $99239894da664ca7$var$status;
// status code to message map
$99239894da664ca7$var$status.STATUS_CODES = $12Y8A;
// array of status codes
$99239894da664ca7$var$status.codes = $99239894da664ca7$var$populateStatusesMap($99239894da664ca7$var$status, $12Y8A);
// status codes for redirects
$99239894da664ca7$var$status.redirect = {
    300: true,
    301: true,
    302: true,
    303: true,
    305: true,
    307: true,
    308: true
};
// status codes for empty bodies
$99239894da664ca7$var$status.empty = {
    204: true,
    205: true,
    304: true
};
// status codes for when you should retry the request
$99239894da664ca7$var$status.retry = {
    502: true,
    503: true,
    504: true
};
/**
 * Populate the statuses map for given codes.
 * @private
 */ function $99239894da664ca7$var$populateStatusesMap(statuses, codes) {
    var arr = [];
    Object.keys(codes).forEach(function forEachCode(code) {
        var message = codes[code];
        var status = Number(code);
        // Populate properties
        statuses[status] = message;
        statuses[message] = status;
        statuses[message.toLowerCase()] = status;
        // Add to array
        arr.push(status);
    });
    return arr;
}
/**
 * Get the status code.
 *
 * Given a number, this will throw if it is not a known status
 * code, otherwise the code will be returned. Given a string,
 * the string will be parsed for a number and return the code
 * if valid, otherwise will lookup the code assuming this is
 * the status message.
 *
 * @param {string|number} code
 * @returns {number}
 * @public
 */ function $99239894da664ca7$var$status(code) {
    if (typeof code === "number") {
        if (!$99239894da664ca7$var$status[code]) throw new Error("invalid status code: " + code);
        return code;
    }
    if (typeof code !== "string") throw new TypeError("code must be a number or string");
    // '403'
    var n = parseInt(code, 10);
    if (!isNaN(n)) {
        if (!$99239894da664ca7$var$status[n]) throw new Error("invalid status code: " + n);
        return n;
    }
    n = $99239894da664ca7$var$status[code.toLowerCase()];
    if (!n) throw new Error('invalid status message: "' + code + '"');
    return n;
}

});
parcelRegister("12Y8A", function(module, exports) {
module.exports = JSON.parse('{"100":"Continue","101":"Switching Protocols","102":"Processing","103":"Early Hints","200":"OK","201":"Created","202":"Accepted","203":"Non-Authoritative Information","204":"No Content","205":"Reset Content","206":"Partial Content","207":"Multi-Status","208":"Already Reported","226":"IM Used","300":"Multiple Choices","301":"Moved Permanently","302":"Found","303":"See Other","304":"Not Modified","305":"Use Proxy","306":"(Unused)","307":"Temporary Redirect","308":"Permanent Redirect","400":"Bad Request","401":"Unauthorized","402":"Payment Required","403":"Forbidden","404":"Not Found","405":"Method Not Allowed","406":"Not Acceptable","407":"Proxy Authentication Required","408":"Request Timeout","409":"Conflict","410":"Gone","411":"Length Required","412":"Precondition Failed","413":"Payload Too Large","414":"URI Too Long","415":"Unsupported Media Type","416":"Range Not Satisfiable","417":"Expectation Failed","418":"I\'m a teapot","421":"Misdirected Request","422":"Unprocessable Entity","423":"Locked","424":"Failed Dependency","425":"Unordered Collection","426":"Upgrade Required","428":"Precondition Required","429":"Too Many Requests","431":"Request Header Fields Too Large","451":"Unavailable For Legal Reasons","500":"Internal Server Error","501":"Not Implemented","502":"Bad Gateway","503":"Service Unavailable","504":"Gateway Timeout","505":"HTTP Version Not Supported","506":"Variant Also Negotiates","507":"Insufficient Storage","508":"Loop Detected","509":"Bandwidth Limit Exceeded","510":"Not Extended","511":"Network Authentication Required"}');

});


parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("23DWx", function(module, exports) {
/*!
 * toidentifier
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";
/**
 * Module exports.
 * @public
 */ module.exports = $17fad871ca850f0a$var$toIdentifier;
/**
 * Trasform the given string into a JavaScript identifier
 *
 * @param {string} str
 * @returns {string}
 * @public
 */ function $17fad871ca850f0a$var$toIdentifier(str) {
    return str.split(" ").map(function(token) {
        return token.slice(0, 1).toUpperCase() + token.slice(1);
    }).join("").replace(/[^ _0-9a-z]/gi, "");
}

});


parcelRegister("f0qo0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
async function $aecb52d74e246b10$var$exponentialBackoff(startWaitTime, retryNumber, waitBackoff, getResult) {
    // TODO: jitter?
    let waitTime = startWaitTime;
    for(let i = 0; i < retryNumber; i++){
        const result = await getResult();
        if (result) return result;
        await $aecb52d74e246b10$var$sleep(waitTime);
        waitTime *= waitBackoff;
    }
    return null;
}
module.exports.default = $aecb52d74e246b10$var$exponentialBackoff;
// Sleep given number of millis.
function $aecb52d74e246b10$var$sleep(millis) {
    return new Promise((resolve)=>setTimeout(resolve, millis));
}

});

parcelRegister("hR4Jw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logWarning = module.exports.ErrorContext = module.exports.TypedError = module.exports.ArgumentTypeError = module.exports.PositionalArgsError = void 0;
class $cffb0ed235ea90a3$var$PositionalArgsError extends Error {
    constructor(){
        super("Contract method calls expect named arguments wrapped in object, e.g. { argName1: argValue1, argName2: argValue2 }");
    }
}
module.exports.PositionalArgsError = $cffb0ed235ea90a3$var$PositionalArgsError;
class $cffb0ed235ea90a3$var$ArgumentTypeError extends Error {
    constructor(argName, argType, argValue){
        super(`Expected ${argType} for '${argName}' argument, but got '${JSON.stringify(argValue)}'`);
    }
}
module.exports.ArgumentTypeError = $cffb0ed235ea90a3$var$ArgumentTypeError;
class $cffb0ed235ea90a3$var$TypedError extends Error {
    constructor(message, type, context){
        super(message);
        this.type = type || "UntypedError";
        this.context = context;
    }
}
module.exports.TypedError = $cffb0ed235ea90a3$var$TypedError;
class $cffb0ed235ea90a3$var$ErrorContext {
    constructor(transactionHash){
        this.transactionHash = transactionHash;
    }
}
module.exports.ErrorContext = $cffb0ed235ea90a3$var$ErrorContext;
function $cffb0ed235ea90a3$var$logWarning(...args) {
    console.warn(...args);
}
module.exports.logWarning = $cffb0ed235ea90a3$var$logWarning;

});


parcelRegister("1Z4jS", function(module, exports) {
"use strict";
var $171ed6ba1fd4234c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getErrorTypeFromErrorMessage = module.exports.formatError = module.exports.parseResultError = module.exports.parseRpcError = module.exports.ServerError = void 0;

const $171ed6ba1fd4234c$var$mustache_1 = $171ed6ba1fd4234c$var$__importDefault((parcelRequire("ifgZ7")));

const $171ed6ba1fd4234c$var$rpc_error_schema_json_1 = $171ed6ba1fd4234c$var$__importDefault((parcelRequire("9xxsQ")));

const $171ed6ba1fd4234c$var$error_messages_json_1 = $171ed6ba1fd4234c$var$__importDefault((parcelRequire("jMLGO")));

var $dyqiS = parcelRequire("dyqiS");

var $hR4Jw = parcelRequire("hR4Jw");
const $171ed6ba1fd4234c$var$mustacheHelpers = {
    formatNear: ()=>(n, render)=>$dyqiS.utils.format.formatNearAmount(render(n))
};
class $171ed6ba1fd4234c$var$ServerError extends $hR4Jw.TypedError {
}
module.exports.ServerError = $171ed6ba1fd4234c$var$ServerError;
class $171ed6ba1fd4234c$var$ServerTransactionError extends $171ed6ba1fd4234c$var$ServerError {
}
function $171ed6ba1fd4234c$var$parseRpcError(errorObj) {
    const result = {};
    const errorClassName = $171ed6ba1fd4234c$var$walkSubtype(errorObj, $171ed6ba1fd4234c$var$rpc_error_schema_json_1.default.schema, result, "");
    // NOTE: This assumes that all errors extend TypedError
    const error = new $171ed6ba1fd4234c$var$ServerError($171ed6ba1fd4234c$var$formatError(errorClassName, result), errorClassName);
    Object.assign(error, result);
    return error;
}
module.exports.parseRpcError = $171ed6ba1fd4234c$var$parseRpcError;
function $171ed6ba1fd4234c$var$parseResultError(result) {
    const server_error = $171ed6ba1fd4234c$var$parseRpcError(result.status.Failure);
    const server_tx_error = new $171ed6ba1fd4234c$var$ServerTransactionError();
    Object.assign(server_tx_error, server_error);
    server_tx_error.type = server_error.type;
    server_tx_error.message = server_error.message;
    server_tx_error.transaction_outcome = result.transaction_outcome;
    return server_tx_error;
}
module.exports.parseResultError = $171ed6ba1fd4234c$var$parseResultError;
function $171ed6ba1fd4234c$var$formatError(errorClassName, errorData) {
    if (typeof $171ed6ba1fd4234c$var$error_messages_json_1.default[errorClassName] === "string") return $171ed6ba1fd4234c$var$mustache_1.default.render($171ed6ba1fd4234c$var$error_messages_json_1.default[errorClassName], {
        ...errorData,
        ...$171ed6ba1fd4234c$var$mustacheHelpers
    });
    return JSON.stringify(errorData);
}
module.exports.formatError = $171ed6ba1fd4234c$var$formatError;
/**
 * Walks through defined schema returning error(s) recursively
 * @param errorObj The error to be parsed
 * @param schema A defined schema in JSON mapping to the RPC errors
 * @param result An object used in recursion or called directly
 * @param typeName The human-readable error type name as defined in the JSON mapping
 */ function $171ed6ba1fd4234c$var$walkSubtype(errorObj, schema, result, typeName) {
    let error;
    let type;
    let errorTypeName;
    for(const errorName in schema){
        if ($171ed6ba1fd4234c$var$isString(errorObj[errorName])) // Return early if error type is in a schema
        return errorObj[errorName];
        if ($171ed6ba1fd4234c$var$isObject(errorObj[errorName])) {
            error = errorObj[errorName];
            type = schema[errorName];
            errorTypeName = errorName;
        } else if ($171ed6ba1fd4234c$var$isObject(errorObj.kind) && $171ed6ba1fd4234c$var$isObject(errorObj.kind[errorName])) {
            error = errorObj.kind[errorName];
            type = schema[errorName];
            errorTypeName = errorName;
        } else continue;
    }
    if (error && type) {
        for (const prop of Object.keys(type.props))result[prop] = error[prop];
        return $171ed6ba1fd4234c$var$walkSubtype(error, schema, result, errorTypeName);
    } else {
        // TODO: is this the right thing to do?
        result.kind = errorObj;
        return typeName;
    }
}
function $171ed6ba1fd4234c$var$getErrorTypeFromErrorMessage(errorMessage) {
    // This function should be removed when JSON RPC starts returning typed errors.
    switch(true){
        case /^account .*? does not exist while viewing$/.test(errorMessage):
            return "AccountDoesNotExist";
        case /^Account .*? doesn't exist$/.test(errorMessage):
            return "AccountDoesNotExist";
        case /^access key .*? does not exist while viewing$/.test(errorMessage):
            return "AccessKeyDoesNotExist";
        case /wasm execution failed with error: FunctionCallError\(CompilationError\(CodeDoesNotExist/.test(errorMessage):
            return "CodeDoesNotExist";
        case /Transaction nonce \d+ must be larger than nonce of the used access key \d+/.test(errorMessage):
            return "InvalidNonce";
        default:
            return "UntypedError";
    }
}
module.exports.getErrorTypeFromErrorMessage = $171ed6ba1fd4234c$var$getErrorTypeFromErrorMessage;
/**
 * Helper function determining if the argument is an object
 * @param n Value to check
 */ function $171ed6ba1fd4234c$var$isObject(n) {
    return Object.prototype.toString.call(n) === "[object Object]";
}
/**
 * Helper function determining if the argument is a string
 * @param n Value to check
 */ function $171ed6ba1fd4234c$var$isString(n) {
    return Object.prototype.toString.call(n) === "[object String]";
}

});
parcelRegister("ifgZ7", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === "[object Array]";
    };
    function isFunction(object) {
        return typeof object === "function";
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? "array" : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === "object" && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== "object" && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;"
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ""; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === "string") tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error("Invalid tags: " + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
            closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp("\\s*" + escapeRegExp("}" + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += " ";
                }
                tokens.push([
                    "text",
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === "\n") {
                    stripSpace();
                    indentation = "";
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || "name";
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === "=") {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === "{") {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = "&";
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error("Unclosed tag at " + scanner.pos);
            if (type == ">") token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === "#" || type === "^") sections.push(token);
            else if (type === "/") {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === "name" || type === "{" || type === "&") nonSpace = true;
            else if (type === "=") // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === "text" && lastToken && lastToken[0] === "text") {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case "#":
                case "^":
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case "/":
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === "";
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return "";
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = "";
                break;
            case 0:
                match = "";
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            ".": this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf(".") > 0) {
                    intermediateValue = context.view;
                    names = name.split(".");
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== "undefined") this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ":" + (tags || mustache.tags).join(":");
        var isCacheEnabled = typeof cache1 !== "undefined";
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = "";
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === "#") value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === "^") value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === ">") value = this.renderPartial(token, context, partials, config);
            else if (symbol === "&") value = this.unescapedValue(token, context);
            else if (symbol === "name") value = this.escapedValue(token, context, config);
            else if (symbol === "text") value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = "";
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === "object" || typeof value === "string" || typeof value === "number") buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== "string") throw new Error("Cannot use higher-order sections without the original template");
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, "");
        var partialByNl = partial.split("\n");
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join("\n");
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === "number" && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === "object") return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === "object" && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: "mustache.js",
        version: "4.2.0",
        tags: [
            "{{",
            "}}"
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== "string") throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + "argument for mustache#render(template, view, partials)");
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});

});

parcelRegister("9xxsQ", function(module, exports) {
module.exports = JSON.parse('{"schema":{"BadUTF16":{"name":"BadUTF16","subtypes":[],"props":{}},"BadUTF8":{"name":"BadUTF8","subtypes":[],"props":{}},"BalanceExceeded":{"name":"BalanceExceeded","subtypes":[],"props":{}},"BreakpointTrap":{"name":"BreakpointTrap","subtypes":[],"props":{}},"CacheError":{"name":"CacheError","subtypes":["ReadError","WriteError","DeserializationError","SerializationError"],"props":{}},"CallIndirectOOB":{"name":"CallIndirectOOB","subtypes":[],"props":{}},"CannotAppendActionToJointPromise":{"name":"CannotAppendActionToJointPromise","subtypes":[],"props":{}},"CannotReturnJointPromise":{"name":"CannotReturnJointPromise","subtypes":[],"props":{}},"CodeDoesNotExist":{"name":"CodeDoesNotExist","subtypes":[],"props":{"account_id":""}},"CompilationError":{"name":"CompilationError","subtypes":["CodeDoesNotExist","PrepareError","WasmerCompileError"],"props":{}},"ContractSizeExceeded":{"name":"ContractSizeExceeded","subtypes":[],"props":{"limit":"","size":""}},"Deprecated":{"name":"Deprecated","subtypes":[],"props":{"method_name":""}},"Deserialization":{"name":"Deserialization","subtypes":[],"props":{}},"DeserializationError":{"name":"DeserializationError","subtypes":[],"props":{}},"EmptyMethodName":{"name":"EmptyMethodName","subtypes":[],"props":{}},"FunctionCallError":{"name":"FunctionCallError","subtypes":["CompilationError","LinkError","MethodResolveError","WasmTrap","WasmUnknownError","HostError","EvmError"],"props":{}},"GasExceeded":{"name":"GasExceeded","subtypes":[],"props":{}},"GasInstrumentation":{"name":"GasInstrumentation","subtypes":[],"props":{}},"GasLimitExceeded":{"name":"GasLimitExceeded","subtypes":[],"props":{}},"GenericTrap":{"name":"GenericTrap","subtypes":[],"props":{}},"GuestPanic":{"name":"GuestPanic","subtypes":[],"props":{"panic_msg":""}},"HostError":{"name":"HostError","subtypes":["BadUTF16","BadUTF8","GasExceeded","GasLimitExceeded","BalanceExceeded","EmptyMethodName","GuestPanic","IntegerOverflow","InvalidPromiseIndex","CannotAppendActionToJointPromise","CannotReturnJointPromise","InvalidPromiseResultIndex","InvalidRegisterId","IteratorWasInvalidated","MemoryAccessViolation","InvalidReceiptIndex","InvalidIteratorIndex","InvalidAccountId","InvalidMethodName","InvalidPublicKey","ProhibitedInView","NumberOfLogsExceeded","KeyLengthExceeded","ValueLengthExceeded","TotalLogLengthExceeded","NumberPromisesExceeded","NumberInputDataDependenciesExceeded","ReturnedValueLengthExceeded","ContractSizeExceeded","Deprecated"],"props":{}},"IllegalArithmetic":{"name":"IllegalArithmetic","subtypes":[],"props":{}},"IncorrectCallIndirectSignature":{"name":"IncorrectCallIndirectSignature","subtypes":[],"props":{}},"Instantiate":{"name":"Instantiate","subtypes":[],"props":{}},"IntegerOverflow":{"name":"IntegerOverflow","subtypes":[],"props":{}},"InternalMemoryDeclared":{"name":"InternalMemoryDeclared","subtypes":[],"props":{}},"InvalidAccountId":{"name":"InvalidAccountId","subtypes":[],"props":{"account_id":""}},"InvalidIteratorIndex":{"name":"InvalidIteratorIndex","subtypes":[],"props":{"iterator_index":""}},"InvalidMethodName":{"name":"InvalidMethodName","subtypes":[],"props":{}},"InvalidPromiseIndex":{"name":"InvalidPromiseIndex","subtypes":[],"props":{"promise_idx":""}},"InvalidPromiseResultIndex":{"name":"InvalidPromiseResultIndex","subtypes":[],"props":{"result_idx":""}},"InvalidPublicKey":{"name":"InvalidPublicKey","subtypes":[],"props":{}},"InvalidReceiptIndex":{"name":"InvalidReceiptIndex","subtypes":[],"props":{"receipt_index":""}},"InvalidRegisterId":{"name":"InvalidRegisterId","subtypes":[],"props":{"register_id":""}},"IteratorWasInvalidated":{"name":"IteratorWasInvalidated","subtypes":[],"props":{"iterator_index":""}},"KeyLengthExceeded":{"name":"KeyLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"LinkError":{"name":"LinkError","subtypes":[],"props":{"msg":""}},"Memory":{"name":"Memory","subtypes":[],"props":{}},"MemoryAccessViolation":{"name":"MemoryAccessViolation","subtypes":[],"props":{}},"MemoryOutOfBounds":{"name":"MemoryOutOfBounds","subtypes":[],"props":{}},"MethodEmptyName":{"name":"MethodEmptyName","subtypes":[],"props":{}},"MethodInvalidSignature":{"name":"MethodInvalidSignature","subtypes":[],"props":{}},"MethodNotFound":{"name":"MethodNotFound","subtypes":[],"props":{}},"MethodResolveError":{"name":"MethodResolveError","subtypes":["MethodEmptyName","MethodUTF8Error","MethodNotFound","MethodInvalidSignature"],"props":{}},"MethodUTF8Error":{"name":"MethodUTF8Error","subtypes":[],"props":{}},"MisalignedAtomicAccess":{"name":"MisalignedAtomicAccess","subtypes":[],"props":{}},"NumberInputDataDependenciesExceeded":{"name":"NumberInputDataDependenciesExceeded","subtypes":[],"props":{"limit":"","number_of_input_data_dependencies":""}},"NumberOfLogsExceeded":{"name":"NumberOfLogsExceeded","subtypes":[],"props":{"limit":""}},"NumberPromisesExceeded":{"name":"NumberPromisesExceeded","subtypes":[],"props":{"limit":"","number_of_promises":""}},"PrepareError":{"name":"PrepareError","subtypes":["Serialization","Deserialization","InternalMemoryDeclared","GasInstrumentation","StackHeightInstrumentation","Instantiate","Memory"],"props":{}},"ProhibitedInView":{"name":"ProhibitedInView","subtypes":[],"props":{"method_name":""}},"ReadError":{"name":"ReadError","subtypes":[],"props":{}},"ReturnedValueLengthExceeded":{"name":"ReturnedValueLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"Serialization":{"name":"Serialization","subtypes":[],"props":{}},"SerializationError":{"name":"SerializationError","subtypes":[],"props":{"hash":""}},"StackHeightInstrumentation":{"name":"StackHeightInstrumentation","subtypes":[],"props":{}},"StackOverflow":{"name":"StackOverflow","subtypes":[],"props":{}},"TotalLogLengthExceeded":{"name":"TotalLogLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"Unreachable":{"name":"Unreachable","subtypes":[],"props":{}},"ValueLengthExceeded":{"name":"ValueLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"WasmTrap":{"name":"WasmTrap","subtypes":["Unreachable","IncorrectCallIndirectSignature","MemoryOutOfBounds","CallIndirectOOB","IllegalArithmetic","MisalignedAtomicAccess","BreakpointTrap","StackOverflow","GenericTrap"],"props":{}},"WasmUnknownError":{"name":"WasmUnknownError","subtypes":[],"props":{}},"WasmerCompileError":{"name":"WasmerCompileError","subtypes":[],"props":{"msg":""}},"WriteError":{"name":"WriteError","subtypes":[],"props":{}},"AccessKeyNotFound":{"name":"AccessKeyNotFound","subtypes":[],"props":{"account_id":"","public_key":""}},"AccountAlreadyExists":{"name":"AccountAlreadyExists","subtypes":[],"props":{"account_id":""}},"AccountDoesNotExist":{"name":"AccountDoesNotExist","subtypes":[],"props":{"account_id":""}},"ActionError":{"name":"ActionError","subtypes":["AccountAlreadyExists","AccountDoesNotExist","CreateAccountOnlyByRegistrar","CreateAccountNotAllowed","ActorNoPermission","DeleteKeyDoesNotExist","AddKeyAlreadyExists","DeleteAccountStaking","LackBalanceForState","TriesToUnstake","TriesToStake","InsufficientStake","FunctionCallError","NewReceiptValidationError","OnlyImplicitAccountCreationAllowed"],"props":{"index":""}},"ActionsValidationError":{"name":"ActionsValidationError","subtypes":["DeleteActionMustBeFinal","TotalPrepaidGasExceeded","TotalNumberOfActionsExceeded","AddKeyMethodNamesNumberOfBytesExceeded","AddKeyMethodNameLengthExceeded","IntegerOverflow","InvalidAccountId","ContractSizeExceeded","FunctionCallMethodNameLengthExceeded","FunctionCallArgumentsLengthExceeded","UnsuitableStakingKey","FunctionCallZeroAttachedGas"],"props":{}},"ActorNoPermission":{"name":"ActorNoPermission","subtypes":[],"props":{"account_id":"","actor_id":""}},"AddKeyAlreadyExists":{"name":"AddKeyAlreadyExists","subtypes":[],"props":{"account_id":"","public_key":""}},"AddKeyMethodNameLengthExceeded":{"name":"AddKeyMethodNameLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"AddKeyMethodNamesNumberOfBytesExceeded":{"name":"AddKeyMethodNamesNumberOfBytesExceeded","subtypes":[],"props":{"limit":"","total_number_of_bytes":""}},"BalanceMismatchError":{"name":"BalanceMismatchError","subtypes":[],"props":{"final_accounts_balance":"","final_postponed_receipts_balance":"","incoming_receipts_balance":"","incoming_validator_rewards":"","initial_accounts_balance":"","initial_postponed_receipts_balance":"","new_delayed_receipts_balance":"","other_burnt_amount":"","outgoing_receipts_balance":"","processed_delayed_receipts_balance":"","slashed_burnt_amount":"","tx_burnt_amount":""}},"CostOverflow":{"name":"CostOverflow","subtypes":[],"props":{}},"CreateAccountNotAllowed":{"name":"CreateAccountNotAllowed","subtypes":[],"props":{"account_id":"","predecessor_id":""}},"CreateAccountOnlyByRegistrar":{"name":"CreateAccountOnlyByRegistrar","subtypes":[],"props":{"account_id":"","predecessor_id":"","registrar_account_id":""}},"DeleteAccountStaking":{"name":"DeleteAccountStaking","subtypes":[],"props":{"account_id":""}},"DeleteActionMustBeFinal":{"name":"DeleteActionMustBeFinal","subtypes":[],"props":{}},"DeleteKeyDoesNotExist":{"name":"DeleteKeyDoesNotExist","subtypes":[],"props":{"account_id":"","public_key":""}},"DepositWithFunctionCall":{"name":"DepositWithFunctionCall","subtypes":[],"props":{}},"Expired":{"name":"Expired","subtypes":[],"props":{}},"FunctionCallArgumentsLengthExceeded":{"name":"FunctionCallArgumentsLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"FunctionCallMethodNameLengthExceeded":{"name":"FunctionCallMethodNameLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"FunctionCallZeroAttachedGas":{"name":"FunctionCallZeroAttachedGas","subtypes":[],"props":{}},"InsufficientStake":{"name":"InsufficientStake","subtypes":[],"props":{"account_id":"","minimum_stake":"","stake":""}},"InvalidAccessKeyError":{"name":"InvalidAccessKeyError","subtypes":["AccessKeyNotFound","ReceiverMismatch","MethodNameMismatch","RequiresFullAccess","NotEnoughAllowance","DepositWithFunctionCall"],"props":{}},"InvalidChain":{"name":"InvalidChain","subtypes":[],"props":{}},"InvalidDataReceiverId":{"name":"InvalidDataReceiverId","subtypes":[],"props":{"account_id":""}},"InvalidNonce":{"name":"InvalidNonce","subtypes":[],"props":{"ak_nonce":"","tx_nonce":""}},"InvalidPredecessorId":{"name":"InvalidPredecessorId","subtypes":[],"props":{"account_id":""}},"InvalidReceiverId":{"name":"InvalidReceiverId","subtypes":[],"props":{"account_id":""}},"InvalidSignature":{"name":"InvalidSignature","subtypes":[],"props":{}},"InvalidSignerId":{"name":"InvalidSignerId","subtypes":[],"props":{"account_id":""}},"InvalidTxError":{"name":"InvalidTxError","subtypes":["InvalidAccessKeyError","InvalidSignerId","SignerDoesNotExist","InvalidNonce","InvalidReceiverId","InvalidSignature","NotEnoughBalance","LackBalanceForState","CostOverflow","InvalidChain","Expired","ActionsValidation"],"props":{}},"LackBalanceForState":{"name":"LackBalanceForState","subtypes":[],"props":{"account_id":"","amount":""}},"MethodNameMismatch":{"name":"MethodNameMismatch","subtypes":[],"props":{"method_name":""}},"NotEnoughAllowance":{"name":"NotEnoughAllowance","subtypes":[],"props":{"account_id":"","allowance":"","cost":"","public_key":""}},"NotEnoughBalance":{"name":"NotEnoughBalance","subtypes":[],"props":{"balance":"","cost":"","signer_id":""}},"OnlyImplicitAccountCreationAllowed":{"name":"OnlyImplicitAccountCreationAllowed","subtypes":[],"props":{"account_id":""}},"ReceiptValidationError":{"name":"ReceiptValidationError","subtypes":["InvalidPredecessorId","InvalidReceiverId","InvalidSignerId","InvalidDataReceiverId","ReturnedValueLengthExceeded","NumberInputDataDependenciesExceeded","ActionsValidation"],"props":{}},"ReceiverMismatch":{"name":"ReceiverMismatch","subtypes":[],"props":{"ak_receiver":"","tx_receiver":""}},"RequiresFullAccess":{"name":"RequiresFullAccess","subtypes":[],"props":{}},"SignerDoesNotExist":{"name":"SignerDoesNotExist","subtypes":[],"props":{"signer_id":""}},"TotalNumberOfActionsExceeded":{"name":"TotalNumberOfActionsExceeded","subtypes":[],"props":{"limit":"","total_number_of_actions":""}},"TotalPrepaidGasExceeded":{"name":"TotalPrepaidGasExceeded","subtypes":[],"props":{"limit":"","total_prepaid_gas":""}},"TriesToStake":{"name":"TriesToStake","subtypes":[],"props":{"account_id":"","balance":"","locked":"","stake":""}},"TriesToUnstake":{"name":"TriesToUnstake","subtypes":[],"props":{"account_id":""}},"TxExecutionError":{"name":"TxExecutionError","subtypes":["ActionError","InvalidTxError"],"props":{}},"UnsuitableStakingKey":{"name":"UnsuitableStakingKey","subtypes":[],"props":{"public_key":""}},"Closed":{"name":"Closed","subtypes":[],"props":{}},"InternalError":{"name":"InternalError","subtypes":[],"props":{}},"ServerError":{"name":"ServerError","subtypes":["TxExecutionError","Timeout","Closed","InternalError"],"props":{}},"Timeout":{"name":"Timeout","subtypes":[],"props":{}}}}');

});

parcelRegister("jMLGO", function(module, exports) {
module.exports = JSON.parse('{"GasLimitExceeded":"Exceeded the maximum amount of gas allowed to burn per contract","MethodEmptyName":"Method name is empty","WasmerCompileError":"Wasmer compilation error: {{msg}}","GuestPanic":"Smart contract panicked: {{panic_msg}}","Memory":"Error creating Wasm memory","GasExceeded":"Exceeded the prepaid gas","MethodUTF8Error":"Method name is not valid UTF8 string","BadUTF16":"String encoding is bad UTF-16 sequence","WasmTrap":"WebAssembly trap: {{msg}}","GasInstrumentation":"Gas instrumentation failed or contract has denied instructions.","InvalidPromiseIndex":"{{promise_idx}} does not correspond to existing promises","InvalidPromiseResultIndex":"Accessed invalid promise result index: {{result_idx}}","Deserialization":"Error happened while deserializing the module","MethodNotFound":"Contract method is not found","InvalidRegisterId":"Accessed invalid register id: {{register_id}}","InvalidReceiptIndex":"VM Logic returned an invalid receipt index: {{receipt_index}}","EmptyMethodName":"Method name is empty in contract call","CannotReturnJointPromise":"Returning joint promise is currently prohibited","StackHeightInstrumentation":"Stack instrumentation failed","CodeDoesNotExist":"Cannot find contract code for account {{account_id}}","MethodInvalidSignature":"Invalid method signature","IntegerOverflow":"Integer overflow happened during contract execution","MemoryAccessViolation":"MemoryAccessViolation","InvalidIteratorIndex":"Iterator index {{iterator_index}} does not exist","IteratorWasInvalidated":"Iterator {{iterator_index}} was invalidated after its creation by performing a mutable operation on trie","InvalidAccountId":"VM Logic returned an invalid account id","Serialization":"Error happened while serializing the module","CannotAppendActionToJointPromise":"Actions can only be appended to non-joint promise.","InternalMemoryDeclared":"Internal memory declaration has been found in the module","Instantiate":"Error happened during instantiation","ProhibitedInView":"{{method_name}} is not allowed in view calls","InvalidMethodName":"VM Logic returned an invalid method name","BadUTF8":"String encoding is bad UTF-8 sequence","BalanceExceeded":"Exceeded the account balance","LinkError":"Wasm contract link error: {{msg}}","InvalidPublicKey":"VM Logic provided an invalid public key","ActorNoPermission":"Actor {{actor_id}} doesn\'t have permission to account {{account_id}} to complete the action","LackBalanceForState":"The account {{account_id}} wouldn\'t have enough balance to cover storage, required to have {{amount}} yoctoNEAR more","ReceiverMismatch":"Wrong AccessKey used for transaction: transaction is sent to receiver_id={{tx_receiver}}, but is signed with function call access key that restricted to only use with receiver_id={{ak_receiver}}. Either change receiver_id in your transaction or switch to use a FullAccessKey.","CostOverflow":"Transaction gas or balance cost is too high","InvalidSignature":"Transaction is not signed with the given public key","AccessKeyNotFound":"Signer \\"{{account_id}}\\" doesn\'t have access key with the given public_key {{public_key}}","NotEnoughBalance":"Sender {{signer_id}} does not have enough balance {{#formatNear}}{{balance}}{{/formatNear}} for operation costing {{#formatNear}}{{cost}}{{/formatNear}}","NotEnoughAllowance":"Access Key {account_id}:{public_key} does not have enough balance {{#formatNear}}{{allowance}}{{/formatNear}} for transaction costing {{#formatNear}}{{cost}}{{/formatNear}}","Expired":"Transaction has expired","DeleteAccountStaking":"Account {{account_id}} is staking and can not be deleted","SignerDoesNotExist":"Signer {{signer_id}} does not exist","TriesToStake":"Account {{account_id}} tried to stake {{#formatNear}}{{stake}}{{/formatNear}}, but has staked {{#formatNear}}{{locked}}{{/formatNear}} and only has {{#formatNear}}{{balance}}{{/formatNear}}","AddKeyAlreadyExists":"The public key {{public_key}} is already used for an existing access key","InvalidSigner":"Invalid signer account ID {{signer_id}} according to requirements","CreateAccountNotAllowed":"The new account_id {{account_id}} can\'t be created by {{predecessor_id}}","RequiresFullAccess":"The transaction contains more then one action, but it was signed with an access key which allows transaction to apply only one specific action. To apply more then one actions TX must be signed with a full access key","TriesToUnstake":"Account {{account_id}} is not yet staked, but tried to unstake","InvalidNonce":"Transaction nonce {{tx_nonce}} must be larger than nonce of the used access key {{ak_nonce}}","AccountAlreadyExists":"Can\'t create a new account {{account_id}}, because it already exists","InvalidChain":"Transaction parent block hash doesn\'t belong to the current chain","AccountDoesNotExist":"Can\'t complete the action because account {{account_id}} doesn\'t exist","MethodNameMismatch":"Transaction method name {{method_name}} isn\'t allowed by the access key","DeleteAccountHasRent":"Account {{account_id}} can\'t be deleted. It has {{#formatNear}}{{balance}}{{/formatNear}}, which is enough to cover the rent","DeleteAccountHasEnoughBalance":"Account {{account_id}} can\'t be deleted. It has {{#formatNear}}{{balance}}{{/formatNear}}, which is enough to cover it\'s storage","InvalidReceiver":"Invalid receiver account ID {{receiver_id}} according to requirements","DeleteKeyDoesNotExist":"Account {{account_id}} tries to remove an access key that doesn\'t exist","Timeout":"Timeout exceeded","Closed":"Connection closed"}');

});




parcelRegister("gphuu", function(module, exports) {
"use strict";
var $bf1c8c6c0b854dc2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bf1c8c6c0b854dc2$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bf1c8c6c0b854dc2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $bf1c8c6c0b854dc2$var$__createBinding(result, mod, k);
    }
    $bf1c8c6c0b854dc2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logWarning = module.exports.rpc_errors = module.exports.KeyPairEd25519 = module.exports.KeyPair = module.exports.PublicKey = module.exports.format = module.exports.enums = module.exports.web = module.exports.serialize = module.exports.key_pair = void 0;

const $bf1c8c6c0b854dc2$var$key_pair = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("lsY0f")));
module.exports.key_pair = $bf1c8c6c0b854dc2$var$key_pair;

const $bf1c8c6c0b854dc2$var$serialize = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("11V5S")));
module.exports.serialize = $bf1c8c6c0b854dc2$var$serialize;

const $bf1c8c6c0b854dc2$var$web = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("9lI55")));
module.exports.web = $bf1c8c6c0b854dc2$var$web;

const $bf1c8c6c0b854dc2$var$enums = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("kVMwJ")));
module.exports.enums = $bf1c8c6c0b854dc2$var$enums;

const $bf1c8c6c0b854dc2$var$format = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("33Nhm")));
module.exports.format = $bf1c8c6c0b854dc2$var$format;

const $bf1c8c6c0b854dc2$var$rpc_errors = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("1Z4jS")));
module.exports.rpc_errors = $bf1c8c6c0b854dc2$var$rpc_errors;

Object.defineProperty(module.exports, "PublicKey", {
    enumerable: true,
    get: function() {
        return (parcelRequire("lsY0f")).PublicKey;
    }
});
Object.defineProperty(module.exports, "KeyPair", {
    enumerable: true,
    get: function() {
        return (parcelRequire("lsY0f")).KeyPair;
    }
});
Object.defineProperty(module.exports, "KeyPairEd25519", {
    enumerable: true,
    get: function() {
        return (parcelRequire("lsY0f")).KeyPairEd25519;
    }
});

var $hR4Jw = parcelRequire("hR4Jw");
Object.defineProperty(module.exports, "logWarning", {
    enumerable: true,
    get: function() {
        return $hR4Jw.logWarning;
    }
});

});
parcelRegister("33Nhm", function(module, exports) {
"use strict";
var $23a7e0acee71dee9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseNearAmount = module.exports.formatNearAmount = module.exports.NEAR_NOMINATION = module.exports.NEAR_NOMINATION_EXP = void 0;

const $23a7e0acee71dee9$var$bn_js_1 = $23a7e0acee71dee9$var$__importDefault((parcelRequire("4l3c8")));
/**
 * Exponent for calculating how many indivisible units are there in one NEAR. See {@link NEAR_NOMINATION}.
 */ module.exports.NEAR_NOMINATION_EXP = 24;
/**
 * Number of indivisible units in one NEAR. Derived from {@link NEAR_NOMINATION_EXP}.
 */ module.exports.NEAR_NOMINATION = new $23a7e0acee71dee9$var$bn_js_1.default("10", 10).pow(new $23a7e0acee71dee9$var$bn_js_1.default(module.exports.NEAR_NOMINATION_EXP, 10));
// Pre-calculate offests used for rounding to different number of digits
const $23a7e0acee71dee9$var$ROUNDING_OFFSETS = [];
const $23a7e0acee71dee9$var$BN10 = new $23a7e0acee71dee9$var$bn_js_1.default(10);
for(let i = 0, offset = new $23a7e0acee71dee9$var$bn_js_1.default(5); i < module.exports.NEAR_NOMINATION_EXP; i++, offset = offset.mul($23a7e0acee71dee9$var$BN10))$23a7e0acee71dee9$var$ROUNDING_OFFSETS[i] = offset;
/**
 * Convert account balance value from internal indivisible units to NEAR. 1 NEAR is defined by {@link NEAR_NOMINATION}.
 * Effectively this divides given amount by {@link NEAR_NOMINATION}.
 *
 * @param balance decimal string representing balance in smallest non-divisible NEAR units (as specified by {@link NEAR_NOMINATION})
 * @param fracDigits number of fractional digits to preserve in formatted string. Balance is rounded to match given number of digits.
 * @returns Value in Ⓝ
 */ function $23a7e0acee71dee9$var$formatNearAmount(balance, fracDigits = module.exports.NEAR_NOMINATION_EXP) {
    const balanceBN = new $23a7e0acee71dee9$var$bn_js_1.default(balance, 10);
    if (fracDigits !== module.exports.NEAR_NOMINATION_EXP) {
        // Adjust balance for rounding at given number of digits
        const roundingExp = module.exports.NEAR_NOMINATION_EXP - fracDigits - 1;
        if (roundingExp > 0) balanceBN.iadd($23a7e0acee71dee9$var$ROUNDING_OFFSETS[roundingExp]);
    }
    balance = balanceBN.toString();
    const wholeStr = balance.substring(0, balance.length - module.exports.NEAR_NOMINATION_EXP) || "0";
    const fractionStr = balance.substring(balance.length - module.exports.NEAR_NOMINATION_EXP).padStart(module.exports.NEAR_NOMINATION_EXP, "0").substring(0, fracDigits);
    return $23a7e0acee71dee9$var$trimTrailingZeroes(`${$23a7e0acee71dee9$var$formatWithCommas(wholeStr)}.${fractionStr}`);
}
module.exports.formatNearAmount = $23a7e0acee71dee9$var$formatNearAmount;
/**
 * Convert human readable NEAR amount to internal indivisible units.
 * Effectively this multiplies given amount by {@link NEAR_NOMINATION}.
 *
 * @param amt decimal string (potentially fractional) denominated in NEAR.
 * @returns The parsed yoctoⓃ amount or null if no amount was passed in
 */ function $23a7e0acee71dee9$var$parseNearAmount(amt) {
    if (!amt) return null;
    amt = $23a7e0acee71dee9$var$cleanupAmount(amt);
    const split = amt.split(".");
    const wholePart = split[0];
    const fracPart = split[1] || "";
    if (split.length > 2 || fracPart.length > module.exports.NEAR_NOMINATION_EXP) throw new Error(`Cannot parse '${amt}' as NEAR amount`);
    return $23a7e0acee71dee9$var$trimLeadingZeroes(wholePart + fracPart.padEnd(module.exports.NEAR_NOMINATION_EXP, "0"));
}
module.exports.parseNearAmount = $23a7e0acee71dee9$var$parseNearAmount;
/**
 * Removes commas from the input
 * @param amount A value or amount that may contain commas
 * @returns string The cleaned value
 */ function $23a7e0acee71dee9$var$cleanupAmount(amount) {
    return amount.replace(/,/g, "").trim();
}
/**
 * Removes .000… from an input
 * @param value A value that may contain trailing zeroes in the decimals place
 * @returns string The value without the trailing zeros
 */ function $23a7e0acee71dee9$var$trimTrailingZeroes(value) {
    return value.replace(/\.?0*$/, "");
}
/**
 * Removes leading zeroes from an input
 * @param value A value that may contain leading zeroes
 * @returns string The value without the leading zeroes
 */ function $23a7e0acee71dee9$var$trimLeadingZeroes(value) {
    value = value.replace(/^0+/, "");
    if (value === "") return "0";
    return value;
}
/**
 * Returns a human-readable value with commas
 * @param value A value that may not contain commas
 * @returns string A value with commas
 */ function $23a7e0acee71dee9$var$formatWithCommas(value) {
    const pattern = /(-?\d+)(\d{3})/;
    while(pattern.test(value))value = value.replace(pattern, "$1,$2");
    return value;
}

});
parcelRegister("4l3c8", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});



parcelRegister("9v9vF", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $6eae62be96d8757d$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $6eae62be96d8757d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.signTransaction = module.exports.createTransaction = module.exports.SCHEMA = module.exports.Action = module.exports.SignedTransaction = module.exports.Transaction = module.exports.Signature = module.exports.deleteAccount = module.exports.deleteKey = module.exports.addKey = module.exports.stake = module.exports.transfer = module.exports.functionCall = module.exports.stringifyJsonOrBytes = module.exports.deployContract = module.exports.createAccount = module.exports.DeleteAccount = module.exports.DeleteKey = module.exports.AddKey = module.exports.Stake = module.exports.Transfer = module.exports.FunctionCall = module.exports.DeployContract = module.exports.CreateAccount = module.exports.IAction = module.exports.functionCallAccessKey = module.exports.fullAccessKey = module.exports.AccessKey = module.exports.AccessKeyPermission = module.exports.FullAccessPermission = module.exports.FunctionCallPermission = void 0;

const $6eae62be96d8757d$var$js_sha256_1 = $6eae62be96d8757d$var$__importDefault((parcelRequire("fBCU1")));

var $kVMwJ = parcelRequire("kVMwJ");

var $75BJw = parcelRequire("75BJw");

var $lsY0f = parcelRequire("lsY0f");
class $6eae62be96d8757d$var$FunctionCallPermission extends $kVMwJ.Assignable {
}
module.exports.FunctionCallPermission = $6eae62be96d8757d$var$FunctionCallPermission;
class $6eae62be96d8757d$var$FullAccessPermission extends $kVMwJ.Assignable {
}
module.exports.FullAccessPermission = $6eae62be96d8757d$var$FullAccessPermission;
class $6eae62be96d8757d$var$AccessKeyPermission extends $kVMwJ.Enum {
}
module.exports.AccessKeyPermission = $6eae62be96d8757d$var$AccessKeyPermission;
class $6eae62be96d8757d$var$AccessKey extends $kVMwJ.Assignable {
}
module.exports.AccessKey = $6eae62be96d8757d$var$AccessKey;
function $6eae62be96d8757d$var$fullAccessKey() {
    return new $6eae62be96d8757d$var$AccessKey({
        nonce: 0,
        permission: new $6eae62be96d8757d$var$AccessKeyPermission({
            fullAccess: new $6eae62be96d8757d$var$FullAccessPermission({})
        })
    });
}
module.exports.fullAccessKey = $6eae62be96d8757d$var$fullAccessKey;
function $6eae62be96d8757d$var$functionCallAccessKey(receiverId, methodNames, allowance) {
    return new $6eae62be96d8757d$var$AccessKey({
        nonce: 0,
        permission: new $6eae62be96d8757d$var$AccessKeyPermission({
            functionCall: new $6eae62be96d8757d$var$FunctionCallPermission({
                receiverId: receiverId,
                allowance: allowance,
                methodNames: methodNames
            })
        })
    });
}
module.exports.functionCallAccessKey = $6eae62be96d8757d$var$functionCallAccessKey;
class $6eae62be96d8757d$var$IAction extends $kVMwJ.Assignable {
}
module.exports.IAction = $6eae62be96d8757d$var$IAction;
class $6eae62be96d8757d$var$CreateAccount extends $6eae62be96d8757d$var$IAction {
}
module.exports.CreateAccount = $6eae62be96d8757d$var$CreateAccount;
class $6eae62be96d8757d$var$DeployContract extends $6eae62be96d8757d$var$IAction {
}
module.exports.DeployContract = $6eae62be96d8757d$var$DeployContract;
class $6eae62be96d8757d$var$FunctionCall extends $6eae62be96d8757d$var$IAction {
}
module.exports.FunctionCall = $6eae62be96d8757d$var$FunctionCall;
class $6eae62be96d8757d$var$Transfer extends $6eae62be96d8757d$var$IAction {
}
module.exports.Transfer = $6eae62be96d8757d$var$Transfer;
class $6eae62be96d8757d$var$Stake extends $6eae62be96d8757d$var$IAction {
}
module.exports.Stake = $6eae62be96d8757d$var$Stake;
class $6eae62be96d8757d$var$AddKey extends $6eae62be96d8757d$var$IAction {
}
module.exports.AddKey = $6eae62be96d8757d$var$AddKey;
class $6eae62be96d8757d$var$DeleteKey extends $6eae62be96d8757d$var$IAction {
}
module.exports.DeleteKey = $6eae62be96d8757d$var$DeleteKey;
class $6eae62be96d8757d$var$DeleteAccount extends $6eae62be96d8757d$var$IAction {
}
module.exports.DeleteAccount = $6eae62be96d8757d$var$DeleteAccount;
function $6eae62be96d8757d$var$createAccount() {
    return new $6eae62be96d8757d$var$Action({
        createAccount: new $6eae62be96d8757d$var$CreateAccount({})
    });
}
module.exports.createAccount = $6eae62be96d8757d$var$createAccount;
function $6eae62be96d8757d$var$deployContract(code) {
    return new $6eae62be96d8757d$var$Action({
        deployContract: new $6eae62be96d8757d$var$DeployContract({
            code: code
        })
    });
}
module.exports.deployContract = $6eae62be96d8757d$var$deployContract;
function $6eae62be96d8757d$var$stringifyJsonOrBytes(args) {
    const isUint8Array = args.byteLength !== undefined && args.byteLength === args.length;
    const serializedArgs = isUint8Array ? args : $6eae62be96d8757d$require$Buffer.from(JSON.stringify(args));
    return serializedArgs;
}
module.exports.stringifyJsonOrBytes = $6eae62be96d8757d$var$stringifyJsonOrBytes;
/**
 * Constructs {@link Action} instance representing contract method call.
 *
 * @param methodName the name of the method to call
 * @param args arguments to pass to method. Can be either plain JS object which gets serialized as JSON automatically
 *  or `Uint8Array` instance which represents bytes passed as is.
 * @param gas max amount of gas that method call can use
 * @param deposit amount of NEAR (in yoctoNEAR) to send together with the call
 * @param stringify Convert input arguments into bytes array.
 */ function $6eae62be96d8757d$var$functionCall(methodName, args, gas, deposit, stringify = $6eae62be96d8757d$var$stringifyJsonOrBytes) {
    return new $6eae62be96d8757d$var$Action({
        functionCall: new $6eae62be96d8757d$var$FunctionCall({
            methodName: methodName,
            args: stringify(args),
            gas: gas,
            deposit: deposit
        })
    });
}
module.exports.functionCall = $6eae62be96d8757d$var$functionCall;
function $6eae62be96d8757d$var$transfer(deposit) {
    return new $6eae62be96d8757d$var$Action({
        transfer: new $6eae62be96d8757d$var$Transfer({
            deposit: deposit
        })
    });
}
module.exports.transfer = $6eae62be96d8757d$var$transfer;
function $6eae62be96d8757d$var$stake(stake, publicKey) {
    return new $6eae62be96d8757d$var$Action({
        stake: new $6eae62be96d8757d$var$Stake({
            stake: stake,
            publicKey: publicKey
        })
    });
}
module.exports.stake = $6eae62be96d8757d$var$stake;
function $6eae62be96d8757d$var$addKey(publicKey, accessKey) {
    return new $6eae62be96d8757d$var$Action({
        addKey: new $6eae62be96d8757d$var$AddKey({
            publicKey: publicKey,
            accessKey: accessKey
        })
    });
}
module.exports.addKey = $6eae62be96d8757d$var$addKey;
function $6eae62be96d8757d$var$deleteKey(publicKey) {
    return new $6eae62be96d8757d$var$Action({
        deleteKey: new $6eae62be96d8757d$var$DeleteKey({
            publicKey: publicKey
        })
    });
}
module.exports.deleteKey = $6eae62be96d8757d$var$deleteKey;
function $6eae62be96d8757d$var$deleteAccount(beneficiaryId) {
    return new $6eae62be96d8757d$var$Action({
        deleteAccount: new $6eae62be96d8757d$var$DeleteAccount({
            beneficiaryId: beneficiaryId
        })
    });
}
module.exports.deleteAccount = $6eae62be96d8757d$var$deleteAccount;
class $6eae62be96d8757d$var$Signature extends $kVMwJ.Assignable {
}
module.exports.Signature = $6eae62be96d8757d$var$Signature;
class $6eae62be96d8757d$var$Transaction extends $kVMwJ.Assignable {
    encode() {
        return $75BJw.serialize(module.exports.SCHEMA, this);
    }
    static decode(bytes) {
        return $75BJw.deserialize(module.exports.SCHEMA, $6eae62be96d8757d$var$Transaction, bytes);
    }
}
module.exports.Transaction = $6eae62be96d8757d$var$Transaction;
class $6eae62be96d8757d$var$SignedTransaction extends $kVMwJ.Assignable {
    encode() {
        return $75BJw.serialize(module.exports.SCHEMA, this);
    }
    static decode(bytes) {
        return $75BJw.deserialize(module.exports.SCHEMA, $6eae62be96d8757d$var$SignedTransaction, bytes);
    }
}
module.exports.SignedTransaction = $6eae62be96d8757d$var$SignedTransaction;
/**
 * Contains a list of the valid transaction Actions available with this API
 * @see {@link https://nomicon.io/RuntimeSpec/Actions.html | Actions Spec}
 */ class $6eae62be96d8757d$var$Action extends $kVMwJ.Enum {
}
module.exports.Action = $6eae62be96d8757d$var$Action;
module.exports.SCHEMA = new Map([
    [
        $6eae62be96d8757d$var$Signature,
        {
            kind: "struct",
            fields: [
                [
                    "keyType",
                    "u8"
                ],
                [
                    "data",
                    [
                        64
                    ]
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$SignedTransaction,
        {
            kind: "struct",
            fields: [
                [
                    "transaction",
                    $6eae62be96d8757d$var$Transaction
                ],
                [
                    "signature",
                    $6eae62be96d8757d$var$Signature
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$Transaction,
        {
            kind: "struct",
            fields: [
                [
                    "signerId",
                    "string"
                ],
                [
                    "publicKey",
                    $lsY0f.PublicKey
                ],
                [
                    "nonce",
                    "u64"
                ],
                [
                    "receiverId",
                    "string"
                ],
                [
                    "blockHash",
                    [
                        32
                    ]
                ],
                [
                    "actions",
                    [
                        $6eae62be96d8757d$var$Action
                    ]
                ]
            ]
        }
    ],
    [
        $lsY0f.PublicKey,
        {
            kind: "struct",
            fields: [
                [
                    "keyType",
                    "u8"
                ],
                [
                    "data",
                    [
                        32
                    ]
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$AccessKey,
        {
            kind: "struct",
            fields: [
                [
                    "nonce",
                    "u64"
                ],
                [
                    "permission",
                    $6eae62be96d8757d$var$AccessKeyPermission
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$AccessKeyPermission,
        {
            kind: "enum",
            field: "enum",
            values: [
                [
                    "functionCall",
                    $6eae62be96d8757d$var$FunctionCallPermission
                ],
                [
                    "fullAccess",
                    $6eae62be96d8757d$var$FullAccessPermission
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$FunctionCallPermission,
        {
            kind: "struct",
            fields: [
                [
                    "allowance",
                    {
                        kind: "option",
                        type: "u128"
                    }
                ],
                [
                    "receiverId",
                    "string"
                ],
                [
                    "methodNames",
                    [
                        "string"
                    ]
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$FullAccessPermission,
        {
            kind: "struct",
            fields: []
        }
    ],
    [
        $6eae62be96d8757d$var$Action,
        {
            kind: "enum",
            field: "enum",
            values: [
                [
                    "createAccount",
                    $6eae62be96d8757d$var$CreateAccount
                ],
                [
                    "deployContract",
                    $6eae62be96d8757d$var$DeployContract
                ],
                [
                    "functionCall",
                    $6eae62be96d8757d$var$FunctionCall
                ],
                [
                    "transfer",
                    $6eae62be96d8757d$var$Transfer
                ],
                [
                    "stake",
                    $6eae62be96d8757d$var$Stake
                ],
                [
                    "addKey",
                    $6eae62be96d8757d$var$AddKey
                ],
                [
                    "deleteKey",
                    $6eae62be96d8757d$var$DeleteKey
                ],
                [
                    "deleteAccount",
                    $6eae62be96d8757d$var$DeleteAccount
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$CreateAccount,
        {
            kind: "struct",
            fields: []
        }
    ],
    [
        $6eae62be96d8757d$var$DeployContract,
        {
            kind: "struct",
            fields: [
                [
                    "code",
                    [
                        "u8"
                    ]
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$FunctionCall,
        {
            kind: "struct",
            fields: [
                [
                    "methodName",
                    "string"
                ],
                [
                    "args",
                    [
                        "u8"
                    ]
                ],
                [
                    "gas",
                    "u64"
                ],
                [
                    "deposit",
                    "u128"
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$Transfer,
        {
            kind: "struct",
            fields: [
                [
                    "deposit",
                    "u128"
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$Stake,
        {
            kind: "struct",
            fields: [
                [
                    "stake",
                    "u128"
                ],
                [
                    "publicKey",
                    $lsY0f.PublicKey
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$AddKey,
        {
            kind: "struct",
            fields: [
                [
                    "publicKey",
                    $lsY0f.PublicKey
                ],
                [
                    "accessKey",
                    $6eae62be96d8757d$var$AccessKey
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$DeleteKey,
        {
            kind: "struct",
            fields: [
                [
                    "publicKey",
                    $lsY0f.PublicKey
                ]
            ]
        }
    ],
    [
        $6eae62be96d8757d$var$DeleteAccount,
        {
            kind: "struct",
            fields: [
                [
                    "beneficiaryId",
                    "string"
                ]
            ]
        }
    ]
]);
function $6eae62be96d8757d$var$createTransaction(signerId, publicKey, receiverId, nonce, actions, blockHash) {
    return new $6eae62be96d8757d$var$Transaction({
        signerId: signerId,
        publicKey: publicKey,
        nonce: nonce,
        receiverId: receiverId,
        actions: actions,
        blockHash: blockHash
    });
}
module.exports.createTransaction = $6eae62be96d8757d$var$createTransaction;
/**
 * Signs a given transaction from an account with given keys, applied to the given network
 * @param transaction The Transaction object to sign
 * @param signer The {Signer} object that assists with signing keys
 * @param accountId The human-readable NEAR account name
 * @param networkId The targeted network. (ex. default, betanet, etc…)
 */ async function $6eae62be96d8757d$var$signTransactionObject(transaction, signer, accountId, networkId) {
    const message = $75BJw.serialize(module.exports.SCHEMA, transaction);
    const hash = new Uint8Array($6eae62be96d8757d$var$js_sha256_1.default.sha256.array(message));
    const signature = await signer.signMessage(message, accountId, networkId);
    const signedTx = new $6eae62be96d8757d$var$SignedTransaction({
        transaction: transaction,
        signature: new $6eae62be96d8757d$var$Signature({
            keyType: transaction.publicKey.keyType,
            data: signature.signature
        })
    });
    return [
        hash,
        signedTx
    ];
}
async function $6eae62be96d8757d$var$signTransaction(...args) {
    if (args[0].constructor === $6eae62be96d8757d$var$Transaction) {
        const [transaction, signer, accountId, networkId] = args;
        return $6eae62be96d8757d$var$signTransactionObject(transaction, signer, accountId, networkId);
    } else {
        const [receiverId, nonce, actions, blockHash, signer, accountId, networkId] = args;
        const publicKey = await signer.getPublicKey(accountId, networkId);
        const transaction = $6eae62be96d8757d$var$createTransaction(accountId, publicKey, receiverId, nonce, actions, blockHash);
        return $6eae62be96d8757d$var$signTransactionObject(transaction, signer, accountId, networkId);
    }
}
module.exports.signTransaction = $6eae62be96d8757d$var$signTransaction;

});
parcelRegister("fBCU1", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var ERROR = "input is invalid type";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $hPtJY === "object" && $hPtJY.versions && $hPtJY.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        "hex",
        "array",
        "digest",
        "arrayBuffer"
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod("hex", is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = eval("require('crypto')");
        var Buffer = eval("require('buffer').Buffer");
        var algorithm = is224 ? "sha224" : "sha256";
        var nodeMethod = function(message) {
            if (typeof message === "string") return crypto.createHash(algorithm).update(message, "utf8").digest("hex");
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(new Buffer(message)).digest("hex");
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod("hex", is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >> 28 & 0x0F] + HEX_CHARS[h4 >> 24 & 0x0F] + HEX_CHARS[h4 >> 20 & 0x0F] + HEX_CHARS[h4 >> 16 & 0x0F] + HEX_CHARS[h4 >> 12 & 0x0F] + HEX_CHARS[h4 >> 8 & 0x0F] + HEX_CHARS[h4 >> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >> 28 & 0x0F] + HEX_CHARS[h5 >> 24 & 0x0F] + HEX_CHARS[h5 >> 20 & 0x0F] + HEX_CHARS[h5 >> 16 & 0x0F] + HEX_CHARS[h5 >> 12 & 0x0F] + HEX_CHARS[h5 >> 8 & 0x0F] + HEX_CHARS[h5 >> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >> 28 & 0x0F] + HEX_CHARS[h6 >> 24 & 0x0F] + HEX_CHARS[h6 >> 20 & 0x0F] + HEX_CHARS[h6 >> 16 & 0x0F] + HEX_CHARS[h6 >> 12 & 0x0F] + HEX_CHARS[h6 >> 8 & 0x0F] + HEX_CHARS[h6 >> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >> 28 & 0x0F] + HEX_CHARS[h7 >> 24 & 0x0F] + HEX_CHARS[h7 >> 20 & 0x0F] + HEX_CHARS[h7 >> 16 & 0x0F] + HEX_CHARS[h7 >> 12 & 0x0F] + HEX_CHARS[h7 >> 8 & 0x0F] + HEX_CHARS[h7 >> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >> 24 & 0xFF,
            h0 >> 16 & 0xFF,
            h0 >> 8 & 0xFF,
            h0 & 0xFF,
            h1 >> 24 & 0xFF,
            h1 >> 16 & 0xFF,
            h1 >> 8 & 0xFF,
            h1 & 0xFF,
            h2 >> 24 & 0xFF,
            h2 >> 16 & 0xFF,
            h2 >> 8 & 0xFF,
            h2 & 0xFF,
            h3 >> 24 & 0xFF,
            h3 >> 16 & 0xFF,
            h3 >> 8 & 0xFF,
            h3 & 0xFF,
            h4 >> 24 & 0xFF,
            h4 >> 16 & 0xFF,
            h4 >> 8 & 0xFF,
            h4 & 0xFF,
            h5 >> 24 & 0xFF,
            h5 >> 16 & 0xFF,
            h5 >> 8 & 0xFF,
            h5 & 0xFF,
            h6 >> 24 & 0xFF,
            h6 >> 16 & 0xFF,
            h6 >> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === "string") {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === "object") {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRegister("hjq28", function(module, exports) {
"use strict";
var $c9a867b8888e98ff$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.diffEpochValidators = module.exports.findSeatPrice = void 0;

const $c9a867b8888e98ff$var$bn_js_1 = $c9a867b8888e98ff$var$__importDefault((parcelRequire("4l3c8")));

const $c9a867b8888e98ff$var$depd_1 = $c9a867b8888e98ff$var$__importDefault((parcelRequire("6TCoX")));
/** Finds seat price given validators stakes and number of seats.
 *  Calculation follow the spec: https://nomicon.io/Economics/README.html#validator-selection
 * @params validators: current or next epoch validators.
 * @params maxNumberOfSeats: maximum number of seats in the network.
 * @params minimumStakeRatio: minimum stake ratio
 * @params protocolVersion: version of the protocol from genesis config
 */ function $c9a867b8888e98ff$var$findSeatPrice(validators, maxNumberOfSeats, minimumStakeRatio, protocolVersion) {
    if (protocolVersion && protocolVersion < 49) return $c9a867b8888e98ff$var$findSeatPriceForProtocolBefore49(validators, maxNumberOfSeats);
    if (!minimumStakeRatio) {
        const deprecate = $c9a867b8888e98ff$var$depd_1.default("findSeatPrice(validators, maxNumberOfSeats)");
        deprecate("`use `findSeatPrice(validators, maxNumberOfSeats, minimumStakeRatio)` instead");
        minimumStakeRatio = [
            1,
            6250
        ]; // harcoded minimumStakeRation from 12/7/21
    }
    return $c9a867b8888e98ff$var$findSeatPriceForProtocolAfter49(validators, maxNumberOfSeats, minimumStakeRatio);
}
module.exports.findSeatPrice = $c9a867b8888e98ff$var$findSeatPrice;
function $c9a867b8888e98ff$var$findSeatPriceForProtocolBefore49(validators, numSeats) {
    const stakes = validators.map((v)=>new $c9a867b8888e98ff$var$bn_js_1.default(v.stake, 10)).sort((a, b)=>a.cmp(b));
    const num = new $c9a867b8888e98ff$var$bn_js_1.default(numSeats);
    const stakesSum = stakes.reduce((a, b)=>a.add(b));
    if (stakesSum.lt(num)) throw new Error("Stakes are below seats");
    // assert stakesSum >= numSeats
    let left = new $c9a867b8888e98ff$var$bn_js_1.default(1), right = stakesSum.add(new $c9a867b8888e98ff$var$bn_js_1.default(1));
    while(!left.eq(right.sub(new $c9a867b8888e98ff$var$bn_js_1.default(1)))){
        const mid = left.add(right).div(new $c9a867b8888e98ff$var$bn_js_1.default(2));
        let found = false;
        let currentSum = new $c9a867b8888e98ff$var$bn_js_1.default(0);
        for(let i = 0; i < stakes.length; ++i){
            currentSum = currentSum.add(stakes[i].div(mid));
            if (currentSum.gte(num)) {
                left = mid;
                found = true;
                break;
            }
        }
        if (!found) right = mid;
    }
    return left;
}
// nearcore reference: https://github.com/near/nearcore/blob/5a8ae263ec07930cd34d0dcf5bcee250c67c02aa/chain/epoch_manager/src/validator_selection.rs#L308;L315
function $c9a867b8888e98ff$var$findSeatPriceForProtocolAfter49(validators, maxNumberOfSeats, minimumStakeRatio) {
    if (minimumStakeRatio.length != 2) throw Error("minimumStakeRatio should have 2 elements");
    const stakes = validators.map((v)=>new $c9a867b8888e98ff$var$bn_js_1.default(v.stake, 10)).sort((a, b)=>a.cmp(b));
    const stakesSum = stakes.reduce((a, b)=>a.add(b));
    if (validators.length < maxNumberOfSeats) return stakesSum.mul(new $c9a867b8888e98ff$var$bn_js_1.default(minimumStakeRatio[0])).div(new $c9a867b8888e98ff$var$bn_js_1.default(minimumStakeRatio[1]));
    else return stakes[0].add(new $c9a867b8888e98ff$var$bn_js_1.default(1));
}
/** Diff validators between current and next epoch.
 * Returns additions, subtractions and changes to validator set.
 * @params currentValidators: list of current validators.
 * @params nextValidators: list of next validators.
 */ function $c9a867b8888e98ff$var$diffEpochValidators(currentValidators, nextValidators) {
    const validatorsMap = new Map();
    currentValidators.forEach((v)=>validatorsMap.set(v.account_id, v));
    const nextValidatorsSet = new Set(nextValidators.map((v)=>v.account_id));
    return {
        newValidators: nextValidators.filter((v)=>!validatorsMap.has(v.account_id)),
        removedValidators: currentValidators.filter((v)=>!nextValidatorsSet.has(v.account_id)),
        changedValidators: nextValidators.filter((v)=>validatorsMap.has(v.account_id) && validatorsMap.get(v.account_id).stake != v.stake).map((v)=>({
                current: validatorsMap.get(v.account_id),
                next: v
            }))
    };
}
module.exports.diffEpochValidators = $c9a867b8888e98ff$var$diffEpochValidators;

});

parcelRegister("2As4n", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $1e24b79592e2e7c7$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $1e24b79592e2e7c7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Account = void 0;

const $1e24b79592e2e7c7$var$bn_js_1 = $1e24b79592e2e7c7$var$__importDefault((parcelRequire("4l3c8")));

const $1e24b79592e2e7c7$var$depd_1 = $1e24b79592e2e7c7$var$__importDefault((parcelRequire("6TCoX")));

var $9v9vF = parcelRequire("9v9vF");

var $2EqIG = parcelRequire("2EqIG");

var $75BJw = parcelRequire("75BJw");

var $lsY0f = parcelRequire("lsY0f");

var $hR4Jw = parcelRequire("hR4Jw");

var $1Z4jS = parcelRequire("1Z4jS");

var $2Vxyv = parcelRequire("2Vxyv");

const $1e24b79592e2e7c7$var$exponential_backoff_1 = $1e24b79592e2e7c7$var$__importDefault((parcelRequire("f0qo0")));
// Default number of retries with different nonce before giving up on a transaction.
const $1e24b79592e2e7c7$var$TX_NONCE_RETRY_NUMBER = 12;
// Default wait until next retry in millis.
const $1e24b79592e2e7c7$var$TX_NONCE_RETRY_WAIT = 500;
// Exponential back off for waiting to retry.
const $1e24b79592e2e7c7$var$TX_NONCE_RETRY_WAIT_BACKOFF = 1.5;
function $1e24b79592e2e7c7$var$parseJsonFromRawResponse(response) {
    return JSON.parse($1e24b79592e2e7c7$require$Buffer.from(response).toString());
}
function $1e24b79592e2e7c7$var$bytesJsonStringify(input) {
    return $1e24b79592e2e7c7$require$Buffer.from(JSON.stringify(input));
}
/**
 * This class provides common account related RPC calls including signing transactions with a {@link KeyPair}.
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#account}
 * @hint Use {@link WalletConnection} in the browser to redirect to {@link https://docs.near.org/docs/tools/near-wallet | NEAR Wallet} for Account/key management using the {@link BrowserLocalStorageKeyStore}.
 * @see {@link https://nomicon.io/DataStructures/Account.html | Account Spec}
 */ class $1e24b79592e2e7c7$var$Account {
    constructor(connection, accountId){
        /** @hidden */ this.accessKeyByPublicKeyCache = {};
        this.connection = connection;
        this.accountId = accountId;
    }
    /** @hidden */ get ready() {
        const deprecate = $1e24b79592e2e7c7$var$depd_1.default("Account.ready()");
        deprecate("not needed anymore, always ready");
        return Promise.resolve();
    }
    async fetchState() {
        const deprecate = $1e24b79592e2e7c7$var$depd_1.default("Account.fetchState()");
        deprecate("use `Account.state()` instead");
    }
    /**
     * Returns basic NEAR account information via the `view_account` RPC query method
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#view-account}
     */ async state() {
        return this.connection.provider.query({
            request_type: "view_account",
            account_id: this.accountId,
            finality: "optimistic"
        });
    }
    /** @hidden */ printLogsAndFailures(contractId, results) {
        for (const result of results){
            console.log(`Receipt${result.receiptIds.length > 1 ? "s" : ""}: ${result.receiptIds.join(", ")}`);
            this.printLogs(contractId, result.logs, "	");
            if (result.failure) console.warn(`\tFailure [${contractId}]: ${result.failure}`);
        }
    }
    /** @hidden */ printLogs(contractId, logs, prefix = "") {
        for (const log of logs)console.log(`${prefix}Log [${contractId}]: ${log}`);
    }
    /**
     * Create a signed transaction which can be broadcast to the network
     * @param receiverId NEAR account receiving the transaction
     * @param actions list of actions to perform as part of the transaction
     * @see {@link JsonRpcProvider.sendTransaction}
     */ async signTransaction(receiverId, actions) {
        const accessKeyInfo = await this.findAccessKey(receiverId, actions);
        if (!accessKeyInfo) throw new $2EqIG.TypedError(`Can not sign transactions for account ${this.accountId} on network ${this.connection.networkId}, no matching key pair found in ${this.connection.signer}.`, "KeyNotFound");
        const { accessKey: accessKey } = accessKeyInfo;
        const block = await this.connection.provider.block({
            finality: "final"
        });
        const blockHash = block.header.hash;
        const nonce = ++accessKey.nonce;
        return await $9v9vF.signTransaction(receiverId, nonce, actions, $75BJw.baseDecode(blockHash), this.connection.signer, this.accountId, this.connection.networkId);
    }
    signAndSendTransaction(...args) {
        if (typeof args[0] === "string") return this.signAndSendTransactionV1(args[0], args[1]);
        else return this.signAndSendTransactionV2(args[0]);
    }
    signAndSendTransactionV1(receiverId, actions) {
        const deprecate = $1e24b79592e2e7c7$var$depd_1.default("Account.signAndSendTransaction(receiverId, actions");
        deprecate("use `Account.signAndSendTransaction(SignAndSendTransactionOptions)` instead");
        return this.signAndSendTransactionV2({
            receiverId: receiverId,
            actions: actions
        });
    }
    async signAndSendTransactionV2({ receiverId: receiverId, actions: actions, returnError: returnError }) {
        let txHash, signedTx;
        // TODO: TX_NONCE (different constants for different uses of exponentialBackoff?)
        const result = await $1e24b79592e2e7c7$var$exponential_backoff_1.default($1e24b79592e2e7c7$var$TX_NONCE_RETRY_WAIT, $1e24b79592e2e7c7$var$TX_NONCE_RETRY_NUMBER, $1e24b79592e2e7c7$var$TX_NONCE_RETRY_WAIT_BACKOFF, async ()=>{
            [txHash, signedTx] = await this.signTransaction(receiverId, actions);
            const publicKey = signedTx.transaction.publicKey;
            try {
                return await this.connection.provider.sendTransaction(signedTx);
            } catch (error) {
                if (error.type === "InvalidNonce") {
                    $hR4Jw.logWarning(`Retrying transaction ${receiverId}:${$75BJw.baseEncode(txHash)} with new nonce.`);
                    delete this.accessKeyByPublicKeyCache[publicKey.toString()];
                    return null;
                }
                if (error.type === "Expired") {
                    $hR4Jw.logWarning(`Retrying transaction ${receiverId}:${$75BJw.baseEncode(txHash)} due to expired block hash`);
                    return null;
                }
                error.context = new $2EqIG.ErrorContext($75BJw.baseEncode(txHash));
                throw error;
            }
        });
        if (!result) // TODO: This should have different code actually, as means "transaction not submitted for sure"
        throw new $2EqIG.TypedError("nonce retries exceeded for transaction. This usually means there are too many parallel requests with the same access key.", "RetriesExceeded");
        const flatLogs = [
            result.transaction_outcome,
            ...result.receipts_outcome
        ].reduce((acc, it)=>{
            if (it.outcome.logs.length || typeof it.outcome.status === "object" && typeof it.outcome.status.Failure === "object") return acc.concat({
                "receiptIds": it.outcome.receipt_ids,
                "logs": it.outcome.logs,
                "failure": typeof it.outcome.status.Failure != "undefined" ? $1Z4jS.parseRpcError(it.outcome.status.Failure) : null
            });
            else return acc;
        }, []);
        this.printLogsAndFailures(signedTx.transaction.receiverId, flatLogs);
        if (!returnError && typeof result.status === "object" && typeof result.status.Failure === "object") {
            // if error data has error_message and error_type properties, we consider that node returned an error in the old format
            if (result.status.Failure.error_message && result.status.Failure.error_type) throw new $2EqIG.TypedError(`Transaction ${result.transaction_outcome.id} failed. ${result.status.Failure.error_message}`, result.status.Failure.error_type);
            else throw $1Z4jS.parseResultError(result);
        }
        // TODO: if Tx is Unknown or Started.
        return result;
    }
    /**
     * Finds the {@link AccessKeyView} associated with the accounts {@link PublicKey} stored in the {@link KeyStore}.
     *
     * @todo Find matching access key based on transaction (i.e. receiverId and actions)
     *
     * @param receiverId currently unused (see todo)
     * @param actions currently unused (see todo)
     * @returns `{ publicKey PublicKey; accessKey: AccessKeyView }`
     */ async findAccessKey(receiverId, actions) {
        // TODO: Find matching access key based on transaction (i.e. receiverId and actions)
        const publicKey = await this.connection.signer.getPublicKey(this.accountId, this.connection.networkId);
        if (!publicKey) return null;
        const cachedAccessKey = this.accessKeyByPublicKeyCache[publicKey.toString()];
        if (cachedAccessKey !== undefined) return {
            publicKey: publicKey,
            accessKey: cachedAccessKey
        };
        try {
            const accessKey = await this.connection.provider.query({
                request_type: "view_access_key",
                account_id: this.accountId,
                public_key: publicKey.toString(),
                finality: "optimistic"
            });
            // this function can be called multiple times and retrieve the same access key
            // this checks to see if the access key was already retrieved and cached while
            // the above network call was in flight. To keep nonce values in line, we return
            // the cached access key.
            if (this.accessKeyByPublicKeyCache[publicKey.toString()]) return {
                publicKey: publicKey,
                accessKey: this.accessKeyByPublicKeyCache[publicKey.toString()]
            };
            this.accessKeyByPublicKeyCache[publicKey.toString()] = accessKey;
            return {
                publicKey: publicKey,
                accessKey: accessKey
            };
        } catch (e) {
            if (e.type == "AccessKeyDoesNotExist") return null;
            throw e;
        }
    }
    /**
     * Create a new account and deploy a contract to it
     *
     * @param contractId NEAR account where the contract is deployed
     * @param publicKey The public key to add to the created contract account
     * @param data The compiled contract code
     * @param amount of NEAR to transfer to the created contract account. Transfer enough to pay for storage https://docs.near.org/docs/concepts/storage-staking
     */ async createAndDeployContract(contractId, publicKey, data, amount) {
        const accessKey = $9v9vF.fullAccessKey();
        await this.signAndSendTransaction({
            receiverId: contractId,
            actions: [
                $9v9vF.createAccount(),
                $9v9vF.transfer(amount),
                $9v9vF.addKey($lsY0f.PublicKey.from(publicKey), accessKey),
                $9v9vF.deployContract(data)
            ]
        });
        const contractAccount = new $1e24b79592e2e7c7$var$Account(this.connection, contractId);
        return contractAccount;
    }
    /**
     * @param receiverId NEAR account receiving Ⓝ
     * @param amount Amount to send in yoctoⓃ
     */ async sendMoney(receiverId, amount) {
        return this.signAndSendTransaction({
            receiverId: receiverId,
            actions: [
                $9v9vF.transfer(amount)
            ]
        });
    }
    /**
     * @param newAccountId NEAR account name to be created
     * @param publicKey A public key created from the masterAccount
     */ async createAccount(newAccountId, publicKey, amount) {
        const accessKey = $9v9vF.fullAccessKey();
        return this.signAndSendTransaction({
            receiverId: newAccountId,
            actions: [
                $9v9vF.createAccount(),
                $9v9vF.transfer(amount),
                $9v9vF.addKey($lsY0f.PublicKey.from(publicKey), accessKey)
            ]
        });
    }
    /**
     * @param beneficiaryId The NEAR account that will receive the remaining Ⓝ balance from the account being deleted
     */ async deleteAccount(beneficiaryId) {
        return this.signAndSendTransaction({
            receiverId: this.accountId,
            actions: [
                $9v9vF.deleteAccount(beneficiaryId)
            ]
        });
    }
    /**
     * @param data The compiled contract code
     */ async deployContract(data) {
        return this.signAndSendTransaction({
            receiverId: this.accountId,
            actions: [
                $9v9vF.deployContract(data)
            ]
        });
    }
    async functionCall(...args) {
        if (typeof args[0] === "string") return this.functionCallV1(args[0], args[1], args[2], args[3], args[4]);
        else return this.functionCallV2(args[0]);
    }
    functionCallV1(contractId, methodName, args, gas, amount) {
        const deprecate = $1e24b79592e2e7c7$var$depd_1.default("Account.functionCall(contractId, methodName, args, gas, amount)");
        deprecate("use `Account.functionCall(FunctionCallOptions)` instead");
        args = args || {};
        this.validateArgs(args);
        return this.signAndSendTransaction({
            receiverId: contractId,
            actions: [
                $9v9vF.functionCall(methodName, args, gas || $2Vxyv.DEFAULT_FUNCTION_CALL_GAS, amount)
            ]
        });
    }
    functionCallV2({ contractId: contractId, methodName: methodName, args: args = {}, gas: gas = $2Vxyv.DEFAULT_FUNCTION_CALL_GAS, attachedDeposit: attachedDeposit, walletMeta: walletMeta, walletCallbackUrl: walletCallbackUrl, stringify: stringify }) {
        this.validateArgs(args);
        const stringifyArg = stringify === undefined ? $9v9vF.stringifyJsonOrBytes : stringify;
        return this.signAndSendTransaction({
            receiverId: contractId,
            actions: [
                $9v9vF.functionCall(methodName, args, gas, attachedDeposit, stringifyArg)
            ],
            walletMeta: walletMeta,
            walletCallbackUrl: walletCallbackUrl
        });
    }
    /**
     * @see {@link https://docs.near.org/docs/concepts/account#access-keys}
     * @todo expand this API to support more options.
     * @param publicKey A public key to be associated with the contract
     * @param contractId NEAR account where the contract is deployed
     * @param methodNames The method names on the contract that should be allowed to be called. Pass null for no method names and '' or [] for any method names.
     * @param amount Payment in yoctoⓃ that is sent to the contract during this function call
     */ async addKey(publicKey, contractId, methodNames, amount) {
        if (!methodNames) methodNames = [];
        if (!Array.isArray(methodNames)) methodNames = [
            methodNames
        ];
        let accessKey;
        if (!contractId) accessKey = $9v9vF.fullAccessKey();
        else accessKey = $9v9vF.functionCallAccessKey(contractId, methodNames, amount);
        return this.signAndSendTransaction({
            receiverId: this.accountId,
            actions: [
                $9v9vF.addKey($lsY0f.PublicKey.from(publicKey), accessKey)
            ]
        });
    }
    /**
     * @param publicKey The public key to be deleted
     * @returns {Promise<FinalExecutionOutcome>}
     */ async deleteKey(publicKey) {
        return this.signAndSendTransaction({
            receiverId: this.accountId,
            actions: [
                $9v9vF.deleteKey($lsY0f.PublicKey.from(publicKey))
            ]
        });
    }
    /**
     * @see {@link https://docs.near.org/docs/validator/staking-overview}
     *
     * @param publicKey The public key for the account that's staking
     * @param amount The account to stake in yoctoⓃ
     */ async stake(publicKey, amount) {
        return this.signAndSendTransaction({
            receiverId: this.accountId,
            actions: [
                $9v9vF.stake(amount, $lsY0f.PublicKey.from(publicKey))
            ]
        });
    }
    /** @hidden */ validateArgs(args) {
        const isUint8Array = args.byteLength !== undefined && args.byteLength === args.length;
        if (isUint8Array) return;
        if (Array.isArray(args) || typeof args !== "object") throw new $hR4Jw.PositionalArgsError();
    }
    /**
     * Invoke a contract view function using the RPC API.
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#call-a-contract-function}
     *
     * @param contractId NEAR account where the contract is deployed
     * @param methodName The view-only method (no state mutations) name on the contract as it is written in the contract code
     * @param args Any arguments to the view contract method, wrapped in JSON
     * @param options.parse Parse the result of the call. Receives a Buffer (bytes array) and converts it to any object. By default result will be treated as json.
     * @param options.stringify Convert input arguments into a bytes array. By default the input is treated as a JSON.
     * @returns {Promise<any>}
     */ async viewFunction(contractId, methodName, args = {}, { parse: parse = $1e24b79592e2e7c7$var$parseJsonFromRawResponse, stringify: stringify = $1e24b79592e2e7c7$var$bytesJsonStringify } = {}) {
        this.validateArgs(args);
        const serializedArgs = stringify(args).toString("base64");
        const result = await this.connection.provider.query({
            request_type: "call_function",
            account_id: contractId,
            method_name: methodName,
            args_base64: serializedArgs,
            finality: "optimistic"
        });
        if (result.logs) this.printLogs(contractId, result.logs);
        return result.result && result.result.length > 0 && parse($1e24b79592e2e7c7$require$Buffer.from(result.result));
    }
    /**
     * Returns the state (key value pairs) of this account's contract based on the key prefix.
     * Pass an empty string for prefix if you would like to return the entire state.
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#view-contract-state}
     *
     * @param prefix allows to filter which keys should be returned. Empty prefix means all keys. String prefix is utf-8 encoded.
     * @param blockQuery specifies which block to query state at. By default returns last "optimistic" block (i.e. not necessarily finalized).
     */ async viewState(prefix, blockQuery = {
        finality: "optimistic"
    }) {
        const { values: values } = await this.connection.provider.query({
            request_type: "view_state",
            ...blockQuery,
            account_id: this.accountId,
            prefix_base64: $1e24b79592e2e7c7$require$Buffer.from(prefix).toString("base64")
        });
        return values.map(({ key: key, value: value })=>({
                key: $1e24b79592e2e7c7$require$Buffer.from(key, "base64"),
                value: $1e24b79592e2e7c7$require$Buffer.from(value, "base64")
            }));
    }
    /**
     * Get all access keys for the account
     * @see {@link https://docs.near.org/docs/develop/front-end/rpc#view-access-key-list}
     */ async getAccessKeys() {
        const response = await this.connection.provider.query({
            request_type: "view_access_key_list",
            account_id: this.accountId,
            finality: "optimistic"
        });
        // A breaking API change introduced extra information into the
        // response, so it now returns an object with a `keys` field instead
        // of an array: https://github.com/nearprotocol/nearcore/pull/1789
        if (Array.isArray(response)) return response;
        return response.keys;
    }
    /**
     * Returns a list of authorized apps
     * @todo update the response value to return all the different keys, not just app keys.
     */ async getAccountDetails() {
        // TODO: update the response value to return all the different keys, not just app keys.
        // Also if we need this function, or getAccessKeys is good enough.
        const accessKeys = await this.getAccessKeys();
        const authorizedApps = accessKeys.filter((item)=>item.access_key.permission !== "FullAccess").map((item)=>{
            const perm = item.access_key.permission;
            return {
                contractId: perm.FunctionCall.receiver_id,
                amount: perm.FunctionCall.allowance,
                publicKey: item.public_key
            };
        });
        return {
            authorizedApps: authorizedApps
        };
    }
    /**
     * Returns calculated account balance
     */ async getAccountBalance() {
        const protocolConfig = await this.connection.provider.experimental_protocolConfig({
            finality: "final"
        });
        const state = await this.state();
        const costPerByte = new $1e24b79592e2e7c7$var$bn_js_1.default(protocolConfig.runtime_config.storage_amount_per_byte);
        const stateStaked = new $1e24b79592e2e7c7$var$bn_js_1.default(state.storage_usage).mul(costPerByte);
        const staked = new $1e24b79592e2e7c7$var$bn_js_1.default(state.locked);
        const totalBalance = new $1e24b79592e2e7c7$var$bn_js_1.default(state.amount).add(staked);
        const availableBalance = totalBalance.sub($1e24b79592e2e7c7$var$bn_js_1.default.max(staked, stateStaked));
        return {
            total: totalBalance.toString(),
            stateStaked: stateStaked.toString(),
            staked: staked.toString(),
            available: availableBalance.toString()
        };
    }
}
module.exports.Account = $1e24b79592e2e7c7$var$Account;

});
parcelRegister("2Vxyv", function(module, exports) {
"use strict";
var $221aef12d71561c5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_FUNCTION_CALL_GAS = void 0;

const $221aef12d71561c5$var$bn_js_1 = $221aef12d71561c5$var$__importDefault((parcelRequire("4l3c8")));
// Default amount of gas to be sent with the function calls. Used to pay for the fees
// incurred while running the contract execution. The unused amount will be refunded back to
// the originator.
// Due to protocol changes that charge upfront for the maximum possible gas price inflation due to
// full blocks, the price of max_prepaid_gas is decreased to `300 * 10**12`.
// For discussion see https://github.com/nearprotocol/NEPs/issues/67
module.exports.DEFAULT_FUNCTION_CALL_GAS = new $221aef12d71561c5$var$bn_js_1.default("30000000000000");

});


parcelRegister("iJiDq", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $da2ae27849e77c82$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $da2ae27849e77c82$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Account2FA = module.exports.AccountMultisig = module.exports.MULTISIG_CONFIRM_METHODS = module.exports.MULTISIG_CHANGE_METHODS = module.exports.MULTISIG_DEPOSIT = module.exports.MULTISIG_GAS = module.exports.MULTISIG_ALLOWANCE = module.exports.MULTISIG_STORAGE_KEY = void 0;

const $da2ae27849e77c82$var$bn_js_1 = $da2ae27849e77c82$var$__importDefault((parcelRequire("4l3c8")));

const $da2ae27849e77c82$var$depd_1 = $da2ae27849e77c82$var$__importDefault((parcelRequire("6TCoX")));

var $2As4n = parcelRequire("2As4n");

var $33Nhm = parcelRequire("33Nhm");

var $lsY0f = parcelRequire("lsY0f");

var $9v9vF = parcelRequire("9v9vF");

var $9lI55 = parcelRequire("9lI55");
module.exports.MULTISIG_STORAGE_KEY = "__multisigRequest";
module.exports.MULTISIG_ALLOWANCE = new $da2ae27849e77c82$var$bn_js_1.default($33Nhm.parseNearAmount("1"));
// TODO: Different gas value for different requests (can reduce gas usage dramatically)
module.exports.MULTISIG_GAS = new $da2ae27849e77c82$var$bn_js_1.default("100000000000000");
module.exports.MULTISIG_DEPOSIT = new $da2ae27849e77c82$var$bn_js_1.default("0");
module.exports.MULTISIG_CHANGE_METHODS = [
    "add_request",
    "add_request_and_confirm",
    "delete_request",
    "confirm"
];
module.exports.MULTISIG_CONFIRM_METHODS = [
    "confirm"
];
// in memory request cache for node w/o localStorage
const $da2ae27849e77c82$var$storageFallback = {
    [module.exports.MULTISIG_STORAGE_KEY]: null
};
class $da2ae27849e77c82$var$AccountMultisig extends $2As4n.Account {
    constructor(connection, accountId, options){
        super(connection, accountId);
        this.storage = options.storage;
        this.onAddRequestResult = options.onAddRequestResult;
    }
    async signAndSendTransactionWithAccount(receiverId, actions) {
        return super.signAndSendTransaction({
            receiverId: receiverId,
            actions: actions
        });
    }
    signAndSendTransaction(...args) {
        if (typeof args[0] === "string") return this._signAndSendTransaction({
            receiverId: args[0],
            actions: args[1]
        });
        return this._signAndSendTransaction(args[0]);
    }
    async _signAndSendTransaction({ receiverId: receiverId, actions: actions }) {
        const { accountId: accountId } = this;
        const args = $da2ae27849e77c82$require$Buffer.from(JSON.stringify({
            request: {
                receiver_id: receiverId,
                actions: $da2ae27849e77c82$var$convertActions(actions, accountId, receiverId)
            }
        }));
        let result;
        try {
            result = await super.signAndSendTransaction({
                receiverId: accountId,
                actions: [
                    $9v9vF.functionCall("add_request_and_confirm", args, module.exports.MULTISIG_GAS, module.exports.MULTISIG_DEPOSIT)
                ]
            });
        } catch (e) {
            if (e.toString().includes("Account has too many active requests. Confirm or delete some")) {
                await this.deleteUnconfirmedRequests();
                return await this.signAndSendTransaction(receiverId, actions);
            }
            throw e;
        }
        // TODO: Are following even needed? Seems like it throws on error already
        if (!result.status) throw new Error("Request failed");
        const status = {
            ...result.status
        };
        if (!status.SuccessValue || typeof status.SuccessValue !== "string") throw new Error("Request failed");
        this.setRequest({
            accountId: accountId,
            actions: actions,
            requestId: parseInt($da2ae27849e77c82$require$Buffer.from(status.SuccessValue, "base64").toString("ascii"), 10)
        });
        if (this.onAddRequestResult) await this.onAddRequestResult(result);
        // NOTE there is no await on purpose to avoid blocking for 2fa
        this.deleteUnconfirmedRequests();
        return result;
    }
    async deleteUnconfirmedRequests() {
        // TODO: Delete in batch, don't delete unexpired
        // TODO: Delete in batch, don't delete unexpired (can reduce gas usage dramatically)
        const request_ids = await this.getRequestIds();
        const { requestId: requestId } = this.getRequest();
        for (const requestIdToDelete of request_ids){
            if (requestIdToDelete == requestId) continue;
            try {
                await super.signAndSendTransaction({
                    receiverId: this.accountId,
                    actions: [
                        $9v9vF.functionCall("delete_request", {
                            request_id: requestIdToDelete
                        }, module.exports.MULTISIG_GAS, module.exports.MULTISIG_DEPOSIT)
                    ]
                });
            } catch (e) {
                console.warn("Attempt to delete an earlier request before 15 minutes failed. Will try again.");
            }
        }
    }
    // helpers
    async getRequestIds() {
        // TODO: Read requests from state to allow filtering by expiration time
        // TODO: https://github.com/near/core-contracts/blob/305d1db4f4f2cf5ce4c1ef3479f7544957381f11/multisig/src/lib.rs#L84
        return this.viewFunction(this.accountId, "list_request_ids");
    }
    getRequest() {
        if (this.storage) return JSON.parse(this.storage.getItem(module.exports.MULTISIG_STORAGE_KEY) || "{}");
        return $da2ae27849e77c82$var$storageFallback[module.exports.MULTISIG_STORAGE_KEY];
    }
    setRequest(data) {
        if (this.storage) return this.storage.setItem(module.exports.MULTISIG_STORAGE_KEY, JSON.stringify(data));
        $da2ae27849e77c82$var$storageFallback[module.exports.MULTISIG_STORAGE_KEY] = data;
    }
}
module.exports.AccountMultisig = $da2ae27849e77c82$var$AccountMultisig;
class $da2ae27849e77c82$var$Account2FA extends $da2ae27849e77c82$var$AccountMultisig {
    constructor(connection, accountId, options){
        super(connection, accountId, options);
        this.helperUrl = "https://helper.testnet.near.org";
        this.helperUrl = options.helperUrl || this.helperUrl;
        this.storage = options.storage;
        this.sendCode = options.sendCode || this.sendCodeDefault;
        this.getCode = options.getCode || this.getCodeDefault;
        this.verifyCode = options.verifyCode || this.verifyCodeDefault;
        this.onConfirmResult = options.onConfirmResult;
    }
    async signAndSendTransaction(...args) {
        if (typeof args[0] === "string") {
            const deprecate = $da2ae27849e77c82$var$depd_1.default("Account.signAndSendTransaction(receiverId, actions");
            deprecate("use `Account2FA.signAndSendTransaction(SignAndSendTransactionOptions)` instead");
            return this.__signAndSendTransaction({
                receiverId: args[0],
                actions: args[1]
            });
        } else return this.__signAndSendTransaction(args[0]);
    }
    async __signAndSendTransaction({ receiverId: receiverId, actions: actions }) {
        await super.signAndSendTransaction({
            receiverId: receiverId,
            actions: actions
        });
        // TODO: Should following override onRequestResult in superclass instead of doing custom signAndSendTransaction?
        await this.sendCode();
        const result = await this.promptAndVerify();
        if (this.onConfirmResult) await this.onConfirmResult(result);
        return result;
    }
    // default helpers for CH deployments of multisig
    async deployMultisig(contractBytes) {
        const { accountId: accountId } = this;
        const seedOrLedgerKey = (await this.getRecoveryMethods()).data.filter(({ kind: kind, publicKey: publicKey })=>(kind === "phrase" || kind === "ledger") && publicKey !== null).map((rm)=>rm.publicKey);
        const fak2lak = (await this.getAccessKeys()).filter(({ public_key: public_key, access_key: { permission: permission } })=>permission === "FullAccess" && !seedOrLedgerKey.includes(public_key)).map((ak)=>ak.public_key).map($da2ae27849e77c82$var$toPK);
        const confirmOnlyKey = $da2ae27849e77c82$var$toPK((await this.postSignedJson("/2fa/getAccessKey", {
            accountId: accountId
        })).publicKey);
        const newArgs = $da2ae27849e77c82$require$Buffer.from(JSON.stringify({
            "num_confirmations": 2
        }));
        const actions = [
            ...fak2lak.map((pk)=>$9v9vF.deleteKey(pk)),
            ...fak2lak.map((pk)=>$9v9vF.addKey(pk, $9v9vF.functionCallAccessKey(accountId, module.exports.MULTISIG_CHANGE_METHODS, null))),
            $9v9vF.addKey(confirmOnlyKey, $9v9vF.functionCallAccessKey(accountId, module.exports.MULTISIG_CONFIRM_METHODS, null)),
            $9v9vF.deployContract(contractBytes)
        ];
        if ((await this.state()).code_hash === "11111111111111111111111111111111") actions.push($9v9vF.functionCall("new", newArgs, module.exports.MULTISIG_GAS, module.exports.MULTISIG_DEPOSIT));
        console.log("deploying multisig contract for", accountId);
        return await super.signAndSendTransactionWithAccount(accountId, actions);
    }
    async disable(contractBytes) {
        const { accountId: accountId } = this;
        const accessKeys = await this.getAccessKeys();
        const lak2fak = accessKeys.filter(({ access_key: access_key })=>access_key.permission !== "FullAccess").filter(({ access_key: access_key })=>{
            const perm = access_key.permission.FunctionCall;
            return perm.receiver_id === accountId && perm.method_names.length === 4 && perm.method_names.includes("add_request_and_confirm");
        });
        const confirmOnlyKey = $lsY0f.PublicKey.from((await this.postSignedJson("/2fa/getAccessKey", {
            accountId: accountId
        })).publicKey);
        const actions = [
            $9v9vF.deleteKey(confirmOnlyKey),
            ...lak2fak.map(({ public_key: public_key })=>$9v9vF.deleteKey($lsY0f.PublicKey.from(public_key))),
            ...lak2fak.map(({ public_key: public_key })=>$9v9vF.addKey($lsY0f.PublicKey.from(public_key), null)),
            $9v9vF.deployContract(contractBytes)
        ];
        console.log("disabling 2fa for", accountId);
        return await this.signAndSendTransaction({
            receiverId: accountId,
            actions: actions
        });
    }
    async sendCodeDefault() {
        const { accountId: accountId } = this;
        const { requestId: requestId } = this.getRequest();
        const method = await this.get2faMethod();
        await this.postSignedJson("/2fa/send", {
            accountId: accountId,
            method: method,
            requestId: requestId
        });
        return requestId;
    }
    async getCodeDefault(method) {
        throw new Error('There is no getCode callback provided. Please provide your own in AccountMultisig constructor options. It has a parameter method where method.kind is "email" or "phone".');
    }
    async promptAndVerify() {
        const method = await this.get2faMethod();
        const securityCode = await this.getCode(method);
        try {
            const result = await this.verifyCode(securityCode);
            // TODO: Parse error from result for real (like in normal account.signAndSendTransaction)
            return result;
        } catch (e) {
            console.warn("Error validating security code:", e);
            if (e.toString().includes("invalid 2fa code provided") || e.toString().includes("2fa code not valid")) return await this.promptAndVerify();
            throw e;
        }
    }
    async verifyCodeDefault(securityCode) {
        const { accountId: accountId } = this;
        const request = this.getRequest();
        if (!request) throw new Error("no request pending");
        const { requestId: requestId } = request;
        return await this.postSignedJson("/2fa/verify", {
            accountId: accountId,
            securityCode: securityCode,
            requestId: requestId
        });
    }
    async getRecoveryMethods() {
        const { accountId: accountId } = this;
        return {
            accountId: accountId,
            data: await this.postSignedJson("/account/recoveryMethods", {
                accountId: accountId
            })
        };
    }
    async get2faMethod() {
        let { data: data } = await this.getRecoveryMethods();
        if (data && data.length) data = data.find((m)=>m.kind.indexOf("2fa-") === 0);
        if (!data) return null;
        const { kind: kind, detail: detail } = data;
        return {
            kind: kind,
            detail: detail
        };
    }
    async signatureFor() {
        const { accountId: accountId } = this;
        const block = await this.connection.provider.block({
            finality: "final"
        });
        const blockNumber = block.header.height.toString();
        const signed = await this.connection.signer.signMessage($da2ae27849e77c82$require$Buffer.from(blockNumber), accountId, this.connection.networkId);
        const blockNumberSignature = $da2ae27849e77c82$require$Buffer.from(signed.signature).toString("base64");
        return {
            blockNumber: blockNumber,
            blockNumberSignature: blockNumberSignature
        };
    }
    async postSignedJson(path, body) {
        return await $9lI55.fetchJson(this.helperUrl + path, JSON.stringify({
            ...body,
            ...await this.signatureFor()
        }));
    }
}
module.exports.Account2FA = $da2ae27849e77c82$var$Account2FA;
// helpers
const $da2ae27849e77c82$var$toPK = (pk)=>$lsY0f.PublicKey.from(pk);
const $da2ae27849e77c82$var$convertPKForContract = (pk)=>pk.toString().replace("ed25519:", "");
const $da2ae27849e77c82$var$convertActions = (actions, accountId, receiverId)=>actions.map((a)=>{
        const type = a.enum;
        const { gas: gas, publicKey: publicKey, methodName: methodName, args: args, deposit: deposit, accessKey: accessKey, code: code } = a[type];
        const action = {
            type: type[0].toUpperCase() + type.substr(1),
            gas: gas && gas.toString() || undefined,
            public_key: publicKey && $da2ae27849e77c82$var$convertPKForContract(publicKey) || undefined,
            method_name: methodName,
            args: args && $da2ae27849e77c82$require$Buffer.from(args).toString("base64") || undefined,
            code: code && $da2ae27849e77c82$require$Buffer.from(code).toString("base64") || undefined,
            amount: deposit && deposit.toString() || undefined,
            deposit: deposit && deposit.toString() || "0",
            permission: undefined
        };
        if (accessKey) {
            if (receiverId === accountId && accessKey.permission.enum !== "fullAccess") action.permission = {
                receiver_id: accountId,
                allowance: module.exports.MULTISIG_ALLOWANCE.toString(),
                method_names: module.exports.MULTISIG_CHANGE_METHODS
            };
            if (accessKey.permission.enum === "functionCall") {
                const { receiverId: receiver_id, methodNames: method_names, allowance: allowance } = accessKey.permission.functionCall;
                action.permission = {
                    receiver_id: receiver_id,
                    allowance: allowance && allowance.toString() || undefined,
                    method_names: method_names
                };
            }
        }
        return action;
    });

});

parcelRegister("7lsXa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlAccountCreator = module.exports.LocalAccountCreator = module.exports.AccountCreator = void 0;

var $9lI55 = parcelRequire("9lI55");
/**
 * Account creator provides an interface for implementations to actually create accounts
 */ class $5590f411b7ae00c5$var$AccountCreator {
}
module.exports.AccountCreator = $5590f411b7ae00c5$var$AccountCreator;
class $5590f411b7ae00c5$var$LocalAccountCreator extends $5590f411b7ae00c5$var$AccountCreator {
    constructor(masterAccount, initialBalance){
        super();
        this.masterAccount = masterAccount;
        this.initialBalance = initialBalance;
    }
    /**
     * Creates an account using a masterAccount, meaning the new account is created from an existing account
     * @param newAccountId The name of the NEAR account to be created
     * @param publicKey The public key from the masterAccount used to create this account
     * @returns {Promise<void>}
     */ async createAccount(newAccountId, publicKey) {
        await this.masterAccount.createAccount(newAccountId, publicKey, this.initialBalance);
    }
}
module.exports.LocalAccountCreator = $5590f411b7ae00c5$var$LocalAccountCreator;
class $5590f411b7ae00c5$var$UrlAccountCreator extends $5590f411b7ae00c5$var$AccountCreator {
    constructor(connection, helperUrl){
        super();
        this.connection = connection;
        this.helperUrl = helperUrl;
    }
    /**
     * Creates an account using a helperUrl
     * This is [hosted here](https://helper.nearprotocol.com) or set up locally with the [near-contract-helper](https://github.com/nearprotocol/near-contract-helper) repository
     * @param newAccountId The name of the NEAR account to be created
     * @param publicKey The public key from the masterAccount used to create this account
     * @returns {Promise<void>}
     */ async createAccount(newAccountId, publicKey) {
        await $9lI55.fetchJson(`${this.helperUrl}/account`, JSON.stringify({
            newAccountId: newAccountId,
            newAccountPublicKey: publicKey.toString()
        }));
    }
}
module.exports.UrlAccountCreator = $5590f411b7ae00c5$var$UrlAccountCreator;

});

parcelRegister("aRlce", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Connection = void 0;

var $2EqIG = parcelRequire("2EqIG");

var $9BnjH = parcelRequire("9BnjH");
/**
 * @param config Contains connection info details
 * @returns {Provider}
 */ function $7e7f4bbd22cbf232$var$getProvider(config) {
    switch(config.type){
        case undefined:
            return config;
        case "JsonRpcProvider":
            return new $2EqIG.JsonRpcProvider({
                ...config.args
            });
        default:
            throw new Error(`Unknown provider type ${config.type}`);
    }
}
/**
 * @param config Contains connection info details
 * @returns {Signer}
 */ function $7e7f4bbd22cbf232$var$getSigner(config) {
    switch(config.type){
        case undefined:
            return config;
        case "InMemorySigner":
            return new $9BnjH.InMemorySigner(config.keyStore);
        default:
            throw new Error(`Unknown signer type ${config.type}`);
    }
}
/**
 * Connects an account to a given network via a given provider
 */ class $7e7f4bbd22cbf232$var$Connection {
    constructor(networkId, provider, signer){
        this.networkId = networkId;
        this.provider = provider;
        this.signer = signer;
    }
    /**
     * @param config Contains connection info details
     */ static fromConfig(config) {
        const provider = $7e7f4bbd22cbf232$var$getProvider(config.provider);
        const signer = $7e7f4bbd22cbf232$var$getSigner(config.signer);
        return new $7e7f4bbd22cbf232$var$Connection(config.networkId, provider, signer);
    }
}
module.exports.Connection = $7e7f4bbd22cbf232$var$Connection;

});
parcelRegister("9BnjH", function(module, exports) {
"use strict";
var $6fd9a7f3f5d9df4c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InMemorySigner = module.exports.Signer = void 0;

const $6fd9a7f3f5d9df4c$var$js_sha256_1 = $6fd9a7f3f5d9df4c$var$__importDefault((parcelRequire("fBCU1")));

var $lsY0f = parcelRequire("lsY0f");

var $kWbvD = parcelRequire("kWbvD");
/**
 * General signing interface, can be used for in memory signing, RPC singing, external wallet, HSM, etc.
 */ class $6fd9a7f3f5d9df4c$var$Signer {
}
module.exports.Signer = $6fd9a7f3f5d9df4c$var$Signer;
/**
 * Signs using in memory key store.
 */ class $6fd9a7f3f5d9df4c$var$InMemorySigner extends $6fd9a7f3f5d9df4c$var$Signer {
    constructor(keyStore){
        super();
        this.keyStore = keyStore;
    }
    /**
     * Creates a single account Signer instance with account, network and keyPair provided.
     *
     * Intended to be useful for temporary keys (e.g. claiming a Linkdrop).
     *
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account to assign the key pair to
     * @param keyPair The keyPair to use for signing
     */ static async fromKeyPair(networkId, accountId, keyPair) {
        const keyStore = new $kWbvD.InMemoryKeyStore();
        await keyStore.setKey(networkId, accountId, keyPair);
        return new $6fd9a7f3f5d9df4c$var$InMemorySigner(keyStore);
    }
    /**
     * Creates a public key for the account given
     * @param accountId The NEAR account to assign a public key to
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns {Promise<PublicKey>}
     */ async createKey(accountId, networkId) {
        const keyPair = $lsY0f.KeyPair.fromRandom("ed25519");
        await this.keyStore.setKey(networkId, accountId, keyPair);
        return keyPair.getPublicKey();
    }
    /**
     * Gets the existing public key for a given account
     * @param accountId The NEAR account to assign a public key to
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns {Promise<PublicKey>} Returns the public key or null if not found
     */ async getPublicKey(accountId, networkId) {
        const keyPair = await this.keyStore.getKey(networkId, accountId);
        if (keyPair === null) return null;
        return keyPair.getPublicKey();
    }
    /**
     * @param message A message to be signed, typically a serialized transaction
     * @param accountId the NEAR account signing the message
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns {Promise<Signature>}
     */ async signMessage(message, accountId, networkId) {
        const hash = new Uint8Array($6fd9a7f3f5d9df4c$var$js_sha256_1.default.sha256.array(message));
        if (!accountId) throw new Error("InMemorySigner requires provided account id");
        const keyPair = await this.keyStore.getKey(networkId, accountId);
        if (keyPair === null) throw new Error(`Key for ${accountId} not found in ${networkId}`);
        return keyPair.sign(hash);
    }
    toString() {
        return `InMemorySigner(${this.keyStore})`;
    }
}
module.exports.InMemorySigner = $6fd9a7f3f5d9df4c$var$InMemorySigner;

});


parcelRegister("jVkqH", function(module, exports) {
"use strict";
var $e81330151495085a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Contract = void 0;

const $e81330151495085a$var$bn_js_1 = $e81330151495085a$var$__importDefault((parcelRequire("4l3c8")));

const $e81330151495085a$var$depd_1 = $e81330151495085a$var$__importDefault((parcelRequire("6TCoX")));

var $2EqIG = parcelRequire("2EqIG");

var $hR4Jw = parcelRequire("hR4Jw");
// Makes `function.name` return given name
function $e81330151495085a$var$nameFunction(name, body) {
    return ({
        [name] (...args) {
            return body(...args);
        }
    })[name];
}
const $e81330151495085a$var$isUint8Array = (x)=>x && x.byteLength !== undefined && x.byteLength === x.length;
const $e81330151495085a$var$isObject = (x)=>Object.prototype.toString.call(x) === "[object Object]";
/**
 * Defines a smart contract on NEAR including the change (mutable) and view (non-mutable) methods
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#contract}
 * @example
 * ```js
 * import { Contract } from 'near-api-js';
 *
 * async function contractExample() {
 *   const methodOptions = {
 *     viewMethods: ['getMessageByAccountId'],
 *     changeMethods: ['addMessage']
 *   };
 *   const contract = new Contract(
 *     wallet.account(),
 *     'contract-id.testnet',
 *     methodOptions
 *   );
 *
 *   // use a contract view method
 *   const messages = await contract.getMessages({
 *     accountId: 'example-account.testnet'
 *   });
 *
 *   // use a contract change method
 *   await contract.addMessage({
 *      meta: 'some info',
 *      callbackUrl: 'https://example.com/callback',
 *      args: { text: 'my message' },
 *      amount: 1
 *   })
 * }
 * ```
 */ class $e81330151495085a$var$Contract {
    /**
     * @param account NEAR account to sign change method transactions
     * @param contractId NEAR account id where the contract is deployed
     * @param options NEAR smart contract methods that your application will use. These will be available as `contract.methodName`
     */ constructor(account, contractId, options){
        this.account = account;
        this.contractId = contractId;
        const { viewMethods: viewMethods = [], changeMethods: changeMethods = [] } = options;
        viewMethods.forEach((methodName)=>{
            Object.defineProperty(this, methodName, {
                writable: false,
                enumerable: true,
                value: $e81330151495085a$var$nameFunction(methodName, async (args = {}, options = {}, ...ignored)=>{
                    if (ignored.length || !($e81330151495085a$var$isObject(args) || $e81330151495085a$var$isUint8Array(args)) || !$e81330151495085a$var$isObject(options)) throw new $hR4Jw.PositionalArgsError();
                    return this.account.viewFunction(this.contractId, methodName, args, options);
                })
            });
        });
        changeMethods.forEach((methodName)=>{
            Object.defineProperty(this, methodName, {
                writable: false,
                enumerable: true,
                value: $e81330151495085a$var$nameFunction(methodName, async (...args)=>{
                    if (args.length && (args.length > 3 || !($e81330151495085a$var$isObject(args[0]) || $e81330151495085a$var$isUint8Array(args[0])))) throw new $hR4Jw.PositionalArgsError();
                    if (args.length > 1 || !(args[0] && args[0].args)) {
                        const deprecate = $e81330151495085a$var$depd_1.default("contract.methodName(args, gas, amount)");
                        deprecate("use `contract.methodName({ args, gas?, amount?, callbackUrl?, meta? })` instead");
                        return this._changeMethod({
                            methodName: methodName,
                            args: args[0],
                            gas: args[1],
                            amount: args[2]
                        });
                    }
                    return this._changeMethod({
                        methodName: methodName,
                        ...args[0]
                    });
                })
            });
        });
    }
    async _changeMethod({ args: args, methodName: methodName, gas: gas, amount: amount, meta: meta, callbackUrl: callbackUrl }) {
        $e81330151495085a$var$validateBNLike({
            gas: gas,
            amount: amount
        });
        const rawResult = await this.account.functionCall({
            contractId: this.contractId,
            methodName: methodName,
            args: args,
            gas: gas,
            attachedDeposit: amount,
            walletMeta: meta,
            walletCallbackUrl: callbackUrl
        });
        return $2EqIG.getTransactionLastResult(rawResult);
    }
}
module.exports.Contract = $e81330151495085a$var$Contract;
/**
 * Validation on arguments being a big number from bn.js
 * Throws if an argument is not in BN format or otherwise invalid
 * @param argMap
 */ function $e81330151495085a$var$validateBNLike(argMap) {
    const bnLike = "number, decimal string or BN";
    for (const argName of Object.keys(argMap)){
        const argValue = argMap[argName];
        if (argValue && !$e81330151495085a$var$bn_js_1.default.isBN(argValue) && isNaN(argValue)) throw new $hR4Jw.ArgumentTypeError(argName, bnLike, argValue);
    }
}

});

parcelRegister("bfxBf", function(module, exports) {
"use strict";
var $830b28a7bf8c6ad6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Near = void 0;

/**
 * This module contains the main class developers will use to interact with NEAR.
 * The {@link Near} class is used to interact with {@link Account | Accounts} through the {@link JsonRpcProvider.JsonRpcProvider | JsonRpcProvider}.
 * It is configured via the {@link NearConfig}.
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#account}
 *
 * @module near
 */ const $830b28a7bf8c6ad6$var$bn_js_1 = $830b28a7bf8c6ad6$var$__importDefault((parcelRequire("4l3c8")));

var $2As4n = parcelRequire("2As4n");

var $aRlce = parcelRequire("aRlce");

var $jVkqH = parcelRequire("jVkqH");

var $7lsXa = parcelRequire("7lsXa");
/**
 * This is the main class developers should use to interact with NEAR.
 * @example
 * ```js
 * const near = new Near(config);
 * ```
 */ class $830b28a7bf8c6ad6$var$Near {
    constructor(config){
        this.config = config;
        this.connection = $aRlce.Connection.fromConfig({
            networkId: config.networkId,
            provider: {
                type: "JsonRpcProvider",
                args: {
                    url: config.nodeUrl,
                    headers: config.headers
                }
            },
            signer: config.signer || {
                type: "InMemorySigner",
                keyStore: config.keyStore || config.deps.keyStore
            }
        });
        if (config.masterAccount) {
            // TODO: figure out better way of specifiying initial balance.
            // Hardcoded number below must be enough to pay the gas cost to dev-deploy with near-shell for multiple times
            const initialBalance = config.initialBalance ? new $830b28a7bf8c6ad6$var$bn_js_1.default(config.initialBalance) : new $830b28a7bf8c6ad6$var$bn_js_1.default("500000000000000000000000000");
            this.accountCreator = new $7lsXa.LocalAccountCreator(new $2As4n.Account(this.connection, config.masterAccount), initialBalance);
        } else if (config.helperUrl) this.accountCreator = new $7lsXa.UrlAccountCreator(this.connection, config.helperUrl);
        else this.accountCreator = null;
    }
    /**
     * @param accountId near accountId used to interact with the network.
     */ async account(accountId) {
        const account = new $2As4n.Account(this.connection, accountId);
        return account;
    }
    /**
     * Create an account using the {@link AccountCreator}. Either:
     * * using a masterAccount with {@link LocalAccountCreator}
     * * using the helperUrl with {@link UrlAccountCreator}
     * @see {@link NearConfig.masterAccount} and {@link NearConfig.helperUrl}-
     *
     * @param accountId
     * @param publicKey
     */ async createAccount(accountId, publicKey) {
        if (!this.accountCreator) throw new Error("Must specify account creator, either via masterAccount or helperUrl configuration settings.");
        await this.accountCreator.createAccount(accountId, publicKey);
        return new $2As4n.Account(this.connection, accountId);
    }
    /**
     * @deprecated Use {@link Contract} instead.
     * @param contractId
     * @param options
     */ async loadContract(contractId, options) {
        const account = new $2As4n.Account(this.connection, options.sender);
        return new $jVkqH.Contract(account, contractId, options);
    }
    /**
     * @deprecated Use {@link Account.sendMoney} instead.
     * @param amount
     * @param originator
     * @param receiver
     */ async sendTokens(amount, originator, receiver) {
        console.warn("near.sendTokens is deprecated. Use `yourAccount.sendMoney` instead.");
        const account = new $2As4n.Account(this.connection, originator);
        const result = await account.sendMoney(receiver, amount);
        return result.transaction_outcome.id;
    }
}
module.exports.Near = $830b28a7bf8c6ad6$var$Near;

});

parcelRegister("DUo3W", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $077f61f01595b6d7$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $077f61f01595b6d7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectedWalletAccount = module.exports.WalletAccount = module.exports.WalletConnection = void 0;

/**
 * The classes in this module are used in conjunction with the {@link BrowserLocalStorageKeyStore}. This module exposes two classes:
 * * {@link WalletConnection} which redirects users to {@link https://docs.near.org/docs/tools/near-wallet | NEAR Wallet} for key management.
 * * {@link ConnectedWalletAccount} is an {@link Account} implementation that uses {@link WalletConnection} to get keys
 *
 * @module walletAccount
 */ const $077f61f01595b6d7$var$depd_1 = $077f61f01595b6d7$var$__importDefault((parcelRequire("6TCoX")));

var $2As4n = parcelRequire("2As4n");

var $9v9vF = parcelRequire("9v9vF");

var $gphuu = parcelRequire("gphuu");

var $75BJw = parcelRequire("75BJw");

var $75BJw = parcelRequire("75BJw");
const $077f61f01595b6d7$var$LOGIN_WALLET_URL_SUFFIX = "/login/";
const $077f61f01595b6d7$var$MULTISIG_HAS_METHOD = "add_request_and_confirm";
const $077f61f01595b6d7$var$LOCAL_STORAGE_KEY_SUFFIX = "_wallet_auth_key";
const $077f61f01595b6d7$var$PENDING_ACCESS_KEY_PREFIX = "pending_key"; // browser storage key for a pending access key (i.e. key has been generated but we are not sure it was added yet)
/**
 * This class is used in conjunction with the {@link BrowserLocalStorageKeyStore}.
 * It redirects users to {@link https://docs.near.org/docs/tools/near-wallet | NEAR Wallet} for key management.
 *
 * @example {@link https://docs.near.org/docs/develop/front-end/naj-quick-reference#wallet}
 * @example
 * ```js
 * // create new WalletConnection instance
 * const wallet = new WalletConnection(near, 'my-app');
 *
 * // If not signed in redirect to the NEAR wallet to sign in
 * // keys will be stored in the BrowserLocalStorageKeyStore
 * if(!wallet.isSingnedIn()) return wallet.requestSignIn()
 * ```
 */ class $077f61f01595b6d7$var$WalletConnection {
    constructor(near, appKeyPrefix){
        this._near = near;
        const authDataKey = appKeyPrefix + $077f61f01595b6d7$var$LOCAL_STORAGE_KEY_SUFFIX;
        const authData = JSON.parse(window.localStorage.getItem(authDataKey));
        this._networkId = near.config.networkId;
        this._walletBaseUrl = near.config.walletUrl;
        appKeyPrefix = appKeyPrefix || near.config.contractName || "default";
        this._keyStore = near.connection.signer.keyStore;
        this._authData = authData || {
            allKeys: []
        };
        this._authDataKey = authDataKey;
        if (!this.isSignedIn()) this._completeSignInWithAccessKey();
    }
    /**
     * Returns true, if this WalletAccount is authorized with the wallet.
     * @example
     * ```js
     * const wallet = new WalletConnection(near, 'my-app');
     * wallet.isSignedIn();
     * ```
     */ isSignedIn() {
        return !!this._authData.accountId;
    }
    /**
     * Returns authorized Account ID.
     * @example
     * ```js
     * const wallet = new WalletConnection(near, 'my-app');
     * wallet.getAccountId();
     * ```
     */ getAccountId() {
        return this._authData.accountId || "";
    }
    /**
     * Redirects current page to the wallet authentication page.
     * @param options An optional options object
     * @param options.contractId The NEAR account where the contract is deployed
     * @param options.successUrl URL to redirect upon success. Default: current url
     * @param options.failureUrl URL to redirect upon failure. Default: current url
     *
     * @example
     * ```js
     * const wallet = new WalletConnection(near, 'my-app');
     * // redirects to the NEAR Wallet
     * wallet.requestSignIn({ contractId: 'account-with-deploy-contract.near' });
     * ```
     */ async requestSignIn(contractIdOrOptions = {}, title, successUrl, failureUrl) {
        let options;
        if (typeof contractIdOrOptions === "string") {
            const deprecate = $077f61f01595b6d7$var$depd_1.default("requestSignIn(contractId, title)");
            deprecate("`title` ignored; use `requestSignIn({ contractId, methodNames, successUrl, failureUrl })` instead");
            options = {
                contractId: contractIdOrOptions,
                successUrl: successUrl,
                failureUrl: failureUrl
            };
        } else options = contractIdOrOptions;
        const currentUrl = new URL(window.location.href);
        const newUrl = new URL(this._walletBaseUrl + $077f61f01595b6d7$var$LOGIN_WALLET_URL_SUFFIX);
        newUrl.searchParams.set("success_url", options.successUrl || currentUrl.href);
        newUrl.searchParams.set("failure_url", options.failureUrl || currentUrl.href);
        if (options.contractId) {
            /* Throws exception if contract account does not exist */ const contractAccount = await this._near.account(options.contractId);
            await contractAccount.state();
            newUrl.searchParams.set("contract_id", options.contractId);
            const accessKey = $gphuu.KeyPair.fromRandom("ed25519");
            newUrl.searchParams.set("public_key", accessKey.getPublicKey().toString());
            await this._keyStore.setKey(this._networkId, $077f61f01595b6d7$var$PENDING_ACCESS_KEY_PREFIX + accessKey.getPublicKey(), accessKey);
        }
        if (options.methodNames) options.methodNames.forEach((methodName)=>{
            newUrl.searchParams.append("methodNames", methodName);
        });
        window.location.assign(newUrl.toString());
    }
    async requestSignTransactions(...args) {
        if (Array.isArray(args[0])) {
            const deprecate = $077f61f01595b6d7$var$depd_1.default("WalletConnection.requestSignTransactions(transactions, callbackUrl, meta)");
            deprecate("use `WalletConnection.requestSignTransactions(RequestSignTransactionsOptions)` instead");
            return this._requestSignTransactions({
                transactions: args[0],
                callbackUrl: args[1],
                meta: args[2]
            });
        }
        return this._requestSignTransactions(args[0]);
    }
    async _requestSignTransactions({ transactions: transactions, meta: meta, callbackUrl: callbackUrl }) {
        const currentUrl = new URL(window.location.href);
        const newUrl = new URL("sign", this._walletBaseUrl);
        newUrl.searchParams.set("transactions", transactions.map((transaction)=>$75BJw.serialize($9v9vF.SCHEMA, transaction)).map((serialized)=>$077f61f01595b6d7$require$Buffer.from(serialized).toString("base64")).join(","));
        newUrl.searchParams.set("callbackUrl", callbackUrl || currentUrl.href);
        if (meta) newUrl.searchParams.set("meta", meta);
        window.location.assign(newUrl.toString());
    }
    /**
     * @hidden
     * Complete sign in for a given account id and public key. To be invoked by the app when getting a callback from the wallet.
     */ async _completeSignInWithAccessKey() {
        const currentUrl = new URL(window.location.href);
        const publicKey = currentUrl.searchParams.get("public_key") || "";
        const allKeys = (currentUrl.searchParams.get("all_keys") || "").split(",");
        const accountId = currentUrl.searchParams.get("account_id") || "";
        // TODO: Handle errors during login
        if (accountId) {
            this._authData = {
                accountId: accountId,
                allKeys: allKeys
            };
            window.localStorage.setItem(this._authDataKey, JSON.stringify(this._authData));
            if (publicKey) await this._moveKeyFromTempToPermanent(accountId, publicKey);
        }
        currentUrl.searchParams.delete("public_key");
        currentUrl.searchParams.delete("all_keys");
        currentUrl.searchParams.delete("account_id");
        currentUrl.searchParams.delete("meta");
        currentUrl.searchParams.delete("transactionHashes");
        window.history.replaceState({}, document.title, currentUrl.toString());
    }
    /**
     * @hidden
     * @param accountId The NEAR account owning the given public key
     * @param publicKey The public key being set to the key store
     */ async _moveKeyFromTempToPermanent(accountId, publicKey) {
        const keyPair = await this._keyStore.getKey(this._networkId, $077f61f01595b6d7$var$PENDING_ACCESS_KEY_PREFIX + publicKey);
        await this._keyStore.setKey(this._networkId, accountId, keyPair);
        await this._keyStore.removeKey(this._networkId, $077f61f01595b6d7$var$PENDING_ACCESS_KEY_PREFIX + publicKey);
    }
    /**
     * Sign out from the current account
     * @example
     * walletAccount.signOut();
     */ signOut() {
        this._authData = {};
        window.localStorage.removeItem(this._authDataKey);
    }
    /**
     * Returns the current connected wallet account
     */ account() {
        if (!this._connectedAccount) this._connectedAccount = new $077f61f01595b6d7$var$ConnectedWalletAccount(this, this._near.connection, this._authData.accountId);
        return this._connectedAccount;
    }
}
module.exports.WalletConnection = $077f61f01595b6d7$var$WalletConnection;
module.exports.WalletAccount = $077f61f01595b6d7$var$WalletConnection;
/**
 * {@link Account} implementation which redirects to wallet using {@link WalletConnection} when no local key is available.
 */ class $077f61f01595b6d7$var$ConnectedWalletAccount extends $2As4n.Account {
    constructor(walletConnection, connection, accountId){
        super(connection, accountId);
        this.walletConnection = walletConnection;
    }
    // Overriding Account methods
    /**
     * Sign a transaction by redirecting to the NEAR Wallet
     * @see {@link WalletConnection.requestSignTransactions}
     */ signAndSendTransaction(...args) {
        if (typeof args[0] === "string") return this._signAndSendTransaction({
            receiverId: args[0],
            actions: args[1]
        });
        return this._signAndSendTransaction(args[0]);
    }
    async _signAndSendTransaction({ receiverId: receiverId, actions: actions, walletMeta: walletMeta, walletCallbackUrl: walletCallbackUrl = window.location.href }) {
        const localKey = await this.connection.signer.getPublicKey(this.accountId, this.connection.networkId);
        let accessKey = await this.accessKeyForTransaction(receiverId, actions, localKey);
        if (!accessKey) throw new Error(`Cannot find matching key for transaction sent to ${receiverId}`);
        if (localKey && localKey.toString() === accessKey.public_key) try {
            return await super.signAndSendTransaction({
                receiverId: receiverId,
                actions: actions
            });
        } catch (e) {
            if (e.type === "NotEnoughAllowance") accessKey = await this.accessKeyForTransaction(receiverId, actions);
            else throw e;
        }
        const block = await this.connection.provider.block({
            finality: "final"
        });
        const blockHash = $75BJw.baseDecode(block.header.hash);
        const publicKey = $gphuu.PublicKey.from(accessKey.public_key);
        // TODO: Cache & listen for nonce updates for given access key
        const nonce = accessKey.access_key.nonce + 1;
        const transaction = $9v9vF.createTransaction(this.accountId, publicKey, receiverId, nonce, actions, blockHash);
        await this.walletConnection.requestSignTransactions({
            transactions: [
                transaction
            ],
            meta: walletMeta,
            callbackUrl: walletCallbackUrl
        });
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject(new Error("Failed to redirect to sign transaction"));
            }, 1000);
        });
    // TODO: Aggregate multiple transaction request with "debounce".
    // TODO: Introduce TrasactionQueue which also can be used to watch for status?
    }
    /**
     * Check if given access key allows the function call or method attempted in transaction
     * @param accessKey Array of {access_key: AccessKey, public_key: PublicKey} items
     * @param receiverId The NEAR account attempting to have access
     * @param actions The action(s) needed to be checked for access
     */ async accessKeyMatchesTransaction(accessKey, receiverId, actions) {
        const { access_key: { permission: permission } } = accessKey;
        if (permission === "FullAccess") return true;
        if (permission.FunctionCall) {
            const { receiver_id: allowedReceiverId, method_names: allowedMethods } = permission.FunctionCall;
            /********************************
            Accept multisig access keys and let wallets attempt to signAndSendTransaction
            If an access key has itself as receiverId and method permission add_request_and_confirm, then it is being used in a wallet with multisig contract: https://github.com/near/core-contracts/blob/671c05f09abecabe7a7e58efe942550a35fc3292/multisig/src/lib.rs#L149-L153
            ********************************/ if (allowedReceiverId === this.accountId && allowedMethods.includes($077f61f01595b6d7$var$MULTISIG_HAS_METHOD)) return true;
            if (allowedReceiverId === receiverId) {
                if (actions.length !== 1) return false;
                const [{ functionCall: functionCall }] = actions;
                return functionCall && (!functionCall.deposit || functionCall.deposit.toString() === "0") && // TODO: Should support charging amount smaller than allowance?
                (allowedMethods.length === 0 || allowedMethods.includes(functionCall.methodName));
            // TODO: Handle cases when allowance doesn't have enough to pay for gas
            }
        }
        // TODO: Support other permissions than FunctionCall
        return false;
    }
    /**
     * Helper function returning the access key (if it exists) to the receiver that grants the designated permission
     * @param receiverId The NEAR account seeking the access key for a transaction
     * @param actions The action(s) sought to gain access to
     * @param localKey A local public key provided to check for access
     * @returns Promise<any>
     */ async accessKeyForTransaction(receiverId, actions, localKey) {
        const accessKeys = await this.getAccessKeys();
        if (localKey) {
            const accessKey = accessKeys.find((key)=>key.public_key.toString() === localKey.toString());
            if (accessKey && await this.accessKeyMatchesTransaction(accessKey, receiverId, actions)) return accessKey;
        }
        const walletKeys = this.walletConnection._authData.allKeys;
        for (const accessKey of accessKeys){
            if (walletKeys.indexOf(accessKey.public_key) !== -1 && await this.accessKeyMatchesTransaction(accessKey, receiverId, actions)) return accessKey;
        }
        return null;
    }
}
module.exports.ConnectedWalletAccount = $077f61f01595b6d7$var$ConnectedWalletAccount;

});


parcelRegister("cgxXB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connect = void 0;

var $bfxBf = parcelRequire("bfxBf");
/**
 * Initialize connection to Near network.
 */ async function $8ee15275564caae5$var$connect(config) {
    return new $bfxBf.Near(config);
}
module.exports.connect = $8ee15275564caae5$var$connect;

});

parcelRegister("almNY", function(module, exports) {
parcelRequire("7oXUf");

var $i2ZXW = parcelRequire("i2ZXW");
var $787d8e2a22c4df92$var$polyfill;



if ($i2ZXW("Error.captureStackTrace")) $787d8e2a22c4df92$var$polyfill = (parcelRequire("lNfpn"));
else if ($i2ZXW("Error.prototype.stack")) $787d8e2a22c4df92$var$polyfill = (parcelRequire("2rpU9"));
else $787d8e2a22c4df92$var$polyfill = (parcelRequire("1K5CT"));
module.exports = $787d8e2a22c4df92$var$polyfill();

});
parcelRegister("7oXUf", function(module, exports) {

(parcelRequire("i2ZXW")).check("es5");

});
parcelRegister("i2ZXW", function(module, exports) {
parcelRequire("jSku7");

module.exports = (parcelRequire("7vsgI"));

});
parcelRegister("jSku7", function(module, exports) {

var $7vsgI = parcelRequire("7vsgI");
var $03bbeb2668dd164e$var$define = $7vsgI.define, $03bbeb2668dd164e$var$test = $7vsgI.test;
$03bbeb2668dd164e$var$define("strict mode", function() {
    return this === undefined;
});
$03bbeb2668dd164e$var$define("arguments.callee.caller", function() {
    try {
        return function() {
            return arguments.callee.caller;
        }() === arguments.callee;
    } catch (strictModeIsEnforced) {
        return false;
    }
});
$03bbeb2668dd164e$var$define("es5", function() {
    return $03bbeb2668dd164e$var$test("Array.prototype.forEach") && $03bbeb2668dd164e$var$test("Array.prototype.map") && $03bbeb2668dd164e$var$test("Function.prototype.bind") && $03bbeb2668dd164e$var$test("Object.create") && $03bbeb2668dd164e$var$test("Object.defineProperties") && $03bbeb2668dd164e$var$test("Object.defineProperty") && $03bbeb2668dd164e$var$test("Object.prototype.hasOwnProperty");
});
$03bbeb2668dd164e$var$define("Array.prototype.forEach", function() {
    return Array.prototype.forEach;
});
$03bbeb2668dd164e$var$define("Array.prototype.map", function() {
    return Array.prototype.map;
});
$03bbeb2668dd164e$var$define("Function.prototype.bind", function() {
    return Function.prototype.bind;
});
$03bbeb2668dd164e$var$define("Object.create", function() {
    return Object.create;
});
$03bbeb2668dd164e$var$define("Object.defineProperties", function() {
    return Object.defineProperties;
});
$03bbeb2668dd164e$var$define("Object.defineProperty", function() {
    return Object.defineProperty;
});
$03bbeb2668dd164e$var$define("Object.prototype.hasOwnProperty", function() {
    return Object.prototype.hasOwnProperty;
});
$03bbeb2668dd164e$var$define("Error.captureStackTrace", function() {
    return Error.captureStackTrace;
});
$03bbeb2668dd164e$var$define("Error.prototype.stack", function() {
    try {
        throw new Error();
    } catch (e) {
        return e.stack || e.stacktrace;
    }
});

});
parcelRegister("7vsgI", function(module, exports) {

var $5OJGg = parcelRequire("5OJGg");
var $57715b363a573b56$var$detector = new $5OJGg();
var $57715b363a573b56$var$capability = function(name) {
    return $57715b363a573b56$var$detector.test(name);
};
$57715b363a573b56$var$capability.define = function(name, test) {
    $57715b363a573b56$var$detector.define(name, test);
};
$57715b363a573b56$var$capability.check = function(name) {
    $57715b363a573b56$var$detector.check(name);
};
$57715b363a573b56$var$capability.test = $57715b363a573b56$var$capability;
module.exports = $57715b363a573b56$var$capability;

});
parcelRegister("5OJGg", function(module, exports) {
var $43c50e7ecc34e136$var$CapabilityDetector = function() {
    this.tests = {};
    this.cache = {};
};
$43c50e7ecc34e136$var$CapabilityDetector.prototype = {
    constructor: $43c50e7ecc34e136$var$CapabilityDetector,
    define: function(name, test) {
        if (typeof name != "string" || !(test instanceof Function)) throw new Error("Invalid capability definition.");
        if (this.tests[name]) throw new Error('Duplicated capability definition by "' + name + '".');
        this.tests[name] = test;
    },
    check: function(name) {
        if (!this.test(name)) throw new Error('The current environment does not support "' + name + '", therefore we cannot continue.');
    },
    test: function(name) {
        if (this.cache[name] !== undefined) return this.cache[name];
        if (!this.tests[name]) throw new Error('Unknown capability with name "' + name + '".');
        var test = this.tests[name];
        this.cache[name] = !!test();
        return this.cache[name];
    }
};
module.exports = $43c50e7ecc34e136$var$CapabilityDetector;

});





parcelRegister("lNfpn", function(module, exports) {

var $cC7FX = parcelRequire("cC7FX");
module.exports = function() {
    Error.getStackTrace = function(throwable) {
        return throwable.stack;
    };
    return {
        prepareStackTrace: $cC7FX
    };
};

});
parcelRegister("cC7FX", function(module, exports) {
var $92eefcde00765971$var$prepareStackTrace = function(throwable, frames, warnings) {
    var string = "";
    string += throwable.name || "Error";
    string += ": " + (throwable.message || "");
    if (warnings instanceof Array) for(var warningIndex in warnings){
        var warning = warnings[warningIndex];
        string += "\n   # " + warning;
    }
    for(var frameIndex in frames){
        var frame = frames[frameIndex];
        string += "\n   at " + frame.toString();
    }
    return string;
};
module.exports = $92eefcde00765971$var$prepareStackTrace;

});


parcelRegister("2rpU9", function(module, exports) {

var $gbjOz = parcelRequire("gbjOz");

var $cE0gq = parcelRequire("cE0gq");

var $7e5AA = parcelRequire("7e5AA");
var $1c7232885d247032$require$cache = $7e5AA.cache;

var $cC7FX = parcelRequire("cC7FX");
module.exports = function() {
    Error.captureStackTrace = function captureStackTrace(throwable, terminator) {
        var warnings;
        var frameShifts = [
            captureStackTrace
        ];
        if (terminator) // additional frames can come here if arguments.callee.caller is supported
        // otherwise it is hard to identify the terminator
        frameShifts.push(terminator);
        var captured = $gbjOz.getInstance().captureFrameStrings(frameShifts);
        Object.defineProperties(throwable, {
            stack: {
                configurable: true,
                get: $1c7232885d247032$require$cache(function() {
                    var frames = $cE0gq.getInstance().getFrames(captured.frameStrings, captured.functionValues);
                    return (Error.prepareStackTrace || $cC7FX)(throwable, frames, warnings);
                })
            },
            cachedStack: {
                configurable: true,
                writable: true,
                enumerable: false,
                value: true
            }
        });
    };
    Error.getStackTrace = function(throwable) {
        if (throwable.cachedStack) return throwable.stack;
        var frameStrings = $gbjOz.getInstance().getFrameStrings(throwable), frames = [], warnings;
        if (frameStrings) frames = $cE0gq.getInstance().getFrames(frameStrings, []);
        else warnings = [
            "The stack is not readable by unthrown errors in this environment."
        ];
        var stack = (Error.prepareStackTrace || $cC7FX)(throwable, frames, warnings);
        if (frameStrings) try {
            Object.defineProperties(throwable, {
                stack: {
                    configurable: true,
                    writable: true,
                    enumerable: false,
                    value: stack
                },
                cachedStack: {
                    configurable: true,
                    writable: true,
                    enumerable: false,
                    value: true
                }
            });
        } catch (nonConfigurableError) {}
        return stack;
    };
    return {
        prepareStackTrace: $cC7FX
    };
};

});
parcelRegister("gbjOz", function(module, exports) {

var $48QTc = parcelRequire("48QTc");
var $bc7d0b32fa8110a1$require$Class = $48QTc.Class;

var $48QTc = parcelRequire("48QTc");
var $bc7d0b32fa8110a1$require$abstractMethod = $48QTc.abstractMethod;

var $7e5AA = parcelRequire("7e5AA");
var $bc7d0b32fa8110a1$require$eachCombination = $7e5AA.eachCombination;

var $7e5AA = parcelRequire("7e5AA");
var $bc7d0b32fa8110a1$require$cache = $7e5AA.cache;

var $i2ZXW = parcelRequire("i2ZXW");
var $bc7d0b32fa8110a1$var$AbstractFrameStringSource = $bc7d0b32fa8110a1$require$Class(Object, {
    prototype: {
        captureFrameStrings: function(frameShifts) {
            var error = this.createError();
            frameShifts.unshift(this.captureFrameStrings);
            frameShifts.unshift(this.createError);
            var capturedFrameStrings = this.getFrameStrings(error);
            var frameStrings = capturedFrameStrings.slice(frameShifts.length), functionValues = [];
            if ($i2ZXW("arguments.callee.caller")) {
                var capturedFunctionValues = [
                    this.createError,
                    this.captureFrameStrings
                ];
                try {
                    var aCaller = arguments.callee;
                    while(aCaller = aCaller.caller)capturedFunctionValues.push(aCaller);
                } catch (useStrictError) {}
                functionValues = capturedFunctionValues.slice(frameShifts.length);
            }
            return {
                frameStrings: frameStrings,
                functionValues: functionValues
            };
        },
        getFrameStrings: function(error) {
            var message = error.message || "";
            var name = error.name || "";
            var stackString = this.getStackString(error);
            if (stackString === undefined) return;
            var stackStringChunks = stackString.split("\n");
            var fromPosition = 0;
            var toPosition = stackStringChunks.length;
            if (this.hasHeader) fromPosition += name.split("\n").length + message.split("\n").length - 1;
            if (this.hasFooter) toPosition -= 1;
            return stackStringChunks.slice(fromPosition, toPosition);
        },
        createError: $bc7d0b32fa8110a1$require$abstractMethod,
        getStackString: $bc7d0b32fa8110a1$require$abstractMethod,
        hasHeader: undefined,
        hasFooter: undefined
    }
});
var $bc7d0b32fa8110a1$var$FrameStringSourceCalibrator = $bc7d0b32fa8110a1$require$Class(Object, {
    prototype: {
        calibrateClass: function(FrameStringSource) {
            return this.calibrateMethods(FrameStringSource) && this.calibrateEnvelope(FrameStringSource);
        },
        calibrateMethods: function(FrameStringSource) {
            try {
                $bc7d0b32fa8110a1$require$eachCombination([
                    [
                        function(message) {
                            return new Error(message);
                        },
                        function(message) {
                            try {
                                throw new Error(message);
                            } catch (error) {
                                return error;
                            }
                        }
                    ],
                    [
                        function(error) {
                            return error.stack;
                        },
                        function(error) {
                            return error.stacktrace;
                        }
                    ]
                ], function(createError, getStackString) {
                    if (getStackString(createError())) throw {
                        getStackString: getStackString,
                        createError: createError
                    };
                });
            } catch (workingImplementation) {
                $bc7d0b32fa8110a1$require$Class.merge.call(FrameStringSource, {
                    prototype: workingImplementation
                });
                return true;
            }
            return false;
        },
        calibrateEnvelope: function(FrameStringSource) {
            var getStackString = FrameStringSource.prototype.getStackString;
            var createError = FrameStringSource.prototype.createError;
            var calibratorStackString = getStackString(createError("marker"));
            var calibratorFrameStrings = calibratorStackString.split("\n");
            $bc7d0b32fa8110a1$require$Class.merge.call(FrameStringSource, {
                prototype: {
                    hasHeader: /marker/.test(calibratorFrameStrings[0]),
                    hasFooter: calibratorFrameStrings[calibratorFrameStrings.length - 1] === ""
                }
            });
            return true;
        }
    }
});
module.exports = {
    getClass: $bc7d0b32fa8110a1$require$cache(function() {
        var FrameStringSource;
        if (FrameStringSource) return FrameStringSource;
        FrameStringSource = $bc7d0b32fa8110a1$require$Class($bc7d0b32fa8110a1$var$AbstractFrameStringSource, {});
        var calibrator = new $bc7d0b32fa8110a1$var$FrameStringSourceCalibrator();
        if (!calibrator.calibrateClass(FrameStringSource)) throw new Error("Cannot read Error.prototype.stack in this environment.");
        return FrameStringSource;
    }),
    getInstance: $bc7d0b32fa8110a1$require$cache(function() {
        var FrameStringSource = this.getClass();
        var instance = new FrameStringSource();
        return instance;
    })
};

});
parcelRegister("48QTc", function(module, exports) {
parcelRequire("7oXUf");

module.exports = (parcelRequire("2UaHm"));

});
parcelRegister("2UaHm", function(module, exports) {


module.exports = {
    Class: (parcelRequire("ahVyj")),
    abstractMethod: (parcelRequire("lkt9d"))
};

});
parcelRegister("ahVyj", function(module, exports) {
var $77d822a49e33c9a3$var$Class = function() {
    var options = Object.create({
        Source: Object,
        config: {},
        buildArgs: []
    });
    function checkOption(option) {
        var key = "config";
        if (option instanceof Function) key = "Source";
        else if (option instanceof Array) key = "buildArgs";
        else if (option instanceof Object) key = "config";
        else throw new Error("Invalid configuration option.");
        if (options.hasOwnProperty(key)) throw new Error("Duplicated configuration option: " + key + ".");
        options[key] = option;
    }
    for(var index = 0, length = arguments.length; index < length; ++index)checkOption(arguments[index]);
    var Source = options.Source, config = options.config, buildArgs = options.buildArgs;
    return (Source.extend || $77d822a49e33c9a3$var$Class.extend).call(Source, config, buildArgs);
};
$77d822a49e33c9a3$var$Class.factory = function() {
    var Source = this;
    return function() {
        var instance = this;
        if (instance.build instanceof Function) instance.build.apply(instance, arguments);
        if (instance.init instanceof Function) instance.init.apply(instance, arguments);
    };
};
$77d822a49e33c9a3$var$Class.extend = function(config, buildArgs) {
    var Source = this;
    if (!config) config = {};
    var Subject;
    if (config.prototype instanceof Object && config.prototype.constructor !== Object) Subject = config.prototype.constructor;
    else if (config.factory instanceof Function) Subject = config.factory.call(Source);
    Subject = (Source.clone || $77d822a49e33c9a3$var$Class.clone).call(Source, Subject, buildArgs);
    (Subject.merge || $77d822a49e33c9a3$var$Class.merge).call(Subject, config);
    return Subject;
};
$77d822a49e33c9a3$var$Class.prototype.extend = function(config, buildArgs) {
    var subject = this;
    var instance = (subject.clone || $77d822a49e33c9a3$var$Class.prototype.clone).apply(subject, buildArgs);
    (instance.merge || $77d822a49e33c9a3$var$Class.prototype.merge).call(instance, config);
    return instance;
};
$77d822a49e33c9a3$var$Class.clone = function(Subject, buildArgs) {
    var Source = this;
    if (!(Subject instanceof Function)) Subject = (Source.factory || $77d822a49e33c9a3$var$Class.factory).call(Source);
    Subject.prototype = (Source.prototype.clone || $77d822a49e33c9a3$var$Class.prototype.clone).apply(Source.prototype, buildArgs || []);
    Subject.prototype.constructor = Subject;
    for(var staticProperty in Source)if (staticProperty !== "prototype") Subject[staticProperty] = Source[staticProperty];
    return Subject;
};
$77d822a49e33c9a3$var$Class.prototype.clone = function() {
    var subject = this;
    var instance = Object.create(subject);
    if (instance.build instanceof Function) instance.build.apply(instance, arguments);
    return instance;
};
$77d822a49e33c9a3$var$Class.merge = function(config) {
    var Subject = this;
    for(var staticProperty in config)if (staticProperty !== "prototype") Subject[staticProperty] = config[staticProperty];
    if (config.prototype instanceof Object) (Subject.prototype.merge || $77d822a49e33c9a3$var$Class.prototype.merge).call(Subject.prototype, config.prototype);
    return Subject;
};
$77d822a49e33c9a3$var$Class.prototype.merge = function(config) {
    var subject = this;
    for(var property in config)if (property !== "constructor") subject[property] = config[property];
    return subject;
};
$77d822a49e33c9a3$var$Class.absorb = function(config) {
    var Subject = this;
    for(var staticProperty in config)if (staticProperty !== "prototype" && (Subject[staticProperty] === undefined || Subject[staticProperty] === Function.prototype[staticProperty])) Subject[staticProperty] = config[staticProperty];
    if (config.prototype instanceof Object) (Subject.prototype.absorb || $77d822a49e33c9a3$var$Class.prototype.absorb).call(Subject.prototype, config.prototype);
    return Subject;
};
$77d822a49e33c9a3$var$Class.prototype.absorb = function(config) {
    var subject = this;
    for(var property in config)if (property !== "constructor" && (subject[property] === undefined || subject[property] === Object.prototype[property])) subject[property] = config[property];
    return subject;
};
$77d822a49e33c9a3$var$Class.getAncestor = function() {
    var Source = this;
    if (Source !== Source.prototype.constructor) return Source.prototype.constructor;
};
$77d822a49e33c9a3$var$Class.newInstance = function() {
    var Subject = this;
    var instance = Object.create(this.prototype);
    Subject.apply(instance, arguments);
    return instance;
};
module.exports = $77d822a49e33c9a3$var$Class;

});

parcelRegister("lkt9d", function(module, exports) {
module.exports = function() {
    throw new Error("Not implemented.");
};

});



parcelRegister("7e5AA", function(module, exports) {

module.exports = (parcelRequire("2sb5y"));

});
parcelRegister("2sb5y", function(module, exports) {


module.exports = {
    cache: (parcelRequire("gegGG")),
    eachCombination: (parcelRequire("ivenR"))
};

});
parcelRegister("gegGG", function(module, exports) {
var $bd0ae5e7bb451db3$var$cache = function(fn) {
    var called = false, store;
    if (!(fn instanceof Function)) {
        called = true;
        store = fn;
        fn = null;
    }
    return function() {
        if (!called) {
            called = true;
            store = fn.apply(this, arguments);
            fn = null;
        }
        return store;
    };
};
module.exports = $bd0ae5e7bb451db3$var$cache;

});

parcelRegister("ivenR", function(module, exports) {
module.exports = function eachCombination(alternativesByDimension, callback, combination) {
    if (!combination) combination = [];
    if (combination.length < alternativesByDimension.length) {
        var alternatives = alternativesByDimension[combination.length];
        for(var index in alternatives){
            combination[combination.length] = alternatives[index];
            eachCombination(alternativesByDimension, callback, combination);
            --combination.length;
        }
    } else callback.apply(null, combination);
};

});




parcelRegister("cE0gq", function(module, exports) {

var $48QTc = parcelRequire("48QTc");
var $93496ce445b130e2$require$Class = $48QTc.Class;

var $3PY2X = parcelRequire("3PY2X");

var $7e5AA = parcelRequire("7e5AA");
var $93496ce445b130e2$require$cache = $7e5AA.cache;
var $93496ce445b130e2$var$FrameStringParser = $93496ce445b130e2$require$Class(Object, {
    prototype: {
        stackParser: null,
        frameParser: null,
        locationParsers: null,
        constructor: function(options) {
            $93496ce445b130e2$require$Class.prototype.merge.call(this, options);
        },
        getFrames: function(frameStrings, functionValues) {
            var frames = [];
            for(var index = 0, length = frameStrings.length; index < length; ++index)frames[index] = this.getFrame(frameStrings[index], functionValues[index]);
            return frames;
        },
        getFrame: function(frameString, functionValue) {
            var config = {
                frameString: frameString,
                functionValue: functionValue
            };
            return new $3PY2X(config);
        }
    }
});
module.exports = {
    getClass: $93496ce445b130e2$require$cache(function() {
        return $93496ce445b130e2$var$FrameStringParser;
    }),
    getInstance: $93496ce445b130e2$require$cache(function() {
        var FrameStringParser = this.getClass();
        var instance = new FrameStringParser();
        return instance;
    })
};

});
parcelRegister("3PY2X", function(module, exports) {

var $48QTc = parcelRequire("48QTc");
var $2cb4b68aded61d91$require$Class = $48QTc.Class;

var $48QTc = parcelRequire("48QTc");
var $2cb4b68aded61d91$require$abstractMethod = $48QTc.abstractMethod;
var $2cb4b68aded61d91$var$Frame = $2cb4b68aded61d91$require$Class(Object, {
    prototype: {
        init: $2cb4b68aded61d91$require$Class.prototype.merge,
        frameString: undefined,
        toString: function() {
            return this.frameString;
        },
        functionValue: undefined,
        getThis: $2cb4b68aded61d91$require$abstractMethod,
        getTypeName: $2cb4b68aded61d91$require$abstractMethod,
        getFunction: function() {
            return this.functionValue;
        },
        getFunctionName: $2cb4b68aded61d91$require$abstractMethod,
        getMethodName: $2cb4b68aded61d91$require$abstractMethod,
        getFileName: $2cb4b68aded61d91$require$abstractMethod,
        getLineNumber: $2cb4b68aded61d91$require$abstractMethod,
        getColumnNumber: $2cb4b68aded61d91$require$abstractMethod,
        getEvalOrigin: $2cb4b68aded61d91$require$abstractMethod,
        isTopLevel: $2cb4b68aded61d91$require$abstractMethod,
        isEval: $2cb4b68aded61d91$require$abstractMethod,
        isNative: $2cb4b68aded61d91$require$abstractMethod,
        isConstructor: $2cb4b68aded61d91$require$abstractMethod
    }
});
module.exports = $2cb4b68aded61d91$var$Frame;

});



parcelRegister("1K5CT", function(module, exports) {

var $7e5AA = parcelRequire("7e5AA");
var $144e739bb184e687$require$cache = $7e5AA.cache;

var $cC7FX = parcelRequire("cC7FX");
module.exports = function() {
    Error.captureStackTrace = function(throwable, terminator) {
        Object.defineProperties(throwable, {
            stack: {
                configurable: true,
                get: $144e739bb184e687$require$cache(function() {
                    return (Error.prepareStackTrace || $cC7FX)(throwable, []);
                })
            },
            cachedStack: {
                configurable: true,
                writable: true,
                enumerable: false,
                value: true
            }
        });
    };
    Error.getStackTrace = function(throwable) {
        if (throwable.cachedStack) return throwable.stack;
        var stack = (Error.prepareStackTrace || $cC7FX)(throwable, []);
        try {
            Object.defineProperties(throwable, {
                stack: {
                    configurable: true,
                    writable: true,
                    enumerable: false,
                    value: stack
                },
                cachedStack: {
                    configurable: true,
                    writable: true,
                    enumerable: false,
                    value: true
                }
            });
        } catch (nonConfigurableError) {}
        return stack;
    };
    return {
        prepareStackTrace: $cC7FX
    };
};

});


parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("kGRcS", function(module, exports) {

var $fJ45P = parcelRequire("fJ45P");
var $f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH = $fJ45P.MAX_SAFE_COMPONENT_LENGTH;
var $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH = $fJ45P.MAX_SAFE_BUILD_LENGTH;
var $f101009ed9c0563c$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;

var $i9RZm = parcelRequire("i9RZm");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        $f101009ed9c0563c$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $i9RZm(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken("MAINVERSIONLOOSE", `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken("PRERELEASELOOSE", `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken("FULL", `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken("LOOSE", `^${src[t.LOOSEPLAIN]}$`);
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken("XRANGEIDENTIFIER", `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken("XRANGEPLAIN", `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken("XRANGELOOSE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCEPLAIN", `${"(^|[^\\d])(\\d{1,"}${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken("COERCE", `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken("COERCEFULL", src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken("COERCERTL", src[t.COERCE], true);
createToken("COERCERTLFULL", src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken("TILDELOOSE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = "$1^";
createToken("CARET", `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken("CARETLOOSE", `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken("COMPARATOR", `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken("HYPHENRANGELOOSE", `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");

});
parcelRegister("fJ45P", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION = "2.0.0";
const $b72e3bc5fa8d2c21$var$MAX_LENGTH = 256;
const $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH = $b72e3bc5fa8d2c21$var$MAX_LENGTH - 6;
const $b72e3bc5fa8d2c21$var$RELEASE_TYPES = [
    "major",
    "premajor",
    "minor",
    "preminor",
    "patch",
    "prepatch",
    "prerelease"
];
module.exports = {
    MAX_LENGTH: $b72e3bc5fa8d2c21$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $b72e3bc5fa8d2c21$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("i9RZm", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
const $d382f2433df5837c$var$debug = (typeof $hPtJY === "object" && $hPtJY.env && undefined, ()=>{});
module.exports = $d382f2433df5837c$var$debug;

});


parcelRegister("fcGo5", function(module, exports) {
"use strict";
module.exports = function(Yallist) {
    Yallist.prototype[Symbol.iterator] = function*() {
        for(let walker = this.head; walker; walker = walker.next)yield walker.value;
    };
};

});

var $7238a34a955809b2$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7238a34a955809b2$exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}


/* Talking with a contract often involves transforming data, we recommend you to encapsulate that logic into a class */ var $e9c96496ce82840e$exports = {};
"use strict";
var $e9c96496ce82840e$var$__createBinding = $e9c96496ce82840e$exports && $e9c96496ce82840e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e9c96496ce82840e$var$__setModuleDefault = $e9c96496ce82840e$exports && $e9c96496ce82840e$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e9c96496ce82840e$var$__importStar = $e9c96496ce82840e$exports && $e9c96496ce82840e$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $e9c96496ce82840e$var$__createBinding(result, mod, k);
    }
    $e9c96496ce82840e$var$__setModuleDefault(result, mod);
    return result;
};
var $e9c96496ce82840e$var$__exportStar = $e9c96496ce82840e$exports && $e9c96496ce82840e$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) $e9c96496ce82840e$var$__createBinding(exports1, m, p);
};
Object.defineProperty($e9c96496ce82840e$exports, "__esModule", {
    value: true
});

/** @hidden @module */ $e9c96496ce82840e$exports.keyStores = $e9c96496ce82840e$var$__importStar((parcelRequire("88YbF")));

$e9c96496ce82840e$var$__exportStar((parcelRequire("dyqiS")), $e9c96496ce82840e$exports);

$e9c96496ce82840e$var$__exportStar((parcelRequire("cgxXB")), $e9c96496ce82840e$exports);
var $3df5f18801f6196e$exports = {};

$3df5f18801f6196e$exports = (parcelRequire("almNY"));




class $5ef75267231851bc$export$8517d80acf00e19a {
    constructor({ contractId: contractId, walletToUse: walletToUse }){
        this.contractId = contractId;
        this.wallet = walletToUse;
    }
    async getBeneficiary() {
        return await this.wallet.viewMethod({
            contractId: this.contractId,
            method: "get_beneficiary"
        });
    }
    async getBeneficiaryName() {
        let name = await this.wallet.viewMethod({
            contractId: this.contractId,
            method: "beneficiary_name"
        });
        console.log(name);
        return name;
    }
    async get_description() {
        return await this.wallet.viewMethod({
            contractId: this.contractId,
            method: "get_description"
        });
    }
    async get_total_amount() {
        return (0, $e9c96496ce82840e$exports.utils).format.formatNearAmount(await this.wallet.viewMethod({
            contractId: this.contractId,
            method: "get_total_donated"
        }));
    }
    async number_of_donors() {
        return await this.wallet.viewMethod({
            contractId: this.contractId,
            method: "number_of_donors"
        });
    }
    async latestDonations() {
        const number_of_donors = await this.wallet.viewMethod({
            contractId: this.contractId,
            method: "number_of_donors"
        });
        const min = number_of_donors > 10 ? number_of_donors - 9 : 0;
        let donations = await this.wallet.viewMethod({
            contractId: this.contractId,
            method: "get_donations",
            args: {
                from_index: min,
                limit: number_of_donors
            }
        });
        donations.forEach((elem)=>{
            elem.total_amount = (0, $e9c96496ce82840e$exports.utils).format.formatNearAmount(elem.total_amount);
        });
        return donations.reverse();
    }
    async topDonors() {
        let donations = await this.wallet.viewMethod({
            contractId: this.contractId,
            method: "get_top_five_donors",
            args: {}
        });
        donations.forEach((elem)=>{
            elem.total_amount = (0, $e9c96496ce82840e$exports.utils).format.formatNearAmount(elem.total_amount);
        });
        return donations;
    }
    async getDonationFromAccount(accountId) {
        let donation_amount = await this.wallet.viewMethod({
            contractId: this.contractId,
            method: "get_donation_for_account",
            args: {
                account_id: accountId
            }
        });
        console.log(donation_amount);
        return (0, $e9c96496ce82840e$exports.utils).format.formatNearAmount(donation_amount.total_amount);
    }
    async getDonationFromTransaction(txhash) {
        let donation_amount = await this.wallet.getTransactionResult(txhash);
        return (0, $e9c96496ce82840e$exports.utils).format.formatNearAmount(donation_amount);
    }
    async donate(amount) {
        let deposit = (0, $e9c96496ce82840e$exports.utils).format.parseNearAmount(amount.toString());
        let response = await this.wallet.callMethod({
            contractId: this.contractId,
            method: "donate",
            deposit: deposit
        });
        return response;
    }
}


/* A helper file that simplifies using the wallet selector */ // near api js


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



var $acw62 = parcelRequire("acw62");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $702e4d306615a028$var$extendStatics = function(d, b) {
    $702e4d306615a028$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $702e4d306615a028$var$extendStatics(d, b);
};
function $702e4d306615a028$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $702e4d306615a028$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $702e4d306615a028$export$18ce0697a983be9b = function() {
    $702e4d306615a028$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $702e4d306615a028$export$18ce0697a983be9b.apply(this, arguments);
};
function $702e4d306615a028$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $702e4d306615a028$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $702e4d306615a028$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $702e4d306615a028$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $702e4d306615a028$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $702e4d306615a028$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $702e4d306615a028$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $702e4d306615a028$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $702e4d306615a028$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $702e4d306615a028$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $702e4d306615a028$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $702e4d306615a028$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $702e4d306615a028$export$45d3717a4c69092e(o, m, p);
}
function $702e4d306615a028$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $702e4d306615a028$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $702e4d306615a028$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($702e4d306615a028$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $702e4d306615a028$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $702e4d306615a028$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $702e4d306615a028$export$10c90e4f7922046c(v) {
    return this instanceof $702e4d306615a028$export$10c90e4f7922046c ? (this.v = v, this) : new $702e4d306615a028$export$10c90e4f7922046c(v);
}
function $702e4d306615a028$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $702e4d306615a028$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $702e4d306615a028$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $702e4d306615a028$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $702e4d306615a028$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $702e4d306615a028$export$19a8beecd37a4c45 === "function" ? $702e4d306615a028$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $702e4d306615a028$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $702e4d306615a028$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $702e4d306615a028$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $702e4d306615a028$export$45d3717a4c69092e(result, mod, k);
    }
    $702e4d306615a028$var$__setModuleDefault(result, mod);
    return result;
}
function $702e4d306615a028$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $702e4d306615a028$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $702e4d306615a028$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $702e4d306615a028$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $702e4d306615a028$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $702e4d306615a028$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $702e4d306615a028$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $702e4d306615a028$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $702e4d306615a028$export$2e2bcd8739ae039 = {
    __extends: $702e4d306615a028$export$a8ba968b8961cb8a,
    __assign: $702e4d306615a028$export$18ce0697a983be9b,
    __rest: $702e4d306615a028$export$3c9a16f847548506,
    __decorate: $702e4d306615a028$export$29e00dfd3077644b,
    __param: $702e4d306615a028$export$d5ad3fd78186038f,
    __metadata: $702e4d306615a028$export$f1db080c865becb9,
    __awaiter: $702e4d306615a028$export$1050f835b63b671e,
    __generator: $702e4d306615a028$export$67ebef60e6f28a6,
    __createBinding: $702e4d306615a028$export$45d3717a4c69092e,
    __exportStar: $702e4d306615a028$export$f33643c0debef087,
    __values: $702e4d306615a028$export$19a8beecd37a4c45,
    __read: $702e4d306615a028$export$8d051b38c9118094,
    __spread: $702e4d306615a028$export$afc72e2116322959,
    __spreadArrays: $702e4d306615a028$export$6388937ca91ccae8,
    __spreadArray: $702e4d306615a028$export$1216008129fb82ed,
    __await: $702e4d306615a028$export$10c90e4f7922046c,
    __asyncGenerator: $702e4d306615a028$export$e427f37a30a4de9b,
    __asyncDelegator: $702e4d306615a028$export$bbd80228419bb833,
    __asyncValues: $702e4d306615a028$export$e3b29a3d6162315f,
    __makeTemplateObject: $702e4d306615a028$export$4fb47efe1390b86f,
    __importStar: $702e4d306615a028$export$c21735bcef00d192,
    __importDefault: $702e4d306615a028$export$da59b14a69baef04,
    __classPrivateFieldGet: $702e4d306615a028$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $702e4d306615a028$export$d40a35129aaff81f,
    __classPrivateFieldIn: $702e4d306615a028$export$81fdc39f203e4e04,
    __addDisposableResource: $702e4d306615a028$export$88ac25d8e944e405,
    __disposeResources: $702e4d306615a028$export$8f076105dc360e92
};




function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}




function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});


function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34)) errors = (0, $702e4d306615a028$export$1216008129fb82ed)((0, $702e4d306615a028$export$1216008129fb82ed)([], (0, $702e4d306615a028$export$8d051b38c9118094)(errors)), (0, $702e4d306615a028$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f587043ffd615a90$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && "closed" in value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.remove) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.add) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $702e4d306615a028$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $702e4d306615a028$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $528e75db69787807$export$8793edee2d425525() {}


var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}


var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8343668acd7c4a9b$export$f55210826850c514));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $92213d3dd6a83b5d$export$3e205fbb5df021e0)(error);
    else (0, $18eb28ff53cc4943$export$ebf645db02d3e99f)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $528e75db69787807$export$8793edee2d425525),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $528e75db69787807$export$8793edee2d425525)
};



var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();


function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}


function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7569c528cdd9d182$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0f1e8e2d1fe93adf$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.next) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.error) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $cf8ce74b80455e9f$export$60959659b2c22881) || $4f562137a990678a$var$isObserver(value) && (0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(value);
}




var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});




var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $43504509ae7aa03d$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $702e4d306615a028$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $4f562137a990678a$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);


var $7aced346698c521d$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038));


function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}




function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $702e4d306615a028$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $cf8ce74b80455e9f$export$60959659b2c22881));


function $35711d117487b96b$export$30fc204bc7867c02(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}


function $095ac41f805f8ce2$export$c87d910e63d22ed6(accumulator, seed) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)((0, $35711d117487b96b$export$30fc204bc7867c02)(accumulator, seed, arguments.length >= 2, true));
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $5bb7220e37bd460f$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
class $5bb7220e37bd460f$var$Provider {
    constructor(url){
        this.provider = new $e9c96496ce82840e$exports.providers.JsonRpcProvider({
            url: url
        });
    }
    query(params) {
        return this.provider.query(params);
    }
    viewAccessKey({ accountId: accountId, publicKey: publicKey }) {
        return this.query({
            request_type: "view_access_key",
            finality: "final",
            account_id: accountId,
            public_key: publicKey
        });
    }
    block(reference) {
        return this.provider.block(reference);
    }
    sendTransaction(signedTransaction) {
        return this.provider.sendTransaction(signedTransaction);
    }
}
const $5bb7220e37bd460f$var$KEY_DELIMITER = ":";
class $5bb7220e37bd460f$var$JsonStorage {
    constructor(storage, namespace){
        this.storage = storage;
        this.namespace = Array.isArray(namespace) ? namespace.join($5bb7220e37bd460f$var$KEY_DELIMITER) : namespace;
    }
    resolveKey(key) {
        return [
            this.namespace,
            key
        ].join($5bb7220e37bd460f$var$KEY_DELIMITER);
    }
    getItem(key) {
        return this.storage.getItem(this.resolveKey(key)).then((item)=>{
            return typeof item === "string" ? JSON.parse(item) : null;
        });
    }
    setItem(key, value) {
        return this.storage.setItem(this.resolveKey(key), JSON.stringify(value));
    }
    removeItem(key) {
        return this.storage.removeItem(this.resolveKey(key));
    }
}
var $5bb7220e37bd460f$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $5bb7220e37bd460f$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $5bb7220e37bd460f$var$global$m = // eslint-disable-next-line es-x/no-global-this -- safe
$5bb7220e37bd460f$var$check(typeof globalThis == "object" && globalThis) || $5bb7220e37bd460f$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$5bb7220e37bd460f$var$check(typeof self == "object" && self) || $5bb7220e37bd460f$var$check(typeof $5bb7220e37bd460f$var$commonjsGlobal == "object" && $5bb7220e37bd460f$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $5bb7220e37bd460f$var$objectGetOwnPropertyDescriptor = {};
var $5bb7220e37bd460f$var$fails$k = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $5bb7220e37bd460f$var$fails$j = $5bb7220e37bd460f$var$fails$k;
// Detect IE8's incomplete defineProperty implementation
var $5bb7220e37bd460f$var$descriptors = !$5bb7220e37bd460f$var$fails$j(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $5bb7220e37bd460f$var$fails$i = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$functionBindNative = !$5bb7220e37bd460f$var$fails$i(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $5bb7220e37bd460f$var$NATIVE_BIND$3 = $5bb7220e37bd460f$var$functionBindNative;
var $5bb7220e37bd460f$var$call$h = Function.prototype.call;
var $5bb7220e37bd460f$var$functionCall = $5bb7220e37bd460f$var$NATIVE_BIND$3 ? $5bb7220e37bd460f$var$call$h.bind($5bb7220e37bd460f$var$call$h) : function() {
    return $5bb7220e37bd460f$var$call$h.apply($5bb7220e37bd460f$var$call$h, arguments);
};
var $5bb7220e37bd460f$var$objectPropertyIsEnumerable = {};
var $5bb7220e37bd460f$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5bb7220e37bd460f$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $5bb7220e37bd460f$var$NASHORN_BUG = $5bb7220e37bd460f$var$getOwnPropertyDescriptor$2 && !$5bb7220e37bd460f$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$5bb7220e37bd460f$var$objectPropertyIsEnumerable.f = $5bb7220e37bd460f$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $5bb7220e37bd460f$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $5bb7220e37bd460f$var$$propertyIsEnumerable;
var $5bb7220e37bd460f$var$createPropertyDescriptor$4 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $5bb7220e37bd460f$var$NATIVE_BIND$2 = $5bb7220e37bd460f$var$functionBindNative;
var $5bb7220e37bd460f$var$FunctionPrototype$2 = Function.prototype;
var $5bb7220e37bd460f$var$bind$5 = $5bb7220e37bd460f$var$FunctionPrototype$2.bind;
var $5bb7220e37bd460f$var$call$g = $5bb7220e37bd460f$var$FunctionPrototype$2.call;
var $5bb7220e37bd460f$var$uncurryThis$j = $5bb7220e37bd460f$var$NATIVE_BIND$2 && $5bb7220e37bd460f$var$bind$5.bind($5bb7220e37bd460f$var$call$g, $5bb7220e37bd460f$var$call$g);
var $5bb7220e37bd460f$var$functionUncurryThis = $5bb7220e37bd460f$var$NATIVE_BIND$2 ? function(fn) {
    return fn && $5bb7220e37bd460f$var$uncurryThis$j(fn);
} : function(fn) {
    return fn && function() {
        return $5bb7220e37bd460f$var$call$g.apply(fn, arguments);
    };
};
var $5bb7220e37bd460f$var$uncurryThis$i = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$toString$6 = $5bb7220e37bd460f$var$uncurryThis$i({}.toString);
var $5bb7220e37bd460f$var$stringSlice$3 = $5bb7220e37bd460f$var$uncurryThis$i("".slice);
var $5bb7220e37bd460f$var$classofRaw$1 = function(it) {
    return $5bb7220e37bd460f$var$stringSlice$3($5bb7220e37bd460f$var$toString$6(it), 8, -1);
};
var $5bb7220e37bd460f$var$uncurryThis$h = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$fails$h = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$classof$7 = $5bb7220e37bd460f$var$classofRaw$1;
var $5bb7220e37bd460f$var$$Object$4 = Object;
var $5bb7220e37bd460f$var$split = $5bb7220e37bd460f$var$uncurryThis$h("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $5bb7220e37bd460f$var$indexedObject = $5bb7220e37bd460f$var$fails$h(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$5bb7220e37bd460f$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $5bb7220e37bd460f$var$classof$7(it) == "String" ? $5bb7220e37bd460f$var$split(it, "") : $5bb7220e37bd460f$var$$Object$4(it);
} : $5bb7220e37bd460f$var$$Object$4;
var $5bb7220e37bd460f$var$$TypeError$e = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $5bb7220e37bd460f$var$requireObjectCoercible$5 = function(it) {
    if (it == undefined) throw $5bb7220e37bd460f$var$$TypeError$e("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $5bb7220e37bd460f$var$IndexedObject$2 = $5bb7220e37bd460f$var$indexedObject;
var $5bb7220e37bd460f$var$requireObjectCoercible$4 = $5bb7220e37bd460f$var$requireObjectCoercible$5;
var $5bb7220e37bd460f$var$toIndexedObject$5 = function(it) {
    return $5bb7220e37bd460f$var$IndexedObject$2($5bb7220e37bd460f$var$requireObjectCoercible$4(it));
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $5bb7220e37bd460f$var$isCallable$l = function(argument) {
    return typeof argument == "function";
};
var $5bb7220e37bd460f$var$isCallable$k = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$isObject$8 = function(it) {
    return typeof it == "object" ? it !== null : $5bb7220e37bd460f$var$isCallable$k(it);
};
var $5bb7220e37bd460f$var$global$l = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$isCallable$j = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$aFunction = function(argument) {
    return $5bb7220e37bd460f$var$isCallable$j(argument) ? argument : undefined;
};
var $5bb7220e37bd460f$var$getBuiltIn$8 = function(namespace, method) {
    return arguments.length < 2 ? $5bb7220e37bd460f$var$aFunction($5bb7220e37bd460f$var$global$l[namespace]) : $5bb7220e37bd460f$var$global$l[namespace] && $5bb7220e37bd460f$var$global$l[namespace][method];
};
var $5bb7220e37bd460f$var$uncurryThis$g = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$objectIsPrototypeOf = $5bb7220e37bd460f$var$uncurryThis$g({}.isPrototypeOf);
var $5bb7220e37bd460f$var$getBuiltIn$7 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$engineUserAgent = $5bb7220e37bd460f$var$getBuiltIn$7("navigator", "userAgent") || "";
var $5bb7220e37bd460f$var$global$k = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$userAgent$3 = $5bb7220e37bd460f$var$engineUserAgent;
var $5bb7220e37bd460f$var$process$3 = $5bb7220e37bd460f$var$global$k.process;
var $5bb7220e37bd460f$var$Deno$1 = $5bb7220e37bd460f$var$global$k.Deno;
var $5bb7220e37bd460f$var$versions = $5bb7220e37bd460f$var$process$3 && $5bb7220e37bd460f$var$process$3.versions || $5bb7220e37bd460f$var$Deno$1 && $5bb7220e37bd460f$var$Deno$1.version;
var $5bb7220e37bd460f$var$v8 = $5bb7220e37bd460f$var$versions && $5bb7220e37bd460f$var$versions.v8;
var $5bb7220e37bd460f$var$match, $5bb7220e37bd460f$var$version;
if ($5bb7220e37bd460f$var$v8) {
    $5bb7220e37bd460f$var$match = $5bb7220e37bd460f$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $5bb7220e37bd460f$var$version = $5bb7220e37bd460f$var$match[0] > 0 && $5bb7220e37bd460f$var$match[0] < 4 ? 1 : +($5bb7220e37bd460f$var$match[0] + $5bb7220e37bd460f$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$5bb7220e37bd460f$var$version && $5bb7220e37bd460f$var$userAgent$3) {
    $5bb7220e37bd460f$var$match = $5bb7220e37bd460f$var$userAgent$3.match(/Edge\/(\d+)/);
    if (!$5bb7220e37bd460f$var$match || $5bb7220e37bd460f$var$match[1] >= 74) {
        $5bb7220e37bd460f$var$match = $5bb7220e37bd460f$var$userAgent$3.match(/Chrome\/(\d+)/);
        if ($5bb7220e37bd460f$var$match) $5bb7220e37bd460f$var$version = +$5bb7220e37bd460f$var$match[1];
    }
}
var $5bb7220e37bd460f$var$engineV8Version = $5bb7220e37bd460f$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $5bb7220e37bd460f$var$V8_VERSION$1 = $5bb7220e37bd460f$var$engineV8Version;
var $5bb7220e37bd460f$var$fails$g = $5bb7220e37bd460f$var$fails$k;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $5bb7220e37bd460f$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$5bb7220e37bd460f$var$fails$g(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $5bb7220e37bd460f$var$V8_VERSION$1 && $5bb7220e37bd460f$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $5bb7220e37bd460f$var$NATIVE_SYMBOL$1 = $5bb7220e37bd460f$var$nativeSymbol;
var $5bb7220e37bd460f$var$useSymbolAsUid = $5bb7220e37bd460f$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $5bb7220e37bd460f$var$getBuiltIn$6 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$isCallable$i = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$isPrototypeOf$2 = $5bb7220e37bd460f$var$objectIsPrototypeOf;
var $5bb7220e37bd460f$var$USE_SYMBOL_AS_UID$1 = $5bb7220e37bd460f$var$useSymbolAsUid;
var $5bb7220e37bd460f$var$$Object$3 = Object;
var $5bb7220e37bd460f$var$isSymbol$2 = $5bb7220e37bd460f$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $5bb7220e37bd460f$var$getBuiltIn$6("Symbol");
    return $5bb7220e37bd460f$var$isCallable$i($Symbol) && $5bb7220e37bd460f$var$isPrototypeOf$2($Symbol.prototype, $5bb7220e37bd460f$var$$Object$3(it));
};
var $5bb7220e37bd460f$var$$String$3 = String;
var $5bb7220e37bd460f$var$tryToString$4 = function(argument) {
    try {
        return $5bb7220e37bd460f$var$$String$3(argument);
    } catch (error) {
        return "Object";
    }
};
var $5bb7220e37bd460f$var$isCallable$h = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$tryToString$3 = $5bb7220e37bd460f$var$tryToString$4;
var $5bb7220e37bd460f$var$$TypeError$d = TypeError;
// `Assert: IsCallable(argument) is true`
var $5bb7220e37bd460f$var$aCallable$8 = function(argument) {
    if ($5bb7220e37bd460f$var$isCallable$h(argument)) return argument;
    throw $5bb7220e37bd460f$var$$TypeError$d($5bb7220e37bd460f$var$tryToString$3(argument) + " is not a function");
};
var $5bb7220e37bd460f$var$aCallable$7 = $5bb7220e37bd460f$var$aCallable$8;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $5bb7220e37bd460f$var$getMethod$4 = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $5bb7220e37bd460f$var$aCallable$7(func);
};
var $5bb7220e37bd460f$var$call$f = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$isCallable$g = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$isObject$7 = $5bb7220e37bd460f$var$isObject$8;
var $5bb7220e37bd460f$var$$TypeError$c = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $5bb7220e37bd460f$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $5bb7220e37bd460f$var$isCallable$g(fn = input.toString) && !$5bb7220e37bd460f$var$isObject$7(val = $5bb7220e37bd460f$var$call$f(fn, input))) return val;
    if ($5bb7220e37bd460f$var$isCallable$g(fn = input.valueOf) && !$5bb7220e37bd460f$var$isObject$7(val = $5bb7220e37bd460f$var$call$f(fn, input))) return val;
    if (pref !== "string" && $5bb7220e37bd460f$var$isCallable$g(fn = input.toString) && !$5bb7220e37bd460f$var$isObject$7(val = $5bb7220e37bd460f$var$call$f(fn, input))) return val;
    throw $5bb7220e37bd460f$var$$TypeError$c("Can't convert object to primitive value");
};
var $5bb7220e37bd460f$var$shared$4 = {
    exports: {}
};
var $5bb7220e37bd460f$var$global$j = $5bb7220e37bd460f$var$global$m;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5bb7220e37bd460f$var$defineProperty$5 = Object.defineProperty;
var $5bb7220e37bd460f$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $5bb7220e37bd460f$var$defineProperty$5($5bb7220e37bd460f$var$global$j, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $5bb7220e37bd460f$var$global$j[key] = value;
    }
    return value;
};
var $5bb7220e37bd460f$var$global$i = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$defineGlobalProperty$2 = $5bb7220e37bd460f$var$defineGlobalProperty$3;
var $5bb7220e37bd460f$var$SHARED = "__core-js_shared__";
var $5bb7220e37bd460f$var$store$3 = $5bb7220e37bd460f$var$global$i[$5bb7220e37bd460f$var$SHARED] || $5bb7220e37bd460f$var$defineGlobalProperty$2($5bb7220e37bd460f$var$SHARED, {});
var $5bb7220e37bd460f$var$sharedStore = $5bb7220e37bd460f$var$store$3;
var $5bb7220e37bd460f$var$store$2 = $5bb7220e37bd460f$var$sharedStore;
($5bb7220e37bd460f$var$shared$4.exports = function(key, value) {
    return $5bb7220e37bd460f$var$store$2[key] || ($5bb7220e37bd460f$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $5bb7220e37bd460f$var$requireObjectCoercible$3 = $5bb7220e37bd460f$var$requireObjectCoercible$5;
var $5bb7220e37bd460f$var$$Object$2 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $5bb7220e37bd460f$var$toObject$4 = function(argument) {
    return $5bb7220e37bd460f$var$$Object$2($5bb7220e37bd460f$var$requireObjectCoercible$3(argument));
};
var $5bb7220e37bd460f$var$uncurryThis$f = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$toObject$3 = $5bb7220e37bd460f$var$toObject$4;
var $5bb7220e37bd460f$var$hasOwnProperty = $5bb7220e37bd460f$var$uncurryThis$f({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $5bb7220e37bd460f$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $5bb7220e37bd460f$var$hasOwnProperty($5bb7220e37bd460f$var$toObject$3(it), key);
};
var $5bb7220e37bd460f$var$uncurryThis$e = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$id = 0;
var $5bb7220e37bd460f$var$postfix = Math.random();
var $5bb7220e37bd460f$var$toString$5 = $5bb7220e37bd460f$var$uncurryThis$e(1.0.toString);
var $5bb7220e37bd460f$var$uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $5bb7220e37bd460f$var$toString$5(++$5bb7220e37bd460f$var$id + $5bb7220e37bd460f$var$postfix, 36);
};
var $5bb7220e37bd460f$var$global$h = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$shared$3 = $5bb7220e37bd460f$var$shared$4.exports;
var $5bb7220e37bd460f$var$hasOwn$9 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$uid$1 = $5bb7220e37bd460f$var$uid$2;
var $5bb7220e37bd460f$var$NATIVE_SYMBOL = $5bb7220e37bd460f$var$nativeSymbol;
var $5bb7220e37bd460f$var$USE_SYMBOL_AS_UID = $5bb7220e37bd460f$var$useSymbolAsUid;
var $5bb7220e37bd460f$var$WellKnownSymbolsStore = $5bb7220e37bd460f$var$shared$3("wks");
var $5bb7220e37bd460f$var$Symbol$1 = $5bb7220e37bd460f$var$global$h.Symbol;
var $5bb7220e37bd460f$var$symbolFor = $5bb7220e37bd460f$var$Symbol$1 && $5bb7220e37bd460f$var$Symbol$1["for"];
var $5bb7220e37bd460f$var$createWellKnownSymbol = $5bb7220e37bd460f$var$USE_SYMBOL_AS_UID ? $5bb7220e37bd460f$var$Symbol$1 : $5bb7220e37bd460f$var$Symbol$1 && $5bb7220e37bd460f$var$Symbol$1.withoutSetter || $5bb7220e37bd460f$var$uid$1;
var $5bb7220e37bd460f$var$wellKnownSymbol$h = function(name) {
    if (!$5bb7220e37bd460f$var$hasOwn$9($5bb7220e37bd460f$var$WellKnownSymbolsStore, name) || !($5bb7220e37bd460f$var$NATIVE_SYMBOL || typeof $5bb7220e37bd460f$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($5bb7220e37bd460f$var$NATIVE_SYMBOL && $5bb7220e37bd460f$var$hasOwn$9($5bb7220e37bd460f$var$Symbol$1, name)) $5bb7220e37bd460f$var$WellKnownSymbolsStore[name] = $5bb7220e37bd460f$var$Symbol$1[name];
        else if ($5bb7220e37bd460f$var$USE_SYMBOL_AS_UID && $5bb7220e37bd460f$var$symbolFor) $5bb7220e37bd460f$var$WellKnownSymbolsStore[name] = $5bb7220e37bd460f$var$symbolFor(description);
        else $5bb7220e37bd460f$var$WellKnownSymbolsStore[name] = $5bb7220e37bd460f$var$createWellKnownSymbol(description);
    }
    return $5bb7220e37bd460f$var$WellKnownSymbolsStore[name];
};
var $5bb7220e37bd460f$var$call$e = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$isObject$6 = $5bb7220e37bd460f$var$isObject$8;
var $5bb7220e37bd460f$var$isSymbol$1 = $5bb7220e37bd460f$var$isSymbol$2;
var $5bb7220e37bd460f$var$getMethod$3 = $5bb7220e37bd460f$var$getMethod$4;
var $5bb7220e37bd460f$var$ordinaryToPrimitive = $5bb7220e37bd460f$var$ordinaryToPrimitive$1;
var $5bb7220e37bd460f$var$wellKnownSymbol$g = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$$TypeError$b = TypeError;
var $5bb7220e37bd460f$var$TO_PRIMITIVE = $5bb7220e37bd460f$var$wellKnownSymbol$g("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $5bb7220e37bd460f$var$toPrimitive$1 = function(input, pref) {
    if (!$5bb7220e37bd460f$var$isObject$6(input) || $5bb7220e37bd460f$var$isSymbol$1(input)) return input;
    var exoticToPrim = $5bb7220e37bd460f$var$getMethod$3(input, $5bb7220e37bd460f$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $5bb7220e37bd460f$var$call$e(exoticToPrim, input, pref);
        if (!$5bb7220e37bd460f$var$isObject$6(result) || $5bb7220e37bd460f$var$isSymbol$1(result)) return result;
        throw $5bb7220e37bd460f$var$$TypeError$b("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $5bb7220e37bd460f$var$ordinaryToPrimitive(input, pref);
};
var $5bb7220e37bd460f$var$toPrimitive = $5bb7220e37bd460f$var$toPrimitive$1;
var $5bb7220e37bd460f$var$isSymbol = $5bb7220e37bd460f$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $5bb7220e37bd460f$var$toPropertyKey$3 = function(argument) {
    var key = $5bb7220e37bd460f$var$toPrimitive(argument, "string");
    return $5bb7220e37bd460f$var$isSymbol(key) ? key : key + "";
};
var $5bb7220e37bd460f$var$global$g = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$isObject$5 = $5bb7220e37bd460f$var$isObject$8;
var $5bb7220e37bd460f$var$document$3 = $5bb7220e37bd460f$var$global$g.document;
// typeof document.createElement is 'object' in old IE
var $5bb7220e37bd460f$var$EXISTS$1 = $5bb7220e37bd460f$var$isObject$5($5bb7220e37bd460f$var$document$3) && $5bb7220e37bd460f$var$isObject$5($5bb7220e37bd460f$var$document$3.createElement);
var $5bb7220e37bd460f$var$documentCreateElement$2 = function(it) {
    return $5bb7220e37bd460f$var$EXISTS$1 ? $5bb7220e37bd460f$var$document$3.createElement(it) : {};
};
var $5bb7220e37bd460f$var$DESCRIPTORS$a = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$fails$f = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$createElement$1 = $5bb7220e37bd460f$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $5bb7220e37bd460f$var$ie8DomDefine = !$5bb7220e37bd460f$var$DESCRIPTORS$a && !$5bb7220e37bd460f$var$fails$f(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($5bb7220e37bd460f$var$createElement$1("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $5bb7220e37bd460f$var$DESCRIPTORS$9 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$call$d = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$propertyIsEnumerableModule$1 = $5bb7220e37bd460f$var$objectPropertyIsEnumerable;
var $5bb7220e37bd460f$var$createPropertyDescriptor$3 = $5bb7220e37bd460f$var$createPropertyDescriptor$4;
var $5bb7220e37bd460f$var$toIndexedObject$4 = $5bb7220e37bd460f$var$toIndexedObject$5;
var $5bb7220e37bd460f$var$toPropertyKey$2 = $5bb7220e37bd460f$var$toPropertyKey$3;
var $5bb7220e37bd460f$var$hasOwn$8 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$IE8_DOM_DEFINE$1 = $5bb7220e37bd460f$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5bb7220e37bd460f$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$5bb7220e37bd460f$var$objectGetOwnPropertyDescriptor.f = $5bb7220e37bd460f$var$DESCRIPTORS$9 ? $5bb7220e37bd460f$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $5bb7220e37bd460f$var$toIndexedObject$4(O);
    P = $5bb7220e37bd460f$var$toPropertyKey$2(P);
    if ($5bb7220e37bd460f$var$IE8_DOM_DEFINE$1) try {
        return $5bb7220e37bd460f$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($5bb7220e37bd460f$var$hasOwn$8(O, P)) return $5bb7220e37bd460f$var$createPropertyDescriptor$3(!$5bb7220e37bd460f$var$call$d($5bb7220e37bd460f$var$propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var $5bb7220e37bd460f$var$objectDefineProperty = {};
var $5bb7220e37bd460f$var$DESCRIPTORS$8 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$fails$e = $5bb7220e37bd460f$var$fails$k;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $5bb7220e37bd460f$var$v8PrototypeDefineBug = $5bb7220e37bd460f$var$DESCRIPTORS$8 && $5bb7220e37bd460f$var$fails$e(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $5bb7220e37bd460f$var$isObject$4 = $5bb7220e37bd460f$var$isObject$8;
var $5bb7220e37bd460f$var$$String$2 = String;
var $5bb7220e37bd460f$var$$TypeError$a = TypeError;
// `Assert: Type(argument) is Object`
var $5bb7220e37bd460f$var$anObject$d = function(argument) {
    if ($5bb7220e37bd460f$var$isObject$4(argument)) return argument;
    throw $5bb7220e37bd460f$var$$TypeError$a($5bb7220e37bd460f$var$$String$2(argument) + " is not an object");
};
var $5bb7220e37bd460f$var$DESCRIPTORS$7 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$IE8_DOM_DEFINE = $5bb7220e37bd460f$var$ie8DomDefine;
var $5bb7220e37bd460f$var$V8_PROTOTYPE_DEFINE_BUG$1 = $5bb7220e37bd460f$var$v8PrototypeDefineBug;
var $5bb7220e37bd460f$var$anObject$c = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$toPropertyKey$1 = $5bb7220e37bd460f$var$toPropertyKey$3;
var $5bb7220e37bd460f$var$$TypeError$9 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5bb7220e37bd460f$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5bb7220e37bd460f$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $5bb7220e37bd460f$var$ENUMERABLE = "enumerable";
var $5bb7220e37bd460f$var$CONFIGURABLE$1 = "configurable";
var $5bb7220e37bd460f$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$5bb7220e37bd460f$var$objectDefineProperty.f = $5bb7220e37bd460f$var$DESCRIPTORS$7 ? $5bb7220e37bd460f$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $5bb7220e37bd460f$var$anObject$c(O);
    P = $5bb7220e37bd460f$var$toPropertyKey$1(P);
    $5bb7220e37bd460f$var$anObject$c(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $5bb7220e37bd460f$var$WRITABLE in Attributes && !Attributes[$5bb7220e37bd460f$var$WRITABLE]) {
        var current = $5bb7220e37bd460f$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$5bb7220e37bd460f$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $5bb7220e37bd460f$var$CONFIGURABLE$1 in Attributes ? Attributes[$5bb7220e37bd460f$var$CONFIGURABLE$1] : current[$5bb7220e37bd460f$var$CONFIGURABLE$1],
                enumerable: $5bb7220e37bd460f$var$ENUMERABLE in Attributes ? Attributes[$5bb7220e37bd460f$var$ENUMERABLE] : current[$5bb7220e37bd460f$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $5bb7220e37bd460f$var$$defineProperty(O, P, Attributes);
} : $5bb7220e37bd460f$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $5bb7220e37bd460f$var$anObject$c(O);
    P = $5bb7220e37bd460f$var$toPropertyKey$1(P);
    $5bb7220e37bd460f$var$anObject$c(Attributes);
    if ($5bb7220e37bd460f$var$IE8_DOM_DEFINE) try {
        return $5bb7220e37bd460f$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $5bb7220e37bd460f$var$$TypeError$9("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $5bb7220e37bd460f$var$DESCRIPTORS$6 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$definePropertyModule$5 = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$createPropertyDescriptor$2 = $5bb7220e37bd460f$var$createPropertyDescriptor$4;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$5 = $5bb7220e37bd460f$var$DESCRIPTORS$6 ? function(object, key, value) {
    return $5bb7220e37bd460f$var$definePropertyModule$5.f(object, key, $5bb7220e37bd460f$var$createPropertyDescriptor$2(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $5bb7220e37bd460f$var$makeBuiltIn$2 = {
    exports: {}
};
var $5bb7220e37bd460f$var$DESCRIPTORS$5 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$hasOwn$7 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5bb7220e37bd460f$var$getDescriptor = $5bb7220e37bd460f$var$DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;
var $5bb7220e37bd460f$var$EXISTS = $5bb7220e37bd460f$var$hasOwn$7($5bb7220e37bd460f$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $5bb7220e37bd460f$var$PROPER = $5bb7220e37bd460f$var$EXISTS && (function something() {}).name === "something";
var $5bb7220e37bd460f$var$CONFIGURABLE = $5bb7220e37bd460f$var$EXISTS && (!$5bb7220e37bd460f$var$DESCRIPTORS$5 || $5bb7220e37bd460f$var$DESCRIPTORS$5 && $5bb7220e37bd460f$var$getDescriptor($5bb7220e37bd460f$var$FunctionPrototype$1, "name").configurable);
var $5bb7220e37bd460f$var$functionName = {
    EXISTS: $5bb7220e37bd460f$var$EXISTS,
    PROPER: $5bb7220e37bd460f$var$PROPER,
    CONFIGURABLE: $5bb7220e37bd460f$var$CONFIGURABLE
};
var $5bb7220e37bd460f$var$uncurryThis$d = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$isCallable$f = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$store$1 = $5bb7220e37bd460f$var$sharedStore;
var $5bb7220e37bd460f$var$functionToString = $5bb7220e37bd460f$var$uncurryThis$d(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$5bb7220e37bd460f$var$isCallable$f($5bb7220e37bd460f$var$store$1.inspectSource)) $5bb7220e37bd460f$var$store$1.inspectSource = function(it) {
    return $5bb7220e37bd460f$var$functionToString(it);
};
var $5bb7220e37bd460f$var$inspectSource$4 = $5bb7220e37bd460f$var$store$1.inspectSource;
var $5bb7220e37bd460f$var$global$f = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$isCallable$e = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$inspectSource$3 = $5bb7220e37bd460f$var$inspectSource$4;
var $5bb7220e37bd460f$var$WeakMap$1 = $5bb7220e37bd460f$var$global$f.WeakMap;
var $5bb7220e37bd460f$var$nativeWeakMap = $5bb7220e37bd460f$var$isCallable$e($5bb7220e37bd460f$var$WeakMap$1) && /native code/.test($5bb7220e37bd460f$var$inspectSource$3($5bb7220e37bd460f$var$WeakMap$1));
var $5bb7220e37bd460f$var$shared$2 = $5bb7220e37bd460f$var$shared$4.exports;
var $5bb7220e37bd460f$var$uid = $5bb7220e37bd460f$var$uid$2;
var $5bb7220e37bd460f$var$keys = $5bb7220e37bd460f$var$shared$2("keys");
var $5bb7220e37bd460f$var$sharedKey$3 = function(key) {
    return $5bb7220e37bd460f$var$keys[key] || ($5bb7220e37bd460f$var$keys[key] = $5bb7220e37bd460f$var$uid(key));
};
var $5bb7220e37bd460f$var$hiddenKeys$4 = {};
var $5bb7220e37bd460f$var$NATIVE_WEAK_MAP = $5bb7220e37bd460f$var$nativeWeakMap;
var $5bb7220e37bd460f$var$global$e = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$uncurryThis$c = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$isObject$3 = $5bb7220e37bd460f$var$isObject$8;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$4 = $5bb7220e37bd460f$var$createNonEnumerableProperty$5;
var $5bb7220e37bd460f$var$hasOwn$6 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$shared$1 = $5bb7220e37bd460f$var$sharedStore;
var $5bb7220e37bd460f$var$sharedKey$2 = $5bb7220e37bd460f$var$sharedKey$3;
var $5bb7220e37bd460f$var$hiddenKeys$3 = $5bb7220e37bd460f$var$hiddenKeys$4;
var $5bb7220e37bd460f$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $5bb7220e37bd460f$var$TypeError$2 = $5bb7220e37bd460f$var$global$e.TypeError;
var $5bb7220e37bd460f$var$WeakMap = $5bb7220e37bd460f$var$global$e.WeakMap;
var $5bb7220e37bd460f$var$set$1, $5bb7220e37bd460f$var$get, $5bb7220e37bd460f$var$has;
var $5bb7220e37bd460f$var$enforce = function(it) {
    return $5bb7220e37bd460f$var$has(it) ? $5bb7220e37bd460f$var$get(it) : $5bb7220e37bd460f$var$set$1(it, {});
};
var $5bb7220e37bd460f$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$5bb7220e37bd460f$var$isObject$3(it) || (state = $5bb7220e37bd460f$var$get(it)).type !== TYPE) throw $5bb7220e37bd460f$var$TypeError$2("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($5bb7220e37bd460f$var$NATIVE_WEAK_MAP || $5bb7220e37bd460f$var$shared$1.state) {
    var $5bb7220e37bd460f$var$store = $5bb7220e37bd460f$var$shared$1.state || ($5bb7220e37bd460f$var$shared$1.state = new $5bb7220e37bd460f$var$WeakMap());
    var $5bb7220e37bd460f$var$wmget = $5bb7220e37bd460f$var$uncurryThis$c($5bb7220e37bd460f$var$store.get);
    var $5bb7220e37bd460f$var$wmhas = $5bb7220e37bd460f$var$uncurryThis$c($5bb7220e37bd460f$var$store.has);
    var $5bb7220e37bd460f$var$wmset = $5bb7220e37bd460f$var$uncurryThis$c($5bb7220e37bd460f$var$store.set);
    $5bb7220e37bd460f$var$set$1 = function(it, metadata) {
        if ($5bb7220e37bd460f$var$wmhas($5bb7220e37bd460f$var$store, it)) throw new $5bb7220e37bd460f$var$TypeError$2($5bb7220e37bd460f$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5bb7220e37bd460f$var$wmset($5bb7220e37bd460f$var$store, it, metadata);
        return metadata;
    };
    $5bb7220e37bd460f$var$get = function(it) {
        return $5bb7220e37bd460f$var$wmget($5bb7220e37bd460f$var$store, it) || {};
    };
    $5bb7220e37bd460f$var$has = function(it) {
        return $5bb7220e37bd460f$var$wmhas($5bb7220e37bd460f$var$store, it);
    };
} else {
    var $5bb7220e37bd460f$var$STATE = $5bb7220e37bd460f$var$sharedKey$2("state");
    $5bb7220e37bd460f$var$hiddenKeys$3[$5bb7220e37bd460f$var$STATE] = true;
    $5bb7220e37bd460f$var$set$1 = function(it, metadata) {
        if ($5bb7220e37bd460f$var$hasOwn$6(it, $5bb7220e37bd460f$var$STATE)) throw new $5bb7220e37bd460f$var$TypeError$2($5bb7220e37bd460f$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5bb7220e37bd460f$var$createNonEnumerableProperty$4(it, $5bb7220e37bd460f$var$STATE, metadata);
        return metadata;
    };
    $5bb7220e37bd460f$var$get = function(it) {
        return $5bb7220e37bd460f$var$hasOwn$6(it, $5bb7220e37bd460f$var$STATE) ? it[$5bb7220e37bd460f$var$STATE] : {};
    };
    $5bb7220e37bd460f$var$has = function(it) {
        return $5bb7220e37bd460f$var$hasOwn$6(it, $5bb7220e37bd460f$var$STATE);
    };
}
var $5bb7220e37bd460f$var$internalState = {
    set: $5bb7220e37bd460f$var$set$1,
    get: $5bb7220e37bd460f$var$get,
    has: $5bb7220e37bd460f$var$has,
    enforce: $5bb7220e37bd460f$var$enforce,
    getterFor: $5bb7220e37bd460f$var$getterFor
};
var $5bb7220e37bd460f$var$fails$d = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$isCallable$d = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$hasOwn$5 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$DESCRIPTORS$4 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$CONFIGURABLE_FUNCTION_NAME$1 = $5bb7220e37bd460f$var$functionName.CONFIGURABLE;
var $5bb7220e37bd460f$var$inspectSource$2 = $5bb7220e37bd460f$var$inspectSource$4;
var $5bb7220e37bd460f$var$InternalStateModule$2 = $5bb7220e37bd460f$var$internalState;
var $5bb7220e37bd460f$var$enforceInternalState = $5bb7220e37bd460f$var$InternalStateModule$2.enforce;
var $5bb7220e37bd460f$var$getInternalState$2 = $5bb7220e37bd460f$var$InternalStateModule$2.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5bb7220e37bd460f$var$defineProperty$4 = Object.defineProperty;
var $5bb7220e37bd460f$var$CONFIGURABLE_LENGTH = $5bb7220e37bd460f$var$DESCRIPTORS$4 && !$5bb7220e37bd460f$var$fails$d(function() {
    return $5bb7220e37bd460f$var$defineProperty$4(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $5bb7220e37bd460f$var$TEMPLATE = String(String).split("String");
var $5bb7220e37bd460f$var$makeBuiltIn$1 = $5bb7220e37bd460f$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$5bb7220e37bd460f$var$hasOwn$5(value, "name") || $5bb7220e37bd460f$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($5bb7220e37bd460f$var$DESCRIPTORS$4) $5bb7220e37bd460f$var$defineProperty$4(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($5bb7220e37bd460f$var$CONFIGURABLE_LENGTH && options && $5bb7220e37bd460f$var$hasOwn$5(options, "arity") && value.length !== options.arity) $5bb7220e37bd460f$var$defineProperty$4(value, "length", {
        value: options.arity
    });
    try {
        if (options && $5bb7220e37bd460f$var$hasOwn$5(options, "constructor") && options.constructor) {
            if ($5bb7220e37bd460f$var$DESCRIPTORS$4) $5bb7220e37bd460f$var$defineProperty$4(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $5bb7220e37bd460f$var$enforceInternalState(value);
    if (!$5bb7220e37bd460f$var$hasOwn$5(state, "source")) state.source = $5bb7220e37bd460f$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $5bb7220e37bd460f$var$makeBuiltIn$1(function toString() {
    return $5bb7220e37bd460f$var$isCallable$d(this) && $5bb7220e37bd460f$var$getInternalState$2(this).source || $5bb7220e37bd460f$var$inspectSource$2(this);
}, "toString");
var $5bb7220e37bd460f$var$isCallable$c = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$definePropertyModule$4 = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$makeBuiltIn = $5bb7220e37bd460f$var$makeBuiltIn$2.exports;
var $5bb7220e37bd460f$var$defineGlobalProperty$1 = $5bb7220e37bd460f$var$defineGlobalProperty$3;
var $5bb7220e37bd460f$var$defineBuiltIn$6 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($5bb7220e37bd460f$var$isCallable$c(value)) $5bb7220e37bd460f$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $5bb7220e37bd460f$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $5bb7220e37bd460f$var$definePropertyModule$4.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $5bb7220e37bd460f$var$objectGetOwnPropertyNames = {};
var $5bb7220e37bd460f$var$ceil = Math.ceil;
var $5bb7220e37bd460f$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $5bb7220e37bd460f$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5bb7220e37bd460f$var$floor : $5bb7220e37bd460f$var$ceil)(n);
};
var $5bb7220e37bd460f$var$trunc = $5bb7220e37bd460f$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $5bb7220e37bd460f$var$toIntegerOrInfinity$3 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5bb7220e37bd460f$var$trunc(number);
};
var $5bb7220e37bd460f$var$toIntegerOrInfinity$2 = $5bb7220e37bd460f$var$toIntegerOrInfinity$3;
var $5bb7220e37bd460f$var$max$1 = Math.max;
var $5bb7220e37bd460f$var$min$2 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $5bb7220e37bd460f$var$toAbsoluteIndex$2 = function(index, length) {
    var integer = $5bb7220e37bd460f$var$toIntegerOrInfinity$2(index);
    return integer < 0 ? $5bb7220e37bd460f$var$max$1(integer + length, 0) : $5bb7220e37bd460f$var$min$2(integer, length);
};
var $5bb7220e37bd460f$var$toIntegerOrInfinity$1 = $5bb7220e37bd460f$var$toIntegerOrInfinity$3;
var $5bb7220e37bd460f$var$min$1 = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $5bb7220e37bd460f$var$toLength$2 = function(argument) {
    return argument > 0 ? $5bb7220e37bd460f$var$min$1($5bb7220e37bd460f$var$toIntegerOrInfinity$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $5bb7220e37bd460f$var$toLength$1 = $5bb7220e37bd460f$var$toLength$2;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $5bb7220e37bd460f$var$lengthOfArrayLike$4 = function(obj) {
    return $5bb7220e37bd460f$var$toLength$1(obj.length);
};
var $5bb7220e37bd460f$var$toIndexedObject$3 = $5bb7220e37bd460f$var$toIndexedObject$5;
var $5bb7220e37bd460f$var$toAbsoluteIndex$1 = $5bb7220e37bd460f$var$toAbsoluteIndex$2;
var $5bb7220e37bd460f$var$lengthOfArrayLike$3 = $5bb7220e37bd460f$var$lengthOfArrayLike$4;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $5bb7220e37bd460f$var$createMethod$2 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $5bb7220e37bd460f$var$toIndexedObject$3($this);
        var length = $5bb7220e37bd460f$var$lengthOfArrayLike$3(O);
        var index = $5bb7220e37bd460f$var$toAbsoluteIndex$1(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $5bb7220e37bd460f$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $5bb7220e37bd460f$var$createMethod$2(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $5bb7220e37bd460f$var$createMethod$2(false)
};
var $5bb7220e37bd460f$var$uncurryThis$b = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$hasOwn$4 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$toIndexedObject$2 = $5bb7220e37bd460f$var$toIndexedObject$5;
var $5bb7220e37bd460f$var$indexOf$1 = $5bb7220e37bd460f$var$arrayIncludes.indexOf;
var $5bb7220e37bd460f$var$hiddenKeys$2 = $5bb7220e37bd460f$var$hiddenKeys$4;
var $5bb7220e37bd460f$var$push$1 = $5bb7220e37bd460f$var$uncurryThis$b([].push);
var $5bb7220e37bd460f$var$objectKeysInternal = function(object, names) {
    var O = $5bb7220e37bd460f$var$toIndexedObject$2(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$5bb7220e37bd460f$var$hasOwn$4($5bb7220e37bd460f$var$hiddenKeys$2, key) && $5bb7220e37bd460f$var$hasOwn$4(O, key) && $5bb7220e37bd460f$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($5bb7220e37bd460f$var$hasOwn$4(O, key = names[i++])) ~$5bb7220e37bd460f$var$indexOf$1(result, key) || $5bb7220e37bd460f$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $5bb7220e37bd460f$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $5bb7220e37bd460f$var$internalObjectKeys$1 = $5bb7220e37bd460f$var$objectKeysInternal;
var $5bb7220e37bd460f$var$enumBugKeys$2 = $5bb7220e37bd460f$var$enumBugKeys$3;
var $5bb7220e37bd460f$var$hiddenKeys$1 = $5bb7220e37bd460f$var$enumBugKeys$2.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$5bb7220e37bd460f$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $5bb7220e37bd460f$var$internalObjectKeys$1(O, $5bb7220e37bd460f$var$hiddenKeys$1);
};
var $5bb7220e37bd460f$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$5bb7220e37bd460f$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $5bb7220e37bd460f$var$getBuiltIn$5 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$uncurryThis$a = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$getOwnPropertyNamesModule = $5bb7220e37bd460f$var$objectGetOwnPropertyNames;
var $5bb7220e37bd460f$var$getOwnPropertySymbolsModule$1 = $5bb7220e37bd460f$var$objectGetOwnPropertySymbols;
var $5bb7220e37bd460f$var$anObject$b = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$concat$1 = $5bb7220e37bd460f$var$uncurryThis$a([].concat);
// all object keys, includes non-enumerable and symbols
var $5bb7220e37bd460f$var$ownKeys$1 = $5bb7220e37bd460f$var$getBuiltIn$5("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $5bb7220e37bd460f$var$getOwnPropertyNamesModule.f($5bb7220e37bd460f$var$anObject$b(it));
    var getOwnPropertySymbols = $5bb7220e37bd460f$var$getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? $5bb7220e37bd460f$var$concat$1(keys, getOwnPropertySymbols(it)) : keys;
};
var $5bb7220e37bd460f$var$hasOwn$3 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$ownKeys = $5bb7220e37bd460f$var$ownKeys$1;
var $5bb7220e37bd460f$var$getOwnPropertyDescriptorModule = $5bb7220e37bd460f$var$objectGetOwnPropertyDescriptor;
var $5bb7220e37bd460f$var$definePropertyModule$3 = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $5bb7220e37bd460f$var$ownKeys(source);
    var defineProperty = $5bb7220e37bd460f$var$definePropertyModule$3.f;
    var getOwnPropertyDescriptor = $5bb7220e37bd460f$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$5bb7220e37bd460f$var$hasOwn$3(target, key) && !(exceptions && $5bb7220e37bd460f$var$hasOwn$3(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $5bb7220e37bd460f$var$fails$c = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$isCallable$b = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$replacement = /#|\.prototype\./;
var $5bb7220e37bd460f$var$isForced$2 = function(feature, detection) {
    var value = $5bb7220e37bd460f$var$data[$5bb7220e37bd460f$var$normalize(feature)];
    return value == $5bb7220e37bd460f$var$POLYFILL ? true : value == $5bb7220e37bd460f$var$NATIVE ? false : $5bb7220e37bd460f$var$isCallable$b(detection) ? $5bb7220e37bd460f$var$fails$c(detection) : !!detection;
};
var $5bb7220e37bd460f$var$normalize = $5bb7220e37bd460f$var$isForced$2.normalize = function(string) {
    return String(string).replace($5bb7220e37bd460f$var$replacement, ".").toLowerCase();
};
var $5bb7220e37bd460f$var$data = $5bb7220e37bd460f$var$isForced$2.data = {};
var $5bb7220e37bd460f$var$NATIVE = $5bb7220e37bd460f$var$isForced$2.NATIVE = "N";
var $5bb7220e37bd460f$var$POLYFILL = $5bb7220e37bd460f$var$isForced$2.POLYFILL = "P";
var $5bb7220e37bd460f$var$isForced_1 = $5bb7220e37bd460f$var$isForced$2;
var $5bb7220e37bd460f$var$global$d = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$getOwnPropertyDescriptor$1 = $5bb7220e37bd460f$var$objectGetOwnPropertyDescriptor.f;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$3 = $5bb7220e37bd460f$var$createNonEnumerableProperty$5;
var $5bb7220e37bd460f$var$defineBuiltIn$5 = $5bb7220e37bd460f$var$defineBuiltIn$6;
var $5bb7220e37bd460f$var$defineGlobalProperty = $5bb7220e37bd460f$var$defineGlobalProperty$3;
var $5bb7220e37bd460f$var$copyConstructorProperties = $5bb7220e37bd460f$var$copyConstructorProperties$1;
var $5bb7220e37bd460f$var$isForced$1 = $5bb7220e37bd460f$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $5bb7220e37bd460f$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $5bb7220e37bd460f$var$global$d;
    else if (STATIC) target = $5bb7220e37bd460f$var$global$d[TARGET] || $5bb7220e37bd460f$var$defineGlobalProperty(TARGET, {});
    else target = ($5bb7220e37bd460f$var$global$d[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $5bb7220e37bd460f$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $5bb7220e37bd460f$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $5bb7220e37bd460f$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $5bb7220e37bd460f$var$createNonEnumerableProperty$3(sourceProperty, "sham", true);
        $5bb7220e37bd460f$var$defineBuiltIn$5(target, key, sourceProperty, options);
    }
};
var $5bb7220e37bd460f$var$classof$6 = $5bb7220e37bd460f$var$classofRaw$1;
var $5bb7220e37bd460f$var$global$c = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$engineIsNode = $5bb7220e37bd460f$var$classof$6($5bb7220e37bd460f$var$global$c.process) == "process";
var $5bb7220e37bd460f$var$isCallable$a = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$$String$1 = String;
var $5bb7220e37bd460f$var$$TypeError$8 = TypeError;
var $5bb7220e37bd460f$var$aPossiblePrototype$1 = function(argument) {
    if (typeof argument == "object" || $5bb7220e37bd460f$var$isCallable$a(argument)) return argument;
    throw $5bb7220e37bd460f$var$$TypeError$8("Can't set " + $5bb7220e37bd460f$var$$String$1(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $5bb7220e37bd460f$var$uncurryThis$9 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$anObject$a = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$aPossiblePrototype = $5bb7220e37bd460f$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $5bb7220e37bd460f$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $5bb7220e37bd460f$var$uncurryThis$9(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $5bb7220e37bd460f$var$anObject$a(O);
        $5bb7220e37bd460f$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $5bb7220e37bd460f$var$defineProperty$3 = $5bb7220e37bd460f$var$objectDefineProperty.f;
var $5bb7220e37bd460f$var$hasOwn$2 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$wellKnownSymbol$f = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$TO_STRING_TAG$3 = $5bb7220e37bd460f$var$wellKnownSymbol$f("toStringTag");
var $5bb7220e37bd460f$var$setToStringTag$3 = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$5bb7220e37bd460f$var$hasOwn$2(target, $5bb7220e37bd460f$var$TO_STRING_TAG$3)) $5bb7220e37bd460f$var$defineProperty$3(target, $5bb7220e37bd460f$var$TO_STRING_TAG$3, {
        configurable: true,
        value: TAG
    });
};
var $5bb7220e37bd460f$var$getBuiltIn$4 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$definePropertyModule$2 = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$wellKnownSymbol$e = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$DESCRIPTORS$3 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$SPECIES$3 = $5bb7220e37bd460f$var$wellKnownSymbol$e("species");
var $5bb7220e37bd460f$var$setSpecies$1 = function(CONSTRUCTOR_NAME) {
    var Constructor = $5bb7220e37bd460f$var$getBuiltIn$4(CONSTRUCTOR_NAME);
    var defineProperty = $5bb7220e37bd460f$var$definePropertyModule$2.f;
    if ($5bb7220e37bd460f$var$DESCRIPTORS$3 && Constructor && !Constructor[$5bb7220e37bd460f$var$SPECIES$3]) defineProperty(Constructor, $5bb7220e37bd460f$var$SPECIES$3, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};
var $5bb7220e37bd460f$var$isPrototypeOf$1 = $5bb7220e37bd460f$var$objectIsPrototypeOf;
var $5bb7220e37bd460f$var$$TypeError$7 = TypeError;
var $5bb7220e37bd460f$var$anInstance$1 = function(it, Prototype) {
    if ($5bb7220e37bd460f$var$isPrototypeOf$1(Prototype, it)) return it;
    throw $5bb7220e37bd460f$var$$TypeError$7("Incorrect invocation");
};
var $5bb7220e37bd460f$var$wellKnownSymbol$d = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$TO_STRING_TAG$2 = $5bb7220e37bd460f$var$wellKnownSymbol$d("toStringTag");
var $5bb7220e37bd460f$var$test = {};
$5bb7220e37bd460f$var$test[$5bb7220e37bd460f$var$TO_STRING_TAG$2] = "z";
var $5bb7220e37bd460f$var$toStringTagSupport = String($5bb7220e37bd460f$var$test) === "[object z]";
var $5bb7220e37bd460f$var$TO_STRING_TAG_SUPPORT = $5bb7220e37bd460f$var$toStringTagSupport;
var $5bb7220e37bd460f$var$isCallable$9 = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$classofRaw = $5bb7220e37bd460f$var$classofRaw$1;
var $5bb7220e37bd460f$var$wellKnownSymbol$c = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$TO_STRING_TAG$1 = $5bb7220e37bd460f$var$wellKnownSymbol$c("toStringTag");
var $5bb7220e37bd460f$var$$Object$1 = Object;
// ES3 wrong here
var $5bb7220e37bd460f$var$CORRECT_ARGUMENTS = $5bb7220e37bd460f$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $5bb7220e37bd460f$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $5bb7220e37bd460f$var$classof$5 = $5bb7220e37bd460f$var$TO_STRING_TAG_SUPPORT ? $5bb7220e37bd460f$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $5bb7220e37bd460f$var$tryGet(O = $5bb7220e37bd460f$var$$Object$1(it), $5bb7220e37bd460f$var$TO_STRING_TAG$1)) == "string" ? tag : $5bb7220e37bd460f$var$CORRECT_ARGUMENTS ? $5bb7220e37bd460f$var$classofRaw(O) : (result = $5bb7220e37bd460f$var$classofRaw(O)) == "Object" && $5bb7220e37bd460f$var$isCallable$9(O.callee) ? "Arguments" : result;
};
var $5bb7220e37bd460f$var$uncurryThis$8 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$fails$b = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$isCallable$8 = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$classof$4 = $5bb7220e37bd460f$var$classof$5;
var $5bb7220e37bd460f$var$getBuiltIn$3 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$inspectSource$1 = $5bb7220e37bd460f$var$inspectSource$4;
var $5bb7220e37bd460f$var$noop = function() {};
var $5bb7220e37bd460f$var$empty = [];
var $5bb7220e37bd460f$var$construct = $5bb7220e37bd460f$var$getBuiltIn$3("Reflect", "construct");
var $5bb7220e37bd460f$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $5bb7220e37bd460f$var$exec$2 = $5bb7220e37bd460f$var$uncurryThis$8($5bb7220e37bd460f$var$constructorRegExp.exec);
var $5bb7220e37bd460f$var$INCORRECT_TO_STRING = !$5bb7220e37bd460f$var$constructorRegExp.exec($5bb7220e37bd460f$var$noop);
var $5bb7220e37bd460f$var$isConstructorModern = function isConstructor(argument) {
    if (!$5bb7220e37bd460f$var$isCallable$8(argument)) return false;
    try {
        $5bb7220e37bd460f$var$construct($5bb7220e37bd460f$var$noop, $5bb7220e37bd460f$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $5bb7220e37bd460f$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$5bb7220e37bd460f$var$isCallable$8(argument)) return false;
    switch($5bb7220e37bd460f$var$classof$4(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $5bb7220e37bd460f$var$INCORRECT_TO_STRING || !!$5bb7220e37bd460f$var$exec$2($5bb7220e37bd460f$var$constructorRegExp, $5bb7220e37bd460f$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$5bb7220e37bd460f$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $5bb7220e37bd460f$var$isConstructor$1 = !$5bb7220e37bd460f$var$construct || $5bb7220e37bd460f$var$fails$b(function() {
    var called;
    return $5bb7220e37bd460f$var$isConstructorModern($5bb7220e37bd460f$var$isConstructorModern.call) || !$5bb7220e37bd460f$var$isConstructorModern(Object) || !$5bb7220e37bd460f$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $5bb7220e37bd460f$var$isConstructorLegacy : $5bb7220e37bd460f$var$isConstructorModern;
var $5bb7220e37bd460f$var$isConstructor = $5bb7220e37bd460f$var$isConstructor$1;
var $5bb7220e37bd460f$var$tryToString$2 = $5bb7220e37bd460f$var$tryToString$4;
var $5bb7220e37bd460f$var$$TypeError$6 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $5bb7220e37bd460f$var$aConstructor$1 = function(argument) {
    if ($5bb7220e37bd460f$var$isConstructor(argument)) return argument;
    throw $5bb7220e37bd460f$var$$TypeError$6($5bb7220e37bd460f$var$tryToString$2(argument) + " is not a constructor");
};
var $5bb7220e37bd460f$var$anObject$9 = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$aConstructor = $5bb7220e37bd460f$var$aConstructor$1;
var $5bb7220e37bd460f$var$wellKnownSymbol$b = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$SPECIES$2 = $5bb7220e37bd460f$var$wellKnownSymbol$b("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $5bb7220e37bd460f$var$speciesConstructor$2 = function(O, defaultConstructor) {
    var C = $5bb7220e37bd460f$var$anObject$9(O).constructor;
    var S;
    return C === undefined || (S = $5bb7220e37bd460f$var$anObject$9(C)[$5bb7220e37bd460f$var$SPECIES$2]) == undefined ? defaultConstructor : $5bb7220e37bd460f$var$aConstructor(S);
};
var $5bb7220e37bd460f$var$NATIVE_BIND$1 = $5bb7220e37bd460f$var$functionBindNative;
var $5bb7220e37bd460f$var$FunctionPrototype = Function.prototype;
var $5bb7220e37bd460f$var$apply$2 = $5bb7220e37bd460f$var$FunctionPrototype.apply;
var $5bb7220e37bd460f$var$call$c = $5bb7220e37bd460f$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $5bb7220e37bd460f$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($5bb7220e37bd460f$var$NATIVE_BIND$1 ? $5bb7220e37bd460f$var$call$c.bind($5bb7220e37bd460f$var$apply$2) : function() {
    return $5bb7220e37bd460f$var$call$c.apply($5bb7220e37bd460f$var$apply$2, arguments);
});
var $5bb7220e37bd460f$var$uncurryThis$7 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$aCallable$6 = $5bb7220e37bd460f$var$aCallable$8;
var $5bb7220e37bd460f$var$NATIVE_BIND = $5bb7220e37bd460f$var$functionBindNative;
var $5bb7220e37bd460f$var$bind$4 = $5bb7220e37bd460f$var$uncurryThis$7($5bb7220e37bd460f$var$uncurryThis$7.bind);
// optional / simple context binding
var $5bb7220e37bd460f$var$functionBindContext = function(fn, that) {
    $5bb7220e37bd460f$var$aCallable$6(fn);
    return that === undefined ? fn : $5bb7220e37bd460f$var$NATIVE_BIND ? $5bb7220e37bd460f$var$bind$4(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $5bb7220e37bd460f$var$getBuiltIn$2 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$html$2 = $5bb7220e37bd460f$var$getBuiltIn$2("document", "documentElement");
var $5bb7220e37bd460f$var$uncurryThis$6 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$arraySlice$2 = $5bb7220e37bd460f$var$uncurryThis$6([].slice);
var $5bb7220e37bd460f$var$$TypeError$5 = TypeError;
var $5bb7220e37bd460f$var$validateArgumentsLength$1 = function(passed, required) {
    if (passed < required) throw $5bb7220e37bd460f$var$$TypeError$5("Not enough arguments");
    return passed;
};
var $5bb7220e37bd460f$var$userAgent$2 = $5bb7220e37bd460f$var$engineUserAgent;
var $5bb7220e37bd460f$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($5bb7220e37bd460f$var$userAgent$2);
var $5bb7220e37bd460f$var$global$b = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$apply$1 = $5bb7220e37bd460f$var$functionApply;
var $5bb7220e37bd460f$var$bind$3 = $5bb7220e37bd460f$var$functionBindContext;
var $5bb7220e37bd460f$var$isCallable$7 = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$hasOwn$1 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$fails$a = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$html$1 = $5bb7220e37bd460f$var$html$2;
var $5bb7220e37bd460f$var$arraySlice$1 = $5bb7220e37bd460f$var$arraySlice$2;
var $5bb7220e37bd460f$var$createElement = $5bb7220e37bd460f$var$documentCreateElement$2;
var $5bb7220e37bd460f$var$validateArgumentsLength = $5bb7220e37bd460f$var$validateArgumentsLength$1;
var $5bb7220e37bd460f$var$IS_IOS$1 = $5bb7220e37bd460f$var$engineIsIos;
var $5bb7220e37bd460f$var$IS_NODE$3 = $5bb7220e37bd460f$var$engineIsNode;
var $5bb7220e37bd460f$var$set = $5bb7220e37bd460f$var$global$b.setImmediate;
var $5bb7220e37bd460f$var$clear = $5bb7220e37bd460f$var$global$b.clearImmediate;
var $5bb7220e37bd460f$var$process$2 = $5bb7220e37bd460f$var$global$b.process;
var $5bb7220e37bd460f$var$Dispatch = $5bb7220e37bd460f$var$global$b.Dispatch;
var $5bb7220e37bd460f$var$Function$1 = $5bb7220e37bd460f$var$global$b.Function;
var $5bb7220e37bd460f$var$MessageChannel = $5bb7220e37bd460f$var$global$b.MessageChannel;
var $5bb7220e37bd460f$var$String$1 = $5bb7220e37bd460f$var$global$b.String;
var $5bb7220e37bd460f$var$counter = 0;
var $5bb7220e37bd460f$var$queue$1 = {};
var $5bb7220e37bd460f$var$ONREADYSTATECHANGE = "onreadystatechange";
var $5bb7220e37bd460f$var$location, $5bb7220e37bd460f$var$defer, $5bb7220e37bd460f$var$channel, $5bb7220e37bd460f$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $5bb7220e37bd460f$var$location = $5bb7220e37bd460f$var$global$b.location;
} catch (error) {}
var $5bb7220e37bd460f$var$run = function(id) {
    if ($5bb7220e37bd460f$var$hasOwn$1($5bb7220e37bd460f$var$queue$1, id)) {
        var fn = $5bb7220e37bd460f$var$queue$1[id];
        delete $5bb7220e37bd460f$var$queue$1[id];
        fn();
    }
};
var $5bb7220e37bd460f$var$runner = function(id) {
    return function() {
        $5bb7220e37bd460f$var$run(id);
    };
};
var $5bb7220e37bd460f$var$listener = function(event) {
    $5bb7220e37bd460f$var$run(event.data);
};
var $5bb7220e37bd460f$var$post = function(id) {
    // old engines have not location.origin
    $5bb7220e37bd460f$var$global$b.postMessage($5bb7220e37bd460f$var$String$1(id), $5bb7220e37bd460f$var$location.protocol + "//" + $5bb7220e37bd460f$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$5bb7220e37bd460f$var$set || !$5bb7220e37bd460f$var$clear) {
    $5bb7220e37bd460f$var$set = function setImmediate(handler) {
        $5bb7220e37bd460f$var$validateArgumentsLength(arguments.length, 1);
        var fn = $5bb7220e37bd460f$var$isCallable$7(handler) ? handler : $5bb7220e37bd460f$var$Function$1(handler);
        var args = $5bb7220e37bd460f$var$arraySlice$1(arguments, 1);
        $5bb7220e37bd460f$var$queue$1[++$5bb7220e37bd460f$var$counter] = function() {
            $5bb7220e37bd460f$var$apply$1(fn, undefined, args);
        };
        $5bb7220e37bd460f$var$defer($5bb7220e37bd460f$var$counter);
        return $5bb7220e37bd460f$var$counter;
    };
    $5bb7220e37bd460f$var$clear = function clearImmediate(id) {
        delete $5bb7220e37bd460f$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($5bb7220e37bd460f$var$IS_NODE$3) $5bb7220e37bd460f$var$defer = function(id) {
        $5bb7220e37bd460f$var$process$2.nextTick($5bb7220e37bd460f$var$runner(id));
    };
    else if ($5bb7220e37bd460f$var$Dispatch && $5bb7220e37bd460f$var$Dispatch.now) $5bb7220e37bd460f$var$defer = function(id) {
        $5bb7220e37bd460f$var$Dispatch.now($5bb7220e37bd460f$var$runner(id));
    };
    else if ($5bb7220e37bd460f$var$MessageChannel && !$5bb7220e37bd460f$var$IS_IOS$1) {
        $5bb7220e37bd460f$var$channel = new $5bb7220e37bd460f$var$MessageChannel();
        $5bb7220e37bd460f$var$port = $5bb7220e37bd460f$var$channel.port2;
        $5bb7220e37bd460f$var$channel.port1.onmessage = $5bb7220e37bd460f$var$listener;
        $5bb7220e37bd460f$var$defer = $5bb7220e37bd460f$var$bind$3($5bb7220e37bd460f$var$port.postMessage, $5bb7220e37bd460f$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($5bb7220e37bd460f$var$global$b.addEventListener && $5bb7220e37bd460f$var$isCallable$7($5bb7220e37bd460f$var$global$b.postMessage) && !$5bb7220e37bd460f$var$global$b.importScripts && $5bb7220e37bd460f$var$location && $5bb7220e37bd460f$var$location.protocol !== "file:" && !$5bb7220e37bd460f$var$fails$a($5bb7220e37bd460f$var$post)) {
        $5bb7220e37bd460f$var$defer = $5bb7220e37bd460f$var$post;
        $5bb7220e37bd460f$var$global$b.addEventListener("message", $5bb7220e37bd460f$var$listener, false);
    // IE8-
    } else if ($5bb7220e37bd460f$var$ONREADYSTATECHANGE in $5bb7220e37bd460f$var$createElement("script")) $5bb7220e37bd460f$var$defer = function(id) {
        $5bb7220e37bd460f$var$html$1.appendChild($5bb7220e37bd460f$var$createElement("script"))[$5bb7220e37bd460f$var$ONREADYSTATECHANGE] = function() {
            $5bb7220e37bd460f$var$html$1.removeChild(this);
            $5bb7220e37bd460f$var$run(id);
        };
    };
    else $5bb7220e37bd460f$var$defer = function(id) {
        setTimeout($5bb7220e37bd460f$var$runner(id), 0);
    };
}
var $5bb7220e37bd460f$var$task$1 = {
    set: $5bb7220e37bd460f$var$set,
    clear: $5bb7220e37bd460f$var$clear
};
var $5bb7220e37bd460f$var$userAgent$1 = $5bb7220e37bd460f$var$engineUserAgent;
var $5bb7220e37bd460f$var$global$a = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($5bb7220e37bd460f$var$userAgent$1) && $5bb7220e37bd460f$var$global$a.Pebble !== undefined;
var $5bb7220e37bd460f$var$userAgent = $5bb7220e37bd460f$var$engineUserAgent;
var $5bb7220e37bd460f$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($5bb7220e37bd460f$var$userAgent);
var $5bb7220e37bd460f$var$global$9 = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$bind$2 = $5bb7220e37bd460f$var$functionBindContext;
var $5bb7220e37bd460f$var$getOwnPropertyDescriptor = $5bb7220e37bd460f$var$objectGetOwnPropertyDescriptor.f;
var $5bb7220e37bd460f$var$macrotask = $5bb7220e37bd460f$var$task$1.set;
var $5bb7220e37bd460f$var$IS_IOS = $5bb7220e37bd460f$var$engineIsIos;
var $5bb7220e37bd460f$var$IS_IOS_PEBBLE = $5bb7220e37bd460f$var$engineIsIosPebble;
var $5bb7220e37bd460f$var$IS_WEBOS_WEBKIT = $5bb7220e37bd460f$var$engineIsWebosWebkit;
var $5bb7220e37bd460f$var$IS_NODE$2 = $5bb7220e37bd460f$var$engineIsNode;
var $5bb7220e37bd460f$var$MutationObserver = $5bb7220e37bd460f$var$global$9.MutationObserver || $5bb7220e37bd460f$var$global$9.WebKitMutationObserver;
var $5bb7220e37bd460f$var$document$2 = $5bb7220e37bd460f$var$global$9.document;
var $5bb7220e37bd460f$var$process$1 = $5bb7220e37bd460f$var$global$9.process;
var $5bb7220e37bd460f$var$Promise$1 = $5bb7220e37bd460f$var$global$9.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $5bb7220e37bd460f$var$queueMicrotaskDescriptor = $5bb7220e37bd460f$var$getOwnPropertyDescriptor($5bb7220e37bd460f$var$global$9, "queueMicrotask");
var $5bb7220e37bd460f$var$queueMicrotask = $5bb7220e37bd460f$var$queueMicrotaskDescriptor && $5bb7220e37bd460f$var$queueMicrotaskDescriptor.value;
var $5bb7220e37bd460f$var$flush, $5bb7220e37bd460f$var$head, $5bb7220e37bd460f$var$last, $5bb7220e37bd460f$var$notify$1, $5bb7220e37bd460f$var$toggle, $5bb7220e37bd460f$var$node, $5bb7220e37bd460f$var$promise, $5bb7220e37bd460f$var$then;
// modern engines have queueMicrotask method
if (!$5bb7220e37bd460f$var$queueMicrotask) {
    $5bb7220e37bd460f$var$flush = function() {
        var parent, fn;
        if ($5bb7220e37bd460f$var$IS_NODE$2 && (parent = $5bb7220e37bd460f$var$process$1.domain)) parent.exit();
        while($5bb7220e37bd460f$var$head){
            fn = $5bb7220e37bd460f$var$head.fn;
            $5bb7220e37bd460f$var$head = $5bb7220e37bd460f$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($5bb7220e37bd460f$var$head) $5bb7220e37bd460f$var$notify$1();
                else $5bb7220e37bd460f$var$last = undefined;
                throw error;
            }
        }
        $5bb7220e37bd460f$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$5bb7220e37bd460f$var$IS_IOS && !$5bb7220e37bd460f$var$IS_NODE$2 && !$5bb7220e37bd460f$var$IS_WEBOS_WEBKIT && $5bb7220e37bd460f$var$MutationObserver && $5bb7220e37bd460f$var$document$2) {
        $5bb7220e37bd460f$var$toggle = true;
        $5bb7220e37bd460f$var$node = $5bb7220e37bd460f$var$document$2.createTextNode("");
        new $5bb7220e37bd460f$var$MutationObserver($5bb7220e37bd460f$var$flush).observe($5bb7220e37bd460f$var$node, {
            characterData: true
        });
        $5bb7220e37bd460f$var$notify$1 = function() {
            $5bb7220e37bd460f$var$node.data = $5bb7220e37bd460f$var$toggle = !$5bb7220e37bd460f$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$5bb7220e37bd460f$var$IS_IOS_PEBBLE && $5bb7220e37bd460f$var$Promise$1 && $5bb7220e37bd460f$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $5bb7220e37bd460f$var$promise = $5bb7220e37bd460f$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $5bb7220e37bd460f$var$promise.constructor = $5bb7220e37bd460f$var$Promise$1;
        $5bb7220e37bd460f$var$then = $5bb7220e37bd460f$var$bind$2($5bb7220e37bd460f$var$promise.then, $5bb7220e37bd460f$var$promise);
        $5bb7220e37bd460f$var$notify$1 = function() {
            $5bb7220e37bd460f$var$then($5bb7220e37bd460f$var$flush);
        };
    // Node.js without promises
    } else if ($5bb7220e37bd460f$var$IS_NODE$2) $5bb7220e37bd460f$var$notify$1 = function() {
        $5bb7220e37bd460f$var$process$1.nextTick($5bb7220e37bd460f$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $5bb7220e37bd460f$var$macrotask = $5bb7220e37bd460f$var$bind$2($5bb7220e37bd460f$var$macrotask, $5bb7220e37bd460f$var$global$9);
        $5bb7220e37bd460f$var$notify$1 = function() {
            $5bb7220e37bd460f$var$macrotask($5bb7220e37bd460f$var$flush);
        };
    }
}
var $5bb7220e37bd460f$var$microtask$1 = $5bb7220e37bd460f$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($5bb7220e37bd460f$var$last) $5bb7220e37bd460f$var$last.next = task;
    if (!$5bb7220e37bd460f$var$head) {
        $5bb7220e37bd460f$var$head = task;
        $5bb7220e37bd460f$var$notify$1();
    }
    $5bb7220e37bd460f$var$last = task;
};
var $5bb7220e37bd460f$var$global$8 = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$hostReportErrors$1 = function(a, b) {
    var console1 = $5bb7220e37bd460f$var$global$8.console;
    if (console1 && console1.error) arguments.length == 1 ? console1.error(a) : console1.error(a, b);
};
var $5bb7220e37bd460f$var$perform$3 = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $5bb7220e37bd460f$var$Queue$1 = function() {
    this.head = null;
    this.tail = null;
};
$5bb7220e37bd460f$var$Queue$1.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $5bb7220e37bd460f$var$queue = $5bb7220e37bd460f$var$Queue$1;
var $5bb7220e37bd460f$var$global$7 = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$promiseNativeConstructor = $5bb7220e37bd460f$var$global$7.Promise;
var $5bb7220e37bd460f$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $5bb7220e37bd460f$var$global$6 = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$NativePromiseConstructor$3 = $5bb7220e37bd460f$var$promiseNativeConstructor;
var $5bb7220e37bd460f$var$isCallable$6 = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$isForced = $5bb7220e37bd460f$var$isForced_1;
var $5bb7220e37bd460f$var$inspectSource = $5bb7220e37bd460f$var$inspectSource$4;
var $5bb7220e37bd460f$var$wellKnownSymbol$a = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$IS_BROWSER = $5bb7220e37bd460f$var$engineIsBrowser;
var $5bb7220e37bd460f$var$V8_VERSION = $5bb7220e37bd460f$var$engineV8Version;
$5bb7220e37bd460f$var$NativePromiseConstructor$3 && $5bb7220e37bd460f$var$NativePromiseConstructor$3.prototype;
var $5bb7220e37bd460f$var$SPECIES$1 = $5bb7220e37bd460f$var$wellKnownSymbol$a("species");
var $5bb7220e37bd460f$var$SUBCLASSING = false;
var $5bb7220e37bd460f$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $5bb7220e37bd460f$var$isCallable$6($5bb7220e37bd460f$var$global$6.PromiseRejectionEvent);
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$5 = $5bb7220e37bd460f$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $5bb7220e37bd460f$var$inspectSource($5bb7220e37bd460f$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($5bb7220e37bd460f$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $5bb7220e37bd460f$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($5bb7220e37bd460f$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $5bb7220e37bd460f$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$5bb7220e37bd460f$var$SPECIES$1] = FakePromise;
    $5bb7220e37bd460f$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$5bb7220e37bd460f$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $5bb7220e37bd460f$var$IS_BROWSER && !$5bb7220e37bd460f$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $5bb7220e37bd460f$var$promiseConstructorDetection = {
    CONSTRUCTOR: $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $5bb7220e37bd460f$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $5bb7220e37bd460f$var$SUBCLASSING
};
var $5bb7220e37bd460f$var$newPromiseCapability$2 = {};
var $5bb7220e37bd460f$var$aCallable$5 = $5bb7220e37bd460f$var$aCallable$8;
var $5bb7220e37bd460f$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $5bb7220e37bd460f$var$aCallable$5(resolve);
    this.reject = $5bb7220e37bd460f$var$aCallable$5(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$5bb7220e37bd460f$var$newPromiseCapability$2.f = function(C) {
    return new $5bb7220e37bd460f$var$PromiseCapability(C);
};
var $5bb7220e37bd460f$var$$$b = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$IS_NODE$1 = $5bb7220e37bd460f$var$engineIsNode;
var $5bb7220e37bd460f$var$global$5 = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$call$b = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$defineBuiltIn$4 = $5bb7220e37bd460f$var$defineBuiltIn$6;
var $5bb7220e37bd460f$var$setPrototypeOf$1 = $5bb7220e37bd460f$var$objectSetPrototypeOf;
var $5bb7220e37bd460f$var$setToStringTag$2 = $5bb7220e37bd460f$var$setToStringTag$3;
var $5bb7220e37bd460f$var$setSpecies = $5bb7220e37bd460f$var$setSpecies$1;
var $5bb7220e37bd460f$var$aCallable$4 = $5bb7220e37bd460f$var$aCallable$8;
var $5bb7220e37bd460f$var$isCallable$5 = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$isObject$2 = $5bb7220e37bd460f$var$isObject$8;
var $5bb7220e37bd460f$var$anInstance = $5bb7220e37bd460f$var$anInstance$1;
var $5bb7220e37bd460f$var$speciesConstructor$1 = $5bb7220e37bd460f$var$speciesConstructor$2;
var $5bb7220e37bd460f$var$task = $5bb7220e37bd460f$var$task$1.set;
var $5bb7220e37bd460f$var$microtask = $5bb7220e37bd460f$var$microtask$1;
var $5bb7220e37bd460f$var$hostReportErrors = $5bb7220e37bd460f$var$hostReportErrors$1;
var $5bb7220e37bd460f$var$perform$2 = $5bb7220e37bd460f$var$perform$3;
var $5bb7220e37bd460f$var$Queue = $5bb7220e37bd460f$var$queue;
var $5bb7220e37bd460f$var$InternalStateModule$1 = $5bb7220e37bd460f$var$internalState;
var $5bb7220e37bd460f$var$NativePromiseConstructor$2 = $5bb7220e37bd460f$var$promiseNativeConstructor;
var $5bb7220e37bd460f$var$PromiseConstructorDetection = $5bb7220e37bd460f$var$promiseConstructorDetection;
var $5bb7220e37bd460f$var$newPromiseCapabilityModule$3 = $5bb7220e37bd460f$var$newPromiseCapability$2;
var $5bb7220e37bd460f$var$PROMISE = "Promise";
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$4 = $5bb7220e37bd460f$var$PromiseConstructorDetection.CONSTRUCTOR;
var $5bb7220e37bd460f$var$NATIVE_PROMISE_REJECTION_EVENT = $5bb7220e37bd460f$var$PromiseConstructorDetection.REJECTION_EVENT;
var $5bb7220e37bd460f$var$NATIVE_PROMISE_SUBCLASSING = $5bb7220e37bd460f$var$PromiseConstructorDetection.SUBCLASSING;
var $5bb7220e37bd460f$var$getInternalPromiseState = $5bb7220e37bd460f$var$InternalStateModule$1.getterFor($5bb7220e37bd460f$var$PROMISE);
var $5bb7220e37bd460f$var$setInternalState$1 = $5bb7220e37bd460f$var$InternalStateModule$1.set;
var $5bb7220e37bd460f$var$NativePromisePrototype$1 = $5bb7220e37bd460f$var$NativePromiseConstructor$2 && $5bb7220e37bd460f$var$NativePromiseConstructor$2.prototype;
var $5bb7220e37bd460f$var$PromiseConstructor = $5bb7220e37bd460f$var$NativePromiseConstructor$2;
var $5bb7220e37bd460f$var$PromisePrototype = $5bb7220e37bd460f$var$NativePromisePrototype$1;
var $5bb7220e37bd460f$var$TypeError$1 = $5bb7220e37bd460f$var$global$5.TypeError;
var $5bb7220e37bd460f$var$document$1 = $5bb7220e37bd460f$var$global$5.document;
var $5bb7220e37bd460f$var$process = $5bb7220e37bd460f$var$global$5.process;
var $5bb7220e37bd460f$var$newPromiseCapability$1 = $5bb7220e37bd460f$var$newPromiseCapabilityModule$3.f;
var $5bb7220e37bd460f$var$newGenericPromiseCapability = $5bb7220e37bd460f$var$newPromiseCapability$1;
var $5bb7220e37bd460f$var$DISPATCH_EVENT = !!($5bb7220e37bd460f$var$document$1 && $5bb7220e37bd460f$var$document$1.createEvent && $5bb7220e37bd460f$var$global$5.dispatchEvent);
var $5bb7220e37bd460f$var$UNHANDLED_REJECTION = "unhandledrejection";
var $5bb7220e37bd460f$var$REJECTION_HANDLED = "rejectionhandled";
var $5bb7220e37bd460f$var$PENDING = 0;
var $5bb7220e37bd460f$var$FULFILLED = 1;
var $5bb7220e37bd460f$var$REJECTED = 2;
var $5bb7220e37bd460f$var$HANDLED = 1;
var $5bb7220e37bd460f$var$UNHANDLED = 2;
var $5bb7220e37bd460f$var$Internal, $5bb7220e37bd460f$var$OwnPromiseCapability, $5bb7220e37bd460f$var$PromiseWrapper, $5bb7220e37bd460f$var$nativeThen;
// helpers
var $5bb7220e37bd460f$var$isThenable = function(it) {
    var then;
    return $5bb7220e37bd460f$var$isObject$2(it) && $5bb7220e37bd460f$var$isCallable$5(then = it.then) ? then : false;
};
var $5bb7220e37bd460f$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $5bb7220e37bd460f$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $5bb7220e37bd460f$var$UNHANDLED) $5bb7220e37bd460f$var$onHandleUnhandled(state);
                state.rejection = $5bb7220e37bd460f$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($5bb7220e37bd460f$var$TypeError$1("Promise-chain cycle"));
            else if (then = $5bb7220e37bd460f$var$isThenable(result)) $5bb7220e37bd460f$var$call$b(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $5bb7220e37bd460f$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $5bb7220e37bd460f$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$5bb7220e37bd460f$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $5bb7220e37bd460f$var$onUnhandled(state);
    });
};
var $5bb7220e37bd460f$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($5bb7220e37bd460f$var$DISPATCH_EVENT) {
        event = $5bb7220e37bd460f$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $5bb7220e37bd460f$var$global$5.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$5bb7220e37bd460f$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $5bb7220e37bd460f$var$global$5["on" + name])) handler(event);
    else if (name === $5bb7220e37bd460f$var$UNHANDLED_REJECTION) $5bb7220e37bd460f$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $5bb7220e37bd460f$var$onUnhandled = function(state) {
    $5bb7220e37bd460f$var$call$b($5bb7220e37bd460f$var$task, $5bb7220e37bd460f$var$global$5, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $5bb7220e37bd460f$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $5bb7220e37bd460f$var$perform$2(function() {
                if ($5bb7220e37bd460f$var$IS_NODE$1) $5bb7220e37bd460f$var$process.emit("unhandledRejection", value, promise);
                else $5bb7220e37bd460f$var$dispatchEvent($5bb7220e37bd460f$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $5bb7220e37bd460f$var$IS_NODE$1 || $5bb7220e37bd460f$var$isUnhandled(state) ? $5bb7220e37bd460f$var$UNHANDLED : $5bb7220e37bd460f$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $5bb7220e37bd460f$var$isUnhandled = function(state) {
    return state.rejection !== $5bb7220e37bd460f$var$HANDLED && !state.parent;
};
var $5bb7220e37bd460f$var$onHandleUnhandled = function(state) {
    $5bb7220e37bd460f$var$call$b($5bb7220e37bd460f$var$task, $5bb7220e37bd460f$var$global$5, function() {
        var promise = state.facade;
        if ($5bb7220e37bd460f$var$IS_NODE$1) $5bb7220e37bd460f$var$process.emit("rejectionHandled", promise);
        else $5bb7220e37bd460f$var$dispatchEvent($5bb7220e37bd460f$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $5bb7220e37bd460f$var$bind$1 = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $5bb7220e37bd460f$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $5bb7220e37bd460f$var$REJECTED;
    $5bb7220e37bd460f$var$notify(state, true);
};
var $5bb7220e37bd460f$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $5bb7220e37bd460f$var$TypeError$1("Promise can't be resolved itself");
        var then = $5bb7220e37bd460f$var$isThenable(value);
        if (then) $5bb7220e37bd460f$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $5bb7220e37bd460f$var$call$b(then, value, $5bb7220e37bd460f$var$bind$1($5bb7220e37bd460f$var$internalResolve, wrapper, state), $5bb7220e37bd460f$var$bind$1($5bb7220e37bd460f$var$internalReject, wrapper, state));
            } catch (error) {
                $5bb7220e37bd460f$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $5bb7220e37bd460f$var$FULFILLED;
            $5bb7220e37bd460f$var$notify(state, false);
        }
    } catch (error) {
        $5bb7220e37bd460f$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $5bb7220e37bd460f$var$PromiseConstructor = function Promise1(executor) {
        $5bb7220e37bd460f$var$anInstance(this, $5bb7220e37bd460f$var$PromisePrototype);
        $5bb7220e37bd460f$var$aCallable$4(executor);
        $5bb7220e37bd460f$var$call$b($5bb7220e37bd460f$var$Internal, this);
        var state = $5bb7220e37bd460f$var$getInternalPromiseState(this);
        try {
            executor($5bb7220e37bd460f$var$bind$1($5bb7220e37bd460f$var$internalResolve, state), $5bb7220e37bd460f$var$bind$1($5bb7220e37bd460f$var$internalReject, state));
        } catch (error) {
            $5bb7220e37bd460f$var$internalReject(state, error);
        }
    };
    $5bb7220e37bd460f$var$PromisePrototype = $5bb7220e37bd460f$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $5bb7220e37bd460f$var$Internal = function Promise1(executor) {
        $5bb7220e37bd460f$var$setInternalState$1(this, {
            type: $5bb7220e37bd460f$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $5bb7220e37bd460f$var$Queue(),
            rejection: false,
            state: $5bb7220e37bd460f$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $5bb7220e37bd460f$var$Internal.prototype = $5bb7220e37bd460f$var$defineBuiltIn$4($5bb7220e37bd460f$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $5bb7220e37bd460f$var$getInternalPromiseState(this);
        var reaction = $5bb7220e37bd460f$var$newPromiseCapability$1($5bb7220e37bd460f$var$speciesConstructor$1(this, $5bb7220e37bd460f$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $5bb7220e37bd460f$var$isCallable$5(onFulfilled) ? onFulfilled : true;
        reaction.fail = $5bb7220e37bd460f$var$isCallable$5(onRejected) && onRejected;
        reaction.domain = $5bb7220e37bd460f$var$IS_NODE$1 ? $5bb7220e37bd460f$var$process.domain : undefined;
        if (state.state == $5bb7220e37bd460f$var$PENDING) state.reactions.add(reaction);
        else $5bb7220e37bd460f$var$microtask(function() {
            $5bb7220e37bd460f$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $5bb7220e37bd460f$var$OwnPromiseCapability = function() {
        var promise = new $5bb7220e37bd460f$var$Internal();
        var state = $5bb7220e37bd460f$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $5bb7220e37bd460f$var$bind$1($5bb7220e37bd460f$var$internalResolve, state);
        this.reject = $5bb7220e37bd460f$var$bind$1($5bb7220e37bd460f$var$internalReject, state);
    };
    $5bb7220e37bd460f$var$newPromiseCapabilityModule$3.f = $5bb7220e37bd460f$var$newPromiseCapability$1 = function(C) {
        return C === $5bb7220e37bd460f$var$PromiseConstructor || C === $5bb7220e37bd460f$var$PromiseWrapper ? new $5bb7220e37bd460f$var$OwnPromiseCapability(C) : $5bb7220e37bd460f$var$newGenericPromiseCapability(C);
    };
    if ($5bb7220e37bd460f$var$isCallable$5($5bb7220e37bd460f$var$NativePromiseConstructor$2) && $5bb7220e37bd460f$var$NativePromisePrototype$1 !== Object.prototype) {
        $5bb7220e37bd460f$var$nativeThen = $5bb7220e37bd460f$var$NativePromisePrototype$1.then;
        if (!$5bb7220e37bd460f$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $5bb7220e37bd460f$var$defineBuiltIn$4($5bb7220e37bd460f$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $5bb7220e37bd460f$var$PromiseConstructor(function(resolve, reject) {
                $5bb7220e37bd460f$var$call$b($5bb7220e37bd460f$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $5bb7220e37bd460f$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($5bb7220e37bd460f$var$setPrototypeOf$1) $5bb7220e37bd460f$var$setPrototypeOf$1($5bb7220e37bd460f$var$NativePromisePrototype$1, $5bb7220e37bd460f$var$PromisePrototype);
    }
}
$5bb7220e37bd460f$var$$$b({
    global: true,
    constructor: true,
    wrap: true,
    forced: $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $5bb7220e37bd460f$var$PromiseConstructor
});
$5bb7220e37bd460f$var$setToStringTag$2($5bb7220e37bd460f$var$PromiseConstructor, $5bb7220e37bd460f$var$PROMISE, false);
$5bb7220e37bd460f$var$setSpecies($5bb7220e37bd460f$var$PROMISE);
var $5bb7220e37bd460f$var$iterators = {};
var $5bb7220e37bd460f$var$wellKnownSymbol$9 = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$Iterators$4 = $5bb7220e37bd460f$var$iterators;
var $5bb7220e37bd460f$var$ITERATOR$5 = $5bb7220e37bd460f$var$wellKnownSymbol$9("iterator");
var $5bb7220e37bd460f$var$ArrayPrototype$1 = Array.prototype;
// check on default Array iterator
var $5bb7220e37bd460f$var$isArrayIteratorMethod$1 = function(it) {
    return it !== undefined && ($5bb7220e37bd460f$var$Iterators$4.Array === it || $5bb7220e37bd460f$var$ArrayPrototype$1[$5bb7220e37bd460f$var$ITERATOR$5] === it);
};
var $5bb7220e37bd460f$var$classof$3 = $5bb7220e37bd460f$var$classof$5;
var $5bb7220e37bd460f$var$getMethod$2 = $5bb7220e37bd460f$var$getMethod$4;
var $5bb7220e37bd460f$var$Iterators$3 = $5bb7220e37bd460f$var$iterators;
var $5bb7220e37bd460f$var$wellKnownSymbol$8 = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$ITERATOR$4 = $5bb7220e37bd460f$var$wellKnownSymbol$8("iterator");
var $5bb7220e37bd460f$var$getIteratorMethod$2 = function(it) {
    if (it != undefined) return $5bb7220e37bd460f$var$getMethod$2(it, $5bb7220e37bd460f$var$ITERATOR$4) || $5bb7220e37bd460f$var$getMethod$2(it, "@@iterator") || $5bb7220e37bd460f$var$Iterators$3[$5bb7220e37bd460f$var$classof$3(it)];
};
var $5bb7220e37bd460f$var$call$a = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$aCallable$3 = $5bb7220e37bd460f$var$aCallable$8;
var $5bb7220e37bd460f$var$anObject$8 = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$tryToString$1 = $5bb7220e37bd460f$var$tryToString$4;
var $5bb7220e37bd460f$var$getIteratorMethod$1 = $5bb7220e37bd460f$var$getIteratorMethod$2;
var $5bb7220e37bd460f$var$$TypeError$4 = TypeError;
var $5bb7220e37bd460f$var$getIterator$1 = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $5bb7220e37bd460f$var$getIteratorMethod$1(argument) : usingIterator;
    if ($5bb7220e37bd460f$var$aCallable$3(iteratorMethod)) return $5bb7220e37bd460f$var$anObject$8($5bb7220e37bd460f$var$call$a(iteratorMethod, argument));
    throw $5bb7220e37bd460f$var$$TypeError$4($5bb7220e37bd460f$var$tryToString$1(argument) + " is not iterable");
};
var $5bb7220e37bd460f$var$call$9 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$anObject$7 = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$getMethod$1 = $5bb7220e37bd460f$var$getMethod$4;
var $5bb7220e37bd460f$var$iteratorClose$1 = function(iterator, kind, value) {
    var innerResult, innerError;
    $5bb7220e37bd460f$var$anObject$7(iterator);
    try {
        innerResult = $5bb7220e37bd460f$var$getMethod$1(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $5bb7220e37bd460f$var$call$9(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $5bb7220e37bd460f$var$anObject$7(innerResult);
    return value;
};
var $5bb7220e37bd460f$var$bind = $5bb7220e37bd460f$var$functionBindContext;
var $5bb7220e37bd460f$var$call$8 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$anObject$6 = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$tryToString = $5bb7220e37bd460f$var$tryToString$4;
var $5bb7220e37bd460f$var$isArrayIteratorMethod = $5bb7220e37bd460f$var$isArrayIteratorMethod$1;
var $5bb7220e37bd460f$var$lengthOfArrayLike$2 = $5bb7220e37bd460f$var$lengthOfArrayLike$4;
var $5bb7220e37bd460f$var$isPrototypeOf = $5bb7220e37bd460f$var$objectIsPrototypeOf;
var $5bb7220e37bd460f$var$getIterator = $5bb7220e37bd460f$var$getIterator$1;
var $5bb7220e37bd460f$var$getIteratorMethod = $5bb7220e37bd460f$var$getIteratorMethod$2;
var $5bb7220e37bd460f$var$iteratorClose = $5bb7220e37bd460f$var$iteratorClose$1;
var $5bb7220e37bd460f$var$$TypeError$3 = TypeError;
var $5bb7220e37bd460f$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $5bb7220e37bd460f$var$ResultPrototype = $5bb7220e37bd460f$var$Result.prototype;
var $5bb7220e37bd460f$var$iterate$2 = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $5bb7220e37bd460f$var$bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $5bb7220e37bd460f$var$iteratorClose(iterator, "normal", condition);
        return new $5bb7220e37bd460f$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $5bb7220e37bd460f$var$anObject$6(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $5bb7220e37bd460f$var$getIteratorMethod(iterable);
        if (!iterFn) throw $5bb7220e37bd460f$var$$TypeError$3($5bb7220e37bd460f$var$tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($5bb7220e37bd460f$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = $5bb7220e37bd460f$var$lengthOfArrayLike$2(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $5bb7220e37bd460f$var$isPrototypeOf($5bb7220e37bd460f$var$ResultPrototype, result)) return result;
            }
            return new $5bb7220e37bd460f$var$Result(false);
        }
        iterator = $5bb7220e37bd460f$var$getIterator(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $5bb7220e37bd460f$var$call$8(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $5bb7220e37bd460f$var$iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $5bb7220e37bd460f$var$isPrototypeOf($5bb7220e37bd460f$var$ResultPrototype, result)) return result;
    }
    return new $5bb7220e37bd460f$var$Result(false);
};
var $5bb7220e37bd460f$var$wellKnownSymbol$7 = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$ITERATOR$3 = $5bb7220e37bd460f$var$wellKnownSymbol$7("iterator");
var $5bb7220e37bd460f$var$SAFE_CLOSING = false;
try {
    var $5bb7220e37bd460f$var$called = 0;
    var $5bb7220e37bd460f$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$5bb7220e37bd460f$var$called++
            };
        },
        "return": function() {
            $5bb7220e37bd460f$var$SAFE_CLOSING = true;
        }
    };
    $5bb7220e37bd460f$var$iteratorWithReturn[$5bb7220e37bd460f$var$ITERATOR$3] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($5bb7220e37bd460f$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $5bb7220e37bd460f$var$checkCorrectnessOfIteration$1 = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$5bb7220e37bd460f$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$5bb7220e37bd460f$var$ITERATOR$3] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $5bb7220e37bd460f$var$NativePromiseConstructor$1 = $5bb7220e37bd460f$var$promiseNativeConstructor;
var $5bb7220e37bd460f$var$checkCorrectnessOfIteration = $5bb7220e37bd460f$var$checkCorrectnessOfIteration$1;
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$3 = $5bb7220e37bd460f$var$promiseConstructorDetection.CONSTRUCTOR;
var $5bb7220e37bd460f$var$promiseStaticsIncorrectIteration = $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$5bb7220e37bd460f$var$checkCorrectnessOfIteration(function(iterable) {
    $5bb7220e37bd460f$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $5bb7220e37bd460f$var$$$a = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$call$7 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$aCallable$2 = $5bb7220e37bd460f$var$aCallable$8;
var $5bb7220e37bd460f$var$newPromiseCapabilityModule$2 = $5bb7220e37bd460f$var$newPromiseCapability$2;
var $5bb7220e37bd460f$var$perform$1 = $5bb7220e37bd460f$var$perform$3;
var $5bb7220e37bd460f$var$iterate$1 = $5bb7220e37bd460f$var$iterate$2;
var $5bb7220e37bd460f$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $5bb7220e37bd460f$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$5bb7220e37bd460f$var$$$a({
    target: "Promise",
    stat: true,
    forced: $5bb7220e37bd460f$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $5bb7220e37bd460f$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $5bb7220e37bd460f$var$perform$1(function() {
            var $promiseResolve = $5bb7220e37bd460f$var$aCallable$2(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $5bb7220e37bd460f$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $5bb7220e37bd460f$var$call$7($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $5bb7220e37bd460f$var$$$9 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$2 = $5bb7220e37bd460f$var$promiseConstructorDetection.CONSTRUCTOR;
var $5bb7220e37bd460f$var$NativePromiseConstructor = $5bb7220e37bd460f$var$promiseNativeConstructor;
var $5bb7220e37bd460f$var$getBuiltIn$1 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$isCallable$4 = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$defineBuiltIn$3 = $5bb7220e37bd460f$var$defineBuiltIn$6;
var $5bb7220e37bd460f$var$NativePromisePrototype = $5bb7220e37bd460f$var$NativePromiseConstructor && $5bb7220e37bd460f$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$5bb7220e37bd460f$var$$$9({
    target: "Promise",
    proto: true,
    forced: $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($5bb7220e37bd460f$var$isCallable$4($5bb7220e37bd460f$var$NativePromiseConstructor)) {
    var $5bb7220e37bd460f$var$method = $5bb7220e37bd460f$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($5bb7220e37bd460f$var$NativePromisePrototype["catch"] !== $5bb7220e37bd460f$var$method) $5bb7220e37bd460f$var$defineBuiltIn$3($5bb7220e37bd460f$var$NativePromisePrototype, "catch", $5bb7220e37bd460f$var$method, {
        unsafe: true
    });
}
var $5bb7220e37bd460f$var$$$8 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$call$6 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$aCallable$1 = $5bb7220e37bd460f$var$aCallable$8;
var $5bb7220e37bd460f$var$newPromiseCapabilityModule$1 = $5bb7220e37bd460f$var$newPromiseCapability$2;
var $5bb7220e37bd460f$var$perform = $5bb7220e37bd460f$var$perform$3;
var $5bb7220e37bd460f$var$iterate = $5bb7220e37bd460f$var$iterate$2;
var $5bb7220e37bd460f$var$PROMISE_STATICS_INCORRECT_ITERATION = $5bb7220e37bd460f$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$5bb7220e37bd460f$var$$$8({
    target: "Promise",
    stat: true,
    forced: $5bb7220e37bd460f$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $5bb7220e37bd460f$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $5bb7220e37bd460f$var$perform(function() {
            var $promiseResolve = $5bb7220e37bd460f$var$aCallable$1(C.resolve);
            $5bb7220e37bd460f$var$iterate(iterable, function(promise) {
                $5bb7220e37bd460f$var$call$6($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $5bb7220e37bd460f$var$$$7 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$call$5 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$newPromiseCapabilityModule = $5bb7220e37bd460f$var$newPromiseCapability$2;
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$1 = $5bb7220e37bd460f$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$5bb7220e37bd460f$var$$$7({
    target: "Promise",
    stat: true,
    forced: $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $5bb7220e37bd460f$var$newPromiseCapabilityModule.f(this);
        $5bb7220e37bd460f$var$call$5(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $5bb7220e37bd460f$var$anObject$5 = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$isObject$1 = $5bb7220e37bd460f$var$isObject$8;
var $5bb7220e37bd460f$var$newPromiseCapability = $5bb7220e37bd460f$var$newPromiseCapability$2;
var $5bb7220e37bd460f$var$promiseResolve$1 = function(C, x) {
    $5bb7220e37bd460f$var$anObject$5(C);
    if ($5bb7220e37bd460f$var$isObject$1(x) && x.constructor === C) return x;
    var promiseCapability = $5bb7220e37bd460f$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $5bb7220e37bd460f$var$$$6 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$getBuiltIn = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR = $5bb7220e37bd460f$var$promiseConstructorDetection.CONSTRUCTOR;
var $5bb7220e37bd460f$var$promiseResolve = $5bb7220e37bd460f$var$promiseResolve$1;
$5bb7220e37bd460f$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$5bb7220e37bd460f$var$$$6({
    target: "Promise",
    stat: true,
    forced: $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $5bb7220e37bd460f$var$promiseResolve(this, x);
    }
});
class $5bb7220e37bd460f$var$WebStorageService {
    getItem(key) {
        return new Promise((resolve)=>{
            const value = localStorage.getItem(key);
            resolve(value);
        });
    }
    setItem(key, value) {
        return new Promise((resolve)=>{
            localStorage.setItem(key, value);
            resolve();
        });
    }
    removeItem(key) {
        return new Promise((resolve)=>{
            localStorage.removeItem(key);
            resolve();
        });
    }
}
var $5bb7220e37bd460f$var$objectDefineProperties = {};
var $5bb7220e37bd460f$var$internalObjectKeys = $5bb7220e37bd460f$var$objectKeysInternal;
var $5bb7220e37bd460f$var$enumBugKeys$1 = $5bb7220e37bd460f$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $5bb7220e37bd460f$var$objectKeys$2 = Object.keys || function keys(O) {
    return $5bb7220e37bd460f$var$internalObjectKeys(O, $5bb7220e37bd460f$var$enumBugKeys$1);
};
var $5bb7220e37bd460f$var$DESCRIPTORS$2 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$V8_PROTOTYPE_DEFINE_BUG = $5bb7220e37bd460f$var$v8PrototypeDefineBug;
var $5bb7220e37bd460f$var$definePropertyModule$1 = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$anObject$4 = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$toIndexedObject$1 = $5bb7220e37bd460f$var$toIndexedObject$5;
var $5bb7220e37bd460f$var$objectKeys$1 = $5bb7220e37bd460f$var$objectKeys$2;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$5bb7220e37bd460f$var$objectDefineProperties.f = $5bb7220e37bd460f$var$DESCRIPTORS$2 && !$5bb7220e37bd460f$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $5bb7220e37bd460f$var$anObject$4(O);
    var props = $5bb7220e37bd460f$var$toIndexedObject$1(Properties);
    var keys = $5bb7220e37bd460f$var$objectKeys$1(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$5bb7220e37bd460f$var$definePropertyModule$1.f(O, key = keys[index++], props[key]);
    return O;
};
/* global ActiveXObject -- old IE, WSH */ var $5bb7220e37bd460f$var$anObject$3 = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$definePropertiesModule = $5bb7220e37bd460f$var$objectDefineProperties;
var $5bb7220e37bd460f$var$enumBugKeys = $5bb7220e37bd460f$var$enumBugKeys$3;
var $5bb7220e37bd460f$var$hiddenKeys = $5bb7220e37bd460f$var$hiddenKeys$4;
var $5bb7220e37bd460f$var$html = $5bb7220e37bd460f$var$html$2;
var $5bb7220e37bd460f$var$documentCreateElement$1 = $5bb7220e37bd460f$var$documentCreateElement$2;
var $5bb7220e37bd460f$var$sharedKey$1 = $5bb7220e37bd460f$var$sharedKey$3;
var $5bb7220e37bd460f$var$GT = ">";
var $5bb7220e37bd460f$var$LT = "<";
var $5bb7220e37bd460f$var$PROTOTYPE = "prototype";
var $5bb7220e37bd460f$var$SCRIPT = "script";
var $5bb7220e37bd460f$var$IE_PROTO$1 = $5bb7220e37bd460f$var$sharedKey$1("IE_PROTO");
var $5bb7220e37bd460f$var$EmptyConstructor = function() {};
var $5bb7220e37bd460f$var$scriptTag = function(content) {
    return $5bb7220e37bd460f$var$LT + $5bb7220e37bd460f$var$SCRIPT + $5bb7220e37bd460f$var$GT + content + $5bb7220e37bd460f$var$LT + "/" + $5bb7220e37bd460f$var$SCRIPT + $5bb7220e37bd460f$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $5bb7220e37bd460f$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($5bb7220e37bd460f$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $5bb7220e37bd460f$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $5bb7220e37bd460f$var$documentCreateElement$1("iframe");
    var JS = "java" + $5bb7220e37bd460f$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $5bb7220e37bd460f$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($5bb7220e37bd460f$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $5bb7220e37bd460f$var$activeXDocument;
var $5bb7220e37bd460f$var$NullProtoObject = function() {
    try {
        $5bb7220e37bd460f$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $5bb7220e37bd460f$var$NullProtoObject = typeof document != "undefined" ? document.domain && $5bb7220e37bd460f$var$activeXDocument ? $5bb7220e37bd460f$var$NullProtoObjectViaActiveX($5bb7220e37bd460f$var$activeXDocument) // old IE
     : $5bb7220e37bd460f$var$NullProtoObjectViaIFrame() : $5bb7220e37bd460f$var$NullProtoObjectViaActiveX($5bb7220e37bd460f$var$activeXDocument); // WSH
    var length = $5bb7220e37bd460f$var$enumBugKeys.length;
    while(length--)delete $5bb7220e37bd460f$var$NullProtoObject[$5bb7220e37bd460f$var$PROTOTYPE][$5bb7220e37bd460f$var$enumBugKeys[length]];
    return $5bb7220e37bd460f$var$NullProtoObject();
};
$5bb7220e37bd460f$var$hiddenKeys[$5bb7220e37bd460f$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $5bb7220e37bd460f$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $5bb7220e37bd460f$var$EmptyConstructor[$5bb7220e37bd460f$var$PROTOTYPE] = $5bb7220e37bd460f$var$anObject$3(O);
        result = new $5bb7220e37bd460f$var$EmptyConstructor();
        $5bb7220e37bd460f$var$EmptyConstructor[$5bb7220e37bd460f$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$5bb7220e37bd460f$var$IE_PROTO$1] = O;
    } else result = $5bb7220e37bd460f$var$NullProtoObject();
    return Properties === undefined ? result : $5bb7220e37bd460f$var$definePropertiesModule.f(result, Properties);
};
var $5bb7220e37bd460f$var$wellKnownSymbol$6 = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$create$2 = $5bb7220e37bd460f$var$objectCreate;
var $5bb7220e37bd460f$var$defineProperty$2 = $5bb7220e37bd460f$var$objectDefineProperty.f;
var $5bb7220e37bd460f$var$UNSCOPABLES = $5bb7220e37bd460f$var$wellKnownSymbol$6("unscopables");
var $5bb7220e37bd460f$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($5bb7220e37bd460f$var$ArrayPrototype[$5bb7220e37bd460f$var$UNSCOPABLES] == undefined) $5bb7220e37bd460f$var$defineProperty$2($5bb7220e37bd460f$var$ArrayPrototype, $5bb7220e37bd460f$var$UNSCOPABLES, {
    configurable: true,
    value: $5bb7220e37bd460f$var$create$2(null)
});
// add a key to Array.prototype[@@unscopables]
var $5bb7220e37bd460f$var$addToUnscopables$2 = function(key) {
    $5bb7220e37bd460f$var$ArrayPrototype[$5bb7220e37bd460f$var$UNSCOPABLES][key] = true;
};
var $5bb7220e37bd460f$var$fails$9 = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$correctPrototypeGetter = !$5bb7220e37bd460f$var$fails$9(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $5bb7220e37bd460f$var$hasOwn = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$isCallable$3 = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$toObject$2 = $5bb7220e37bd460f$var$toObject$4;
var $5bb7220e37bd460f$var$sharedKey = $5bb7220e37bd460f$var$sharedKey$3;
var $5bb7220e37bd460f$var$CORRECT_PROTOTYPE_GETTER = $5bb7220e37bd460f$var$correctPrototypeGetter;
var $5bb7220e37bd460f$var$IE_PROTO = $5bb7220e37bd460f$var$sharedKey("IE_PROTO");
var $5bb7220e37bd460f$var$$Object = Object;
var $5bb7220e37bd460f$var$ObjectPrototype = $5bb7220e37bd460f$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $5bb7220e37bd460f$var$objectGetPrototypeOf = $5bb7220e37bd460f$var$CORRECT_PROTOTYPE_GETTER ? $5bb7220e37bd460f$var$$Object.getPrototypeOf : function(O) {
    var object = $5bb7220e37bd460f$var$toObject$2(O);
    if ($5bb7220e37bd460f$var$hasOwn(object, $5bb7220e37bd460f$var$IE_PROTO)) return object[$5bb7220e37bd460f$var$IE_PROTO];
    var constructor = object.constructor;
    if ($5bb7220e37bd460f$var$isCallable$3(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $5bb7220e37bd460f$var$$Object ? $5bb7220e37bd460f$var$ObjectPrototype : null;
};
var $5bb7220e37bd460f$var$fails$8 = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$isCallable$2 = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$getPrototypeOf$1 = $5bb7220e37bd460f$var$objectGetPrototypeOf;
var $5bb7220e37bd460f$var$defineBuiltIn$2 = $5bb7220e37bd460f$var$defineBuiltIn$6;
var $5bb7220e37bd460f$var$wellKnownSymbol$5 = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$ITERATOR$2 = $5bb7220e37bd460f$var$wellKnownSymbol$5("iterator");
var $5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $5bb7220e37bd460f$var$IteratorPrototype$2, $5bb7220e37bd460f$var$PrototypeOfArrayIteratorPrototype, $5bb7220e37bd460f$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $5bb7220e37bd460f$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $5bb7220e37bd460f$var$arrayIterator)) $5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $5bb7220e37bd460f$var$PrototypeOfArrayIteratorPrototype = $5bb7220e37bd460f$var$getPrototypeOf$1($5bb7220e37bd460f$var$getPrototypeOf$1($5bb7220e37bd460f$var$arrayIterator));
        if ($5bb7220e37bd460f$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $5bb7220e37bd460f$var$IteratorPrototype$2 = $5bb7220e37bd460f$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $5bb7220e37bd460f$var$NEW_ITERATOR_PROTOTYPE = $5bb7220e37bd460f$var$IteratorPrototype$2 == undefined || $5bb7220e37bd460f$var$fails$8(function() {
    var test = {};
    // FF44- legacy iterators case
    return $5bb7220e37bd460f$var$IteratorPrototype$2[$5bb7220e37bd460f$var$ITERATOR$2].call(test) !== test;
});
if ($5bb7220e37bd460f$var$NEW_ITERATOR_PROTOTYPE) $5bb7220e37bd460f$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$5bb7220e37bd460f$var$isCallable$2($5bb7220e37bd460f$var$IteratorPrototype$2[$5bb7220e37bd460f$var$ITERATOR$2])) $5bb7220e37bd460f$var$defineBuiltIn$2($5bb7220e37bd460f$var$IteratorPrototype$2, $5bb7220e37bd460f$var$ITERATOR$2, function() {
    return this;
});
var $5bb7220e37bd460f$var$iteratorsCore = {
    IteratorPrototype: $5bb7220e37bd460f$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS$1
};
var $5bb7220e37bd460f$var$IteratorPrototype$1 = $5bb7220e37bd460f$var$iteratorsCore.IteratorPrototype;
var $5bb7220e37bd460f$var$create$1 = $5bb7220e37bd460f$var$objectCreate;
var $5bb7220e37bd460f$var$createPropertyDescriptor$1 = $5bb7220e37bd460f$var$createPropertyDescriptor$4;
var $5bb7220e37bd460f$var$setToStringTag$1 = $5bb7220e37bd460f$var$setToStringTag$3;
var $5bb7220e37bd460f$var$Iterators$2 = $5bb7220e37bd460f$var$iterators;
var $5bb7220e37bd460f$var$returnThis$1 = function() {
    return this;
};
var $5bb7220e37bd460f$var$createIteratorConstructor$1 = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $5bb7220e37bd460f$var$create$1($5bb7220e37bd460f$var$IteratorPrototype$1, {
        next: $5bb7220e37bd460f$var$createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next)
    });
    $5bb7220e37bd460f$var$setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
    $5bb7220e37bd460f$var$Iterators$2[TO_STRING_TAG] = $5bb7220e37bd460f$var$returnThis$1;
    return IteratorConstructor;
};
var $5bb7220e37bd460f$var$$$5 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$call$4 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$FunctionName = $5bb7220e37bd460f$var$functionName;
var $5bb7220e37bd460f$var$isCallable$1 = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$createIteratorConstructor = $5bb7220e37bd460f$var$createIteratorConstructor$1;
var $5bb7220e37bd460f$var$getPrototypeOf = $5bb7220e37bd460f$var$objectGetPrototypeOf;
var $5bb7220e37bd460f$var$setPrototypeOf = $5bb7220e37bd460f$var$objectSetPrototypeOf;
var $5bb7220e37bd460f$var$setToStringTag = $5bb7220e37bd460f$var$setToStringTag$3;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$2 = $5bb7220e37bd460f$var$createNonEnumerableProperty$5;
var $5bb7220e37bd460f$var$defineBuiltIn$1 = $5bb7220e37bd460f$var$defineBuiltIn$6;
var $5bb7220e37bd460f$var$wellKnownSymbol$4 = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$Iterators$1 = $5bb7220e37bd460f$var$iterators;
var $5bb7220e37bd460f$var$IteratorsCore = $5bb7220e37bd460f$var$iteratorsCore;
var $5bb7220e37bd460f$var$PROPER_FUNCTION_NAME = $5bb7220e37bd460f$var$FunctionName.PROPER;
var $5bb7220e37bd460f$var$CONFIGURABLE_FUNCTION_NAME = $5bb7220e37bd460f$var$FunctionName.CONFIGURABLE;
var $5bb7220e37bd460f$var$IteratorPrototype = $5bb7220e37bd460f$var$IteratorsCore.IteratorPrototype;
var $5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS = $5bb7220e37bd460f$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $5bb7220e37bd460f$var$ITERATOR$1 = $5bb7220e37bd460f$var$wellKnownSymbol$4("iterator");
var $5bb7220e37bd460f$var$KEYS = "keys";
var $5bb7220e37bd460f$var$VALUES = "values";
var $5bb7220e37bd460f$var$ENTRIES = "entries";
var $5bb7220e37bd460f$var$returnThis = function() {
    return this;
};
var $5bb7220e37bd460f$var$defineIterator$1 = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $5bb7220e37bd460f$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $5bb7220e37bd460f$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $5bb7220e37bd460f$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $5bb7220e37bd460f$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$5bb7220e37bd460f$var$ITERATOR$1] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $5bb7220e37bd460f$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($5bb7220e37bd460f$var$getPrototypeOf(CurrentIteratorPrototype) !== $5bb7220e37bd460f$var$IteratorPrototype) {
                if ($5bb7220e37bd460f$var$setPrototypeOf) $5bb7220e37bd460f$var$setPrototypeOf(CurrentIteratorPrototype, $5bb7220e37bd460f$var$IteratorPrototype);
                else if (!$5bb7220e37bd460f$var$isCallable$1(CurrentIteratorPrototype[$5bb7220e37bd460f$var$ITERATOR$1])) $5bb7220e37bd460f$var$defineBuiltIn$1(CurrentIteratorPrototype, $5bb7220e37bd460f$var$ITERATOR$1, $5bb7220e37bd460f$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $5bb7220e37bd460f$var$setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($5bb7220e37bd460f$var$PROPER_FUNCTION_NAME && DEFAULT == $5bb7220e37bd460f$var$VALUES && nativeIterator && nativeIterator.name !== $5bb7220e37bd460f$var$VALUES) {
        if ($5bb7220e37bd460f$var$CONFIGURABLE_FUNCTION_NAME) $5bb7220e37bd460f$var$createNonEnumerableProperty$2(IterablePrototype, "name", $5bb7220e37bd460f$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $5bb7220e37bd460f$var$call$4(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($5bb7220e37bd460f$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($5bb7220e37bd460f$var$KEYS),
            entries: getIterationMethod($5bb7220e37bd460f$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $5bb7220e37bd460f$var$defineBuiltIn$1(IterablePrototype, KEY, methods[KEY]);
        } else $5bb7220e37bd460f$var$$$5({
            target: NAME,
            proto: true,
            forced: $5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$5bb7220e37bd460f$var$ITERATOR$1] !== defaultIterator) $5bb7220e37bd460f$var$defineBuiltIn$1(IterablePrototype, $5bb7220e37bd460f$var$ITERATOR$1, defaultIterator, {
        name: DEFAULT
    });
    $5bb7220e37bd460f$var$Iterators$1[NAME] = defaultIterator;
    return methods;
};
var $5bb7220e37bd460f$var$toIndexedObject = $5bb7220e37bd460f$var$toIndexedObject$5;
var $5bb7220e37bd460f$var$addToUnscopables$1 = $5bb7220e37bd460f$var$addToUnscopables$2;
var $5bb7220e37bd460f$var$Iterators = $5bb7220e37bd460f$var$iterators;
var $5bb7220e37bd460f$var$InternalStateModule = $5bb7220e37bd460f$var$internalState;
var $5bb7220e37bd460f$var$defineProperty$1 = $5bb7220e37bd460f$var$objectDefineProperty.f;
var $5bb7220e37bd460f$var$defineIterator = $5bb7220e37bd460f$var$defineIterator$1;
var $5bb7220e37bd460f$var$DESCRIPTORS$1 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$ARRAY_ITERATOR = "Array Iterator";
var $5bb7220e37bd460f$var$setInternalState = $5bb7220e37bd460f$var$InternalStateModule.set;
var $5bb7220e37bd460f$var$getInternalState$1 = $5bb7220e37bd460f$var$InternalStateModule.getterFor($5bb7220e37bd460f$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $5bb7220e37bd460f$var$es_array_iterator = $5bb7220e37bd460f$var$defineIterator(Array, "Array", function(iterated, kind) {
    $5bb7220e37bd460f$var$setInternalState(this, {
        type: $5bb7220e37bd460f$var$ARRAY_ITERATOR,
        target: $5bb7220e37bd460f$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $5bb7220e37bd460f$var$getInternalState$1(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $5bb7220e37bd460f$var$values = $5bb7220e37bd460f$var$Iterators.Arguments = $5bb7220e37bd460f$var$Iterators.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$5bb7220e37bd460f$var$addToUnscopables$1("keys");
$5bb7220e37bd460f$var$addToUnscopables$1("values");
$5bb7220e37bd460f$var$addToUnscopables$1("entries");
// V8 ~ Chrome 45- bug
if ($5bb7220e37bd460f$var$DESCRIPTORS$1 && $5bb7220e37bd460f$var$values.name !== "values") try {
    $5bb7220e37bd460f$var$defineProperty$1($5bb7220e37bd460f$var$values, "name", {
        value: "values"
    });
} catch (error) {}
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $5bb7220e37bd460f$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $5bb7220e37bd460f$var$documentCreateElement = $5bb7220e37bd460f$var$documentCreateElement$2;
var $5bb7220e37bd460f$var$classList = $5bb7220e37bd460f$var$documentCreateElement("span").classList;
var $5bb7220e37bd460f$var$DOMTokenListPrototype$1 = $5bb7220e37bd460f$var$classList && $5bb7220e37bd460f$var$classList.constructor && $5bb7220e37bd460f$var$classList.constructor.prototype;
var $5bb7220e37bd460f$var$domTokenListPrototype = $5bb7220e37bd460f$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $5bb7220e37bd460f$var$DOMTokenListPrototype$1;
var $5bb7220e37bd460f$var$global$4 = $5bb7220e37bd460f$var$global$m;
var $5bb7220e37bd460f$var$DOMIterables = $5bb7220e37bd460f$var$domIterables;
var $5bb7220e37bd460f$var$DOMTokenListPrototype = $5bb7220e37bd460f$var$domTokenListPrototype;
var $5bb7220e37bd460f$var$ArrayIteratorMethods = $5bb7220e37bd460f$var$es_array_iterator;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$1 = $5bb7220e37bd460f$var$createNonEnumerableProperty$5;
var $5bb7220e37bd460f$var$wellKnownSymbol$3 = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$ITERATOR = $5bb7220e37bd460f$var$wellKnownSymbol$3("iterator");
var $5bb7220e37bd460f$var$TO_STRING_TAG = $5bb7220e37bd460f$var$wellKnownSymbol$3("toStringTag");
var $5bb7220e37bd460f$var$ArrayValues = $5bb7220e37bd460f$var$ArrayIteratorMethods.values;
var $5bb7220e37bd460f$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$5bb7220e37bd460f$var$ITERATOR] !== $5bb7220e37bd460f$var$ArrayValues) try {
            $5bb7220e37bd460f$var$createNonEnumerableProperty$1(CollectionPrototype, $5bb7220e37bd460f$var$ITERATOR, $5bb7220e37bd460f$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$5bb7220e37bd460f$var$ITERATOR] = $5bb7220e37bd460f$var$ArrayValues;
        }
        if (!CollectionPrototype[$5bb7220e37bd460f$var$TO_STRING_TAG]) $5bb7220e37bd460f$var$createNonEnumerableProperty$1(CollectionPrototype, $5bb7220e37bd460f$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($5bb7220e37bd460f$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $5bb7220e37bd460f$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $5bb7220e37bd460f$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $5bb7220e37bd460f$var$createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, $5bb7220e37bd460f$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $5bb7220e37bd460f$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $5bb7220e37bd460f$var$COLLECTION_NAME in $5bb7220e37bd460f$var$DOMIterables)$5bb7220e37bd460f$var$handlePrototype($5bb7220e37bd460f$var$global$4[$5bb7220e37bd460f$var$COLLECTION_NAME] && $5bb7220e37bd460f$var$global$4[$5bb7220e37bd460f$var$COLLECTION_NAME].prototype, $5bb7220e37bd460f$var$COLLECTION_NAME);
$5bb7220e37bd460f$var$handlePrototype($5bb7220e37bd460f$var$DOMTokenListPrototype, "DOMTokenList");
class $5bb7220e37bd460f$var$Logger {
    constructor(namespace){
        this.namespace = namespace;
    }
    emit(method, ...params) {
        if (!$5bb7220e37bd460f$var$Logger.debug) return;
        if (this.namespace && method !== "error") {
            // eslint-disable-next-line no-console
            console[method](this.namespace, ...params);
            return;
        } // eslint-disable-next-line no-console
        console[method](...params);
    }
    log(...params) {
        this.emit("log", ...params);
    }
    info(...params) {
        this.emit("info", ...params);
    }
    warn(...params) {
        this.emit("warn", ...params);
    }
    error(...params) {
        this.emit("error", ...params);
    }
}
$5bb7220e37bd460f$var$Logger.debug = false;
const $5bb7220e37bd460f$var$logger = new $5bb7220e37bd460f$var$Logger();
var $5bb7220e37bd460f$var$$$4 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$$includes = $5bb7220e37bd460f$var$arrayIncludes.includes;
var $5bb7220e37bd460f$var$fails$7 = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$addToUnscopables = $5bb7220e37bd460f$var$addToUnscopables$2;
// FF99+ bug
var $5bb7220e37bd460f$var$BROKEN_ON_SPARSE = $5bb7220e37bd460f$var$fails$7(function() {
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$5bb7220e37bd460f$var$$$4({
    target: "Array",
    proto: true,
    forced: $5bb7220e37bd460f$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $5bb7220e37bd460f$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$5bb7220e37bd460f$var$addToUnscopables("includes");
var $5bb7220e37bd460f$var$isObject = $5bb7220e37bd460f$var$isObject$8;
var $5bb7220e37bd460f$var$classof$2 = $5bb7220e37bd460f$var$classofRaw$1;
var $5bb7220e37bd460f$var$wellKnownSymbol$2 = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$MATCH$1 = $5bb7220e37bd460f$var$wellKnownSymbol$2("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var $5bb7220e37bd460f$var$isRegexp = function(it) {
    var isRegExp;
    return $5bb7220e37bd460f$var$isObject(it) && ((isRegExp = it[$5bb7220e37bd460f$var$MATCH$1]) !== undefined ? !!isRegExp : $5bb7220e37bd460f$var$classof$2(it) == "RegExp");
};
var $5bb7220e37bd460f$var$isRegExp$1 = $5bb7220e37bd460f$var$isRegexp;
var $5bb7220e37bd460f$var$$TypeError$2 = TypeError;
var $5bb7220e37bd460f$var$notARegexp = function(it) {
    if ($5bb7220e37bd460f$var$isRegExp$1(it)) throw $5bb7220e37bd460f$var$$TypeError$2("The method doesn't accept regular expressions");
    return it;
};
var $5bb7220e37bd460f$var$classof$1 = $5bb7220e37bd460f$var$classof$5;
var $5bb7220e37bd460f$var$$String = String;
var $5bb7220e37bd460f$var$toString$4 = function(argument) {
    if ($5bb7220e37bd460f$var$classof$1(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $5bb7220e37bd460f$var$$String(argument);
};
var $5bb7220e37bd460f$var$wellKnownSymbol$1 = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$MATCH = $5bb7220e37bd460f$var$wellKnownSymbol$1("match");
var $5bb7220e37bd460f$var$correctIsRegexpLogic = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$5bb7220e37bd460f$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};
var $5bb7220e37bd460f$var$$$3 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$uncurryThis$5 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$notARegExp = $5bb7220e37bd460f$var$notARegexp;
var $5bb7220e37bd460f$var$requireObjectCoercible$2 = $5bb7220e37bd460f$var$requireObjectCoercible$5;
var $5bb7220e37bd460f$var$toString$3 = $5bb7220e37bd460f$var$toString$4;
var $5bb7220e37bd460f$var$correctIsRegExpLogic = $5bb7220e37bd460f$var$correctIsRegexpLogic;
var $5bb7220e37bd460f$var$stringIndexOf = $5bb7220e37bd460f$var$uncurryThis$5("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$5bb7220e37bd460f$var$$$3({
    target: "String",
    proto: true,
    forced: !$5bb7220e37bd460f$var$correctIsRegExpLogic("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$5bb7220e37bd460f$var$stringIndexOf($5bb7220e37bd460f$var$toString$3($5bb7220e37bd460f$var$requireObjectCoercible$2(this)), $5bb7220e37bd460f$var$toString$3($5bb7220e37bd460f$var$notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $5bb7220e37bd460f$var$DESCRIPTORS = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$uncurryThis$4 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$call$3 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$fails$6 = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$objectKeys = $5bb7220e37bd460f$var$objectKeys$2;
var $5bb7220e37bd460f$var$getOwnPropertySymbolsModule = $5bb7220e37bd460f$var$objectGetOwnPropertySymbols;
var $5bb7220e37bd460f$var$propertyIsEnumerableModule = $5bb7220e37bd460f$var$objectPropertyIsEnumerable;
var $5bb7220e37bd460f$var$toObject$1 = $5bb7220e37bd460f$var$toObject$4;
var $5bb7220e37bd460f$var$IndexedObject$1 = $5bb7220e37bd460f$var$indexedObject;
// eslint-disable-next-line es-x/no-object-assign -- safe
var $5bb7220e37bd460f$var$$assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var $5bb7220e37bd460f$var$defineProperty = Object.defineProperty;
var $5bb7220e37bd460f$var$concat = $5bb7220e37bd460f$var$uncurryThis$4([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $5bb7220e37bd460f$var$objectAssign = !$5bb7220e37bd460f$var$$assign || $5bb7220e37bd460f$var$fails$6(function() {
    // should have correct order of operations (Edge bug)
    if ($5bb7220e37bd460f$var$DESCRIPTORS && $5bb7220e37bd460f$var$$assign({
        b: 1
    }, $5bb7220e37bd460f$var$$assign($5bb7220e37bd460f$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $5bb7220e37bd460f$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es-x/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $5bb7220e37bd460f$var$$assign({}, A)[symbol] != 7 || $5bb7220e37bd460f$var$objectKeys($5bb7220e37bd460f$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $5bb7220e37bd460f$var$toObject$1(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $5bb7220e37bd460f$var$getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = $5bb7220e37bd460f$var$propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = $5bb7220e37bd460f$var$IndexedObject$1(arguments[index++]);
        var keys = getOwnPropertySymbols ? $5bb7220e37bd460f$var$concat($5bb7220e37bd460f$var$objectKeys(S), getOwnPropertySymbols(S)) : $5bb7220e37bd460f$var$objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$5bb7220e37bd460f$var$DESCRIPTORS || $5bb7220e37bd460f$var$call$3(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $5bb7220e37bd460f$var$$assign;
var $5bb7220e37bd460f$var$$$2 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$assign = $5bb7220e37bd460f$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$5bb7220e37bd460f$var$$$2({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $5bb7220e37bd460f$var$assign
}, {
    assign: $5bb7220e37bd460f$var$assign
});
var $5bb7220e37bd460f$var$events = {
    exports: {}
};
var $5bb7220e37bd460f$var$R = typeof Reflect === "object" ? Reflect : null;
var $5bb7220e37bd460f$var$ReflectApply = $5bb7220e37bd460f$var$R && typeof $5bb7220e37bd460f$var$R.apply === "function" ? $5bb7220e37bd460f$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5bb7220e37bd460f$var$ReflectOwnKeys;
if ($5bb7220e37bd460f$var$R && typeof $5bb7220e37bd460f$var$R.ownKeys === "function") $5bb7220e37bd460f$var$ReflectOwnKeys = $5bb7220e37bd460f$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5bb7220e37bd460f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5bb7220e37bd460f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5bb7220e37bd460f$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5bb7220e37bd460f$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5bb7220e37bd460f$var$EventEmitter$1() {
    $5bb7220e37bd460f$var$EventEmitter$1.init.call(this);
}
$5bb7220e37bd460f$var$events.exports = $5bb7220e37bd460f$var$EventEmitter$1;
$5bb7220e37bd460f$var$events.exports.once = $5bb7220e37bd460f$var$once;
// Backwards-compat with node 0.10.x
$5bb7220e37bd460f$var$EventEmitter$1.EventEmitter = $5bb7220e37bd460f$var$EventEmitter$1;
$5bb7220e37bd460f$var$EventEmitter$1.prototype._events = undefined;
$5bb7220e37bd460f$var$EventEmitter$1.prototype._eventsCount = 0;
$5bb7220e37bd460f$var$EventEmitter$1.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5bb7220e37bd460f$var$defaultMaxListeners = 10;
function $5bb7220e37bd460f$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5bb7220e37bd460f$var$EventEmitter$1, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5bb7220e37bd460f$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5bb7220e37bd460f$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5bb7220e37bd460f$var$defaultMaxListeners = arg;
    }
});
$5bb7220e37bd460f$var$EventEmitter$1.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5bb7220e37bd460f$var$EventEmitter$1.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5bb7220e37bd460f$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5bb7220e37bd460f$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5bb7220e37bd460f$var$EventEmitter$1.defaultMaxListeners;
    return that._maxListeners;
}
$5bb7220e37bd460f$var$EventEmitter$1.prototype.getMaxListeners = function getMaxListeners() {
    return $5bb7220e37bd460f$var$_getMaxListeners(this);
};
$5bb7220e37bd460f$var$EventEmitter$1.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5bb7220e37bd460f$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5bb7220e37bd460f$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5bb7220e37bd460f$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5bb7220e37bd460f$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5bb7220e37bd460f$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5bb7220e37bd460f$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5bb7220e37bd460f$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5bb7220e37bd460f$var$EventEmitter$1.prototype.addListener = function addListener(type, listener) {
    return $5bb7220e37bd460f$var$_addListener(this, type, listener, false);
};
$5bb7220e37bd460f$var$EventEmitter$1.prototype.on = $5bb7220e37bd460f$var$EventEmitter$1.prototype.addListener;
$5bb7220e37bd460f$var$EventEmitter$1.prototype.prependListener = function prependListener(type, listener) {
    return $5bb7220e37bd460f$var$_addListener(this, type, listener, true);
};
function $5bb7220e37bd460f$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5bb7220e37bd460f$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5bb7220e37bd460f$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5bb7220e37bd460f$var$EventEmitter$1.prototype.once = function once(type, listener) {
    $5bb7220e37bd460f$var$checkListener(listener);
    this.on(type, $5bb7220e37bd460f$var$_onceWrap(this, type, listener));
    return this;
};
$5bb7220e37bd460f$var$EventEmitter$1.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5bb7220e37bd460f$var$checkListener(listener);
    this.prependListener(type, $5bb7220e37bd460f$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5bb7220e37bd460f$var$EventEmitter$1.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5bb7220e37bd460f$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5bb7220e37bd460f$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5bb7220e37bd460f$var$EventEmitter$1.prototype.off = $5bb7220e37bd460f$var$EventEmitter$1.prototype.removeListener;
$5bb7220e37bd460f$var$EventEmitter$1.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5bb7220e37bd460f$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5bb7220e37bd460f$var$unwrapListeners(evlistener) : $5bb7220e37bd460f$var$arrayClone(evlistener, evlistener.length);
}
$5bb7220e37bd460f$var$EventEmitter$1.prototype.listeners = function listeners(type) {
    return $5bb7220e37bd460f$var$_listeners(this, type, true);
};
$5bb7220e37bd460f$var$EventEmitter$1.prototype.rawListeners = function rawListeners(type) {
    return $5bb7220e37bd460f$var$_listeners(this, type, false);
};
$5bb7220e37bd460f$var$EventEmitter$1.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5bb7220e37bd460f$var$listenerCount.call(emitter, type);
};
$5bb7220e37bd460f$var$EventEmitter$1.prototype.listenerCount = $5bb7220e37bd460f$var$listenerCount;
function $5bb7220e37bd460f$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5bb7220e37bd460f$var$EventEmitter$1.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5bb7220e37bd460f$var$ReflectOwnKeys(this._events) : [];
};
function $5bb7220e37bd460f$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5bb7220e37bd460f$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5bb7220e37bd460f$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5bb7220e37bd460f$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5bb7220e37bd460f$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5bb7220e37bd460f$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5bb7220e37bd460f$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5bb7220e37bd460f$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5bb7220e37bd460f$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}
class $5bb7220e37bd460f$export$4fae95256245c8c0 {
    constructor(){
        this.emitter = new $5bb7220e37bd460f$var$events.exports.EventEmitter();
    }
    on(eventName, callback) {
        this.emitter.on(eventName, callback);
        return {
            remove: ()=>this.emitter.off(eventName, callback)
        };
    }
    off(eventName, callback) {
        this.emitter.off(eventName, callback);
    }
    emit(eventName, event) {
        this.emitter.emit(eventName, event);
    }
}
const $5bb7220e37bd460f$var$PACKAGE_NAME = "near-wallet-selector";
const $5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS = "recentlySignedInWallets";
const $5bb7220e37bd460f$var$CONTRACT = "contract";
const $5bb7220e37bd460f$var$PENDING_CONTRACT = "contract:pending";
const $5bb7220e37bd460f$var$SELECTED_WALLET_ID = `selectedWalletId`;
const $5bb7220e37bd460f$var$PENDING_SELECTED_WALLET_ID = `selectedWalletId:pending`;
class $5bb7220e37bd460f$var$WalletModules {
    constructor({ factories: factories, storage: storage, options: options, store: store, emitter: emitter, provider: provider }){
        this.factories = factories;
        this.storage = storage;
        this.options = options;
        this.store = store;
        this.emitter = emitter;
        this.provider = provider;
        this.modules = [];
        this.instances = {};
    }
    validateWallet(id) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            let accounts = [];
            const wallet = yield this.getWallet(id);
            if (wallet) // Ensure our persistent state aligns with the selected wallet.
            // For example a wallet is selected, but it returns no accounts (not signed in).
            accounts = yield wallet.getAccounts().catch((err)=>{
                $5bb7220e37bd460f$var$logger.log(`Failed to validate ${wallet.id} during setup`);
                $5bb7220e37bd460f$var$logger.error(err);
                return [];
            });
            return accounts;
        });
    }
    resolveStorageState() {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const jsonStorage = new $5bb7220e37bd460f$var$JsonStorage(this.storage, $5bb7220e37bd460f$var$PACKAGE_NAME);
            const pendingSelectedWalletId = yield jsonStorage.getItem($5bb7220e37bd460f$var$PENDING_SELECTED_WALLET_ID);
            const pendingContract = yield jsonStorage.getItem($5bb7220e37bd460f$var$PENDING_CONTRACT);
            if (pendingSelectedWalletId && pendingContract) {
                const _accounts = yield this.validateWallet(pendingSelectedWalletId);
                yield jsonStorage.removeItem($5bb7220e37bd460f$var$PENDING_SELECTED_WALLET_ID);
                yield jsonStorage.removeItem($5bb7220e37bd460f$var$PENDING_CONTRACT);
                if (_accounts.length) {
                    const { selectedWalletId: _selectedWalletId } = this.store.getState();
                    const selectedWallet = yield this.getWallet(_selectedWalletId);
                    if (selectedWallet && pendingSelectedWalletId !== _selectedWalletId) yield selectedWallet.signOut().catch((err)=>{
                        $5bb7220e37bd460f$var$logger.log("Failed to sign out existing wallet");
                        $5bb7220e37bd460f$var$logger.error(err);
                    });
                    const recentlySignedInWalletsFromPending = yield this.setWalletAsRecentlySignedIn(pendingSelectedWalletId);
                    return {
                        accounts: _accounts,
                        contract: pendingContract,
                        selectedWalletId: pendingSelectedWalletId,
                        recentlySignedInWallets: recentlySignedInWalletsFromPending
                    };
                }
            }
            const { contract: contract, selectedWalletId: selectedWalletId } = this.store.getState();
            const accounts = yield this.validateWallet(selectedWalletId);
            const recentlySignedInWallets = yield jsonStorage.getItem($5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS);
            if (!accounts.length) return {
                accounts: [],
                contract: null,
                selectedWalletId: null,
                recentlySignedInWallets: recentlySignedInWallets || []
            };
            return {
                accounts: accounts,
                contract: contract,
                selectedWalletId: selectedWalletId,
                recentlySignedInWallets: recentlySignedInWallets || []
            };
        });
    }
    setWalletAsRecentlySignedIn(walletId) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const jsonStorage = new $5bb7220e37bd460f$var$JsonStorage(this.storage, $5bb7220e37bd460f$var$PACKAGE_NAME);
            let recentlySignedInWallets = yield jsonStorage.getItem($5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS);
            if (!recentlySignedInWallets) recentlySignedInWallets = [];
            if (!recentlySignedInWallets.includes(walletId)) {
                recentlySignedInWallets.unshift(walletId);
                recentlySignedInWallets = recentlySignedInWallets.slice(0, 5);
                yield jsonStorage.setItem($5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS, recentlySignedInWallets);
            }
            return recentlySignedInWallets;
        });
    }
    signOutWallet(walletId) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const wallet = yield this.getWallet(walletId);
            yield wallet.signOut().catch((err)=>{
                $5bb7220e37bd460f$var$logger.log(`Failed to sign out ${wallet.id}`);
                $5bb7220e37bd460f$var$logger.error(err); // At least clean up state on our side.
                this.onWalletSignedOut(wallet.id);
            });
        });
    }
    onWalletSignedIn(walletId, { accounts: accounts, contractId: contractId, methodNames: methodNames }) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const { selectedWalletId: selectedWalletId } = this.store.getState();
            const jsonStorage = new $5bb7220e37bd460f$var$JsonStorage(this.storage, $5bb7220e37bd460f$var$PACKAGE_NAME);
            const contract = {
                contractId: contractId,
                methodNames: methodNames
            };
            if (!accounts.length) {
                const module = this.getModule(walletId); // We can't guarantee the user will actually sign in with browser wallets.
                // Best we can do is set in storage and validate on init.
                if (module.type === "browser") {
                    yield jsonStorage.setItem($5bb7220e37bd460f$var$PENDING_SELECTED_WALLET_ID, walletId);
                    yield jsonStorage.setItem($5bb7220e37bd460f$var$PENDING_CONTRACT, contract);
                }
                return;
            }
            if (selectedWalletId && selectedWalletId !== walletId) yield this.signOutWallet(selectedWalletId);
            const recentlySignedInWallets = yield this.setWalletAsRecentlySignedIn(walletId);
            this.store.dispatch({
                type: "WALLET_CONNECTED",
                payload: {
                    walletId: walletId,
                    contract: contract,
                    accounts: accounts,
                    recentlySignedInWallets: recentlySignedInWallets
                }
            });
            this.emitter.emit("signedIn", {
                walletId: walletId,
                contractId: contractId,
                methodNames: methodNames,
                accounts: accounts
            });
        });
    }
    onWalletSignedOut(walletId) {
        this.store.dispatch({
            type: "WALLET_DISCONNECTED",
            payload: {
                walletId: walletId
            }
        });
        this.emitter.emit("signedOut", {
            walletId: walletId
        });
    }
    setupWalletEmitter(module) {
        const emitter = new $5bb7220e37bd460f$export$4fae95256245c8c0();
        emitter.on("signedOut", ()=>{
            this.onWalletSignedOut(module.id);
        });
        emitter.on("signedIn", (event)=>{
            this.onWalletSignedIn(module.id, event);
        });
        emitter.on("accountsChanged", ({ accounts: accounts })=>$5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
                this.emitter.emit("accountsChanged", {
                    walletId: module.id,
                    accounts: accounts
                });
                if (!accounts.length) return this.signOutWallet(module.id);
                this.store.dispatch({
                    type: "ACCOUNTS_CHANGED",
                    payload: {
                        walletId: module.id,
                        accounts: accounts
                    }
                });
            }));
        emitter.on("networkChanged", ({ networkId: networkId })=>{
            this.emitter.emit("networkChanged", {
                walletId: module.id,
                networkId: networkId
            });
        });
        emitter.on("uriChanged", ({ uri: uri })=>{
            this.emitter.emit("uriChanged", {
                walletId: module.id,
                uri: uri
            });
        });
        return emitter;
    }
    decorateWallet(wallet) {
        const _signIn = wallet.signIn;
        const _signOut = wallet.signOut;
        wallet.signIn = (params)=>$5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
                const accounts = yield _signIn(params);
                const { contractId: contractId, methodNames: methodNames = [] } = params;
                yield this.onWalletSignedIn(wallet.id, {
                    accounts: accounts,
                    contractId: contractId,
                    methodNames: methodNames
                });
                return accounts;
            });
        wallet.signOut = ()=>$5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
                yield _signOut();
                this.onWalletSignedOut(wallet.id);
            });
        return wallet;
    }
    setupInstance(module) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            if (!module.metadata.available) {
                const message = module.type === "injected" ? "not installed" : "not available";
                throw Error(`${module.metadata.name} is ${message}`);
            }
            const wallet = Object.assign({
                id: module.id,
                type: module.type,
                metadata: module.metadata
            }, (yield module.init({
                id: module.id,
                type: module.type,
                metadata: module.metadata,
                options: this.options,
                store: this.store.toReadOnly(),
                provider: this.provider,
                emitter: this.setupWalletEmitter(module),
                logger: new $5bb7220e37bd460f$var$Logger(module.id),
                storage: new $5bb7220e37bd460f$var$JsonStorage(this.storage, [
                    $5bb7220e37bd460f$var$PACKAGE_NAME,
                    module.id
                ])
            })));
            return this.decorateWallet(wallet);
        });
    }
    getModule(id) {
        return this.modules.find((x)=>x.id === id);
    }
    getWallet(id) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const module = this.getModule(id);
            if (!module) return null;
            const { selectedWalletId: selectedWalletId } = this.store.getState(); // If user uninstalled/removed a wallet which was previously signed in with
            // best we can do is clean up state on our side.
            if (!module.metadata.available && selectedWalletId) {
                this.onWalletSignedOut(selectedWalletId);
                return null;
            }
            return yield module.wallet();
        });
    }
    setup() {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const modules = [];
            for(let i = 0; i < this.factories.length; i += 1){
                const module = yield this.factories[i]({
                    options: this.options
                }).catch((err)=>{
                    $5bb7220e37bd460f$var$logger.log("Failed to setup module");
                    $5bb7220e37bd460f$var$logger.error(err);
                    return null;
                }); // Filter out wallets that aren't available.
                if (!module) continue;
                 // Skip duplicated module.
                if (modules.some((x)=>x.id === module.id)) continue;
                modules.push({
                    id: module.id,
                    type: module.type,
                    metadata: module.metadata,
                    wallet: ()=>$5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
                            let instance = this.instances[module.id];
                            if (instance) return instance;
                            instance = yield this.setupInstance(module);
                            this.instances[module.id] = instance;
                            return instance;
                        })
                });
            }
            this.modules = modules;
            for(let i = 0; i < this.modules.length; i++)if (this.modules[i].type === "instant-link") {
                const wallet = yield this.modules[i].wallet();
                if (wallet.metadata.runOnStartup) try {
                    yield wallet.signIn({
                        contractId: wallet.getContractId()
                    });
                } catch (err) {
                    $5bb7220e37bd460f$var$logger.error("Failed to sign in to wallet. " + err);
                }
            }
            const { accounts: accounts, contract: contract, selectedWalletId: selectedWalletId, recentlySignedInWallets: recentlySignedInWallets } = yield this.resolveStorageState();
            this.store.dispatch({
                type: "SETUP_WALLET_MODULES",
                payload: {
                    modules: modules,
                    accounts: accounts,
                    contract: contract,
                    selectedWalletId: selectedWalletId,
                    recentlySignedInWallets: recentlySignedInWallets
                }
            });
        });
    }
}
const $5bb7220e37bd460f$var$getNetworkPreset = (networkId)=>{
    switch(networkId){
        case "mainnet":
            return {
                networkId: networkId,
                nodeUrl: "https://rpc.mainnet.near.org",
                helperUrl: "https://helper.mainnet.near.org",
                explorerUrl: "https://explorer.near.org",
                indexerUrl: "https://api.kitwallet.app"
            };
        case "testnet":
            return {
                networkId: networkId,
                nodeUrl: "https://rpc.testnet.near.org",
                helperUrl: "https://helper.testnet.near.org",
                explorerUrl: "https://explorer.testnet.near.org",
                indexerUrl: "https://testnet-api.kitwallet.app"
            };
        default:
            throw Error(`Failed to find config for: '${networkId}'`);
    }
};
const $5bb7220e37bd460f$var$resolveNetwork = (network)=>{
    return typeof network === "string" ? $5bb7220e37bd460f$var$getNetworkPreset(network) : network;
};
const $5bb7220e37bd460f$var$resolveOptions = (params)=>{
    const options = {
        languageCode: params.languageCode || undefined,
        network: $5bb7220e37bd460f$var$resolveNetwork(params.network),
        debug: params.debug || false,
        optimizeWalletOrder: params.optimizeWalletOrder === false ? false : true,
        randomizeWalletOrder: params.randomizeWalletOrder || false
    };
    return {
        options: options,
        storage: params.storage || new $5bb7220e37bd460f$var$WebStorageService()
    };
};
const $5bb7220e37bd460f$var$reducer = (state, action)=>{
    $5bb7220e37bd460f$var$logger.log("Store Action", action);
    switch(action.type){
        case "SETUP_WALLET_MODULES":
            {
                const { modules: modules, accounts: accounts, contract: contract, selectedWalletId: selectedWalletId, recentlySignedInWallets: recentlySignedInWallets } = action.payload;
                const accountStates = accounts.map((account, i)=>{
                    return Object.assign(Object.assign({}, account), {
                        active: i === 0
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    modules: modules,
                    accounts: accountStates,
                    contract: contract,
                    selectedWalletId: selectedWalletId,
                    recentlySignedInWallets: recentlySignedInWallets
                });
            }
        case "WALLET_CONNECTED":
            {
                const { walletId: walletId, contract: contract, accounts: accounts, recentlySignedInWallets: recentlySignedInWallets } = action.payload;
                if (!accounts.length) return state;
                const activeAccountIndex = state.accounts.findIndex((account)=>account.active);
                const accountStates = accounts.map((account, i)=>{
                    return Object.assign(Object.assign({}, account), {
                        active: i === (activeAccountIndex > -1 ? activeAccountIndex : 0)
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    contract: contract,
                    accounts: accountStates,
                    selectedWalletId: walletId,
                    recentlySignedInWallets: recentlySignedInWallets
                });
            }
        case "WALLET_DISCONNECTED":
            {
                const { walletId: walletId } = action.payload;
                if (walletId !== state.selectedWalletId) return state;
                return Object.assign(Object.assign({}, state), {
                    contract: null,
                    accounts: [],
                    selectedWalletId: null
                });
            }
        case "ACCOUNTS_CHANGED":
            {
                const { walletId: walletId, accounts: accounts } = action.payload;
                if (walletId !== state.selectedWalletId) return state;
                const activeAccount = state.accounts.find((account)=>account.active);
                const isActiveAccountRemoved = !accounts.some((account)=>account.accountId === (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.accountId));
                const accountStates = accounts.map((account, i)=>{
                    return Object.assign(Object.assign({}, account), {
                        active: isActiveAccountRemoved ? i === 0 : account.accountId === (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.accountId)
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    accounts: accountStates
                });
            }
        case "SET_ACTIVE_ACCOUNT":
            {
                const { accountId: accountId } = action.payload;
                const accountStates = state.accounts.map((account)=>{
                    return Object.assign(Object.assign({}, account), {
                        active: account.accountId === accountId
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    accounts: accountStates
                });
            }
        default:
            return state;
    }
};
const $5bb7220e37bd460f$var$createStore = (storage)=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
        const jsonStorage = new $5bb7220e37bd460f$var$JsonStorage(storage, $5bb7220e37bd460f$var$PACKAGE_NAME);
        const initialState = {
            modules: [],
            accounts: [],
            contract: yield jsonStorage.getItem($5bb7220e37bd460f$var$CONTRACT),
            selectedWalletId: yield jsonStorage.getItem($5bb7220e37bd460f$var$SELECTED_WALLET_ID),
            recentlySignedInWallets: (yield jsonStorage.getItem($5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS)) || []
        };
        const state$ = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(initialState);
        const actions$ = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
        actions$.pipe((0, $095ac41f805f8ce2$export$c87d910e63d22ed6)($5bb7220e37bd460f$var$reducer, initialState)).subscribe(state$);
        const syncStorage = (prevState, state, storageKey, property)=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
                if (state[property] === prevState[property]) return;
                if (state[property]) {
                    yield jsonStorage.setItem(storageKey, state[property]);
                    return;
                }
                yield jsonStorage.removeItem(storageKey);
            });
        let prevState = state$.getValue();
        state$.subscribe((state)=>{
            syncStorage(prevState, state, $5bb7220e37bd460f$var$SELECTED_WALLET_ID, "selectedWalletId");
            syncStorage(prevState, state, $5bb7220e37bd460f$var$CONTRACT, "contract");
            syncStorage(prevState, state, $5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS, "recentlySignedInWallets");
            prevState = state;
        });
        return {
            observable: state$,
            getState: ()=>state$.getValue(),
            dispatch: (action)=>actions$.next(action),
            toReadOnly: ()=>({
                    getState: ()=>state$.getValue(),
                    observable: state$.asObservable()
                })
        };
    });
let $5bb7220e37bd460f$var$walletSelectorInstance = null;
const $5bb7220e37bd460f$var$createSelector = (options, store, walletModules, emitter)=>{
    return {
        options: options,
        store: store.toReadOnly(),
        wallet: (id)=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
                const { selectedWalletId: selectedWalletId } = store.getState();
                const wallet = yield walletModules.getWallet(id || selectedWalletId);
                if (!wallet) {
                    if (id) throw new Error("Invalid wallet id");
                    throw new Error("No wallet selected");
                }
                return wallet;
            }),
        setActiveAccount: (accountId)=>{
            const { accounts: accounts } = store.getState();
            if (!accounts.some((account)=>account.accountId === accountId)) throw new Error("Invalid account id");
            store.dispatch({
                type: "SET_ACTIVE_ACCOUNT",
                payload: {
                    accountId: accountId
                }
            });
        },
        isSignedIn () {
            const { accounts: accounts } = store.getState();
            return Boolean(accounts.length);
        },
        on: (eventName, callback)=>{
            return emitter.on(eventName, callback);
        },
        off: (eventName, callback)=>{
            emitter.off(eventName, callback);
        }
    };
};
const $5bb7220e37bd460f$export$f9bdc9e9de5b988e = (params)=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
        const { options: options, storage: storage } = $5bb7220e37bd460f$var$resolveOptions(params);
        $5bb7220e37bd460f$var$Logger.debug = options.debug;
        const emitter = new $5bb7220e37bd460f$export$4fae95256245c8c0();
        const store = yield $5bb7220e37bd460f$var$createStore(storage);
        const walletModules = new $5bb7220e37bd460f$var$WalletModules({
            factories: params.modules,
            storage: storage,
            options: options,
            store: store,
            emitter: emitter,
            provider: new $5bb7220e37bd460f$var$Provider(options.network.nodeUrl)
        });
        yield walletModules.setup();
        if (params.allowMultipleSelectors) return $5bb7220e37bd460f$var$createSelector(options, store, walletModules, emitter);
        if (!$5bb7220e37bd460f$var$walletSelectorInstance) $5bb7220e37bd460f$var$walletSelectorInstance = $5bb7220e37bd460f$var$createSelector(options, store, walletModules, emitter);
        return $5bb7220e37bd460f$var$walletSelectorInstance;
    });
const $5bb7220e37bd460f$var$wait = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $5bb7220e37bd460f$var$poll = (cb, interval, remaining)=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
        const result = cb();
        if (result) return result;
        if (!remaining) throw new Error("Exceeded timeout");
        return $5bb7220e37bd460f$var$wait(interval).then(()=>$5bb7220e37bd460f$var$poll(cb, interval, remaining - 1));
    });
const $5bb7220e37bd460f$export$9bbfceb27f687c1b = (cb, opts = {})=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
        const { timeout: timeout = 100, interval: interval = 50 } = opts;
        return Promise.race([
            $5bb7220e37bd460f$var$wait(timeout).then(()=>{
                throw new Error("Exceeded timeout");
            }),
            $5bb7220e37bd460f$var$poll(cb, interval, Math.floor(timeout / interval))
        ]);
    });
const $5bb7220e37bd460f$export$13dd2e33a23839ad = (state)=>{
    return state.accounts.find((account)=>account.active) || null;
};
var $5bb7220e37bd460f$var$aCallable = $5bb7220e37bd460f$var$aCallable$8;
var $5bb7220e37bd460f$var$toObject = $5bb7220e37bd460f$var$toObject$4;
var $5bb7220e37bd460f$var$IndexedObject = $5bb7220e37bd460f$var$indexedObject;
var $5bb7220e37bd460f$var$lengthOfArrayLike$1 = $5bb7220e37bd460f$var$lengthOfArrayLike$4;
var $5bb7220e37bd460f$var$$TypeError$1 = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $5bb7220e37bd460f$var$createMethod$1 = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $5bb7220e37bd460f$var$aCallable(callbackfn);
        var O = $5bb7220e37bd460f$var$toObject(that);
        var self1 = $5bb7220e37bd460f$var$IndexedObject(O);
        var length = $5bb7220e37bd460f$var$lengthOfArrayLike$1(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self1) {
                memo = self1[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $5bb7220e37bd460f$var$$TypeError$1("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
        return memo;
    };
};
var $5bb7220e37bd460f$var$arrayReduce = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $5bb7220e37bd460f$var$createMethod$1(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $5bb7220e37bd460f$var$createMethod$1(true)
};
var $5bb7220e37bd460f$var$fails$5 = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$arrayMethodIsStrict$1 = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $5bb7220e37bd460f$var$fails$5(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};
var $5bb7220e37bd460f$var$$$1 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$$reduce = $5bb7220e37bd460f$var$arrayReduce.left;
var $5bb7220e37bd460f$var$arrayMethodIsStrict = $5bb7220e37bd460f$var$arrayMethodIsStrict$1;
var $5bb7220e37bd460f$var$CHROME_VERSION = $5bb7220e37bd460f$var$engineV8Version;
var $5bb7220e37bd460f$var$IS_NODE = $5bb7220e37bd460f$var$engineIsNode;
var $5bb7220e37bd460f$var$STRICT_METHOD = $5bb7220e37bd460f$var$arrayMethodIsStrict("reduce");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $5bb7220e37bd460f$var$CHROME_BUG = !$5bb7220e37bd460f$var$IS_NODE && $5bb7220e37bd460f$var$CHROME_VERSION > 79 && $5bb7220e37bd460f$var$CHROME_VERSION < 83;
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$5bb7220e37bd460f$var$$$1({
    target: "Array",
    proto: true,
    forced: !$5bb7220e37bd460f$var$STRICT_METHOD || $5bb7220e37bd460f$var$CHROME_BUG
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $5bb7220e37bd460f$var$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});
var $5bb7220e37bd460f$var$anObject$2 = $5bb7220e37bd460f$var$anObject$d;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $5bb7220e37bd460f$var$regexpFlags$1 = function() {
    var that = $5bb7220e37bd460f$var$anObject$2(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $5bb7220e37bd460f$var$fails$4 = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$global$3 = $5bb7220e37bd460f$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $5bb7220e37bd460f$var$$RegExp$2 = $5bb7220e37bd460f$var$global$3.RegExp;
var $5bb7220e37bd460f$var$UNSUPPORTED_Y$2 = $5bb7220e37bd460f$var$fails$4(function() {
    var re = $5bb7220e37bd460f$var$$RegExp$2("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $5bb7220e37bd460f$var$MISSED_STICKY = $5bb7220e37bd460f$var$UNSUPPORTED_Y$2 || $5bb7220e37bd460f$var$fails$4(function() {
    return !$5bb7220e37bd460f$var$$RegExp$2("a", "y").sticky;
});
var $5bb7220e37bd460f$var$BROKEN_CARET = $5bb7220e37bd460f$var$UNSUPPORTED_Y$2 || $5bb7220e37bd460f$var$fails$4(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $5bb7220e37bd460f$var$$RegExp$2("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});
var $5bb7220e37bd460f$var$regexpStickyHelpers = {
    BROKEN_CARET: $5bb7220e37bd460f$var$BROKEN_CARET,
    MISSED_STICKY: $5bb7220e37bd460f$var$MISSED_STICKY,
    UNSUPPORTED_Y: $5bb7220e37bd460f$var$UNSUPPORTED_Y$2
};
var $5bb7220e37bd460f$var$fails$3 = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$global$2 = $5bb7220e37bd460f$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $5bb7220e37bd460f$var$$RegExp$1 = $5bb7220e37bd460f$var$global$2.RegExp;
var $5bb7220e37bd460f$var$regexpUnsupportedDotAll = $5bb7220e37bd460f$var$fails$3(function() {
    var re = $5bb7220e37bd460f$var$$RegExp$1(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});
var $5bb7220e37bd460f$var$fails$2 = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$global$1 = $5bb7220e37bd460f$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $5bb7220e37bd460f$var$$RegExp = $5bb7220e37bd460f$var$global$1.RegExp;
var $5bb7220e37bd460f$var$regexpUnsupportedNcg = $5bb7220e37bd460f$var$fails$2(function() {
    var re = $5bb7220e37bd460f$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var $5bb7220e37bd460f$var$call$2 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$uncurryThis$3 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$toString$2 = $5bb7220e37bd460f$var$toString$4;
var $5bb7220e37bd460f$var$regexpFlags = $5bb7220e37bd460f$var$regexpFlags$1;
var $5bb7220e37bd460f$var$stickyHelpers$1 = $5bb7220e37bd460f$var$regexpStickyHelpers;
var $5bb7220e37bd460f$var$shared = $5bb7220e37bd460f$var$shared$4.exports;
var $5bb7220e37bd460f$var$create = $5bb7220e37bd460f$var$objectCreate;
var $5bb7220e37bd460f$var$getInternalState = $5bb7220e37bd460f$var$internalState.get;
var $5bb7220e37bd460f$var$UNSUPPORTED_DOT_ALL = $5bb7220e37bd460f$var$regexpUnsupportedDotAll;
var $5bb7220e37bd460f$var$UNSUPPORTED_NCG = $5bb7220e37bd460f$var$regexpUnsupportedNcg;
var $5bb7220e37bd460f$var$nativeReplace = $5bb7220e37bd460f$var$shared("native-string-replace", String.prototype.replace);
var $5bb7220e37bd460f$var$nativeExec = RegExp.prototype.exec;
var $5bb7220e37bd460f$var$patchedExec = $5bb7220e37bd460f$var$nativeExec;
var $5bb7220e37bd460f$var$charAt$2 = $5bb7220e37bd460f$var$uncurryThis$3("".charAt);
var $5bb7220e37bd460f$var$indexOf = $5bb7220e37bd460f$var$uncurryThis$3("".indexOf);
var $5bb7220e37bd460f$var$replace = $5bb7220e37bd460f$var$uncurryThis$3("".replace);
var $5bb7220e37bd460f$var$stringSlice$2 = $5bb7220e37bd460f$var$uncurryThis$3("".slice);
var $5bb7220e37bd460f$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $5bb7220e37bd460f$var$call$2($5bb7220e37bd460f$var$nativeExec, re1, "a");
    $5bb7220e37bd460f$var$call$2($5bb7220e37bd460f$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $5bb7220e37bd460f$var$UNSUPPORTED_Y$1 = $5bb7220e37bd460f$var$stickyHelpers$1.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $5bb7220e37bd460f$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $5bb7220e37bd460f$var$PATCH = $5bb7220e37bd460f$var$UPDATES_LAST_INDEX_WRONG || $5bb7220e37bd460f$var$NPCG_INCLUDED || $5bb7220e37bd460f$var$UNSUPPORTED_Y$1 || $5bb7220e37bd460f$var$UNSUPPORTED_DOT_ALL || $5bb7220e37bd460f$var$UNSUPPORTED_NCG;
if ($5bb7220e37bd460f$var$PATCH) $5bb7220e37bd460f$var$patchedExec = function exec(string) {
    var re = this;
    var state = $5bb7220e37bd460f$var$getInternalState(re);
    var str = $5bb7220e37bd460f$var$toString$2(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $5bb7220e37bd460f$var$call$2($5bb7220e37bd460f$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $5bb7220e37bd460f$var$UNSUPPORTED_Y$1 && re.sticky;
    var flags = $5bb7220e37bd460f$var$call$2($5bb7220e37bd460f$var$regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $5bb7220e37bd460f$var$replace(flags, "y", "");
        if ($5bb7220e37bd460f$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $5bb7220e37bd460f$var$stringSlice$2(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $5bb7220e37bd460f$var$charAt$2(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($5bb7220e37bd460f$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($5bb7220e37bd460f$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $5bb7220e37bd460f$var$call$2($5bb7220e37bd460f$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $5bb7220e37bd460f$var$stringSlice$2(match.input, charsAdded);
            match[0] = $5bb7220e37bd460f$var$stringSlice$2(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($5bb7220e37bd460f$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($5bb7220e37bd460f$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    $5bb7220e37bd460f$var$call$2($5bb7220e37bd460f$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $5bb7220e37bd460f$var$create(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
var $5bb7220e37bd460f$var$regexpExec$3 = $5bb7220e37bd460f$var$patchedExec;
var $5bb7220e37bd460f$var$$ = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$exec$1 = $5bb7220e37bd460f$var$regexpExec$3;
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$5bb7220e37bd460f$var$$({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $5bb7220e37bd460f$var$exec$1
}, {
    exec: $5bb7220e37bd460f$var$exec$1
});
/* eslint-disable no-useless-escape */ // https://github.com/DamonOehlman/detect-browser/blob/master/src/index.ts
const $5bb7220e37bd460f$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
const $5bb7220e37bd460f$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $5bb7220e37bd460f$var$SEARCHBOX_UA_REGEX
    ]
];
const $5bb7220e37bd460f$var$matchUserAgent = (ua)=>{
    return ua !== "" && $5bb7220e37bd460f$var$userAgentRules.reduce((matched, [browser, regex])=>{
        if (matched) return matched;
        const uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
};
const $5bb7220e37bd460f$export$3ef098392766df13 = (supportedBrowser)=>{
    if (typeof navigator === "undefined") return false;
    const matchedRule = $5bb7220e37bd460f$var$matchUserAgent(navigator.userAgent);
    if (!matchedRule) return false;
    const [name] = matchedRule;
    if (name === "searchbot") return false;
    return !!supportedBrowser.find((item)=>item === name);
};
// TODO: Remove from `core-js@4` since it's moved to entry points
var $5bb7220e37bd460f$var$uncurryThis$2 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$defineBuiltIn = $5bb7220e37bd460f$var$defineBuiltIn$6;
var $5bb7220e37bd460f$var$regexpExec$2 = $5bb7220e37bd460f$var$regexpExec$3;
var $5bb7220e37bd460f$var$fails$1 = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$wellKnownSymbol = $5bb7220e37bd460f$var$wellKnownSymbol$h;
var $5bb7220e37bd460f$var$createNonEnumerableProperty = $5bb7220e37bd460f$var$createNonEnumerableProperty$5;
var $5bb7220e37bd460f$var$SPECIES = $5bb7220e37bd460f$var$wellKnownSymbol("species");
var $5bb7220e37bd460f$var$RegExpPrototype = RegExp.prototype;
var $5bb7220e37bd460f$var$fixRegexpWellKnownSymbolLogic = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $5bb7220e37bd460f$var$wellKnownSymbol(KEY);
    var DELEGATES_TO_SYMBOL = !$5bb7220e37bd460f$var$fails$1(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$5bb7220e37bd460f$var$fails$1(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$5bb7220e37bd460f$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $5bb7220e37bd460f$var$uncurryThis$2(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $5bb7220e37bd460f$var$uncurryThis$2(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $5bb7220e37bd460f$var$regexpExec$2 || $exec === $5bb7220e37bd460f$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $5bb7220e37bd460f$var$defineBuiltIn(String.prototype, KEY, methods[0]);
        $5bb7220e37bd460f$var$defineBuiltIn($5bb7220e37bd460f$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $5bb7220e37bd460f$var$createNonEnumerableProperty($5bb7220e37bd460f$var$RegExpPrototype[SYMBOL], "sham", true);
};
var $5bb7220e37bd460f$var$uncurryThis$1 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$toIntegerOrInfinity = $5bb7220e37bd460f$var$toIntegerOrInfinity$3;
var $5bb7220e37bd460f$var$toString$1 = $5bb7220e37bd460f$var$toString$4;
var $5bb7220e37bd460f$var$requireObjectCoercible$1 = $5bb7220e37bd460f$var$requireObjectCoercible$5;
var $5bb7220e37bd460f$var$charAt$1 = $5bb7220e37bd460f$var$uncurryThis$1("".charAt);
var $5bb7220e37bd460f$var$charCodeAt = $5bb7220e37bd460f$var$uncurryThis$1("".charCodeAt);
var $5bb7220e37bd460f$var$stringSlice$1 = $5bb7220e37bd460f$var$uncurryThis$1("".slice);
var $5bb7220e37bd460f$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $5bb7220e37bd460f$var$toString$1($5bb7220e37bd460f$var$requireObjectCoercible$1($this));
        var position = $5bb7220e37bd460f$var$toIntegerOrInfinity(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $5bb7220e37bd460f$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $5bb7220e37bd460f$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $5bb7220e37bd460f$var$charAt$1(S, position) : first : CONVERT_TO_STRING ? $5bb7220e37bd460f$var$stringSlice$1(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
var $5bb7220e37bd460f$var$stringMultibyte = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $5bb7220e37bd460f$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $5bb7220e37bd460f$var$createMethod(true)
};
var $5bb7220e37bd460f$var$charAt = $5bb7220e37bd460f$var$stringMultibyte.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var $5bb7220e37bd460f$var$advanceStringIndex$1 = function(S, index, unicode) {
    return index + (unicode ? $5bb7220e37bd460f$var$charAt(S, index).length : 1);
};
var $5bb7220e37bd460f$var$toPropertyKey = $5bb7220e37bd460f$var$toPropertyKey$3;
var $5bb7220e37bd460f$var$definePropertyModule = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$createPropertyDescriptor = $5bb7220e37bd460f$var$createPropertyDescriptor$4;
var $5bb7220e37bd460f$var$createProperty$1 = function(object, key, value) {
    var propertyKey = $5bb7220e37bd460f$var$toPropertyKey(key);
    if (propertyKey in object) $5bb7220e37bd460f$var$definePropertyModule.f(object, propertyKey, $5bb7220e37bd460f$var$createPropertyDescriptor(0, value));
    else object[propertyKey] = value;
};
var $5bb7220e37bd460f$var$toAbsoluteIndex = $5bb7220e37bd460f$var$toAbsoluteIndex$2;
var $5bb7220e37bd460f$var$lengthOfArrayLike = $5bb7220e37bd460f$var$lengthOfArrayLike$4;
var $5bb7220e37bd460f$var$createProperty = $5bb7220e37bd460f$var$createProperty$1;
var $5bb7220e37bd460f$var$$Array = Array;
var $5bb7220e37bd460f$var$max = Math.max;
var $5bb7220e37bd460f$var$arraySliceSimple = function(O, start, end) {
    var length = $5bb7220e37bd460f$var$lengthOfArrayLike(O);
    var k = $5bb7220e37bd460f$var$toAbsoluteIndex(start, length);
    var fin = $5bb7220e37bd460f$var$toAbsoluteIndex(end === undefined ? length : end, length);
    var result = $5bb7220e37bd460f$var$$Array($5bb7220e37bd460f$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$5bb7220e37bd460f$var$createProperty(result, n, O[k]);
    result.length = n;
    return result;
};
var $5bb7220e37bd460f$var$call$1 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$anObject$1 = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$isCallable = $5bb7220e37bd460f$var$isCallable$l;
var $5bb7220e37bd460f$var$classof = $5bb7220e37bd460f$var$classofRaw$1;
var $5bb7220e37bd460f$var$regexpExec$1 = $5bb7220e37bd460f$var$regexpExec$3;
var $5bb7220e37bd460f$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var $5bb7220e37bd460f$var$regexpExecAbstract = function(R, S) {
    var exec = R.exec;
    if ($5bb7220e37bd460f$var$isCallable(exec)) {
        var result = $5bb7220e37bd460f$var$call$1(exec, R, S);
        if (result !== null) $5bb7220e37bd460f$var$anObject$1(result);
        return result;
    }
    if ($5bb7220e37bd460f$var$classof(R) === "RegExp") return $5bb7220e37bd460f$var$call$1($5bb7220e37bd460f$var$regexpExec$1, R, S);
    throw $5bb7220e37bd460f$var$$TypeError("RegExp#exec called on incompatible receiver");
};
var $5bb7220e37bd460f$var$apply = $5bb7220e37bd460f$var$functionApply;
var $5bb7220e37bd460f$var$call = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$uncurryThis = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$fixRegExpWellKnownSymbolLogic = $5bb7220e37bd460f$var$fixRegexpWellKnownSymbolLogic;
var $5bb7220e37bd460f$var$isRegExp = $5bb7220e37bd460f$var$isRegexp;
var $5bb7220e37bd460f$var$anObject = $5bb7220e37bd460f$var$anObject$d;
var $5bb7220e37bd460f$var$requireObjectCoercible = $5bb7220e37bd460f$var$requireObjectCoercible$5;
var $5bb7220e37bd460f$var$speciesConstructor = $5bb7220e37bd460f$var$speciesConstructor$2;
var $5bb7220e37bd460f$var$advanceStringIndex = $5bb7220e37bd460f$var$advanceStringIndex$1;
var $5bb7220e37bd460f$var$toLength = $5bb7220e37bd460f$var$toLength$2;
var $5bb7220e37bd460f$var$toString = $5bb7220e37bd460f$var$toString$4;
var $5bb7220e37bd460f$var$getMethod = $5bb7220e37bd460f$var$getMethod$4;
var $5bb7220e37bd460f$var$arraySlice = $5bb7220e37bd460f$var$arraySliceSimple;
var $5bb7220e37bd460f$var$callRegExpExec = $5bb7220e37bd460f$var$regexpExecAbstract;
var $5bb7220e37bd460f$var$regexpExec = $5bb7220e37bd460f$var$regexpExec$3;
var $5bb7220e37bd460f$var$stickyHelpers = $5bb7220e37bd460f$var$regexpStickyHelpers;
var $5bb7220e37bd460f$var$fails = $5bb7220e37bd460f$var$fails$k;
var $5bb7220e37bd460f$var$UNSUPPORTED_Y = $5bb7220e37bd460f$var$stickyHelpers.UNSUPPORTED_Y;
var $5bb7220e37bd460f$var$MAX_UINT32 = 0xFFFFFFFF;
var $5bb7220e37bd460f$var$min = Math.min;
var $5bb7220e37bd460f$var$$push = [].push;
var $5bb7220e37bd460f$var$exec = $5bb7220e37bd460f$var$uncurryThis(/./.exec);
var $5bb7220e37bd460f$var$push = $5bb7220e37bd460f$var$uncurryThis($5bb7220e37bd460f$var$$push);
var $5bb7220e37bd460f$var$stringSlice = $5bb7220e37bd460f$var$uncurryThis("".slice);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var $5bb7220e37bd460f$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !$5bb7220e37bd460f$var$fails(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = "ab".split(re);
    return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
});
// @@split logic
$5bb7220e37bd460f$var$fixRegExpWellKnownSymbolLogic("split", function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit;
    if ("abbc".split(/(b)*/)[1] == "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
    "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    ".".split(/()()/).length > 1 || "".split(/.?/).length) // based on es5-shim implementation, need to rework it
    internalSplit = function(separator, limit) {
        var string = $5bb7220e37bd460f$var$toString($5bb7220e37bd460f$var$requireObjectCoercible(this));
        var lim = limit === undefined ? $5bb7220e37bd460f$var$MAX_UINT32 : limit >>> 0;
        if (lim === 0) return [];
        if (separator === undefined) return [
            string
        ];
        // If `separator` is not a regex, use native split
        if (!$5bb7220e37bd460f$var$isRegExp(separator)) return $5bb7220e37bd460f$var$call(nativeSplit, string, separator, lim);
        var output = [];
        var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
        var lastLastIndex = 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + "g");
        var match, lastIndex, lastLength;
        while(match = $5bb7220e37bd460f$var$call($5bb7220e37bd460f$var$regexpExec, separatorCopy, string)){
            lastIndex = separatorCopy.lastIndex;
            if (lastIndex > lastLastIndex) {
                $5bb7220e37bd460f$var$push(output, $5bb7220e37bd460f$var$stringSlice(string, lastLastIndex, match.index));
                if (match.length > 1 && match.index < string.length) $5bb7220e37bd460f$var$apply($5bb7220e37bd460f$var$$push, output, $5bb7220e37bd460f$var$arraySlice(match, 1));
                lastLength = match[0].length;
                lastLastIndex = lastIndex;
                if (output.length >= lim) break;
            }
            if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
        }
        if (lastLastIndex === string.length) {
            if (lastLength || !$5bb7220e37bd460f$var$exec(separatorCopy, "")) $5bb7220e37bd460f$var$push(output, "");
        } else $5bb7220e37bd460f$var$push(output, $5bb7220e37bd460f$var$stringSlice(string, lastLastIndex));
        return output.length > lim ? $5bb7220e37bd460f$var$arraySlice(output, 0, lim) : output;
    };
    else if ("0".split(undefined, 0).length) internalSplit = function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $5bb7220e37bd460f$var$call(nativeSplit, this, separator, limit);
    };
    else internalSplit = nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = $5bb7220e37bd460f$var$requireObjectCoercible(this);
            var splitter = separator == undefined ? undefined : $5bb7220e37bd460f$var$getMethod(separator, SPLIT);
            return splitter ? $5bb7220e37bd460f$var$call(splitter, separator, O, limit) : $5bb7220e37bd460f$var$call(internalSplit, $5bb7220e37bd460f$var$toString(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = $5bb7220e37bd460f$var$anObject(this);
            var S = $5bb7220e37bd460f$var$toString(string);
            var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
            if (res.done) return res.value;
            var C = $5bb7220e37bd460f$var$speciesConstructor(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + ($5bb7220e37bd460f$var$UNSUPPORTED_Y ? "g" : "y");
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($5bb7220e37bd460f$var$UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
            var lim = limit === undefined ? $5bb7220e37bd460f$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $5bb7220e37bd460f$var$callRegExpExec(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $5bb7220e37bd460f$var$UNSUPPORTED_Y ? 0 : q;
                var z = $5bb7220e37bd460f$var$callRegExpExec(splitter, $5bb7220e37bd460f$var$UNSUPPORTED_Y ? $5bb7220e37bd460f$var$stringSlice(S, q) : S);
                var e;
                if (z === null || (e = $5bb7220e37bd460f$var$min($5bb7220e37bd460f$var$toLength(splitter.lastIndex + ($5bb7220e37bd460f$var$UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = $5bb7220e37bd460f$var$advanceStringIndex(S, q, unicodeMatching);
                else {
                    $5bb7220e37bd460f$var$push(A, $5bb7220e37bd460f$var$stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        $5bb7220e37bd460f$var$push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            $5bb7220e37bd460f$var$push(A, $5bb7220e37bd460f$var$stringSlice(S, p));
            return A;
        }
    ];
}, !$5bb7220e37bd460f$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, $5bb7220e37bd460f$var$UNSUPPORTED_Y);
var $5bb7220e37bd460f$var$modal$b = {
    wallet: {
        connectYourWallet: "Connect Your Wallet",
        whatIsAWallet: "What is a Wallet?",
        secureAndManage: "Secure & Manage Your Digital Assets",
        safelyStore: "Safely store and transfer your crypto and NFTs.",
        logInToAny: "Log In to Any NEAR App",
        noNeedToCreate: "No need to create new accounts or credentials. Connect your wallet and you are good to go!",
        getAWallet: "Get a Wallet",
        useAWallet: "Use a wallet to secure and manage your NEAR assets, and to log in to any NEAR app without the need for usernames and passwords.",
        connectionFailed: "Connection Failed",
        connectionSuccessful: "Connection Successful",
        connected: "Connected",
        connectingTo: "Connecting to",
        connectingMessage: {
            injected: "Confirm the connection in the extension window",
            browser: "Confirm the connection in the wallet after redirect",
            hardware: "Confirm the connection in the ledger device",
            bridge: "Confirm the connection in the wallet"
        }
    },
    ledger: {
        connectWithLedger: "Connect with Ledger",
        makeSureYourLedger: "Make sure your Ledger is connected securely, and that the NEAR app is open on your device",
        "continue": "Continue",
        specifyHDPath: "Specify HD Path",
        enterYourPreferredHDPath: "Enter your preferred HD path, then scan for any active accounts.",
        scan: "Scan",
        retry: "Retry",
        ledgerIsNotAvailable: "Ledger is not available",
        accessDeniedToUseLedgerDevice: "Access denied to use Ledger device",
        noAccountsFound: "No Accounts Found",
        selectYourAccounts: "Select Your Accounts",
        connecting1Account: "Connecting 1 Account",
        cantFindAnyAccount: "Can't find any account associated with this Ledger. Please create a new NEAR account on",
        orConnectAnAnotherLedger: "or connect an another Ledger.",
        connecting: "Connecting",
        ofAccounts: "of Accounts",
        failedToAutomatically: "Failed to automatically find account id. Provide it manually:",
        overviewTheListOfAuthorized: "Overview the list of authorized account(s), complete sign in by clicking the button below.",
        finish: "Finish"
    },
    install: {
        youllNeedToInstall: "You'll need to install",
        toContinueAfterInstalling: "to continue. After installing",
        refreshThePage: "refresh the page.",
        open: "Open"
    },
    qr: {
        copiedToClipboard: "Copied to clipboard",
        failedToCopy: "Failed to copy to clipboard",
        scanWithYourMobile: "Scan with Your Mobile Device",
        copyToClipboard: " Copy to clipboard",
        preferTheOfficial: "Prefer the official dialogue of",
        open: "Open"
    },
    exportAccounts: {
        chooseAWallet: "Choose a Wallet",
        transferYourAccounts: "Transfer Your Accounts",
        selectAWallet: "Select a wallet that fits your needs and supports your connected accounts.",
        selectYourAccounts: "Select Your Accounts",
        afterDecide: "After you decide on a wallet, you can select which accounts you want to transfer.",
        disclaimer: "You won\u2019t be able to transfer accounts that have never been funded or used on NEAR.",
        warning: "does not support account export at this time. Please select another wallet.",
        walletTypes: {
            hardware: "Hardware Wallet",
            browser: "Browser Wallet",
            injected: "Wallet Extension",
            bridge: "Bridge Wallet",
            mobile: "Mobile Wallet"
        },
        selectAccounts: {
            title: "Select Accounts to Transfer",
            button: "Get Passphrase",
            deselectAll: "Deselect All",
            selectAll: "Select All",
            unavailable: "Transfer Unavailable",
            error: "Account does not exist",
            warningLedger: "Ledger support required",
            noBalance: "Account not funded"
        },
        getPassphrase: {
            title: "Copy Temporary Password",
            desc: "You\u2019ll need to enter this password when you begin exporting your accounts to a different wallet.",
            button: "Continue",
            label: "Click to Copy",
            checkLabel: "I copied or wrote down the password"
        },
        complete: {
            title: "Complete the Transfer",
            descOne: "You will now be redirected to the wallet you selected to complete the transfer.",
            descTwo: "Once import part of process is completed from selected wallet, press button to complete the transfer process.",
            button: "Complete"
        }
    }
};
var $5bb7220e37bd460f$var$component$1 = {
    clickToCopy: {
        label: "Copied",
        tooltip: "Click to copy"
    }
};
var $5bb7220e37bd460f$var$en = {
    modal: $5bb7220e37bd460f$var$modal$b,
    component: $5bb7220e37bd460f$var$component$1
};
var $5bb7220e37bd460f$var$modal$a = {
    wallet: {
        connectYourWallet: "Conecta Tu Billetera",
        whatIsAWallet: "\xbfQue es una Billetera?",
        secureAndManage: "Resguarda y Administrar Tus Activos Digitales",
        safelyStore: "Almacena de forma segura y transfiere tus cryptos y NFT's",
        logInToAny: "Inicie sesi\xf3n en Cualquier Aplicacion NEAR",
        noNeedToCreate: "No es necesario crear nuevas cuentas o credenciales, \xa1Conecta tu billetera y listo!",
        getAWallet: "Obten una Billetera",
        useAWallet: "Usa tu Billetera para resguardar y administrar tus activos en NEAR, e Iniciar sesi\xf3n en cualquier aplicacion NEAR sin la necesidad de nombres de usuarios y contrase\xf1as",
        connectionFailed: "Conexi\xf3n Fallida",
        connectionSuccessful: "Conexi\xf3n Existosa",
        connected: "Conectado",
        connectingTo: "Conectando a ",
        connectingMessage: {
            injected: "Confirme la conexi\xf3n en la ventana de extensi\xf3n",
            browser: "Confirme la conexi\xf3n en la billetera despu\xe9s de la redirecci\xf3n",
            hardware: "Confirme la conexi\xf3n en el dispositivo de libro mayor",
            bridge: "Confirmar la conexi\xf3n en la billetera"
        }
    },
    ledger: {
        connectWithLedger: "Conectar con Ledger",
        makeSureYourLedger: "Aseg\xfarese de que su ledger est\xe1 conectada de forma segura y que la aplicacion NEAR est\xe9 abierta en su dispositivo",
        "continue": "Continuar",
        specifyHDPath: "Especifique la ruta HD",
        enterYourPreferredHDPath: "Ingrese su ruta HD prerida,y luego busque cualquier cuenta activa.",
        scan: "Escanear",
        retry: "Reintentar",
        ledgerIsNotAvailable: "El Ledger no est\xe1 disponible",
        accessDeniedToUseLedgerDevice: "Acceso denegado para usar el dispositivo ledger",
        noAccountsFound: "No se encontraron cuentas",
        selectYourAccounts: "Selecciona tus cuentas",
        connecting1Account: "Conectando a 1 cuenta",
        cantFindAnyAccount: "No se pudo encontrar ninguna cuenta asociada con este ledger,Por favor crea una nueva cuenta en NEAR",
        orConnectAnAnotherLedger: "o conecta otro ledger",
        connecting: "Conectando",
        ofAccounts: "de Cuentas",
        failedToAutomatically: "No se pudo encontrar automaticamente el id de la cuenta,Ingresalo manualmente:",
        overviewTheListOfAuthorized: "Revise la lista de las cuentas autorizadas,Complete el inicio de sesi\xf3n haciedo click a countinuacion.",
        finish: "Finalizar"
    },
    install: {
        youllNeedToInstall: "Tendr\xe1s que instalar",
        toContinueAfterInstalling: "Para continuar, Despues de instalar",
        refreshThePage: "Recarga la pagina",
        open: "Abrir"
    },
    qr: {
        copiedToClipboard: "Copiado al Portapapeles",
        failedToCopy: "Fall\xf3 la copia al Portapapeles",
        scanWithYourMobile: "Busca con tu dispositivo movil",
        copyToClipboard: " Copiar al Portapapeles",
        preferTheOfficial: "\xbfPrefires el di\xe1logo oficial de",
        open: "Abrir"
    }
};
var $5bb7220e37bd460f$var$es = {
    modal: $5bb7220e37bd460f$var$modal$a
};
var $5bb7220e37bd460f$var$modal$9 = {
    wallet: {
        connectYourWallet: "\u8FDE\u63A5\u4F60\u7684\u94B1\u5305",
        whatIsAWallet: "\u4EC0\u4E48\u662F\u94B1\u5305\uFF1F",
        secureAndManage: "\u4FDD\u62A4\u548C\u7BA1\u7406\u4F60\u7684\u6570\u5B57\u8D44\u4EA7",
        safelyStore: "\u5B89\u5168\u5B58\u50A8\u548C\u8F6C\u79FB\u4F60\u7684\u52A0\u5BC6\u8D27\u5E01\u548CNFT",
        logInToAny: "\u767B\u5F55\u4EFB\u4F55 NEAR \u5E94\u7528",
        noNeedToCreate: "\u4E0D\u9700\u8981\u521B\u5EFA\u65B0\u8D26\u6237\u6216\u5BC6\u7801\u3002\u8FDE\u63A5\u4F60\u7684\u94B1\u5305\uFF0C\u5373\u53EF\u5F00\u59CB\u4F7F\u7528\uFF01",
        getAWallet: "\u83B7\u53D6\u65B0\u8D26\u6237",
        useAWallet: "\u4F7F\u7528\u94B1\u5305\u6765\u4FDD\u62A4\u548C\u7BA1\u7406\u4F60\u7684 NEAR \u8D44\u4EA7\uFF0C\u65E0\u9700\u7528\u6237\u540D\u548C\u5BC6\u7801\u5373\u53EF\u767B\u5F55\u4EFB\u4F55 NEAR \u5E94\u7528",
        connectionFailed: "\u8FDE\u63A5\u5931\u8D25",
        connectionSuccessful: "\u8FDE\u63A5\u6210\u529F",
        connected: "\u5DF2\u8FDE\u63A5",
        connectingTo: "\u6B63\u5728\u8FDE\u63A5"
    },
    ledger: {
        connectWithLedger: "\u8FDE\u63A5 Ledger",
        makeSureYourLedger: "\u786E\u4FDD\u4F60\u7684 Ledger \u5DF2\u7ECF\u5B89\u5168\u8FDE\u63A5\uFF0C\u5E76\u4E14 NEAR \u5E94\u7528\u5DF2\u7ECF\u5728\u4F60\u8BBE\u5907\u4E0A\u6253\u5F00",
        "continue": "\u7EE7\u7EED",
        specifyHDPath: "\u6307\u5B9A HD \u8DEF\u5F84",
        enterYourPreferredHDPath: "\u8F93\u5165\u4F60\u504F\u597D\u7684 HD \u8DEF\u5F84\uFF0C\u7136\u540E\u4E3A\u4EFB\u610F\u6D3B\u8DC3\u8D26\u6237\u626B\u7801",
        scan: "\u626B\u7801",
        retry: "\u91CD\u8BD5",
        ledgerIsNotAvailable: "Ledger \u4E0D\u53EF\u7528",
        accessDeniedToUseLedgerDevice: "\u8BBF\u95EE Ledger \u8BBE\u5907\u88AB\u62D2\u7EDD",
        noAccountsFound: "\u6CA1\u6709\u627E\u5230\u8D26\u6237",
        selectYourAccounts: "\u9009\u62E9\u4F60\u7684\u8D26\u6237",
        connecting1Account: "\u6B63\u5728\u8FDE\u63A51\u4E2A\u8D26\u6237",
        cantFindAnyAccount: "\u6CA1\u6709\u627E\u5230\u4EFB\u4F55\u4E0E\u8FD9\u4E2A Ledger \u76F8\u5173\u8054\u7684\u8D26\u6237\u3002\u8BF7\u521B\u5EFA\u65B0\u8D26\u6237\u4E8E",
        "orConnectAnAnotherLedger.": "\u6216\u8FDE\u63A5\u53E6\u4E00\u4E2A Ledger",
        connecting: "\u6B63\u5728\u8FDE\u63A5",
        ofAccounts: "\u4E2A\u8D26\u6237",
        failedToAutomatically: "\u65E0\u6CD5\u81EA\u52A8\u627E\u5230\u8D26\u6237ID\uFF0C\u8BF7\u4E3B\u52A8\u63D0\u4F9B\uFF1A",
        overviewTheListOfAuthorized: "\u8BF7\u67E5\u770B\u5DF2\u6388\u6743\u7684\u8D26\u6237\u5217\u8868\uFF0C\u70B9\u51FB\u4EE5\u4E0B\u6309\u94AE\u5B8C\u6210\u767B\u5F55",
        finish: "\u5B8C\u6210"
    },
    install: {
        youllNeedToInstall: "\u4F60\u5C06\u9700\u8981\u5B89\u88C5",
        toContinueAfterInstalling: "\u4EE5\u7EE7\u7EED\u3002\u5B89\u88C5\u5B8C",
        refreshThePage: "\u8BF7\u5237\u65B0\u9875\u9762",
        open: "\u6253\u5F00"
    },
    qr: {
        copiedToClipboard: "\u590D\u5236\u5230\u4E86\u526A\u8D34\u677F",
        failedToCopy: "\u590D\u5236\u5230\u526A\u8D34\u677F\u5931\u8D25",
        scanWithYourMobile: "\u7528\u4F60\u7684\u79FB\u52A8\u8BBE\u5907\u626B\u7801",
        copyToClipboard: " \u590D\u5236\u5230\u526A\u8D34\u677F",
        preferTheOfficial: "\u5E0C\u671B\u4F7F\u7528\u5B98\u65B9\u5BF9\u8BDD\u6846\u4E8E",
        open: "\u6253\u5F00"
    }
};
var $5bb7220e37bd460f$var$zh = {
    modal: $5bb7220e37bd460f$var$modal$9
};
var $5bb7220e37bd460f$var$modal$8 = {
    wallet: {
        connectYourWallet: "\u0421\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u041F\u043E\u0440\u0442\u0444\u0435\u0439\u043B",
        whatIsAWallet: "\u041A\u0430\u043A\u0432\u043E \u0435 \u041F\u043E\u0440\u0442\u0444\u0435\u0439\u043B?",
        secureAndManage: "\u0417\u0430\u0449\u0438\u0442\u0435\u0442\u0435 \u0438 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0432\u0430\u0439\u0442\u0435 \u0434\u0438\u0433\u0438\u0442\u0430\u043B\u043D\u0438\u0442\u0435 \u0441\u0438 \u0430\u043A\u0442\u0438\u0432\u0438",
        safelyStore: "\u0421\u044A\u0445\u0440\u0430\u043D\u044F\u0432\u0430\u0439\u0442\u0435 \u0438 \u043F\u0440\u0435\u0445\u0432\u044A\u0440\u043B\u044F\u0439\u0442\u0435 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E \u0432\u0430\u0448\u0438\u0442\u0435 \u043A\u0440\u0438\u043F\u0442\u043E \u0438 NFT.",
        logInToAny: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0432\u0441\u044F\u043A\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 NEAR",
        noNeedToCreate: "\u041D\u044F\u043C\u0430 \u043D\u0443\u0436\u0434\u0430 \u0434\u0430 \u0441\u044A\u0437\u0434\u0430\u0432\u0430\u0442\u0435 \u043D\u043E\u0432\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0438. \u0421\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u0430 \u0441\u0438 \u0438 \u0441\u0442\u0435 \u0433\u043E\u0442\u043E\u0432\u0438!",
        getAWallet: "\u0421\u044A\u0437\u0434\u0430\u0439\u0442\u0435 \u041F\u043E\u0440\u0442\u0444\u0435\u0439\u043B",
        useAWallet: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u0430, \u0437\u0430 \u0434\u0430 \u0437\u0430\u0449\u0438\u0442\u0438\u0442\u0435 \u0438 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0432\u0430\u0442\u0435 \u0430\u043A\u0442\u0438\u0432\u0438\u0442\u0435 \u0441\u0438 \u043D\u0430 NEAR \u043A\u0430\u043A\u0442\u043E \u0438 \u0434\u0430 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u0432\u0441\u044F\u043A\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 NEAR \u0431\u0435\u0437 \u043D\u0443\u0436\u0434\u0430 \u043E\u0442 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u0438 \u0438\u043C\u0435\u043D\u0430 \u0438 \u043F\u0430\u0440\u043E\u043B\u0438.",
        connectionFailed: "\u0421\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E",
        connectionSuccessful: "\u0421\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E",
        connected: "\u0421\u0432\u044A\u0440\u0437\u0430\u043D",
        connectingTo: "\u0421\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435 \u043A\u044A\u043C",
        connectingMessage: {
            injected: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0441\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u0432 \u043F\u0440\u043E\u0437\u043E\u0440\u0435\u0446\u0430 \u043D\u0430 \u0440\u0430\u0437\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0442\u043E",
            browser: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0441\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u0432 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u0430 \u0441\u043B\u0435\u0434 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0432\u0430\u043D\u0435\u0442\u043E",
            hardware: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0441\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u0432 \u0445\u0430\u0440\u0434\u0443\u0435\u0440\u043D\u0438\u044F \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B",
            bridge: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0432\u0440\u044A\u0437\u043A\u0430\u0442\u0430 \u0432 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u0430"
        }
    },
    ledger: {
        connectWithLedger: "\u0421\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0441\u0435 \u0441 Ledger",
        makeSureYourLedger: "\u0423\u0432\u0435\u0440\u0435\u0442\u0435 \u0441\u0435, \u0447\u0435 \u0432\u0430\u0448\u0438\u044F\u0442 Ledger \u0435 \u0441\u0432\u044A\u0440\u0437\u0430\u043D \u0438 \u0447\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E NEAR \u0435 \u043E\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u043Da \u043D\u0435\u0433\u043E.",
        "continue": "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0435\u0442\u0435",
        specifyHDPath: "\u041F\u043E\u0441\u043E\u0447\u0435\u0442\u0435 HD \u043F\u044A\u0442",
        enterYourPreferredHDPath: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043F\u0440\u0435\u0434\u043F\u043E\u0447\u0438\u0442\u0430\u043D\u0438\u044F HD \u043F\u044A\u0442, \u0441\u043B\u0435\u0434 \u043A\u043E\u0435\u0442\u043E \u0441\u043A\u0430\u043D\u0438\u0440\u0430\u0439\u0442\u0435 \u0437\u0430 \u0430\u043A\u0442\u0438\u0432\u043D\u0438 \u0430\u043A\u0430\u0443\u043D\u0442\u0438.",
        scan: "\u0421\u043A\u0430\u043D\u0438\u0440\u0430\u0439\u0442\u0435",
        retry: "\u041E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u043E\u0442\u043D\u043E\u0432\u043E",
        ledgerIsNotAvailable: "Ledger \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E\u0442\u043E \u043D\u0435 \u0435 \u0434\u043E\u0441\u0442\u044A\u043F\u043D\u043E",
        accessDeniedToUseLedgerDevice: "\u0414\u043E\u0441\u0442\u044A\u043F\u044A\u0442 \u0437\u0430 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435 \u043D\u0430 Ledger \u0435 \u043E\u0442\u043A\u0430\u0437\u0430\u043D",
        noAccountsFound: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0438",
        selectYourAccounts: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u0442\u0435 \u043F\u0440\u043E\u0444\u0438\u043B\u0438",
        connecting1Account: "\u0421\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435 \u043D\u0430 1 \u043F\u0440\u043E\u0444\u0438\u043B",
        cantFindAnyAccount: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0438, \u0441\u044A\u0432\u0440\u0437\u0430\u043D\u0438 \u0441 \u0442\u043E\u0437\u0438 Ledger. \u041C\u043E\u043B\u044F, \u0441\u044A\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432 NEAR \u043F\u0440\u043E\u0444\u0438\u043B \u043D\u0430",
        orConnectAnAnotherLedger: "\u0438\u043B\u0438 \u0441\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0434\u0440\u0443\u0433 Ledger.",
        connecting: "\u0421\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435",
        ofAccounts: "\u043E\u0442 \u043F\u0440\u043E\u0444\u0438\u043B\u0438",
        failedToAutomatically: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E\u0442\u043E \u043D\u0430\u043C\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043F\u0440\u043E\u0444\u0438\u043B\u0430 \u043D\u0435 \u0431\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E. \u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0433\u043E \u0440\u044A\u0447\u043D\u043E:",
        overviewTheListOfAuthorized: "\u041F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0439\u0442\u0435 \u0441\u043F\u0438\u0441\u044A\u043A\u0430 \u0441 \u0443\u043F\u044A\u043B\u043D\u043E\u043C\u043E\u0449\u0435\u043D\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0438, \u0437\u0430\u0432\u044A\u0440\u0448\u0435\u0442\u0435 \u0432\u043B\u0438\u0437\u0430\u043D\u0435\u0442\u043E, \u043A\u0430\u0442\u043E \u0449\u0440\u0430\u043A\u043D\u0435\u0442\u0435 \u0432\u044A\u0440\u0445\u0443 \u0431\u0443\u0442\u043E\u043D\u0430 \u043F\u043E-\u0434\u043E\u043B\u0443..",
        finish: "\u0417\u0430\u0432\u044A\u0440\u0448\u0435\u0442\u0435"
    },
    install: {
        youllNeedToInstall: "\u0429\u0435 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u0442\u0435",
        toContinueAfterInstalling: "\u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435. \u0421\u043B\u0435\u0434 \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u043D\u0435",
        refreshThePage: "\u043F\u0440\u0435\u0437\u0430\u0440\u0435\u0434\u0435\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0442\u0430.",
        open: "\u041E\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    },
    qr: {
        copiedToClipboard: "\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u043E \u0432 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434\u0430",
        failedToCopy: "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043A\u043E\u043F\u0438\u0440\u0430\u043D\u0435 \u0432 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434\u0430",
        scanWithYourMobile: " \u0421\u043A\u0430\u043D\u0438\u0440\u0430\u0439\u0442\u0435 \u0441 \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0442\u043E \u0441\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E",
        copyToClipboard: " \u041A\u043E\u043F\u0438\u0440\u0430\u0439\u0442\u0435 \u0432 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434\u0430",
        preferTheOfficial: "\u041F\u0440\u0435\u0434\u043F\u043E\u0447\u0438\u0442\u0430\u043D \u0435\u0437\u0438\u043A \u0437\u0430 \u043A\u043E\u0440\u0435\u0441\u043F\u043E\u043D\u0434\u0435\u043D\u0446\u0438\u044F",
        open: "\u041E\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    }
};
var $5bb7220e37bd460f$var$bg = {
    modal: $5bb7220e37bd460f$var$modal$8
};
var $5bb7220e37bd460f$var$modal$7 = {
    wallet: {
        connectYourWallet: "\uC9C0\uAC11 \uC5F0\uACB0\uD558\uAE30",
        whatIsAWallet: "\uC9C0\uAC11\uC740 \uBB34\uC2A8 \uC5ED\uD560\uC744 \uD558\uB098\uC694?",
        secureAndManage: "\uB2F9\uC2E0\uC758 \uB514\uC9C0\uD138 \uC790\uC0B0\uC744 \uBCF4\uD638\uD558\uACE0 \uAD00\uB9AC\uD569\uB2C8\uB2E4.",
        safelyStore: "\uC554\uD638\uD654\uD3D0\uC640 NFT\uB97C \uC548\uC804\uD558\uAC8C \uC800\uC7A5\uD558\uACE0 \uC804\uC1A1\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        logInToAny: "NEAR App\uC5D0 \uB85C\uADF8\uC778\uD569\uB2C8\uB2E4.",
        noNeedToCreate: "\uC0C8\uB85C\uC6B4 \uACC4\uC815\uC774\uB098 \uBE44\uBC00\uBC88\uD638\uB97C \uB9CC\uB4E4 \uD544\uC694 \uC5C6\uC774 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD55C \uD6C4 \uBC14\uB85C \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        getAWallet: "\uC9C0\uAC11 \uAC00\uC838\uC624\uAE30",
        useAWallet: "\uC9C0\uAC11\uC744 \uC0AC\uC6A9\uD558\uC5EC NEAR \uC790\uC0B0\uC744 \uBCF4\uD638\xb7\uAD00\uB9AC\uD558\uACE0, \uC544\uC774\uB514\uC640 \uBE44\uBC00\uBC88\uD638 \uC5C6\uC774 NEAR \uC571\uC5D0 \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        connectionFailed: "\uC5F0\uACB0 \uC2E4\uD328",
        connectionSuccessful: "\uC5F0\uACB0 \uC131\uACF5",
        connected: "Connected",
        connectingTo: "\uC5F0\uACB0 \uC911: ",
        connectingMessage: {
            injected: "\uC775\uC2A4\uD150\uC158 \uCC3D\uC5D0\uC11C \uC5F0\uACB0\uC744 \uD655\uC778\uD558\uC138\uC694",
            browser: "\uB9AC\uB2E4\uC774\uB809\uD2B8 \uB41C \uC9C0\uAC11\uC5D0\uC11C \uC5F0\uACB0\uC744 \uD655\uC778\uD558\uC138\uC694",
            hardware: "Ledger \uAE30\uAE30\uC5D0\uC11C \uC5F0\uACB0\uC744 \uD655\uC778\uD558\uC138\uC694",
            bridge: "\uC9C0\uAC11\uC5D0\uC11C \uC5F0\uACB0 \uD655\uC778"
        }
    },
    ledger: {
        connectWithLedger: "Ledger \uC5F0\uACB0\uD558\uAE30",
        makeSureYourLedger: "Ledger\uAC00 \uC548\uC804\uD558\uAC8C \uC5F0\uACB0\uB418\uC5B4 \uC788\uACE0, NEAR \uC571\uC774 \uC5F4\uB824 \uC788\uB294 \uC9C0 \uD655\uC778\uD558\uC138\uC694",
        "continue": "\uACC4\uC18D\uD558\uAE30",
        specifyHDPath: "HD Path \uC9C0\uC815\uD558\uAE30",
        enterYourPreferredHDPath: "\uC6D0\uD558\uB294 HD Path\uB97C \uC120\uD0DD\uD558\uACE0, \uD65C\uC131\uD654\uB41C \uACC4\uC815\uC774 \uC788\uB294 \uC9C0 \uAC80\uC0C9\uD558\uC138\uC694",
        scan: "\uAC80\uC0C9",
        retry: "\uB2E4\uC2DC \uC2DC\uB3C4",
        ledgerIsNotAvailable: "Ledger\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
        accessDeniedToUseLedgerDevice: "Ledger \uAE30\uAE30 \uC811\uADFC \uAD8C\uD55C\uC774 \uAC70\uBD80\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
        noAccountsFound: "\uACC4\uC815\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
        selectYourAccounts: "\uACC4\uC815 \uC120\uD0DD\uD558\uAE30",
        connecting1Account: "\uD558\uB098\uC758 \uACC4\uC815\uC5D0 \uC5F0\uACB0",
        cantFindAnyAccount: "Ledger\uC640 \uC5F0\uACB0\uB41C \uACC4\uC815\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC0C8\uB85C\uC6B4 \uACC4\uC815\uC744 \uC0DD\uC131\uD558\uAC70\uB098 ",
        orConnectAnAnotherLedger: "\uB2E4\uB978 Ledger\uB97C \uC5F0\uACB0\uD558\uC138\uC694",
        connecting: "\uACC4\uC815 \uC5F0\uACB0\uD558\uAE30: ",
        ofAccounts: "\uAC1C \uACC4\uC815\uC744 \uCC3E\uC558\uC2B5\uB2C8\uB2E4",
        failedToAutomatically: "\uACC4\uC815 ID\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4. \uC218\uB3D9\uC73C\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
        overviewTheListOfAuthorized: "\uC778\uC99D\uB41C \uACC4\uC815 \uBAA9\uB85D\uC744 \uD655\uC778\uD55C \uD6C4 \uC544\uB798 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uB85C\uADF8\uC778\uC744 \uC644\uB8CC\uD558\uC138\uC694",
        finish: "\uC644\uB8CC"
    },
    install: {
        youllNeedToInstall: "\uB2E4\uC74C \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD574\uC8FC\uC138\uC694:",
        toContinueAfterInstalling: ". \uC124\uCE58 \uC644\uB8CC \uD6C4 \uD398\uC774\uC9C0 \uC0C8\uB85C \uACE0\uCE68\uC774 \uD544\uC694\uD569\uB2C8\uB2E4. ",
        refreshThePage: "\uC0C8\uB85C \uACE0\uCE68",
        open: "Open"
    },
    qr: {
        copiedToClipboard: "\uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC \uC644\uB8CC",
        failedToCopy: "\uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC \uC2E4\uD328",
        scanWithYourMobile: "\uBAA8\uBC14\uC77C \uC7A5\uCE58\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC2A4\uCE94\uD574\uC8FC\uC138\uC694",
        copyToClipboard: " \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uD558\uAE30",
        preferTheOfficial: "\uB2E4\uC74C \uD504\uB85C\uADF8\uB7A8\uC5D0\uC11C \uC81C\uACF5\uD558\uB294 \uACF5\uC2DD \uD504\uB85C\uC138\uC2A4\uB97C \uC120\uD638\uD558\uC2ED\uB2C8\uAE4C: ",
        open: "Open"
    }
};
var $5bb7220e37bd460f$var$ko = {
    modal: $5bb7220e37bd460f$var$modal$7
};
var $5bb7220e37bd460f$var$modal$6 = {
    wallet: {
        connectYourWallet: "K\u1EBFt n\u1ED1i v\xed c\u1EE7a b\u1EA1n",
        whatIsAWallet: "V\xed l\xe0 g\xec?",
        secureAndManage: "B\u1EA3o m\u1EADt & Qu\u1EA3n l\xfd t\xe0i s\u1EA3n s\u1ED1 c\u1EE7a b\u1EA1n",
        safelyStore: "L\u01B0u tr\u1EEF v\xe0 chuy\u1EC3n ti\u1EC1n \u0111i\u1EC7n t\u1EED v\xe0 NFT c\u1EE7a b\u1EA1n m\u1ED9t c\xe1ch an to\xe0n.",
        logInToAny: "\u0110\u0103ng nh\u1EADp v\xe0o b\u1EA5t k\u1EF3 \u1EE9ng d\u1EE5ng tr\xean NEAR",
        noNeedToCreate: "Kh\xf4ng c\u1EA7n t\u1EA1o t\xe0i kho\u1EA3n ho\u1EB7c th\xf4ng tin \u0111\u0103ng nh\u1EADp m\u1EDBi. K\u1EBFt n\u1ED1i v\xed c\u1EE7a b\u1EA1n v\xe0 b\u1EAFt \u0111\u1EA7u!",
        getAWallet: "T\u1EA1o V\xed",
        useAWallet: "S\u1EED d\u1EE5ng v\xed \u0111\u1EC3 b\u1EA3o m\u1EADt v\xe0 qu\u1EA3n l\xfd t\xe0i s\u1EA3n tr\xean NEAR c\u1EE7a b\u1EA1n v\xe0 \u0111\u0103ng nh\u1EADp v\xe0o b\u1EA5t k\u1EF3 \u1EE9ng d\u1EE5ng NEAR n\xe0o, kh\xf4ng c\u1EA7n t\xean ng\u01B0\u1EDDi d\xf9ng v\xe0 m\u1EADt kh\u1EA9u.",
        connectionFailed: "K\u1EBFt n\u1ED1i th\u1EA5t b\u1EA1i",
        connectionSuccessful: "K\u1EBFt n\u1ED1i th\xe0nh c\xf4ng",
        connected: "\u0110\xe3 k\u1EBFt n\u1ED1i",
        connectingTo: "\u0110ang k\u1EBFt n\u1ED1i t\u1EDBi",
        connectingMessage: {
            injected: "X\xe1c nh\u1EADn k\u1EBFt n\u1ED1i trong c\u1EEDa s\u1ED5 ti\u1EC7n \xedch m\u1EDF r\u1ED9ng",
            browser: "X\xe1c nh\u1EADn k\u1EBFt n\u1ED1i trong v\xed sau khi \u0111\u01B0\u1EE3c chuy\u1EC3n h\u01B0\u1EDBng",
            hardware: "X\xe1c nh\u1EADn k\u1EBFt n\u1ED1i v\u1EDBi v\xed l\u1EA1nh",
            bridge: "X\xe1c nh\u1EADn k\u1EBFt n\u1ED1i trong v\xed"
        }
    },
    ledger: {
        connectWithLedger: "K\u1EBFt n\u1ED1i v\xed Ledger",
        makeSureYourLedger: "\u0110\u1EA3m b\u1EA3o Ledger c\u1EE7a b\u1EA1n \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i an to\xe0n v\xe0 \u1EE9ng d\u1EE5ng NEAR \u0111ang m\u1EDF s\u1EB5n tr\xean thi\u1EBFt b\u1ECB",
        "continue": "Ti\u1EBFp t\u1EE5c",
        specifyHDPath: "Ch\u1EC9 \u0111\u1ECBnh HD Path",
        enterYourPreferredHDPath: "Nh\u1EADp HD Path c\u1EE7a b\u1EA1n, sau \u0111\xf3 qu\xe9t t\xecm c\xe1c t\xe0i kho\u1EA3n ho\u1EA1t \u0111\u1ED9ng",
        scan: "Qu\xe9t",
        retry: "Th\u1EED l\u1EA1i",
        ledgerIsNotAvailable: "Ledger kh\xf4ng kh\u1EA3 d\u1EE5ng",
        accessDeniedToUseLedgerDevice: "Truy c\u1EADp Ledger b\u1ECB t\u1EEB ch\u1ED1i",
        noAccountsFound: "Kh\xf4ng t\xecm th\u1EA5y t\xe0i kho\u1EA3n",
        selectYourAccounts: "Ch\u1ECDn t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n",
        connecting1Account: "\u0110ang k\u1EBFt n\u1ED1i 1 t\xe0i kho\u1EA3n",
        cantFindAnyAccount: "Kh\xf4ng th\u1EC3 t\xecm th\u1EA5y b\u1EA5t k\u1EF3 t\xe0i kho\u1EA3n n\xe0o \u0111\u01B0\u1EE3c li\xean k\u1EBFt v\u1EDBi Ledger n\xe0y. Vui l\xf2ng t\u1EA1o m\u1ED9t t\xe0i kho\u1EA3n NEAR m\u1EDBi",
        orConnectAnAnotherLedger: "ho\u1EB7c k\u1EBFt n\u1ED1i v\u1EDBi v\xed Ledger kh\xe1c.",
        connecting: "\u0110ang k\u1EBFt n\u1ED1i",
        ofAccounts: "c\u1EE7a t\xe0i kho\u1EA3n",
        failedToAutomatically: "Kh\xf4ng th\u1EC3 t\u1EF1 \u0111\u1ED9ng t\xecm id t\xe0i kho\u1EA3n. Nh\u1EADp th\u1EE7 c\xf4ng:",
        overviewTheListOfAuthorized: "T\u1ED5ng quan danh s\xe1ch c\xe1c t\xe0i kho\u1EA3n \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n, ho\xe0n t\u1EA5t \u0111\u0103ng nh\u1EADp b\u1EB1ng c\xe1ch b\u1EA5m v\xe0o n\xfat b\xean d\u01B0\u1EDBi.",
        finish: "Ho\xe0n th\xe0nh"
    },
    install: {
        youllNeedToInstall: "B\u1EA1n s\u1EBD c\u1EA7n c\xe0i \u0111\u1EB7t",
        toContinueAfterInstalling: "\u0111\u1EC3 b\u1EAFt \u0111\u1EA7u. Sau khi c\xe0i \u0111\u1EB7t xong",
        refreshThePage: "T\u1EA3i l\u1EA1i trang.",
        open: "M\u1EDF"
    },
    qr: {
        copiedToClipboard: "\u0110\xe3 sao ch\xe9p v\xe0o b\u1EA3ng ghi t\u1EA1m",
        failedToCopy: "Sao ch\xe9p v\xe0o b\u1EA3ng ghi t\u1EA1m th\u1EA5t b\u1EA1i",
        scanWithYourMobile: "Qu\xe9t v\u1EDBi \u0111i\u1EC7n tho\u1EA1i c\u1EE7a b\u1EA1n",
        copyToClipboard: " Sao ch\xe9p v\xe0o b\u1EA3ng ghi t\u1EA1m",
        preferTheOfficial: "Dialogue ch\xednh th\u1EE9c c\u1EE7a",
        open: "M\u1EDF"
    },
    exportAccounts: {
        chooseAWallet: "Ch\u1ECDn v\xed",
        transferYourAccounts: "Chuy\u1EC3n t\xe0i kho\u1EA3n",
        selectAWallet: "Ch\u1ECDn v\xed ph\xf9 h\u1EE3p v\u1EDBi nhu c\u1EA7u c\u1EE7a b\u1EA1n, v\xed \u0111\u01B0\u1EE3c ch\u1ECDn c\u1EA7n h\u1ED7 tr\u1EE3 c\xe1c t\xe0i kho\u1EA3n \u0111ang s\u1EED d\u1EE5ng.",
        selectYourAccounts: "Ch\u1ECDn t\xe0i kho\u1EA3n",
        afterDecide: "Sau khi ch\u1ECDn \u0111\u01B0\u1EE3c t\xe0i kho\u1EA3n b\u1EA1n c\xf3 chuy\u1EC3n.",
        disclaimer: "B\u1EA1n kh\xf4ng th\u1EC3 chuy\u1EC3n t\xe0i kho\u1EA3n n\u1EBFu t\xe0i kho\u1EA3n \u0111\xf3 ch\u01B0a \u0111\u01B0\u1EE3c nh\u1EADn ti\u1EC1n ho\u1EB7c ch\u01B0a ph\xe1t sinh giao d\u1ECBch tr\xean NEAR.",
        warning: "kh\xf4ng h\u1ED7 tr\u1EE3 xu\u1EA5t t\xe0i kho\u1EA3n. Vui l\xf2ng ch\u1ECDn v\xed kh\xe1c.",
        walletTypes: {
            hardware: "V\xed l\u1EA1nh",
            browser: "V\xed tr\xecnh duy\u1EC7t",
            injected: "V\xed ti\u1EC7n \xedch m\u1EDF r\u1ED9ng",
            bridge: "V\xed C\u1EA7u",
            mobile: "V\xed Mobile"
        },
        selectAccounts: {
            title: "Ch\u1ECDn t\xe0i kho\u1EA3n \u0111\u1EC3 chuy\u1EC3n",
            button: "L\u1EA5y c\u1EE5m m\u1EADt kh\u1EA9u",
            deselectAll: "B\u1ECF ch\u1ECDn t\u1EA5t c\u1EA3",
            selectAll: "Ch\u1ECDn t\u1EA5t c\u1EA3",
            unavailable: "Chuy\u1EC3n kh\xf4ng kh\u1EA3 d\u1EE5ng",
            error: "T\xe0i kho\u1EA3n kh\xf4ng t\u1ED3n t\u1EA1i",
            warningLedger: "Y\xeau c\u1EA7u h\u1ED7 tr\u1EE3 Ledger",
            noBalance: "T\xe0i kho\u1EA3n tr\u1ED1ng"
        },
        getPassphrase: {
            title: "Sao ch\xe9p m\u1EADt kh\u1EA9u t\u1EA1m th\u1EDDi",
            desc: "B\u1EA1n s\u1EBD c\u1EA7n nh\u1EADp m\u1EADt kh\u1EA9u khi b\u1EAFt \u0111\u1EA7u xu\u1EA5t c\xe1c kho\u1EA3n t\u1EDBi v\xed kh\xe1c.",
            button: "Ti\u1EBFp t\u1EE5c",
            label: "B\u1EA5m \u0111\u1EC3 sao ch\xe9p",
            checkLabel: "T\xf4i \u0111\xe3 ch\xe9p ho\u1EB7c ghi l\u1EA1i m\u1EADt kh\u1EA9u"
        },
        complete: {
            title: "Ho\xe0n th\xe0nh chuy\u1EC3n",
            descOne: "B\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c chuy\u1EC3n h\u01B0\u1EDBng t\u1EDBi t\xe0i kho\u1EA3n \u0111\xe3 ch\u1ECDn \u0111\u1EC3 ho\xe0n t\u1EA5t qu\xe1 tr\xecnh.",
            descTwo: "Sau khi nh\u1EADp, nh\u1EA5n n\xfat \u0111\u1EC3 ho\xe0n t\u1EA5t quy tr\xecnh chuy\u1EC3n.",
            button: "Ho\xe0n th\xe0nh"
        }
    }
};
var $5bb7220e37bd460f$var$component = {
    clickToCopy: {
        label: "\u0110\xe3 sao ch\xe9p",
        tooltip: "B\u1EA5m \u0111\u1EC3 sao ch\xe9p"
    }
};
var $5bb7220e37bd460f$var$vi = {
    modal: $5bb7220e37bd460f$var$modal$6,
    component: $5bb7220e37bd460f$var$component
};
var $5bb7220e37bd460f$var$modal$5 = {
    wallet: {
        connectYourWallet: "\u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F (Wallet) \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902\u0964",
        whatIsAWallet: "\u0935\u0949\u0932\u0947\u091F \u0915\u094D\u092F\u093E \u0939\u0948?",
        secureAndManage: "\u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0914\u0930 \u092A\u094D\u0930\u092C\u0902\u0927\u093F\u0924 \u0915\u0930\u0947\u0902\u0964",
        safelyStore: "\u0905\u092A\u0928\u0940 \u0915\u094D\u0930\u093F\u092A\u094D\u091F\u094B\u0915\u0930\u0947\u0902\u0938\u0940 \u0914\u0930 \u090F\u0928\u090F\u092B\u091F\u0940 \u0915\u094B \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u0938\u094D\u091F\u094B\u0930 \u0914\u0930 \u091F\u094D\u0930\u093E\u0902\u0938\u092B\u0930 \u0915\u0930\u0947\u0902\u0964",
        logInToAny: "NEAR \u092A\u0930 \u0915\u093F\u0938\u0940 \u092D\u0940 \u0910\u092A \u092E\u0947\u0902 \u0938\u093E\u0907\u0928 \u0907\u0928 \u0915\u0930\u0947\u0902\u0964",
        noNeedToCreate: "\u0928\u090F \u0916\u093E\u0924\u0947 \u092F\u093E \u0932\u0949\u0917\u093F\u0928 \u092C\u0928\u093E\u0928\u0947 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0928\u0939\u0940\u0902 \u0939\u0948\u0964 \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F(NEAR Wallet)\u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902 \u0914\u0930 \u0906\u0930\u0902\u092D \u0915\u0930\u0947\u0902\u0964",
        getAWallet: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0901\u0964",
        useAWallet: "\u0905\u092A\u0928\u0940 NEAR \u0938\u0902\u092A\u0924\u094D\u0924\u093F\u092F\u094B\u0902 \u0915\u094B \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0914\u0930 \u092A\u094D\u0930\u092C\u0902\u0927\u093F\u0924 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0947\u0902 \u0914\u0930 \u0915\u093F\u0938\u0940 \u092D\u0940 NEAR \u0910\u092A (app) \u092E\u0947\u0902 \u0932\u0949\u0917 \u0907\u0928 \u0915\u0930\u0947\u0902, \u0915\u093F\u0938\u0940 \u0909\u092A\u092F\u094B\u0917\u0915\u0930\u094D\u0924\u093E (user) \u0928\u093E\u092E \u0914\u0930 \u092A\u093E\u0938\u0935\u0930\u094D\u0921 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0928\u0939\u0940\u0902 \u0939\u0948\u0964",
        connectionFailed: "\u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0935\u093F\u092B\u0932|",
        connectionSuccessful: "\u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0938\u092B\u0932|",
        connected: "\u0935\u0949\u0932\u0947\u091F \u091C\u0941\u095C \u0917\u092F\u093E|",
        connectingTo: "\u0935\u0949\u0932\u0947\u091F \u091C\u0941\u095C \u0930\u0939\u093E \u0939\u0947|",
        connectingMessage: {
            injected: "\u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0935\u093F\u0902\u0921\u094B \u092E\u0947\u0902 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902|",
            browser: "\u0930\u0940\u0921\u093E\u092F\u0930\u0947\u0915\u094D\u091F \u0939\u094B\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926 \u0935\u0949\u0932\u0947\u091F \u092E\u0947\u0902 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902|",
            hardware: "\u0915\u094B\u0932\u094D\u0921 \u0935\u0949\u0932\u0947\u091F \u0915\u0947 \u0938\u093E\u0925 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902|"
        }
    },
    ledger: {
        connectWithLedger: "\u0932\u0947\u091C\u0930(Ledger)\u0935\u0949\u0932\u0947\u091F \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902|",
        makeSureYourLedger: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A\u0915\u093E \u0932\u0947\u091C\u0930 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u091C\u0941\u0921\u093C\u093E \u0939\u0941\u0906 \u0939\u0948 \u0914\u0930 NEAR \u0910\u092A \u0906\u092A\u0915\u0947 \u0921\u093F\u0935\u093E\u0907\u0938 (Device)\u092A\u0930 \u092A\u0939\u0932\u0947 \u0938\u0947 \u0939\u0940 \u0916\u0941\u0932\u093E \u0939\u0948|",
        "continue": "\u091C\u093E\u0930\u0940 \u0930\u0916\u0947|",
        specifyHDPath: "\u0939\u093E\u0930\u094D\u0921 \u0921\u093F\u0938\u094D\u0915(Hard Disk)\u092A\u0925(Path)\u0928\u093F\u0930\u094D\u0927\u093E\u0930\u093F\u0924 \u0915\u0930\u0947|",
        enterYourPreferredHDPath: "\u0905\u092A\u0928\u093E \u090F\u091A\u0921\u0940 \u092A\u0925 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902, \u092B\u093F\u0930 \u0938\u0915\u094D\u0930\u093F\u092F \u0916\u093E\u0924\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902|",
        scan: "\u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947|",
        retry: "\u0926\u094B\u092C\u093E\u0930\u093E \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947|",
        ledgerIsNotAvailable: "\u0932\u0947\u091C\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948|",
        accessDeniedToUseLedgerDevice: "\u0932\u0947\u091C\u0930 \u0921\u093F\u0935\u093E\u0907\u0938 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092A\u094D\u0930\u0935\u0947\u0936 \u0928\u093F\u0937\u0947\u0927|",
        noAccountsFound: "\u0916\u093E\u0924\u093E \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E|",
        selectYourAccounts: "\u0905\u092A\u0928\u0947 \u0916\u093E\u0924\u0947 \u091A\u0941\u0928\u0947\u0902|",
        connecting1Account: "\u090F\u0915 \u0916\u093E\u0924\u093E \u0915\u0928\u0947\u0915\u094D\u091F \u0939\u094B \u0930\u0939\u093E \u0939\u0948|",
        cantFindAnyAccount: "\u0907\u0938 \u0932\u0947\u091C\u0930 \u0938\u0947 \u091C\u0941\u0921\u093C\u093E \u0915\u094B\u0908 \u0916\u093E\u0924\u093E \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E\u0964 \u0915\u0943\u092A\u092F\u093E \u090F\u0915 \u0928\u092F\u093E NEAR \u0916\u093E\u0924\u093E \u092C\u0928\u093E\u090F\u0901|",
        orConnectAnAnotherLedger: "\u0905\u0925\u0935\u093E \u0926\u0942\u0938\u0930\u0947 \u0932\u0947\u091C\u0930 \u0935\u0949\u0932\u0947\u091F \u0938\u0947 \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902\u0964",
        connecting: "\u091C\u0941\u095C \u0930\u0939\u093E \u0939\u0947|",
        ofAccounts: "\u0916\u093E\u0924\u093E \u0905\u092C \u091C\u0941\u095C\u093E \u0928\u0939\u0940\u0902 \u0939\u0947|",
        failedToAutomatically: "\u0916\u093E\u0924\u093E \u0906\u0908\u0921\u0940 \u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u0916\u094B\u091C\u0928\u0947 \u092E\u0947\u0902 \u0905\u0938\u092E\u0930\u094D\u0925\u0964 \u092E\u0948\u0928\u094D\u092F\u0941\u0905\u0932 (Manuall) \u0930\u0942\u092A \u0938\u0947 \u0915\u094B\u0936\u093F\u0936 \u0915\u0930\u0947\u0902|",
        overviewTheListOfAuthorized: "\u0905\u0935\u0932\u094B\u0915\u0928 \u0905\u0927\u093F\u0915\u0943\u0924 \u0915\u0940 \u0938\u0942\u091A\u0940, \u0928\u0940\u091A\u0947 \u0926\u093F\u090F \u0917\u090F \u092C\u091F\u0928 \u092A\u0930 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0915\u0947 \u0932\u0949\u0917\u093F\u0928 \u092A\u0942\u0930\u093E \u0915\u0930\u0947\u0902\u0964",
        finish: "\u0938\u092E\u093E\u092A\u094D\u0924|"
    },
    install: {
        youllNeedToInstall: "\u0906\u092A\u0915\u094B \u0907\u0902\u0938\u094D\u091F\u0949\u0932 \u0915\u0930\u0928\u093E \u0939\u094B\u0917\u093E|",
        toContinueAfterInstalling: "\u0907\u0902\u0938\u094D\u091F\u0949\u0932 \u0915\u0930\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926 \u091C\u093E\u0930\u0940 \u0930\u0916\u0947|",
        refreshThePage: "\u092A\u0941\u0928: \u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964",
        open: "\u0916\u094B\u0932\u0947|"
    },
    qr: {
        copiedToClipboard: "\u0915\u094D\u0932\u093F\u092A\u092C\u094B\u0930\u094D\u0921(Clipboard)\u092A\u0930 \u0915\u0949\u092A\u0940 \u0915\u093F\u092F\u093E \u0917\u092F\u093E|",
        failedToCopy: "\u0915\u094D\u0932\u093F\u092A\u092C\u094B\u0930\u094D\u0921 \u092A\u0930 \u0915\u0949\u092A\u0940 \u0915\u0930\u0928\u093E \u0935\u093F\u092B\u0932 \u0930\u0939\u093E|",
        scanWithYourMobile: "\u0905\u092A\u0928\u0947 \u092B\u094B\u0928 (Mobile)\u0938\u0947 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902|",
        copyToClipboard: " \u0915\u094D\u0932\u093F\u092A\u092C\u094B\u0930\u094D\u0921 \u092A\u0930 \u0915\u0949\u092A\u0940 \u0915\u0930\u0947\u0902|",
        preferTheOfficial: "\u0906\u0927\u093F\u0915\u093E\u0930\u093F\u0915 \u0938\u0902\u0935\u093E\u0926 \u0915\u094B \u092A\u094D\u0930\u093E\u0925\u092E\u093F\u0915\u0924\u093E \u0926\u0947\u0902|",
        open: "\u0916\u094B\u0932\u0947|"
    }
};
var $5bb7220e37bd460f$var$hi = {
    modal: $5bb7220e37bd460f$var$modal$5
};
var $5bb7220e37bd460f$var$modal$4 = {
    wallet: {
        connectYourWallet: "\u0635\u0644 \u0645\u062D\u0641\u0638\u062A\u0643",
        whatIsAWallet: "\u0645\u0627 \u0647\u064A \u0627\u0644\u0645\u062D\u0641\u0638\u0629\u061F",
        secureAndManage: "\u062A\u0623\u0645\u064A\u0646 \u0648\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0645\u062A\u0644\u0643\u0627\u062A \u0627\u0644\u0631\u0642\u0645\u064A\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643",
        safelyStore: "\u0642\u0645 \u0628\u062A\u062E\u0632\u064A\u0646 \u0648 \u0627\u0631\u0633\u0627\u0644 \u0639\u0645\u0644\u0627\u062A\u0643 \u0648 \u0623\u0635\u0648\u0644\u0643 \u0627\u0644\u0631\u0642\u0645\u064A\u0629 \u0628\u0623\u0645\u0627\u0646",
        logInToAny: "\u0633\u062C\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0623\u064A \u062A\u0637\u0628\u064A\u0642 \u064A\u0633\u062A\u062E\u062F\u0645 \u0646\u064A\u0631",
        noNeedToCreate: ".\u0644\u0627 \u062F\u0627\u0639\u064A \u0644\u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628 \u062C\u062F\u064A\u062F. \u0641\u0642\u0637 \u0642\u0645 \u0628\u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u062A\u0643 \u0648\u0627\u0646\u0637\u0644\u0642",
        getAWallet: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0645\u062D\u0641\u0638\u0629",
        useAWallet: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0645\u062D\u0641\u0638\u0629 \u0644\u062A\u0623\u0645\u064A\u0646 \u0648\u0625\u062F\u0627\u0631\u0629 \u0623\u0635\u0648\u0644 \u0646\u064A\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643\u060C \u0648\u0627\u062F\u062E\u0644 \u0644\u0623\u064A \u062A\u0637\u0628\u064A\u0642 \u064A\u0633\u062A\u062E\u062F\u0645 \u0646\u064A\u0631 \u062F\u0648\u0646 \u0627\u0644\u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0648\u0643\u0644\u0645\u0629\u0627\u0644\u0645\u0631\u0648\u0631",
        connectionFailed: "\u0627\u062A\u0635\u0627\u0644 \u0641\u0627\u0634\u0644",
        connectionSuccessful: "\u0627\u062A\u0635\u0627\u0644 \u0646\u0627\u062C\u062D",
        connected: "\u0645\u062A\u0635\u0644",
        connectingTo: "\u062C\u0627\u0631\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628",
        connectingMessage: {
            injected: "\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u064A \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0625\u0636\u0627\u0641\u0629",
            browser: "\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u064A \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0628\u0639\u062F \u0625\u0639\u0627\u062F\u0629 \u062A\u0648\u062C\u064A\u0647",
            hardware: "\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u064A \u062C\u0647\u0627\u0632 \u0644\u064A\u062F\u062C\u0631",
            bridge: "\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u064A \u0627\u0644\u0645\u062D\u0641\u0638\u0629"
        }
    },
    ledger: {
        connectWithLedger: "\u0627\u062A\u0635\u0644 \u0645\u0639 \u0644\u064A\u062F\u062C\u0631",
        makeSureYourLedger: "\u062A\u0623\u0643\u062F \u0623\u0646 \u0644\u064A\u062F\u062C\u0631 \u0645\u062A\u0635\u0644 \u0628\u0623\u0645\u0627\u0646, \u0648 \u0623\u0646 \u062A\u0637\u0628\u064A\u0642 \u0646\u064A\u0631 \u0645\u0641\u062A\u0648\u062D \u0641\u064A \u062C\u0647\u0627\u0632\u0643",
        "continue": "\u062A\u0627\u0628\u0639",
        specifyHDPath: "\u062D\u062F\u062F \u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0633\u0627\u0628",
        enterYourPreferredHDPath: "\u0623\u062F\u062E\u0644 \u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0641\u0636\u0644\u060C \u062B\u0645 \u0627\u0628\u062D\u062B \u0639\u0646 \u0643\u0644 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0646\u0634\u0637\u0629",
        scan: "\u0645\u0633\u062D",
        retry: "\u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
        ledgerIsNotAvailable: "\u0644\u064A\u062F\u062C\u0631 \u063A\u064A\u0631 \u0645\u062A\u0648\u0641\u0631",
        accessDeniedToUseLedgerDevice: "\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0644\u064A\u062F\u062C\u0631",
        noAccountsFound: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0623\u064A \u062D\u0633\u0627\u0628\u0627\u062A",
        selectYourAccounts: "\u062D\u062F\u062F \u062D\u0633\u0627\u0628\u0627\u062A\u0643",
        connecting1Account: "\u062C\u0627\u0631\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u062D\u0633\u0627\u0628 \u0648\u0627\u062D\u062F",
        cantFindAnyAccount: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0623\u064A \u062D\u0633\u0627\u0628 \u0645\u0631\u062A\u0628\u0637 \u0628\u0647\u0630\u0627 \u0644\u064A\u062F\u062C\u0631 \u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628 \u0646\u064A\u0631 \u062C\u062F\u064A\u062F \u0639\u0644\u0649",
        orConnectAnAnotherLedger: "\u0627\u0648 \u0627\u0631\u0628\u0637 \u062C\u0647\u0627\u0632 \u0644\u064A\u062F\u062C\u0631 \u0622\u062E\u0631",
        connecting: "\u062C\u0627\u0631\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
        ofAccounts: "\u0645\u0646 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A",
        failedToAutomatically: "\u0641\u0634\u0644 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u062D\u0633\u0627\u0628 \u062A\u0644\u0642\u0627\u0626\u064A\u0627. \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u062D\u0633\u0627\u0628 \u064A\u062F\u0648\u064A\u0627",
        overviewTheListOfAuthorized: "\u0644\u0627\u0626\u062D\u0629 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0645\u0635\u0631\u062D \u0628\u0647\u0627, \u0623\u0643\u0645\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0644\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u0632\u0631 \u0623\u062F\u0646\u0627\u0647",
        finish: "\u0625\u0646\u0647\u0627\u0621"
    },
    install: {
        youllNeedToInstall: "\u0633\u062A\u062D\u062A\u0627\u062C \u0644\u062A\u062B\u0628\u064A\u062A",
        toContinueAfterInstalling: "\u0644\u0644\u0627\u0633\u062A\u0643\u0645\u0627\u0644. \u0628\u0639\u062F \u0627\u0644\u062A\u062B\u0628\u064A\u062A",
        refreshThePage: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629",
        open: "\u0627\u0641\u062A\u062D"
    },
    qr: {
        copiedToClipboard: "\u062A\u0645 \u0627\u0644\u0646\u0633\u062E",
        failedToCopy: "\u0641\u0634\u0644 \u0627\u0644\u0646\u0633\u062E",
        scanWithYourMobile: "\u0627\u0645\u0633\u062D \u0628\u062C\u0647\u0627\u0632\u0643 \u0627\u0644\u0645\u062D\u0645\u0648\u0644",
        copyToClipboard: "\u0646\u0633\u062E",
        preferTheOfficial: "\u062A\u0641\u0636\u0644 \u0627\u0644\u062D\u0648\u0627\u0631 \u0627\u0644\u0631\u0633\u0645\u064A \u0644",
        open: "\u0641\u062A\u062D"
    }
};
var $5bb7220e37bd460f$var$ar = {
    modal: $5bb7220e37bd460f$var$modal$4
};
var $5bb7220e37bd460f$var$modal$3 = {
    wallet: {
        connectYourWallet: "Spojite crypto nov\u010Danik!",
        whatIsAWallet: "\u0160to je to crypto nov\u010Danik?",
        secureAndManage: "Osigurajte i upravljajte svojom digitalnom imovinom.",
        safelyStore: "Sigurno pohranite i prebacite svoj crypto i NFT-eve.",
        logInToAny: " Prijavite se u bilo koju NEAR aplikaciju",
        noNeedToCreate: "Nema potrebe za stvaranjem novih naloga ili korisni\u010Dkih podataka. Spojite svoj crypto nov\u010Danik i spremni ste!",
        getAWallet: "Otvorite crypto nov\u010Danik",
        useAWallet: "Koristite crypto nov\u010Danik da biste osigurali i upravljali svojom NEAR imovinom, te se prijavite u bilo koju NEAR aplikaciju bez korisni\u010Dkog imena i lozinke.",
        connectionFailed: "Neuspje\u0161no povezivanje.",
        connectionSuccessful: "Uspje\u0161no povezivanje.",
        connected: "Povezano.",
        connectingTo: "Povezivanje u tijeku",
        connectingMessage: {
            injected: "Potvrdite vezu u eksternom prozoru",
            browser: "Nakon redirekcije, potvrdite vezu u nov\u010Daniku",
            hardware: "Potvrdite vezu sa nov\u010Danikom",
            bridge: "Potvrdite vezu u nov\u010Daniku"
        }
    },
    ledger: {
        connectWithLedger: "Pove\u017Eite se hardverskim nov\u010Danikom",
        makeSureYourLedger: "Osigurajte sigurnu vezu s hardverskim nov\u010Danikom, te da je NEAR aplikacija otvorena na va\u0161em ure\u0111aju",
        "continue": "Nastavite",
        specifyHDPath: "Specificirajte HD putanju",
        enterYourPreferredHDPath: "Upi\u0161ite preferiranu HD putanju, zatim skenirajte aktivne naloge",
        scan: "Skenirajte",
        retry: "Poku\u0161ajte ponovno",
        ledgerIsNotAvailable: "Hardverski nov\u010Danik nije dostupan.",
        accessDeniedToUseLedgerDevice: "Odbijen pristup za kori\u0161tenjem hardverskog nov\u010Danika",
        noAccountsFound: "Nalozi nisu prona\u0111eni",
        selectYourAccounts: "Odaberite svoje naloge",
        connecting1Account: "Povezivanje 1 naloga",
        cantFindAnyAccount: "Nije mogu\u0107e prona\u0107i niti jedan nalog povezan s ovim hardverskim nov\u010Danikom. Molimo vas, kreirajte novi NEAR nalog",
        orConnectAnAnotherLedger: "Ili pove\u017Eite drugi hardverski nov\u010Danik.",
        connecting: "Povezivanje",
        ofAccounts: "naloga",
        failedToAutomatically: "Neuspje\u0161no automatsko pronala\u017Eenje ID naloga. Unesite ru\u010Dno:",
        overviewTheListOfAuthorized: "Pregledajte popis odobrenih naloga, zavr\u0161ite prijavu pritiskom na ni\u017Ee prikazani gumb.",
        finish: "Zavr\u0161ite"
    },
    install: {
        youllNeedToInstall: " Potrebno je instalirati modal",
        toContinueAfterInstalling: "za nastavak. Nakon instalacije",
        refreshThePage: "osvje\u017Eite stranicu.",
        open: "Otvorite QR modal"
    },
    qr: {
        copiedToClipboard: "Kopirano u me\u0111uspremnik",
        failedToCopy: "Neupsje\u0161no kopiranje u me\u0111uspremnik",
        scanWithYourMobile: "Skenirajte svojim mobilnim ure\u0111ajem",
        copyToClipboard: " Kopirajte u me\u0111uspremnik",
        preferTheOfficial: "Odaberite slu\u017Ebeni dijalog",
        open: "Otvorite"
    },
    exportAccounts: {
        chooseAWallet: "Odaberi Wallet",
        transferYourAccounts: "Prenesi svoje naloge",
        selectAWallet: "Odaberite wallet koji odgovara va\u0161im potrebama i podr\u017Eava va\u0161e povezane naloge.",
        selectYourAccounts: "Odaberi svoje naloge",
        afterDecide: "Nakon \u0161to odlu\u010Dite koji wallet koristite, mo\u017Eete odabrati koje ra\u010Dune \u017Eelite prebaciti.",
        disclaimer: "Ne\u0107ete mo\u0107i prebaciti naloge koji nisu nikada bili kori\u0161teni na NEAR-u.",
        warning: "ne podr\u017Eava izvoz naloga u ovom trenutku. Molimo odaberite drugi wallet.",
        walletTypes: {
            hardware: "Hardware Wallet",
            browser: "Browser Wallet",
            injected: "Wallet Extension",
            bridge: "Bridge Wallet",
            mobile: "Mobile Wallet"
        },
        selectAccounts: {
            title: "Odaberi naloge za prijenos",
            button: "Generiraj lozinku",
            deselectAll: "Makni odabir sa svih",
            selectAll: "Odaberi sve",
            unavailable: "Prijenos nije dostupan",
            error: "Nalog ne postoji",
            warningLedger: "Potrebna ledger podr\u0161ka",
            noBalance: "Nalog nema sredstava"
        },
        getPassphrase: {
            title: "Kopiraj privremenu lozinku",
            desc: "Bit \u0107e potrebno unijeti ovu lozinku na po\u010Detku izvoza naloga na drugi wallet.",
            button: "Nastavi",
            label: "Klikni za kopiju",
            checkLabel: "Kopirao sam ili zapisao lozinku"
        },
        complete: {
            title: "Zavr\u0161i prijenos",
            descOne: "You will now be redirected to the wallet you selected to complete the transfer.",
            descTwo: "Kada je unos s odabranog walleta zavr\u0161en, pritisnite gumb da biste zavr\u0161ili prijenos.",
            button: "Zavr\u0161i"
        }
    }
};
var $5bb7220e37bd460f$var$hr = {
    modal: $5bb7220e37bd460f$var$modal$3
};
var $5bb7220e37bd460f$var$modal$2 = {
    wallet: {
        connectYourWallet: "\u041F\u043E\u0432\u0440\u0437\u0435\u0442\u0435 \u0433\u043E \u0432\u0430\u0448\u0438\u043E\u0442 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A!",
        whatIsAWallet: "\u0428\u0442\u043E \u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A?",
        secureAndManage: "\u0417\u0430\u0448\u0442\u0438\u0442\u0435\u0442\u0435 \u0433\u0438 \u0438 \u0443\u043F\u0440\u0430\u0432\u0443\u0432\u0430\u0458\u0442\u0435 \u0441\u043E \u0432\u0430\u0448\u0438\u0442\u0435 \u0434\u0438\u0433\u0438\u0442\u0430\u043B\u043D\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430.",
        safelyStore: "\u0411\u0435\u0437\u0431\u0435\u0434\u043D\u043E \u0441\u043A\u043B\u0430\u0434\u0438\u0440\u0430\u0458\u0442\u0435 \u0438 \u0438\u0437\u0432\u0440\u0448\u0443\u0432\u0430\u0458\u0442\u0435 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0438 \u0441\u043E \u0432\u0430\u0448\u0438\u0442\u0435 \u043A\u0440\u0438\u043F\u0442\u043E \u0438 NFT.",
        logInToAny: "\u041D\u0430\u0458\u0430\u0432\u0435\u0442\u0435 \u0441\u0435 \u043D\u0430 \u043A\u043E\u0458\u0430 \u0431\u0438\u043B\u043E NEAR \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0430",
        noNeedToCreate: "\u041D\u0435\u043C\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0430 \u0434\u0430 \u043A\u0440\u0435\u0438\u0440\u0430\u0442\u0435 \u043D\u043E\u0432\u0438 \u0441\u043C\u0435\u0442\u043A\u0438 \u0438\u043B\u0438 \u0438\u043D\u0433\u0435\u0440\u0435\u043D\u0446\u0438\u0438. \u041F\u043E\u0432\u0440\u0437\u0435\u0442\u0435 \u0433\u043E \u0432\u0430\u0448\u0438\u043E\u0442 \u043F\u0430\u0440\u0438\u0447\u043D\u0438\u043A \u0438 \u0441\u0442\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u0435\u043D\u0438!",
        getAWallet: "\u041D\u0430\u043F\u0440\u0430\u0432\u0435\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        useAWallet: "\u041A\u043E\u0440\u0438\u0441\u0442\u0435\u0442\u0435 \u043F\u0430\u0440\u0438\u0447\u043D\u0438\u043A \u0437\u0430 \u0434\u0430 \u0433\u0438 \u0437\u0430\u0448\u0442\u0438\u0442\u0438\u0442\u0435 \u0438 \u0443\u043F\u0440\u0430\u0432\u0443\u0432\u0430\u0442\u0435 \u0432\u0430\u0448\u0438\u0442\u0435 NEAR \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 \u0438 \u0434\u0430 \u0441\u0435 \u043D\u0430\u0458\u0430\u0432\u0438\u0442\u0435 \u043D\u0430 \u043A\u043E\u0458\u0430 \u0431\u0438\u043B\u043E NEAR \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0430 \u0431\u0435\u0437 \u043F\u043E\u0442\u0440\u0435\u0431\u0430 \u043E\u0434 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0438\u043C\u0438\u045A\u0430 \u0438 \u043B\u043E\u0437\u0438\u043D\u043A\u0438.",
        connectionFailed: "\u041F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435\u0442\u043E \u043D\u0435 \u0431\u0435\u0448\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E.",
        connectionSuccessful: "\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435.",
        connected: "\u041F\u043E\u0432\u0440\u0437\u0430\u043D\u043E.",
        connectingTo: "\u041F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435 \u0441\u043E",
        connectingMessage: {
            injected: "\u041F\u043E\u0442\u0432\u0440\u0434\u0435\u0442\u0435 \u0433\u043E \u043F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435\u0442\u043E \u0432\u043E \u0435\u043A\u0441\u0442\u0435\u0440\u043D\u0438\u043E\u0442 \u043F\u0440\u043E\u0437\u043E\u0440\u0435\u0446",
            browser: "\u041F\u043E \u043F\u0440\u0435\u0443\u0441\u043C\u0435\u0440\u0443\u0432\u0430\u045A\u0435\u0442\u043E, \u043F\u043E\u0442\u0432\u0440\u0434\u0435\u0442\u0435 \u0433\u043E \u043F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435\u0442\u043E \u043E\u0434 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043E\u043A\u0442",
            hardware: "\u041F\u043E\u0442\u0432\u0440\u0434\u0435\u0442\u0435 \u0433\u043E \u043F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435\u0442\u043E \u0441\u043E \u043B\u0430\u0434\u0435\u043D \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            bridge: "\u041F\u043E\u0442\u0432\u0440\u0434\u0435\u0442\u0435 \u0458\u0430 \u0432\u0440\u0441\u043A\u0430\u0442\u0430 \u0432\u043E \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u043E\u0442"
        }
    },
    ledger: {
        connectWithLedger: "\u041F\u043E\u0432\u0440\u0437\u0435\u0442\u0435 \u0441\u0435 \u0441\u043E \u041B\u0435\u045F\u0435\u0440",
        makeSureYourLedger: "\u041E\u0441\u0438\u0433\u0443\u0440\u0430\u0458\u0442\u0435 \u0441\u0435 \u0434\u0435\u043A\u0430 \u0432\u0430\u0448\u0438\u043E\u0442 \u041B\u0435\u045F\u0435\u0440 \u0435 \u043F\u043E\u0432\u0440\u0437\u0430\u043D \u0431\u0435\u0437\u0431\u0435\u0434\u043D\u043E, \u0438 \u0434\u0435\u043A\u0430 NEAR \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0430\u0442\u0430 \u0435 \u043E\u0442\u0432\u043E\u0440\u0435\u043D\u0430 \u043D\u0430 \u0432\u0430\u0448\u0438\u043E\u0442 \u0443\u0440\u0435\u0434",
        "continue": "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u0442\u0435",
        specifyHDPath: "\u041D\u0430\u0432\u0435\u0434\u0435\u0442\u0435 \u0425\u0414 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0430",
        enterYourPreferredHDPath: "\u0412\u043D\u0435\u0441\u0435\u0442\u0435 \u0458\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0435\u0444\u0435\u0440\u0438\u0440\u0430\u043D\u0430 \u0425\u0414 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0430, \u0430 \u043F\u043E\u0442\u043E\u0430 \u0441\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435 \u0434\u0430 \u0433\u0438 \u043D\u0430\u0458\u0434\u0435\u0442\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0442\u0435 \u0441\u043C\u0435\u0442\u043A\u0438.",
        scan: "\u0421\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435",
        retry: "\u041E\u0431\u0438\u0434\u0435\u0442\u0435 \u0441\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
        ledgerIsNotAvailable: "\u041B\u0435\u045F\u0435\u0440\u043E\u0442 \u043D\u0435 \u0435 \u0434\u043E\u0441\u0442\u0430\u043F\u0435\u043D.",
        accessDeniedToUseLedgerDevice: "\u041F\u0440\u0438\u0441\u0442\u0430\u043F\u043E\u0442 \u0437\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0435\u045A\u0435 \u043D\u0430 \u041B\u0435\u045F\u0435\u0440 \u0443\u0440\u0435\u0434 \u0435 \u043E\u0434\u0431\u0438\u0435\u043D",
        noAccountsFound: "\u041D\u0435\u043C\u0430 \u043D\u0430\u0458\u0434\u0435\u043D\u0438 \u0441\u043C\u0435\u0442\u043A\u0438",
        selectYourAccounts: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0433\u0438 \u0432\u0430\u0448\u0438\u0442\u0435 \u0441\u043C\u0435\u0442\u043A\u0438",
        connecting1Account: "\u041F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435 \u043D\u0430 \u0435\u0434\u043D\u0430 \u0441\u043C\u0435\u0442\u043A\u0430",
        cantFindAnyAccount: "\u041D\u0435 \u0441\u0435 \u043D\u0430\u0458\u0434\u0435\u043D\u0438 \u0441\u043C\u0435\u0442\u043A\u0438 \u043F\u043E\u0432\u0440\u0437\u0430\u043D\u0438 \u0441\u043E \u043E\u0432\u043E\u0458 \u041B\u0435\u045F\u0435\u0440. \u0412\u0435 \u043C\u043E\u043B\u0438\u043C\u0435 \u043A\u0440\u0435\u0438\u0440\u0430\u0458\u0442\u0435 \u043D\u043E\u0432\u0430 NEAR \u0441\u043C\u0435\u0442\u043A\u0430 ",
        orConnectAnAnotherLedger: "\u0438\u043B\u0438 \u043F\u043E\u0432\u0440\u0437\u0435\u0442\u0435 \u0434\u0440\u0443\u0433 \u041B\u0435\u045F\u0435\u0440.",
        connecting: "\u041F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435",
        ofAccounts: "\u043D\u0430 \u0441\u043C\u0435\u0442\u043A\u0438",
        failedToAutomatically: "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0441\u043A\u043E \u0431\u0430\u0440\u0430\u045A\u0435 \u043D\u0430 \u0418\u0414 \u043D\u0430 \u0441\u043C\u0435\u0442\u043A\u0430\u0442\u0430. \u0412\u043D\u0435\u0441\u0435\u0442\u0435 \u0433\u043E \u0440\u0430\u0447\u043D\u043E:",
        overviewTheListOfAuthorized: "\u041F\u0440\u0435\u0433\u043B\u0435\u0434 \u043D\u0430 \u043B\u0438\u0441\u0442\u0430\u0442\u0430 \u043D\u0430 \u043E\u0432\u043B\u0430\u0441\u0442\u0435\u043D\u0438 \u0441\u043C\u0435\u0442\u043A\u0438, \u0437\u0430\u0432\u0440\u0448\u0435\u0442\u0435 \u0441\u0435 \u043D\u0430\u0458\u0430\u0432\u0430\u0442\u0430 \u0441\u043E \u043A\u043B\u0438\u043A\u043D\u0443\u0432\u0430\u045A\u0435 \u043D\u0430 \u043A\u043E\u043F\u0447\u0435\u0442\u043E \u043F\u043E\u0434\u043E\u043B\u0443.",
        finish: "\u0417\u0430\u0432\u0440\u0448\u0435\u0442\u0435"
    },
    install: {
        youllNeedToInstall: "\u0422\u0440\u0435\u0431\u0430 \u0434\u0430 \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u0442\u0435",
        toContinueAfterInstalling: "\u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435. \u041F\u043E \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u045A\u0435\u0442\u043E",
        refreshThePage: "\u041E\u0441\u0432\u0435\u0436\u0435\u0442\u0435 \u0458\u0430 \u0441\u0442\u0440\u0430\u043D\u0430\u0442\u0430.",
        open: "\u041E\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    },
    qr: {
        copiedToClipboard: "\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u043E \u043D\u0430 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434\u043E\u0442",
        failedToCopy: "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043A\u043E\u043F\u0438\u0440\u0430\u045A\u0435 \u043D\u0430 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434",
        scanWithYourMobile: "\u0421\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435 \u0441\u043E \u0432\u0430\u0448\u0438\u043E\u0442 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0441\u043A\u0438 \u0443\u0440\u0435\u0434",
        copyToClipboard: "\u041A\u043E\u043F\u0438\u0440\u0430\u0458\u0442\u0435 \u043D\u0430 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434",
        preferTheOfficial: "\u041F\u0440\u0435\u0444\u0435\u0440\u0438\u0440\u0430\u0458\u0442\u0435 \u043E\u0444\u0438\u0446\u0438\u0458\u0430\u043B\u0435\u043D \u0434\u0438\u0430\u043B\u043E\u0433 \u043D\u0430",
        open: "\u041E\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    },
    exportAccounts: {
        chooseAWallet: "\u041E\u0434\u0431\u0435\u0440\u0435\u0442\u0435 \u043F\u0430\u0440\u0438\u0447\u043D\u0438\u043A",
        transferYourAccounts: "\u041F\u0440\u0435\u0444\u0440\u043B\u0435\u0442\u0435 \u0433\u0438 \u0432\u0430\u0448\u0438\u0442\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438",
        selectAWallet: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435\u043D \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043A\u043E\u0458 \u0433\u0438 \u0437\u0430\u0434\u043E\u0432\u043E\u043B\u0443\u0432\u0430 \u0432\u0430\u0448\u0438\u0442\u0435 \u0431\u0430\u0440\u0430\u043D\u045A\u0430 \u0438 \u0433\u0438 \u043F\u043E\u0434\u0434\u0440\u0436\u0443\u0432\u0430 \u0432\u0430\u0448\u0438\u0442\u0435 \u043F\u043E\u0432\u0440\u0437\u0430\u043D\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438.",
        selectYourAccounts: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0433\u0438 \u0432\u0430\u0448\u0438\u0442\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438",
        afterDecide: "\u041E\u0434\u043A\u0430\u043A\u043E \u045C\u0435 \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A, \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043A\u043E\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438 \u0441\u0430\u043A\u0430\u0442\u0435 \u0434\u0430 \u0433\u0438 \u043F\u0440\u0435\u0444\u0440\u043B\u0438\u0442\u0435.",
        disclaimer: "\u041D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u043F\u0440\u0444\u0440\u043B\u0430\u0442\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438 \u043A\u043E\u0438 \u043D\u0438\u043A\u043E\u0433\u0430\u0448 \u043D\u0435 \u0431\u0438\u043B\u0435 \u043D\u0430\u0434\u043E\u043F\u043E\u043B\u043D\u0430\u0442\u0438 \u0438\u043B\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0435\u043D\u0438 \u043D\u0430 NEAR.",
        warning: "\u043D\u0435 \u043F\u043E\u0434\u0434\u0440\u0436\u0443\u0432\u0430 \u0438\u0437\u0432\u0435\u0437\u0443\u0432\u0430\u045A\u0435 \u043D\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438 \u0432\u043E \u043E\u0432\u043E\u0458 \u043C\u043E\u043C\u0435\u043D\u0442. \u0412\u0435 \u043C\u043E\u043B\u0438\u043C\u0435 \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0434\u0440\u0443\u0433 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A.",
        walletTypes: {
            hardware: "\u0425\u0430\u0440\u0434\u0432\u0435\u0440\u0441\u043A\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            browser: "\u041D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043D\u0430 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u0440\u0435\u043B\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
            injected: "\u0415\u043A\u0441\u0442\u0435\u043D\u0437\u0438\u0458\u0430 \u0437\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            bridge: "Bridge \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            mobile: "\u041C\u043E\u0431\u0438\u043B\u0435\u043D \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A"
        },
        selectAccounts: {
            title: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0433\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438\u0442\u0435 \u0441\u043C\u0435\u0442\u043A\u0438 \u0437\u0430 \u0434\u0430 \u0433\u0438 \u043F\u0440\u0435\u0444\u0440\u043B\u0438\u0442\u0435.",
            button: "\u0414\u043E\u0431\u0438\u0458\u0442\u0435 \u043B\u043E\u0437\u0438\u043D\u043A\u0430",
            deselectAll: "\u041E\u0442\u0441\u0435\u043B\u0435\u043A\u0442\u0438\u0440\u0430\u0458\u0442\u0435 \u0441\u0435",
            selectAll: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0441\u0435",
            unavailable: "\u0422\u0440\u0430\u043D\u0441\u0444\u0435\u0440\u043E\u0442 \u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u043F\u0435\u043D",
            error: "\u041A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0430\u0442\u0430 \u0441\u043C\u0435\u0442\u043A\u0430 \u043D\u0435 \u043F\u043E\u0441\u0442\u043E\u0438",
            warningLedger: "\u041F\u043E\u0442\u0440\u0435\u0431\u043D\u0430 \u0435 \u043F\u043E\u0434\u0434\u0440\u0448\u043A\u0430 \u043E\u0434 \u041B\u0435\u045F\u0435\u0440",
            noBalance: "\u0421\u043C\u0435\u0442\u043A\u0430\u0442\u0430 \u043D\u0435 \u0435 \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u0430\u043D\u0430"
        },
        getPassphrase: {
            title: "\u041A\u043E\u043F\u0438\u0440\u0430\u0458\u0442\u0435 \u0458\u0430 \u043F\u0440\u0438\u0432\u0440\u0435\u043C\u0435\u043D\u0430\u0442\u0430 \u043B\u043E\u0437\u0438\u043D\u043A\u0430",
            desc: "\u040C\u0435 \u0442\u0440\u0435\u0431\u0430 \u0434\u0430 \u0458\u0430 \u0432\u043D\u0435\u0441\u0435\u0442\u0435 \u043E\u0432\u0430\u0430 \u043B\u043E\u0437\u0438\u043D\u043A\u0430 \u043A\u043E\u0433\u0430 \u045C\u0435 \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0434\u0430 \u0433\u0438 \u0438\u0437\u0432\u0435\u0437\u0443\u0432\u0430\u0442\u0435 \u0432\u0430\u0448\u0438\u0442\u0435 \u0441\u043C\u0435\u0442\u043A\u0438 \u043D\u0430 \u0434\u0440\u0443\u0433 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A.",
            button: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u0442\u0435",
            label: "\u041A\u043B\u0438\u043A\u043D\u0435\u0442\u0435 \u0437\u0430 \u0434\u0430 \u043A\u043E\u043F\u0438\u0440\u0430\u0442\u0435",
            checkLabel: "\u0408\u0430 \u043A\u043E\u043F\u0438\u0440\u0430\u0432 \u0438\u043B\u0438 \u0437\u0430\u043F\u0438\u0448\u0430\u0432 \u043B\u043E\u0437\u0438\u043D\u043A\u0430\u0442\u0430"
        },
        complete: {
            title: "\u0417\u0430\u0432\u0440\u0448\u0435\u0442\u0435 \u0433\u043E \u043F\u0440\u0435\u043D\u043E\u0441\u043E\u0442",
            descOne: "\u0421\u0435\u0433\u0430 \u045C\u0435 \u0431\u0438\u0434\u0435\u0442\u0435 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0435\u043D\u0438 \u043D\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u043E\u0442 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u0437\u0430 \u0437\u0430\u0432\u0440\u0448\u0443\u0432\u0430\u045A\u0435 \u043D\u0430 \u043F\u0440\u0435\u043D\u043E\u0441\u043E\u0442.",
            descTwo: "\u041E\u0442\u043A\u0430\u043A\u043E \u045C\u0435 \u0437\u0430\u0432\u0440\u0448\u0438 \u0443\u0432\u043E\u0437\u043E\u0442 \u043E\u0434 \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u043E\u0442 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A, \u043F\u0440\u0438\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u0433\u043E \u043A\u043E\u043F\u0447\u0435\u0442\u043E \u0437\u0430 \u0434\u0430 \u0433\u043E \u0437\u0430\u0432\u0440\u0448\u0438\u0442\u0435 \u043F\u0440\u0435\u043D\u043E\u0441\u043E\u0442.",
            button: "\u0417\u0430\u0432\u0440\u0448\u0435\u0442\u0435"
        }
    }
};
var $5bb7220e37bd460f$var$mk = {
    modal: $5bb7220e37bd460f$var$modal$2
};
var $5bb7220e37bd460f$var$modal$1 = {
    wallet: {
        connectYourWallet: "Pove\u017Eite svojo denarnico!",
        whatIsAWallet: "Kaj je denarnica?",
        secureAndManage: "Zavarujte in upravljajte svoja digitalna sredstva.",
        safelyStore: "Varno shranjujte in prena\u0161ajte svoje kriptovalute in NFTje.",
        logInToAny: "Prijavite se v katero koli aplikacijo na NEAR",
        noNeedToCreate: "Ni vam treba ustvarjati novih ra\u010Dunov. Pove\u017Eite svojo denarnico in za\u010Dnite!",
        getAWallet: "Ustvarite denarnico",
        useAWallet: "Uporabite denarnico, da bi zavarovali in upravljali s svoja NEAR digitalna sredstva, in se prijavite v katero koli aplikacijo ekosistema NEAR",
        connectionFailed: "Povezava ni bila uspe\u0161na.",
        connectionSuccessful: "Povezava je bila uspe\u0161na.",
        connected: "Va\u0161a denarnica je povezana.",
        connectingTo: "Povezovanje z",
        connectingMessage: {
            injected: "Potrdite povezavo v oknu raz\u0161iritve",
            browser: "Po preusmeritvi potrdite povezavo v denarnici",
            hardware: "Potrdite povezavo s hladno denarnico",
            bridge: "Potrdite povezavo v denarnici"
        }
    },
    ledger: {
        connectWithLedger: "Pove\u017Eite se z Ledger",
        makeSureYourLedger: "Prepri\u010Dajte se, da je va\u0161 Ledger varno povezan in da je aplikacija NEAR odprta v va\u0161i napravi",
        "continue": "Nadaljuj",
        specifyHDPath: "Dolo\u010Dite HD pot",
        enterYourPreferredHDPath: "Vnesite \u017Eeleno HD pot, nato poi\u0161\u010Dite vse aktivne ra\u010Dune.",
        scan: "Skenirajte",
        retry: "Poskusite znova",
        ledgerIsNotAvailable: "Ledger ni na voljo",
        accessDeniedToUseLedgerDevice: "Dostop za uporabo naprave Ledger zavrnjen",
        noAccountsFound: "Ni najdenih ra\u010Dunov",
        selectYourAccounts: "Izberite Va\u0161i ra\u010Duni",
        connecting1Account: "Povezovanje enega ra\u010Duna",
        cantFindAnyAccount: "Ni mogo\u010De najti nobenega ra\u010Duna, povezanega s tem Ledgerjem. Ustvarite nov NEAR ra\u010Dun ",
        orConnectAnAnotherLedger: "ali pove\u017Eite drug Ledger..",
        connecting: "Povezovanje",
        ofAccounts: "ra\u010Dunov",
        failedToAutomatically: "ID-ja ra\u010Duna ni bilo mogo\u010De samodejno najti. Zagotovite ga ro\u010Dno:",
        overviewTheListOfAuthorized: "Oglejte si seznam poobla\u0161\u010Denih ra\u010Dunov, dokon\u010Dajte prijavo s klikom na spodnji gumb.",
        finish: "Kon\u010Dajte"
    },
    install: {
        youllNeedToInstall: "Morali ga boste namestiti",
        toContinueAfterInstalling: "nadaljevati. Po namestitvi",
        refreshThePage: "Osve\u017Eite stran.",
        open: "Odprite"
    },
    qr: {
        copiedToClipboard: "Kopirano v podlo\u017Eni mapi",
        failedToCopy: "Kopiranje v podlo\u017Eni mapi ni uspelo",
        scanWithYourMobile: "Skenirajte s svojo mobilno napravo",
        copyToClipboard: " Kopirajte v podlo\u017Eni mapi",
        preferTheOfficial: "Preferirajte uradno pogovorno okno",
        open: "Odprite"
    },
    exportAccounts: {
        chooseAWallet: "Izberite denarnico",
        transferYourAccounts: "Prenesite svoje ra\u010Dune",
        selectAWallet: "Izberite denarnico, ki ustreza va\u0161im potrebam in podpira va\u0161e povezane ra\u010Dune.",
        selectYourAccounts: "Izberite va\u0161i ra\u010Duni",
        afterDecide: "Ko se odlo\u010Dite za denarnico, lahko izberete, katere ra\u010Dune \u017Eelite prenesti.",
        disclaimer: "Ne boste mogli prenesti Ra\u010Dunov, ki nikoli niso bili financirani ali uporabljeni na NEAR.",
        warning: "trenutno ne podpira izvoza ra\u010Duna. Izberite drugo denarnico",
        walletTypes: {
            hardware: "Hladna denarnica",
            browser: "Denarnica brskalnika",
            injected: "Raz\u0161iritev za denarnico",
            bridge: "Bridge denarnica",
            mobile: "Mobilna denarnica"
        },
        selectAccounts: {
            title: "Izberite ra\u010Duni za prenos.",
            button: "Pridobite geslo",
            deselectAll: "Prekli\u010Di izbiro vseh",
            selectAll: "Izberi vse",
            unavailable: "Prenos ni na voljo",
            error: "Ra\u010Dun ne obstaja",
            warningLedger: "Potrebna je podpora za Ledger",
            noBalance: "Ra\u010Dun ni financiran"
        },
        getPassphrase: {
            title: "Kopiraj za\u010Dasno geslo",
            desc: "To geslo boste morali vnesti, ko boste za\u010Deli izva\u017Eati svoje ra\u010Dune v drugo denarnico.",
            button: "Nadaljujte",
            label: "Kliknite za kopiranje",
            checkLabel: "Geslo sem kopiral ali zapisal"
        },
        complete: {
            title: "Dokon\u010Dajte prenos",
            descOne: "Zdaj boste preusmerjeni v denarnico, ki ste jo izbrali za dokon\u010Danje prenosa.",
            descTwo: "Ko je uvozni del postopka kon\u010Dan iz izbrane denarnice, pritisnite gumb za dokon\u010Danje postopka prenosa.",
            button: "Kon\u010Dajte"
        }
    }
};
var $5bb7220e37bd460f$var$sl = {
    modal: $5bb7220e37bd460f$var$modal$1
};
var $5bb7220e37bd460f$var$modal = {
    wallet: {
        connectYourWallet: "\u041F\u043E\u0432\u0435\u0436\u0438\u0442\u0435 \u0441\u0432\u043E\u0458 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A!",
        whatIsAWallet: "\u0428\u0442\u0430 \u0458\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A?",
        secureAndManage: "\u041E\u0431\u0435\u0437\u0431\u0435\u0434\u0438\u0442\u0435 \u0438 \u0443\u043F\u0440\u0430\u0432\u0459\u0430\u0458\u0442\u0435 \u0441\u0432\u043E\u0458\u043E\u043C \u0434\u0438\u0433\u0438\u0442\u0430\u043B\u043D\u043E\u043C \u0438\u043C\u043E\u0432\u0438\u043D\u043E\u043C.",
        safelyStore: "\u0411\u0435\u0437\u0431\u0435\u0434\u043D\u043E \u0447\u0443\u0432\u0430\u0458\u0442\u0435 \u0438 \u043F\u0440\u0435\u043D\u043E\u0441\u0438\u0442\u0435 \u0441\u0432\u043E\u0458\u0435 \u043A\u0440\u0438\u043F\u0442\u043E\u0432\u0430\u043B\u0443\u0442\u0435 \u0438 NFT.",
        logInToAny: "\u041F\u0440\u0438\u0458\u0430\u0432\u0438\u0442\u0435 \u0441\u0435 \u043D\u0430 \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u0443 \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0443 NEAR",
        noNeedToCreate: "\u041D\u0435\u043C\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0435 \u0434\u0430 \u043A\u0440\u0435\u0438\u0440\u0430\u0442\u0435 \u043D\u043E\u0432\u0435 \u043D\u0430\u043B\u043E\u0433\u0435 \u0438\u043B\u0438 \u0430\u043A\u0440\u0435\u0434\u0438\u0442\u0438\u0432\u0435. \u041F\u043E\u0432\u0435\u0436\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u0438 \u0441\u043F\u0440\u0435\u043C\u043D\u0438 \u0441\u0442e!",
        getAWallet: "\u041D\u0430\u0431\u0430\u0432\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        useAWallet: "\u041A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u0434\u0430 \u043E\u0431\u0435\u0437\u0431\u0435\u0434\u0438\u0442\u0435 \u0438 \u0443\u043F\u0440\u0430\u0432\u0459\u0430\u0442\u0435 \u0441\u0432\u043E\u0458\u0438\u043C NEAR \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0438\u043C\u0430 \u0438 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0458\u0430\u0432\u0438\u0442\u0435 \u0443 \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u0443 \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0443 NEAR \u0431\u0435\u0437 \u043F\u043E\u0442\u0440\u0435\u0431\u0435 \u0437\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438\u043C \u0438\u043C\u0435\u043D\u0438\u043C\u0430 \u0438 \u043B\u043E\u0437\u0438\u043D\u043A\u0430\u043C\u0430.",
        connectionFailed: "\u0412\u0435\u0437\u0430 \u043D\u0438\u0458\u0435 \u0443\u0441\u043F\u043E\u0441\u0442\u0430\u0432\u0459\u0435\u043D\u0430.",
        connectionSuccessful: "\u0412\u0435\u0437\u0430 \u0458\u0435 \u0443\u0441\u043F\u0435\u043B\u0430.",
        connected: "\u041F\u043E\u0432\u0435\u0437\u0430\u043D.",
        connectingTo: "\u041F\u043E\u0432\u0435\u0437\u0438\u0432\u0430\u045A\u0435 \u043D\u0430",
        connectingMessage: {
            injected: "\u041F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0435 \u0432\u0435\u0437\u0443 \u0443 \u0441\u043F\u043E\u0459\u043D\u043E\u043C \u043F\u0440\u043E\u0437\u043E\u0440\u0443",
            browser: "\u041D\u0430\u043A\u043E\u043D \u043F\u0440\u0435\u0443\u0441\u043C\u0435\u0440\u0430\u0432\u0430\u045A\u0430, \u043F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0435 \u0432\u0435\u0437\u0443 \u0443 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0443",
            hardware: "\u041F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0435 \u0432\u0435\u0437\u0443 \u0441\u0430 \u0445\u043B\u0430\u0434\u043D\u0438\u043C \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u043E\u043C",
            bridge: "\u041F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0435 \u0432\u0435\u0437\u0443 \u0441\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u043E\u043C"
        }
    },
    ledger: {
        connectWithLedger: "\u041F\u043E\u0432\u0435\u0436\u0438\u0442\u0435 \u0441\u0435 \u0441\u0430 Ledger",
        makeSureYourLedger: "\u0423\u0432\u0435\u0440\u0438\u0442\u0435 \u0441\u0435 \u0434\u0430 \u0458\u0435 \u0432\u0430\u0448 Ledger \u0431\u0435\u0437\u0431\u0435\u0434\u043D\u043E \u043F\u043E\u0432\u0435\u0437\u0430\u043D \u0438 \u0434\u0430 \u0458\u0435 \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0430 NEAR \u043E\u0442\u0432\u043E\u0440\u0435\u043D\u0430 \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0443\u0440\u0435\u0452\u0430\u0458\u0443",
        "continue": "\u041D\u0430\u0441\u0442\u0430\u0432\u0438",
        specifyHDPath: "\u041D\u0430\u0432\u0435\u0434\u0438\u0442\u0435 \u0425\u0414 \u043F\u0443\u0442\u0430\u045A\u0443",
        enterYourPreferredHDPath: "\u0423\u043D\u0435\u0441\u0438\u0442\u0435 \u0436\u0435\u0459\u0435\u043D\u0443 \u0436\u0435\u0459\u0435\u043D\u0443 \u0425\u0414 \u043F\u0443\u0442\u0430\u045A\u0443, \u0430 \u0437\u0430\u0442\u0438\u043C \u0441\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435 \u0441\u0432\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0435 \u043D\u0430\u043B\u043E\u0433\u0435.",
        scan: "\u0421\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435",
        retry: "\u041F\u043E\u043A\u0443\u0448\u0430\u0458 \u043F\u043E\u043D\u043E\u0432\u043E",
        ledgerIsNotAvailable: "Ledger \u043D\u0438\u0458\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0430\u043D.",
        accessDeniedToUseLedgerDevice: "\u041F\u0440\u0438\u0441\u0442\u0443\u043F \u0458\u0435 \u043E\u0434\u0431\u0438\u0458\u0435\u043D \u0437\u0430 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0435 Ledger \u0443\u0440\u0435\u0452\u0430\u0458\u0430",
        noAccountsFound: "\u041D\u0430l\u043E\u0437\u0438 \u043D\u0438\u0441\u0443 \u043F\u0440\u043E\u043D\u0430\u0452\u0435\u043D\u0438",
        selectYourAccounts: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0412\u0430\u0448 \u043D\u0430l\u043E\u0433",
        connecting1Account: "\u041F\u043E\u0432\u0435\u0437\u0430\u0442\u0438 1 \u043D\u0430l\u043E\u0433",
        cantFindAnyAccount: "\u041D\u0438\u0458\u0435 \u043C\u043E\u0433\u0443\u045B\u0435 \u043F\u0440\u043E\u043D\u0430\u045B\u0438 \u043D\u0438\u0458\u0435\u0434\u0430\u043D \u043D\u0430l\u043E\u0433 \u043F\u043E\u0432\u0435\u0437\u0430\u043D \u0441\u0430 \u043E\u0432\u0438\u043C Ledger-\u043E\u043C. \u041D\u0430\u043F\u0440\u0430\u0432\u0438\u0442\u0435 \u043D\u043E\u0432\u0438 NEAR \u043D\u0430l\u043E\u0433",
        orConnectAnAnotherLedger: "\u0438\u043B\u0438 \u043F\u043E\u0432\u0435\u0436\u0438\u0442\u0435 \u0434\u0440\u0443\u0433\u0438 Ledger.",
        connecting: "\u041F\u043E\u0432\u0435\u0437\u0438\u0432\u0430\u045A\u0435",
        ofAccounts: "\u043D\u0430l\u043E\u0433\u0430",
        failedToAutomatically: "\u0410\u0443\u0442\u043E\u043C\u0430\u0442\u0441\u043A\u043E \u043F\u0440\u043E\u043D\u0430\u043B\u0430\u0436\u0435\u045A\u0435 ID-a \u043D\u0430l\u043E\u0433\u0430 \u043D\u0438\u0458\u0435 \u0443\u0441\u043F\u0435\u043B\u043E. \u041D\u0430\u0432\u0435\u0434\u0438\u0442\u0435 \u0433\u0430 \u0440\u0443\u0447\u043D\u043E:",
        overviewTheListOfAuthorized: "\u041F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0458\u0442\u0435 \u043B\u0438\u0441\u0442\u0443 \u043E\u0432\u043B\u0430\u0448\u045B\u0435\u043D\u0438\u0445 \u0440\u0430\u0447\u0443\u043D\u0430, \u0437\u0430\u0432\u0440\u0448\u0438\u0442\u0435 \u043F\u0440\u0438\u0458\u0430\u0432\u0443 \u043A\u043B\u0438\u043A\u043E\u043C \u043D\u0430 \u0434\u0443\u0433\u043C\u0435 \u0438\u0441\u043F\u043E\u0434.",
        finish: "\u0417\u0430\u0432\u0440\u0448\u0438"
    },
    install: {
        youllNeedToInstall: "\u041C\u043E\u0440\u0430\u045B\u0435\u0442\u0435 \u0434\u0430 \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u0442\u0435",
        toContinueAfterInstalling: "\u0437\u0430 \u043D\u0430\u0441\u0442\u0430\u0432\u0430\u043A. \u041D\u0430\u043A\u043E\u043D \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u045A\u0430",
        refreshThePage: "\u043F\u043E\u043D\u043E\u0432\u043E \u0443\u0447\u0438\u0442\u0430\u0442\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
        open: "\u041E\u0442\u0432\u043E\u0440\u0438"
    },
    qr: {
        copiedToClipboard: "\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u043E \u0443 \u043C\u0435\u0452\u0443\u0441\u043F\u0440\u0435\u043C\u043D\u0438\u043A",
        failedToCopy: "\u041A\u043E\u043F\u0438\u0440\u0430\u045A\u0435 \u0443 \u043C\u0435\u0452\u0443\u0441\u043F\u0440\u0435\u043C\u043D\u0438\u043A \u043D\u0438\u0458\u0435 \u0443\u0441\u043F\u0435\u043B\u043E",
        scanWithYourMobile: "\u0421\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435 \u043F\u043E\u043C\u043E\u045B\u0443 \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0433 \u0443\u0440\u0435\u0452\u0430\u0458\u0430",
        copyToClipboard: " \u041A\u043E\u043F\u0438\u0440\u0430\u0458 \u0443 \u043C\u0435\u0452\u0443\u0441\u043F\u0440\u0435\u043C\u043D\u0438\u043A",
        preferTheOfficial: "\u041F\u0440\u0435\u0444\u0435\u0440\u0438\u0440\u0430\u0442\u0435 \u0437\u0432\u0430\u043D\u0438\u0447\u043D\u0438 \u0434\u0438\u0458\u0430\u043B\u043E\u0433 \u043E\u0434",
        open: "\u041E\u0442\u0432\u043E\u0440\u0438"
    },
    exportAccounts: {
        chooseAWallet: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        transferYourAccounts: "\u041F\u0440\u0435\u043D\u0435\u0441\u0438\u0442\u0435 \u0441\u0432\u043E\u0458\u0435 \u043D\u0430\u043B\u043E\u0433\u0435",
        selectAWallet: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043A\u043E\u0458\u0438 \u043E\u0434\u0433\u043E\u0432\u0430\u0440\u0430 \u0432\u0430\u0448\u0438\u043C \u043F\u043E\u0442\u0440\u0435\u0431\u0430\u043C\u0430 \u0438 \u043A\u043E\u0458\u0438 \u043F\u043E\u0434\u0440\u0436\u0430\u0432\u0430 \u0432\u0430\u0448\u0435 \u043F\u043E\u0432\u0435\u0437\u0430\u043D\u0435 \u043D\u0430\u043B\u043E\u0433\u0435.",
        selectYourAccounts: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0430\u0448\u0435 \u043D\u0430\u043B\u043E\u0433\u0435",
        afterDecide: "\u041D\u0430\u043A\u043E\u043D \u0448\u0442\u043E \u0441\u0435 \u043E\u0434\u043B\u0443\u0447\u0438\u0442\u0435 \u0437\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A, \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0437\u0430\u0431\u0440\u0430\u0442\u0438 \u043A\u043E\u0458\u0435 \u043D\u0430\u043B\u043E\u0433\u0435 \u0436\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u043F\u0440\u0435\u043D\u0435\u0441\u0435\u0442\u0435.",
        disclaimer: "\u041D\u0435\u045B\u0435\u0442\u0435 \u043C\u043E\u045B\u0438 \u0434\u0430 \u043F\u0440\u0435\u043D\u0435\u0441\u0435\u0442\u0435 \u043D\u0430\u043B\u043E\u0433\u0435 \u043A\u043E\u0458\u0438 \u043D\u0438\u043A\u0430\u0434\u0430 \u043D\u0438\u0441\u0443 \u0431\u0438\u043B\u0438 \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u0430\u043D\u0438 \u0438\u043B\u0438 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u043D\u0438 \u043D\u0430  NEAR.",
        warning: "\u0442\u0440\u0435\u043D\u0443\u0442\u043D\u043E \u043D\u0435 \u043F\u043E\u0434\u0440\u0436\u0430\u0432\u0430 \u0438\u0437\u0432\u043E\u0437 \u043D\u0430\u043B\u043E\u0433\u0430. \u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0440\u0443\u0433\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A.",
        walletTypes: {
            hardware: "\u0425\u0430\u0440\u0434\u0432\u0435\u0440\u0441\u043A\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            browser: "\u041D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043F\u0440\u0435\u0442\u0440\u0430\u0436\u0438\u0432\u0430\u0447\u0430,",
            injected: "\u0414\u043E\u0434\u0430\u0442\u0430\u043A \u0437\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A,",
            bridge: "Bridge \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            mobile: "\u041C\u043E\u0431\u0438\u043B\u043D\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A"
        },
        selectAccounts: {
            title: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0430\u043B\u043E\u0433\u0435 \u0437\u0430 \u043F\u0440\u0435\u043D\u043E\u0441.",
            button: "\u0414\u043E\u0431\u0438\u0458\u0442\u0435 \u043F\u0440\u0438\u0441\u0442\u0443\u043F\u043D\u0443 \u0444\u0440\u0430\u0437\u0443",
            deselectAll: "\u041F\u043E\u043D\u0438\u0448\u0442\u0438\u0442\u0435 \u0438\u0437\u0431\u043E\u0440",
            selectAll: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0432\u0435",
            unavailable: "\u0422\u0440\u0430\u043D\u0441\u0444\u0435\u0440 \u043D\u0438\u0458\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0430\u043D",
            error: "\u041D\u0430\u043B\u043E\u0433 \u043D\u0435 \u043F\u043E\u0441\u0442\u043E\u0458\u0438",
            warningLedger: "\u041F\u043E\u0442\u0440\u0435\u0431\u043D\u0430 \u043F\u043E\u0434\u0440\u0448\u043A\u0430 \u0437\u0430 Ledger",
            noBalance: "\u041D\u0430\u043B\u043E\u0433 \u043D\u0438\u0458\u0435 \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u0430\u043D"
        },
        getPassphrase: {
            title: "\u041A\u043E\u043F\u0438\u0440\u0430\u0458 \u043F\u0440\u0438\u0432\u0440\u0435\u043C\u0435\u043D\u0443 \u043B\u043E\u0437\u0438\u043D\u043A\u0443",
            desc: "\u041C\u043E\u0440\u0430\u045B\u0435\u0442\u0435 \u0434\u0430 \u0443\u043D\u0435\u0441\u0435\u0442\u0435 \u043E\u0432\u0443 \u043B\u043E\u0437\u0438\u043D\u043A\u0443 \u043A\u0430\u0434\u0430 \u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0434\u0430 \u0438\u0437\u0432\u043E\u0437\u0438\u0442\u0435 \u0441\u0432\u043E\u0458\u0435 \u043D\u0430\u043B\u043E\u0433\u0435 \u0443 \u0434\u0440\u0443\u0433\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A.",
            button: "\u041D\u0430\u0441\u0442\u0430\u0432\u0438\u0442\u0435",
            label: "\u041A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u0434\u0430 \u0431\u0438\u0441\u0442\u0435 \u043A\u043E\u043F\u0438\u0440\u0430\u043B\u0438",
            checkLabel: "\u041A\u043E\u043F\u0438\u0440\u0430\u043E \u0441\u0430\u043C \u0438\u043B\u0438 \u0437\u0430\u043F\u0438\u0441\u0430\u043E \u043B\u043E\u0437\u0438\u043D\u043A\u0443"
        },
        complete: {
            title: "\u0414\u043E\u0432\u0440\u0448\u0438\u0442\u0435 \u0442\u0440\u0430\u043D\u0441\u0444\u0435\u0440",
            descOne: "\u0421\u0430\u0434\u0430 \u045B\u0435\u0442\u0435 \u0431\u0438\u0442\u0438 \u043F\u0440\u0435\u0443\u0441\u043C\u0435\u0440\u0435\u043D\u0438 \u043D\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043A\u043E\u0458\u0438 \u0441\u0442\u0435 \u0438\u0437\u0430\u0431\u0440\u0430\u043B\u0438 \u0434\u0430 \u0437\u0430\u0432\u0440\u0448\u0438\u0442\u0435 \u0442\u0440\u0430\u043D\u0441\u0444\u0435\u0440.",
            descTwo: "\u041A\u0430\u0434\u0430 \u0441\u0435 \u0434\u0435\u043E \u043F\u0440\u043E\u0446\u0435\u0441\u0430 \u0443\u0432\u043E\u0437\u0430 \u0437\u0430\u0432\u0440\u0448\u0438 \u0438\u0437 \u0438\u0437\u0430\u0431\u0440\u0430\u043D\u043E\u0433 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0430, \u043F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 \u0434\u0443\u0433\u043C\u0435 \u0434\u0430 \u0437\u0430\u0432\u0440\u0448\u0438\u0442\u0435 \u043F\u0440\u043E\u0446\u0435\u0441 \u043F\u0440\u0435\u043D\u043E\u0441\u0430.",
            button: "\u0417\u0430\u0432\u0440\u0448\u0438\u0442\u0435"
        }
    }
};
var $5bb7220e37bd460f$var$sr = {
    modal: $5bb7220e37bd460f$var$modal
};
const $5bb7220e37bd460f$var$getLanguage = (languageCode)=>{
    switch(languageCode){
        case "en":
            return $5bb7220e37bd460f$var$en;
        case "es":
            return $5bb7220e37bd460f$var$es;
        case "zh":
            return $5bb7220e37bd460f$var$zh;
        case "bg":
            return $5bb7220e37bd460f$var$bg;
        case "ko":
            return $5bb7220e37bd460f$var$ko;
        case "vi":
            return $5bb7220e37bd460f$var$vi;
        case "hi":
            return $5bb7220e37bd460f$var$hi;
        case "ar":
            return $5bb7220e37bd460f$var$ar;
        case "hr":
            return $5bb7220e37bd460f$var$hr;
        case "mk":
            return $5bb7220e37bd460f$var$mk;
        case "sl":
            return $5bb7220e37bd460f$var$sl;
        case "sr":
            return $5bb7220e37bd460f$var$sr;
        default:
            return $5bb7220e37bd460f$var$en;
    }
};
let $5bb7220e37bd460f$var$chosenLang;
const $5bb7220e37bd460f$export$b162ef060a488de1 = (langCode)=>{
    $5bb7220e37bd460f$var$chosenLang = langCode;
}; // (i.e en-CA returns just en)
const $5bb7220e37bd460f$var$shortenLanguageCode = (lang)=>{
    return lang.indexOf("-") !== -1 ? lang.split("-")[0] : lang.split("_")[0];
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5bb7220e37bd460f$var$findObjectPropByStringPath = (obj, prop)=>{
    if (!obj) return "";
    const _index = prop.indexOf(".");
    if (_index > -1) {
        const currentProp = prop.substring(0, _index);
        const nextProp = prop.substring(_index + 1);
        return $5bb7220e37bd460f$var$findObjectPropByStringPath(obj[currentProp], nextProp);
    }
    return obj[prop];
};
const $5bb7220e37bd460f$export$d73ee8ef04f5226a = (path)=>{
    let browserLang = window.navigator.languages ? window.navigator.languages[0] : null;
    browserLang = browserLang || window.navigator.language;
    const languageCode = $5bb7220e37bd460f$var$shortenLanguageCode($5bb7220e37bd460f$var$chosenLang || browserLang);
    const selectedLanguage = $5bb7220e37bd460f$var$getLanguage(languageCode);
    const text = $5bb7220e37bd460f$var$findObjectPropByStringPath(selectedLanguage, path);
    return text && typeof text === "string" ? text : path;
};


var $092c7e998bebe629$exports = {};

$parcel$export($092c7e998bebe629$exports, "create", () => $092c7e998bebe629$export$185802fd694ee1f5, (v) => $092c7e998bebe629$export$185802fd694ee1f5 = v);
$parcel$export($092c7e998bebe629$exports, "toCanvas", () => $092c7e998bebe629$export$f87f6982d1fd4f81, (v) => $092c7e998bebe629$export$f87f6982d1fd4f81 = v);
$parcel$export($092c7e998bebe629$exports, "toDataURL", () => $092c7e998bebe629$export$723e4939e5a27c8, (v) => $092c7e998bebe629$export$723e4939e5a27c8 = v);
$parcel$export($092c7e998bebe629$exports, "toString", () => $092c7e998bebe629$export$f84e8e69fd4488a5, (v) => $092c7e998bebe629$export$f84e8e69fd4488a5 = v);
var $092c7e998bebe629$export$185802fd694ee1f5;
var $092c7e998bebe629$export$f87f6982d1fd4f81;
var $092c7e998bebe629$export$723e4939e5a27c8;
// only svg for now.
var $092c7e998bebe629$export$f84e8e69fd4488a5;
var $e6419622b12b5572$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$e6419622b12b5572$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $5f2127839fe01a16$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c1483b5b1305278f$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c1483b5b1305278f$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c1483b5b1305278f$export$ed1d66da50968976;
var $c1483b5b1305278f$export$6733b14783f975c2;
var $c1483b5b1305278f$export$ce5b1274f8597fa0;
var $c1483b5b1305278f$export$43dd553ecded716d;
let $c1483b5b1305278f$var$toSJISFunction;
const $c1483b5b1305278f$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c1483b5b1305278f$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c1483b5b1305278f$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c1483b5b1305278f$var$CODEWORDS_COUNT[version];
};
$c1483b5b1305278f$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c1483b5b1305278f$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $c1483b5b1305278f$var$toSJISFunction = f;
};
$c1483b5b1305278f$export$ce5b1274f8597fa0 = function() {
    return typeof $c1483b5b1305278f$var$toSJISFunction !== "undefined";
};
$c1483b5b1305278f$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c1483b5b1305278f$var$toSJISFunction(kanji);
};


var $d22956012916b666$export$61196ced6d74a310;
var $d22956012916b666$export$3a1a48c8f6ef640e;
var $d22956012916b666$export$3722cfe417b6ed86;
var $d22956012916b666$export$7f8ddf7c7c20b3cd;
var $d22956012916b666$export$1ea939691cdc45b8;
var $d22956012916b666$export$6788812c4e6611e6;
$d22956012916b666$export$61196ced6d74a310 = {
    bit: 1
};
$d22956012916b666$export$3a1a48c8f6ef640e = {
    bit: 0
};
$d22956012916b666$export$3722cfe417b6ed86 = {
    bit: 3
};
$d22956012916b666$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $d22956012916b666$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $d22956012916b666$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $d22956012916b666$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $d22956012916b666$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $d22956012916b666$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$d22956012916b666$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$d22956012916b666$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d22956012916b666$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d22956012916b666$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $22a6389bcfc83921$exports = {};
function $22a6389bcfc83921$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$22a6389bcfc83921$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$22a6389bcfc83921$exports = $22a6389bcfc83921$var$BitBuffer;


var $3c0264e2c9c64d36$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $3c0264e2c9c64d36$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$3c0264e2c9c64d36$exports = $3c0264e2c9c64d36$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $c20e4b3185223698$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c20e4b3185223698$export$c39457c570f2b189;

var $c20e4b3185223698$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
$c20e4b3185223698$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $c20e4b3185223698$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$c20e4b3185223698$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $c20e4b3185223698$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4836838cc492349$export$c39457c570f2b189;

var $b4836838cc492349$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
const $b4836838cc492349$var$FINDER_PATTERN_SIZE = 7;
$b4836838cc492349$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4836838cc492349$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $1edc2624fba191d0$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $1edc2624fba191d0$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $1edc2624fba191d0$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $1edc2624fba191d0$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $1edc2624fba191d0$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $1edc2624fba191d0$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $1edc2624fba191d0$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $1edc2624fba191d0$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $1edc2624fba191d0$export$fe9625aaceb0e563;
$1edc2624fba191d0$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $1edc2624fba191d0$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$1edc2624fba191d0$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$1edc2624fba191d0$export$6788812c4e6611e6 = function from(value) {
    return $1edc2624fba191d0$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$1edc2624fba191d0$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$1edc2624fba191d0$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N2;
};
$1edc2624fba191d0$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N3;
};
$1edc2624fba191d0$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $1edc2624fba191d0$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $1edc2624fba191d0$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$1edc2624fba191d0$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $1edc2624fba191d0$var$getMaskAt(pattern, row, col));
    }
};
$1edc2624fba191d0$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($1edc2624fba191d0$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $1edc2624fba191d0$export$a5fd3a02c14d0b3e(data) + $1edc2624fba191d0$export$9a9385107a518e46(data) + $1edc2624fba191d0$export$ade754353f0dc75e(data) + $1edc2624fba191d0$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $7f809b8d8966b945$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $7f809b8d8966b945$export$683d1b3e8a1a8438;

const $7f809b8d8966b945$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $7f809b8d8966b945$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$7f809b8d8966b945$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$7f809b8d8966b945$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $06a1abce65162dc0$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $9563d144998a4c78$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $9563d144998a4c78$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $9563d144998a4c78$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $758ebb328fd03b3c$export$6e3a27864ab166fe;
const $758ebb328fd03b3c$var$EXP_TABLE = new Uint8Array(512);
const $758ebb328fd03b3c$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $758ebb328fd03b3c$var$EXP_TABLE[i] = x;
        $758ebb328fd03b3c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$758ebb328fd03b3c$var$EXP_TABLE[i] = $758ebb328fd03b3c$var$EXP_TABLE[i - 255];
})();
$758ebb328fd03b3c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $758ebb328fd03b3c$var$LOG_TABLE[n];
};
$758ebb328fd03b3c$export$b310ec824aaee37f = function exp(n) {
    return $758ebb328fd03b3c$var$EXP_TABLE[n];
};
$758ebb328fd03b3c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $758ebb328fd03b3c$var$EXP_TABLE[$758ebb328fd03b3c$var$LOG_TABLE[x] + $758ebb328fd03b3c$var$LOG_TABLE[y]];
};


$9563d144998a4c78$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$9563d144998a4c78$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$9563d144998a4c78$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $9563d144998a4c78$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $758ebb328fd03b3c$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $06a1abce65162dc0$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $9563d144998a4c78$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $9563d144998a4c78$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$06a1abce65162dc0$exports = $06a1abce65162dc0$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $140eee110ea3b5f9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $140eee110ea3b5f9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $140eee110ea3b5f9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $140eee110ea3b5f9$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $21e4e023abb588c2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $21e4e023abb588c2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $21e4e023abb588c2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $21e4e023abb588c2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $21e4e023abb588c2$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7f0bebb05133540b$export$1ea939691cdc45b8;
$7f0bebb05133540b$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $d479c387334094fb$export$a4d452c2363c8e12;
var $d479c387334094fb$export$9df7c29d562bab83;
var $d479c387334094fb$export$8f4bf8f7eb581284;
var $d479c387334094fb$export$4d318981b5a83836;
var $d479c387334094fb$export$376a9ed239d6c1c8;
var $d479c387334094fb$export$175f16aef75a4569;
var $d479c387334094fb$export$50b7f9bf92c74274;
var $d479c387334094fb$export$4ba5f52893b4ac97;
const $d479c387334094fb$var$numeric = "[0-9]+";
const $d479c387334094fb$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $d479c387334094fb$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d479c387334094fb$var$kanji = $d479c387334094fb$var$kanji.replace(/u/g, "\\u");
const $d479c387334094fb$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $d479c387334094fb$var$kanji + ")(?:.|[\r\n]))+";
$d479c387334094fb$export$a4d452c2363c8e12 = new RegExp($d479c387334094fb$var$kanji, "g");
$d479c387334094fb$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$d479c387334094fb$export$8f4bf8f7eb581284 = new RegExp($d479c387334094fb$var$byte, "g");
$d479c387334094fb$export$4d318981b5a83836 = new RegExp($d479c387334094fb$var$numeric, "g");
$d479c387334094fb$export$376a9ed239d6c1c8 = new RegExp($d479c387334094fb$var$alphanumeric, "g");
const $d479c387334094fb$var$TEST_KANJI = new RegExp("^" + $d479c387334094fb$var$kanji + "$");
const $d479c387334094fb$var$TEST_NUMERIC = new RegExp("^" + $d479c387334094fb$var$numeric + "$");
const $d479c387334094fb$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$d479c387334094fb$export$175f16aef75a4569 = function testKanji(str) {
    return $d479c387334094fb$var$TEST_KANJI.test(str);
};
$d479c387334094fb$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d479c387334094fb$var$TEST_NUMERIC.test(str);
};
$d479c387334094fb$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d479c387334094fb$var$TEST_ALPHANUMERIC.test(str);
};


$21e4e023abb588c2$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$21e4e023abb588c2$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$21e4e023abb588c2$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$21e4e023abb588c2$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$21e4e023abb588c2$export$bb410559a65d3418 = {
    bit: -1
};
$21e4e023abb588c2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$21e4e023abb588c2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($d479c387334094fb$export$50b7f9bf92c74274(dataStr)) return $21e4e023abb588c2$export$4d318981b5a83836;
    else if ($d479c387334094fb$export$4ba5f52893b4ac97(dataStr)) return $21e4e023abb588c2$export$376a9ed239d6c1c8;
    else if ($d479c387334094fb$export$175f16aef75a4569(dataStr)) return $21e4e023abb588c2$export$a4d452c2363c8e12;
    else return $21e4e023abb588c2$export$8f4bf8f7eb581284;
};
$21e4e023abb588c2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$21e4e023abb588c2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $21e4e023abb588c2$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $21e4e023abb588c2$export$4d318981b5a83836;
        case "alphanumeric":
            return $21e4e023abb588c2$export$376a9ed239d6c1c8;
        case "kanji":
            return $21e4e023abb588c2$export$a4d452c2363c8e12;
        case "byte":
            return $21e4e023abb588c2$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$21e4e023abb588c2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($21e4e023abb588c2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $21e4e023abb588c2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $140eee110ea3b5f9$var$G18 = 7973;
const $140eee110ea3b5f9$var$G18_BCH = $c1483b5b1305278f$export$ed1d66da50968976($140eee110ea3b5f9$var$G18);
function $140eee110ea3b5f9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $140eee110ea3b5f9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $21e4e023abb588c2$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $140eee110ea3b5f9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $140eee110ea3b5f9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $21e4e023abb588c2$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$140eee110ea3b5f9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($7f0bebb05133540b$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$140eee110ea3b5f9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $21e4e023abb588c2$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $140eee110ea3b5f9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$140eee110ea3b5f9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $d22956012916b666$export$6788812c4e6611e6(errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $140eee110ea3b5f9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $140eee110ea3b5f9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$140eee110ea3b5f9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH >= 0)d ^= $140eee110ea3b5f9$var$G18 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1f894980312e7d2a$export$eee5438974ef6f0e;

const $1f894980312e7d2a$var$G15 = 1335;
const $1f894980312e7d2a$var$G15_MASK = 21522;
const $1f894980312e7d2a$var$G15_BCH = $c1483b5b1305278f$export$ed1d66da50968976($1f894980312e7d2a$var$G15);
$1f894980312e7d2a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH >= 0)d ^= $1f894980312e7d2a$var$G15 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1f894980312e7d2a$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $06b6d7424b9df2df$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $06b6d7424b9df2df$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $06b6d7424b9df2df$export$89ab1afb9839589b;

var $7a5bacf4a539441d$exports = {};

function $7a5bacf4a539441d$var$NumericData(data) {
    this.mode = $21e4e023abb588c2$export$4d318981b5a83836;
    this.data = data.toString();
}
$7a5bacf4a539441d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$7a5bacf4a539441d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7a5bacf4a539441d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $7a5bacf4a539441d$var$NumericData.getBitsLength(this.data.length);
};
$7a5bacf4a539441d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$7a5bacf4a539441d$exports = $7a5bacf4a539441d$var$NumericData;


var $f6549c884fd9ace3$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f6549c884fd9ace3$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $f6549c884fd9ace3$var$AlphanumericData(data) {
    this.mode = $21e4e023abb588c2$export$376a9ed239d6c1c8;
    this.data = data;
}
$f6549c884fd9ace3$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f6549c884fd9ace3$var$AlphanumericData.getBitsLength(this.data.length);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$f6549c884fd9ace3$exports = $f6549c884fd9ace3$var$AlphanumericData;


var $47f01312d66828cb$exports = {};
var $b5acdf7c8123a019$exports = {};
"use strict";
$b5acdf7c8123a019$exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};



function $47f01312d66828cb$var$ByteData(data) {
    this.mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    if (typeof data === "string") data = $b5acdf7c8123a019$exports(data);
    this.data = new Uint8Array(data);
}
$47f01312d66828cb$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$47f01312d66828cb$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$47f01312d66828cb$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $47f01312d66828cb$var$ByteData.getBitsLength(this.data.length);
};
$47f01312d66828cb$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$47f01312d66828cb$exports = $47f01312d66828cb$var$ByteData;


var $668803520f2d7445$exports = {};


function $668803520f2d7445$var$KanjiData(data) {
    this.mode = $21e4e023abb588c2$export$a4d452c2363c8e12;
    this.data = data;
}
$668803520f2d7445$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$668803520f2d7445$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$668803520f2d7445$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $668803520f2d7445$var$KanjiData.getBitsLength(this.data.length);
};
$668803520f2d7445$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $c1483b5b1305278f$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$668803520f2d7445$exports = $668803520f2d7445$var$KanjiData;




var $6c1abb425b529163$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $6c1abb425b529163$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $6c1abb425b529163$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $6c1abb425b529163$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $6c1abb425b529163$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $6c1abb425b529163$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$6c1abb425b529163$exports = $6c1abb425b529163$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $06b6d7424b9df2df$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegmentsFromString(dataStr) {
    const numSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$4d318981b5a83836, $21e4e023abb588c2$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$376a9ed239d6c1c8, $21e4e023abb588c2$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($c1483b5b1305278f$export$ce5b1274f8597fa0()) {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$8f4bf8f7eb581284, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$a4d452c2363c8e12, $21e4e023abb588c2$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$9df7c29d562bab83, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $06b6d7424b9df2df$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return $7a5bacf4a539441d$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return $f6549c884fd9ace3$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return $668803520f2d7445$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return $47f01312d66828cb$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $21e4e023abb588c2$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $06b6d7424b9df2df$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(node.length, node.mode) + 4 + $21e4e023abb588c2$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $06b6d7424b9df2df$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $21e4e023abb588c2$export$1bd4c93ffb42e55e(data);
    mode = $21e4e023abb588c2$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $21e4e023abb588c2$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $21e4e023abb588c2$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $21e4e023abb588c2$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $21e4e023abb588c2$export$a4d452c2363c8e12 && !$c1483b5b1305278f$export$ce5b1274f8597fa0()) mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return new $7a5bacf4a539441d$exports(data);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return new $f6549c884fd9ace3$exports(data);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return new $668803520f2d7445$exports(data);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return new $47f01312d66828cb$exports(data);
    }
}
$06b6d7424b9df2df$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$06b6d7424b9df2df$export$3004f64547af360e = function fromString(data, version) {
    const segs = $06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0());
    const nodes = $06b6d7424b9df2df$var$buildNodes(segs);
    const graph = $06b6d7424b9df2df$var$buildGraph(nodes, version);
    const path = $6c1abb425b529163$exports.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$mergeSegments(optimizedSegs));
};
$06b6d7424b9df2df$export$89ab1afb9839589b = function rawSplit(data) {
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $b4836838cc492349$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $5f2127839fe01a16$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupAlignmentPattern(matrix, version) {
    const pos = $c20e4b3185223698$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $140eee110ea3b5f9$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $5f2127839fe01a16$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $1f894980312e7d2a$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $5f2127839fe01a16$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $22a6389bcfc83921$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $21e4e023abb588c2$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $5f2127839fe01a16$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $7f809b8d8966b945$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $06a1abce65162dc0$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $06b6d7424b9df2df$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $06b6d7424b9df2df$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $06b6d7424b9df2df$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $c1483b5b1305278f$export$8d4a06d3facd414b(version);
    const modules = new $3c0264e2c9c64d36$exports(moduleCount);
    // Add function modules
    $5f2127839fe01a16$var$setupFinderPattern(modules, version);
    $5f2127839fe01a16$var$setupTimingPattern(modules);
    $5f2127839fe01a16$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $5f2127839fe01a16$var$setupVersionInfo(modules, version);
    // Add data codewords
    $5f2127839fe01a16$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $1edc2624fba191d0$export$fe9625aaceb0e563(modules, $5f2127839fe01a16$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $1edc2624fba191d0$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$5f2127839fe01a16$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $d22956012916b666$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $d22956012916b666$export$6788812c4e6611e6(options.errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
        version = $140eee110ea3b5f9$export$6788812c4e6611e6(options.version);
        mask = $1edc2624fba191d0$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $c1483b5b1305278f$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $53c344a5283c422c$export$b3890eb0ae9dca99;
var $53c344a5283c422c$export$c3e5526bbaf70a25;
var $c890d85f31194258$export$d2312e68e1f5ad00;
var $c890d85f31194258$export$5cdac61cf538712e;
var $c890d85f31194258$export$c3a1a1f268a8142b;
var $c890d85f31194258$export$83136f57c739c5f3;
function $c890d85f31194258$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$c890d85f31194258$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c890d85f31194258$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $c890d85f31194258$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c890d85f31194258$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c890d85f31194258$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c890d85f31194258$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c890d85f31194258$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c890d85f31194258$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $53c344a5283c422c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $53c344a5283c422c$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$53c344a5283c422c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $53c344a5283c422c$var$getCanvasElement();
    opts = $c890d85f31194258$export$d2312e68e1f5ad00(opts);
    const size = $c890d85f31194258$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $c890d85f31194258$export$83136f57c739c5f3(image.data, qrData, opts);
    $53c344a5283c422c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$53c344a5283c422c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $53c344a5283c422c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $3112213e4acbe245$export$b3890eb0ae9dca99;

function $3112213e4acbe245$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $3112213e4acbe245$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $3112213e4acbe245$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $3112213e4acbe245$var$svgCmd("M", col + margin, 0.5 + row + margin) : $3112213e4acbe245$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $3112213e4acbe245$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$3112213e4acbe245$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $c890d85f31194258$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $3112213e4acbe245$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $092c7e998bebe629$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$e6419622b12b5572$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$092c7e998bebe629$export$185802fd694ee1f5 = $5f2127839fe01a16$export$185802fd694ee1f5;
$092c7e998bebe629$export$f87f6982d1fd4f81 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$b3890eb0ae9dca99);
$092c7e998bebe629$export$723e4939e5a27c8 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$c3e5526bbaf70a25);
$092c7e998bebe629$export$f84e8e69fd4488a5 = $092c7e998bebe629$var$renderCanvas.bind(null, function(data, _, opts) {
    return $3112213e4acbe245$export$b3890eb0ae9dca99(data, opts);
});


var $e5a78797c4262d1f$exports = {};
"use strict";
var $9e6bd5018912b3a9$exports = {};
$9e6bd5018912b3a9$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $e5a78797c4262d1f$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $e5a78797c4262d1f$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $e5a78797c4262d1f$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $e5a78797c4262d1f$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $9e6bd5018912b3a9$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $e5a78797c4262d1f$var$clipboardToIE11Formatting[options.format] || $e5a78797c4262d1f$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $e5a78797c4262d1f$var$format("message" in options ? options.message : $e5a78797c4262d1f$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$e5a78797c4262d1f$exports = $e5a78797c4262d1f$var$copy;


var $6daeff2c8e1d7f1b$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $6daeff2c8e1d7f1b$var$fails$h = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $6daeff2c8e1d7f1b$var$fails$g = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$functionBindNative = !$6daeff2c8e1d7f1b$var$fails$g(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $6daeff2c8e1d7f1b$var$NATIVE_BIND$3 = $6daeff2c8e1d7f1b$var$functionBindNative;
var $6daeff2c8e1d7f1b$var$FunctionPrototype$2 = Function.prototype;
var $6daeff2c8e1d7f1b$var$bind$5 = $6daeff2c8e1d7f1b$var$FunctionPrototype$2.bind;
var $6daeff2c8e1d7f1b$var$call$f = $6daeff2c8e1d7f1b$var$FunctionPrototype$2.call;
var $6daeff2c8e1d7f1b$var$uncurryThis$h = $6daeff2c8e1d7f1b$var$NATIVE_BIND$3 && $6daeff2c8e1d7f1b$var$bind$5.bind($6daeff2c8e1d7f1b$var$call$f, $6daeff2c8e1d7f1b$var$call$f);
var $6daeff2c8e1d7f1b$var$functionUncurryThis = $6daeff2c8e1d7f1b$var$NATIVE_BIND$3 ? function(fn) {
    return fn && $6daeff2c8e1d7f1b$var$uncurryThis$h(fn);
} : function(fn) {
    return fn && function() {
        return $6daeff2c8e1d7f1b$var$call$f.apply(fn, arguments);
    };
};
var $6daeff2c8e1d7f1b$var$uncurryThis$g = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$toString$5 = $6daeff2c8e1d7f1b$var$uncurryThis$g({}.toString);
var $6daeff2c8e1d7f1b$var$stringSlice$1 = $6daeff2c8e1d7f1b$var$uncurryThis$g("".slice);
var $6daeff2c8e1d7f1b$var$classofRaw$1 = function(it) {
    return $6daeff2c8e1d7f1b$var$stringSlice$1($6daeff2c8e1d7f1b$var$toString$5(it), 8, -1);
};
var $6daeff2c8e1d7f1b$var$uncurryThis$f = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$fails$f = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$classof$6 = $6daeff2c8e1d7f1b$var$classofRaw$1;
var $6daeff2c8e1d7f1b$var$$Object$4 = Object;
var $6daeff2c8e1d7f1b$var$split = $6daeff2c8e1d7f1b$var$uncurryThis$f("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $6daeff2c8e1d7f1b$var$indexedObject = $6daeff2c8e1d7f1b$var$fails$f(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$6daeff2c8e1d7f1b$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $6daeff2c8e1d7f1b$var$classof$6(it) == "String" ? $6daeff2c8e1d7f1b$var$split(it, "") : $6daeff2c8e1d7f1b$var$$Object$4(it);
} : $6daeff2c8e1d7f1b$var$$Object$4;
var $6daeff2c8e1d7f1b$var$$TypeError$e = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $6daeff2c8e1d7f1b$var$requireObjectCoercible$3 = function(it) {
    if (it == undefined) throw $6daeff2c8e1d7f1b$var$$TypeError$e("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $6daeff2c8e1d7f1b$var$IndexedObject$2 = $6daeff2c8e1d7f1b$var$indexedObject;
var $6daeff2c8e1d7f1b$var$requireObjectCoercible$2 = $6daeff2c8e1d7f1b$var$requireObjectCoercible$3;
var $6daeff2c8e1d7f1b$var$toIndexedObject$5 = function(it) {
    return $6daeff2c8e1d7f1b$var$IndexedObject$2($6daeff2c8e1d7f1b$var$requireObjectCoercible$2(it));
};
var $6daeff2c8e1d7f1b$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $6daeff2c8e1d7f1b$var$global$k = // eslint-disable-next-line es-x/no-global-this -- safe
$6daeff2c8e1d7f1b$var$check(typeof globalThis == "object" && globalThis) || $6daeff2c8e1d7f1b$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$6daeff2c8e1d7f1b$var$check(typeof self == "object" && self) || $6daeff2c8e1d7f1b$var$check(typeof $6daeff2c8e1d7f1b$var$commonjsGlobal == "object" && $6daeff2c8e1d7f1b$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $6daeff2c8e1d7f1b$var$shared$3 = {
    exports: {}
};
var $6daeff2c8e1d7f1b$var$global$j = $6daeff2c8e1d7f1b$var$global$k;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $6daeff2c8e1d7f1b$var$defineProperty$6 = Object.defineProperty;
var $6daeff2c8e1d7f1b$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $6daeff2c8e1d7f1b$var$defineProperty$6($6daeff2c8e1d7f1b$var$global$j, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $6daeff2c8e1d7f1b$var$global$j[key] = value;
    }
    return value;
};
var $6daeff2c8e1d7f1b$var$global$i = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$defineGlobalProperty$2 = $6daeff2c8e1d7f1b$var$defineGlobalProperty$3;
var $6daeff2c8e1d7f1b$var$SHARED = "__core-js_shared__";
var $6daeff2c8e1d7f1b$var$store$3 = $6daeff2c8e1d7f1b$var$global$i[$6daeff2c8e1d7f1b$var$SHARED] || $6daeff2c8e1d7f1b$var$defineGlobalProperty$2($6daeff2c8e1d7f1b$var$SHARED, {});
var $6daeff2c8e1d7f1b$var$sharedStore = $6daeff2c8e1d7f1b$var$store$3;
var $6daeff2c8e1d7f1b$var$store$2 = $6daeff2c8e1d7f1b$var$sharedStore;
($6daeff2c8e1d7f1b$var$shared$3.exports = function(key, value) {
    return $6daeff2c8e1d7f1b$var$store$2[key] || ($6daeff2c8e1d7f1b$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $6daeff2c8e1d7f1b$var$requireObjectCoercible$1 = $6daeff2c8e1d7f1b$var$requireObjectCoercible$3;
var $6daeff2c8e1d7f1b$var$$Object$3 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $6daeff2c8e1d7f1b$var$toObject$5 = function(argument) {
    return $6daeff2c8e1d7f1b$var$$Object$3($6daeff2c8e1d7f1b$var$requireObjectCoercible$1(argument));
};
var $6daeff2c8e1d7f1b$var$uncurryThis$e = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$toObject$4 = $6daeff2c8e1d7f1b$var$toObject$5;
var $6daeff2c8e1d7f1b$var$hasOwnProperty = $6daeff2c8e1d7f1b$var$uncurryThis$e({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $6daeff2c8e1d7f1b$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $6daeff2c8e1d7f1b$var$hasOwnProperty($6daeff2c8e1d7f1b$var$toObject$4(it), key);
};
var $6daeff2c8e1d7f1b$var$uncurryThis$d = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$id = 0;
var $6daeff2c8e1d7f1b$var$postfix = Math.random();
var $6daeff2c8e1d7f1b$var$toString$4 = $6daeff2c8e1d7f1b$var$uncurryThis$d(1.0.toString);
var $6daeff2c8e1d7f1b$var$uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $6daeff2c8e1d7f1b$var$toString$4(++$6daeff2c8e1d7f1b$var$id + $6daeff2c8e1d7f1b$var$postfix, 36);
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $6daeff2c8e1d7f1b$var$isCallable$l = function(argument) {
    return typeof argument == "function";
};
var $6daeff2c8e1d7f1b$var$global$h = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$isCallable$k = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$aFunction = function(argument) {
    return $6daeff2c8e1d7f1b$var$isCallable$k(argument) ? argument : undefined;
};
var $6daeff2c8e1d7f1b$var$getBuiltIn$8 = function(namespace, method) {
    return arguments.length < 2 ? $6daeff2c8e1d7f1b$var$aFunction($6daeff2c8e1d7f1b$var$global$h[namespace]) : $6daeff2c8e1d7f1b$var$global$h[namespace] && $6daeff2c8e1d7f1b$var$global$h[namespace][method];
};
var $6daeff2c8e1d7f1b$var$getBuiltIn$7 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$engineUserAgent = $6daeff2c8e1d7f1b$var$getBuiltIn$7("navigator", "userAgent") || "";
var $6daeff2c8e1d7f1b$var$global$g = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$userAgent$5 = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$process$3 = $6daeff2c8e1d7f1b$var$global$g.process;
var $6daeff2c8e1d7f1b$var$Deno$1 = $6daeff2c8e1d7f1b$var$global$g.Deno;
var $6daeff2c8e1d7f1b$var$versions = $6daeff2c8e1d7f1b$var$process$3 && $6daeff2c8e1d7f1b$var$process$3.versions || $6daeff2c8e1d7f1b$var$Deno$1 && $6daeff2c8e1d7f1b$var$Deno$1.version;
var $6daeff2c8e1d7f1b$var$v8 = $6daeff2c8e1d7f1b$var$versions && $6daeff2c8e1d7f1b$var$versions.v8;
var $6daeff2c8e1d7f1b$var$match, $6daeff2c8e1d7f1b$var$version;
if ($6daeff2c8e1d7f1b$var$v8) {
    $6daeff2c8e1d7f1b$var$match = $6daeff2c8e1d7f1b$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $6daeff2c8e1d7f1b$var$version = $6daeff2c8e1d7f1b$var$match[0] > 0 && $6daeff2c8e1d7f1b$var$match[0] < 4 ? 1 : +($6daeff2c8e1d7f1b$var$match[0] + $6daeff2c8e1d7f1b$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$6daeff2c8e1d7f1b$var$version && $6daeff2c8e1d7f1b$var$userAgent$5) {
    $6daeff2c8e1d7f1b$var$match = $6daeff2c8e1d7f1b$var$userAgent$5.match(/Edge\/(\d+)/);
    if (!$6daeff2c8e1d7f1b$var$match || $6daeff2c8e1d7f1b$var$match[1] >= 74) {
        $6daeff2c8e1d7f1b$var$match = $6daeff2c8e1d7f1b$var$userAgent$5.match(/Chrome\/(\d+)/);
        if ($6daeff2c8e1d7f1b$var$match) $6daeff2c8e1d7f1b$var$version = +$6daeff2c8e1d7f1b$var$match[1];
    }
}
var $6daeff2c8e1d7f1b$var$engineV8Version = $6daeff2c8e1d7f1b$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $6daeff2c8e1d7f1b$var$V8_VERSION$1 = $6daeff2c8e1d7f1b$var$engineV8Version;
var $6daeff2c8e1d7f1b$var$fails$e = $6daeff2c8e1d7f1b$var$fails$h;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $6daeff2c8e1d7f1b$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$6daeff2c8e1d7f1b$var$fails$e(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $6daeff2c8e1d7f1b$var$V8_VERSION$1 && $6daeff2c8e1d7f1b$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $6daeff2c8e1d7f1b$var$NATIVE_SYMBOL$2 = $6daeff2c8e1d7f1b$var$nativeSymbol;
var $6daeff2c8e1d7f1b$var$useSymbolAsUid = $6daeff2c8e1d7f1b$var$NATIVE_SYMBOL$2 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $6daeff2c8e1d7f1b$var$global$f = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$shared$2 = $6daeff2c8e1d7f1b$var$shared$3.exports;
var $6daeff2c8e1d7f1b$var$hasOwn$b = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$uid$1 = $6daeff2c8e1d7f1b$var$uid$2;
var $6daeff2c8e1d7f1b$var$NATIVE_SYMBOL$1 = $6daeff2c8e1d7f1b$var$nativeSymbol;
var $6daeff2c8e1d7f1b$var$USE_SYMBOL_AS_UID$1 = $6daeff2c8e1d7f1b$var$useSymbolAsUid;
var $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore = $6daeff2c8e1d7f1b$var$shared$2("wks");
var $6daeff2c8e1d7f1b$var$Symbol$1 = $6daeff2c8e1d7f1b$var$global$f.Symbol;
var $6daeff2c8e1d7f1b$var$symbolFor = $6daeff2c8e1d7f1b$var$Symbol$1 && $6daeff2c8e1d7f1b$var$Symbol$1["for"];
var $6daeff2c8e1d7f1b$var$createWellKnownSymbol = $6daeff2c8e1d7f1b$var$USE_SYMBOL_AS_UID$1 ? $6daeff2c8e1d7f1b$var$Symbol$1 : $6daeff2c8e1d7f1b$var$Symbol$1 && $6daeff2c8e1d7f1b$var$Symbol$1.withoutSetter || $6daeff2c8e1d7f1b$var$uid$1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$g = function(name) {
    if (!$6daeff2c8e1d7f1b$var$hasOwn$b($6daeff2c8e1d7f1b$var$WellKnownSymbolsStore, name) || !($6daeff2c8e1d7f1b$var$NATIVE_SYMBOL$1 || typeof $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($6daeff2c8e1d7f1b$var$NATIVE_SYMBOL$1 && $6daeff2c8e1d7f1b$var$hasOwn$b($6daeff2c8e1d7f1b$var$Symbol$1, name)) $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore[name] = $6daeff2c8e1d7f1b$var$Symbol$1[name];
        else if ($6daeff2c8e1d7f1b$var$USE_SYMBOL_AS_UID$1 && $6daeff2c8e1d7f1b$var$symbolFor) $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore[name] = $6daeff2c8e1d7f1b$var$symbolFor(description);
        else $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore[name] = $6daeff2c8e1d7f1b$var$createWellKnownSymbol(description);
    }
    return $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore[name];
};
var $6daeff2c8e1d7f1b$var$isCallable$j = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isObject$8 = function(it) {
    return typeof it == "object" ? it !== null : $6daeff2c8e1d7f1b$var$isCallable$j(it);
};
var $6daeff2c8e1d7f1b$var$isObject$7 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$$String$3 = String;
var $6daeff2c8e1d7f1b$var$$TypeError$d = TypeError;
// `Assert: Type(argument) is Object`
var $6daeff2c8e1d7f1b$var$anObject$c = function(argument) {
    if ($6daeff2c8e1d7f1b$var$isObject$7(argument)) return argument;
    throw $6daeff2c8e1d7f1b$var$$TypeError$d($6daeff2c8e1d7f1b$var$$String$3(argument) + " is not an object");
};
var $6daeff2c8e1d7f1b$var$objectDefineProperties = {};
var $6daeff2c8e1d7f1b$var$fails$d = $6daeff2c8e1d7f1b$var$fails$h;
// Detect IE8's incomplete defineProperty implementation
var $6daeff2c8e1d7f1b$var$descriptors = !$6daeff2c8e1d7f1b$var$fails$d(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$b = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$fails$c = $6daeff2c8e1d7f1b$var$fails$h;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $6daeff2c8e1d7f1b$var$v8PrototypeDefineBug = $6daeff2c8e1d7f1b$var$DESCRIPTORS$b && $6daeff2c8e1d7f1b$var$fails$c(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $6daeff2c8e1d7f1b$var$objectDefineProperty = {};
var $6daeff2c8e1d7f1b$var$global$e = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$isObject$6 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$document$3 = $6daeff2c8e1d7f1b$var$global$e.document;
// typeof document.createElement is 'object' in old IE
var $6daeff2c8e1d7f1b$var$EXISTS$1 = $6daeff2c8e1d7f1b$var$isObject$6($6daeff2c8e1d7f1b$var$document$3) && $6daeff2c8e1d7f1b$var$isObject$6($6daeff2c8e1d7f1b$var$document$3.createElement);
var $6daeff2c8e1d7f1b$var$documentCreateElement$2 = function(it) {
    return $6daeff2c8e1d7f1b$var$EXISTS$1 ? $6daeff2c8e1d7f1b$var$document$3.createElement(it) : {};
};
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$a = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$fails$b = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$createElement$1 = $6daeff2c8e1d7f1b$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $6daeff2c8e1d7f1b$var$ie8DomDefine = !$6daeff2c8e1d7f1b$var$DESCRIPTORS$a && !$6daeff2c8e1d7f1b$var$fails$b(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($6daeff2c8e1d7f1b$var$createElement$1("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $6daeff2c8e1d7f1b$var$NATIVE_BIND$2 = $6daeff2c8e1d7f1b$var$functionBindNative;
var $6daeff2c8e1d7f1b$var$call$e = Function.prototype.call;
var $6daeff2c8e1d7f1b$var$functionCall = $6daeff2c8e1d7f1b$var$NATIVE_BIND$2 ? $6daeff2c8e1d7f1b$var$call$e.bind($6daeff2c8e1d7f1b$var$call$e) : function() {
    return $6daeff2c8e1d7f1b$var$call$e.apply($6daeff2c8e1d7f1b$var$call$e, arguments);
};
var $6daeff2c8e1d7f1b$var$uncurryThis$c = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$objectIsPrototypeOf = $6daeff2c8e1d7f1b$var$uncurryThis$c({}.isPrototypeOf);
var $6daeff2c8e1d7f1b$var$getBuiltIn$6 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$isCallable$i = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isPrototypeOf$4 = $6daeff2c8e1d7f1b$var$objectIsPrototypeOf;
var $6daeff2c8e1d7f1b$var$USE_SYMBOL_AS_UID = $6daeff2c8e1d7f1b$var$useSymbolAsUid;
var $6daeff2c8e1d7f1b$var$$Object$2 = Object;
var $6daeff2c8e1d7f1b$var$isSymbol$2 = $6daeff2c8e1d7f1b$var$USE_SYMBOL_AS_UID ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $6daeff2c8e1d7f1b$var$getBuiltIn$6("Symbol");
    return $6daeff2c8e1d7f1b$var$isCallable$i($Symbol) && $6daeff2c8e1d7f1b$var$isPrototypeOf$4($Symbol.prototype, $6daeff2c8e1d7f1b$var$$Object$2(it));
};
var $6daeff2c8e1d7f1b$var$$String$2 = String;
var $6daeff2c8e1d7f1b$var$tryToString$5 = function(argument) {
    try {
        return $6daeff2c8e1d7f1b$var$$String$2(argument);
    } catch (error) {
        return "Object";
    }
};
var $6daeff2c8e1d7f1b$var$isCallable$h = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$tryToString$4 = $6daeff2c8e1d7f1b$var$tryToString$5;
var $6daeff2c8e1d7f1b$var$$TypeError$c = TypeError;
// `Assert: IsCallable(argument) is true`
var $6daeff2c8e1d7f1b$var$aCallable$9 = function(argument) {
    if ($6daeff2c8e1d7f1b$var$isCallable$h(argument)) return argument;
    throw $6daeff2c8e1d7f1b$var$$TypeError$c($6daeff2c8e1d7f1b$var$tryToString$4(argument) + " is not a function");
};
var $6daeff2c8e1d7f1b$var$aCallable$8 = $6daeff2c8e1d7f1b$var$aCallable$9;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $6daeff2c8e1d7f1b$var$getMethod$3 = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $6daeff2c8e1d7f1b$var$aCallable$8(func);
};
var $6daeff2c8e1d7f1b$var$call$d = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$isCallable$g = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isObject$5 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$$TypeError$b = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $6daeff2c8e1d7f1b$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $6daeff2c8e1d7f1b$var$isCallable$g(fn = input.toString) && !$6daeff2c8e1d7f1b$var$isObject$5(val = $6daeff2c8e1d7f1b$var$call$d(fn, input))) return val;
    if ($6daeff2c8e1d7f1b$var$isCallable$g(fn = input.valueOf) && !$6daeff2c8e1d7f1b$var$isObject$5(val = $6daeff2c8e1d7f1b$var$call$d(fn, input))) return val;
    if (pref !== "string" && $6daeff2c8e1d7f1b$var$isCallable$g(fn = input.toString) && !$6daeff2c8e1d7f1b$var$isObject$5(val = $6daeff2c8e1d7f1b$var$call$d(fn, input))) return val;
    throw $6daeff2c8e1d7f1b$var$$TypeError$b("Can't convert object to primitive value");
};
var $6daeff2c8e1d7f1b$var$call$c = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$isObject$4 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$isSymbol$1 = $6daeff2c8e1d7f1b$var$isSymbol$2;
var $6daeff2c8e1d7f1b$var$getMethod$2 = $6daeff2c8e1d7f1b$var$getMethod$3;
var $6daeff2c8e1d7f1b$var$ordinaryToPrimitive = $6daeff2c8e1d7f1b$var$ordinaryToPrimitive$1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$f = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$$TypeError$a = TypeError;
var $6daeff2c8e1d7f1b$var$TO_PRIMITIVE = $6daeff2c8e1d7f1b$var$wellKnownSymbol$f("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $6daeff2c8e1d7f1b$var$toPrimitive$1 = function(input, pref) {
    if (!$6daeff2c8e1d7f1b$var$isObject$4(input) || $6daeff2c8e1d7f1b$var$isSymbol$1(input)) return input;
    var exoticToPrim = $6daeff2c8e1d7f1b$var$getMethod$2(input, $6daeff2c8e1d7f1b$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $6daeff2c8e1d7f1b$var$call$c(exoticToPrim, input, pref);
        if (!$6daeff2c8e1d7f1b$var$isObject$4(result) || $6daeff2c8e1d7f1b$var$isSymbol$1(result)) return result;
        throw $6daeff2c8e1d7f1b$var$$TypeError$a("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $6daeff2c8e1d7f1b$var$ordinaryToPrimitive(input, pref);
};
var $6daeff2c8e1d7f1b$var$toPrimitive = $6daeff2c8e1d7f1b$var$toPrimitive$1;
var $6daeff2c8e1d7f1b$var$isSymbol = $6daeff2c8e1d7f1b$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $6daeff2c8e1d7f1b$var$toPropertyKey$3 = function(argument) {
    var key = $6daeff2c8e1d7f1b$var$toPrimitive(argument, "string");
    return $6daeff2c8e1d7f1b$var$isSymbol(key) ? key : key + "";
};
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$9 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$IE8_DOM_DEFINE$1 = $6daeff2c8e1d7f1b$var$ie8DomDefine;
var $6daeff2c8e1d7f1b$var$V8_PROTOTYPE_DEFINE_BUG$1 = $6daeff2c8e1d7f1b$var$v8PrototypeDefineBug;
var $6daeff2c8e1d7f1b$var$anObject$b = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$toPropertyKey$2 = $6daeff2c8e1d7f1b$var$toPropertyKey$3;
var $6daeff2c8e1d7f1b$var$$TypeError$9 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $6daeff2c8e1d7f1b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $6daeff2c8e1d7f1b$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var $6daeff2c8e1d7f1b$var$ENUMERABLE = "enumerable";
var $6daeff2c8e1d7f1b$var$CONFIGURABLE$1 = "configurable";
var $6daeff2c8e1d7f1b$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$6daeff2c8e1d7f1b$var$objectDefineProperty.f = $6daeff2c8e1d7f1b$var$DESCRIPTORS$9 ? $6daeff2c8e1d7f1b$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $6daeff2c8e1d7f1b$var$anObject$b(O);
    P = $6daeff2c8e1d7f1b$var$toPropertyKey$2(P);
    $6daeff2c8e1d7f1b$var$anObject$b(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $6daeff2c8e1d7f1b$var$WRITABLE in Attributes && !Attributes[$6daeff2c8e1d7f1b$var$WRITABLE]) {
        var current = $6daeff2c8e1d7f1b$var$$getOwnPropertyDescriptor$1(O, P);
        if (current && current[$6daeff2c8e1d7f1b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $6daeff2c8e1d7f1b$var$CONFIGURABLE$1 in Attributes ? Attributes[$6daeff2c8e1d7f1b$var$CONFIGURABLE$1] : current[$6daeff2c8e1d7f1b$var$CONFIGURABLE$1],
                enumerable: $6daeff2c8e1d7f1b$var$ENUMERABLE in Attributes ? Attributes[$6daeff2c8e1d7f1b$var$ENUMERABLE] : current[$6daeff2c8e1d7f1b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $6daeff2c8e1d7f1b$var$$defineProperty(O, P, Attributes);
} : $6daeff2c8e1d7f1b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $6daeff2c8e1d7f1b$var$anObject$b(O);
    P = $6daeff2c8e1d7f1b$var$toPropertyKey$2(P);
    $6daeff2c8e1d7f1b$var$anObject$b(Attributes);
    if ($6daeff2c8e1d7f1b$var$IE8_DOM_DEFINE$1) try {
        return $6daeff2c8e1d7f1b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $6daeff2c8e1d7f1b$var$$TypeError$9("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $6daeff2c8e1d7f1b$var$ceil = Math.ceil;
var $6daeff2c8e1d7f1b$var$floor$1 = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $6daeff2c8e1d7f1b$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $6daeff2c8e1d7f1b$var$floor$1 : $6daeff2c8e1d7f1b$var$ceil)(n);
};
var $6daeff2c8e1d7f1b$var$trunc = $6daeff2c8e1d7f1b$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $6daeff2c8e1d7f1b$var$toIntegerOrInfinity$2 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $6daeff2c8e1d7f1b$var$trunc(number);
};
var $6daeff2c8e1d7f1b$var$toIntegerOrInfinity$1 = $6daeff2c8e1d7f1b$var$toIntegerOrInfinity$2;
var $6daeff2c8e1d7f1b$var$max$1 = Math.max;
var $6daeff2c8e1d7f1b$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $6daeff2c8e1d7f1b$var$toAbsoluteIndex$2 = function(index, length) {
    var integer = $6daeff2c8e1d7f1b$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $6daeff2c8e1d7f1b$var$max$1(integer + length, 0) : $6daeff2c8e1d7f1b$var$min$1(integer, length);
};
var $6daeff2c8e1d7f1b$var$toIntegerOrInfinity = $6daeff2c8e1d7f1b$var$toIntegerOrInfinity$2;
var $6daeff2c8e1d7f1b$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $6daeff2c8e1d7f1b$var$toLength$1 = function(argument) {
    return argument > 0 ? $6daeff2c8e1d7f1b$var$min($6daeff2c8e1d7f1b$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $6daeff2c8e1d7f1b$var$toLength = $6daeff2c8e1d7f1b$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5 = function(obj) {
    return $6daeff2c8e1d7f1b$var$toLength(obj.length);
};
var $6daeff2c8e1d7f1b$var$toIndexedObject$4 = $6daeff2c8e1d7f1b$var$toIndexedObject$5;
var $6daeff2c8e1d7f1b$var$toAbsoluteIndex$1 = $6daeff2c8e1d7f1b$var$toAbsoluteIndex$2;
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike$4 = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $6daeff2c8e1d7f1b$var$createMethod$1 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $6daeff2c8e1d7f1b$var$toIndexedObject$4($this);
        var length = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$4(O);
        var index = $6daeff2c8e1d7f1b$var$toAbsoluteIndex$1(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $6daeff2c8e1d7f1b$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $6daeff2c8e1d7f1b$var$createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $6daeff2c8e1d7f1b$var$createMethod$1(false)
};
var $6daeff2c8e1d7f1b$var$hiddenKeys$4 = {};
var $6daeff2c8e1d7f1b$var$uncurryThis$b = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$hasOwn$a = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$toIndexedObject$3 = $6daeff2c8e1d7f1b$var$toIndexedObject$5;
var $6daeff2c8e1d7f1b$var$indexOf = $6daeff2c8e1d7f1b$var$arrayIncludes.indexOf;
var $6daeff2c8e1d7f1b$var$hiddenKeys$3 = $6daeff2c8e1d7f1b$var$hiddenKeys$4;
var $6daeff2c8e1d7f1b$var$push$1 = $6daeff2c8e1d7f1b$var$uncurryThis$b([].push);
var $6daeff2c8e1d7f1b$var$objectKeysInternal = function(object, names) {
    var O = $6daeff2c8e1d7f1b$var$toIndexedObject$3(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$6daeff2c8e1d7f1b$var$hasOwn$a($6daeff2c8e1d7f1b$var$hiddenKeys$3, key) && $6daeff2c8e1d7f1b$var$hasOwn$a(O, key) && $6daeff2c8e1d7f1b$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($6daeff2c8e1d7f1b$var$hasOwn$a(O, key = names[i++])) ~$6daeff2c8e1d7f1b$var$indexOf(result, key) || $6daeff2c8e1d7f1b$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $6daeff2c8e1d7f1b$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $6daeff2c8e1d7f1b$var$internalObjectKeys$1 = $6daeff2c8e1d7f1b$var$objectKeysInternal;
var $6daeff2c8e1d7f1b$var$enumBugKeys$2 = $6daeff2c8e1d7f1b$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $6daeff2c8e1d7f1b$var$objectKeys$2 = Object.keys || function keys(O) {
    return $6daeff2c8e1d7f1b$var$internalObjectKeys$1(O, $6daeff2c8e1d7f1b$var$enumBugKeys$2);
};
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$8 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$V8_PROTOTYPE_DEFINE_BUG = $6daeff2c8e1d7f1b$var$v8PrototypeDefineBug;
var $6daeff2c8e1d7f1b$var$definePropertyModule$5 = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$anObject$a = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$toIndexedObject$2 = $6daeff2c8e1d7f1b$var$toIndexedObject$5;
var $6daeff2c8e1d7f1b$var$objectKeys$1 = $6daeff2c8e1d7f1b$var$objectKeys$2;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$6daeff2c8e1d7f1b$var$objectDefineProperties.f = $6daeff2c8e1d7f1b$var$DESCRIPTORS$8 && !$6daeff2c8e1d7f1b$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $6daeff2c8e1d7f1b$var$anObject$a(O);
    var props = $6daeff2c8e1d7f1b$var$toIndexedObject$2(Properties);
    var keys = $6daeff2c8e1d7f1b$var$objectKeys$1(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$6daeff2c8e1d7f1b$var$definePropertyModule$5.f(O, key = keys[index++], props[key]);
    return O;
};
var $6daeff2c8e1d7f1b$var$getBuiltIn$5 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$html$2 = $6daeff2c8e1d7f1b$var$getBuiltIn$5("document", "documentElement");
var $6daeff2c8e1d7f1b$var$shared$1 = $6daeff2c8e1d7f1b$var$shared$3.exports;
var $6daeff2c8e1d7f1b$var$uid = $6daeff2c8e1d7f1b$var$uid$2;
var $6daeff2c8e1d7f1b$var$keys = $6daeff2c8e1d7f1b$var$shared$1("keys");
var $6daeff2c8e1d7f1b$var$sharedKey$3 = function(key) {
    return $6daeff2c8e1d7f1b$var$keys[key] || ($6daeff2c8e1d7f1b$var$keys[key] = $6daeff2c8e1d7f1b$var$uid(key));
};
/* global ActiveXObject -- old IE, WSH */ var $6daeff2c8e1d7f1b$var$anObject$9 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$definePropertiesModule = $6daeff2c8e1d7f1b$var$objectDefineProperties;
var $6daeff2c8e1d7f1b$var$enumBugKeys$1 = $6daeff2c8e1d7f1b$var$enumBugKeys$3;
var $6daeff2c8e1d7f1b$var$hiddenKeys$2 = $6daeff2c8e1d7f1b$var$hiddenKeys$4;
var $6daeff2c8e1d7f1b$var$html$1 = $6daeff2c8e1d7f1b$var$html$2;
var $6daeff2c8e1d7f1b$var$documentCreateElement$1 = $6daeff2c8e1d7f1b$var$documentCreateElement$2;
var $6daeff2c8e1d7f1b$var$sharedKey$2 = $6daeff2c8e1d7f1b$var$sharedKey$3;
var $6daeff2c8e1d7f1b$var$GT = ">";
var $6daeff2c8e1d7f1b$var$LT = "<";
var $6daeff2c8e1d7f1b$var$PROTOTYPE = "prototype";
var $6daeff2c8e1d7f1b$var$SCRIPT = "script";
var $6daeff2c8e1d7f1b$var$IE_PROTO$1 = $6daeff2c8e1d7f1b$var$sharedKey$2("IE_PROTO");
var $6daeff2c8e1d7f1b$var$EmptyConstructor = function() {};
var $6daeff2c8e1d7f1b$var$scriptTag = function(content) {
    return $6daeff2c8e1d7f1b$var$LT + $6daeff2c8e1d7f1b$var$SCRIPT + $6daeff2c8e1d7f1b$var$GT + content + $6daeff2c8e1d7f1b$var$LT + "/" + $6daeff2c8e1d7f1b$var$SCRIPT + $6daeff2c8e1d7f1b$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $6daeff2c8e1d7f1b$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($6daeff2c8e1d7f1b$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $6daeff2c8e1d7f1b$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $6daeff2c8e1d7f1b$var$documentCreateElement$1("iframe");
    var JS = "java" + $6daeff2c8e1d7f1b$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $6daeff2c8e1d7f1b$var$html$1.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($6daeff2c8e1d7f1b$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $6daeff2c8e1d7f1b$var$activeXDocument;
var $6daeff2c8e1d7f1b$var$NullProtoObject = function() {
    try {
        $6daeff2c8e1d7f1b$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $6daeff2c8e1d7f1b$var$NullProtoObject = typeof document != "undefined" ? document.domain && $6daeff2c8e1d7f1b$var$activeXDocument ? $6daeff2c8e1d7f1b$var$NullProtoObjectViaActiveX($6daeff2c8e1d7f1b$var$activeXDocument) // old IE
     : $6daeff2c8e1d7f1b$var$NullProtoObjectViaIFrame() : $6daeff2c8e1d7f1b$var$NullProtoObjectViaActiveX($6daeff2c8e1d7f1b$var$activeXDocument); // WSH
    var length = $6daeff2c8e1d7f1b$var$enumBugKeys$1.length;
    while(length--)delete $6daeff2c8e1d7f1b$var$NullProtoObject[$6daeff2c8e1d7f1b$var$PROTOTYPE][$6daeff2c8e1d7f1b$var$enumBugKeys$1[length]];
    return $6daeff2c8e1d7f1b$var$NullProtoObject();
};
$6daeff2c8e1d7f1b$var$hiddenKeys$2[$6daeff2c8e1d7f1b$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $6daeff2c8e1d7f1b$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $6daeff2c8e1d7f1b$var$EmptyConstructor[$6daeff2c8e1d7f1b$var$PROTOTYPE] = $6daeff2c8e1d7f1b$var$anObject$9(O);
        result = new $6daeff2c8e1d7f1b$var$EmptyConstructor();
        $6daeff2c8e1d7f1b$var$EmptyConstructor[$6daeff2c8e1d7f1b$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$6daeff2c8e1d7f1b$var$IE_PROTO$1] = O;
    } else result = $6daeff2c8e1d7f1b$var$NullProtoObject();
    return Properties === undefined ? result : $6daeff2c8e1d7f1b$var$definePropertiesModule.f(result, Properties);
};
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$e = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$create$1 = $6daeff2c8e1d7f1b$var$objectCreate;
var $6daeff2c8e1d7f1b$var$defineProperty$5 = $6daeff2c8e1d7f1b$var$objectDefineProperty.f;
var $6daeff2c8e1d7f1b$var$UNSCOPABLES = $6daeff2c8e1d7f1b$var$wellKnownSymbol$e("unscopables");
var $6daeff2c8e1d7f1b$var$ArrayPrototype$1 = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($6daeff2c8e1d7f1b$var$ArrayPrototype$1[$6daeff2c8e1d7f1b$var$UNSCOPABLES] == undefined) $6daeff2c8e1d7f1b$var$defineProperty$5($6daeff2c8e1d7f1b$var$ArrayPrototype$1, $6daeff2c8e1d7f1b$var$UNSCOPABLES, {
    configurable: true,
    value: $6daeff2c8e1d7f1b$var$create$1(null)
});
// add a key to Array.prototype[@@unscopables]
var $6daeff2c8e1d7f1b$var$addToUnscopables$2 = function(key) {
    $6daeff2c8e1d7f1b$var$ArrayPrototype$1[$6daeff2c8e1d7f1b$var$UNSCOPABLES][key] = true;
};
var $6daeff2c8e1d7f1b$var$iterators = {};
var $6daeff2c8e1d7f1b$var$uncurryThis$a = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$isCallable$f = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$store$1 = $6daeff2c8e1d7f1b$var$sharedStore;
var $6daeff2c8e1d7f1b$var$functionToString = $6daeff2c8e1d7f1b$var$uncurryThis$a(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$6daeff2c8e1d7f1b$var$isCallable$f($6daeff2c8e1d7f1b$var$store$1.inspectSource)) $6daeff2c8e1d7f1b$var$store$1.inspectSource = function(it) {
    return $6daeff2c8e1d7f1b$var$functionToString(it);
};
var $6daeff2c8e1d7f1b$var$inspectSource$4 = $6daeff2c8e1d7f1b$var$store$1.inspectSource;
var $6daeff2c8e1d7f1b$var$global$d = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$isCallable$e = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$inspectSource$3 = $6daeff2c8e1d7f1b$var$inspectSource$4;
var $6daeff2c8e1d7f1b$var$WeakMap$1 = $6daeff2c8e1d7f1b$var$global$d.WeakMap;
var $6daeff2c8e1d7f1b$var$nativeWeakMap = $6daeff2c8e1d7f1b$var$isCallable$e($6daeff2c8e1d7f1b$var$WeakMap$1) && /native code/.test($6daeff2c8e1d7f1b$var$inspectSource$3($6daeff2c8e1d7f1b$var$WeakMap$1));
var $6daeff2c8e1d7f1b$var$createPropertyDescriptor$4 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$7 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$definePropertyModule$4 = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$createPropertyDescriptor$3 = $6daeff2c8e1d7f1b$var$createPropertyDescriptor$4;
var $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$4 = $6daeff2c8e1d7f1b$var$DESCRIPTORS$7 ? function(object, key, value) {
    return $6daeff2c8e1d7f1b$var$definePropertyModule$4.f(object, key, $6daeff2c8e1d7f1b$var$createPropertyDescriptor$3(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $6daeff2c8e1d7f1b$var$NATIVE_WEAK_MAP = $6daeff2c8e1d7f1b$var$nativeWeakMap;
var $6daeff2c8e1d7f1b$var$global$c = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$uncurryThis$9 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$isObject$3 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$3 = $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$4;
var $6daeff2c8e1d7f1b$var$hasOwn$9 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$shared = $6daeff2c8e1d7f1b$var$sharedStore;
var $6daeff2c8e1d7f1b$var$sharedKey$1 = $6daeff2c8e1d7f1b$var$sharedKey$3;
var $6daeff2c8e1d7f1b$var$hiddenKeys$1 = $6daeff2c8e1d7f1b$var$hiddenKeys$4;
var $6daeff2c8e1d7f1b$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $6daeff2c8e1d7f1b$var$TypeError$2 = $6daeff2c8e1d7f1b$var$global$c.TypeError;
var $6daeff2c8e1d7f1b$var$WeakMap = $6daeff2c8e1d7f1b$var$global$c.WeakMap;
var $6daeff2c8e1d7f1b$var$set$1, $6daeff2c8e1d7f1b$var$get, $6daeff2c8e1d7f1b$var$has;
var $6daeff2c8e1d7f1b$var$enforce = function(it) {
    return $6daeff2c8e1d7f1b$var$has(it) ? $6daeff2c8e1d7f1b$var$get(it) : $6daeff2c8e1d7f1b$var$set$1(it, {});
};
var $6daeff2c8e1d7f1b$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$6daeff2c8e1d7f1b$var$isObject$3(it) || (state = $6daeff2c8e1d7f1b$var$get(it)).type !== TYPE) throw $6daeff2c8e1d7f1b$var$TypeError$2("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($6daeff2c8e1d7f1b$var$NATIVE_WEAK_MAP || $6daeff2c8e1d7f1b$var$shared.state) {
    var $6daeff2c8e1d7f1b$var$store = $6daeff2c8e1d7f1b$var$shared.state || ($6daeff2c8e1d7f1b$var$shared.state = new $6daeff2c8e1d7f1b$var$WeakMap());
    var $6daeff2c8e1d7f1b$var$wmget = $6daeff2c8e1d7f1b$var$uncurryThis$9($6daeff2c8e1d7f1b$var$store.get);
    var $6daeff2c8e1d7f1b$var$wmhas = $6daeff2c8e1d7f1b$var$uncurryThis$9($6daeff2c8e1d7f1b$var$store.has);
    var $6daeff2c8e1d7f1b$var$wmset = $6daeff2c8e1d7f1b$var$uncurryThis$9($6daeff2c8e1d7f1b$var$store.set);
    $6daeff2c8e1d7f1b$var$set$1 = function(it, metadata) {
        if ($6daeff2c8e1d7f1b$var$wmhas($6daeff2c8e1d7f1b$var$store, it)) throw new $6daeff2c8e1d7f1b$var$TypeError$2($6daeff2c8e1d7f1b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $6daeff2c8e1d7f1b$var$wmset($6daeff2c8e1d7f1b$var$store, it, metadata);
        return metadata;
    };
    $6daeff2c8e1d7f1b$var$get = function(it) {
        return $6daeff2c8e1d7f1b$var$wmget($6daeff2c8e1d7f1b$var$store, it) || {};
    };
    $6daeff2c8e1d7f1b$var$has = function(it) {
        return $6daeff2c8e1d7f1b$var$wmhas($6daeff2c8e1d7f1b$var$store, it);
    };
} else {
    var $6daeff2c8e1d7f1b$var$STATE = $6daeff2c8e1d7f1b$var$sharedKey$1("state");
    $6daeff2c8e1d7f1b$var$hiddenKeys$1[$6daeff2c8e1d7f1b$var$STATE] = true;
    $6daeff2c8e1d7f1b$var$set$1 = function(it, metadata) {
        if ($6daeff2c8e1d7f1b$var$hasOwn$9(it, $6daeff2c8e1d7f1b$var$STATE)) throw new $6daeff2c8e1d7f1b$var$TypeError$2($6daeff2c8e1d7f1b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$3(it, $6daeff2c8e1d7f1b$var$STATE, metadata);
        return metadata;
    };
    $6daeff2c8e1d7f1b$var$get = function(it) {
        return $6daeff2c8e1d7f1b$var$hasOwn$9(it, $6daeff2c8e1d7f1b$var$STATE) ? it[$6daeff2c8e1d7f1b$var$STATE] : {};
    };
    $6daeff2c8e1d7f1b$var$has = function(it) {
        return $6daeff2c8e1d7f1b$var$hasOwn$9(it, $6daeff2c8e1d7f1b$var$STATE);
    };
}
var $6daeff2c8e1d7f1b$var$internalState = {
    set: $6daeff2c8e1d7f1b$var$set$1,
    get: $6daeff2c8e1d7f1b$var$get,
    has: $6daeff2c8e1d7f1b$var$has,
    enforce: $6daeff2c8e1d7f1b$var$enforce,
    getterFor: $6daeff2c8e1d7f1b$var$getterFor
};
var $6daeff2c8e1d7f1b$var$objectGetOwnPropertyDescriptor = {};
var $6daeff2c8e1d7f1b$var$objectPropertyIsEnumerable = {};
var $6daeff2c8e1d7f1b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $6daeff2c8e1d7f1b$var$NASHORN_BUG = $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor$2 && !$6daeff2c8e1d7f1b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$6daeff2c8e1d7f1b$var$objectPropertyIsEnumerable.f = $6daeff2c8e1d7f1b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $6daeff2c8e1d7f1b$var$$propertyIsEnumerable;
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$6 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$call$b = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$propertyIsEnumerableModule$1 = $6daeff2c8e1d7f1b$var$objectPropertyIsEnumerable;
var $6daeff2c8e1d7f1b$var$createPropertyDescriptor$2 = $6daeff2c8e1d7f1b$var$createPropertyDescriptor$4;
var $6daeff2c8e1d7f1b$var$toIndexedObject$1 = $6daeff2c8e1d7f1b$var$toIndexedObject$5;
var $6daeff2c8e1d7f1b$var$toPropertyKey$1 = $6daeff2c8e1d7f1b$var$toPropertyKey$3;
var $6daeff2c8e1d7f1b$var$hasOwn$8 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$IE8_DOM_DEFINE = $6daeff2c8e1d7f1b$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $6daeff2c8e1d7f1b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$6daeff2c8e1d7f1b$var$objectGetOwnPropertyDescriptor.f = $6daeff2c8e1d7f1b$var$DESCRIPTORS$6 ? $6daeff2c8e1d7f1b$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $6daeff2c8e1d7f1b$var$toIndexedObject$1(O);
    P = $6daeff2c8e1d7f1b$var$toPropertyKey$1(P);
    if ($6daeff2c8e1d7f1b$var$IE8_DOM_DEFINE) try {
        return $6daeff2c8e1d7f1b$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($6daeff2c8e1d7f1b$var$hasOwn$8(O, P)) return $6daeff2c8e1d7f1b$var$createPropertyDescriptor$2(!$6daeff2c8e1d7f1b$var$call$b($6daeff2c8e1d7f1b$var$propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var $6daeff2c8e1d7f1b$var$makeBuiltIn$2 = {
    exports: {}
};
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$5 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$hasOwn$7 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $6daeff2c8e1d7f1b$var$getDescriptor = $6daeff2c8e1d7f1b$var$DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;
var $6daeff2c8e1d7f1b$var$EXISTS = $6daeff2c8e1d7f1b$var$hasOwn$7($6daeff2c8e1d7f1b$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $6daeff2c8e1d7f1b$var$PROPER = $6daeff2c8e1d7f1b$var$EXISTS && (function something() {}).name === "something";
var $6daeff2c8e1d7f1b$var$CONFIGURABLE = $6daeff2c8e1d7f1b$var$EXISTS && (!$6daeff2c8e1d7f1b$var$DESCRIPTORS$5 || $6daeff2c8e1d7f1b$var$DESCRIPTORS$5 && $6daeff2c8e1d7f1b$var$getDescriptor($6daeff2c8e1d7f1b$var$FunctionPrototype$1, "name").configurable);
var $6daeff2c8e1d7f1b$var$functionName = {
    EXISTS: $6daeff2c8e1d7f1b$var$EXISTS,
    PROPER: $6daeff2c8e1d7f1b$var$PROPER,
    CONFIGURABLE: $6daeff2c8e1d7f1b$var$CONFIGURABLE
};
var $6daeff2c8e1d7f1b$var$fails$a = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$isCallable$d = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$hasOwn$6 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$4 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$CONFIGURABLE_FUNCTION_NAME$1 = $6daeff2c8e1d7f1b$var$functionName.CONFIGURABLE;
var $6daeff2c8e1d7f1b$var$inspectSource$2 = $6daeff2c8e1d7f1b$var$inspectSource$4;
var $6daeff2c8e1d7f1b$var$InternalStateModule$2 = $6daeff2c8e1d7f1b$var$internalState;
var $6daeff2c8e1d7f1b$var$enforceInternalState = $6daeff2c8e1d7f1b$var$InternalStateModule$2.enforce;
var $6daeff2c8e1d7f1b$var$getInternalState$1 = $6daeff2c8e1d7f1b$var$InternalStateModule$2.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $6daeff2c8e1d7f1b$var$defineProperty$4 = Object.defineProperty;
var $6daeff2c8e1d7f1b$var$CONFIGURABLE_LENGTH = $6daeff2c8e1d7f1b$var$DESCRIPTORS$4 && !$6daeff2c8e1d7f1b$var$fails$a(function() {
    return $6daeff2c8e1d7f1b$var$defineProperty$4(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $6daeff2c8e1d7f1b$var$TEMPLATE = String(String).split("String");
var $6daeff2c8e1d7f1b$var$makeBuiltIn$1 = $6daeff2c8e1d7f1b$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$6daeff2c8e1d7f1b$var$hasOwn$6(value, "name") || $6daeff2c8e1d7f1b$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($6daeff2c8e1d7f1b$var$DESCRIPTORS$4) $6daeff2c8e1d7f1b$var$defineProperty$4(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($6daeff2c8e1d7f1b$var$CONFIGURABLE_LENGTH && options && $6daeff2c8e1d7f1b$var$hasOwn$6(options, "arity") && value.length !== options.arity) $6daeff2c8e1d7f1b$var$defineProperty$4(value, "length", {
        value: options.arity
    });
    try {
        if (options && $6daeff2c8e1d7f1b$var$hasOwn$6(options, "constructor") && options.constructor) {
            if ($6daeff2c8e1d7f1b$var$DESCRIPTORS$4) $6daeff2c8e1d7f1b$var$defineProperty$4(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $6daeff2c8e1d7f1b$var$enforceInternalState(value);
    if (!$6daeff2c8e1d7f1b$var$hasOwn$6(state, "source")) state.source = $6daeff2c8e1d7f1b$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $6daeff2c8e1d7f1b$var$makeBuiltIn$1(function toString() {
    return $6daeff2c8e1d7f1b$var$isCallable$d(this) && $6daeff2c8e1d7f1b$var$getInternalState$1(this).source || $6daeff2c8e1d7f1b$var$inspectSource$2(this);
}, "toString");
var $6daeff2c8e1d7f1b$var$isCallable$c = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$definePropertyModule$3 = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$makeBuiltIn = $6daeff2c8e1d7f1b$var$makeBuiltIn$2.exports;
var $6daeff2c8e1d7f1b$var$defineGlobalProperty$1 = $6daeff2c8e1d7f1b$var$defineGlobalProperty$3;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$6 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($6daeff2c8e1d7f1b$var$isCallable$c(value)) $6daeff2c8e1d7f1b$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $6daeff2c8e1d7f1b$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $6daeff2c8e1d7f1b$var$definePropertyModule$3.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $6daeff2c8e1d7f1b$var$objectGetOwnPropertyNames = {};
var $6daeff2c8e1d7f1b$var$internalObjectKeys = $6daeff2c8e1d7f1b$var$objectKeysInternal;
var $6daeff2c8e1d7f1b$var$enumBugKeys = $6daeff2c8e1d7f1b$var$enumBugKeys$3;
var $6daeff2c8e1d7f1b$var$hiddenKeys = $6daeff2c8e1d7f1b$var$enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$6daeff2c8e1d7f1b$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $6daeff2c8e1d7f1b$var$internalObjectKeys(O, $6daeff2c8e1d7f1b$var$hiddenKeys);
};
var $6daeff2c8e1d7f1b$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$6daeff2c8e1d7f1b$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $6daeff2c8e1d7f1b$var$getBuiltIn$4 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$uncurryThis$8 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$getOwnPropertyNamesModule = $6daeff2c8e1d7f1b$var$objectGetOwnPropertyNames;
var $6daeff2c8e1d7f1b$var$getOwnPropertySymbolsModule$1 = $6daeff2c8e1d7f1b$var$objectGetOwnPropertySymbols;
var $6daeff2c8e1d7f1b$var$anObject$8 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$concat$1 = $6daeff2c8e1d7f1b$var$uncurryThis$8([].concat);
// all object keys, includes non-enumerable and symbols
var $6daeff2c8e1d7f1b$var$ownKeys$1 = $6daeff2c8e1d7f1b$var$getBuiltIn$4("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $6daeff2c8e1d7f1b$var$getOwnPropertyNamesModule.f($6daeff2c8e1d7f1b$var$anObject$8(it));
    var getOwnPropertySymbols = $6daeff2c8e1d7f1b$var$getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? $6daeff2c8e1d7f1b$var$concat$1(keys, getOwnPropertySymbols(it)) : keys;
};
var $6daeff2c8e1d7f1b$var$hasOwn$5 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$ownKeys = $6daeff2c8e1d7f1b$var$ownKeys$1;
var $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptorModule = $6daeff2c8e1d7f1b$var$objectGetOwnPropertyDescriptor;
var $6daeff2c8e1d7f1b$var$definePropertyModule$2 = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$copyConstructorProperties$2 = function(target, source, exceptions) {
    var keys = $6daeff2c8e1d7f1b$var$ownKeys(source);
    var defineProperty = $6daeff2c8e1d7f1b$var$definePropertyModule$2.f;
    var getOwnPropertyDescriptor = $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$6daeff2c8e1d7f1b$var$hasOwn$5(target, key) && !(exceptions && $6daeff2c8e1d7f1b$var$hasOwn$5(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $6daeff2c8e1d7f1b$var$fails$9 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$isCallable$b = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$replacement = /#|\.prototype\./;
var $6daeff2c8e1d7f1b$var$isForced$2 = function(feature, detection) {
    var value = $6daeff2c8e1d7f1b$var$data[$6daeff2c8e1d7f1b$var$normalize(feature)];
    return value == $6daeff2c8e1d7f1b$var$POLYFILL ? true : value == $6daeff2c8e1d7f1b$var$NATIVE ? false : $6daeff2c8e1d7f1b$var$isCallable$b(detection) ? $6daeff2c8e1d7f1b$var$fails$9(detection) : !!detection;
};
var $6daeff2c8e1d7f1b$var$normalize = $6daeff2c8e1d7f1b$var$isForced$2.normalize = function(string) {
    return String(string).replace($6daeff2c8e1d7f1b$var$replacement, ".").toLowerCase();
};
var $6daeff2c8e1d7f1b$var$data = $6daeff2c8e1d7f1b$var$isForced$2.data = {};
var $6daeff2c8e1d7f1b$var$NATIVE = $6daeff2c8e1d7f1b$var$isForced$2.NATIVE = "N";
var $6daeff2c8e1d7f1b$var$POLYFILL = $6daeff2c8e1d7f1b$var$isForced$2.POLYFILL = "P";
var $6daeff2c8e1d7f1b$var$isForced_1 = $6daeff2c8e1d7f1b$var$isForced$2;
var $6daeff2c8e1d7f1b$var$global$b = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor$1 = $6daeff2c8e1d7f1b$var$objectGetOwnPropertyDescriptor.f;
var $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$2 = $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$4;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$5 = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$defineGlobalProperty = $6daeff2c8e1d7f1b$var$defineGlobalProperty$3;
var $6daeff2c8e1d7f1b$var$copyConstructorProperties$1 = $6daeff2c8e1d7f1b$var$copyConstructorProperties$2;
var $6daeff2c8e1d7f1b$var$isForced$1 = $6daeff2c8e1d7f1b$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $6daeff2c8e1d7f1b$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $6daeff2c8e1d7f1b$var$global$b;
    else if (STATIC) target = $6daeff2c8e1d7f1b$var$global$b[TARGET] || $6daeff2c8e1d7f1b$var$defineGlobalProperty(TARGET, {});
    else target = ($6daeff2c8e1d7f1b$var$global$b[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $6daeff2c8e1d7f1b$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $6daeff2c8e1d7f1b$var$copyConstructorProperties$1(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$2(sourceProperty, "sham", true);
        $6daeff2c8e1d7f1b$var$defineBuiltIn$5(target, key, sourceProperty, options);
    }
};
var $6daeff2c8e1d7f1b$var$fails$8 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$correctPrototypeGetter = !$6daeff2c8e1d7f1b$var$fails$8(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $6daeff2c8e1d7f1b$var$hasOwn$4 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$isCallable$a = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$toObject$3 = $6daeff2c8e1d7f1b$var$toObject$5;
var $6daeff2c8e1d7f1b$var$sharedKey = $6daeff2c8e1d7f1b$var$sharedKey$3;
var $6daeff2c8e1d7f1b$var$CORRECT_PROTOTYPE_GETTER = $6daeff2c8e1d7f1b$var$correctPrototypeGetter;
var $6daeff2c8e1d7f1b$var$IE_PROTO = $6daeff2c8e1d7f1b$var$sharedKey("IE_PROTO");
var $6daeff2c8e1d7f1b$var$$Object$1 = Object;
var $6daeff2c8e1d7f1b$var$ObjectPrototype = $6daeff2c8e1d7f1b$var$$Object$1.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $6daeff2c8e1d7f1b$var$objectGetPrototypeOf = $6daeff2c8e1d7f1b$var$CORRECT_PROTOTYPE_GETTER ? $6daeff2c8e1d7f1b$var$$Object$1.getPrototypeOf : function(O) {
    var object = $6daeff2c8e1d7f1b$var$toObject$3(O);
    if ($6daeff2c8e1d7f1b$var$hasOwn$4(object, $6daeff2c8e1d7f1b$var$IE_PROTO)) return object[$6daeff2c8e1d7f1b$var$IE_PROTO];
    var constructor = object.constructor;
    if ($6daeff2c8e1d7f1b$var$isCallable$a(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $6daeff2c8e1d7f1b$var$$Object$1 ? $6daeff2c8e1d7f1b$var$ObjectPrototype : null;
};
var $6daeff2c8e1d7f1b$var$fails$7 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$isCallable$9 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$getPrototypeOf$1 = $6daeff2c8e1d7f1b$var$objectGetPrototypeOf;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$4 = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$d = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$ITERATOR$5 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$d("iterator");
var $6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $6daeff2c8e1d7f1b$var$IteratorPrototype$2, $6daeff2c8e1d7f1b$var$PrototypeOfArrayIteratorPrototype, $6daeff2c8e1d7f1b$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $6daeff2c8e1d7f1b$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $6daeff2c8e1d7f1b$var$arrayIterator)) $6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $6daeff2c8e1d7f1b$var$PrototypeOfArrayIteratorPrototype = $6daeff2c8e1d7f1b$var$getPrototypeOf$1($6daeff2c8e1d7f1b$var$getPrototypeOf$1($6daeff2c8e1d7f1b$var$arrayIterator));
        if ($6daeff2c8e1d7f1b$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $6daeff2c8e1d7f1b$var$IteratorPrototype$2 = $6daeff2c8e1d7f1b$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $6daeff2c8e1d7f1b$var$NEW_ITERATOR_PROTOTYPE = $6daeff2c8e1d7f1b$var$IteratorPrototype$2 == undefined || $6daeff2c8e1d7f1b$var$fails$7(function() {
    var test = {};
    // FF44- legacy iterators case
    return $6daeff2c8e1d7f1b$var$IteratorPrototype$2[$6daeff2c8e1d7f1b$var$ITERATOR$5].call(test) !== test;
});
if ($6daeff2c8e1d7f1b$var$NEW_ITERATOR_PROTOTYPE) $6daeff2c8e1d7f1b$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$6daeff2c8e1d7f1b$var$isCallable$9($6daeff2c8e1d7f1b$var$IteratorPrototype$2[$6daeff2c8e1d7f1b$var$ITERATOR$5])) $6daeff2c8e1d7f1b$var$defineBuiltIn$4($6daeff2c8e1d7f1b$var$IteratorPrototype$2, $6daeff2c8e1d7f1b$var$ITERATOR$5, function() {
    return this;
});
var $6daeff2c8e1d7f1b$var$iteratorsCore = {
    IteratorPrototype: $6daeff2c8e1d7f1b$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS$1
};
var $6daeff2c8e1d7f1b$var$defineProperty$3 = $6daeff2c8e1d7f1b$var$objectDefineProperty.f;
var $6daeff2c8e1d7f1b$var$hasOwn$3 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$c = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$TO_STRING_TAG$3 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$c("toStringTag");
var $6daeff2c8e1d7f1b$var$setToStringTag$3 = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$6daeff2c8e1d7f1b$var$hasOwn$3(target, $6daeff2c8e1d7f1b$var$TO_STRING_TAG$3)) $6daeff2c8e1d7f1b$var$defineProperty$3(target, $6daeff2c8e1d7f1b$var$TO_STRING_TAG$3, {
        configurable: true,
        value: TAG
    });
};
var $6daeff2c8e1d7f1b$var$IteratorPrototype$1 = $6daeff2c8e1d7f1b$var$iteratorsCore.IteratorPrototype;
var $6daeff2c8e1d7f1b$var$create = $6daeff2c8e1d7f1b$var$objectCreate;
var $6daeff2c8e1d7f1b$var$createPropertyDescriptor$1 = $6daeff2c8e1d7f1b$var$createPropertyDescriptor$4;
var $6daeff2c8e1d7f1b$var$setToStringTag$2 = $6daeff2c8e1d7f1b$var$setToStringTag$3;
var $6daeff2c8e1d7f1b$var$Iterators$4 = $6daeff2c8e1d7f1b$var$iterators;
var $6daeff2c8e1d7f1b$var$returnThis$1 = function() {
    return this;
};
var $6daeff2c8e1d7f1b$var$createIteratorConstructor$1 = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $6daeff2c8e1d7f1b$var$create($6daeff2c8e1d7f1b$var$IteratorPrototype$1, {
        next: $6daeff2c8e1d7f1b$var$createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next)
    });
    $6daeff2c8e1d7f1b$var$setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
    $6daeff2c8e1d7f1b$var$Iterators$4[TO_STRING_TAG] = $6daeff2c8e1d7f1b$var$returnThis$1;
    return IteratorConstructor;
};
var $6daeff2c8e1d7f1b$var$isCallable$8 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$$String$1 = String;
var $6daeff2c8e1d7f1b$var$$TypeError$8 = TypeError;
var $6daeff2c8e1d7f1b$var$aPossiblePrototype$1 = function(argument) {
    if (typeof argument == "object" || $6daeff2c8e1d7f1b$var$isCallable$8(argument)) return argument;
    throw $6daeff2c8e1d7f1b$var$$TypeError$8("Can't set " + $6daeff2c8e1d7f1b$var$$String$1(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $6daeff2c8e1d7f1b$var$uncurryThis$7 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$anObject$7 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$aPossiblePrototype = $6daeff2c8e1d7f1b$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $6daeff2c8e1d7f1b$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $6daeff2c8e1d7f1b$var$uncurryThis$7(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $6daeff2c8e1d7f1b$var$anObject$7(O);
        $6daeff2c8e1d7f1b$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $6daeff2c8e1d7f1b$var$$$c = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$call$a = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$FunctionName = $6daeff2c8e1d7f1b$var$functionName;
var $6daeff2c8e1d7f1b$var$isCallable$7 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$createIteratorConstructor = $6daeff2c8e1d7f1b$var$createIteratorConstructor$1;
var $6daeff2c8e1d7f1b$var$getPrototypeOf = $6daeff2c8e1d7f1b$var$objectGetPrototypeOf;
var $6daeff2c8e1d7f1b$var$setPrototypeOf$1 = $6daeff2c8e1d7f1b$var$objectSetPrototypeOf;
var $6daeff2c8e1d7f1b$var$setToStringTag$1 = $6daeff2c8e1d7f1b$var$setToStringTag$3;
var $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$1 = $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$4;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$3 = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$b = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$Iterators$3 = $6daeff2c8e1d7f1b$var$iterators;
var $6daeff2c8e1d7f1b$var$IteratorsCore = $6daeff2c8e1d7f1b$var$iteratorsCore;
var $6daeff2c8e1d7f1b$var$PROPER_FUNCTION_NAME$1 = $6daeff2c8e1d7f1b$var$FunctionName.PROPER;
var $6daeff2c8e1d7f1b$var$CONFIGURABLE_FUNCTION_NAME = $6daeff2c8e1d7f1b$var$FunctionName.CONFIGURABLE;
var $6daeff2c8e1d7f1b$var$IteratorPrototype = $6daeff2c8e1d7f1b$var$IteratorsCore.IteratorPrototype;
var $6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS = $6daeff2c8e1d7f1b$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $6daeff2c8e1d7f1b$var$ITERATOR$4 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$b("iterator");
var $6daeff2c8e1d7f1b$var$KEYS = "keys";
var $6daeff2c8e1d7f1b$var$VALUES = "values";
var $6daeff2c8e1d7f1b$var$ENTRIES = "entries";
var $6daeff2c8e1d7f1b$var$returnThis = function() {
    return this;
};
var $6daeff2c8e1d7f1b$var$defineIterator$1 = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $6daeff2c8e1d7f1b$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $6daeff2c8e1d7f1b$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $6daeff2c8e1d7f1b$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $6daeff2c8e1d7f1b$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$6daeff2c8e1d7f1b$var$ITERATOR$4] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $6daeff2c8e1d7f1b$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($6daeff2c8e1d7f1b$var$getPrototypeOf(CurrentIteratorPrototype) !== $6daeff2c8e1d7f1b$var$IteratorPrototype) {
                if ($6daeff2c8e1d7f1b$var$setPrototypeOf$1) $6daeff2c8e1d7f1b$var$setPrototypeOf$1(CurrentIteratorPrototype, $6daeff2c8e1d7f1b$var$IteratorPrototype);
                else if (!$6daeff2c8e1d7f1b$var$isCallable$7(CurrentIteratorPrototype[$6daeff2c8e1d7f1b$var$ITERATOR$4])) $6daeff2c8e1d7f1b$var$defineBuiltIn$3(CurrentIteratorPrototype, $6daeff2c8e1d7f1b$var$ITERATOR$4, $6daeff2c8e1d7f1b$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $6daeff2c8e1d7f1b$var$setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($6daeff2c8e1d7f1b$var$PROPER_FUNCTION_NAME$1 && DEFAULT == $6daeff2c8e1d7f1b$var$VALUES && nativeIterator && nativeIterator.name !== $6daeff2c8e1d7f1b$var$VALUES) {
        if ($6daeff2c8e1d7f1b$var$CONFIGURABLE_FUNCTION_NAME) $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$1(IterablePrototype, "name", $6daeff2c8e1d7f1b$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $6daeff2c8e1d7f1b$var$call$a(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($6daeff2c8e1d7f1b$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($6daeff2c8e1d7f1b$var$KEYS),
            entries: getIterationMethod($6daeff2c8e1d7f1b$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $6daeff2c8e1d7f1b$var$defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
        } else $6daeff2c8e1d7f1b$var$$$c({
            target: NAME,
            proto: true,
            forced: $6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$6daeff2c8e1d7f1b$var$ITERATOR$4] !== defaultIterator) $6daeff2c8e1d7f1b$var$defineBuiltIn$3(IterablePrototype, $6daeff2c8e1d7f1b$var$ITERATOR$4, defaultIterator, {
        name: DEFAULT
    });
    $6daeff2c8e1d7f1b$var$Iterators$3[NAME] = defaultIterator;
    return methods;
};
var $6daeff2c8e1d7f1b$var$toIndexedObject = $6daeff2c8e1d7f1b$var$toIndexedObject$5;
var $6daeff2c8e1d7f1b$var$addToUnscopables$1 = $6daeff2c8e1d7f1b$var$addToUnscopables$2;
var $6daeff2c8e1d7f1b$var$Iterators$2 = $6daeff2c8e1d7f1b$var$iterators;
var $6daeff2c8e1d7f1b$var$InternalStateModule$1 = $6daeff2c8e1d7f1b$var$internalState;
var $6daeff2c8e1d7f1b$var$defineProperty$2 = $6daeff2c8e1d7f1b$var$objectDefineProperty.f;
var $6daeff2c8e1d7f1b$var$defineIterator = $6daeff2c8e1d7f1b$var$defineIterator$1;
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$3 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$ARRAY_ITERATOR = "Array Iterator";
var $6daeff2c8e1d7f1b$var$setInternalState$1 = $6daeff2c8e1d7f1b$var$InternalStateModule$1.set;
var $6daeff2c8e1d7f1b$var$getInternalState = $6daeff2c8e1d7f1b$var$InternalStateModule$1.getterFor($6daeff2c8e1d7f1b$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $6daeff2c8e1d7f1b$var$es_array_iterator = $6daeff2c8e1d7f1b$var$defineIterator(Array, "Array", function(iterated, kind) {
    $6daeff2c8e1d7f1b$var$setInternalState$1(this, {
        type: $6daeff2c8e1d7f1b$var$ARRAY_ITERATOR,
        target: $6daeff2c8e1d7f1b$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $6daeff2c8e1d7f1b$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $6daeff2c8e1d7f1b$var$values = $6daeff2c8e1d7f1b$var$Iterators$2.Arguments = $6daeff2c8e1d7f1b$var$Iterators$2.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$6daeff2c8e1d7f1b$var$addToUnscopables$1("keys");
$6daeff2c8e1d7f1b$var$addToUnscopables$1("values");
$6daeff2c8e1d7f1b$var$addToUnscopables$1("entries");
// V8 ~ Chrome 45- bug
if ($6daeff2c8e1d7f1b$var$DESCRIPTORS$3 && $6daeff2c8e1d7f1b$var$values.name !== "values") try {
    $6daeff2c8e1d7f1b$var$defineProperty$2($6daeff2c8e1d7f1b$var$values, "name", {
        value: "values"
    });
} catch (error) {}
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $6daeff2c8e1d7f1b$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $6daeff2c8e1d7f1b$var$documentCreateElement = $6daeff2c8e1d7f1b$var$documentCreateElement$2;
var $6daeff2c8e1d7f1b$var$classList = $6daeff2c8e1d7f1b$var$documentCreateElement("span").classList;
var $6daeff2c8e1d7f1b$var$DOMTokenListPrototype$1 = $6daeff2c8e1d7f1b$var$classList && $6daeff2c8e1d7f1b$var$classList.constructor && $6daeff2c8e1d7f1b$var$classList.constructor.prototype;
var $6daeff2c8e1d7f1b$var$domTokenListPrototype = $6daeff2c8e1d7f1b$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $6daeff2c8e1d7f1b$var$DOMTokenListPrototype$1;
var $6daeff2c8e1d7f1b$var$global$a = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$DOMIterables = $6daeff2c8e1d7f1b$var$domIterables;
var $6daeff2c8e1d7f1b$var$DOMTokenListPrototype = $6daeff2c8e1d7f1b$var$domTokenListPrototype;
var $6daeff2c8e1d7f1b$var$ArrayIteratorMethods = $6daeff2c8e1d7f1b$var$es_array_iterator;
var $6daeff2c8e1d7f1b$var$createNonEnumerableProperty = $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$4;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$a = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$ITERATOR$3 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$a("iterator");
var $6daeff2c8e1d7f1b$var$TO_STRING_TAG$2 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$a("toStringTag");
var $6daeff2c8e1d7f1b$var$ArrayValues = $6daeff2c8e1d7f1b$var$ArrayIteratorMethods.values;
var $6daeff2c8e1d7f1b$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$6daeff2c8e1d7f1b$var$ITERATOR$3] !== $6daeff2c8e1d7f1b$var$ArrayValues) try {
            $6daeff2c8e1d7f1b$var$createNonEnumerableProperty(CollectionPrototype, $6daeff2c8e1d7f1b$var$ITERATOR$3, $6daeff2c8e1d7f1b$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$6daeff2c8e1d7f1b$var$ITERATOR$3] = $6daeff2c8e1d7f1b$var$ArrayValues;
        }
        if (!CollectionPrototype[$6daeff2c8e1d7f1b$var$TO_STRING_TAG$2]) $6daeff2c8e1d7f1b$var$createNonEnumerableProperty(CollectionPrototype, $6daeff2c8e1d7f1b$var$TO_STRING_TAG$2, COLLECTION_NAME);
        if ($6daeff2c8e1d7f1b$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $6daeff2c8e1d7f1b$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $6daeff2c8e1d7f1b$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $6daeff2c8e1d7f1b$var$createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, $6daeff2c8e1d7f1b$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $6daeff2c8e1d7f1b$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $6daeff2c8e1d7f1b$var$COLLECTION_NAME in $6daeff2c8e1d7f1b$var$DOMIterables)$6daeff2c8e1d7f1b$var$handlePrototype($6daeff2c8e1d7f1b$var$global$a[$6daeff2c8e1d7f1b$var$COLLECTION_NAME] && $6daeff2c8e1d7f1b$var$global$a[$6daeff2c8e1d7f1b$var$COLLECTION_NAME].prototype, $6daeff2c8e1d7f1b$var$COLLECTION_NAME);
$6daeff2c8e1d7f1b$var$handlePrototype($6daeff2c8e1d7f1b$var$DOMTokenListPrototype, "DOMTokenList");
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$2 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$uncurryThis$6 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$call$9 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$fails$6 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$objectKeys = $6daeff2c8e1d7f1b$var$objectKeys$2;
var $6daeff2c8e1d7f1b$var$getOwnPropertySymbolsModule = $6daeff2c8e1d7f1b$var$objectGetOwnPropertySymbols;
var $6daeff2c8e1d7f1b$var$propertyIsEnumerableModule = $6daeff2c8e1d7f1b$var$objectPropertyIsEnumerable;
var $6daeff2c8e1d7f1b$var$toObject$2 = $6daeff2c8e1d7f1b$var$toObject$5;
var $6daeff2c8e1d7f1b$var$IndexedObject$1 = $6daeff2c8e1d7f1b$var$indexedObject;
// eslint-disable-next-line es-x/no-object-assign -- safe
var $6daeff2c8e1d7f1b$var$$assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var $6daeff2c8e1d7f1b$var$defineProperty$1 = Object.defineProperty;
var $6daeff2c8e1d7f1b$var$concat = $6daeff2c8e1d7f1b$var$uncurryThis$6([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $6daeff2c8e1d7f1b$var$objectAssign = !$6daeff2c8e1d7f1b$var$$assign || $6daeff2c8e1d7f1b$var$fails$6(function() {
    // should have correct order of operations (Edge bug)
    if ($6daeff2c8e1d7f1b$var$DESCRIPTORS$2 && $6daeff2c8e1d7f1b$var$$assign({
        b: 1
    }, $6daeff2c8e1d7f1b$var$$assign($6daeff2c8e1d7f1b$var$defineProperty$1({}, "a", {
        enumerable: true,
        get: function() {
            $6daeff2c8e1d7f1b$var$defineProperty$1(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es-x/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $6daeff2c8e1d7f1b$var$$assign({}, A)[symbol] != 7 || $6daeff2c8e1d7f1b$var$objectKeys($6daeff2c8e1d7f1b$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $6daeff2c8e1d7f1b$var$toObject$2(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $6daeff2c8e1d7f1b$var$getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = $6daeff2c8e1d7f1b$var$propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = $6daeff2c8e1d7f1b$var$IndexedObject$1(arguments[index++]);
        var keys = getOwnPropertySymbols ? $6daeff2c8e1d7f1b$var$concat($6daeff2c8e1d7f1b$var$objectKeys(S), getOwnPropertySymbols(S)) : $6daeff2c8e1d7f1b$var$objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$6daeff2c8e1d7f1b$var$DESCRIPTORS$2 || $6daeff2c8e1d7f1b$var$call$9(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $6daeff2c8e1d7f1b$var$$assign;
var $6daeff2c8e1d7f1b$var$$$b = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$assign = $6daeff2c8e1d7f1b$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$6daeff2c8e1d7f1b$var$$$b({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $6daeff2c8e1d7f1b$var$assign
}, {
    assign: $6daeff2c8e1d7f1b$var$assign
});
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $6daeff2c8e1d7f1b$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
const $6daeff2c8e1d7f1b$var$CloseButton = ({ onClick: onClick })=>{
    return (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
        onClick: onClick,
        className: "close-button"
    }, {
        children: (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
            xmlns: "http://www.w3.org/2000/svg",
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            fill: "#C1C1C1"
        }, {
            children: [
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                })
            ]
        }))
    }));
};
const $6daeff2c8e1d7f1b$var$ModalHeader = ({ title: title, onCloseModal: onCloseModal })=>{
    const additionalClasses = title === "Get a Wallet" ? " -open" : "";
    return (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
        className: "nws-modal-header"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h3", Object.assign({
                className: `middleTitle ${additionalClasses}`
            }, {
                children: title
            })),
            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$CloseButton, {
                onClick: onCloseModal
            })
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$BackArrow = ({ onClick: onClick })=>{
    return (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
        onClick: onClick,
        className: "back-button"
    }, {
        children: (0, $7b02d682eb115277$exports.jsx)("svg", Object.assign({
            width: "8",
            height: "14",
            viewBox: "0 0 8 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, {
            children: (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 13L1 7L7 1",
                stroke: "#6494EE",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        }))
    }));
};
const $6daeff2c8e1d7f1b$var$WalletNetworkChanged = ({ selector: selector, onBack: onBack, onCloseModal: onCloseModal })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$BackArrow, {
                        onClick: onBack
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                        title: "You Must Change the Network",
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "switch-network-message-wrapper"
            }, {
                children: (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                "We've detected that you need to change your wallet's network to",
                                (0, $7b02d682eb115277$exports.jsx)("strong", Object.assign({
                                    className: "network-id"
                                }, {
                                    children: ` ${selector.options.network.networkId}`
                                })),
                                " ",
                                "for this dApp."
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Some wallets may not support changing networks. If you can not change networks you may consider switching to another wallet."
                        })
                    ]
                }))
            }))
        ]
    });
};
var $6daeff2c8e1d7f1b$var$tryToString$3 = $6daeff2c8e1d7f1b$var$tryToString$5;
var $6daeff2c8e1d7f1b$var$$TypeError$7 = TypeError;
var $6daeff2c8e1d7f1b$var$deletePropertyOrThrow$1 = function(O, P) {
    if (!delete O[P]) throw $6daeff2c8e1d7f1b$var$$TypeError$7("Cannot delete property " + $6daeff2c8e1d7f1b$var$tryToString$3(P) + " of " + $6daeff2c8e1d7f1b$var$tryToString$3(O));
};
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$9 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$TO_STRING_TAG$1 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$9("toStringTag");
var $6daeff2c8e1d7f1b$var$test$1 = {};
$6daeff2c8e1d7f1b$var$test$1[$6daeff2c8e1d7f1b$var$TO_STRING_TAG$1] = "z";
var $6daeff2c8e1d7f1b$var$toStringTagSupport = String($6daeff2c8e1d7f1b$var$test$1) === "[object z]";
var $6daeff2c8e1d7f1b$var$TO_STRING_TAG_SUPPORT = $6daeff2c8e1d7f1b$var$toStringTagSupport;
var $6daeff2c8e1d7f1b$var$isCallable$6 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$classofRaw = $6daeff2c8e1d7f1b$var$classofRaw$1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$8 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$TO_STRING_TAG = $6daeff2c8e1d7f1b$var$wellKnownSymbol$8("toStringTag");
var $6daeff2c8e1d7f1b$var$$Object = Object;
// ES3 wrong here
var $6daeff2c8e1d7f1b$var$CORRECT_ARGUMENTS = $6daeff2c8e1d7f1b$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $6daeff2c8e1d7f1b$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $6daeff2c8e1d7f1b$var$classof$5 = $6daeff2c8e1d7f1b$var$TO_STRING_TAG_SUPPORT ? $6daeff2c8e1d7f1b$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $6daeff2c8e1d7f1b$var$tryGet(O = $6daeff2c8e1d7f1b$var$$Object(it), $6daeff2c8e1d7f1b$var$TO_STRING_TAG)) == "string" ? tag : $6daeff2c8e1d7f1b$var$CORRECT_ARGUMENTS ? $6daeff2c8e1d7f1b$var$classofRaw(O) : (result = $6daeff2c8e1d7f1b$var$classofRaw(O)) == "Object" && $6daeff2c8e1d7f1b$var$isCallable$6(O.callee) ? "Arguments" : result;
};
var $6daeff2c8e1d7f1b$var$classof$4 = $6daeff2c8e1d7f1b$var$classof$5;
var $6daeff2c8e1d7f1b$var$$String = String;
var $6daeff2c8e1d7f1b$var$toString$3 = function(argument) {
    if ($6daeff2c8e1d7f1b$var$classof$4(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $6daeff2c8e1d7f1b$var$$String(argument);
};
var $6daeff2c8e1d7f1b$var$toPropertyKey = $6daeff2c8e1d7f1b$var$toPropertyKey$3;
var $6daeff2c8e1d7f1b$var$definePropertyModule$1 = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$createPropertyDescriptor = $6daeff2c8e1d7f1b$var$createPropertyDescriptor$4;
var $6daeff2c8e1d7f1b$var$createProperty$1 = function(object, key, value) {
    var propertyKey = $6daeff2c8e1d7f1b$var$toPropertyKey(key);
    if (propertyKey in object) $6daeff2c8e1d7f1b$var$definePropertyModule$1.f(object, propertyKey, $6daeff2c8e1d7f1b$var$createPropertyDescriptor(0, value));
    else object[propertyKey] = value;
};
var $6daeff2c8e1d7f1b$var$toAbsoluteIndex = $6daeff2c8e1d7f1b$var$toAbsoluteIndex$2;
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike$3 = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5;
var $6daeff2c8e1d7f1b$var$createProperty = $6daeff2c8e1d7f1b$var$createProperty$1;
var $6daeff2c8e1d7f1b$var$$Array = Array;
var $6daeff2c8e1d7f1b$var$max = Math.max;
var $6daeff2c8e1d7f1b$var$arraySliceSimple = function(O, start, end) {
    var length = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$3(O);
    var k = $6daeff2c8e1d7f1b$var$toAbsoluteIndex(start, length);
    var fin = $6daeff2c8e1d7f1b$var$toAbsoluteIndex(end === undefined ? length : end, length);
    var result = $6daeff2c8e1d7f1b$var$$Array($6daeff2c8e1d7f1b$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$6daeff2c8e1d7f1b$var$createProperty(result, n, O[k]);
    result.length = n;
    return result;
};
var $6daeff2c8e1d7f1b$var$arraySlice$2 = $6daeff2c8e1d7f1b$var$arraySliceSimple;
var $6daeff2c8e1d7f1b$var$floor = Math.floor;
var $6daeff2c8e1d7f1b$var$mergeSort = function(array, comparefn) {
    var length = array.length;
    var middle = $6daeff2c8e1d7f1b$var$floor(length / 2);
    return length < 8 ? $6daeff2c8e1d7f1b$var$insertionSort(array, comparefn) : $6daeff2c8e1d7f1b$var$merge(array, $6daeff2c8e1d7f1b$var$mergeSort($6daeff2c8e1d7f1b$var$arraySlice$2(array, 0, middle), comparefn), $6daeff2c8e1d7f1b$var$mergeSort($6daeff2c8e1d7f1b$var$arraySlice$2(array, middle), comparefn), comparefn);
};
var $6daeff2c8e1d7f1b$var$insertionSort = function(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $6daeff2c8e1d7f1b$var$merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
var $6daeff2c8e1d7f1b$var$arraySort = $6daeff2c8e1d7f1b$var$mergeSort;
var $6daeff2c8e1d7f1b$var$fails$5 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$arrayMethodIsStrict$2 = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $6daeff2c8e1d7f1b$var$fails$5(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};
var $6daeff2c8e1d7f1b$var$userAgent$4 = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$firefox = $6daeff2c8e1d7f1b$var$userAgent$4.match(/firefox\/(\d+)/i);
var $6daeff2c8e1d7f1b$var$engineFfVersion = !!$6daeff2c8e1d7f1b$var$firefox && +$6daeff2c8e1d7f1b$var$firefox[1];
var $6daeff2c8e1d7f1b$var$UA = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$engineIsIeOrEdge = /MSIE|Trident/.test($6daeff2c8e1d7f1b$var$UA);
var $6daeff2c8e1d7f1b$var$userAgent$3 = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$webkit = $6daeff2c8e1d7f1b$var$userAgent$3.match(/AppleWebKit\/(\d+)\./);
var $6daeff2c8e1d7f1b$var$engineWebkitVersion = !!$6daeff2c8e1d7f1b$var$webkit && +$6daeff2c8e1d7f1b$var$webkit[1];
var $6daeff2c8e1d7f1b$var$$$a = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$uncurryThis$5 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$aCallable$7 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$toObject$1 = $6daeff2c8e1d7f1b$var$toObject$5;
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike$2 = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5;
var $6daeff2c8e1d7f1b$var$deletePropertyOrThrow = $6daeff2c8e1d7f1b$var$deletePropertyOrThrow$1;
var $6daeff2c8e1d7f1b$var$toString$2 = $6daeff2c8e1d7f1b$var$toString$3;
var $6daeff2c8e1d7f1b$var$fails$4 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$internalSort = $6daeff2c8e1d7f1b$var$arraySort;
var $6daeff2c8e1d7f1b$var$arrayMethodIsStrict$1 = $6daeff2c8e1d7f1b$var$arrayMethodIsStrict$2;
var $6daeff2c8e1d7f1b$var$FF = $6daeff2c8e1d7f1b$var$engineFfVersion;
var $6daeff2c8e1d7f1b$var$IE_OR_EDGE = $6daeff2c8e1d7f1b$var$engineIsIeOrEdge;
var $6daeff2c8e1d7f1b$var$V8 = $6daeff2c8e1d7f1b$var$engineV8Version;
var $6daeff2c8e1d7f1b$var$WEBKIT = $6daeff2c8e1d7f1b$var$engineWebkitVersion;
var $6daeff2c8e1d7f1b$var$test = [];
var $6daeff2c8e1d7f1b$var$un$Sort = $6daeff2c8e1d7f1b$var$uncurryThis$5($6daeff2c8e1d7f1b$var$test.sort);
var $6daeff2c8e1d7f1b$var$push = $6daeff2c8e1d7f1b$var$uncurryThis$5($6daeff2c8e1d7f1b$var$test.push);
// IE8-
var $6daeff2c8e1d7f1b$var$FAILS_ON_UNDEFINED = $6daeff2c8e1d7f1b$var$fails$4(function() {
    $6daeff2c8e1d7f1b$var$test.sort(undefined);
});
// V8 bug
var $6daeff2c8e1d7f1b$var$FAILS_ON_NULL = $6daeff2c8e1d7f1b$var$fails$4(function() {
    $6daeff2c8e1d7f1b$var$test.sort(null);
});
// Old WebKit
var $6daeff2c8e1d7f1b$var$STRICT_METHOD$1 = $6daeff2c8e1d7f1b$var$arrayMethodIsStrict$1("sort");
var $6daeff2c8e1d7f1b$var$STABLE_SORT = !$6daeff2c8e1d7f1b$var$fails$4(function() {
    // feature detection can be too slow, so check engines versions
    if ($6daeff2c8e1d7f1b$var$V8) return $6daeff2c8e1d7f1b$var$V8 < 70;
    if ($6daeff2c8e1d7f1b$var$FF && $6daeff2c8e1d7f1b$var$FF > 3) return;
    if ($6daeff2c8e1d7f1b$var$IE_OR_EDGE) return true;
    if ($6daeff2c8e1d7f1b$var$WEBKIT) return $6daeff2c8e1d7f1b$var$WEBKIT < 603;
    var result = "";
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$6daeff2c8e1d7f1b$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $6daeff2c8e1d7f1b$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $6daeff2c8e1d7f1b$var$test.length; index++){
        chr = $6daeff2c8e1d7f1b$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== "DGBEFHACIJK";
});
var $6daeff2c8e1d7f1b$var$FORCED = $6daeff2c8e1d7f1b$var$FAILS_ON_UNDEFINED || !$6daeff2c8e1d7f1b$var$FAILS_ON_NULL || !$6daeff2c8e1d7f1b$var$STRICT_METHOD$1 || !$6daeff2c8e1d7f1b$var$STABLE_SORT;
var $6daeff2c8e1d7f1b$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $6daeff2c8e1d7f1b$var$toString$2(x) > $6daeff2c8e1d7f1b$var$toString$2(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$6daeff2c8e1d7f1b$var$$$a({
    target: "Array",
    proto: true,
    forced: $6daeff2c8e1d7f1b$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $6daeff2c8e1d7f1b$var$aCallable$7(comparefn);
        var array = $6daeff2c8e1d7f1b$var$toObject$1(this);
        if ($6daeff2c8e1d7f1b$var$STABLE_SORT) return comparefn === undefined ? $6daeff2c8e1d7f1b$var$un$Sort(array) : $6daeff2c8e1d7f1b$var$un$Sort(array, comparefn);
        var items = [];
        var arrayLength = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$2(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $6daeff2c8e1d7f1b$var$push(items, array[index]);
        $6daeff2c8e1d7f1b$var$internalSort(items, $6daeff2c8e1d7f1b$var$getSortCompare(comparefn));
        itemsLength = items.length;
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$6daeff2c8e1d7f1b$var$deletePropertyOrThrow(array, index++);
        return array;
    }
});
var $6daeff2c8e1d7f1b$var$$$9 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$$includes = $6daeff2c8e1d7f1b$var$arrayIncludes.includes;
var $6daeff2c8e1d7f1b$var$fails$3 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$addToUnscopables = $6daeff2c8e1d7f1b$var$addToUnscopables$2;
// FF99+ bug
var $6daeff2c8e1d7f1b$var$BROKEN_ON_SPARSE = $6daeff2c8e1d7f1b$var$fails$3(function() {
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$6daeff2c8e1d7f1b$var$$$9({
    target: "Array",
    proto: true,
    forced: $6daeff2c8e1d7f1b$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $6daeff2c8e1d7f1b$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$6daeff2c8e1d7f1b$var$addToUnscopables("includes");
var $6daeff2c8e1d7f1b$var$isObject$2 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$classof$3 = $6daeff2c8e1d7f1b$var$classofRaw$1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$7 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$MATCH$1 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$7("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var $6daeff2c8e1d7f1b$var$isRegexp = function(it) {
    var isRegExp;
    return $6daeff2c8e1d7f1b$var$isObject$2(it) && ((isRegExp = it[$6daeff2c8e1d7f1b$var$MATCH$1]) !== undefined ? !!isRegExp : $6daeff2c8e1d7f1b$var$classof$3(it) == "RegExp");
};
var $6daeff2c8e1d7f1b$var$isRegExp = $6daeff2c8e1d7f1b$var$isRegexp;
var $6daeff2c8e1d7f1b$var$$TypeError$6 = TypeError;
var $6daeff2c8e1d7f1b$var$notARegexp = function(it) {
    if ($6daeff2c8e1d7f1b$var$isRegExp(it)) throw $6daeff2c8e1d7f1b$var$$TypeError$6("The method doesn't accept regular expressions");
    return it;
};
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$6 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$MATCH = $6daeff2c8e1d7f1b$var$wellKnownSymbol$6("match");
var $6daeff2c8e1d7f1b$var$correctIsRegexpLogic = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$6daeff2c8e1d7f1b$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};
var $6daeff2c8e1d7f1b$var$$$8 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$uncurryThis$4 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$notARegExp = $6daeff2c8e1d7f1b$var$notARegexp;
var $6daeff2c8e1d7f1b$var$requireObjectCoercible = $6daeff2c8e1d7f1b$var$requireObjectCoercible$3;
var $6daeff2c8e1d7f1b$var$toString$1 = $6daeff2c8e1d7f1b$var$toString$3;
var $6daeff2c8e1d7f1b$var$correctIsRegExpLogic = $6daeff2c8e1d7f1b$var$correctIsRegexpLogic;
var $6daeff2c8e1d7f1b$var$stringIndexOf = $6daeff2c8e1d7f1b$var$uncurryThis$4("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$6daeff2c8e1d7f1b$var$$$8({
    target: "String",
    proto: true,
    forced: !$6daeff2c8e1d7f1b$var$correctIsRegExpLogic("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$6daeff2c8e1d7f1b$var$stringIndexOf($6daeff2c8e1d7f1b$var$toString$1($6daeff2c8e1d7f1b$var$requireObjectCoercible(this)), $6daeff2c8e1d7f1b$var$toString$1($6daeff2c8e1d7f1b$var$notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $6daeff2c8e1d7f1b$var$aCallable$6 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$toObject = $6daeff2c8e1d7f1b$var$toObject$5;
var $6daeff2c8e1d7f1b$var$IndexedObject = $6daeff2c8e1d7f1b$var$indexedObject;
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike$1 = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5;
var $6daeff2c8e1d7f1b$var$$TypeError$5 = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $6daeff2c8e1d7f1b$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $6daeff2c8e1d7f1b$var$aCallable$6(callbackfn);
        var O = $6daeff2c8e1d7f1b$var$toObject(that);
        var self1 = $6daeff2c8e1d7f1b$var$IndexedObject(O);
        var length = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$1(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self1) {
                memo = self1[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $6daeff2c8e1d7f1b$var$$TypeError$5("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
        return memo;
    };
};
var $6daeff2c8e1d7f1b$var$arrayReduce = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $6daeff2c8e1d7f1b$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $6daeff2c8e1d7f1b$var$createMethod(true)
};
var $6daeff2c8e1d7f1b$var$classof$2 = $6daeff2c8e1d7f1b$var$classofRaw$1;
var $6daeff2c8e1d7f1b$var$global$9 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$engineIsNode = $6daeff2c8e1d7f1b$var$classof$2($6daeff2c8e1d7f1b$var$global$9.process) == "process";
var $6daeff2c8e1d7f1b$var$$$7 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$$reduce = $6daeff2c8e1d7f1b$var$arrayReduce.left;
var $6daeff2c8e1d7f1b$var$arrayMethodIsStrict = $6daeff2c8e1d7f1b$var$arrayMethodIsStrict$2;
var $6daeff2c8e1d7f1b$var$CHROME_VERSION = $6daeff2c8e1d7f1b$var$engineV8Version;
var $6daeff2c8e1d7f1b$var$IS_NODE$3 = $6daeff2c8e1d7f1b$var$engineIsNode;
var $6daeff2c8e1d7f1b$var$STRICT_METHOD = $6daeff2c8e1d7f1b$var$arrayMethodIsStrict("reduce");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $6daeff2c8e1d7f1b$var$CHROME_BUG = !$6daeff2c8e1d7f1b$var$IS_NODE$3 && $6daeff2c8e1d7f1b$var$CHROME_VERSION > 79 && $6daeff2c8e1d7f1b$var$CHROME_VERSION < 83;
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$6daeff2c8e1d7f1b$var$$$7({
    target: "Array",
    proto: true,
    forced: !$6daeff2c8e1d7f1b$var$STRICT_METHOD || $6daeff2c8e1d7f1b$var$CHROME_BUG
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $6daeff2c8e1d7f1b$var$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});
var $6daeff2c8e1d7f1b$var$$$6 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$1 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$global$8 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$uncurryThis$3 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$hasOwn$2 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$isCallable$5 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isPrototypeOf$3 = $6daeff2c8e1d7f1b$var$objectIsPrototypeOf;
var $6daeff2c8e1d7f1b$var$toString = $6daeff2c8e1d7f1b$var$toString$3;
var $6daeff2c8e1d7f1b$var$defineProperty = $6daeff2c8e1d7f1b$var$objectDefineProperty.f;
var $6daeff2c8e1d7f1b$var$copyConstructorProperties = $6daeff2c8e1d7f1b$var$copyConstructorProperties$2;
var $6daeff2c8e1d7f1b$var$NativeSymbol = $6daeff2c8e1d7f1b$var$global$8.Symbol;
var $6daeff2c8e1d7f1b$var$SymbolPrototype = $6daeff2c8e1d7f1b$var$NativeSymbol && $6daeff2c8e1d7f1b$var$NativeSymbol.prototype;
if ($6daeff2c8e1d7f1b$var$DESCRIPTORS$1 && $6daeff2c8e1d7f1b$var$isCallable$5($6daeff2c8e1d7f1b$var$NativeSymbol) && (!("description" in $6daeff2c8e1d7f1b$var$SymbolPrototype) || // Safari 12 bug
$6daeff2c8e1d7f1b$var$NativeSymbol().description !== undefined)) {
    var $6daeff2c8e1d7f1b$var$EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var $6daeff2c8e1d7f1b$var$SymbolWrapper = function Symbol1() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : $6daeff2c8e1d7f1b$var$toString(arguments[0]);
        var result = $6daeff2c8e1d7f1b$var$isPrototypeOf$3($6daeff2c8e1d7f1b$var$SymbolPrototype, this) ? new $6daeff2c8e1d7f1b$var$NativeSymbol(description) : description === undefined ? $6daeff2c8e1d7f1b$var$NativeSymbol() : $6daeff2c8e1d7f1b$var$NativeSymbol(description);
        if (description === "") $6daeff2c8e1d7f1b$var$EmptyStringDescriptionStore[result] = true;
        return result;
    };
    $6daeff2c8e1d7f1b$var$copyConstructorProperties($6daeff2c8e1d7f1b$var$SymbolWrapper, $6daeff2c8e1d7f1b$var$NativeSymbol);
    $6daeff2c8e1d7f1b$var$SymbolWrapper.prototype = $6daeff2c8e1d7f1b$var$SymbolPrototype;
    $6daeff2c8e1d7f1b$var$SymbolPrototype.constructor = $6daeff2c8e1d7f1b$var$SymbolWrapper;
    var $6daeff2c8e1d7f1b$var$NATIVE_SYMBOL = String($6daeff2c8e1d7f1b$var$NativeSymbol("test")) == "Symbol(test)";
    var $6daeff2c8e1d7f1b$var$symbolToString = $6daeff2c8e1d7f1b$var$uncurryThis$3($6daeff2c8e1d7f1b$var$SymbolPrototype.toString);
    var $6daeff2c8e1d7f1b$var$symbolValueOf = $6daeff2c8e1d7f1b$var$uncurryThis$3($6daeff2c8e1d7f1b$var$SymbolPrototype.valueOf);
    var $6daeff2c8e1d7f1b$var$regexp = /^Symbol\((.*)\)[^)]+$/;
    var $6daeff2c8e1d7f1b$var$replace = $6daeff2c8e1d7f1b$var$uncurryThis$3("".replace);
    var $6daeff2c8e1d7f1b$var$stringSlice = $6daeff2c8e1d7f1b$var$uncurryThis$3("".slice);
    $6daeff2c8e1d7f1b$var$defineProperty($6daeff2c8e1d7f1b$var$SymbolPrototype, "description", {
        configurable: true,
        get: function description() {
            var symbol = $6daeff2c8e1d7f1b$var$symbolValueOf(this);
            var string = $6daeff2c8e1d7f1b$var$symbolToString(symbol);
            if ($6daeff2c8e1d7f1b$var$hasOwn$2($6daeff2c8e1d7f1b$var$EmptyStringDescriptionStore, symbol)) return "";
            var desc = $6daeff2c8e1d7f1b$var$NATIVE_SYMBOL ? $6daeff2c8e1d7f1b$var$stringSlice(string, 7, -1) : $6daeff2c8e1d7f1b$var$replace(string, $6daeff2c8e1d7f1b$var$regexp, "$1");
            return desc === "" ? undefined : desc;
        }
    });
    $6daeff2c8e1d7f1b$var$$$6({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: $6daeff2c8e1d7f1b$var$SymbolWrapper
    });
}
const $6daeff2c8e1d7f1b$var$WalletOptions = ({ selector: selector, handleWalletClick: handleWalletClick })=>{
    const [modules, setModules] = (0, $acw62.useState)([]);
    const [recentModules, setRecentModules] = (0, $acw62.useState)([]);
    const [moreModules, setMoreModules] = (0, $acw62.useState)([]);
    const [activeWalletId, setActiveWalletId] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        const subscription = selector.store.observable.subscribe((state)=>{
            const { selectedWalletId: selectedWalletId } = selector.store.getState();
            if (selectedWalletId) setActiveWalletId(selectedWalletId);
            const wallets = state.modules.filter((module)=>!(module.type === "instant-link" && selectedWalletId !== module.id));
            if (selector.options.optimizeWalletOrder) {
                state.modules.sort((current, next)=>{
                    if (current.metadata.deprecated === next.metadata.deprecated) return 0;
                    return current.metadata.deprecated ? 1 : -1;
                });
                state.modules.sort((current, next)=>{
                    if (next.metadata.available === current.metadata.available) return 0;
                    return next.metadata.available ? 1 : -1;
                });
                const moreWallets = [];
                const recentlySignedInWallets = [];
                wallets.forEach((module)=>{
                    if (selector.store.getState().recentlySignedInWallets.includes(module.id)) recentlySignedInWallets.push(module);
                    else moreWallets.push(module);
                });
                setRecentModules(recentlySignedInWallets);
                setMoreModules(moreWallets);
            }
            if (selector.options.randomizeWalletOrder) setModules(wallets.sort(()=>Math.random() - 0.5));
            else setModules(wallets);
        });
        return ()=>subscription.unsubscribe(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function renderOptionsList(modulesToRender) {
        return modulesToRender.reduce((result, module, index)=>{
            const { selectedWalletId: selectedWalletId } = selector.store.getState();
            const { name: name, description: description, iconUrl: iconUrl, deprecated: deprecated } = module.metadata;
            const selected = module.id === selectedWalletId;
            result.push((0, $7b02d682eb115277$exports.jsxs)("li", Object.assign({
                tabIndex: 0,
                className: `single-wallet ${activeWalletId === module.id ? "selected-wallet" : ""} ${selected ? "connected-wallet" : ""} ${deprecated ? "deprecated-wallet" : ""} sidebar ${module.id}`,
                onClick: ()=>{
                    if (module.id === modulesToRender[index].id) setActiveWalletId(module.id);
                    return handleWalletClick(module);
                }
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "icon"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: iconUrl,
                            alt: name
                        })
                    })),
                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "content"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "title"
                            }, {
                                children: name
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "description"
                            }, {
                                children: description
                            }))
                        ]
                    })),
                    deprecated && (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "warning-triangle"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
                            width: "18",
                            height: "18",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                        }, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M4.95215 16.3536L10.2152 5.85657C10.9531 4.38481 13.0538 4.38519 13.7912 5.85723L19.0494 16.3543C19.7156 17.6841 18.7486 19.25 17.2612 19.25H6.74001C5.25228 19.25 4.28535 17.6835 4.95215 16.3536Z",
                                    stroke: "#E6B73E",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M12 10V12",
                                    stroke: "#E6B73E",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16C11.5 15.7239 11.7239 15.5 12 15.5C12.2761 15.5 12.5 15.7239 12.5 16Z",
                                    stroke: "#E6B73E"
                                })
                            ]
                        }))
                    }))
                ]
            }), module.id));
            return result;
        }, []);
    }
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        children: selector.options.optimizeWalletOrder && selector.store.getState().recentlySignedInWallets.length > 0 ? (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
            className: "wallet-options-wrapper"
        }, {
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "options-list-section"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "options-list-section-header"
                        }, {
                            children: "Recent"
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "options-list more-options-list-content"
                        }, {
                            children: renderOptionsList(recentModules)
                        }))
                    ]
                })),
                (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "options-list-section"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "options-list-section-header"
                        }, {
                            children: "More"
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "options-list more-options-list-content"
                        }, {
                            children: renderOptionsList(moreModules)
                        }))
                    ]
                }))
            ]
        })) : (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
            className: "wallet-options-wrapper"
        }, {
            children: (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "options-list"
            }, {
                children: renderOptionsList(modules)
            }))
        }))
    });
};
const $6daeff2c8e1d7f1b$var$ConnectionResult = ({ module: module, message: message, err: err, onRetry: onRetry })=>{
    return (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
        className: "connection connecting-details"
    }, {
        children: err ? (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
            className: "error-wrapper"
        }, {
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "error"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
                            width: "21",
                            height: "20",
                            viewBox: "0 0 21 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                        }, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M10.5001 18.3333C15.1025 18.3333 18.8334 14.6023 18.8334 9.99996C18.8334 5.39759 15.1025 1.66663 10.5001 1.66663C5.89771 1.66663 2.16675 5.39759 2.16675 9.99996C2.16675 14.6023 5.89771 18.3333 10.5001 18.3333Z",
                                    stroke: "#CE5A6F",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M13 7.5L8 12.5",
                                    stroke: "#CE5A6F",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M8 7.5L13 12.5",
                                    stroke: "#CE5A6F",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })),
                        (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.connectionFailed")
                    ]
                })),
                (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: message
                }),
                (module === null || module === void 0 ? void 0 : module.metadata.available) && (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                    onClick: onRetry
                }, {
                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.retry")
                }))
            ]
        })) : (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
            className: "success"
        }, {
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
                    width: "21",
                    height: "20",
                    viewBox: "0 0 21 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M18.8333 9.2333V9.99997C18.8323 11.797 18.2504 13.5455 17.1744 14.9848C16.0984 16.4241 14.586 17.477 12.8628 17.9866C11.1395 18.4961 9.29768 18.4349 7.61202 17.8121C5.92636 17.1894 4.48717 16.0384 3.50909 14.5309C2.53101 13.0233 2.06645 11.24 2.18469 9.4469C2.30293 7.65377 2.99763 5.94691 4.16519 4.58086C5.33275 3.21482 6.91061 2.26279 8.66345 1.86676C10.4163 1.47073 12.2502 1.65192 13.8916 2.3833",
                            stroke: "#4FD98F",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M18.8333 3.33337L10.5 11.675L8 9.17504",
                            stroke: "#4FD98F",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })),
                (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.connectionSuccessful")
            ]
        }))
    }));
};
const $6daeff2c8e1d7f1b$var$AlertMessage = ({ message: message, module: module, onBack: onBack, onCloseModal: onCloseModal })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                title: "",
                onCloseModal: onCloseModal
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "alert-message connecting-wrapper connecting-wrapper-err"
            }, {
                children: (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "icon"
                        }, {
                            children: (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: module === null || module === void 0 ? void 0 : module.metadata.iconUrl,
                                alt: module === null || module === void 0 ? void 0 : module.metadata.name
                            })
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("h3", Object.assign({
                            className: "connecting-name"
                        }, {
                            children: module === null || module === void 0 ? void 0 : module.metadata.name
                        })),
                        (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ConnectionResult, {
                            module: module,
                            message: message,
                            err: message !== null,
                            onRetry: ()=>{
                                onBack(true);
                            }
                        })
                    ]
                }))
            }))
        ]
    });
};
var $6daeff2c8e1d7f1b$var$getBuiltIn$3 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$definePropertyModule = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$5 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$DESCRIPTORS = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$SPECIES$2 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$5("species");
var $6daeff2c8e1d7f1b$var$setSpecies$1 = function(CONSTRUCTOR_NAME) {
    var Constructor = $6daeff2c8e1d7f1b$var$getBuiltIn$3(CONSTRUCTOR_NAME);
    var defineProperty = $6daeff2c8e1d7f1b$var$definePropertyModule.f;
    if ($6daeff2c8e1d7f1b$var$DESCRIPTORS && Constructor && !Constructor[$6daeff2c8e1d7f1b$var$SPECIES$2]) defineProperty(Constructor, $6daeff2c8e1d7f1b$var$SPECIES$2, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};
var $6daeff2c8e1d7f1b$var$isPrototypeOf$2 = $6daeff2c8e1d7f1b$var$objectIsPrototypeOf;
var $6daeff2c8e1d7f1b$var$$TypeError$4 = TypeError;
var $6daeff2c8e1d7f1b$var$anInstance$1 = function(it, Prototype) {
    if ($6daeff2c8e1d7f1b$var$isPrototypeOf$2(Prototype, it)) return it;
    throw $6daeff2c8e1d7f1b$var$$TypeError$4("Incorrect invocation");
};
var $6daeff2c8e1d7f1b$var$uncurryThis$2 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$fails$2 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$isCallable$4 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$classof$1 = $6daeff2c8e1d7f1b$var$classof$5;
var $6daeff2c8e1d7f1b$var$getBuiltIn$2 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$inspectSource$1 = $6daeff2c8e1d7f1b$var$inspectSource$4;
var $6daeff2c8e1d7f1b$var$noop = function() {};
var $6daeff2c8e1d7f1b$var$empty = [];
var $6daeff2c8e1d7f1b$var$construct = $6daeff2c8e1d7f1b$var$getBuiltIn$2("Reflect", "construct");
var $6daeff2c8e1d7f1b$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $6daeff2c8e1d7f1b$var$exec = $6daeff2c8e1d7f1b$var$uncurryThis$2($6daeff2c8e1d7f1b$var$constructorRegExp.exec);
var $6daeff2c8e1d7f1b$var$INCORRECT_TO_STRING = !$6daeff2c8e1d7f1b$var$constructorRegExp.exec($6daeff2c8e1d7f1b$var$noop);
var $6daeff2c8e1d7f1b$var$isConstructorModern = function isConstructor(argument) {
    if (!$6daeff2c8e1d7f1b$var$isCallable$4(argument)) return false;
    try {
        $6daeff2c8e1d7f1b$var$construct($6daeff2c8e1d7f1b$var$noop, $6daeff2c8e1d7f1b$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $6daeff2c8e1d7f1b$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$6daeff2c8e1d7f1b$var$isCallable$4(argument)) return false;
    switch($6daeff2c8e1d7f1b$var$classof$1(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $6daeff2c8e1d7f1b$var$INCORRECT_TO_STRING || !!$6daeff2c8e1d7f1b$var$exec($6daeff2c8e1d7f1b$var$constructorRegExp, $6daeff2c8e1d7f1b$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$6daeff2c8e1d7f1b$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $6daeff2c8e1d7f1b$var$isConstructor$1 = !$6daeff2c8e1d7f1b$var$construct || $6daeff2c8e1d7f1b$var$fails$2(function() {
    var called;
    return $6daeff2c8e1d7f1b$var$isConstructorModern($6daeff2c8e1d7f1b$var$isConstructorModern.call) || !$6daeff2c8e1d7f1b$var$isConstructorModern(Object) || !$6daeff2c8e1d7f1b$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $6daeff2c8e1d7f1b$var$isConstructorLegacy : $6daeff2c8e1d7f1b$var$isConstructorModern;
var $6daeff2c8e1d7f1b$var$isConstructor = $6daeff2c8e1d7f1b$var$isConstructor$1;
var $6daeff2c8e1d7f1b$var$tryToString$2 = $6daeff2c8e1d7f1b$var$tryToString$5;
var $6daeff2c8e1d7f1b$var$$TypeError$3 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $6daeff2c8e1d7f1b$var$aConstructor$1 = function(argument) {
    if ($6daeff2c8e1d7f1b$var$isConstructor(argument)) return argument;
    throw $6daeff2c8e1d7f1b$var$$TypeError$3($6daeff2c8e1d7f1b$var$tryToString$2(argument) + " is not a constructor");
};
var $6daeff2c8e1d7f1b$var$anObject$6 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$aConstructor = $6daeff2c8e1d7f1b$var$aConstructor$1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$4 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$SPECIES$1 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$4("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $6daeff2c8e1d7f1b$var$speciesConstructor$1 = function(O, defaultConstructor) {
    var C = $6daeff2c8e1d7f1b$var$anObject$6(O).constructor;
    var S;
    return C === undefined || (S = $6daeff2c8e1d7f1b$var$anObject$6(C)[$6daeff2c8e1d7f1b$var$SPECIES$1]) == undefined ? defaultConstructor : $6daeff2c8e1d7f1b$var$aConstructor(S);
};
var $6daeff2c8e1d7f1b$var$NATIVE_BIND$1 = $6daeff2c8e1d7f1b$var$functionBindNative;
var $6daeff2c8e1d7f1b$var$FunctionPrototype = Function.prototype;
var $6daeff2c8e1d7f1b$var$apply$1 = $6daeff2c8e1d7f1b$var$FunctionPrototype.apply;
var $6daeff2c8e1d7f1b$var$call$8 = $6daeff2c8e1d7f1b$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $6daeff2c8e1d7f1b$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($6daeff2c8e1d7f1b$var$NATIVE_BIND$1 ? $6daeff2c8e1d7f1b$var$call$8.bind($6daeff2c8e1d7f1b$var$apply$1) : function() {
    return $6daeff2c8e1d7f1b$var$call$8.apply($6daeff2c8e1d7f1b$var$apply$1, arguments);
});
var $6daeff2c8e1d7f1b$var$uncurryThis$1 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$aCallable$5 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$NATIVE_BIND = $6daeff2c8e1d7f1b$var$functionBindNative;
var $6daeff2c8e1d7f1b$var$bind$4 = $6daeff2c8e1d7f1b$var$uncurryThis$1($6daeff2c8e1d7f1b$var$uncurryThis$1.bind);
// optional / simple context binding
var $6daeff2c8e1d7f1b$var$functionBindContext = function(fn, that) {
    $6daeff2c8e1d7f1b$var$aCallable$5(fn);
    return that === undefined ? fn : $6daeff2c8e1d7f1b$var$NATIVE_BIND ? $6daeff2c8e1d7f1b$var$bind$4(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $6daeff2c8e1d7f1b$var$uncurryThis = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$arraySlice$1 = $6daeff2c8e1d7f1b$var$uncurryThis([].slice);
var $6daeff2c8e1d7f1b$var$$TypeError$2 = TypeError;
var $6daeff2c8e1d7f1b$var$validateArgumentsLength$1 = function(passed, required) {
    if (passed < required) throw $6daeff2c8e1d7f1b$var$$TypeError$2("Not enough arguments");
    return passed;
};
var $6daeff2c8e1d7f1b$var$userAgent$2 = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($6daeff2c8e1d7f1b$var$userAgent$2);
var $6daeff2c8e1d7f1b$var$global$7 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$apply = $6daeff2c8e1d7f1b$var$functionApply;
var $6daeff2c8e1d7f1b$var$bind$3 = $6daeff2c8e1d7f1b$var$functionBindContext;
var $6daeff2c8e1d7f1b$var$isCallable$3 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$hasOwn$1 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$fails$1 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$html = $6daeff2c8e1d7f1b$var$html$2;
var $6daeff2c8e1d7f1b$var$arraySlice = $6daeff2c8e1d7f1b$var$arraySlice$1;
var $6daeff2c8e1d7f1b$var$createElement = $6daeff2c8e1d7f1b$var$documentCreateElement$2;
var $6daeff2c8e1d7f1b$var$validateArgumentsLength = $6daeff2c8e1d7f1b$var$validateArgumentsLength$1;
var $6daeff2c8e1d7f1b$var$IS_IOS$1 = $6daeff2c8e1d7f1b$var$engineIsIos;
var $6daeff2c8e1d7f1b$var$IS_NODE$2 = $6daeff2c8e1d7f1b$var$engineIsNode;
var $6daeff2c8e1d7f1b$var$set = $6daeff2c8e1d7f1b$var$global$7.setImmediate;
var $6daeff2c8e1d7f1b$var$clear = $6daeff2c8e1d7f1b$var$global$7.clearImmediate;
var $6daeff2c8e1d7f1b$var$process$2 = $6daeff2c8e1d7f1b$var$global$7.process;
var $6daeff2c8e1d7f1b$var$Dispatch = $6daeff2c8e1d7f1b$var$global$7.Dispatch;
var $6daeff2c8e1d7f1b$var$Function$1 = $6daeff2c8e1d7f1b$var$global$7.Function;
var $6daeff2c8e1d7f1b$var$MessageChannel = $6daeff2c8e1d7f1b$var$global$7.MessageChannel;
var $6daeff2c8e1d7f1b$var$String$1 = $6daeff2c8e1d7f1b$var$global$7.String;
var $6daeff2c8e1d7f1b$var$counter = 0;
var $6daeff2c8e1d7f1b$var$queue$1 = {};
var $6daeff2c8e1d7f1b$var$ONREADYSTATECHANGE = "onreadystatechange";
var $6daeff2c8e1d7f1b$var$location, $6daeff2c8e1d7f1b$var$defer, $6daeff2c8e1d7f1b$var$channel, $6daeff2c8e1d7f1b$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $6daeff2c8e1d7f1b$var$location = $6daeff2c8e1d7f1b$var$global$7.location;
} catch (error) {}
var $6daeff2c8e1d7f1b$var$run = function(id) {
    if ($6daeff2c8e1d7f1b$var$hasOwn$1($6daeff2c8e1d7f1b$var$queue$1, id)) {
        var fn = $6daeff2c8e1d7f1b$var$queue$1[id];
        delete $6daeff2c8e1d7f1b$var$queue$1[id];
        fn();
    }
};
var $6daeff2c8e1d7f1b$var$runner = function(id) {
    return function() {
        $6daeff2c8e1d7f1b$var$run(id);
    };
};
var $6daeff2c8e1d7f1b$var$listener = function(event) {
    $6daeff2c8e1d7f1b$var$run(event.data);
};
var $6daeff2c8e1d7f1b$var$post = function(id) {
    // old engines have not location.origin
    $6daeff2c8e1d7f1b$var$global$7.postMessage($6daeff2c8e1d7f1b$var$String$1(id), $6daeff2c8e1d7f1b$var$location.protocol + "//" + $6daeff2c8e1d7f1b$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$6daeff2c8e1d7f1b$var$set || !$6daeff2c8e1d7f1b$var$clear) {
    $6daeff2c8e1d7f1b$var$set = function setImmediate(handler) {
        $6daeff2c8e1d7f1b$var$validateArgumentsLength(arguments.length, 1);
        var fn = $6daeff2c8e1d7f1b$var$isCallable$3(handler) ? handler : $6daeff2c8e1d7f1b$var$Function$1(handler);
        var args = $6daeff2c8e1d7f1b$var$arraySlice(arguments, 1);
        $6daeff2c8e1d7f1b$var$queue$1[++$6daeff2c8e1d7f1b$var$counter] = function() {
            $6daeff2c8e1d7f1b$var$apply(fn, undefined, args);
        };
        $6daeff2c8e1d7f1b$var$defer($6daeff2c8e1d7f1b$var$counter);
        return $6daeff2c8e1d7f1b$var$counter;
    };
    $6daeff2c8e1d7f1b$var$clear = function clearImmediate(id) {
        delete $6daeff2c8e1d7f1b$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($6daeff2c8e1d7f1b$var$IS_NODE$2) $6daeff2c8e1d7f1b$var$defer = function(id) {
        $6daeff2c8e1d7f1b$var$process$2.nextTick($6daeff2c8e1d7f1b$var$runner(id));
    };
    else if ($6daeff2c8e1d7f1b$var$Dispatch && $6daeff2c8e1d7f1b$var$Dispatch.now) $6daeff2c8e1d7f1b$var$defer = function(id) {
        $6daeff2c8e1d7f1b$var$Dispatch.now($6daeff2c8e1d7f1b$var$runner(id));
    };
    else if ($6daeff2c8e1d7f1b$var$MessageChannel && !$6daeff2c8e1d7f1b$var$IS_IOS$1) {
        $6daeff2c8e1d7f1b$var$channel = new $6daeff2c8e1d7f1b$var$MessageChannel();
        $6daeff2c8e1d7f1b$var$port = $6daeff2c8e1d7f1b$var$channel.port2;
        $6daeff2c8e1d7f1b$var$channel.port1.onmessage = $6daeff2c8e1d7f1b$var$listener;
        $6daeff2c8e1d7f1b$var$defer = $6daeff2c8e1d7f1b$var$bind$3($6daeff2c8e1d7f1b$var$port.postMessage, $6daeff2c8e1d7f1b$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($6daeff2c8e1d7f1b$var$global$7.addEventListener && $6daeff2c8e1d7f1b$var$isCallable$3($6daeff2c8e1d7f1b$var$global$7.postMessage) && !$6daeff2c8e1d7f1b$var$global$7.importScripts && $6daeff2c8e1d7f1b$var$location && $6daeff2c8e1d7f1b$var$location.protocol !== "file:" && !$6daeff2c8e1d7f1b$var$fails$1($6daeff2c8e1d7f1b$var$post)) {
        $6daeff2c8e1d7f1b$var$defer = $6daeff2c8e1d7f1b$var$post;
        $6daeff2c8e1d7f1b$var$global$7.addEventListener("message", $6daeff2c8e1d7f1b$var$listener, false);
    // IE8-
    } else if ($6daeff2c8e1d7f1b$var$ONREADYSTATECHANGE in $6daeff2c8e1d7f1b$var$createElement("script")) $6daeff2c8e1d7f1b$var$defer = function(id) {
        $6daeff2c8e1d7f1b$var$html.appendChild($6daeff2c8e1d7f1b$var$createElement("script"))[$6daeff2c8e1d7f1b$var$ONREADYSTATECHANGE] = function() {
            $6daeff2c8e1d7f1b$var$html.removeChild(this);
            $6daeff2c8e1d7f1b$var$run(id);
        };
    };
    else $6daeff2c8e1d7f1b$var$defer = function(id) {
        setTimeout($6daeff2c8e1d7f1b$var$runner(id), 0);
    };
}
var $6daeff2c8e1d7f1b$var$task$1 = {
    set: $6daeff2c8e1d7f1b$var$set,
    clear: $6daeff2c8e1d7f1b$var$clear
};
var $6daeff2c8e1d7f1b$var$userAgent$1 = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$global$6 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($6daeff2c8e1d7f1b$var$userAgent$1) && $6daeff2c8e1d7f1b$var$global$6.Pebble !== undefined;
var $6daeff2c8e1d7f1b$var$userAgent = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($6daeff2c8e1d7f1b$var$userAgent);
var $6daeff2c8e1d7f1b$var$global$5 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$bind$2 = $6daeff2c8e1d7f1b$var$functionBindContext;
var $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor = $6daeff2c8e1d7f1b$var$objectGetOwnPropertyDescriptor.f;
var $6daeff2c8e1d7f1b$var$macrotask = $6daeff2c8e1d7f1b$var$task$1.set;
var $6daeff2c8e1d7f1b$var$IS_IOS = $6daeff2c8e1d7f1b$var$engineIsIos;
var $6daeff2c8e1d7f1b$var$IS_IOS_PEBBLE = $6daeff2c8e1d7f1b$var$engineIsIosPebble;
var $6daeff2c8e1d7f1b$var$IS_WEBOS_WEBKIT = $6daeff2c8e1d7f1b$var$engineIsWebosWebkit;
var $6daeff2c8e1d7f1b$var$IS_NODE$1 = $6daeff2c8e1d7f1b$var$engineIsNode;
var $6daeff2c8e1d7f1b$var$MutationObserver = $6daeff2c8e1d7f1b$var$global$5.MutationObserver || $6daeff2c8e1d7f1b$var$global$5.WebKitMutationObserver;
var $6daeff2c8e1d7f1b$var$document$2 = $6daeff2c8e1d7f1b$var$global$5.document;
var $6daeff2c8e1d7f1b$var$process$1 = $6daeff2c8e1d7f1b$var$global$5.process;
var $6daeff2c8e1d7f1b$var$Promise$1 = $6daeff2c8e1d7f1b$var$global$5.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $6daeff2c8e1d7f1b$var$queueMicrotaskDescriptor = $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor($6daeff2c8e1d7f1b$var$global$5, "queueMicrotask");
var $6daeff2c8e1d7f1b$var$queueMicrotask = $6daeff2c8e1d7f1b$var$queueMicrotaskDescriptor && $6daeff2c8e1d7f1b$var$queueMicrotaskDescriptor.value;
var $6daeff2c8e1d7f1b$var$flush, $6daeff2c8e1d7f1b$var$head, $6daeff2c8e1d7f1b$var$last, $6daeff2c8e1d7f1b$var$notify$1, $6daeff2c8e1d7f1b$var$toggle, $6daeff2c8e1d7f1b$var$node, $6daeff2c8e1d7f1b$var$promise, $6daeff2c8e1d7f1b$var$then;
// modern engines have queueMicrotask method
if (!$6daeff2c8e1d7f1b$var$queueMicrotask) {
    $6daeff2c8e1d7f1b$var$flush = function() {
        var parent, fn;
        if ($6daeff2c8e1d7f1b$var$IS_NODE$1 && (parent = $6daeff2c8e1d7f1b$var$process$1.domain)) parent.exit();
        while($6daeff2c8e1d7f1b$var$head){
            fn = $6daeff2c8e1d7f1b$var$head.fn;
            $6daeff2c8e1d7f1b$var$head = $6daeff2c8e1d7f1b$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($6daeff2c8e1d7f1b$var$head) $6daeff2c8e1d7f1b$var$notify$1();
                else $6daeff2c8e1d7f1b$var$last = undefined;
                throw error;
            }
        }
        $6daeff2c8e1d7f1b$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$6daeff2c8e1d7f1b$var$IS_IOS && !$6daeff2c8e1d7f1b$var$IS_NODE$1 && !$6daeff2c8e1d7f1b$var$IS_WEBOS_WEBKIT && $6daeff2c8e1d7f1b$var$MutationObserver && $6daeff2c8e1d7f1b$var$document$2) {
        $6daeff2c8e1d7f1b$var$toggle = true;
        $6daeff2c8e1d7f1b$var$node = $6daeff2c8e1d7f1b$var$document$2.createTextNode("");
        new $6daeff2c8e1d7f1b$var$MutationObserver($6daeff2c8e1d7f1b$var$flush).observe($6daeff2c8e1d7f1b$var$node, {
            characterData: true
        });
        $6daeff2c8e1d7f1b$var$notify$1 = function() {
            $6daeff2c8e1d7f1b$var$node.data = $6daeff2c8e1d7f1b$var$toggle = !$6daeff2c8e1d7f1b$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$6daeff2c8e1d7f1b$var$IS_IOS_PEBBLE && $6daeff2c8e1d7f1b$var$Promise$1 && $6daeff2c8e1d7f1b$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $6daeff2c8e1d7f1b$var$promise = $6daeff2c8e1d7f1b$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $6daeff2c8e1d7f1b$var$promise.constructor = $6daeff2c8e1d7f1b$var$Promise$1;
        $6daeff2c8e1d7f1b$var$then = $6daeff2c8e1d7f1b$var$bind$2($6daeff2c8e1d7f1b$var$promise.then, $6daeff2c8e1d7f1b$var$promise);
        $6daeff2c8e1d7f1b$var$notify$1 = function() {
            $6daeff2c8e1d7f1b$var$then($6daeff2c8e1d7f1b$var$flush);
        };
    // Node.js without promises
    } else if ($6daeff2c8e1d7f1b$var$IS_NODE$1) $6daeff2c8e1d7f1b$var$notify$1 = function() {
        $6daeff2c8e1d7f1b$var$process$1.nextTick($6daeff2c8e1d7f1b$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $6daeff2c8e1d7f1b$var$macrotask = $6daeff2c8e1d7f1b$var$bind$2($6daeff2c8e1d7f1b$var$macrotask, $6daeff2c8e1d7f1b$var$global$5);
        $6daeff2c8e1d7f1b$var$notify$1 = function() {
            $6daeff2c8e1d7f1b$var$macrotask($6daeff2c8e1d7f1b$var$flush);
        };
    }
}
var $6daeff2c8e1d7f1b$var$microtask$1 = $6daeff2c8e1d7f1b$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($6daeff2c8e1d7f1b$var$last) $6daeff2c8e1d7f1b$var$last.next = task;
    if (!$6daeff2c8e1d7f1b$var$head) {
        $6daeff2c8e1d7f1b$var$head = task;
        $6daeff2c8e1d7f1b$var$notify$1();
    }
    $6daeff2c8e1d7f1b$var$last = task;
};
var $6daeff2c8e1d7f1b$var$global$4 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$hostReportErrors$1 = function(a, b) {
    var console = $6daeff2c8e1d7f1b$var$global$4.console;
    if (console && console.error) arguments.length == 1 ? console.error(a) : console.error(a, b);
};
var $6daeff2c8e1d7f1b$var$perform$3 = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $6daeff2c8e1d7f1b$var$Queue$1 = function() {
    this.head = null;
    this.tail = null;
};
$6daeff2c8e1d7f1b$var$Queue$1.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $6daeff2c8e1d7f1b$var$queue = $6daeff2c8e1d7f1b$var$Queue$1;
var $6daeff2c8e1d7f1b$var$global$3 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$promiseNativeConstructor = $6daeff2c8e1d7f1b$var$global$3.Promise;
var $6daeff2c8e1d7f1b$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $6daeff2c8e1d7f1b$var$global$2 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$NativePromiseConstructor$3 = $6daeff2c8e1d7f1b$var$promiseNativeConstructor;
var $6daeff2c8e1d7f1b$var$isCallable$2 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isForced = $6daeff2c8e1d7f1b$var$isForced_1;
var $6daeff2c8e1d7f1b$var$inspectSource = $6daeff2c8e1d7f1b$var$inspectSource$4;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$3 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$IS_BROWSER = $6daeff2c8e1d7f1b$var$engineIsBrowser;
var $6daeff2c8e1d7f1b$var$V8_VERSION = $6daeff2c8e1d7f1b$var$engineV8Version;
$6daeff2c8e1d7f1b$var$NativePromiseConstructor$3 && $6daeff2c8e1d7f1b$var$NativePromiseConstructor$3.prototype;
var $6daeff2c8e1d7f1b$var$SPECIES = $6daeff2c8e1d7f1b$var$wellKnownSymbol$3("species");
var $6daeff2c8e1d7f1b$var$SUBCLASSING = false;
var $6daeff2c8e1d7f1b$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $6daeff2c8e1d7f1b$var$isCallable$2($6daeff2c8e1d7f1b$var$global$2.PromiseRejectionEvent);
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$5 = $6daeff2c8e1d7f1b$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $6daeff2c8e1d7f1b$var$inspectSource($6daeff2c8e1d7f1b$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($6daeff2c8e1d7f1b$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $6daeff2c8e1d7f1b$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($6daeff2c8e1d7f1b$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $6daeff2c8e1d7f1b$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$6daeff2c8e1d7f1b$var$SPECIES] = FakePromise;
    $6daeff2c8e1d7f1b$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$6daeff2c8e1d7f1b$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $6daeff2c8e1d7f1b$var$IS_BROWSER && !$6daeff2c8e1d7f1b$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $6daeff2c8e1d7f1b$var$promiseConstructorDetection = {
    CONSTRUCTOR: $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $6daeff2c8e1d7f1b$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $6daeff2c8e1d7f1b$var$SUBCLASSING
};
var $6daeff2c8e1d7f1b$var$newPromiseCapability$2 = {};
var $6daeff2c8e1d7f1b$var$aCallable$4 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $6daeff2c8e1d7f1b$var$aCallable$4(resolve);
    this.reject = $6daeff2c8e1d7f1b$var$aCallable$4(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$6daeff2c8e1d7f1b$var$newPromiseCapability$2.f = function(C) {
    return new $6daeff2c8e1d7f1b$var$PromiseCapability(C);
};
var $6daeff2c8e1d7f1b$var$$$5 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$IS_NODE = $6daeff2c8e1d7f1b$var$engineIsNode;
var $6daeff2c8e1d7f1b$var$global$1 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$call$7 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$2 = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$setPrototypeOf = $6daeff2c8e1d7f1b$var$objectSetPrototypeOf;
var $6daeff2c8e1d7f1b$var$setToStringTag = $6daeff2c8e1d7f1b$var$setToStringTag$3;
var $6daeff2c8e1d7f1b$var$setSpecies = $6daeff2c8e1d7f1b$var$setSpecies$1;
var $6daeff2c8e1d7f1b$var$aCallable$3 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$isCallable$1 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isObject$1 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$anInstance = $6daeff2c8e1d7f1b$var$anInstance$1;
var $6daeff2c8e1d7f1b$var$speciesConstructor = $6daeff2c8e1d7f1b$var$speciesConstructor$1;
var $6daeff2c8e1d7f1b$var$task = $6daeff2c8e1d7f1b$var$task$1.set;
var $6daeff2c8e1d7f1b$var$microtask = $6daeff2c8e1d7f1b$var$microtask$1;
var $6daeff2c8e1d7f1b$var$hostReportErrors = $6daeff2c8e1d7f1b$var$hostReportErrors$1;
var $6daeff2c8e1d7f1b$var$perform$2 = $6daeff2c8e1d7f1b$var$perform$3;
var $6daeff2c8e1d7f1b$var$Queue = $6daeff2c8e1d7f1b$var$queue;
var $6daeff2c8e1d7f1b$var$InternalStateModule = $6daeff2c8e1d7f1b$var$internalState;
var $6daeff2c8e1d7f1b$var$NativePromiseConstructor$2 = $6daeff2c8e1d7f1b$var$promiseNativeConstructor;
var $6daeff2c8e1d7f1b$var$PromiseConstructorDetection = $6daeff2c8e1d7f1b$var$promiseConstructorDetection;
var $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$3 = $6daeff2c8e1d7f1b$var$newPromiseCapability$2;
var $6daeff2c8e1d7f1b$var$PROMISE = "Promise";
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$4 = $6daeff2c8e1d7f1b$var$PromiseConstructorDetection.CONSTRUCTOR;
var $6daeff2c8e1d7f1b$var$NATIVE_PROMISE_REJECTION_EVENT = $6daeff2c8e1d7f1b$var$PromiseConstructorDetection.REJECTION_EVENT;
var $6daeff2c8e1d7f1b$var$NATIVE_PROMISE_SUBCLASSING = $6daeff2c8e1d7f1b$var$PromiseConstructorDetection.SUBCLASSING;
var $6daeff2c8e1d7f1b$var$getInternalPromiseState = $6daeff2c8e1d7f1b$var$InternalStateModule.getterFor($6daeff2c8e1d7f1b$var$PROMISE);
var $6daeff2c8e1d7f1b$var$setInternalState = $6daeff2c8e1d7f1b$var$InternalStateModule.set;
var $6daeff2c8e1d7f1b$var$NativePromisePrototype$1 = $6daeff2c8e1d7f1b$var$NativePromiseConstructor$2 && $6daeff2c8e1d7f1b$var$NativePromiseConstructor$2.prototype;
var $6daeff2c8e1d7f1b$var$PromiseConstructor = $6daeff2c8e1d7f1b$var$NativePromiseConstructor$2;
var $6daeff2c8e1d7f1b$var$PromisePrototype = $6daeff2c8e1d7f1b$var$NativePromisePrototype$1;
var $6daeff2c8e1d7f1b$var$TypeError$1 = $6daeff2c8e1d7f1b$var$global$1.TypeError;
var $6daeff2c8e1d7f1b$var$document$1 = $6daeff2c8e1d7f1b$var$global$1.document;
var $6daeff2c8e1d7f1b$var$process = $6daeff2c8e1d7f1b$var$global$1.process;
var $6daeff2c8e1d7f1b$var$newPromiseCapability$1 = $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$3.f;
var $6daeff2c8e1d7f1b$var$newGenericPromiseCapability = $6daeff2c8e1d7f1b$var$newPromiseCapability$1;
var $6daeff2c8e1d7f1b$var$DISPATCH_EVENT = !!($6daeff2c8e1d7f1b$var$document$1 && $6daeff2c8e1d7f1b$var$document$1.createEvent && $6daeff2c8e1d7f1b$var$global$1.dispatchEvent);
var $6daeff2c8e1d7f1b$var$UNHANDLED_REJECTION = "unhandledrejection";
var $6daeff2c8e1d7f1b$var$REJECTION_HANDLED = "rejectionhandled";
var $6daeff2c8e1d7f1b$var$PENDING = 0;
var $6daeff2c8e1d7f1b$var$FULFILLED = 1;
var $6daeff2c8e1d7f1b$var$REJECTED = 2;
var $6daeff2c8e1d7f1b$var$HANDLED = 1;
var $6daeff2c8e1d7f1b$var$UNHANDLED = 2;
var $6daeff2c8e1d7f1b$var$Internal, $6daeff2c8e1d7f1b$var$OwnPromiseCapability, $6daeff2c8e1d7f1b$var$PromiseWrapper, $6daeff2c8e1d7f1b$var$nativeThen;
// helpers
var $6daeff2c8e1d7f1b$var$isThenable = function(it) {
    var then;
    return $6daeff2c8e1d7f1b$var$isObject$1(it) && $6daeff2c8e1d7f1b$var$isCallable$1(then = it.then) ? then : false;
};
var $6daeff2c8e1d7f1b$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $6daeff2c8e1d7f1b$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $6daeff2c8e1d7f1b$var$UNHANDLED) $6daeff2c8e1d7f1b$var$onHandleUnhandled(state);
                state.rejection = $6daeff2c8e1d7f1b$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($6daeff2c8e1d7f1b$var$TypeError$1("Promise-chain cycle"));
            else if (then = $6daeff2c8e1d7f1b$var$isThenable(result)) $6daeff2c8e1d7f1b$var$call$7(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $6daeff2c8e1d7f1b$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $6daeff2c8e1d7f1b$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$6daeff2c8e1d7f1b$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $6daeff2c8e1d7f1b$var$onUnhandled(state);
    });
};
var $6daeff2c8e1d7f1b$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($6daeff2c8e1d7f1b$var$DISPATCH_EVENT) {
        event = $6daeff2c8e1d7f1b$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $6daeff2c8e1d7f1b$var$global$1.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$6daeff2c8e1d7f1b$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $6daeff2c8e1d7f1b$var$global$1["on" + name])) handler(event);
    else if (name === $6daeff2c8e1d7f1b$var$UNHANDLED_REJECTION) $6daeff2c8e1d7f1b$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $6daeff2c8e1d7f1b$var$onUnhandled = function(state) {
    $6daeff2c8e1d7f1b$var$call$7($6daeff2c8e1d7f1b$var$task, $6daeff2c8e1d7f1b$var$global$1, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $6daeff2c8e1d7f1b$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $6daeff2c8e1d7f1b$var$perform$2(function() {
                if ($6daeff2c8e1d7f1b$var$IS_NODE) $6daeff2c8e1d7f1b$var$process.emit("unhandledRejection", value, promise);
                else $6daeff2c8e1d7f1b$var$dispatchEvent($6daeff2c8e1d7f1b$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $6daeff2c8e1d7f1b$var$IS_NODE || $6daeff2c8e1d7f1b$var$isUnhandled(state) ? $6daeff2c8e1d7f1b$var$UNHANDLED : $6daeff2c8e1d7f1b$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $6daeff2c8e1d7f1b$var$isUnhandled = function(state) {
    return state.rejection !== $6daeff2c8e1d7f1b$var$HANDLED && !state.parent;
};
var $6daeff2c8e1d7f1b$var$onHandleUnhandled = function(state) {
    $6daeff2c8e1d7f1b$var$call$7($6daeff2c8e1d7f1b$var$task, $6daeff2c8e1d7f1b$var$global$1, function() {
        var promise = state.facade;
        if ($6daeff2c8e1d7f1b$var$IS_NODE) $6daeff2c8e1d7f1b$var$process.emit("rejectionHandled", promise);
        else $6daeff2c8e1d7f1b$var$dispatchEvent($6daeff2c8e1d7f1b$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $6daeff2c8e1d7f1b$var$bind$1 = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $6daeff2c8e1d7f1b$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $6daeff2c8e1d7f1b$var$REJECTED;
    $6daeff2c8e1d7f1b$var$notify(state, true);
};
var $6daeff2c8e1d7f1b$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $6daeff2c8e1d7f1b$var$TypeError$1("Promise can't be resolved itself");
        var then = $6daeff2c8e1d7f1b$var$isThenable(value);
        if (then) $6daeff2c8e1d7f1b$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $6daeff2c8e1d7f1b$var$call$7(then, value, $6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalResolve, wrapper, state), $6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalReject, wrapper, state));
            } catch (error) {
                $6daeff2c8e1d7f1b$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $6daeff2c8e1d7f1b$var$FULFILLED;
            $6daeff2c8e1d7f1b$var$notify(state, false);
        }
    } catch (error) {
        $6daeff2c8e1d7f1b$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $6daeff2c8e1d7f1b$var$PromiseConstructor = function Promise1(executor) {
        $6daeff2c8e1d7f1b$var$anInstance(this, $6daeff2c8e1d7f1b$var$PromisePrototype);
        $6daeff2c8e1d7f1b$var$aCallable$3(executor);
        $6daeff2c8e1d7f1b$var$call$7($6daeff2c8e1d7f1b$var$Internal, this);
        var state = $6daeff2c8e1d7f1b$var$getInternalPromiseState(this);
        try {
            executor($6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalResolve, state), $6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalReject, state));
        } catch (error) {
            $6daeff2c8e1d7f1b$var$internalReject(state, error);
        }
    };
    $6daeff2c8e1d7f1b$var$PromisePrototype = $6daeff2c8e1d7f1b$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $6daeff2c8e1d7f1b$var$Internal = function Promise1(executor) {
        $6daeff2c8e1d7f1b$var$setInternalState(this, {
            type: $6daeff2c8e1d7f1b$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $6daeff2c8e1d7f1b$var$Queue(),
            rejection: false,
            state: $6daeff2c8e1d7f1b$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $6daeff2c8e1d7f1b$var$Internal.prototype = $6daeff2c8e1d7f1b$var$defineBuiltIn$2($6daeff2c8e1d7f1b$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $6daeff2c8e1d7f1b$var$getInternalPromiseState(this);
        var reaction = $6daeff2c8e1d7f1b$var$newPromiseCapability$1($6daeff2c8e1d7f1b$var$speciesConstructor(this, $6daeff2c8e1d7f1b$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $6daeff2c8e1d7f1b$var$isCallable$1(onFulfilled) ? onFulfilled : true;
        reaction.fail = $6daeff2c8e1d7f1b$var$isCallable$1(onRejected) && onRejected;
        reaction.domain = $6daeff2c8e1d7f1b$var$IS_NODE ? $6daeff2c8e1d7f1b$var$process.domain : undefined;
        if (state.state == $6daeff2c8e1d7f1b$var$PENDING) state.reactions.add(reaction);
        else $6daeff2c8e1d7f1b$var$microtask(function() {
            $6daeff2c8e1d7f1b$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $6daeff2c8e1d7f1b$var$OwnPromiseCapability = function() {
        var promise = new $6daeff2c8e1d7f1b$var$Internal();
        var state = $6daeff2c8e1d7f1b$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalResolve, state);
        this.reject = $6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalReject, state);
    };
    $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$3.f = $6daeff2c8e1d7f1b$var$newPromiseCapability$1 = function(C) {
        return C === $6daeff2c8e1d7f1b$var$PromiseConstructor || C === $6daeff2c8e1d7f1b$var$PromiseWrapper ? new $6daeff2c8e1d7f1b$var$OwnPromiseCapability(C) : $6daeff2c8e1d7f1b$var$newGenericPromiseCapability(C);
    };
    if ($6daeff2c8e1d7f1b$var$isCallable$1($6daeff2c8e1d7f1b$var$NativePromiseConstructor$2) && $6daeff2c8e1d7f1b$var$NativePromisePrototype$1 !== Object.prototype) {
        $6daeff2c8e1d7f1b$var$nativeThen = $6daeff2c8e1d7f1b$var$NativePromisePrototype$1.then;
        if (!$6daeff2c8e1d7f1b$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $6daeff2c8e1d7f1b$var$defineBuiltIn$2($6daeff2c8e1d7f1b$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $6daeff2c8e1d7f1b$var$PromiseConstructor(function(resolve, reject) {
                $6daeff2c8e1d7f1b$var$call$7($6daeff2c8e1d7f1b$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $6daeff2c8e1d7f1b$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($6daeff2c8e1d7f1b$var$setPrototypeOf) $6daeff2c8e1d7f1b$var$setPrototypeOf($6daeff2c8e1d7f1b$var$NativePromisePrototype$1, $6daeff2c8e1d7f1b$var$PromisePrototype);
    }
}
$6daeff2c8e1d7f1b$var$$$5({
    global: true,
    constructor: true,
    wrap: true,
    forced: $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $6daeff2c8e1d7f1b$var$PromiseConstructor
});
$6daeff2c8e1d7f1b$var$setToStringTag($6daeff2c8e1d7f1b$var$PromiseConstructor, $6daeff2c8e1d7f1b$var$PROMISE, false);
$6daeff2c8e1d7f1b$var$setSpecies($6daeff2c8e1d7f1b$var$PROMISE);
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$2 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$Iterators$1 = $6daeff2c8e1d7f1b$var$iterators;
var $6daeff2c8e1d7f1b$var$ITERATOR$2 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$2("iterator");
var $6daeff2c8e1d7f1b$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
var $6daeff2c8e1d7f1b$var$isArrayIteratorMethod$1 = function(it) {
    return it !== undefined && ($6daeff2c8e1d7f1b$var$Iterators$1.Array === it || $6daeff2c8e1d7f1b$var$ArrayPrototype[$6daeff2c8e1d7f1b$var$ITERATOR$2] === it);
};
var $6daeff2c8e1d7f1b$var$classof = $6daeff2c8e1d7f1b$var$classof$5;
var $6daeff2c8e1d7f1b$var$getMethod$1 = $6daeff2c8e1d7f1b$var$getMethod$3;
var $6daeff2c8e1d7f1b$var$Iterators = $6daeff2c8e1d7f1b$var$iterators;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$1 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$ITERATOR$1 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$1("iterator");
var $6daeff2c8e1d7f1b$var$getIteratorMethod$2 = function(it) {
    if (it != undefined) return $6daeff2c8e1d7f1b$var$getMethod$1(it, $6daeff2c8e1d7f1b$var$ITERATOR$1) || $6daeff2c8e1d7f1b$var$getMethod$1(it, "@@iterator") || $6daeff2c8e1d7f1b$var$Iterators[$6daeff2c8e1d7f1b$var$classof(it)];
};
var $6daeff2c8e1d7f1b$var$call$6 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$aCallable$2 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$anObject$5 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$tryToString$1 = $6daeff2c8e1d7f1b$var$tryToString$5;
var $6daeff2c8e1d7f1b$var$getIteratorMethod$1 = $6daeff2c8e1d7f1b$var$getIteratorMethod$2;
var $6daeff2c8e1d7f1b$var$$TypeError$1 = TypeError;
var $6daeff2c8e1d7f1b$var$getIterator$1 = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $6daeff2c8e1d7f1b$var$getIteratorMethod$1(argument) : usingIterator;
    if ($6daeff2c8e1d7f1b$var$aCallable$2(iteratorMethod)) return $6daeff2c8e1d7f1b$var$anObject$5($6daeff2c8e1d7f1b$var$call$6(iteratorMethod, argument));
    throw $6daeff2c8e1d7f1b$var$$TypeError$1($6daeff2c8e1d7f1b$var$tryToString$1(argument) + " is not iterable");
};
var $6daeff2c8e1d7f1b$var$call$5 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$anObject$4 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$getMethod = $6daeff2c8e1d7f1b$var$getMethod$3;
var $6daeff2c8e1d7f1b$var$iteratorClose$1 = function(iterator, kind, value) {
    var innerResult, innerError;
    $6daeff2c8e1d7f1b$var$anObject$4(iterator);
    try {
        innerResult = $6daeff2c8e1d7f1b$var$getMethod(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $6daeff2c8e1d7f1b$var$call$5(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $6daeff2c8e1d7f1b$var$anObject$4(innerResult);
    return value;
};
var $6daeff2c8e1d7f1b$var$bind = $6daeff2c8e1d7f1b$var$functionBindContext;
var $6daeff2c8e1d7f1b$var$call$4 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$anObject$3 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$tryToString = $6daeff2c8e1d7f1b$var$tryToString$5;
var $6daeff2c8e1d7f1b$var$isArrayIteratorMethod = $6daeff2c8e1d7f1b$var$isArrayIteratorMethod$1;
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5;
var $6daeff2c8e1d7f1b$var$isPrototypeOf$1 = $6daeff2c8e1d7f1b$var$objectIsPrototypeOf;
var $6daeff2c8e1d7f1b$var$getIterator = $6daeff2c8e1d7f1b$var$getIterator$1;
var $6daeff2c8e1d7f1b$var$getIteratorMethod = $6daeff2c8e1d7f1b$var$getIteratorMethod$2;
var $6daeff2c8e1d7f1b$var$iteratorClose = $6daeff2c8e1d7f1b$var$iteratorClose$1;
var $6daeff2c8e1d7f1b$var$$TypeError = TypeError;
var $6daeff2c8e1d7f1b$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $6daeff2c8e1d7f1b$var$ResultPrototype = $6daeff2c8e1d7f1b$var$Result.prototype;
var $6daeff2c8e1d7f1b$var$iterate$2 = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $6daeff2c8e1d7f1b$var$bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $6daeff2c8e1d7f1b$var$iteratorClose(iterator, "normal", condition);
        return new $6daeff2c8e1d7f1b$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $6daeff2c8e1d7f1b$var$anObject$3(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $6daeff2c8e1d7f1b$var$getIteratorMethod(iterable);
        if (!iterFn) throw $6daeff2c8e1d7f1b$var$$TypeError($6daeff2c8e1d7f1b$var$tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($6daeff2c8e1d7f1b$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = $6daeff2c8e1d7f1b$var$lengthOfArrayLike(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $6daeff2c8e1d7f1b$var$isPrototypeOf$1($6daeff2c8e1d7f1b$var$ResultPrototype, result)) return result;
            }
            return new $6daeff2c8e1d7f1b$var$Result(false);
        }
        iterator = $6daeff2c8e1d7f1b$var$getIterator(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $6daeff2c8e1d7f1b$var$call$4(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $6daeff2c8e1d7f1b$var$iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $6daeff2c8e1d7f1b$var$isPrototypeOf$1($6daeff2c8e1d7f1b$var$ResultPrototype, result)) return result;
    }
    return new $6daeff2c8e1d7f1b$var$Result(false);
};
var $6daeff2c8e1d7f1b$var$wellKnownSymbol = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$ITERATOR = $6daeff2c8e1d7f1b$var$wellKnownSymbol("iterator");
var $6daeff2c8e1d7f1b$var$SAFE_CLOSING = false;
try {
    var $6daeff2c8e1d7f1b$var$called = 0;
    var $6daeff2c8e1d7f1b$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$6daeff2c8e1d7f1b$var$called++
            };
        },
        "return": function() {
            $6daeff2c8e1d7f1b$var$SAFE_CLOSING = true;
        }
    };
    $6daeff2c8e1d7f1b$var$iteratorWithReturn[$6daeff2c8e1d7f1b$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($6daeff2c8e1d7f1b$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $6daeff2c8e1d7f1b$var$checkCorrectnessOfIteration$1 = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$6daeff2c8e1d7f1b$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$6daeff2c8e1d7f1b$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $6daeff2c8e1d7f1b$var$NativePromiseConstructor$1 = $6daeff2c8e1d7f1b$var$promiseNativeConstructor;
var $6daeff2c8e1d7f1b$var$checkCorrectnessOfIteration = $6daeff2c8e1d7f1b$var$checkCorrectnessOfIteration$1;
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$3 = $6daeff2c8e1d7f1b$var$promiseConstructorDetection.CONSTRUCTOR;
var $6daeff2c8e1d7f1b$var$promiseStaticsIncorrectIteration = $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$6daeff2c8e1d7f1b$var$checkCorrectnessOfIteration(function(iterable) {
    $6daeff2c8e1d7f1b$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $6daeff2c8e1d7f1b$var$$$4 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$call$3 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$aCallable$1 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$2 = $6daeff2c8e1d7f1b$var$newPromiseCapability$2;
var $6daeff2c8e1d7f1b$var$perform$1 = $6daeff2c8e1d7f1b$var$perform$3;
var $6daeff2c8e1d7f1b$var$iterate$1 = $6daeff2c8e1d7f1b$var$iterate$2;
var $6daeff2c8e1d7f1b$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $6daeff2c8e1d7f1b$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$6daeff2c8e1d7f1b$var$$$4({
    target: "Promise",
    stat: true,
    forced: $6daeff2c8e1d7f1b$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $6daeff2c8e1d7f1b$var$perform$1(function() {
            var $promiseResolve = $6daeff2c8e1d7f1b$var$aCallable$1(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $6daeff2c8e1d7f1b$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $6daeff2c8e1d7f1b$var$call$3($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $6daeff2c8e1d7f1b$var$$$3 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$2 = $6daeff2c8e1d7f1b$var$promiseConstructorDetection.CONSTRUCTOR;
var $6daeff2c8e1d7f1b$var$NativePromiseConstructor = $6daeff2c8e1d7f1b$var$promiseNativeConstructor;
var $6daeff2c8e1d7f1b$var$getBuiltIn$1 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$isCallable = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$1 = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$NativePromisePrototype = $6daeff2c8e1d7f1b$var$NativePromiseConstructor && $6daeff2c8e1d7f1b$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$6daeff2c8e1d7f1b$var$$$3({
    target: "Promise",
    proto: true,
    forced: $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($6daeff2c8e1d7f1b$var$isCallable($6daeff2c8e1d7f1b$var$NativePromiseConstructor)) {
    var $6daeff2c8e1d7f1b$var$method = $6daeff2c8e1d7f1b$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($6daeff2c8e1d7f1b$var$NativePromisePrototype["catch"] !== $6daeff2c8e1d7f1b$var$method) $6daeff2c8e1d7f1b$var$defineBuiltIn$1($6daeff2c8e1d7f1b$var$NativePromisePrototype, "catch", $6daeff2c8e1d7f1b$var$method, {
        unsafe: true
    });
}
var $6daeff2c8e1d7f1b$var$$$2 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$call$2 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$aCallable = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$1 = $6daeff2c8e1d7f1b$var$newPromiseCapability$2;
var $6daeff2c8e1d7f1b$var$perform = $6daeff2c8e1d7f1b$var$perform$3;
var $6daeff2c8e1d7f1b$var$iterate = $6daeff2c8e1d7f1b$var$iterate$2;
var $6daeff2c8e1d7f1b$var$PROMISE_STATICS_INCORRECT_ITERATION = $6daeff2c8e1d7f1b$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$6daeff2c8e1d7f1b$var$$$2({
    target: "Promise",
    stat: true,
    forced: $6daeff2c8e1d7f1b$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $6daeff2c8e1d7f1b$var$perform(function() {
            var $promiseResolve = $6daeff2c8e1d7f1b$var$aCallable(C.resolve);
            $6daeff2c8e1d7f1b$var$iterate(iterable, function(promise) {
                $6daeff2c8e1d7f1b$var$call$2($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $6daeff2c8e1d7f1b$var$$$1 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$call$1 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule = $6daeff2c8e1d7f1b$var$newPromiseCapability$2;
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$1 = $6daeff2c8e1d7f1b$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$6daeff2c8e1d7f1b$var$$$1({
    target: "Promise",
    stat: true,
    forced: $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule.f(this);
        $6daeff2c8e1d7f1b$var$call$1(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $6daeff2c8e1d7f1b$var$anObject$2 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$isObject = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$newPromiseCapability = $6daeff2c8e1d7f1b$var$newPromiseCapability$2;
var $6daeff2c8e1d7f1b$var$promiseResolve$1 = function(C, x) {
    $6daeff2c8e1d7f1b$var$anObject$2(C);
    if ($6daeff2c8e1d7f1b$var$isObject(x) && x.constructor === C) return x;
    var promiseCapability = $6daeff2c8e1d7f1b$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $6daeff2c8e1d7f1b$var$$ = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$getBuiltIn = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR = $6daeff2c8e1d7f1b$var$promiseConstructorDetection.CONSTRUCTOR;
var $6daeff2c8e1d7f1b$var$promiseResolve = $6daeff2c8e1d7f1b$var$promiseResolve$1;
$6daeff2c8e1d7f1b$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$6daeff2c8e1d7f1b$var$$({
    target: "Promise",
    stat: true,
    forced: $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $6daeff2c8e1d7f1b$var$promiseResolve(this, x);
    }
});
const $6daeff2c8e1d7f1b$var$HardwareWalletAccountsForm = ({ accounts: accounts, onSelectedChanged: onSelectedChanged, onSubmit: onSubmit, onChangeRoute: onChangeRoute })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
        className: "choose-ledger-account-form-wrapper"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "We found ",
                    accounts.length,
                    " accounts on your device. Select the account(s) you wish to connect."
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "button-wrapper"
            }, {
                children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                    onClick: ()=>{
                        onChangeRoute("SpecifyHDPath");
                    }
                }, {
                    children: "HD.../0"
                }))
            })),
            (0, $7b02d682eb115277$exports.jsx)("form", Object.assign({
                className: "form",
                onSubmit: (e)=>{
                    onSubmit(accounts, e);
                }
            }, {
                children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "nws-form-control"
                        }, {
                            children: accounts.map((account, index)=>(0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                    className: "account"
                                }, {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("input", {
                                            onChange: (e)=>{
                                                onSelectedChanged(index, e.target.checked);
                                            },
                                            checked: account.selected,
                                            type: "checkbox",
                                            id: account.accountId,
                                            name: account.accountId,
                                            value: account.accountId
                                        }),
                                        (0, $7b02d682eb115277$exports.jsxs)("label", Object.assign({
                                            htmlFor: account.accountId
                                        }, {
                                            children: [
                                                " ",
                                                account.accountId
                                            ]
                                        })),
                                        (0, $7b02d682eb115277$exports.jsx)("br", {})
                                    ]
                                }), index))
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "action-buttons"
                        }, {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                className: "middleButton",
                                type: "submit",
                                disabled: !accounts.some((x)=>x.selected)
                            }, {
                                children: "Connect"
                            }))
                        }))
                    ]
                })
            }))
        ]
    }));
};
var $6daeff2c8e1d7f1b$var$img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAR3SURBVHgBpVZ9aJVVGH+e55z33bi7zY9hMz+yMAeNoEIq6A9ZRKQWEsQNFIIpsf5Y9E+GsD9iBEEDMUkDa6ShRKKZYIWiRkaKaUGUGCKOTGMF84PNO99773vOefq9720yK5ZzD/dwPt/nd37P17lEk5Qnuz9roUkKT7T5bNe+QjTNLCHv24h1Xgh+OmtwQYPH2jUXwlnW9NRooqePfLS6MmmQ59cdeEGJlkJZA5MGVecoAwghBYZTVY9ftuaDSy8x8w9fbFl95JZAXuw9dmelkvRAyXxS7wMFryG4bIyWZiqzPgMhaFfGfn3NY3AZG9sPf/Dy8HidZvxkZc/h1pqnPlKey6yspMqUd9jVAEYY6RCGDQTwjGDwGTgAlbwRijV1C9vanz577tT+6r+YrOz5rlXFrQ/qZ+FbDxCfXS5oOgxln4v473f3rbgwdn7FK5/MCaH2eAg6X8g3K2iBMTiBkNJVKbod+ze9mgPZsY/UaicYzCE1HgpZc558olCTjTvWLxv9p1n3bV45iO7T5zq3TU9j9xTOLwQ5D9t48aEYrtGj2P/2BpNS78nZJoRdlDsYd8vphz273lqyhW5Rnlnz3hOe6SEwghvxPUMTVfYe2rpuUOqOkZeIxdSbsSJ8eTIAmXy5tftrMPkzi0C4B2ZDNHp+INvLQURkhYiJ6gDGko376DbEJ8k3mcnYBSeSM2ptL/XGsurNnxfnDIQNwCKADO1845Ef6Tbk0M51g4joMgncDyBmkrtsNEMQovcDxGYsGL2yDNAUxPv0VySs4yxhfeYbabJg0Awg+ILylEB6nKMpSOp0WCR1+QSuD4ELljNDEfyRrdXPCU1BTEgD7pyOzVmC2iBm0KgYAMCEeXovoClIjdKiVdQ3FYbzmatxWRqMPcNsDHyfNWskWk5TkJhNEwVyxA6hLL5clLJsW7voFxa6LiR5CCOeWzo3XFxKtyEdy3tnp7VahAoDp6PEVGvJye09l3P7K9k9WQijXBv4B6WG+0pvD0ybFEBHZ6OPh+/OGaBsIvNRAGp/ZHv1jJeon+omszBkFsr3FhsLB7rev3JLQKVSyfjmaW2BJSavDlqR7c5VrR+4AbLttbkXMehH7gjA8gZiD/tq+Or/ABZ3dUW/J62LcPUGcrW8pKSVFAg6cHz3O0l25qZHa/XGwWPg9aAwwzdZAaDX+7tbNsMYf5+bpaUS0dDQEF8rtsUxCbI5e5KRzGhBMiqNxllKju7d8NOYXjseRBytQngcVDL3wD9H+7vf3YS7mnnzqrZpwSxrwkh04cpM5NTMyJdHbIgaESyxJ6tZ5cDbw3qd0tqVCp25Se/4yYdr5/zm/ehjwvpxZHgN0Wlub0/Yt7awdykqRYFHy6NUQVrBd4o6p6ngrVL2Bo8ksuJqoXzq9Ln9m6rj9U74b6Wjo8OeP082aY5NUxRsYzwDkeFsU+MdUU3U4PG0QtbahqhadDMuHTy4fvS/9EwIUpdeuW/ZiShOipFxURRbNdWETFMRZrCFlEZGkuPHdycTafgLExNiI6YfUpcAAAAASUVORK5CYII=";
const $6daeff2c8e1d7f1b$var$WalletConnecting = ({ wallet: wallet, onCloseModal: onCloseModal })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                title: "",
                onCloseModal: onCloseModal
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "connecting-wrapper"
            }, {
                children: (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "icon"
                        }, {
                            children: (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: wallet === null || wallet === void 0 ? void 0 : wallet.metadata.iconUrl,
                                alt: wallet === null || wallet === void 0 ? void 0 : wallet.metadata.name
                            })
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("h3", Object.assign({
                            className: "connecting-name"
                        }, {
                            children: wallet === null || wallet === void 0 ? void 0 : wallet.metadata.name
                        })),
                        (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                            className: "connecting-details"
                        }, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                    className: "spinner"
                                }, {
                                    children: (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: $6daeff2c8e1d7f1b$var$img,
                                        alt: "loading-icon"
                                    })
                                })),
                                (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.connectingTo"),
                                        " ",
                                        wallet === null || wallet === void 0 ? void 0 : wallet.metadata.name,
                                        "..."
                                    ]
                                })
                            ]
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "connecting-message"
                        }, {
                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)(`modal.wallet.connectingMessage.${wallet === null || wallet === void 0 ? void 0 : wallet.type}`)
                            })
                        }))
                    ]
                }))
            }))
        ]
    });
};
const $6daeff2c8e1d7f1b$var$LedgerDeviceIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
        width: "317",
        height: "157",
        viewBox: "0 0 317 157",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M249.99 16.0994C270.063 -0.864155 289.788 1.58873 301.497 10.7365C307.402 15.3499 311.278 21.6575 312.267 28.1258C313.247 34.5412 311.413 41.2233 305.692 46.8044C297.366 54.9273 286.343 55.3362 273.015 51.5109C261.654 48.25 249.058 42.0377 235.726 35.4627L235.726 35.4626L235.717 35.458C233.367 34.2992 230.995 33.129 228.602 31.9618C212.742 24.2253 196.067 16.6575 179.842 13.8595C163.538 11.0479 147.552 13.0313 133.266 24.522C128.032 28.732 123.478 35.2086 121.716 44.8205C119.961 54.3947 120.992 66.9771 126.703 83.4311C135.432 108.583 132.899 126.677 123.575 138.063C114.217 149.491 97.5614 154.733 76.7887 153.121C55.0043 151.43 29.0621 142.206 3.29867 125.227L0.887817 127.942C27.2472 145.405 53.9251 154.952 76.5105 156.705C97.9028 158.365 115.96 153.035 126.356 140.341C136.785 127.606 139.045 108.029 130.099 82.2524C124.521 66.1801 123.642 54.2493 125.252 45.4687C126.854 36.7258 130.94 31.006 135.519 27.3232C148.794 16.6458 163.649 14.715 179.231 17.4021C194.891 20.1027 211.146 27.4463 227.026 35.1928C229.381 36.3415 231.729 37.5001 234.066 38.6531L234.073 38.6568C247.382 45.223 260.324 51.608 272.024 54.9662C285.819 58.9258 298.493 58.8501 308.202 49.3776C314.764 42.9759 316.974 35.1288 315.82 27.5826C314.675 20.0893 310.237 13.0029 303.71 7.90363C290.555 -2.37382 268.938 -4.62038 247.67 13.3537L249.99 16.0994Z",
                fill: "url(#paint0_linear_3_672)"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M260.264 17.8767L177.605 89.4649L157.679 73.9664L239.23 3.85423L260.264 17.8767Z",
                fill: "#6A7075"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M205.939 54.4577L199.764 50.2636L233.316 20.9053L239.907 25.8395L205.939 54.4577Z",
                fill: "#494E52"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M260.264 17.8757L177.605 89.4639L182.033 98.3202L264.323 26.363L260.264 17.8757Z",
                fill: "#494E52"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M177.236 89.4646L181.295 98.3209L165.059 85.7745L170.963 85.0365L177.236 89.4646Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M93.4708 99.6384L91.9948 110.13L174.653 92.894L164.69 85.7749L93.4708 99.6384Z",
                fill: "#DCDADA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M93.1157 104.323L94.314 100.129L165.613 86.3483L169.208 89.344L93.1157 104.323Z",
                fill: "#C1C1C1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M94.2086 99.7963L86.0903 101.272L92.3635 110.129L94.2086 99.7963Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M86.0903 100.907L89.0027 74.1304L178.455 55.2416C184.695 53.9962 195.766 54.7675 197.177 63.7058C198.284 70.717 195.506 73.9943 191.628 77.3592C188.495 80.0671 180.152 82.4646 178.343 82.8944C178.293 82.9064 178.241 82.9188 178.186 82.9319C177.38 83.1245 176.007 83.4525 170.644 84.5088C169.085 84.8158 167.382 85.1501 165.557 85.5078L164.933 85.63C146.312 89.2764 115.528 95.2297 93.9844 99.3849C91.1808 99.9257 88.5337 100.436 86.0903 100.907ZM185.076 75.554C190.748 73.3535 193.99 68.0745 192.318 63.7631C190.645 59.4517 184.691 57.7405 179.019 59.941C173.347 62.1416 170.105 67.4206 171.778 71.732C173.45 76.0434 179.404 77.7546 185.076 75.554Z",
                fill: "#F4F1E8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M199.764 50.3994L196.768 48.3043L232.194 18.0454L233.316 21.6403L199.764 50.3994Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M239.968 25.9943L232.588 20.4592V17.5071L241.813 24.5183L239.968 25.9943Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "182.084",
                cy: "68.0811",
                rx: "10.242",
                ry: "7.46772",
                transform: "rotate(-23.7949 182.084 68.0811)",
                fill: "#494E52"
            }),
            (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "182.084",
                cy: "68.0816",
                rx: "6.68462",
                ry: "4.87394",
                transform: "rotate(-23.7949 182.084 68.0816)",
                fill: "#494E52"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M238.725 2.93094L260.368 17.2564L264.865 26.4556L181.615 99.0341L175.16 94.311L92.0028 110.947L85.3267 101.399L88.3269 73.8157L178.118 54.8553L238.725 2.93094ZM178.599 56.2622L89.6786 75.0388L86.9321 100.29C89.0979 99.8725 91.4124 99.4263 93.8446 98.9572C115.388 94.8019 146.171 88.8488 164.791 85.2026L165.415 85.0804C167.24 84.7228 168.943 84.3885 170.501 84.0816C175.853 83.0275 177.219 82.701 178.015 82.5107C178.07 82.4976 178.122 82.4852 178.173 82.4732C179.048 82.2652 181.558 81.5669 184.235 80.5851C186.742 79.6655 189.286 78.5354 190.802 77.3758L191.151 77.0922L191.644 76.6595C193.341 75.147 194.723 73.6739 195.61 71.871C196.571 69.916 196.982 67.5029 196.448 64.1178C195.8 60.0131 192.959 57.7574 189.408 56.6566C185.833 55.5483 181.637 55.6566 178.603 56.2615C178.601 56.2617 178.6 56.262 178.599 56.2622ZM192.631 77.7565L259.555 18.9531L263.042 26.0869L181.808 96.9078L178.132 89.5713L191.724 78.529C191.859 78.4249 191.988 78.32 192.11 78.2144L192.111 78.2136C192.286 78.0617 192.46 77.9094 192.631 77.7565ZM185.491 81.6908C185.24 81.7868 184.99 81.8802 184.743 81.9709C182.013 82.9723 179.447 83.6875 178.514 83.9093C178.463 83.9213 178.411 83.9338 178.356 83.9468C177.635 84.1192 176.472 84.3971 172.491 85.1919L177.172 88.4492L185.491 81.6908ZM176.631 89.8707L170.479 85.5903C169.306 85.8213 168.054 86.0673 166.731 86.3265L175.769 92.9276L179.548 95.6924L176.631 89.8707ZM164.758 86.7132C146.252 90.3362 116.027 96.1817 94.6324 100.308L93.2258 109.197L173.543 93.1293L164.758 86.7132ZM91.888 108.207L93.0909 100.606C91.0848 100.993 89.1642 101.363 87.3471 101.713L91.888 108.207ZM258.581 17.8436L197.306 71.6841C198.142 69.5779 198.41 67.0795 197.906 63.8876C197.143 59.0539 193.743 56.4549 189.845 55.2467C186.921 54.3402 183.662 54.1916 180.861 54.449L238.84 4.77668L258.581 17.8436ZM232.505 16.82L243.089 24.5643L205.915 56.5106L196.042 48.0665L232.505 16.82ZM232.118 19.096L198.312 48.0654L199.744 49.29L232.584 20.9424L232.118 19.096ZM233.456 22.1396L200.878 50.2604L205.913 54.5664L239.041 26.0969L233.456 22.1396ZM240.195 25.1054L240.717 24.6571L233.759 19.5663L234.06 20.7586L240.195 25.1054Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M190.194 69.9744C191.32 68.1409 191.576 66.2271 190.942 64.5937C190.308 62.9603 188.829 61.7198 186.761 61.1254C184.691 60.5307 182.116 60.6196 179.553 61.6139C176.991 62.6081 175.029 64.2794 173.902 66.1141C172.776 67.9477 172.52 69.8614 173.154 71.4948C173.788 73.1282 175.267 74.3687 177.335 74.9631C179.405 75.5578 181.98 75.4689 184.543 74.4746C187.105 73.4804 189.067 71.8091 190.194 69.9744ZM185.077 75.8508C190.749 73.6502 193.991 68.3712 192.318 64.0598C190.645 59.7484 184.691 58.0372 179.019 60.2378C173.347 62.4383 170.105 67.7173 171.778 72.0287C173.451 76.3401 179.405 78.0513 185.077 75.8508Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M187.391 69.169C188.127 67.9713 188.266 66.7721 187.881 65.7812C187.497 64.7903 186.586 63.9984 185.235 63.6102C183.883 63.2216 182.173 63.2741 180.456 63.9404C178.738 64.6068 177.441 65.7208 176.705 66.9196C175.969 68.1172 175.83 69.3165 176.215 70.3074C176.599 71.2983 177.511 72.0901 178.861 72.4783C180.214 72.8669 181.923 72.8144 183.64 72.1481C185.358 71.4818 186.655 70.3678 187.391 69.169ZM184.174 73.5242C188.156 71.9795 190.432 68.2738 189.257 65.2473C188.083 62.2208 183.904 61.0196 179.922 62.5643C175.94 64.1091 173.665 67.8148 174.839 70.8412C176.013 73.8677 180.193 75.0689 184.174 73.5242Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M240.499 41.2441C239.744 40.3649 239.844 39.04 240.724 38.285L249.781 30.5067C250.66 29.7516 251.985 29.8523 252.74 30.7315V30.7315C253.495 31.6108 253.395 32.9356 252.516 33.6907L243.458 41.469C242.579 42.224 241.254 42.1234 240.499 41.2441V41.2441Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M250.743 31.6265L241.685 39.4048C241.424 39.6287 241.395 40.0217 241.619 40.2825C241.842 40.5433 242.235 40.5731 242.496 40.3492L251.554 32.5709C251.815 32.3469 251.845 31.954 251.621 31.6932C251.397 31.4324 251.004 31.4025 250.743 31.6265ZM240.724 38.285C239.844 39.04 239.744 40.3649 240.499 41.2441C241.254 42.1234 242.579 42.224 243.458 41.469L252.516 33.6907C253.395 32.9356 253.495 31.6108 252.74 30.7315C251.985 29.8523 250.66 29.7516 249.781 30.5067L240.724 38.285Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M205.779 71.4647C205.005 70.5642 205.108 69.2073 206.009 68.4339L214.989 60.7218C215.89 59.9485 217.247 60.0516 218.02 60.9521V60.9521C218.793 61.8526 218.69 63.2095 217.79 63.9829L208.809 71.695C207.909 72.4683 206.552 72.3652 205.779 71.4647V71.4647Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M215.951 61.8416L206.97 69.5537C206.688 69.796 206.656 70.221 206.898 70.5031C207.141 70.7851 207.566 70.8174 207.848 70.5752L216.828 62.863C217.11 62.6208 217.143 62.1958 216.9 61.9137C216.658 61.6317 216.233 61.5994 215.951 61.8416ZM206.009 68.4339C205.108 69.2073 205.005 70.5642 205.779 71.4647C206.552 72.3652 207.909 72.4683 208.809 71.695L217.79 63.9829C218.69 63.2095 218.793 61.8526 218.02 60.9521C217.247 60.0516 215.89 59.9485 214.989 60.7218L206.009 68.4339Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "141.356",
                cy: "19.525",
                r: "10.1855",
                fill: "#FE89B4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "139.062",
                cy: "14.7094",
                rx: "2.42519",
                ry: "1.94015",
                transform: "rotate(-34.544 139.062 14.7094)",
                fill: "#FDF7FF"
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "252.489",
                cy: "79.7577",
                r: "7.78893",
                fill: "#EC5236"
            }),
            (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "250.434",
                cy: "76.3701",
                rx: "2.61272",
                ry: "2.09018",
                transform: "rotate(-34.544 250.434 76.3701)",
                fill: "#EDB69D"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M100.436 79.9254C100.461 79.6567 100.732 79.3897 101.042 79.329L106.657 78.2299C107.587 78.0478 108.281 78.5536 108.207 79.3596L107.759 84.2243C107.734 84.493 107.463 84.76 107.153 84.8207L100.416 86.1396C100.106 86.2003 99.8742 86.0317 99.899 85.7631L100.436 79.9254Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.8553 81.7775C95.9294 80.9715 96.7437 80.1704 97.6739 79.9883L98.7968 79.7685C99.1069 79.7078 99.3382 79.8764 99.3135 80.1451L99.1344 82.091C99.1096 82.3597 98.8382 82.6267 98.5282 82.6874L96.2824 83.127C95.9723 83.1877 95.741 83.0191 95.7657 82.7505L95.8553 81.7775Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.5865 84.6965C95.6112 84.4278 95.8826 84.1608 96.1927 84.1001L98.4385 83.6605C98.7486 83.5998 98.9799 83.7684 98.9552 84.037L98.7761 85.9829C98.7513 86.2516 98.4799 86.5186 98.1699 86.5793L95.9241 87.019C95.614 87.0797 95.3827 86.9111 95.4074 86.6424L95.5865 84.6965Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.2282 88.5884C95.2529 88.3197 95.5244 88.0527 95.8344 87.992L98.0802 87.5524C98.3903 87.4917 98.6216 87.6603 98.5969 87.929L98.4178 89.8749C98.3931 90.1435 98.1216 90.4105 97.8116 90.4712L96.6887 90.6911C95.7584 90.8732 95.0645 90.3674 95.1387 89.5614L95.2282 88.5884Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M99.7197 87.709C99.7444 87.4403 100.016 87.1733 100.326 87.1126L102.572 86.673C102.882 86.6123 103.113 86.7809 103.088 87.0496L102.909 88.9955C102.885 89.2641 102.613 89.5312 102.303 89.5919L100.057 90.0315C99.7472 90.0922 99.5159 89.9236 99.5406 89.6549L99.7197 87.709Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104.211 86.8298C104.236 86.5611 104.507 86.2941 104.817 86.2334L107.063 85.7938C107.373 85.7331 107.605 85.9017 107.58 86.1704L107.49 87.1433C107.416 87.9493 106.602 88.7504 105.672 88.9325L104.549 89.1523C104.239 89.213 104.007 89.0444 104.032 88.7757L104.211 86.8298Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsxs)("linearGradient", Object.assign({
                    id: "paint0_linear_3_672",
                    x1: "-44.5195",
                    y1: "122.42",
                    x2: "263.357",
                    y2: "-8.65023",
                    gradientUnits: "userSpaceOnUse"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "0.110697",
                            stopColor: "#232323"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "1",
                            stopColor: "#3D3D3D"
                        })
                    ]
                }))
            })
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$DEFAULT_DERIVATION_PATH = "44'/397'/0'/0'/1'";
const $6daeff2c8e1d7f1b$var$DerivationPath = ({ selector: selector, options: options, onBack: onBack, onConnected: onConnected, params: params, onError: onError, onCloseModal: onCloseModal })=>{
    const [route, setRoute] = (0, $acw62.useState)("EnterDerivationPath");
    const [derivationPath, setDerivationPath] = (0, $acw62.useState)($6daeff2c8e1d7f1b$var$DEFAULT_DERIVATION_PATH);
    const [customDerivationPath, setCustomDerivationPath] = (0, $acw62.useState)(1);
    const [accounts, setAccounts] = (0, $acw62.useState)([]);
    const [selectedAccounts, setSelectedAccounts] = (0, $acw62.useState)([]);
    const [hardwareWallet, setHardwareWallet] = (0, $acw62.useState)();
    const [customAccountId, setCustomAccountId] = (0, $acw62.useState)("");
    const [connecting, setConnecting] = (0, $acw62.useState)(false);
    const initalHeaderTitle = (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.connectWithLedger");
    const [headerTitle, setHeaderTitle] = (0, $acw62.useState)(initalHeaderTitle);
    const getAccountIds = (publicKey)=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
            const response = yield fetch(`${selector.options.network.indexerUrl}/publicKey/ed25519:${publicKey}/accounts`);
            if (!response.ok) throw new Error("Failed to get account id from public key");
            const accountIds = yield response.json();
            if (!Array.isArray(accountIds) || !accountIds.length) return [];
            return accountIds;
        });
    const resolveAccounts = (wallet)=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
            const publicKey = yield wallet.getPublicKey(derivationPath);
            try {
                const accountIds = yield getAccountIds(publicKey);
                return accountIds.map((accountId, index)=>{
                    return {
                        derivationPath: derivationPath,
                        publicKey: publicKey,
                        accountId: accountId,
                        selected: index === 0
                    };
                });
            } catch (e) {
                return null;
            }
        });
    const handleValidateAccount = ()=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
            const wallet = yield selector.wallet(params.walletId);
            if (wallet.type !== "hardware") return;
            setConnecting(true);
            setHardwareWallet(wallet);
            try {
                const resolvedAccounts = yield resolveAccounts(wallet);
                if (!resolvedAccounts) {
                    setRoute("AddCustomAccountId");
                    return;
                }
                const noAccounts = resolvedAccounts.length === 0;
                const multipleAccounts = resolvedAccounts.length > 1;
                if (noAccounts) {
                    setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.noAccountsFound"));
                    setRoute("NoAccountsFound");
                    return;
                }
                setAccounts(resolvedAccounts);
                if (!multipleAccounts) {
                    setSelectedAccounts(resolvedAccounts);
                    setRoute("OverviewAccounts");
                } else {
                    setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.selectYourAccounts"));
                    setRoute("ChooseAccount");
                }
            } catch (err) {
                setConnecting(false);
                const message = err instanceof Error ? err.message : "Something went wrong";
                onError(message, wallet);
            } finally{
                setConnecting(false);
            }
        });
    const handleAddCustomAccountId = ()=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
            try {
                setConnecting(true);
                const publicKey = yield hardwareWallet.getPublicKey(derivationPath);
                const accountList = [
                    {
                        derivationPath: derivationPath,
                        publicKey: publicKey,
                        accountId: customAccountId,
                        selected: true
                    }
                ];
                setAccounts(accountList);
                setSelectedAccounts(accountList);
                setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.connecting1Account"));
                setRoute("OverviewAccounts");
            } catch (err) {
                setConnecting(false);
                const message = err instanceof Error ? err.message : "Something went wrong";
                onError(message, hardwareWallet);
            } finally{
                setConnecting(false);
            }
        });
    const handleSignIn = ()=>{
        const mapAccounts = selectedAccounts.map((account)=>{
            return {
                derivationPath: account.derivationPath,
                publicKey: account.publicKey,
                accountId: account.accountId
            };
        });
        return hardwareWallet.signIn({
            contractId: options.contractId,
            methodNames: options.methodNames,
            accounts: mapAccounts
        }).then(()=>onConnected()).catch((err)=>{
            onError(`Error: ${err.message}`, hardwareWallet);
        });
    };
    const handleOnBackButtonClick = ()=>{
        if (route === "SpecifyHDPath" || route === "NoAccountsFound" || route === "ChooseAccount") {
            setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.connectWithLedger"));
            setRoute("EnterDerivationPath");
        }
        if (route === "OverviewAccounts") {
            setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.selectYourAccounts"));
            setRoute("ChooseAccount");
        }
    };
    if (connecting) return (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
        className: "derivation-path-wrapper"
    }, {
        children: (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletConnecting, {
            wallet: hardwareWallet,
            onBack: ()=>{
                setConnecting(false);
            },
            onCloseModal: onCloseModal
        })
    }));
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    (route === "SpecifyHDPath" || route === "NoAccountsFound" || route === "ChooseAccount" || route === "OverviewAccounts") && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$BackArrow, {
                        onClick: handleOnBackButtonClick
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                        title: headerTitle,
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "derivation-path-wrapper"
            }, {
                children: [
                    route === "EnterDerivationPath" && (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "enter-derivation-path"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "ledger-image"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$LedgerDeviceIcon, {})
                            })),
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "ledger-description"
                            }, {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.makeSureYourLedger")
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("p", Object.assign({
                                        className: "specify-path",
                                        onClick: ()=>{
                                            setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.specifyHDPath"));
                                            setRoute("SpecifyHDPath");
                                        }
                                    }, {
                                        children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.specifyHDPath")
                                    }))
                                ]
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleValidateAccount
                                }, {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.continue")
                                }))
                            }))
                        ]
                    })),
                    route === "SpecifyHDPath" && (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "specify-path-wrapper"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "change-path-wrapper"
                            }, {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                        className: "display-path"
                                    }, {
                                        children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: derivationPath.slice(0, -2)
                                        })
                                    })),
                                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                        className: "change-path"
                                    }, {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                                className: "path-value"
                                            }, {
                                                children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: customDerivationPath
                                                })
                                            })),
                                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                                className: "buttons-wrapper"
                                            }, {
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                                        onClick: ()=>{
                                                            const newValue = customDerivationPath + 1;
                                                            const path = derivationPath.slice(0, -2);
                                                            setDerivationPath(`${path}${newValue}'`);
                                                            setCustomDerivationPath(newValue);
                                                        }
                                                    }, {
                                                        children: (0, $7b02d682eb115277$exports.jsx)("svg", Object.assign({
                                                            width: "10",
                                                            height: "7",
                                                            viewBox: "0 0 10 7",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg"
                                                        }, {
                                                            children: (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M9 5.4762L5 1.4762L1 5.4762",
                                                                stroke: "#4F7CD1",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        }))
                                                    })),
                                                    (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                                        onClick: ()=>{
                                                            const newValue = customDerivationPath - 1;
                                                            if (newValue < 0) return;
                                                            const path = derivationPath.slice(0, -2);
                                                            setDerivationPath(`${path}${newValue}'`);
                                                            setCustomDerivationPath(newValue);
                                                        }
                                                    }, {
                                                        children: (0, $7b02d682eb115277$exports.jsx)("svg", Object.assign({
                                                            width: "10",
                                                            height: "7",
                                                            viewBox: "0 0 10 7",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg"
                                                        }, {
                                                            children: (0, $7b02d682eb115277$exports.jsx)("path", {
                                                                d: "M1 1.52382L5 5.52382L9 1.52382",
                                                                stroke: "#4F7CD1",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        }))
                                                    }))
                                                ]
                                            }))
                                        ]
                                    }))
                                ]
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("p", Object.assign({
                                className: "path-description"
                            }, {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.enterYourPreferredHDPath")
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("p", Object.assign({
                                className: "what-link"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
                                    href: "https://www.ledger.com/academy/crypto/what-are-hierarchical-deterministic-hd-wallets",
                                    target: "_blank"
                                }, {
                                    children: "What's this?"
                                }))
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleValidateAccount
                                }, {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.scan")
                                }))
                            }))
                        ]
                    })),
                    route === "NoAccountsFound" && (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "no-accounts-found-wrapper"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.cantFindAnyAccount"),
                                " ",
                                (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
                                    href: `https://${selector.options.network.networkId === "testnet" ? "testnet" : "app"}.mynearwallet.com/create`,
                                    target: "_blank"
                                }, {
                                    children: "MyNearWallet"
                                })),
                                " ",
                                (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.orConnectAnAnotherLedger")
                            ]
                        })
                    })),
                    route === "ChooseAccount" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$HardwareWalletAccountsForm, {
                        accounts: accounts,
                        onSelectedChanged: (index, selected)=>{
                            setAccounts((prevAccounts)=>{
                                const updateAccounts = prevAccounts.map((account, idx)=>{
                                    const selectedValue = index === idx ? selected : account.selected;
                                    return Object.assign(Object.assign({}, account), {
                                        selected: selectedValue
                                    });
                                });
                                return [
                                    ...updateAccounts
                                ];
                            });
                        },
                        onSubmit: (acc, e)=>{
                            e.preventDefault();
                            const selectedAcc = acc.filter((account)=>account.selected);
                            setSelectedAccounts(selectedAcc);
                            const numberOfAccounts = selectedAcc.length;
                            setHeaderTitle(`${(0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.connecting")} ${numberOfAccounts} ${(0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.ofAccounts")}`);
                            setRoute("OverviewAccounts");
                        },
                        onChangeRoute: (newRoute)=>{
                            if (newRoute === "SpecifyHDPath") setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.specifyHDPath"));
                            setRoute(newRoute);
                        }
                    }),
                    route === "AddCustomAccountId" && (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "enter-custom-account"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.failedToAutomatically")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "input-wrapper"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    placeholder: "Account ID",
                                    value: customAccountId,
                                    onChange: (e)=>{
                                        setCustomAccountId(e.target.value);
                                    }
                                })
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleAddCustomAccountId
                                }, {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("ledger.Continue")
                                }))
                            }))
                        ]
                    })),
                    route === "OverviewAccounts" && (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "overview-wrapper"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.overviewTheListOfAuthorized")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "accounts"
                            }, {
                                children: selectedAccounts.map((account, index)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                            className: "account"
                                        }, {
                                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: account.accountId
                                            })
                                        }))
                                    }, account.accountId))
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleSignIn,
                                    disabled: accounts.length === 0
                                }, {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.finish")
                                }))
                            }))
                        ]
                    }))
                ]
            }))
        ]
    });
};
const $6daeff2c8e1d7f1b$var$WalletNotInstalled = ({ module: module, onBack: onBack, onCloseModal: onCloseModal })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$BackArrow, {
                        onClick: onBack
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                        title: "",
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "wallet-not-installed-wrapper"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "wallet-data"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: `wallet-icon-box ${module.id}`
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: module.metadata.iconUrl,
                                    alt: module.metadata.name
                                })
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: module.metadata.name
                            })
                        ]
                    })),
                    (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.install.youllNeedToInstall"),
                            " ",
                            module.metadata.name,
                            " ",
                            (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.install.toContinueAfterInstalling"),
                            (0, $7b02d682eb115277$exports.jsxs)("span", Object.assign({
                                className: "refresh-link",
                                onClick: ()=>window.location.reload()
                            }, {
                                children: [
                                    " ",
                                    (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.install.refreshThePage")
                                ]
                            }))
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "action-buttons"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsxs)("button", Object.assign({
                            className: "middleButton",
                            onClick: ()=>{
                                if (module.type !== "injected") return;
                                window.open(module.metadata.downloadUrl, "_blank");
                            }
                        }, {
                            children: [
                                (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.install.open"),
                                " ",
                                module.metadata.name
                            ]
                        }))
                    }))
                ]
            }))
        ]
    });
};
const $6daeff2c8e1d7f1b$var$WalletHome = ({ selector: selector, onCloseModal: onCloseModal })=>{
    const [modules, setModules] = (0, $acw62.useState)([]);
    const [route, setRoute] = (0, $acw62.useState)("WalletInfo");
    (0, $acw62.useEffect)(()=>{
        const subscription = selector.store.observable.subscribe((state)=>{
            const filterByType = (item)=>{
                return item.type !== "bridge" && item.type !== "hardware";
            };
            const filteredModules = state.modules.filter(filterByType);
            setModules(filteredModules);
        });
        return ()=>subscription.unsubscribe(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const goToWallet = (module)=>{
        const { networkId: networkId } = selector.options.network;
        let url = "";
        if (module.type === "injected") url = module.metadata.downloadUrl;
         // TODO: improve links to wallets other than injected type.
        if (module.id === "my-near-wallet") {
            const subdomain = networkId === "testnet" ? "testnet" : "app";
            url = `https://${subdomain}.mynearwallet.com`;
        }
        if (module.id === "opto-wallet") {
            const subdomain = networkId === "testnet" ? "app.testnet" : "app";
            url = `https://${subdomain}.optowallet.com`;
        }
        if (module.id === "near-wallet") {
            const subdomain = networkId === "testnet" ? "testnet." : "";
            url = `https://wallet.${subdomain}near.org`;
        }
        if (module.id === "here-wallet") url = "https://herewallet.app/";
        if (url === "" && module.type === "bridge" || module.type === "hardware") return;
        window.open(url, "_blank");
    };
    const getTypeNameAndIcon = (walletId, type)=>{
        switch(type){
            case "injected":
                if (walletId === "nearfi") return {
                    typeFullName: "Wallet Extension",
                    qrIcon: true
                };
                if (walletId === "here-wallet") return {
                    typeFullName: "Mobile Wallet",
                    qrIcon: true
                };
                return {
                    typeFullName: "Wallet Extension",
                    qrIcon: false
                };
            case "browser":
                if (walletId === "here-wallet") return {
                    typeFullName: "Web Wallet",
                    qrIcon: true
                };
                return {
                    typeFullName: "Web Wallet",
                    qrIcon: false
                };
            default:
                return {
                    typeFullName: "Web Wallet",
                    qrIcon: false
                };
        }
    };
    return (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
        className: "wallet-home-wrapper"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    route === "GetWallets" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$BackArrow, {
                        onClick: ()=>{
                            setRoute("WalletInfo");
                        }
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                        title: route === "GetWallets" ? (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.getAWallet") : (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.whatIsAWallet"),
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            route === "GetWallets" && (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "get-wallet-wrapper"
            }, {
                children: modules.map((module)=>{
                    const { iconUrl: iconUrl, name: name } = module.metadata;
                    const { type: type, id: id } = module;
                    const { typeFullName: typeFullName, qrIcon: qrIcon } = getTypeNameAndIcon(id, type);
                    return (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        tabIndex: 0,
                        className: `single-wallet-get ${module.id}`,
                        onClick: ()=>{
                            goToWallet(module);
                        }
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "small-icon"
                            }, {
                                children: [
                                    qrIcon && (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
                                        width: "18",
                                        height: "16",
                                        viewBox: "0 0 18 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                    }, {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M7.22224 1.33334H1.44446V6.66668H7.22224V1.33334Z",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M15.8889 1.33334H10.1111V6.66668H15.8889V1.33334Z",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M7.22224 9.33334H1.44446V14.6667H7.22224V9.33334Z",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M10.1111 13.1429V14.6667H15.8889M10.1111 9.33334V10.8572H12.5873V9.33334H15.8889V12.381",
                                                stroke: "#4C5155",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                x: "3.61108",
                                                y: "3.33334",
                                                width: "1.44444",
                                                height: "1.33333",
                                                fill: "#4C5155"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                x: "3.61108",
                                                y: "11.3333",
                                                width: "1.44444",
                                                height: "1.33333",
                                                fill: "#4C5155"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("rect", {
                                                x: "12.2778",
                                                y: "3.33334",
                                                width: "1.44445",
                                                height: "1.33333",
                                                fill: "#4C5155"
                                            })
                                        ]
                                    })),
                                    !qrIcon && (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
                                        width: "18",
                                        height: "16",
                                        viewBox: "0 0 18 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                    }, {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M13 8.66667V12.6667C13 13.0203 12.8478 13.3594 12.577 13.6095C12.3061 13.8595 11.9387 14 11.5556 14H3.61113C3.22804 14 2.86064 13.8595 2.58975 13.6095C2.31887 13.3594 2.16669 13.0203 2.16669 12.6667V5.33333C2.16669 4.97971 2.31887 4.64057 2.58975 4.39052C2.86064 4.14048 3.22804 4 3.61113 4H7.94447",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M10.8333 2H15.1666V6",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M7.22223 9.33333L15.1667 2",
                                                stroke: "currentColor",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    }))
                                ]
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "icon"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: iconUrl,
                                    alt: name
                                })
                            })),
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "content"
                            }, {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                        className: "title"
                                    }, {
                                        children: name
                                    })),
                                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                        className: "type"
                                    }, {
                                        children: typeFullName
                                    }))
                                ]
                            }))
                        ]
                    }), module.id);
                })
            })),
            route === "WalletInfo" && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "wallet-info-wrapper what-wallet-hide"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "wallet-what"
                            }, {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                        className: "icon-side"
                                    }, {
                                        children: (0, $7b02d682eb115277$exports.jsx)("svg", Object.assign({
                                            width: "40",
                                            height: "40",
                                            viewBox: "0 0 40 40",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                        }, {
                                            children: (0, $7b02d682eb115277$exports.jsx)("path", {
                                                d: "M33.5 1.83325L30.1666 5.16658M17.4818 17.8514C19.1406 19.5103 20.1666 21.8019 20.1666 24.3333C20.1666 29.3959 16.0626 33.4999 11 33.4999C5.93735 33.4999 1.8333 29.3959 1.8333 24.3333C1.8333 19.2706 5.93735 15.1666 11 15.1666C13.5313 15.1666 15.8229 16.1926 17.4818 17.8514ZM17.4818 17.8514L24.3333 10.9999M24.3333 10.9999L29.3333 15.9999L35.1666 10.1666L30.1666 5.16658M24.3333 10.9999L30.1666 5.16658",
                                                stroke: "currentColor",
                                                strokeWidth: "3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }))
                                    })),
                                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                        className: "content-side"
                                    }, {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.secureAndManage")
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.safelyStore")
                                            })
                                        ]
                                    }))
                                ]
                            })),
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "wallet-what"
                            }, {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                        className: "icon-side"
                                    }, {
                                        children: (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
                                            width: "40",
                                            height: "41",
                                            viewBox: "0 0 40 41",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                        }, {
                                            children: [
                                                (0, $7b02d682eb115277$exports.jsx)("circle", {
                                                    cx: "28.3333",
                                                    cy: "23.8333",
                                                    r: "1.66667",
                                                    fill: "currentColor"
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M35 12.1667H7C5.89543 12.1667 5 11.2712 5 10.1667V7.5C5 6.39543 5.89543 5.5 7 5.5H31.6667",
                                                    stroke: "currentColor",
                                                    strokeWidth: "3",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    d: "M35 12.1667V35.5H7C5.89543 35.5 5 34.6046 5 33.5V8.83334",
                                                    stroke: "currentColor",
                                                    strokeWidth: "3",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        }))
                                    })),
                                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                        className: "content-side"
                                    }, {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.logInToAny")
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.noNeedToCreate")
                                            })
                                        ]
                                    }))
                                ]
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "button-spacing"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                className: "middleButton",
                                onClick: ()=>{
                                    setRoute("GetWallets");
                                }
                            }, {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.getAWallet")
                            }))
                        ]
                    })),
                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "what-wallet-mobile"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.useAWallet")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                className: "middleButton",
                                onClick: ()=>{
                                    setRoute("GetWallets");
                                }
                            }, {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.getAWallet")
                            }))
                        ]
                    })),
                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "lang-selector-wrapper"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsxs)("select", Object.assign({
                            className: "lang-selector",
                            name: "lang"
                        }, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("option", Object.assign({
                                    value: "en"
                                }, {
                                    children: "English"
                                })),
                                (0, $7b02d682eb115277$exports.jsx)("option", Object.assign({
                                    value: "es"
                                }, {
                                    children: "Spanish"
                                }))
                            ]
                        }))
                    }))
                ]
            })
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$WalletConnected = ({ module: module, onCloseModal: onCloseModal })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("h3", Object.assign({
                        className: "middleTitle"
                    }, {
                        children: ``
                    })),
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$CloseButton, {
                        onClick: onCloseModal
                    })
                ]
            })),
            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "connecting-wrapper"
            }, {
                children: (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                            className: "icon"
                        }, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "green-dot"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: module === null || module === void 0 ? void 0 : module.metadata.iconUrl,
                                    alt: module === null || module === void 0 ? void 0 : module.metadata.name
                                })
                            ]
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("h3", Object.assign({
                            className: "connecting-name"
                        }, {
                            children: module === null || module === void 0 ? void 0 : module.metadata.name
                        })),
                        (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                            className: "wallet-connected-success"
                        }, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
                                    width: "21",
                                    height: "20",
                                    viewBox: "0 0 21 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                }, {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M18.8333 9.2333V9.99997C18.8323 11.797 18.2504 13.5455 17.1744 14.9848C16.0984 16.4241 14.586 17.477 12.8628 17.9866C11.1395 18.4961 9.29768 18.4349 7.61202 17.8121C5.92636 17.1894 4.48717 16.0384 3.50909 14.5309C2.53101 13.0233 2.06645 11.24 2.18469 9.4469C2.30293 7.65377 2.99763 5.94691 4.16519 4.58086C5.33275 3.21482 6.91061 2.26279 8.66345 1.86676C10.4163 1.47073 12.2502 1.65192 13.8916 2.3833",
                                            stroke: "#4FD98F",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }),
                                        (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M18.8333 3.33337L10.5 11.675L8 9.17504",
                                            stroke: "#4FD98F",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    ]
                                })),
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.connectionSuccessful")
                                })
                            ]
                        }))
                    ]
                }))
            }))
        ]
    });
};
var $6daeff2c8e1d7f1b$var$anObject$1 = $6daeff2c8e1d7f1b$var$anObject$c;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $6daeff2c8e1d7f1b$var$regexpFlags = function() {
    var that = $6daeff2c8e1d7f1b$var$anObject$1(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $6daeff2c8e1d7f1b$var$call = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$hasOwn = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$isPrototypeOf = $6daeff2c8e1d7f1b$var$objectIsPrototypeOf;
var $6daeff2c8e1d7f1b$var$regExpFlags = $6daeff2c8e1d7f1b$var$regexpFlags;
var $6daeff2c8e1d7f1b$var$RegExpPrototype$1 = RegExp.prototype;
var $6daeff2c8e1d7f1b$var$regexpGetFlags = function(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $6daeff2c8e1d7f1b$var$RegExpPrototype$1) && !$6daeff2c8e1d7f1b$var$hasOwn(R, "flags") && $6daeff2c8e1d7f1b$var$isPrototypeOf($6daeff2c8e1d7f1b$var$RegExpPrototype$1, R) ? $6daeff2c8e1d7f1b$var$call($6daeff2c8e1d7f1b$var$regExpFlags, R) : flags;
};
var $6daeff2c8e1d7f1b$var$PROPER_FUNCTION_NAME = $6daeff2c8e1d7f1b$var$functionName.PROPER;
var $6daeff2c8e1d7f1b$var$defineBuiltIn = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$anObject = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$$toString = $6daeff2c8e1d7f1b$var$toString$3;
var $6daeff2c8e1d7f1b$var$fails = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$getRegExpFlags = $6daeff2c8e1d7f1b$var$regexpGetFlags;
var $6daeff2c8e1d7f1b$var$TO_STRING = "toString";
var $6daeff2c8e1d7f1b$var$RegExpPrototype = RegExp.prototype;
var $6daeff2c8e1d7f1b$var$n$ToString = $6daeff2c8e1d7f1b$var$RegExpPrototype[$6daeff2c8e1d7f1b$var$TO_STRING];
var $6daeff2c8e1d7f1b$var$NOT_GENERIC = $6daeff2c8e1d7f1b$var$fails(function() {
    return $6daeff2c8e1d7f1b$var$n$ToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $6daeff2c8e1d7f1b$var$INCORRECT_NAME = $6daeff2c8e1d7f1b$var$PROPER_FUNCTION_NAME && $6daeff2c8e1d7f1b$var$n$ToString.name != $6daeff2c8e1d7f1b$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($6daeff2c8e1d7f1b$var$NOT_GENERIC || $6daeff2c8e1d7f1b$var$INCORRECT_NAME) $6daeff2c8e1d7f1b$var$defineBuiltIn(RegExp.prototype, $6daeff2c8e1d7f1b$var$TO_STRING, function toString() {
    var R = $6daeff2c8e1d7f1b$var$anObject(this);
    var pattern = $6daeff2c8e1d7f1b$var$$toString(R.source);
    var flags = $6daeff2c8e1d7f1b$var$$toString($6daeff2c8e1d7f1b$var$getRegExpFlags(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});
const $6daeff2c8e1d7f1b$var$CopyIcon = ()=>(0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.5 15.25a1.75 1.75 0 0 1-1.75-1.75V6.75a2 2 0 0 1 2-2h6.75c.966 0 1.75.784 1.75 1.75",
                stroke: "#4F7CD1",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.75 10.75a2 2 0 0 1 2-2h6.5a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2h-6.5a2 2 0 0 1-2-2v-6.5Z",
                stroke: "#4F7CD1",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
function $6daeff2c8e1d7f1b$var$formatQRCodeImage(data) {
    return $6daeff2c8e1d7f1b$var$__awaiter(this, void 0, void 0, function*() {
        return yield (0, (/*@__PURE__*/$parcel$interopDefault($092c7e998bebe629$exports))).toString(data, {
            margin: 0,
            type: "svg"
        });
    });
}
const $6daeff2c8e1d7f1b$var$ScanQRCode = ({ wallet: wallet, uri: uri, onCloseModal: onCloseModal, handleOpenDefaultModal: handleOpenDefaultModal })=>{
    const [notification, setNotification] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [svg, setSvg] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const copyToClipboard = ()=>{
        if (!uri) return;
        const success = (0, (/*@__PURE__*/$parcel$interopDefault($e5a78797c4262d1f$exports)))(uri);
        if (success) {
            setNotification((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.copiedToClipboard"));
            setTimeout(()=>setNotification(""), 1200);
        } else {
            setNotification((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.failedToCopy"));
            setTimeout(()=>setNotification(""), 1200);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (()=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
                if (uri) setSvg((yield $6daeff2c8e1d7f1b$var$formatQRCodeImage(uri)));
            }))();
    }, [
        uri
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("section", Object.assign({
        className: "scan-qr-code"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                title: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.scanWithYourMobile"),
                onCloseModal: onCloseModal
            }),
            (0, $7b02d682eb115277$exports.jsxs)("section", Object.assign({
                className: "qr-code"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: svg
                        }
                    }),
                    notification ? (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "notification"
                    }, {
                        children: notification
                    })) : (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "copy-btn",
                        onClick: copyToClipboard
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$CopyIcon, {}),
                            (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.copyToClipboard")
                        ]
                    }))
                ]
            })),
            (0, $7b02d682eb115277$exports.jsxs)("footer", Object.assign({
                className: "footer"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.preferTheOfficial"),
                            " ",
                            wallet.metadata.name,
                            "?"
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                        className: "btn",
                        onClick: handleOpenDefaultModal
                    }, {
                        children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.open")
                    }))
                ]
            }))
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$getThemeClass = (theme)=>{
    switch(theme){
        case "dark":
            return "dark-theme";
        case "light":
            return "light-theme";
        default:
            return "";
    }
};
const $6daeff2c8e1d7f1b$var$Modal = ({ selector: selector, options: options, visible: visible, hide: hide, emitter: emitter })=>{
    var _a, _b, _c;
    const [route, setRoute] = (0, $acw62.useState)({
        name: "WalletHome"
    });
    const [alertMessage, setAlertMessage] = (0, $acw62.useState)(null);
    const [selectedWallet, setSelectedWallet] = (0, $acw62.useState)();
    const [bridgeWalletUri, setBridgeWalletUri] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setRoute({
            name: "WalletHome"
        });
        (0, $5bb7220e37bd460f$export$b162ef060a488de1)(selector.options.languageCode);
        const { selectedWalletId: selectedWalletId, modules: modules } = selector.store.getState();
        if (selectedWalletId) {
            const module = modules.find((m)=>m.id === selectedWalletId);
            setSelectedWallet(module);
            setRoute({
                name: "WalletConnected",
                params: {
                    module: module
                }
            });
        }
        setBridgeWalletUri(""); // eslint-disable-next-line
    }, [
        visible
    ]);
    (0, $acw62.useEffect)(()=>{
        const subscription = selector.on("networkChanged", ({ networkId: networkId })=>{
            // Switched back to the correct network.
            if (networkId === selector.options.network.networkId) return handleDismissClick({});
            setRoute({
                name: "WalletNetworkChanged"
            });
        });
        return ()=>subscription.remove(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDismissClick = (0, $acw62.useCallback)(({ hideReason: hideReason })=>{
        setAlertMessage(null);
        setRoute({
            name: "WalletHome"
        });
        if (hideReason === "user-triggered") emitter.emit("onHide", {
            hideReason: hideReason
        });
        if (hideReason === "wallet-navigation") emitter.emit("onHide", {
            hideReason: hideReason
        });
        hide();
    }, [
        hide,
        emitter
    ]);
    (0, $acw62.useEffect)(()=>{
        const close = (e)=>{
            if (e.key === "Escape") handleDismissClick({
                hideReason: "user-triggered"
            });
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, [
        handleDismissClick
    ]);
    const handleWalletClick = (module, qrCodeModal)=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
            setSelectedWallet(module);
            const { selectedWalletId: selectedWalletId } = selector.store.getState();
            if (selectedWalletId === module.id) {
                setRoute({
                    name: "WalletConnected",
                    params: {
                        module: module
                    }
                });
                return;
            }
            try {
                const { deprecated: deprecated, available: available } = module.metadata;
                if (module.type === "injected" && !available) {
                    setRoute({
                        name: "WalletNotInstalled",
                        params: {
                            module: module
                        }
                    });
                    return;
                }
                const wallet = yield module.wallet();
                if (deprecated) {
                    setAlertMessage(`${module.metadata.name} is deprecated. Please select another wallet.`);
                    setRoute({
                        name: "AlertMessage",
                        params: {
                            module: module
                        }
                    });
                    return;
                }
                if (wallet.type === "hardware") {
                    setRoute({
                        name: "DerivationPath",
                        params: {
                            walletId: wallet.id || "ledger"
                        }
                    });
                    return;
                }
                setRoute({
                    name: "WalletConnecting",
                    params: {
                        wallet: wallet
                    }
                });
                if (wallet.type === "bridge") {
                    const subscription = selector.on("uriChanged", ({ uri: uri })=>{
                        setBridgeWalletUri(uri);
                        setRoute({
                            name: "ScanQRCode",
                            params: {
                                uri: uri,
                                wallet: wallet
                            }
                        });
                    });
                    yield wallet.signIn({
                        contractId: options.contractId,
                        methodNames: options.methodNames,
                        qrCodeModal: qrCodeModal
                    });
                    subscription.remove();
                    handleDismissClick({
                        hideReason: "wallet-navigation"
                    });
                    return;
                }
                if (wallet.type === "browser") {
                    yield wallet.signIn({
                        contractId: options.contractId,
                        methodNames: options.methodNames,
                        successUrl: wallet.metadata.successUrl,
                        failureUrl: wallet.metadata.failureUrl
                    });
                    handleDismissClick({
                        hideReason: "wallet-navigation"
                    });
                    return;
                }
                yield wallet.signIn({
                    contractId: options.contractId,
                    methodNames: options.methodNames
                });
                handleDismissClick({
                    hideReason: "wallet-navigation"
                });
            } catch (err) {
                const { name: name } = module.metadata;
                const message = err instanceof Error ? err.message : "Something went wrong";
                setAlertMessage(`Failed to sign in with ${name}: ${message}`);
                setRoute({
                    name: "AlertMessage",
                    params: {
                        module: module
                    }
                });
            }
        });
    if (!visible) return null;
    return (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
        className: `nws-modal-wrapper ${$6daeff2c8e1d7f1b$var$getThemeClass(options === null || options === void 0 ? void 0 : options.theme)} ${visible ? "open" : ""}`
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "nws-modal-overlay",
                onClick: ()=>{
                    handleDismissClick({
                        hideReason: "user-triggered"
                    });
                }
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "modal-left"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "modal-left-title"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.connectYourWallet")
                                })
                            })),
                            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletOptions, {
                                handleWalletClick: (module)=>{
                                    handleWalletClick(module, false);
                                },
                                selector: selector
                            })
                        ]
                    })),
                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "modal-right"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                            className: "nws-modal-body"
                        }, {
                            children: [
                                route.name === "AlertMessage" && alertMessage && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$AlertMessage, {
                                    message: alertMessage,
                                    module: (_a = route.params) === null || _a === void 0 ? void 0 : _a.module,
                                    onBack: (retry)=>{
                                        if (retry) handleWalletClick(selectedWallet, false);
                                        setAlertMessage(null);
                                        setRoute({
                                            name: "WalletHome"
                                        });
                                    },
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "DerivationPath" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$DerivationPath, {
                                    selector: selector,
                                    options: options,
                                    onConnected: ()=>{
                                        handleDismissClick({
                                            hideReason: "wallet-navigation"
                                        });
                                    },
                                    params: route.params,
                                    onBack: ()=>setRoute({
                                            name: "WalletHome"
                                        }),
                                    onError: (message, wallet)=>{
                                        const { modules: modules } = selector.store.getState();
                                        const findModule = modules.find((module)=>module.id === wallet.id);
                                        setAlertMessage(message);
                                        setRoute({
                                            name: "AlertMessage",
                                            params: {
                                                module: findModule
                                            }
                                        });
                                    },
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "WalletNetworkChanged" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletNetworkChanged, {
                                    selector: selector,
                                    onBack: ()=>setRoute({
                                            name: "WalletHome"
                                        }),
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "WalletNotInstalled" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletNotInstalled, {
                                    module: (_b = route.params) === null || _b === void 0 ? void 0 : _b.module,
                                    onBack: ()=>{
                                        setRoute({
                                            name: "WalletHome"
                                        });
                                    },
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "WalletConnecting" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletConnecting, {
                                    wallet: (_c = route.params) === null || _c === void 0 ? void 0 : _c.wallet,
                                    onBack: ()=>{
                                        setRoute({
                                            name: "WalletHome"
                                        });
                                    },
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "WalletHome" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletHome, {
                                    selector: selector,
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "WalletConnected" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletConnected, {
                                    module: selectedWallet,
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "ScanQRCode" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ScanQRCode, {
                                    handleOpenDefaultModal: ()=>{
                                        handleWalletClick(selectedWallet, true);
                                    },
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        }),
                                    uri: bridgeWalletUri,
                                    wallet: selectedWallet
                                })
                            ]
                        }))
                    }))
                ]
            }))
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$MODAL_ELEMENT_ID = "near-wallet-selector-modal";
let $6daeff2c8e1d7f1b$var$modalInstance = null;
const $6daeff2c8e1d7f1b$export$60f0f9f4cfa9469a = (selector, options)=>{
    const el = document.createElement("div");
    el.id = $6daeff2c8e1d7f1b$var$MODAL_ELEMENT_ID;
    if (!document.getElementById($6daeff2c8e1d7f1b$var$MODAL_ELEMENT_ID)) document.body.appendChild(el);
    const container = document.getElementById($6daeff2c8e1d7f1b$var$MODAL_ELEMENT_ID);
    const root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(container);
    const emitter = new (0, $5bb7220e37bd460f$export$4fae95256245c8c0)();
    const render = (visible = false)=>{
        root.render((0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$Modal, {
            selector: selector,
            options: options,
            visible: visible,
            hide: ()=>render(false),
            emitter: emitter
        }));
    };
    if (!$6daeff2c8e1d7f1b$var$modalInstance) $6daeff2c8e1d7f1b$var$modalInstance = {
        show: ()=>{
            render(true);
        },
        hide: ()=>{
            render(false);
        },
        on: (eventName, callback)=>{
            return emitter.on(eventName, callback);
        },
        off: (eventName, callback)=>{
            emitter.off(eventName, callback);
        }
    };
    return $6daeff2c8e1d7f1b$var$modalInstance;
};


var $d8854490a0ef0108$exports = {};
$d8854490a0ef0108$exports = new URL("ledger-icon.7213d67e.png", import.meta.url).toString();


var $ea1b12ab6682ab47$exports = {};
$ea1b12ab6682ab47$exports = new URL("my-near-wallet-icon.ff4757f7.png", import.meta.url).toString();



var $b5a8117fb009006e$exports = {};
"use strict";
$b5a8117fb009006e$exports = $b5a8117fb009006e$var$isMobile;
$b5a8117fb009006e$exports.isMobile = $b5a8117fb009006e$var$isMobile;
$b5a8117fb009006e$exports.default = $b5a8117fb009006e$var$isMobile;
const $b5a8117fb009006e$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $b5a8117fb009006e$var$notMobileRE = /CrOS/;
const $b5a8117fb009006e$var$tabletRE = /android|ipad|playbook|silk/i;
function $b5a8117fb009006e$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== "undefined") ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") ua = ua.headers["user-agent"];
    if (typeof ua !== "string") return false;
    let result = $b5a8117fb009006e$var$mobileRE.test(ua) && !$b5a8117fb009006e$var$notMobileRE.test(ua) || !!opts.tablet && $b5a8117fb009006e$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf("Macintosh") !== -1 && ua.indexOf("Safari") !== -1) result = true;
    return result;
}



var $dEXSZ = parcelRequire("dEXSZ");

const { transactions: $5aa677c457ee63c9$var$transactions, utils: $5aa677c457ee63c9$var$utils } = $e9c96496ce82840e$exports;
const $5aa677c457ee63c9$var$getAccessKey = (permission)=>{
    if (permission === "FullAccess") return $5aa677c457ee63c9$var$transactions.fullAccessKey();
    const { receiverId: receiverId, methodNames: methodNames = [] } = permission;
    const allowance = permission.allowance ? new (0, $dEXSZ.BN)(permission.allowance) : undefined;
    return $5aa677c457ee63c9$var$transactions.functionCallAccessKey(receiverId, methodNames, allowance);
};
const $5aa677c457ee63c9$export$309c7a02b0b0bc62 = (action)=>{
    switch(action.type){
        case "CreateAccount":
            return $5aa677c457ee63c9$var$transactions.createAccount();
        case "DeployContract":
            {
                const { code: code } = action.params;
                return $5aa677c457ee63c9$var$transactions.deployContract(code);
            }
        case "FunctionCall":
            {
                const { methodName: methodName, args: args, gas: gas, deposit: deposit } = action.params;
                return $5aa677c457ee63c9$var$transactions.functionCall(methodName, args, new (0, $dEXSZ.BN)(gas), new (0, $dEXSZ.BN)(deposit));
            }
        case "Transfer":
            {
                const { deposit: deposit } = action.params;
                return $5aa677c457ee63c9$var$transactions.transfer(new (0, $dEXSZ.BN)(deposit));
            }
        case "Stake":
            {
                const { stake: stake, publicKey: publicKey } = action.params;
                return $5aa677c457ee63c9$var$transactions.stake(new (0, $dEXSZ.BN)(stake), $5aa677c457ee63c9$var$utils.PublicKey.from(publicKey));
            }
        case "AddKey":
            {
                const { publicKey: publicKey, accessKey: accessKey } = action.params;
                return $5aa677c457ee63c9$var$transactions.addKey($5aa677c457ee63c9$var$utils.PublicKey.from(publicKey), $5aa677c457ee63c9$var$getAccessKey(accessKey.permission));
            }
        case "DeleteKey":
            {
                const { publicKey: publicKey } = action.params;
                return $5aa677c457ee63c9$var$transactions.deleteKey($5aa677c457ee63c9$var$utils.PublicKey.from(publicKey));
            }
        case "DeleteAccount":
            {
                const { beneficiaryId: beneficiaryId } = action.params;
                return $5aa677c457ee63c9$var$transactions.deleteAccount(beneficiaryId);
            }
        default:
            throw new Error("Invalid action type");
    }
};
var $5aa677c457ee63c9$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $5aa677c457ee63c9$var$fails$d = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $5aa677c457ee63c9$var$fails$c = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$functionBindNative = !$5aa677c457ee63c9$var$fails$c(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $5aa677c457ee63c9$var$NATIVE_BIND$3 = $5aa677c457ee63c9$var$functionBindNative;
var $5aa677c457ee63c9$var$FunctionPrototype$2 = Function.prototype;
var $5aa677c457ee63c9$var$bind$5 = $5aa677c457ee63c9$var$FunctionPrototype$2.bind;
var $5aa677c457ee63c9$var$call$e = $5aa677c457ee63c9$var$FunctionPrototype$2.call;
var $5aa677c457ee63c9$var$uncurryThis$d = $5aa677c457ee63c9$var$NATIVE_BIND$3 && $5aa677c457ee63c9$var$bind$5.bind($5aa677c457ee63c9$var$call$e, $5aa677c457ee63c9$var$call$e);
var $5aa677c457ee63c9$var$functionUncurryThis = $5aa677c457ee63c9$var$NATIVE_BIND$3 ? function(fn) {
    return fn && $5aa677c457ee63c9$var$uncurryThis$d(fn);
} : function(fn) {
    return fn && function() {
        return $5aa677c457ee63c9$var$call$e.apply(fn, arguments);
    };
};
var $5aa677c457ee63c9$var$uncurryThis$c = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$toString$2 = $5aa677c457ee63c9$var$uncurryThis$c({}.toString);
var $5aa677c457ee63c9$var$stringSlice = $5aa677c457ee63c9$var$uncurryThis$c("".slice);
var $5aa677c457ee63c9$var$classofRaw$1 = function(it) {
    return $5aa677c457ee63c9$var$stringSlice($5aa677c457ee63c9$var$toString$2(it), 8, -1);
};
var $5aa677c457ee63c9$var$uncurryThis$b = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$fails$b = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$classof$5 = $5aa677c457ee63c9$var$classofRaw$1;
var $5aa677c457ee63c9$var$$Object$4 = Object;
var $5aa677c457ee63c9$var$split = $5aa677c457ee63c9$var$uncurryThis$b("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $5aa677c457ee63c9$var$indexedObject = $5aa677c457ee63c9$var$fails$b(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$5aa677c457ee63c9$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $5aa677c457ee63c9$var$classof$5(it) == "String" ? $5aa677c457ee63c9$var$split(it, "") : $5aa677c457ee63c9$var$$Object$4(it);
} : $5aa677c457ee63c9$var$$Object$4;
var $5aa677c457ee63c9$var$$TypeError$b = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $5aa677c457ee63c9$var$requireObjectCoercible$2 = function(it) {
    if (it == undefined) throw $5aa677c457ee63c9$var$$TypeError$b("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $5aa677c457ee63c9$var$IndexedObject = $5aa677c457ee63c9$var$indexedObject;
var $5aa677c457ee63c9$var$requireObjectCoercible$1 = $5aa677c457ee63c9$var$requireObjectCoercible$2;
var $5aa677c457ee63c9$var$toIndexedObject$5 = function(it) {
    return $5aa677c457ee63c9$var$IndexedObject($5aa677c457ee63c9$var$requireObjectCoercible$1(it));
};
var $5aa677c457ee63c9$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $5aa677c457ee63c9$var$global$j = // eslint-disable-next-line es-x/no-global-this -- safe
$5aa677c457ee63c9$var$check(typeof globalThis == "object" && globalThis) || $5aa677c457ee63c9$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$5aa677c457ee63c9$var$check(typeof self == "object" && self) || $5aa677c457ee63c9$var$check(typeof $5aa677c457ee63c9$var$commonjsGlobal == "object" && $5aa677c457ee63c9$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $5aa677c457ee63c9$var$shared$3 = {
    exports: {}
};
var $5aa677c457ee63c9$var$global$i = $5aa677c457ee63c9$var$global$j;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5aa677c457ee63c9$var$defineProperty$4 = Object.defineProperty;
var $5aa677c457ee63c9$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $5aa677c457ee63c9$var$defineProperty$4($5aa677c457ee63c9$var$global$i, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $5aa677c457ee63c9$var$global$i[key] = value;
    }
    return value;
};
var $5aa677c457ee63c9$var$global$h = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$defineGlobalProperty$2 = $5aa677c457ee63c9$var$defineGlobalProperty$3;
var $5aa677c457ee63c9$var$SHARED = "__core-js_shared__";
var $5aa677c457ee63c9$var$store$3 = $5aa677c457ee63c9$var$global$h[$5aa677c457ee63c9$var$SHARED] || $5aa677c457ee63c9$var$defineGlobalProperty$2($5aa677c457ee63c9$var$SHARED, {});
var $5aa677c457ee63c9$var$sharedStore = $5aa677c457ee63c9$var$store$3;
var $5aa677c457ee63c9$var$store$2 = $5aa677c457ee63c9$var$sharedStore;
($5aa677c457ee63c9$var$shared$3.exports = function(key, value) {
    return $5aa677c457ee63c9$var$store$2[key] || ($5aa677c457ee63c9$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $5aa677c457ee63c9$var$requireObjectCoercible = $5aa677c457ee63c9$var$requireObjectCoercible$2;
var $5aa677c457ee63c9$var$$Object$3 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $5aa677c457ee63c9$var$toObject$2 = function(argument) {
    return $5aa677c457ee63c9$var$$Object$3($5aa677c457ee63c9$var$requireObjectCoercible(argument));
};
var $5aa677c457ee63c9$var$uncurryThis$a = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$toObject$1 = $5aa677c457ee63c9$var$toObject$2;
var $5aa677c457ee63c9$var$hasOwnProperty = $5aa677c457ee63c9$var$uncurryThis$a({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $5aa677c457ee63c9$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $5aa677c457ee63c9$var$hasOwnProperty($5aa677c457ee63c9$var$toObject$1(it), key);
};
var $5aa677c457ee63c9$var$uncurryThis$9 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$id = 0;
var $5aa677c457ee63c9$var$postfix = Math.random();
var $5aa677c457ee63c9$var$toString$1 = $5aa677c457ee63c9$var$uncurryThis$9(1.0.toString);
var $5aa677c457ee63c9$var$uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $5aa677c457ee63c9$var$toString$1(++$5aa677c457ee63c9$var$id + $5aa677c457ee63c9$var$postfix, 36);
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $5aa677c457ee63c9$var$isCallable$k = function(argument) {
    return typeof argument == "function";
};
var $5aa677c457ee63c9$var$global$g = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$isCallable$j = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$aFunction = function(argument) {
    return $5aa677c457ee63c9$var$isCallable$j(argument) ? argument : undefined;
};
var $5aa677c457ee63c9$var$getBuiltIn$8 = function(namespace, method) {
    return arguments.length < 2 ? $5aa677c457ee63c9$var$aFunction($5aa677c457ee63c9$var$global$g[namespace]) : $5aa677c457ee63c9$var$global$g[namespace] && $5aa677c457ee63c9$var$global$g[namespace][method];
};
var $5aa677c457ee63c9$var$getBuiltIn$7 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$engineUserAgent = $5aa677c457ee63c9$var$getBuiltIn$7("navigator", "userAgent") || "";
var $5aa677c457ee63c9$var$global$f = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$userAgent$3 = $5aa677c457ee63c9$var$engineUserAgent;
var $5aa677c457ee63c9$var$process$3 = $5aa677c457ee63c9$var$global$f.process;
var $5aa677c457ee63c9$var$Deno$1 = $5aa677c457ee63c9$var$global$f.Deno;
var $5aa677c457ee63c9$var$versions = $5aa677c457ee63c9$var$process$3 && $5aa677c457ee63c9$var$process$3.versions || $5aa677c457ee63c9$var$Deno$1 && $5aa677c457ee63c9$var$Deno$1.version;
var $5aa677c457ee63c9$var$v8 = $5aa677c457ee63c9$var$versions && $5aa677c457ee63c9$var$versions.v8;
var $5aa677c457ee63c9$var$match, $5aa677c457ee63c9$var$version;
if ($5aa677c457ee63c9$var$v8) {
    $5aa677c457ee63c9$var$match = $5aa677c457ee63c9$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $5aa677c457ee63c9$var$version = $5aa677c457ee63c9$var$match[0] > 0 && $5aa677c457ee63c9$var$match[0] < 4 ? 1 : +($5aa677c457ee63c9$var$match[0] + $5aa677c457ee63c9$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$5aa677c457ee63c9$var$version && $5aa677c457ee63c9$var$userAgent$3) {
    $5aa677c457ee63c9$var$match = $5aa677c457ee63c9$var$userAgent$3.match(/Edge\/(\d+)/);
    if (!$5aa677c457ee63c9$var$match || $5aa677c457ee63c9$var$match[1] >= 74) {
        $5aa677c457ee63c9$var$match = $5aa677c457ee63c9$var$userAgent$3.match(/Chrome\/(\d+)/);
        if ($5aa677c457ee63c9$var$match) $5aa677c457ee63c9$var$version = +$5aa677c457ee63c9$var$match[1];
    }
}
var $5aa677c457ee63c9$var$engineV8Version = $5aa677c457ee63c9$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $5aa677c457ee63c9$var$V8_VERSION$1 = $5aa677c457ee63c9$var$engineV8Version;
var $5aa677c457ee63c9$var$fails$a = $5aa677c457ee63c9$var$fails$d;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $5aa677c457ee63c9$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$5aa677c457ee63c9$var$fails$a(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $5aa677c457ee63c9$var$V8_VERSION$1 && $5aa677c457ee63c9$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $5aa677c457ee63c9$var$NATIVE_SYMBOL$1 = $5aa677c457ee63c9$var$nativeSymbol;
var $5aa677c457ee63c9$var$useSymbolAsUid = $5aa677c457ee63c9$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $5aa677c457ee63c9$var$global$e = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$shared$2 = $5aa677c457ee63c9$var$shared$3.exports;
var $5aa677c457ee63c9$var$hasOwn$a = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$uid$1 = $5aa677c457ee63c9$var$uid$2;
var $5aa677c457ee63c9$var$NATIVE_SYMBOL = $5aa677c457ee63c9$var$nativeSymbol;
var $5aa677c457ee63c9$var$USE_SYMBOL_AS_UID$1 = $5aa677c457ee63c9$var$useSymbolAsUid;
var $5aa677c457ee63c9$var$WellKnownSymbolsStore = $5aa677c457ee63c9$var$shared$2("wks");
var $5aa677c457ee63c9$var$Symbol$1 = $5aa677c457ee63c9$var$global$e.Symbol;
var $5aa677c457ee63c9$var$symbolFor = $5aa677c457ee63c9$var$Symbol$1 && $5aa677c457ee63c9$var$Symbol$1["for"];
var $5aa677c457ee63c9$var$createWellKnownSymbol = $5aa677c457ee63c9$var$USE_SYMBOL_AS_UID$1 ? $5aa677c457ee63c9$var$Symbol$1 : $5aa677c457ee63c9$var$Symbol$1 && $5aa677c457ee63c9$var$Symbol$1.withoutSetter || $5aa677c457ee63c9$var$uid$1;
var $5aa677c457ee63c9$var$wellKnownSymbol$e = function(name) {
    if (!$5aa677c457ee63c9$var$hasOwn$a($5aa677c457ee63c9$var$WellKnownSymbolsStore, name) || !($5aa677c457ee63c9$var$NATIVE_SYMBOL || typeof $5aa677c457ee63c9$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($5aa677c457ee63c9$var$NATIVE_SYMBOL && $5aa677c457ee63c9$var$hasOwn$a($5aa677c457ee63c9$var$Symbol$1, name)) $5aa677c457ee63c9$var$WellKnownSymbolsStore[name] = $5aa677c457ee63c9$var$Symbol$1[name];
        else if ($5aa677c457ee63c9$var$USE_SYMBOL_AS_UID$1 && $5aa677c457ee63c9$var$symbolFor) $5aa677c457ee63c9$var$WellKnownSymbolsStore[name] = $5aa677c457ee63c9$var$symbolFor(description);
        else $5aa677c457ee63c9$var$WellKnownSymbolsStore[name] = $5aa677c457ee63c9$var$createWellKnownSymbol(description);
    }
    return $5aa677c457ee63c9$var$WellKnownSymbolsStore[name];
};
var $5aa677c457ee63c9$var$isCallable$i = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$isObject$7 = function(it) {
    return typeof it == "object" ? it !== null : $5aa677c457ee63c9$var$isCallable$i(it);
};
var $5aa677c457ee63c9$var$isObject$6 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$$String$3 = String;
var $5aa677c457ee63c9$var$$TypeError$a = TypeError;
// `Assert: Type(argument) is Object`
var $5aa677c457ee63c9$var$anObject$c = function(argument) {
    if ($5aa677c457ee63c9$var$isObject$6(argument)) return argument;
    throw $5aa677c457ee63c9$var$$TypeError$a($5aa677c457ee63c9$var$$String$3(argument) + " is not an object");
};
var $5aa677c457ee63c9$var$objectDefineProperties = {};
var $5aa677c457ee63c9$var$fails$9 = $5aa677c457ee63c9$var$fails$d;
// Detect IE8's incomplete defineProperty implementation
var $5aa677c457ee63c9$var$descriptors = !$5aa677c457ee63c9$var$fails$9(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $5aa677c457ee63c9$var$DESCRIPTORS$9 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$fails$8 = $5aa677c457ee63c9$var$fails$d;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $5aa677c457ee63c9$var$v8PrototypeDefineBug = $5aa677c457ee63c9$var$DESCRIPTORS$9 && $5aa677c457ee63c9$var$fails$8(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $5aa677c457ee63c9$var$objectDefineProperty = {};
var $5aa677c457ee63c9$var$global$d = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$isObject$5 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$document$3 = $5aa677c457ee63c9$var$global$d.document;
// typeof document.createElement is 'object' in old IE
var $5aa677c457ee63c9$var$EXISTS$1 = $5aa677c457ee63c9$var$isObject$5($5aa677c457ee63c9$var$document$3) && $5aa677c457ee63c9$var$isObject$5($5aa677c457ee63c9$var$document$3.createElement);
var $5aa677c457ee63c9$var$documentCreateElement$2 = function(it) {
    return $5aa677c457ee63c9$var$EXISTS$1 ? $5aa677c457ee63c9$var$document$3.createElement(it) : {};
};
var $5aa677c457ee63c9$var$DESCRIPTORS$8 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$fails$7 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$createElement$1 = $5aa677c457ee63c9$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $5aa677c457ee63c9$var$ie8DomDefine = !$5aa677c457ee63c9$var$DESCRIPTORS$8 && !$5aa677c457ee63c9$var$fails$7(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($5aa677c457ee63c9$var$createElement$1("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $5aa677c457ee63c9$var$NATIVE_BIND$2 = $5aa677c457ee63c9$var$functionBindNative;
var $5aa677c457ee63c9$var$call$d = Function.prototype.call;
var $5aa677c457ee63c9$var$functionCall = $5aa677c457ee63c9$var$NATIVE_BIND$2 ? $5aa677c457ee63c9$var$call$d.bind($5aa677c457ee63c9$var$call$d) : function() {
    return $5aa677c457ee63c9$var$call$d.apply($5aa677c457ee63c9$var$call$d, arguments);
};
var $5aa677c457ee63c9$var$uncurryThis$8 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$objectIsPrototypeOf = $5aa677c457ee63c9$var$uncurryThis$8({}.isPrototypeOf);
var $5aa677c457ee63c9$var$getBuiltIn$6 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$isCallable$h = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$isPrototypeOf$3 = $5aa677c457ee63c9$var$objectIsPrototypeOf;
var $5aa677c457ee63c9$var$USE_SYMBOL_AS_UID = $5aa677c457ee63c9$var$useSymbolAsUid;
var $5aa677c457ee63c9$var$$Object$2 = Object;
var $5aa677c457ee63c9$var$isSymbol$2 = $5aa677c457ee63c9$var$USE_SYMBOL_AS_UID ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $5aa677c457ee63c9$var$getBuiltIn$6("Symbol");
    return $5aa677c457ee63c9$var$isCallable$h($Symbol) && $5aa677c457ee63c9$var$isPrototypeOf$3($Symbol.prototype, $5aa677c457ee63c9$var$$Object$2(it));
};
var $5aa677c457ee63c9$var$$String$2 = String;
var $5aa677c457ee63c9$var$tryToString$4 = function(argument) {
    try {
        return $5aa677c457ee63c9$var$$String$2(argument);
    } catch (error) {
        return "Object";
    }
};
var $5aa677c457ee63c9$var$isCallable$g = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$tryToString$3 = $5aa677c457ee63c9$var$tryToString$4;
var $5aa677c457ee63c9$var$$TypeError$9 = TypeError;
// `Assert: IsCallable(argument) is true`
var $5aa677c457ee63c9$var$aCallable$7 = function(argument) {
    if ($5aa677c457ee63c9$var$isCallable$g(argument)) return argument;
    throw $5aa677c457ee63c9$var$$TypeError$9($5aa677c457ee63c9$var$tryToString$3(argument) + " is not a function");
};
var $5aa677c457ee63c9$var$aCallable$6 = $5aa677c457ee63c9$var$aCallable$7;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $5aa677c457ee63c9$var$getMethod$3 = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $5aa677c457ee63c9$var$aCallable$6(func);
};
var $5aa677c457ee63c9$var$call$c = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$isCallable$f = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$isObject$4 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$$TypeError$8 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $5aa677c457ee63c9$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $5aa677c457ee63c9$var$isCallable$f(fn = input.toString) && !$5aa677c457ee63c9$var$isObject$4(val = $5aa677c457ee63c9$var$call$c(fn, input))) return val;
    if ($5aa677c457ee63c9$var$isCallable$f(fn = input.valueOf) && !$5aa677c457ee63c9$var$isObject$4(val = $5aa677c457ee63c9$var$call$c(fn, input))) return val;
    if (pref !== "string" && $5aa677c457ee63c9$var$isCallable$f(fn = input.toString) && !$5aa677c457ee63c9$var$isObject$4(val = $5aa677c457ee63c9$var$call$c(fn, input))) return val;
    throw $5aa677c457ee63c9$var$$TypeError$8("Can't convert object to primitive value");
};
var $5aa677c457ee63c9$var$call$b = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$isObject$3 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$isSymbol$1 = $5aa677c457ee63c9$var$isSymbol$2;
var $5aa677c457ee63c9$var$getMethod$2 = $5aa677c457ee63c9$var$getMethod$3;
var $5aa677c457ee63c9$var$ordinaryToPrimitive = $5aa677c457ee63c9$var$ordinaryToPrimitive$1;
var $5aa677c457ee63c9$var$wellKnownSymbol$d = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$$TypeError$7 = TypeError;
var $5aa677c457ee63c9$var$TO_PRIMITIVE = $5aa677c457ee63c9$var$wellKnownSymbol$d("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $5aa677c457ee63c9$var$toPrimitive$1 = function(input, pref) {
    if (!$5aa677c457ee63c9$var$isObject$3(input) || $5aa677c457ee63c9$var$isSymbol$1(input)) return input;
    var exoticToPrim = $5aa677c457ee63c9$var$getMethod$2(input, $5aa677c457ee63c9$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $5aa677c457ee63c9$var$call$b(exoticToPrim, input, pref);
        if (!$5aa677c457ee63c9$var$isObject$3(result) || $5aa677c457ee63c9$var$isSymbol$1(result)) return result;
        throw $5aa677c457ee63c9$var$$TypeError$7("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $5aa677c457ee63c9$var$ordinaryToPrimitive(input, pref);
};
var $5aa677c457ee63c9$var$toPrimitive = $5aa677c457ee63c9$var$toPrimitive$1;
var $5aa677c457ee63c9$var$isSymbol = $5aa677c457ee63c9$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $5aa677c457ee63c9$var$toPropertyKey$2 = function(argument) {
    var key = $5aa677c457ee63c9$var$toPrimitive(argument, "string");
    return $5aa677c457ee63c9$var$isSymbol(key) ? key : key + "";
};
var $5aa677c457ee63c9$var$DESCRIPTORS$7 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$IE8_DOM_DEFINE$1 = $5aa677c457ee63c9$var$ie8DomDefine;
var $5aa677c457ee63c9$var$V8_PROTOTYPE_DEFINE_BUG$1 = $5aa677c457ee63c9$var$v8PrototypeDefineBug;
var $5aa677c457ee63c9$var$anObject$b = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$toPropertyKey$1 = $5aa677c457ee63c9$var$toPropertyKey$2;
var $5aa677c457ee63c9$var$$TypeError$6 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5aa677c457ee63c9$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5aa677c457ee63c9$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var $5aa677c457ee63c9$var$ENUMERABLE = "enumerable";
var $5aa677c457ee63c9$var$CONFIGURABLE$1 = "configurable";
var $5aa677c457ee63c9$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$5aa677c457ee63c9$var$objectDefineProperty.f = $5aa677c457ee63c9$var$DESCRIPTORS$7 ? $5aa677c457ee63c9$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $5aa677c457ee63c9$var$anObject$b(O);
    P = $5aa677c457ee63c9$var$toPropertyKey$1(P);
    $5aa677c457ee63c9$var$anObject$b(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $5aa677c457ee63c9$var$WRITABLE in Attributes && !Attributes[$5aa677c457ee63c9$var$WRITABLE]) {
        var current = $5aa677c457ee63c9$var$$getOwnPropertyDescriptor$1(O, P);
        if (current && current[$5aa677c457ee63c9$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $5aa677c457ee63c9$var$CONFIGURABLE$1 in Attributes ? Attributes[$5aa677c457ee63c9$var$CONFIGURABLE$1] : current[$5aa677c457ee63c9$var$CONFIGURABLE$1],
                enumerable: $5aa677c457ee63c9$var$ENUMERABLE in Attributes ? Attributes[$5aa677c457ee63c9$var$ENUMERABLE] : current[$5aa677c457ee63c9$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $5aa677c457ee63c9$var$$defineProperty(O, P, Attributes);
} : $5aa677c457ee63c9$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $5aa677c457ee63c9$var$anObject$b(O);
    P = $5aa677c457ee63c9$var$toPropertyKey$1(P);
    $5aa677c457ee63c9$var$anObject$b(Attributes);
    if ($5aa677c457ee63c9$var$IE8_DOM_DEFINE$1) try {
        return $5aa677c457ee63c9$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $5aa677c457ee63c9$var$$TypeError$6("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $5aa677c457ee63c9$var$ceil = Math.ceil;
var $5aa677c457ee63c9$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $5aa677c457ee63c9$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5aa677c457ee63c9$var$floor : $5aa677c457ee63c9$var$ceil)(n);
};
var $5aa677c457ee63c9$var$trunc = $5aa677c457ee63c9$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $5aa677c457ee63c9$var$toIntegerOrInfinity$2 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5aa677c457ee63c9$var$trunc(number);
};
var $5aa677c457ee63c9$var$toIntegerOrInfinity$1 = $5aa677c457ee63c9$var$toIntegerOrInfinity$2;
var $5aa677c457ee63c9$var$max = Math.max;
var $5aa677c457ee63c9$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $5aa677c457ee63c9$var$toAbsoluteIndex$1 = function(index, length) {
    var integer = $5aa677c457ee63c9$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $5aa677c457ee63c9$var$max(integer + length, 0) : $5aa677c457ee63c9$var$min$1(integer, length);
};
var $5aa677c457ee63c9$var$toIntegerOrInfinity = $5aa677c457ee63c9$var$toIntegerOrInfinity$2;
var $5aa677c457ee63c9$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $5aa677c457ee63c9$var$toLength$1 = function(argument) {
    return argument > 0 ? $5aa677c457ee63c9$var$min($5aa677c457ee63c9$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $5aa677c457ee63c9$var$toLength = $5aa677c457ee63c9$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $5aa677c457ee63c9$var$lengthOfArrayLike$2 = function(obj) {
    return $5aa677c457ee63c9$var$toLength(obj.length);
};
var $5aa677c457ee63c9$var$toIndexedObject$4 = $5aa677c457ee63c9$var$toIndexedObject$5;
var $5aa677c457ee63c9$var$toAbsoluteIndex = $5aa677c457ee63c9$var$toAbsoluteIndex$1;
var $5aa677c457ee63c9$var$lengthOfArrayLike$1 = $5aa677c457ee63c9$var$lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $5aa677c457ee63c9$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $5aa677c457ee63c9$var$toIndexedObject$4($this);
        var length = $5aa677c457ee63c9$var$lengthOfArrayLike$1(O);
        var index = $5aa677c457ee63c9$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $5aa677c457ee63c9$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $5aa677c457ee63c9$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $5aa677c457ee63c9$var$createMethod(false)
};
var $5aa677c457ee63c9$var$hiddenKeys$4 = {};
var $5aa677c457ee63c9$var$uncurryThis$7 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$hasOwn$9 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$toIndexedObject$3 = $5aa677c457ee63c9$var$toIndexedObject$5;
var $5aa677c457ee63c9$var$indexOf = $5aa677c457ee63c9$var$arrayIncludes.indexOf;
var $5aa677c457ee63c9$var$hiddenKeys$3 = $5aa677c457ee63c9$var$hiddenKeys$4;
var $5aa677c457ee63c9$var$push = $5aa677c457ee63c9$var$uncurryThis$7([].push);
var $5aa677c457ee63c9$var$objectKeysInternal = function(object, names) {
    var O = $5aa677c457ee63c9$var$toIndexedObject$3(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$5aa677c457ee63c9$var$hasOwn$9($5aa677c457ee63c9$var$hiddenKeys$3, key) && $5aa677c457ee63c9$var$hasOwn$9(O, key) && $5aa677c457ee63c9$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($5aa677c457ee63c9$var$hasOwn$9(O, key = names[i++])) ~$5aa677c457ee63c9$var$indexOf(result, key) || $5aa677c457ee63c9$var$push(result, key);
    return result;
};
// IE8- don't enum bug keys
var $5aa677c457ee63c9$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $5aa677c457ee63c9$var$internalObjectKeys$1 = $5aa677c457ee63c9$var$objectKeysInternal;
var $5aa677c457ee63c9$var$enumBugKeys$2 = $5aa677c457ee63c9$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $5aa677c457ee63c9$var$objectKeys$1 = Object.keys || function keys(O) {
    return $5aa677c457ee63c9$var$internalObjectKeys$1(O, $5aa677c457ee63c9$var$enumBugKeys$2);
};
var $5aa677c457ee63c9$var$DESCRIPTORS$6 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$V8_PROTOTYPE_DEFINE_BUG = $5aa677c457ee63c9$var$v8PrototypeDefineBug;
var $5aa677c457ee63c9$var$definePropertyModule$4 = $5aa677c457ee63c9$var$objectDefineProperty;
var $5aa677c457ee63c9$var$anObject$a = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$toIndexedObject$2 = $5aa677c457ee63c9$var$toIndexedObject$5;
var $5aa677c457ee63c9$var$objectKeys = $5aa677c457ee63c9$var$objectKeys$1;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$5aa677c457ee63c9$var$objectDefineProperties.f = $5aa677c457ee63c9$var$DESCRIPTORS$6 && !$5aa677c457ee63c9$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $5aa677c457ee63c9$var$anObject$a(O);
    var props = $5aa677c457ee63c9$var$toIndexedObject$2(Properties);
    var keys = $5aa677c457ee63c9$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$5aa677c457ee63c9$var$definePropertyModule$4.f(O, key = keys[index++], props[key]);
    return O;
};
var $5aa677c457ee63c9$var$getBuiltIn$5 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$html$2 = $5aa677c457ee63c9$var$getBuiltIn$5("document", "documentElement");
var $5aa677c457ee63c9$var$shared$1 = $5aa677c457ee63c9$var$shared$3.exports;
var $5aa677c457ee63c9$var$uid = $5aa677c457ee63c9$var$uid$2;
var $5aa677c457ee63c9$var$keys = $5aa677c457ee63c9$var$shared$1("keys");
var $5aa677c457ee63c9$var$sharedKey$3 = function(key) {
    return $5aa677c457ee63c9$var$keys[key] || ($5aa677c457ee63c9$var$keys[key] = $5aa677c457ee63c9$var$uid(key));
};
/* global ActiveXObject -- old IE, WSH */ var $5aa677c457ee63c9$var$anObject$9 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$definePropertiesModule = $5aa677c457ee63c9$var$objectDefineProperties;
var $5aa677c457ee63c9$var$enumBugKeys$1 = $5aa677c457ee63c9$var$enumBugKeys$3;
var $5aa677c457ee63c9$var$hiddenKeys$2 = $5aa677c457ee63c9$var$hiddenKeys$4;
var $5aa677c457ee63c9$var$html$1 = $5aa677c457ee63c9$var$html$2;
var $5aa677c457ee63c9$var$documentCreateElement$1 = $5aa677c457ee63c9$var$documentCreateElement$2;
var $5aa677c457ee63c9$var$sharedKey$2 = $5aa677c457ee63c9$var$sharedKey$3;
var $5aa677c457ee63c9$var$GT = ">";
var $5aa677c457ee63c9$var$LT = "<";
var $5aa677c457ee63c9$var$PROTOTYPE = "prototype";
var $5aa677c457ee63c9$var$SCRIPT = "script";
var $5aa677c457ee63c9$var$IE_PROTO$1 = $5aa677c457ee63c9$var$sharedKey$2("IE_PROTO");
var $5aa677c457ee63c9$var$EmptyConstructor = function() {};
var $5aa677c457ee63c9$var$scriptTag = function(content) {
    return $5aa677c457ee63c9$var$LT + $5aa677c457ee63c9$var$SCRIPT + $5aa677c457ee63c9$var$GT + content + $5aa677c457ee63c9$var$LT + "/" + $5aa677c457ee63c9$var$SCRIPT + $5aa677c457ee63c9$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $5aa677c457ee63c9$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($5aa677c457ee63c9$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $5aa677c457ee63c9$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $5aa677c457ee63c9$var$documentCreateElement$1("iframe");
    var JS = "java" + $5aa677c457ee63c9$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $5aa677c457ee63c9$var$html$1.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($5aa677c457ee63c9$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $5aa677c457ee63c9$var$activeXDocument;
var $5aa677c457ee63c9$var$NullProtoObject = function() {
    try {
        $5aa677c457ee63c9$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $5aa677c457ee63c9$var$NullProtoObject = typeof document != "undefined" ? document.domain && $5aa677c457ee63c9$var$activeXDocument ? $5aa677c457ee63c9$var$NullProtoObjectViaActiveX($5aa677c457ee63c9$var$activeXDocument) // old IE
     : $5aa677c457ee63c9$var$NullProtoObjectViaIFrame() : $5aa677c457ee63c9$var$NullProtoObjectViaActiveX($5aa677c457ee63c9$var$activeXDocument); // WSH
    var length = $5aa677c457ee63c9$var$enumBugKeys$1.length;
    while(length--)delete $5aa677c457ee63c9$var$NullProtoObject[$5aa677c457ee63c9$var$PROTOTYPE][$5aa677c457ee63c9$var$enumBugKeys$1[length]];
    return $5aa677c457ee63c9$var$NullProtoObject();
};
$5aa677c457ee63c9$var$hiddenKeys$2[$5aa677c457ee63c9$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $5aa677c457ee63c9$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $5aa677c457ee63c9$var$EmptyConstructor[$5aa677c457ee63c9$var$PROTOTYPE] = $5aa677c457ee63c9$var$anObject$9(O);
        result = new $5aa677c457ee63c9$var$EmptyConstructor();
        $5aa677c457ee63c9$var$EmptyConstructor[$5aa677c457ee63c9$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$5aa677c457ee63c9$var$IE_PROTO$1] = O;
    } else result = $5aa677c457ee63c9$var$NullProtoObject();
    return Properties === undefined ? result : $5aa677c457ee63c9$var$definePropertiesModule.f(result, Properties);
};
var $5aa677c457ee63c9$var$wellKnownSymbol$c = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$create$1 = $5aa677c457ee63c9$var$objectCreate;
var $5aa677c457ee63c9$var$defineProperty$3 = $5aa677c457ee63c9$var$objectDefineProperty.f;
var $5aa677c457ee63c9$var$UNSCOPABLES = $5aa677c457ee63c9$var$wellKnownSymbol$c("unscopables");
var $5aa677c457ee63c9$var$ArrayPrototype$1 = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($5aa677c457ee63c9$var$ArrayPrototype$1[$5aa677c457ee63c9$var$UNSCOPABLES] == undefined) $5aa677c457ee63c9$var$defineProperty$3($5aa677c457ee63c9$var$ArrayPrototype$1, $5aa677c457ee63c9$var$UNSCOPABLES, {
    configurable: true,
    value: $5aa677c457ee63c9$var$create$1(null)
});
// add a key to Array.prototype[@@unscopables]
var $5aa677c457ee63c9$var$addToUnscopables$1 = function(key) {
    $5aa677c457ee63c9$var$ArrayPrototype$1[$5aa677c457ee63c9$var$UNSCOPABLES][key] = true;
};
var $5aa677c457ee63c9$var$iterators = {};
var $5aa677c457ee63c9$var$uncurryThis$6 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$isCallable$e = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$store$1 = $5aa677c457ee63c9$var$sharedStore;
var $5aa677c457ee63c9$var$functionToString = $5aa677c457ee63c9$var$uncurryThis$6(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$5aa677c457ee63c9$var$isCallable$e($5aa677c457ee63c9$var$store$1.inspectSource)) $5aa677c457ee63c9$var$store$1.inspectSource = function(it) {
    return $5aa677c457ee63c9$var$functionToString(it);
};
var $5aa677c457ee63c9$var$inspectSource$4 = $5aa677c457ee63c9$var$store$1.inspectSource;
var $5aa677c457ee63c9$var$global$c = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$isCallable$d = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$inspectSource$3 = $5aa677c457ee63c9$var$inspectSource$4;
var $5aa677c457ee63c9$var$WeakMap$1 = $5aa677c457ee63c9$var$global$c.WeakMap;
var $5aa677c457ee63c9$var$nativeWeakMap = $5aa677c457ee63c9$var$isCallable$d($5aa677c457ee63c9$var$WeakMap$1) && /native code/.test($5aa677c457ee63c9$var$inspectSource$3($5aa677c457ee63c9$var$WeakMap$1));
var $5aa677c457ee63c9$var$createPropertyDescriptor$3 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $5aa677c457ee63c9$var$DESCRIPTORS$5 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$definePropertyModule$3 = $5aa677c457ee63c9$var$objectDefineProperty;
var $5aa677c457ee63c9$var$createPropertyDescriptor$2 = $5aa677c457ee63c9$var$createPropertyDescriptor$3;
var $5aa677c457ee63c9$var$createNonEnumerableProperty$4 = $5aa677c457ee63c9$var$DESCRIPTORS$5 ? function(object, key, value) {
    return $5aa677c457ee63c9$var$definePropertyModule$3.f(object, key, $5aa677c457ee63c9$var$createPropertyDescriptor$2(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $5aa677c457ee63c9$var$NATIVE_WEAK_MAP = $5aa677c457ee63c9$var$nativeWeakMap;
var $5aa677c457ee63c9$var$global$b = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$uncurryThis$5 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$isObject$2 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$createNonEnumerableProperty$3 = $5aa677c457ee63c9$var$createNonEnumerableProperty$4;
var $5aa677c457ee63c9$var$hasOwn$8 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$shared = $5aa677c457ee63c9$var$sharedStore;
var $5aa677c457ee63c9$var$sharedKey$1 = $5aa677c457ee63c9$var$sharedKey$3;
var $5aa677c457ee63c9$var$hiddenKeys$1 = $5aa677c457ee63c9$var$hiddenKeys$4;
var $5aa677c457ee63c9$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $5aa677c457ee63c9$var$TypeError$2 = $5aa677c457ee63c9$var$global$b.TypeError;
var $5aa677c457ee63c9$var$WeakMap = $5aa677c457ee63c9$var$global$b.WeakMap;
var $5aa677c457ee63c9$var$set$1, $5aa677c457ee63c9$var$get, $5aa677c457ee63c9$var$has;
var $5aa677c457ee63c9$var$enforce = function(it) {
    return $5aa677c457ee63c9$var$has(it) ? $5aa677c457ee63c9$var$get(it) : $5aa677c457ee63c9$var$set$1(it, {});
};
var $5aa677c457ee63c9$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$5aa677c457ee63c9$var$isObject$2(it) || (state = $5aa677c457ee63c9$var$get(it)).type !== TYPE) throw $5aa677c457ee63c9$var$TypeError$2("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($5aa677c457ee63c9$var$NATIVE_WEAK_MAP || $5aa677c457ee63c9$var$shared.state) {
    var $5aa677c457ee63c9$var$store = $5aa677c457ee63c9$var$shared.state || ($5aa677c457ee63c9$var$shared.state = new $5aa677c457ee63c9$var$WeakMap());
    var $5aa677c457ee63c9$var$wmget = $5aa677c457ee63c9$var$uncurryThis$5($5aa677c457ee63c9$var$store.get);
    var $5aa677c457ee63c9$var$wmhas = $5aa677c457ee63c9$var$uncurryThis$5($5aa677c457ee63c9$var$store.has);
    var $5aa677c457ee63c9$var$wmset = $5aa677c457ee63c9$var$uncurryThis$5($5aa677c457ee63c9$var$store.set);
    $5aa677c457ee63c9$var$set$1 = function(it, metadata) {
        if ($5aa677c457ee63c9$var$wmhas($5aa677c457ee63c9$var$store, it)) throw new $5aa677c457ee63c9$var$TypeError$2($5aa677c457ee63c9$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5aa677c457ee63c9$var$wmset($5aa677c457ee63c9$var$store, it, metadata);
        return metadata;
    };
    $5aa677c457ee63c9$var$get = function(it) {
        return $5aa677c457ee63c9$var$wmget($5aa677c457ee63c9$var$store, it) || {};
    };
    $5aa677c457ee63c9$var$has = function(it) {
        return $5aa677c457ee63c9$var$wmhas($5aa677c457ee63c9$var$store, it);
    };
} else {
    var $5aa677c457ee63c9$var$STATE = $5aa677c457ee63c9$var$sharedKey$1("state");
    $5aa677c457ee63c9$var$hiddenKeys$1[$5aa677c457ee63c9$var$STATE] = true;
    $5aa677c457ee63c9$var$set$1 = function(it, metadata) {
        if ($5aa677c457ee63c9$var$hasOwn$8(it, $5aa677c457ee63c9$var$STATE)) throw new $5aa677c457ee63c9$var$TypeError$2($5aa677c457ee63c9$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5aa677c457ee63c9$var$createNonEnumerableProperty$3(it, $5aa677c457ee63c9$var$STATE, metadata);
        return metadata;
    };
    $5aa677c457ee63c9$var$get = function(it) {
        return $5aa677c457ee63c9$var$hasOwn$8(it, $5aa677c457ee63c9$var$STATE) ? it[$5aa677c457ee63c9$var$STATE] : {};
    };
    $5aa677c457ee63c9$var$has = function(it) {
        return $5aa677c457ee63c9$var$hasOwn$8(it, $5aa677c457ee63c9$var$STATE);
    };
}
var $5aa677c457ee63c9$var$internalState = {
    set: $5aa677c457ee63c9$var$set$1,
    get: $5aa677c457ee63c9$var$get,
    has: $5aa677c457ee63c9$var$has,
    enforce: $5aa677c457ee63c9$var$enforce,
    getterFor: $5aa677c457ee63c9$var$getterFor
};
var $5aa677c457ee63c9$var$objectGetOwnPropertyDescriptor = {};
var $5aa677c457ee63c9$var$objectPropertyIsEnumerable = {};
var $5aa677c457ee63c9$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5aa677c457ee63c9$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $5aa677c457ee63c9$var$NASHORN_BUG = $5aa677c457ee63c9$var$getOwnPropertyDescriptor$2 && !$5aa677c457ee63c9$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$5aa677c457ee63c9$var$objectPropertyIsEnumerable.f = $5aa677c457ee63c9$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $5aa677c457ee63c9$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $5aa677c457ee63c9$var$$propertyIsEnumerable;
var $5aa677c457ee63c9$var$DESCRIPTORS$4 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$call$a = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$propertyIsEnumerableModule = $5aa677c457ee63c9$var$objectPropertyIsEnumerable;
var $5aa677c457ee63c9$var$createPropertyDescriptor$1 = $5aa677c457ee63c9$var$createPropertyDescriptor$3;
var $5aa677c457ee63c9$var$toIndexedObject$1 = $5aa677c457ee63c9$var$toIndexedObject$5;
var $5aa677c457ee63c9$var$toPropertyKey = $5aa677c457ee63c9$var$toPropertyKey$2;
var $5aa677c457ee63c9$var$hasOwn$7 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$IE8_DOM_DEFINE = $5aa677c457ee63c9$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5aa677c457ee63c9$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$5aa677c457ee63c9$var$objectGetOwnPropertyDescriptor.f = $5aa677c457ee63c9$var$DESCRIPTORS$4 ? $5aa677c457ee63c9$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $5aa677c457ee63c9$var$toIndexedObject$1(O);
    P = $5aa677c457ee63c9$var$toPropertyKey(P);
    if ($5aa677c457ee63c9$var$IE8_DOM_DEFINE) try {
        return $5aa677c457ee63c9$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($5aa677c457ee63c9$var$hasOwn$7(O, P)) return $5aa677c457ee63c9$var$createPropertyDescriptor$1(!$5aa677c457ee63c9$var$call$a($5aa677c457ee63c9$var$propertyIsEnumerableModule.f, O, P), O[P]);
};
var $5aa677c457ee63c9$var$makeBuiltIn$2 = {
    exports: {}
};
var $5aa677c457ee63c9$var$DESCRIPTORS$3 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$hasOwn$6 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5aa677c457ee63c9$var$getDescriptor = $5aa677c457ee63c9$var$DESCRIPTORS$3 && Object.getOwnPropertyDescriptor;
var $5aa677c457ee63c9$var$EXISTS = $5aa677c457ee63c9$var$hasOwn$6($5aa677c457ee63c9$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $5aa677c457ee63c9$var$PROPER = $5aa677c457ee63c9$var$EXISTS && (function something() {}).name === "something";
var $5aa677c457ee63c9$var$CONFIGURABLE = $5aa677c457ee63c9$var$EXISTS && (!$5aa677c457ee63c9$var$DESCRIPTORS$3 || $5aa677c457ee63c9$var$DESCRIPTORS$3 && $5aa677c457ee63c9$var$getDescriptor($5aa677c457ee63c9$var$FunctionPrototype$1, "name").configurable);
var $5aa677c457ee63c9$var$functionName = {
    EXISTS: $5aa677c457ee63c9$var$EXISTS,
    PROPER: $5aa677c457ee63c9$var$PROPER,
    CONFIGURABLE: $5aa677c457ee63c9$var$CONFIGURABLE
};
var $5aa677c457ee63c9$var$fails$6 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$isCallable$c = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$hasOwn$5 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$DESCRIPTORS$2 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$CONFIGURABLE_FUNCTION_NAME$1 = $5aa677c457ee63c9$var$functionName.CONFIGURABLE;
var $5aa677c457ee63c9$var$inspectSource$2 = $5aa677c457ee63c9$var$inspectSource$4;
var $5aa677c457ee63c9$var$InternalStateModule$2 = $5aa677c457ee63c9$var$internalState;
var $5aa677c457ee63c9$var$enforceInternalState = $5aa677c457ee63c9$var$InternalStateModule$2.enforce;
var $5aa677c457ee63c9$var$getInternalState$1 = $5aa677c457ee63c9$var$InternalStateModule$2.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5aa677c457ee63c9$var$defineProperty$2 = Object.defineProperty;
var $5aa677c457ee63c9$var$CONFIGURABLE_LENGTH = $5aa677c457ee63c9$var$DESCRIPTORS$2 && !$5aa677c457ee63c9$var$fails$6(function() {
    return $5aa677c457ee63c9$var$defineProperty$2(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $5aa677c457ee63c9$var$TEMPLATE = String(String).split("String");
var $5aa677c457ee63c9$var$makeBuiltIn$1 = $5aa677c457ee63c9$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$5aa677c457ee63c9$var$hasOwn$5(value, "name") || $5aa677c457ee63c9$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($5aa677c457ee63c9$var$DESCRIPTORS$2) $5aa677c457ee63c9$var$defineProperty$2(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($5aa677c457ee63c9$var$CONFIGURABLE_LENGTH && options && $5aa677c457ee63c9$var$hasOwn$5(options, "arity") && value.length !== options.arity) $5aa677c457ee63c9$var$defineProperty$2(value, "length", {
        value: options.arity
    });
    try {
        if (options && $5aa677c457ee63c9$var$hasOwn$5(options, "constructor") && options.constructor) {
            if ($5aa677c457ee63c9$var$DESCRIPTORS$2) $5aa677c457ee63c9$var$defineProperty$2(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $5aa677c457ee63c9$var$enforceInternalState(value);
    if (!$5aa677c457ee63c9$var$hasOwn$5(state, "source")) state.source = $5aa677c457ee63c9$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $5aa677c457ee63c9$var$makeBuiltIn$1(function toString() {
    return $5aa677c457ee63c9$var$isCallable$c(this) && $5aa677c457ee63c9$var$getInternalState$1(this).source || $5aa677c457ee63c9$var$inspectSource$2(this);
}, "toString");
var $5aa677c457ee63c9$var$isCallable$b = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$definePropertyModule$2 = $5aa677c457ee63c9$var$objectDefineProperty;
var $5aa677c457ee63c9$var$makeBuiltIn = $5aa677c457ee63c9$var$makeBuiltIn$2.exports;
var $5aa677c457ee63c9$var$defineGlobalProperty$1 = $5aa677c457ee63c9$var$defineGlobalProperty$3;
var $5aa677c457ee63c9$var$defineBuiltIn$6 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($5aa677c457ee63c9$var$isCallable$b(value)) $5aa677c457ee63c9$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $5aa677c457ee63c9$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $5aa677c457ee63c9$var$definePropertyModule$2.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $5aa677c457ee63c9$var$objectGetOwnPropertyNames = {};
var $5aa677c457ee63c9$var$internalObjectKeys = $5aa677c457ee63c9$var$objectKeysInternal;
var $5aa677c457ee63c9$var$enumBugKeys = $5aa677c457ee63c9$var$enumBugKeys$3;
var $5aa677c457ee63c9$var$hiddenKeys = $5aa677c457ee63c9$var$enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$5aa677c457ee63c9$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $5aa677c457ee63c9$var$internalObjectKeys(O, $5aa677c457ee63c9$var$hiddenKeys);
};
var $5aa677c457ee63c9$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$5aa677c457ee63c9$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $5aa677c457ee63c9$var$getBuiltIn$4 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$uncurryThis$4 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$getOwnPropertyNamesModule = $5aa677c457ee63c9$var$objectGetOwnPropertyNames;
var $5aa677c457ee63c9$var$getOwnPropertySymbolsModule = $5aa677c457ee63c9$var$objectGetOwnPropertySymbols;
var $5aa677c457ee63c9$var$anObject$8 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$concat = $5aa677c457ee63c9$var$uncurryThis$4([].concat);
// all object keys, includes non-enumerable and symbols
var $5aa677c457ee63c9$var$ownKeys$1 = $5aa677c457ee63c9$var$getBuiltIn$4("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $5aa677c457ee63c9$var$getOwnPropertyNamesModule.f($5aa677c457ee63c9$var$anObject$8(it));
    var getOwnPropertySymbols = $5aa677c457ee63c9$var$getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? $5aa677c457ee63c9$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};
var $5aa677c457ee63c9$var$hasOwn$4 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$ownKeys = $5aa677c457ee63c9$var$ownKeys$1;
var $5aa677c457ee63c9$var$getOwnPropertyDescriptorModule = $5aa677c457ee63c9$var$objectGetOwnPropertyDescriptor;
var $5aa677c457ee63c9$var$definePropertyModule$1 = $5aa677c457ee63c9$var$objectDefineProperty;
var $5aa677c457ee63c9$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $5aa677c457ee63c9$var$ownKeys(source);
    var defineProperty = $5aa677c457ee63c9$var$definePropertyModule$1.f;
    var getOwnPropertyDescriptor = $5aa677c457ee63c9$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$5aa677c457ee63c9$var$hasOwn$4(target, key) && !(exceptions && $5aa677c457ee63c9$var$hasOwn$4(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $5aa677c457ee63c9$var$fails$5 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$isCallable$a = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$replacement = /#|\.prototype\./;
var $5aa677c457ee63c9$var$isForced$2 = function(feature, detection) {
    var value = $5aa677c457ee63c9$var$data[$5aa677c457ee63c9$var$normalize(feature)];
    return value == $5aa677c457ee63c9$var$POLYFILL ? true : value == $5aa677c457ee63c9$var$NATIVE ? false : $5aa677c457ee63c9$var$isCallable$a(detection) ? $5aa677c457ee63c9$var$fails$5(detection) : !!detection;
};
var $5aa677c457ee63c9$var$normalize = $5aa677c457ee63c9$var$isForced$2.normalize = function(string) {
    return String(string).replace($5aa677c457ee63c9$var$replacement, ".").toLowerCase();
};
var $5aa677c457ee63c9$var$data = $5aa677c457ee63c9$var$isForced$2.data = {};
var $5aa677c457ee63c9$var$NATIVE = $5aa677c457ee63c9$var$isForced$2.NATIVE = "N";
var $5aa677c457ee63c9$var$POLYFILL = $5aa677c457ee63c9$var$isForced$2.POLYFILL = "P";
var $5aa677c457ee63c9$var$isForced_1 = $5aa677c457ee63c9$var$isForced$2;
var $5aa677c457ee63c9$var$global$a = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$getOwnPropertyDescriptor$1 = $5aa677c457ee63c9$var$objectGetOwnPropertyDescriptor.f;
var $5aa677c457ee63c9$var$createNonEnumerableProperty$2 = $5aa677c457ee63c9$var$createNonEnumerableProperty$4;
var $5aa677c457ee63c9$var$defineBuiltIn$5 = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$defineGlobalProperty = $5aa677c457ee63c9$var$defineGlobalProperty$3;
var $5aa677c457ee63c9$var$copyConstructorProperties = $5aa677c457ee63c9$var$copyConstructorProperties$1;
var $5aa677c457ee63c9$var$isForced$1 = $5aa677c457ee63c9$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $5aa677c457ee63c9$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $5aa677c457ee63c9$var$global$a;
    else if (STATIC) target = $5aa677c457ee63c9$var$global$a[TARGET] || $5aa677c457ee63c9$var$defineGlobalProperty(TARGET, {});
    else target = ($5aa677c457ee63c9$var$global$a[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $5aa677c457ee63c9$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $5aa677c457ee63c9$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $5aa677c457ee63c9$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $5aa677c457ee63c9$var$createNonEnumerableProperty$2(sourceProperty, "sham", true);
        $5aa677c457ee63c9$var$defineBuiltIn$5(target, key, sourceProperty, options);
    }
};
var $5aa677c457ee63c9$var$fails$4 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$correctPrototypeGetter = !$5aa677c457ee63c9$var$fails$4(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $5aa677c457ee63c9$var$hasOwn$3 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$isCallable$9 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$toObject = $5aa677c457ee63c9$var$toObject$2;
var $5aa677c457ee63c9$var$sharedKey = $5aa677c457ee63c9$var$sharedKey$3;
var $5aa677c457ee63c9$var$CORRECT_PROTOTYPE_GETTER = $5aa677c457ee63c9$var$correctPrototypeGetter;
var $5aa677c457ee63c9$var$IE_PROTO = $5aa677c457ee63c9$var$sharedKey("IE_PROTO");
var $5aa677c457ee63c9$var$$Object$1 = Object;
var $5aa677c457ee63c9$var$ObjectPrototype = $5aa677c457ee63c9$var$$Object$1.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $5aa677c457ee63c9$var$objectGetPrototypeOf = $5aa677c457ee63c9$var$CORRECT_PROTOTYPE_GETTER ? $5aa677c457ee63c9$var$$Object$1.getPrototypeOf : function(O) {
    var object = $5aa677c457ee63c9$var$toObject(O);
    if ($5aa677c457ee63c9$var$hasOwn$3(object, $5aa677c457ee63c9$var$IE_PROTO)) return object[$5aa677c457ee63c9$var$IE_PROTO];
    var constructor = object.constructor;
    if ($5aa677c457ee63c9$var$isCallable$9(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $5aa677c457ee63c9$var$$Object$1 ? $5aa677c457ee63c9$var$ObjectPrototype : null;
};
var $5aa677c457ee63c9$var$fails$3 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$isCallable$8 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$getPrototypeOf$1 = $5aa677c457ee63c9$var$objectGetPrototypeOf;
var $5aa677c457ee63c9$var$defineBuiltIn$4 = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$wellKnownSymbol$b = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$ITERATOR$5 = $5aa677c457ee63c9$var$wellKnownSymbol$b("iterator");
var $5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $5aa677c457ee63c9$var$IteratorPrototype$2, $5aa677c457ee63c9$var$PrototypeOfArrayIteratorPrototype, $5aa677c457ee63c9$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $5aa677c457ee63c9$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $5aa677c457ee63c9$var$arrayIterator)) $5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $5aa677c457ee63c9$var$PrototypeOfArrayIteratorPrototype = $5aa677c457ee63c9$var$getPrototypeOf$1($5aa677c457ee63c9$var$getPrototypeOf$1($5aa677c457ee63c9$var$arrayIterator));
        if ($5aa677c457ee63c9$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $5aa677c457ee63c9$var$IteratorPrototype$2 = $5aa677c457ee63c9$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $5aa677c457ee63c9$var$NEW_ITERATOR_PROTOTYPE = $5aa677c457ee63c9$var$IteratorPrototype$2 == undefined || $5aa677c457ee63c9$var$fails$3(function() {
    var test = {};
    // FF44- legacy iterators case
    return $5aa677c457ee63c9$var$IteratorPrototype$2[$5aa677c457ee63c9$var$ITERATOR$5].call(test) !== test;
});
if ($5aa677c457ee63c9$var$NEW_ITERATOR_PROTOTYPE) $5aa677c457ee63c9$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$5aa677c457ee63c9$var$isCallable$8($5aa677c457ee63c9$var$IteratorPrototype$2[$5aa677c457ee63c9$var$ITERATOR$5])) $5aa677c457ee63c9$var$defineBuiltIn$4($5aa677c457ee63c9$var$IteratorPrototype$2, $5aa677c457ee63c9$var$ITERATOR$5, function() {
    return this;
});
var $5aa677c457ee63c9$var$iteratorsCore = {
    IteratorPrototype: $5aa677c457ee63c9$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS$1
};
var $5aa677c457ee63c9$var$defineProperty$1 = $5aa677c457ee63c9$var$objectDefineProperty.f;
var $5aa677c457ee63c9$var$hasOwn$2 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$wellKnownSymbol$a = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$TO_STRING_TAG$3 = $5aa677c457ee63c9$var$wellKnownSymbol$a("toStringTag");
var $5aa677c457ee63c9$var$setToStringTag$3 = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$5aa677c457ee63c9$var$hasOwn$2(target, $5aa677c457ee63c9$var$TO_STRING_TAG$3)) $5aa677c457ee63c9$var$defineProperty$1(target, $5aa677c457ee63c9$var$TO_STRING_TAG$3, {
        configurable: true,
        value: TAG
    });
};
var $5aa677c457ee63c9$var$IteratorPrototype$1 = $5aa677c457ee63c9$var$iteratorsCore.IteratorPrototype;
var $5aa677c457ee63c9$var$create = $5aa677c457ee63c9$var$objectCreate;
var $5aa677c457ee63c9$var$createPropertyDescriptor = $5aa677c457ee63c9$var$createPropertyDescriptor$3;
var $5aa677c457ee63c9$var$setToStringTag$2 = $5aa677c457ee63c9$var$setToStringTag$3;
var $5aa677c457ee63c9$var$Iterators$4 = $5aa677c457ee63c9$var$iterators;
var $5aa677c457ee63c9$var$returnThis$1 = function() {
    return this;
};
var $5aa677c457ee63c9$var$createIteratorConstructor$1 = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $5aa677c457ee63c9$var$create($5aa677c457ee63c9$var$IteratorPrototype$1, {
        next: $5aa677c457ee63c9$var$createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
    });
    $5aa677c457ee63c9$var$setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
    $5aa677c457ee63c9$var$Iterators$4[TO_STRING_TAG] = $5aa677c457ee63c9$var$returnThis$1;
    return IteratorConstructor;
};
var $5aa677c457ee63c9$var$isCallable$7 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$$String$1 = String;
var $5aa677c457ee63c9$var$$TypeError$5 = TypeError;
var $5aa677c457ee63c9$var$aPossiblePrototype$1 = function(argument) {
    if (typeof argument == "object" || $5aa677c457ee63c9$var$isCallable$7(argument)) return argument;
    throw $5aa677c457ee63c9$var$$TypeError$5("Can't set " + $5aa677c457ee63c9$var$$String$1(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $5aa677c457ee63c9$var$uncurryThis$3 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$anObject$7 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$aPossiblePrototype = $5aa677c457ee63c9$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $5aa677c457ee63c9$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $5aa677c457ee63c9$var$uncurryThis$3(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $5aa677c457ee63c9$var$anObject$7(O);
        $5aa677c457ee63c9$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $5aa677c457ee63c9$var$$$6 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$call$9 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$FunctionName = $5aa677c457ee63c9$var$functionName;
var $5aa677c457ee63c9$var$isCallable$6 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$createIteratorConstructor = $5aa677c457ee63c9$var$createIteratorConstructor$1;
var $5aa677c457ee63c9$var$getPrototypeOf = $5aa677c457ee63c9$var$objectGetPrototypeOf;
var $5aa677c457ee63c9$var$setPrototypeOf$1 = $5aa677c457ee63c9$var$objectSetPrototypeOf;
var $5aa677c457ee63c9$var$setToStringTag$1 = $5aa677c457ee63c9$var$setToStringTag$3;
var $5aa677c457ee63c9$var$createNonEnumerableProperty$1 = $5aa677c457ee63c9$var$createNonEnumerableProperty$4;
var $5aa677c457ee63c9$var$defineBuiltIn$3 = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$wellKnownSymbol$9 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$Iterators$3 = $5aa677c457ee63c9$var$iterators;
var $5aa677c457ee63c9$var$IteratorsCore = $5aa677c457ee63c9$var$iteratorsCore;
var $5aa677c457ee63c9$var$PROPER_FUNCTION_NAME$1 = $5aa677c457ee63c9$var$FunctionName.PROPER;
var $5aa677c457ee63c9$var$CONFIGURABLE_FUNCTION_NAME = $5aa677c457ee63c9$var$FunctionName.CONFIGURABLE;
var $5aa677c457ee63c9$var$IteratorPrototype = $5aa677c457ee63c9$var$IteratorsCore.IteratorPrototype;
var $5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS = $5aa677c457ee63c9$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $5aa677c457ee63c9$var$ITERATOR$4 = $5aa677c457ee63c9$var$wellKnownSymbol$9("iterator");
var $5aa677c457ee63c9$var$KEYS = "keys";
var $5aa677c457ee63c9$var$VALUES = "values";
var $5aa677c457ee63c9$var$ENTRIES = "entries";
var $5aa677c457ee63c9$var$returnThis = function() {
    return this;
};
var $5aa677c457ee63c9$var$defineIterator$1 = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $5aa677c457ee63c9$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $5aa677c457ee63c9$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $5aa677c457ee63c9$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $5aa677c457ee63c9$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$5aa677c457ee63c9$var$ITERATOR$4] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $5aa677c457ee63c9$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($5aa677c457ee63c9$var$getPrototypeOf(CurrentIteratorPrototype) !== $5aa677c457ee63c9$var$IteratorPrototype) {
                if ($5aa677c457ee63c9$var$setPrototypeOf$1) $5aa677c457ee63c9$var$setPrototypeOf$1(CurrentIteratorPrototype, $5aa677c457ee63c9$var$IteratorPrototype);
                else if (!$5aa677c457ee63c9$var$isCallable$6(CurrentIteratorPrototype[$5aa677c457ee63c9$var$ITERATOR$4])) $5aa677c457ee63c9$var$defineBuiltIn$3(CurrentIteratorPrototype, $5aa677c457ee63c9$var$ITERATOR$4, $5aa677c457ee63c9$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $5aa677c457ee63c9$var$setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($5aa677c457ee63c9$var$PROPER_FUNCTION_NAME$1 && DEFAULT == $5aa677c457ee63c9$var$VALUES && nativeIterator && nativeIterator.name !== $5aa677c457ee63c9$var$VALUES) {
        if ($5aa677c457ee63c9$var$CONFIGURABLE_FUNCTION_NAME) $5aa677c457ee63c9$var$createNonEnumerableProperty$1(IterablePrototype, "name", $5aa677c457ee63c9$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $5aa677c457ee63c9$var$call$9(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($5aa677c457ee63c9$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($5aa677c457ee63c9$var$KEYS),
            entries: getIterationMethod($5aa677c457ee63c9$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $5aa677c457ee63c9$var$defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
        } else $5aa677c457ee63c9$var$$$6({
            target: NAME,
            proto: true,
            forced: $5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$5aa677c457ee63c9$var$ITERATOR$4] !== defaultIterator) $5aa677c457ee63c9$var$defineBuiltIn$3(IterablePrototype, $5aa677c457ee63c9$var$ITERATOR$4, defaultIterator, {
        name: DEFAULT
    });
    $5aa677c457ee63c9$var$Iterators$3[NAME] = defaultIterator;
    return methods;
};
var $5aa677c457ee63c9$var$toIndexedObject = $5aa677c457ee63c9$var$toIndexedObject$5;
var $5aa677c457ee63c9$var$addToUnscopables = $5aa677c457ee63c9$var$addToUnscopables$1;
var $5aa677c457ee63c9$var$Iterators$2 = $5aa677c457ee63c9$var$iterators;
var $5aa677c457ee63c9$var$InternalStateModule$1 = $5aa677c457ee63c9$var$internalState;
var $5aa677c457ee63c9$var$defineProperty = $5aa677c457ee63c9$var$objectDefineProperty.f;
var $5aa677c457ee63c9$var$defineIterator = $5aa677c457ee63c9$var$defineIterator$1;
var $5aa677c457ee63c9$var$DESCRIPTORS$1 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$ARRAY_ITERATOR = "Array Iterator";
var $5aa677c457ee63c9$var$setInternalState$1 = $5aa677c457ee63c9$var$InternalStateModule$1.set;
var $5aa677c457ee63c9$var$getInternalState = $5aa677c457ee63c9$var$InternalStateModule$1.getterFor($5aa677c457ee63c9$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $5aa677c457ee63c9$var$es_array_iterator = $5aa677c457ee63c9$var$defineIterator(Array, "Array", function(iterated, kind) {
    $5aa677c457ee63c9$var$setInternalState$1(this, {
        type: $5aa677c457ee63c9$var$ARRAY_ITERATOR,
        target: $5aa677c457ee63c9$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $5aa677c457ee63c9$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $5aa677c457ee63c9$var$values = $5aa677c457ee63c9$var$Iterators$2.Arguments = $5aa677c457ee63c9$var$Iterators$2.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$5aa677c457ee63c9$var$addToUnscopables("keys");
$5aa677c457ee63c9$var$addToUnscopables("values");
$5aa677c457ee63c9$var$addToUnscopables("entries");
// V8 ~ Chrome 45- bug
if ($5aa677c457ee63c9$var$DESCRIPTORS$1 && $5aa677c457ee63c9$var$values.name !== "values") try {
    $5aa677c457ee63c9$var$defineProperty($5aa677c457ee63c9$var$values, "name", {
        value: "values"
    });
} catch (error) {}
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $5aa677c457ee63c9$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $5aa677c457ee63c9$var$documentCreateElement = $5aa677c457ee63c9$var$documentCreateElement$2;
var $5aa677c457ee63c9$var$classList = $5aa677c457ee63c9$var$documentCreateElement("span").classList;
var $5aa677c457ee63c9$var$DOMTokenListPrototype$1 = $5aa677c457ee63c9$var$classList && $5aa677c457ee63c9$var$classList.constructor && $5aa677c457ee63c9$var$classList.constructor.prototype;
var $5aa677c457ee63c9$var$domTokenListPrototype = $5aa677c457ee63c9$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $5aa677c457ee63c9$var$DOMTokenListPrototype$1;
var $5aa677c457ee63c9$var$global$9 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$DOMIterables = $5aa677c457ee63c9$var$domIterables;
var $5aa677c457ee63c9$var$DOMTokenListPrototype = $5aa677c457ee63c9$var$domTokenListPrototype;
var $5aa677c457ee63c9$var$ArrayIteratorMethods = $5aa677c457ee63c9$var$es_array_iterator;
var $5aa677c457ee63c9$var$createNonEnumerableProperty = $5aa677c457ee63c9$var$createNonEnumerableProperty$4;
var $5aa677c457ee63c9$var$wellKnownSymbol$8 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$ITERATOR$3 = $5aa677c457ee63c9$var$wellKnownSymbol$8("iterator");
var $5aa677c457ee63c9$var$TO_STRING_TAG$2 = $5aa677c457ee63c9$var$wellKnownSymbol$8("toStringTag");
var $5aa677c457ee63c9$var$ArrayValues = $5aa677c457ee63c9$var$ArrayIteratorMethods.values;
var $5aa677c457ee63c9$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$5aa677c457ee63c9$var$ITERATOR$3] !== $5aa677c457ee63c9$var$ArrayValues) try {
            $5aa677c457ee63c9$var$createNonEnumerableProperty(CollectionPrototype, $5aa677c457ee63c9$var$ITERATOR$3, $5aa677c457ee63c9$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$5aa677c457ee63c9$var$ITERATOR$3] = $5aa677c457ee63c9$var$ArrayValues;
        }
        if (!CollectionPrototype[$5aa677c457ee63c9$var$TO_STRING_TAG$2]) $5aa677c457ee63c9$var$createNonEnumerableProperty(CollectionPrototype, $5aa677c457ee63c9$var$TO_STRING_TAG$2, COLLECTION_NAME);
        if ($5aa677c457ee63c9$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $5aa677c457ee63c9$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $5aa677c457ee63c9$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $5aa677c457ee63c9$var$createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, $5aa677c457ee63c9$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $5aa677c457ee63c9$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $5aa677c457ee63c9$var$COLLECTION_NAME in $5aa677c457ee63c9$var$DOMIterables)$5aa677c457ee63c9$var$handlePrototype($5aa677c457ee63c9$var$global$9[$5aa677c457ee63c9$var$COLLECTION_NAME] && $5aa677c457ee63c9$var$global$9[$5aa677c457ee63c9$var$COLLECTION_NAME].prototype, $5aa677c457ee63c9$var$COLLECTION_NAME);
$5aa677c457ee63c9$var$handlePrototype($5aa677c457ee63c9$var$DOMTokenListPrototype, "DOMTokenList");
var $5aa677c457ee63c9$var$classof$4 = $5aa677c457ee63c9$var$classofRaw$1;
var $5aa677c457ee63c9$var$global$8 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$engineIsNode = $5aa677c457ee63c9$var$classof$4($5aa677c457ee63c9$var$global$8.process) == "process";
var $5aa677c457ee63c9$var$getBuiltIn$3 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$definePropertyModule = $5aa677c457ee63c9$var$objectDefineProperty;
var $5aa677c457ee63c9$var$wellKnownSymbol$7 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$DESCRIPTORS = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$SPECIES$2 = $5aa677c457ee63c9$var$wellKnownSymbol$7("species");
var $5aa677c457ee63c9$var$setSpecies$1 = function(CONSTRUCTOR_NAME) {
    var Constructor = $5aa677c457ee63c9$var$getBuiltIn$3(CONSTRUCTOR_NAME);
    var defineProperty = $5aa677c457ee63c9$var$definePropertyModule.f;
    if ($5aa677c457ee63c9$var$DESCRIPTORS && Constructor && !Constructor[$5aa677c457ee63c9$var$SPECIES$2]) defineProperty(Constructor, $5aa677c457ee63c9$var$SPECIES$2, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};
var $5aa677c457ee63c9$var$isPrototypeOf$2 = $5aa677c457ee63c9$var$objectIsPrototypeOf;
var $5aa677c457ee63c9$var$$TypeError$4 = TypeError;
var $5aa677c457ee63c9$var$anInstance$1 = function(it, Prototype) {
    if ($5aa677c457ee63c9$var$isPrototypeOf$2(Prototype, it)) return it;
    throw $5aa677c457ee63c9$var$$TypeError$4("Incorrect invocation");
};
var $5aa677c457ee63c9$var$wellKnownSymbol$6 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$TO_STRING_TAG$1 = $5aa677c457ee63c9$var$wellKnownSymbol$6("toStringTag");
var $5aa677c457ee63c9$var$test = {};
$5aa677c457ee63c9$var$test[$5aa677c457ee63c9$var$TO_STRING_TAG$1] = "z";
var $5aa677c457ee63c9$var$toStringTagSupport = String($5aa677c457ee63c9$var$test) === "[object z]";
var $5aa677c457ee63c9$var$TO_STRING_TAG_SUPPORT = $5aa677c457ee63c9$var$toStringTagSupport;
var $5aa677c457ee63c9$var$isCallable$5 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$classofRaw = $5aa677c457ee63c9$var$classofRaw$1;
var $5aa677c457ee63c9$var$wellKnownSymbol$5 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$TO_STRING_TAG = $5aa677c457ee63c9$var$wellKnownSymbol$5("toStringTag");
var $5aa677c457ee63c9$var$$Object = Object;
// ES3 wrong here
var $5aa677c457ee63c9$var$CORRECT_ARGUMENTS = $5aa677c457ee63c9$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $5aa677c457ee63c9$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $5aa677c457ee63c9$var$classof$3 = $5aa677c457ee63c9$var$TO_STRING_TAG_SUPPORT ? $5aa677c457ee63c9$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $5aa677c457ee63c9$var$tryGet(O = $5aa677c457ee63c9$var$$Object(it), $5aa677c457ee63c9$var$TO_STRING_TAG)) == "string" ? tag : $5aa677c457ee63c9$var$CORRECT_ARGUMENTS ? $5aa677c457ee63c9$var$classofRaw(O) : (result = $5aa677c457ee63c9$var$classofRaw(O)) == "Object" && $5aa677c457ee63c9$var$isCallable$5(O.callee) ? "Arguments" : result;
};
var $5aa677c457ee63c9$var$uncurryThis$2 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$fails$2 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$isCallable$4 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$classof$2 = $5aa677c457ee63c9$var$classof$3;
var $5aa677c457ee63c9$var$getBuiltIn$2 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$inspectSource$1 = $5aa677c457ee63c9$var$inspectSource$4;
var $5aa677c457ee63c9$var$noop = function() {};
var $5aa677c457ee63c9$var$empty = [];
var $5aa677c457ee63c9$var$construct = $5aa677c457ee63c9$var$getBuiltIn$2("Reflect", "construct");
var $5aa677c457ee63c9$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $5aa677c457ee63c9$var$exec = $5aa677c457ee63c9$var$uncurryThis$2($5aa677c457ee63c9$var$constructorRegExp.exec);
var $5aa677c457ee63c9$var$INCORRECT_TO_STRING = !$5aa677c457ee63c9$var$constructorRegExp.exec($5aa677c457ee63c9$var$noop);
var $5aa677c457ee63c9$var$isConstructorModern = function isConstructor(argument) {
    if (!$5aa677c457ee63c9$var$isCallable$4(argument)) return false;
    try {
        $5aa677c457ee63c9$var$construct($5aa677c457ee63c9$var$noop, $5aa677c457ee63c9$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $5aa677c457ee63c9$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$5aa677c457ee63c9$var$isCallable$4(argument)) return false;
    switch($5aa677c457ee63c9$var$classof$2(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $5aa677c457ee63c9$var$INCORRECT_TO_STRING || !!$5aa677c457ee63c9$var$exec($5aa677c457ee63c9$var$constructorRegExp, $5aa677c457ee63c9$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$5aa677c457ee63c9$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $5aa677c457ee63c9$var$isConstructor$1 = !$5aa677c457ee63c9$var$construct || $5aa677c457ee63c9$var$fails$2(function() {
    var called;
    return $5aa677c457ee63c9$var$isConstructorModern($5aa677c457ee63c9$var$isConstructorModern.call) || !$5aa677c457ee63c9$var$isConstructorModern(Object) || !$5aa677c457ee63c9$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $5aa677c457ee63c9$var$isConstructorLegacy : $5aa677c457ee63c9$var$isConstructorModern;
var $5aa677c457ee63c9$var$isConstructor = $5aa677c457ee63c9$var$isConstructor$1;
var $5aa677c457ee63c9$var$tryToString$2 = $5aa677c457ee63c9$var$tryToString$4;
var $5aa677c457ee63c9$var$$TypeError$3 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $5aa677c457ee63c9$var$aConstructor$1 = function(argument) {
    if ($5aa677c457ee63c9$var$isConstructor(argument)) return argument;
    throw $5aa677c457ee63c9$var$$TypeError$3($5aa677c457ee63c9$var$tryToString$2(argument) + " is not a constructor");
};
var $5aa677c457ee63c9$var$anObject$6 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$aConstructor = $5aa677c457ee63c9$var$aConstructor$1;
var $5aa677c457ee63c9$var$wellKnownSymbol$4 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$SPECIES$1 = $5aa677c457ee63c9$var$wellKnownSymbol$4("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $5aa677c457ee63c9$var$speciesConstructor$1 = function(O, defaultConstructor) {
    var C = $5aa677c457ee63c9$var$anObject$6(O).constructor;
    var S;
    return C === undefined || (S = $5aa677c457ee63c9$var$anObject$6(C)[$5aa677c457ee63c9$var$SPECIES$1]) == undefined ? defaultConstructor : $5aa677c457ee63c9$var$aConstructor(S);
};
var $5aa677c457ee63c9$var$NATIVE_BIND$1 = $5aa677c457ee63c9$var$functionBindNative;
var $5aa677c457ee63c9$var$FunctionPrototype = Function.prototype;
var $5aa677c457ee63c9$var$apply$1 = $5aa677c457ee63c9$var$FunctionPrototype.apply;
var $5aa677c457ee63c9$var$call$8 = $5aa677c457ee63c9$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $5aa677c457ee63c9$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($5aa677c457ee63c9$var$NATIVE_BIND$1 ? $5aa677c457ee63c9$var$call$8.bind($5aa677c457ee63c9$var$apply$1) : function() {
    return $5aa677c457ee63c9$var$call$8.apply($5aa677c457ee63c9$var$apply$1, arguments);
});
var $5aa677c457ee63c9$var$uncurryThis$1 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$aCallable$5 = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$NATIVE_BIND = $5aa677c457ee63c9$var$functionBindNative;
var $5aa677c457ee63c9$var$bind$4 = $5aa677c457ee63c9$var$uncurryThis$1($5aa677c457ee63c9$var$uncurryThis$1.bind);
// optional / simple context binding
var $5aa677c457ee63c9$var$functionBindContext = function(fn, that) {
    $5aa677c457ee63c9$var$aCallable$5(fn);
    return that === undefined ? fn : $5aa677c457ee63c9$var$NATIVE_BIND ? $5aa677c457ee63c9$var$bind$4(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $5aa677c457ee63c9$var$uncurryThis = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$arraySlice$1 = $5aa677c457ee63c9$var$uncurryThis([].slice);
var $5aa677c457ee63c9$var$$TypeError$2 = TypeError;
var $5aa677c457ee63c9$var$validateArgumentsLength$1 = function(passed, required) {
    if (passed < required) throw $5aa677c457ee63c9$var$$TypeError$2("Not enough arguments");
    return passed;
};
var $5aa677c457ee63c9$var$userAgent$2 = $5aa677c457ee63c9$var$engineUserAgent;
var $5aa677c457ee63c9$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($5aa677c457ee63c9$var$userAgent$2);
var $5aa677c457ee63c9$var$global$7 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$apply = $5aa677c457ee63c9$var$functionApply;
var $5aa677c457ee63c9$var$bind$3 = $5aa677c457ee63c9$var$functionBindContext;
var $5aa677c457ee63c9$var$isCallable$3 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$hasOwn$1 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$fails$1 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$html = $5aa677c457ee63c9$var$html$2;
var $5aa677c457ee63c9$var$arraySlice = $5aa677c457ee63c9$var$arraySlice$1;
var $5aa677c457ee63c9$var$createElement = $5aa677c457ee63c9$var$documentCreateElement$2;
var $5aa677c457ee63c9$var$validateArgumentsLength = $5aa677c457ee63c9$var$validateArgumentsLength$1;
var $5aa677c457ee63c9$var$IS_IOS$1 = $5aa677c457ee63c9$var$engineIsIos;
var $5aa677c457ee63c9$var$IS_NODE$2 = $5aa677c457ee63c9$var$engineIsNode;
var $5aa677c457ee63c9$var$set = $5aa677c457ee63c9$var$global$7.setImmediate;
var $5aa677c457ee63c9$var$clear = $5aa677c457ee63c9$var$global$7.clearImmediate;
var $5aa677c457ee63c9$var$process$2 = $5aa677c457ee63c9$var$global$7.process;
var $5aa677c457ee63c9$var$Dispatch = $5aa677c457ee63c9$var$global$7.Dispatch;
var $5aa677c457ee63c9$var$Function$1 = $5aa677c457ee63c9$var$global$7.Function;
var $5aa677c457ee63c9$var$MessageChannel = $5aa677c457ee63c9$var$global$7.MessageChannel;
var $5aa677c457ee63c9$var$String$1 = $5aa677c457ee63c9$var$global$7.String;
var $5aa677c457ee63c9$var$counter = 0;
var $5aa677c457ee63c9$var$queue$1 = {};
var $5aa677c457ee63c9$var$ONREADYSTATECHANGE = "onreadystatechange";
var $5aa677c457ee63c9$var$location, $5aa677c457ee63c9$var$defer, $5aa677c457ee63c9$var$channel, $5aa677c457ee63c9$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $5aa677c457ee63c9$var$location = $5aa677c457ee63c9$var$global$7.location;
} catch (error) {}
var $5aa677c457ee63c9$var$run = function(id) {
    if ($5aa677c457ee63c9$var$hasOwn$1($5aa677c457ee63c9$var$queue$1, id)) {
        var fn = $5aa677c457ee63c9$var$queue$1[id];
        delete $5aa677c457ee63c9$var$queue$1[id];
        fn();
    }
};
var $5aa677c457ee63c9$var$runner = function(id) {
    return function() {
        $5aa677c457ee63c9$var$run(id);
    };
};
var $5aa677c457ee63c9$var$listener = function(event) {
    $5aa677c457ee63c9$var$run(event.data);
};
var $5aa677c457ee63c9$var$post = function(id) {
    // old engines have not location.origin
    $5aa677c457ee63c9$var$global$7.postMessage($5aa677c457ee63c9$var$String$1(id), $5aa677c457ee63c9$var$location.protocol + "//" + $5aa677c457ee63c9$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$5aa677c457ee63c9$var$set || !$5aa677c457ee63c9$var$clear) {
    $5aa677c457ee63c9$var$set = function setImmediate(handler) {
        $5aa677c457ee63c9$var$validateArgumentsLength(arguments.length, 1);
        var fn = $5aa677c457ee63c9$var$isCallable$3(handler) ? handler : $5aa677c457ee63c9$var$Function$1(handler);
        var args = $5aa677c457ee63c9$var$arraySlice(arguments, 1);
        $5aa677c457ee63c9$var$queue$1[++$5aa677c457ee63c9$var$counter] = function() {
            $5aa677c457ee63c9$var$apply(fn, undefined, args);
        };
        $5aa677c457ee63c9$var$defer($5aa677c457ee63c9$var$counter);
        return $5aa677c457ee63c9$var$counter;
    };
    $5aa677c457ee63c9$var$clear = function clearImmediate(id) {
        delete $5aa677c457ee63c9$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($5aa677c457ee63c9$var$IS_NODE$2) $5aa677c457ee63c9$var$defer = function(id) {
        $5aa677c457ee63c9$var$process$2.nextTick($5aa677c457ee63c9$var$runner(id));
    };
    else if ($5aa677c457ee63c9$var$Dispatch && $5aa677c457ee63c9$var$Dispatch.now) $5aa677c457ee63c9$var$defer = function(id) {
        $5aa677c457ee63c9$var$Dispatch.now($5aa677c457ee63c9$var$runner(id));
    };
    else if ($5aa677c457ee63c9$var$MessageChannel && !$5aa677c457ee63c9$var$IS_IOS$1) {
        $5aa677c457ee63c9$var$channel = new $5aa677c457ee63c9$var$MessageChannel();
        $5aa677c457ee63c9$var$port = $5aa677c457ee63c9$var$channel.port2;
        $5aa677c457ee63c9$var$channel.port1.onmessage = $5aa677c457ee63c9$var$listener;
        $5aa677c457ee63c9$var$defer = $5aa677c457ee63c9$var$bind$3($5aa677c457ee63c9$var$port.postMessage, $5aa677c457ee63c9$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($5aa677c457ee63c9$var$global$7.addEventListener && $5aa677c457ee63c9$var$isCallable$3($5aa677c457ee63c9$var$global$7.postMessage) && !$5aa677c457ee63c9$var$global$7.importScripts && $5aa677c457ee63c9$var$location && $5aa677c457ee63c9$var$location.protocol !== "file:" && !$5aa677c457ee63c9$var$fails$1($5aa677c457ee63c9$var$post)) {
        $5aa677c457ee63c9$var$defer = $5aa677c457ee63c9$var$post;
        $5aa677c457ee63c9$var$global$7.addEventListener("message", $5aa677c457ee63c9$var$listener, false);
    // IE8-
    } else if ($5aa677c457ee63c9$var$ONREADYSTATECHANGE in $5aa677c457ee63c9$var$createElement("script")) $5aa677c457ee63c9$var$defer = function(id) {
        $5aa677c457ee63c9$var$html.appendChild($5aa677c457ee63c9$var$createElement("script"))[$5aa677c457ee63c9$var$ONREADYSTATECHANGE] = function() {
            $5aa677c457ee63c9$var$html.removeChild(this);
            $5aa677c457ee63c9$var$run(id);
        };
    };
    else $5aa677c457ee63c9$var$defer = function(id) {
        setTimeout($5aa677c457ee63c9$var$runner(id), 0);
    };
}
var $5aa677c457ee63c9$var$task$1 = {
    set: $5aa677c457ee63c9$var$set,
    clear: $5aa677c457ee63c9$var$clear
};
var $5aa677c457ee63c9$var$userAgent$1 = $5aa677c457ee63c9$var$engineUserAgent;
var $5aa677c457ee63c9$var$global$6 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($5aa677c457ee63c9$var$userAgent$1) && $5aa677c457ee63c9$var$global$6.Pebble !== undefined;
var $5aa677c457ee63c9$var$userAgent = $5aa677c457ee63c9$var$engineUserAgent;
var $5aa677c457ee63c9$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($5aa677c457ee63c9$var$userAgent);
var $5aa677c457ee63c9$var$global$5 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$bind$2 = $5aa677c457ee63c9$var$functionBindContext;
var $5aa677c457ee63c9$var$getOwnPropertyDescriptor = $5aa677c457ee63c9$var$objectGetOwnPropertyDescriptor.f;
var $5aa677c457ee63c9$var$macrotask = $5aa677c457ee63c9$var$task$1.set;
var $5aa677c457ee63c9$var$IS_IOS = $5aa677c457ee63c9$var$engineIsIos;
var $5aa677c457ee63c9$var$IS_IOS_PEBBLE = $5aa677c457ee63c9$var$engineIsIosPebble;
var $5aa677c457ee63c9$var$IS_WEBOS_WEBKIT = $5aa677c457ee63c9$var$engineIsWebosWebkit;
var $5aa677c457ee63c9$var$IS_NODE$1 = $5aa677c457ee63c9$var$engineIsNode;
var $5aa677c457ee63c9$var$MutationObserver = $5aa677c457ee63c9$var$global$5.MutationObserver || $5aa677c457ee63c9$var$global$5.WebKitMutationObserver;
var $5aa677c457ee63c9$var$document$2 = $5aa677c457ee63c9$var$global$5.document;
var $5aa677c457ee63c9$var$process$1 = $5aa677c457ee63c9$var$global$5.process;
var $5aa677c457ee63c9$var$Promise$1 = $5aa677c457ee63c9$var$global$5.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $5aa677c457ee63c9$var$queueMicrotaskDescriptor = $5aa677c457ee63c9$var$getOwnPropertyDescriptor($5aa677c457ee63c9$var$global$5, "queueMicrotask");
var $5aa677c457ee63c9$var$queueMicrotask = $5aa677c457ee63c9$var$queueMicrotaskDescriptor && $5aa677c457ee63c9$var$queueMicrotaskDescriptor.value;
var $5aa677c457ee63c9$var$flush, $5aa677c457ee63c9$var$head, $5aa677c457ee63c9$var$last, $5aa677c457ee63c9$var$notify$1, $5aa677c457ee63c9$var$toggle, $5aa677c457ee63c9$var$node, $5aa677c457ee63c9$var$promise, $5aa677c457ee63c9$var$then;
// modern engines have queueMicrotask method
if (!$5aa677c457ee63c9$var$queueMicrotask) {
    $5aa677c457ee63c9$var$flush = function() {
        var parent, fn;
        if ($5aa677c457ee63c9$var$IS_NODE$1 && (parent = $5aa677c457ee63c9$var$process$1.domain)) parent.exit();
        while($5aa677c457ee63c9$var$head){
            fn = $5aa677c457ee63c9$var$head.fn;
            $5aa677c457ee63c9$var$head = $5aa677c457ee63c9$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($5aa677c457ee63c9$var$head) $5aa677c457ee63c9$var$notify$1();
                else $5aa677c457ee63c9$var$last = undefined;
                throw error;
            }
        }
        $5aa677c457ee63c9$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$5aa677c457ee63c9$var$IS_IOS && !$5aa677c457ee63c9$var$IS_NODE$1 && !$5aa677c457ee63c9$var$IS_WEBOS_WEBKIT && $5aa677c457ee63c9$var$MutationObserver && $5aa677c457ee63c9$var$document$2) {
        $5aa677c457ee63c9$var$toggle = true;
        $5aa677c457ee63c9$var$node = $5aa677c457ee63c9$var$document$2.createTextNode("");
        new $5aa677c457ee63c9$var$MutationObserver($5aa677c457ee63c9$var$flush).observe($5aa677c457ee63c9$var$node, {
            characterData: true
        });
        $5aa677c457ee63c9$var$notify$1 = function() {
            $5aa677c457ee63c9$var$node.data = $5aa677c457ee63c9$var$toggle = !$5aa677c457ee63c9$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$5aa677c457ee63c9$var$IS_IOS_PEBBLE && $5aa677c457ee63c9$var$Promise$1 && $5aa677c457ee63c9$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $5aa677c457ee63c9$var$promise = $5aa677c457ee63c9$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $5aa677c457ee63c9$var$promise.constructor = $5aa677c457ee63c9$var$Promise$1;
        $5aa677c457ee63c9$var$then = $5aa677c457ee63c9$var$bind$2($5aa677c457ee63c9$var$promise.then, $5aa677c457ee63c9$var$promise);
        $5aa677c457ee63c9$var$notify$1 = function() {
            $5aa677c457ee63c9$var$then($5aa677c457ee63c9$var$flush);
        };
    // Node.js without promises
    } else if ($5aa677c457ee63c9$var$IS_NODE$1) $5aa677c457ee63c9$var$notify$1 = function() {
        $5aa677c457ee63c9$var$process$1.nextTick($5aa677c457ee63c9$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $5aa677c457ee63c9$var$macrotask = $5aa677c457ee63c9$var$bind$2($5aa677c457ee63c9$var$macrotask, $5aa677c457ee63c9$var$global$5);
        $5aa677c457ee63c9$var$notify$1 = function() {
            $5aa677c457ee63c9$var$macrotask($5aa677c457ee63c9$var$flush);
        };
    }
}
var $5aa677c457ee63c9$var$microtask$1 = $5aa677c457ee63c9$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($5aa677c457ee63c9$var$last) $5aa677c457ee63c9$var$last.next = task;
    if (!$5aa677c457ee63c9$var$head) {
        $5aa677c457ee63c9$var$head = task;
        $5aa677c457ee63c9$var$notify$1();
    }
    $5aa677c457ee63c9$var$last = task;
};
var $5aa677c457ee63c9$var$global$4 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$hostReportErrors$1 = function(a, b) {
    var console = $5aa677c457ee63c9$var$global$4.console;
    if (console && console.error) arguments.length == 1 ? console.error(a) : console.error(a, b);
};
var $5aa677c457ee63c9$var$perform$3 = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $5aa677c457ee63c9$var$Queue$1 = function() {
    this.head = null;
    this.tail = null;
};
$5aa677c457ee63c9$var$Queue$1.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $5aa677c457ee63c9$var$queue = $5aa677c457ee63c9$var$Queue$1;
var $5aa677c457ee63c9$var$global$3 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$promiseNativeConstructor = $5aa677c457ee63c9$var$global$3.Promise;
var $5aa677c457ee63c9$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $5aa677c457ee63c9$var$global$2 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$NativePromiseConstructor$3 = $5aa677c457ee63c9$var$promiseNativeConstructor;
var $5aa677c457ee63c9$var$isCallable$2 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$isForced = $5aa677c457ee63c9$var$isForced_1;
var $5aa677c457ee63c9$var$inspectSource = $5aa677c457ee63c9$var$inspectSource$4;
var $5aa677c457ee63c9$var$wellKnownSymbol$3 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$IS_BROWSER = $5aa677c457ee63c9$var$engineIsBrowser;
var $5aa677c457ee63c9$var$V8_VERSION = $5aa677c457ee63c9$var$engineV8Version;
$5aa677c457ee63c9$var$NativePromiseConstructor$3 && $5aa677c457ee63c9$var$NativePromiseConstructor$3.prototype;
var $5aa677c457ee63c9$var$SPECIES = $5aa677c457ee63c9$var$wellKnownSymbol$3("species");
var $5aa677c457ee63c9$var$SUBCLASSING = false;
var $5aa677c457ee63c9$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $5aa677c457ee63c9$var$isCallable$2($5aa677c457ee63c9$var$global$2.PromiseRejectionEvent);
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$5 = $5aa677c457ee63c9$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $5aa677c457ee63c9$var$inspectSource($5aa677c457ee63c9$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($5aa677c457ee63c9$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $5aa677c457ee63c9$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($5aa677c457ee63c9$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $5aa677c457ee63c9$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$5aa677c457ee63c9$var$SPECIES] = FakePromise;
    $5aa677c457ee63c9$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$5aa677c457ee63c9$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $5aa677c457ee63c9$var$IS_BROWSER && !$5aa677c457ee63c9$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $5aa677c457ee63c9$var$promiseConstructorDetection = {
    CONSTRUCTOR: $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $5aa677c457ee63c9$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $5aa677c457ee63c9$var$SUBCLASSING
};
var $5aa677c457ee63c9$var$newPromiseCapability$2 = {};
var $5aa677c457ee63c9$var$aCallable$4 = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $5aa677c457ee63c9$var$aCallable$4(resolve);
    this.reject = $5aa677c457ee63c9$var$aCallable$4(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$5aa677c457ee63c9$var$newPromiseCapability$2.f = function(C) {
    return new $5aa677c457ee63c9$var$PromiseCapability(C);
};
var $5aa677c457ee63c9$var$$$5 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$IS_NODE = $5aa677c457ee63c9$var$engineIsNode;
var $5aa677c457ee63c9$var$global$1 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$call$7 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$defineBuiltIn$2 = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$setPrototypeOf = $5aa677c457ee63c9$var$objectSetPrototypeOf;
var $5aa677c457ee63c9$var$setToStringTag = $5aa677c457ee63c9$var$setToStringTag$3;
var $5aa677c457ee63c9$var$setSpecies = $5aa677c457ee63c9$var$setSpecies$1;
var $5aa677c457ee63c9$var$aCallable$3 = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$isCallable$1 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$isObject$1 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$anInstance = $5aa677c457ee63c9$var$anInstance$1;
var $5aa677c457ee63c9$var$speciesConstructor = $5aa677c457ee63c9$var$speciesConstructor$1;
var $5aa677c457ee63c9$var$task = $5aa677c457ee63c9$var$task$1.set;
var $5aa677c457ee63c9$var$microtask = $5aa677c457ee63c9$var$microtask$1;
var $5aa677c457ee63c9$var$hostReportErrors = $5aa677c457ee63c9$var$hostReportErrors$1;
var $5aa677c457ee63c9$var$perform$2 = $5aa677c457ee63c9$var$perform$3;
var $5aa677c457ee63c9$var$Queue = $5aa677c457ee63c9$var$queue;
var $5aa677c457ee63c9$var$InternalStateModule = $5aa677c457ee63c9$var$internalState;
var $5aa677c457ee63c9$var$NativePromiseConstructor$2 = $5aa677c457ee63c9$var$promiseNativeConstructor;
var $5aa677c457ee63c9$var$PromiseConstructorDetection = $5aa677c457ee63c9$var$promiseConstructorDetection;
var $5aa677c457ee63c9$var$newPromiseCapabilityModule$3 = $5aa677c457ee63c9$var$newPromiseCapability$2;
var $5aa677c457ee63c9$var$PROMISE = "Promise";
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$4 = $5aa677c457ee63c9$var$PromiseConstructorDetection.CONSTRUCTOR;
var $5aa677c457ee63c9$var$NATIVE_PROMISE_REJECTION_EVENT = $5aa677c457ee63c9$var$PromiseConstructorDetection.REJECTION_EVENT;
var $5aa677c457ee63c9$var$NATIVE_PROMISE_SUBCLASSING = $5aa677c457ee63c9$var$PromiseConstructorDetection.SUBCLASSING;
var $5aa677c457ee63c9$var$getInternalPromiseState = $5aa677c457ee63c9$var$InternalStateModule.getterFor($5aa677c457ee63c9$var$PROMISE);
var $5aa677c457ee63c9$var$setInternalState = $5aa677c457ee63c9$var$InternalStateModule.set;
var $5aa677c457ee63c9$var$NativePromisePrototype$1 = $5aa677c457ee63c9$var$NativePromiseConstructor$2 && $5aa677c457ee63c9$var$NativePromiseConstructor$2.prototype;
var $5aa677c457ee63c9$var$PromiseConstructor = $5aa677c457ee63c9$var$NativePromiseConstructor$2;
var $5aa677c457ee63c9$var$PromisePrototype = $5aa677c457ee63c9$var$NativePromisePrototype$1;
var $5aa677c457ee63c9$var$TypeError$1 = $5aa677c457ee63c9$var$global$1.TypeError;
var $5aa677c457ee63c9$var$document$1 = $5aa677c457ee63c9$var$global$1.document;
var $5aa677c457ee63c9$var$process = $5aa677c457ee63c9$var$global$1.process;
var $5aa677c457ee63c9$var$newPromiseCapability$1 = $5aa677c457ee63c9$var$newPromiseCapabilityModule$3.f;
var $5aa677c457ee63c9$var$newGenericPromiseCapability = $5aa677c457ee63c9$var$newPromiseCapability$1;
var $5aa677c457ee63c9$var$DISPATCH_EVENT = !!($5aa677c457ee63c9$var$document$1 && $5aa677c457ee63c9$var$document$1.createEvent && $5aa677c457ee63c9$var$global$1.dispatchEvent);
var $5aa677c457ee63c9$var$UNHANDLED_REJECTION = "unhandledrejection";
var $5aa677c457ee63c9$var$REJECTION_HANDLED = "rejectionhandled";
var $5aa677c457ee63c9$var$PENDING = 0;
var $5aa677c457ee63c9$var$FULFILLED = 1;
var $5aa677c457ee63c9$var$REJECTED = 2;
var $5aa677c457ee63c9$var$HANDLED = 1;
var $5aa677c457ee63c9$var$UNHANDLED = 2;
var $5aa677c457ee63c9$var$Internal, $5aa677c457ee63c9$var$OwnPromiseCapability, $5aa677c457ee63c9$var$PromiseWrapper, $5aa677c457ee63c9$var$nativeThen;
// helpers
var $5aa677c457ee63c9$var$isThenable = function(it) {
    var then;
    return $5aa677c457ee63c9$var$isObject$1(it) && $5aa677c457ee63c9$var$isCallable$1(then = it.then) ? then : false;
};
var $5aa677c457ee63c9$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $5aa677c457ee63c9$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $5aa677c457ee63c9$var$UNHANDLED) $5aa677c457ee63c9$var$onHandleUnhandled(state);
                state.rejection = $5aa677c457ee63c9$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($5aa677c457ee63c9$var$TypeError$1("Promise-chain cycle"));
            else if (then = $5aa677c457ee63c9$var$isThenable(result)) $5aa677c457ee63c9$var$call$7(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $5aa677c457ee63c9$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $5aa677c457ee63c9$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$5aa677c457ee63c9$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $5aa677c457ee63c9$var$onUnhandled(state);
    });
};
var $5aa677c457ee63c9$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($5aa677c457ee63c9$var$DISPATCH_EVENT) {
        event = $5aa677c457ee63c9$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $5aa677c457ee63c9$var$global$1.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$5aa677c457ee63c9$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $5aa677c457ee63c9$var$global$1["on" + name])) handler(event);
    else if (name === $5aa677c457ee63c9$var$UNHANDLED_REJECTION) $5aa677c457ee63c9$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $5aa677c457ee63c9$var$onUnhandled = function(state) {
    $5aa677c457ee63c9$var$call$7($5aa677c457ee63c9$var$task, $5aa677c457ee63c9$var$global$1, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $5aa677c457ee63c9$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $5aa677c457ee63c9$var$perform$2(function() {
                if ($5aa677c457ee63c9$var$IS_NODE) $5aa677c457ee63c9$var$process.emit("unhandledRejection", value, promise);
                else $5aa677c457ee63c9$var$dispatchEvent($5aa677c457ee63c9$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $5aa677c457ee63c9$var$IS_NODE || $5aa677c457ee63c9$var$isUnhandled(state) ? $5aa677c457ee63c9$var$UNHANDLED : $5aa677c457ee63c9$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $5aa677c457ee63c9$var$isUnhandled = function(state) {
    return state.rejection !== $5aa677c457ee63c9$var$HANDLED && !state.parent;
};
var $5aa677c457ee63c9$var$onHandleUnhandled = function(state) {
    $5aa677c457ee63c9$var$call$7($5aa677c457ee63c9$var$task, $5aa677c457ee63c9$var$global$1, function() {
        var promise = state.facade;
        if ($5aa677c457ee63c9$var$IS_NODE) $5aa677c457ee63c9$var$process.emit("rejectionHandled", promise);
        else $5aa677c457ee63c9$var$dispatchEvent($5aa677c457ee63c9$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $5aa677c457ee63c9$var$bind$1 = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $5aa677c457ee63c9$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $5aa677c457ee63c9$var$REJECTED;
    $5aa677c457ee63c9$var$notify(state, true);
};
var $5aa677c457ee63c9$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $5aa677c457ee63c9$var$TypeError$1("Promise can't be resolved itself");
        var then = $5aa677c457ee63c9$var$isThenable(value);
        if (then) $5aa677c457ee63c9$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $5aa677c457ee63c9$var$call$7(then, value, $5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalResolve, wrapper, state), $5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalReject, wrapper, state));
            } catch (error) {
                $5aa677c457ee63c9$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $5aa677c457ee63c9$var$FULFILLED;
            $5aa677c457ee63c9$var$notify(state, false);
        }
    } catch (error) {
        $5aa677c457ee63c9$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $5aa677c457ee63c9$var$PromiseConstructor = function Promise1(executor) {
        $5aa677c457ee63c9$var$anInstance(this, $5aa677c457ee63c9$var$PromisePrototype);
        $5aa677c457ee63c9$var$aCallable$3(executor);
        $5aa677c457ee63c9$var$call$7($5aa677c457ee63c9$var$Internal, this);
        var state = $5aa677c457ee63c9$var$getInternalPromiseState(this);
        try {
            executor($5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalResolve, state), $5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalReject, state));
        } catch (error) {
            $5aa677c457ee63c9$var$internalReject(state, error);
        }
    };
    $5aa677c457ee63c9$var$PromisePrototype = $5aa677c457ee63c9$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $5aa677c457ee63c9$var$Internal = function Promise1(executor) {
        $5aa677c457ee63c9$var$setInternalState(this, {
            type: $5aa677c457ee63c9$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $5aa677c457ee63c9$var$Queue(),
            rejection: false,
            state: $5aa677c457ee63c9$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $5aa677c457ee63c9$var$Internal.prototype = $5aa677c457ee63c9$var$defineBuiltIn$2($5aa677c457ee63c9$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $5aa677c457ee63c9$var$getInternalPromiseState(this);
        var reaction = $5aa677c457ee63c9$var$newPromiseCapability$1($5aa677c457ee63c9$var$speciesConstructor(this, $5aa677c457ee63c9$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $5aa677c457ee63c9$var$isCallable$1(onFulfilled) ? onFulfilled : true;
        reaction.fail = $5aa677c457ee63c9$var$isCallable$1(onRejected) && onRejected;
        reaction.domain = $5aa677c457ee63c9$var$IS_NODE ? $5aa677c457ee63c9$var$process.domain : undefined;
        if (state.state == $5aa677c457ee63c9$var$PENDING) state.reactions.add(reaction);
        else $5aa677c457ee63c9$var$microtask(function() {
            $5aa677c457ee63c9$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $5aa677c457ee63c9$var$OwnPromiseCapability = function() {
        var promise = new $5aa677c457ee63c9$var$Internal();
        var state = $5aa677c457ee63c9$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalResolve, state);
        this.reject = $5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalReject, state);
    };
    $5aa677c457ee63c9$var$newPromiseCapabilityModule$3.f = $5aa677c457ee63c9$var$newPromiseCapability$1 = function(C) {
        return C === $5aa677c457ee63c9$var$PromiseConstructor || C === $5aa677c457ee63c9$var$PromiseWrapper ? new $5aa677c457ee63c9$var$OwnPromiseCapability(C) : $5aa677c457ee63c9$var$newGenericPromiseCapability(C);
    };
    if ($5aa677c457ee63c9$var$isCallable$1($5aa677c457ee63c9$var$NativePromiseConstructor$2) && $5aa677c457ee63c9$var$NativePromisePrototype$1 !== Object.prototype) {
        $5aa677c457ee63c9$var$nativeThen = $5aa677c457ee63c9$var$NativePromisePrototype$1.then;
        if (!$5aa677c457ee63c9$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $5aa677c457ee63c9$var$defineBuiltIn$2($5aa677c457ee63c9$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $5aa677c457ee63c9$var$PromiseConstructor(function(resolve, reject) {
                $5aa677c457ee63c9$var$call$7($5aa677c457ee63c9$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $5aa677c457ee63c9$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($5aa677c457ee63c9$var$setPrototypeOf) $5aa677c457ee63c9$var$setPrototypeOf($5aa677c457ee63c9$var$NativePromisePrototype$1, $5aa677c457ee63c9$var$PromisePrototype);
    }
}
$5aa677c457ee63c9$var$$$5({
    global: true,
    constructor: true,
    wrap: true,
    forced: $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $5aa677c457ee63c9$var$PromiseConstructor
});
$5aa677c457ee63c9$var$setToStringTag($5aa677c457ee63c9$var$PromiseConstructor, $5aa677c457ee63c9$var$PROMISE, false);
$5aa677c457ee63c9$var$setSpecies($5aa677c457ee63c9$var$PROMISE);
var $5aa677c457ee63c9$var$wellKnownSymbol$2 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$Iterators$1 = $5aa677c457ee63c9$var$iterators;
var $5aa677c457ee63c9$var$ITERATOR$2 = $5aa677c457ee63c9$var$wellKnownSymbol$2("iterator");
var $5aa677c457ee63c9$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
var $5aa677c457ee63c9$var$isArrayIteratorMethod$1 = function(it) {
    return it !== undefined && ($5aa677c457ee63c9$var$Iterators$1.Array === it || $5aa677c457ee63c9$var$ArrayPrototype[$5aa677c457ee63c9$var$ITERATOR$2] === it);
};
var $5aa677c457ee63c9$var$classof$1 = $5aa677c457ee63c9$var$classof$3;
var $5aa677c457ee63c9$var$getMethod$1 = $5aa677c457ee63c9$var$getMethod$3;
var $5aa677c457ee63c9$var$Iterators = $5aa677c457ee63c9$var$iterators;
var $5aa677c457ee63c9$var$wellKnownSymbol$1 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$ITERATOR$1 = $5aa677c457ee63c9$var$wellKnownSymbol$1("iterator");
var $5aa677c457ee63c9$var$getIteratorMethod$2 = function(it) {
    if (it != undefined) return $5aa677c457ee63c9$var$getMethod$1(it, $5aa677c457ee63c9$var$ITERATOR$1) || $5aa677c457ee63c9$var$getMethod$1(it, "@@iterator") || $5aa677c457ee63c9$var$Iterators[$5aa677c457ee63c9$var$classof$1(it)];
};
var $5aa677c457ee63c9$var$call$6 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$aCallable$2 = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$anObject$5 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$tryToString$1 = $5aa677c457ee63c9$var$tryToString$4;
var $5aa677c457ee63c9$var$getIteratorMethod$1 = $5aa677c457ee63c9$var$getIteratorMethod$2;
var $5aa677c457ee63c9$var$$TypeError$1 = TypeError;
var $5aa677c457ee63c9$var$getIterator$1 = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $5aa677c457ee63c9$var$getIteratorMethod$1(argument) : usingIterator;
    if ($5aa677c457ee63c9$var$aCallable$2(iteratorMethod)) return $5aa677c457ee63c9$var$anObject$5($5aa677c457ee63c9$var$call$6(iteratorMethod, argument));
    throw $5aa677c457ee63c9$var$$TypeError$1($5aa677c457ee63c9$var$tryToString$1(argument) + " is not iterable");
};
var $5aa677c457ee63c9$var$call$5 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$anObject$4 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$getMethod = $5aa677c457ee63c9$var$getMethod$3;
var $5aa677c457ee63c9$var$iteratorClose$1 = function(iterator, kind, value) {
    var innerResult, innerError;
    $5aa677c457ee63c9$var$anObject$4(iterator);
    try {
        innerResult = $5aa677c457ee63c9$var$getMethod(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $5aa677c457ee63c9$var$call$5(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $5aa677c457ee63c9$var$anObject$4(innerResult);
    return value;
};
var $5aa677c457ee63c9$var$bind = $5aa677c457ee63c9$var$functionBindContext;
var $5aa677c457ee63c9$var$call$4 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$anObject$3 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$tryToString = $5aa677c457ee63c9$var$tryToString$4;
var $5aa677c457ee63c9$var$isArrayIteratorMethod = $5aa677c457ee63c9$var$isArrayIteratorMethod$1;
var $5aa677c457ee63c9$var$lengthOfArrayLike = $5aa677c457ee63c9$var$lengthOfArrayLike$2;
var $5aa677c457ee63c9$var$isPrototypeOf$1 = $5aa677c457ee63c9$var$objectIsPrototypeOf;
var $5aa677c457ee63c9$var$getIterator = $5aa677c457ee63c9$var$getIterator$1;
var $5aa677c457ee63c9$var$getIteratorMethod = $5aa677c457ee63c9$var$getIteratorMethod$2;
var $5aa677c457ee63c9$var$iteratorClose = $5aa677c457ee63c9$var$iteratorClose$1;
var $5aa677c457ee63c9$var$$TypeError = TypeError;
var $5aa677c457ee63c9$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $5aa677c457ee63c9$var$ResultPrototype = $5aa677c457ee63c9$var$Result.prototype;
var $5aa677c457ee63c9$var$iterate$2 = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $5aa677c457ee63c9$var$bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $5aa677c457ee63c9$var$iteratorClose(iterator, "normal", condition);
        return new $5aa677c457ee63c9$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $5aa677c457ee63c9$var$anObject$3(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $5aa677c457ee63c9$var$getIteratorMethod(iterable);
        if (!iterFn) throw $5aa677c457ee63c9$var$$TypeError($5aa677c457ee63c9$var$tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($5aa677c457ee63c9$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = $5aa677c457ee63c9$var$lengthOfArrayLike(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $5aa677c457ee63c9$var$isPrototypeOf$1($5aa677c457ee63c9$var$ResultPrototype, result)) return result;
            }
            return new $5aa677c457ee63c9$var$Result(false);
        }
        iterator = $5aa677c457ee63c9$var$getIterator(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $5aa677c457ee63c9$var$call$4(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $5aa677c457ee63c9$var$iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $5aa677c457ee63c9$var$isPrototypeOf$1($5aa677c457ee63c9$var$ResultPrototype, result)) return result;
    }
    return new $5aa677c457ee63c9$var$Result(false);
};
var $5aa677c457ee63c9$var$wellKnownSymbol = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$ITERATOR = $5aa677c457ee63c9$var$wellKnownSymbol("iterator");
var $5aa677c457ee63c9$var$SAFE_CLOSING = false;
try {
    var $5aa677c457ee63c9$var$called = 0;
    var $5aa677c457ee63c9$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$5aa677c457ee63c9$var$called++
            };
        },
        "return": function() {
            $5aa677c457ee63c9$var$SAFE_CLOSING = true;
        }
    };
    $5aa677c457ee63c9$var$iteratorWithReturn[$5aa677c457ee63c9$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($5aa677c457ee63c9$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $5aa677c457ee63c9$var$checkCorrectnessOfIteration$1 = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$5aa677c457ee63c9$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$5aa677c457ee63c9$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $5aa677c457ee63c9$var$NativePromiseConstructor$1 = $5aa677c457ee63c9$var$promiseNativeConstructor;
var $5aa677c457ee63c9$var$checkCorrectnessOfIteration = $5aa677c457ee63c9$var$checkCorrectnessOfIteration$1;
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$3 = $5aa677c457ee63c9$var$promiseConstructorDetection.CONSTRUCTOR;
var $5aa677c457ee63c9$var$promiseStaticsIncorrectIteration = $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$5aa677c457ee63c9$var$checkCorrectnessOfIteration(function(iterable) {
    $5aa677c457ee63c9$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $5aa677c457ee63c9$var$$$4 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$call$3 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$aCallable$1 = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$newPromiseCapabilityModule$2 = $5aa677c457ee63c9$var$newPromiseCapability$2;
var $5aa677c457ee63c9$var$perform$1 = $5aa677c457ee63c9$var$perform$3;
var $5aa677c457ee63c9$var$iterate$1 = $5aa677c457ee63c9$var$iterate$2;
var $5aa677c457ee63c9$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $5aa677c457ee63c9$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$5aa677c457ee63c9$var$$$4({
    target: "Promise",
    stat: true,
    forced: $5aa677c457ee63c9$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $5aa677c457ee63c9$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $5aa677c457ee63c9$var$perform$1(function() {
            var $promiseResolve = $5aa677c457ee63c9$var$aCallable$1(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $5aa677c457ee63c9$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $5aa677c457ee63c9$var$call$3($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $5aa677c457ee63c9$var$$$3 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$2 = $5aa677c457ee63c9$var$promiseConstructorDetection.CONSTRUCTOR;
var $5aa677c457ee63c9$var$NativePromiseConstructor = $5aa677c457ee63c9$var$promiseNativeConstructor;
var $5aa677c457ee63c9$var$getBuiltIn$1 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$isCallable = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$defineBuiltIn$1 = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$NativePromisePrototype = $5aa677c457ee63c9$var$NativePromiseConstructor && $5aa677c457ee63c9$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$5aa677c457ee63c9$var$$$3({
    target: "Promise",
    proto: true,
    forced: $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($5aa677c457ee63c9$var$isCallable($5aa677c457ee63c9$var$NativePromiseConstructor)) {
    var $5aa677c457ee63c9$var$method = $5aa677c457ee63c9$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($5aa677c457ee63c9$var$NativePromisePrototype["catch"] !== $5aa677c457ee63c9$var$method) $5aa677c457ee63c9$var$defineBuiltIn$1($5aa677c457ee63c9$var$NativePromisePrototype, "catch", $5aa677c457ee63c9$var$method, {
        unsafe: true
    });
}
var $5aa677c457ee63c9$var$$$2 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$call$2 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$aCallable = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$newPromiseCapabilityModule$1 = $5aa677c457ee63c9$var$newPromiseCapability$2;
var $5aa677c457ee63c9$var$perform = $5aa677c457ee63c9$var$perform$3;
var $5aa677c457ee63c9$var$iterate = $5aa677c457ee63c9$var$iterate$2;
var $5aa677c457ee63c9$var$PROMISE_STATICS_INCORRECT_ITERATION = $5aa677c457ee63c9$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$5aa677c457ee63c9$var$$$2({
    target: "Promise",
    stat: true,
    forced: $5aa677c457ee63c9$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $5aa677c457ee63c9$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $5aa677c457ee63c9$var$perform(function() {
            var $promiseResolve = $5aa677c457ee63c9$var$aCallable(C.resolve);
            $5aa677c457ee63c9$var$iterate(iterable, function(promise) {
                $5aa677c457ee63c9$var$call$2($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $5aa677c457ee63c9$var$$$1 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$call$1 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$newPromiseCapabilityModule = $5aa677c457ee63c9$var$newPromiseCapability$2;
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$1 = $5aa677c457ee63c9$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$5aa677c457ee63c9$var$$$1({
    target: "Promise",
    stat: true,
    forced: $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $5aa677c457ee63c9$var$newPromiseCapabilityModule.f(this);
        $5aa677c457ee63c9$var$call$1(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $5aa677c457ee63c9$var$anObject$2 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$isObject = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$newPromiseCapability = $5aa677c457ee63c9$var$newPromiseCapability$2;
var $5aa677c457ee63c9$var$promiseResolve$1 = function(C, x) {
    $5aa677c457ee63c9$var$anObject$2(C);
    if ($5aa677c457ee63c9$var$isObject(x) && x.constructor === C) return x;
    var promiseCapability = $5aa677c457ee63c9$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $5aa677c457ee63c9$var$$ = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$getBuiltIn = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR = $5aa677c457ee63c9$var$promiseConstructorDetection.CONSTRUCTOR;
var $5aa677c457ee63c9$var$promiseResolve = $5aa677c457ee63c9$var$promiseResolve$1;
$5aa677c457ee63c9$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$5aa677c457ee63c9$var$$({
    target: "Promise",
    stat: true,
    forced: $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $5aa677c457ee63c9$var$promiseResolve(this, x);
    }
});
var $5aa677c457ee63c9$var$classof = $5aa677c457ee63c9$var$classof$3;
var $5aa677c457ee63c9$var$$String = String;
var $5aa677c457ee63c9$var$toString = function(argument) {
    if ($5aa677c457ee63c9$var$classof(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $5aa677c457ee63c9$var$$String(argument);
};
var $5aa677c457ee63c9$var$anObject$1 = $5aa677c457ee63c9$var$anObject$c;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $5aa677c457ee63c9$var$regexpFlags = function() {
    var that = $5aa677c457ee63c9$var$anObject$1(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $5aa677c457ee63c9$var$call = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$hasOwn = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$isPrototypeOf = $5aa677c457ee63c9$var$objectIsPrototypeOf;
var $5aa677c457ee63c9$var$regExpFlags = $5aa677c457ee63c9$var$regexpFlags;
var $5aa677c457ee63c9$var$RegExpPrototype$1 = RegExp.prototype;
var $5aa677c457ee63c9$var$regexpGetFlags = function(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $5aa677c457ee63c9$var$RegExpPrototype$1) && !$5aa677c457ee63c9$var$hasOwn(R, "flags") && $5aa677c457ee63c9$var$isPrototypeOf($5aa677c457ee63c9$var$RegExpPrototype$1, R) ? $5aa677c457ee63c9$var$call($5aa677c457ee63c9$var$regExpFlags, R) : flags;
};
var $5aa677c457ee63c9$var$PROPER_FUNCTION_NAME = $5aa677c457ee63c9$var$functionName.PROPER;
var $5aa677c457ee63c9$var$defineBuiltIn = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$anObject = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$$toString = $5aa677c457ee63c9$var$toString;
var $5aa677c457ee63c9$var$fails = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$getRegExpFlags = $5aa677c457ee63c9$var$regexpGetFlags;
var $5aa677c457ee63c9$var$TO_STRING = "toString";
var $5aa677c457ee63c9$var$RegExpPrototype = RegExp.prototype;
var $5aa677c457ee63c9$var$n$ToString = $5aa677c457ee63c9$var$RegExpPrototype[$5aa677c457ee63c9$var$TO_STRING];
var $5aa677c457ee63c9$var$NOT_GENERIC = $5aa677c457ee63c9$var$fails(function() {
    return $5aa677c457ee63c9$var$n$ToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $5aa677c457ee63c9$var$INCORRECT_NAME = $5aa677c457ee63c9$var$PROPER_FUNCTION_NAME && $5aa677c457ee63c9$var$n$ToString.name != $5aa677c457ee63c9$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($5aa677c457ee63c9$var$NOT_GENERIC || $5aa677c457ee63c9$var$INCORRECT_NAME) $5aa677c457ee63c9$var$defineBuiltIn(RegExp.prototype, $5aa677c457ee63c9$var$TO_STRING, function toString() {
    var R = $5aa677c457ee63c9$var$anObject(this);
    var pattern = $5aa677c457ee63c9$var$$toString(R.source);
    var flags = $5aa677c457ee63c9$var$$toString($5aa677c457ee63c9$var$getRegExpFlags(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $5aa677c457ee63c9$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
const $5aa677c457ee63c9$export$6a7fdf2f99a9cf08 = (transactions, signer, network)=>$5aa677c457ee63c9$var$__awaiter(void 0, void 0, void 0, function*() {
        const provider = new $e9c96496ce82840e$exports.providers.JsonRpcProvider({
            url: network.nodeUrl
        });
        const signedTransactions = [];
        for(let i = 0; i < transactions.length; i++){
            const publicKey = yield signer.getPublicKey(transactions[i].signerId, network.networkId);
            const [block, accessKey] = yield Promise.all([
                provider.block({
                    finality: "final"
                }),
                provider.query({
                    request_type: "view_access_key",
                    finality: "final",
                    account_id: transactions[i].signerId,
                    public_key: publicKey.toString()
                })
            ]);
            const actions = transactions[i].actions.map((action)=>$5aa677c457ee63c9$export$309c7a02b0b0bc62(action));
            const transaction = $e9c96496ce82840e$exports.transactions.createTransaction(transactions[i].signerId, $e9c96496ce82840e$exports.utils.PublicKey.from(publicKey.toString()), transactions[i].receiverId, accessKey.nonce + i + 1, actions, $e9c96496ce82840e$exports.utils.serialize.base_decode(block.header.hash));
            const response = yield $e9c96496ce82840e$exports.transactions.signTransaction(transaction, signer, transactions[i].signerId, network.networkId);
            signedTransactions.push(response[1]);
        }
        return signedTransactions;
    });



var $5440e9199a418654$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
$5440e9199a418654$exports = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


/* eslint-disable no-continue */ /* eslint-disable no-unused-vars */ /* eslint-disable no-param-reassign */ /* eslint-disable no-prototype-builtins */ const $50105411ce29e10f$var$errorClasses = {};
const $50105411ce29e10f$var$deserializers = {};
const $50105411ce29e10f$export$ff6248acd0c27a3f = (name, deserializer)=>{
    $50105411ce29e10f$var$deserializers[name] = deserializer;
};
const $50105411ce29e10f$export$94baff7bf5134824 = (name)=>{
    class CustomErrorClass extends Error {
        constructor(message, fields, options){
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            super(message || name, options);
            // Set the prototype explicitly. See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(this, CustomErrorClass.prototype);
            this.name = name;
            if (fields) for(const k in fields)// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this[k] = fields[k];
            if (options && $50105411ce29e10f$var$isObject(options) && "cause" in options && !("cause" in this)) {
                // .cause was specified but the superconstructor
                // did not create an instance property.
                const cause = options.cause;
                this.cause = cause;
                if ("stack" in cause) this.stack = this.stack + "\nCAUSE: " + cause.stack;
            }
        }
    }
    $50105411ce29e10f$var$errorClasses[name] = CustomErrorClass;
    return CustomErrorClass;
};
function $50105411ce29e10f$var$isObject(value) {
    return typeof value === "object";
}
const $50105411ce29e10f$export$64cddc1e268e9046 = (object)=>{
    if (object && typeof object === "object") {
        try {
            if (typeof object.message === "string") {
                const msg = JSON.parse(object.message);
                if (msg.message && msg.name) object = msg;
            }
        } catch (e) {
        // nothing
        }
        let error;
        if (typeof object.name === "string") {
            const { name: name } = object;
            const des = $50105411ce29e10f$var$deserializers[name];
            if (des) error = des(object);
            else {
                let constructor = name === "Error" ? Error : $50105411ce29e10f$var$errorClasses[name];
                if (!constructor) {
                    console.warn("deserializing an unknown class '" + name + "'");
                    constructor = $50105411ce29e10f$export$94baff7bf5134824(name);
                }
                error = Object.create(constructor.prototype);
                try {
                    for(const prop in object)if (object.hasOwnProperty(prop)) error[prop] = object[prop];
                } catch (e) {
                // sometimes setting a property can fail (e.g. .name)
                }
            }
        } else if (typeof object.message === "string") error = new Error(object.message);
        if (error && !error.stack && Error.captureStackTrace) Error.captureStackTrace(error, $50105411ce29e10f$export$64cddc1e268e9046);
        return error;
    }
    return new Error(String(object));
};
const $50105411ce29e10f$export$46ff38bc6bdea8fb = (value)=>{
    if (!value) return value;
    if (typeof value === "object") return $50105411ce29e10f$var$destroyCircular(value, []);
    if (typeof value === "function") return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
// https://www.npmjs.com/package/destroy-circular
function $50105411ce29e10f$var$destroyCircular(from, seen) {
    const to = {};
    seen.push(from);
    for (const key of Object.keys(from)){
        const value = from[key];
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (seen.indexOf(from[key]) === -1) {
            to[key] = $50105411ce29e10f$var$destroyCircular(from[key], seen.slice(0));
            continue;
        }
        to[key] = "[Circular]";
    }
    if (typeof from.name === "string") to.name = from.name;
    if (typeof from.message === "string") to.message = from.message;
    if (typeof from.stack === "string") to.stack = from.stack;
    return to;
}


const $9a194f74559621d2$export$d7dd32b41fc9c3a0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("AccountNameRequired");
const $9a194f74559621d2$export$fb9db505804530ec = (0, $50105411ce29e10f$export$94baff7bf5134824)("AccountNotSupported");
const $9a194f74559621d2$export$c9d6bf2b06944665 = (0, $50105411ce29e10f$export$94baff7bf5134824)("AmountRequired");
const $9a194f74559621d2$export$2628fce2396c23c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("BluetoothRequired");
const $9a194f74559621d2$export$75f8b0767ef406f1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("BtcUnmatchedApp");
const $9a194f74559621d2$export$f60aa84fd00bc3ee = (0, $50105411ce29e10f$export$94baff7bf5134824)("CantOpenDevice");
const $9a194f74559621d2$export$fc0260506e4022ab = (0, $50105411ce29e10f$export$94baff7bf5134824)("CashAddrNotSupported");
const $9a194f74559621d2$export$1e9e90415b859c28 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ClaimRewardsFeesWarning");
const $9a194f74559621d2$export$e0b1ec53ba36e221 = (0, $50105411ce29e10f$export$94baff7bf5134824)("CurrencyNotSupported");
const $9a194f74559621d2$export$fa9aacd48d3a45c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceAppVerifyNotSupported");
const $9a194f74559621d2$export$f21ce806524ab8d4 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceGenuineSocketEarlyClose");
const $9a194f74559621d2$export$9c30dc6872fcd74c = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceNotGenuine");
const $9a194f74559621d2$export$1d5ae41b109edf1f = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnDashboardExpected");
const $9a194f74559621d2$export$8eecf64ec9a8cfd7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnDashboardUnexpected");
const $9a194f74559621d2$export$a5e2071f1ac48fdd = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceInOSUExpected");
const $9a194f74559621d2$export$3be6e7231165f4ac = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceHalted");
const $9a194f74559621d2$export$fa7bfae6dce03474 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceNameInvalid");
const $9a194f74559621d2$export$bcce4e5aded80ca0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketFail");
const $9a194f74559621d2$export$944a0f9a7cc1e03a = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketNoBulkStatus");
const $9a194f74559621d2$export$612d1f6d08d4cfb = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketNoBulkStatus");
const $9a194f74559621d2$export$5f6bf7cdd5818529 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnresponsiveDeviceError");
const $9a194f74559621d2$export$1e42f3936938e063 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DisconnectedDevice");
const $9a194f74559621d2$export$2a60f41a2ed2742 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DisconnectedDeviceDuringOperation");
const $9a194f74559621d2$export$93e2040d8e24d646 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceExtractOnboardingStateError");
const $9a194f74559621d2$export$e6aaf90bcb4b2013 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnboardingStatePollingError");
const $9a194f74559621d2$export$cfbd0adf8f9fdaf9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("EnpointConfig");
const $9a194f74559621d2$export$96d8d3c501f1625 = (0, $50105411ce29e10f$export$94baff7bf5134824)("EthAppPleaseEnableContractData");
const $9a194f74559621d2$export$37b49553b7172cb1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeEstimationFailed");
const $9a194f74559621d2$export$d00fd6c398a70fd9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FirmwareNotRecognized");
const $9a194f74559621d2$export$3dc3bbf8c134219c = (0, $50105411ce29e10f$export$94baff7bf5134824)("HardResetFail");
const $9a194f74559621d2$export$5e8f7ae1054a2777 = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidXRPTag");
const $9a194f74559621d2$export$953b602d2269ceba = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidAddress");
const $9a194f74559621d2$export$61e75f453df94067 = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidNonce");
const $9a194f74559621d2$export$bbdaf7c77a7508eb = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidAddressBecauseDestinationIsAlsoSource");
const $9a194f74559621d2$export$882967e2980534f9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LatestMCUInstalledError");
const $9a194f74559621d2$export$59772a13ac97df0e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnknownMCU");
const $9a194f74559621d2$export$26bf4f7c63d50901 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPIError");
const $9a194f74559621d2$export$fdab6afd1b1820af = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPIErrorWithMessage");
const $9a194f74559621d2$export$c2996b38942cf758 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPINotAvailable");
const $9a194f74559621d2$export$3d81abcc61613a27 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppAlreadyInstalled");
const $9a194f74559621d2$export$87a9bff9fff141e2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppRelyOnBTC");
const $9a194f74559621d2$export$86581a722c4238c0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppDepInstallRequired");
const $9a194f74559621d2$export$267a8476044885dd = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppDepUninstallRequired");
const $9a194f74559621d2$export$bb771ca417eca344 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerDeviceLocked");
const $9a194f74559621d2$export$b634ce25e3ff5229 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerFirmwareNotEnoughSpace");
const $9a194f74559621d2$export$2d26f4eadfe37285 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerNotEnoughSpace");
const $9a194f74559621d2$export$ceb7f9bef5a1e481 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerUninstallBTCDep");
const $9a194f74559621d2$export$baadb6886fde1621 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NetworkDown");
const $9a194f74559621d2$export$bae979e68e4dc802 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NetworkError");
const $9a194f74559621d2$export$5cbfa0659f97216a = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoAddressesFound");
const $9a194f74559621d2$export$9e00aead3515e5c9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalance");
const $9a194f74559621d2$export$5ed90e0e011f4857 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceToDelegate");
const $9a194f74559621d2$export$75178c95e66d9630 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceInParentAccount");
const $9a194f74559621d2$export$e3e2865b29f7e0b0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughSpendableBalance");
const $9a194f74559621d2$export$a84b3634866707ea = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceBecauseDestinationNotCreated");
const $9a194f74559621d2$export$a282f858b69a7326 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoAccessToCamera");
const $9a194f74559621d2$export$5111c405c5cacc97 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughGas");
const $9a194f74559621d2$export$1cb5c4489aaca4d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughGasSwap");
const $9a194f74559621d2$export$626e1fd20d22139c = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotSupportedLegacyAddress");
const $9a194f74559621d2$export$f919e2c9c746346b = (0, $50105411ce29e10f$export$94baff7bf5134824)("GasLessThanEstimate");
const $9a194f74559621d2$export$cc562f3706902d22 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeTooLow");
const $9a194f74559621d2$export$ee14d05cd43eb762 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeTooHigh");
const $9a194f74559621d2$export$931458f4b7d53154 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeHigherThanMaxFee");
const $9a194f74559621d2$export$c0ce9cadb94c6b86 = (0, $50105411ce29e10f$export$94baff7bf5134824)("MaxFeeTooLow");
const $9a194f74559621d2$export$22c5aa8937c5b423 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PasswordsDontMatch");
const $9a194f74559621d2$export$f57670cd1aaf386 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PasswordIncorrect");
const $9a194f74559621d2$export$3ba22bf10deb1448 = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecommendSubAccountsToEmpty");
const $9a194f74559621d2$export$33f73085e1b7871b = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecommendUndelegation");
const $9a194f74559621d2$export$cd4d967a66d81060 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TimeoutTagged");
const $9a194f74559621d2$export$9375635756d6156e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnexpectedBootloader");
const $9a194f74559621d2$export$90478a5d08d6c2d7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("MCUNotGenuineToDashboard");
const $9a194f74559621d2$export$132f0197eaa65535 = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecipientRequired");
const $9a194f74559621d2$export$7aee729193ab77ba = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountReceive");
const $9a194f74559621d2$export$4ec11dc947a3c9d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountSend");
const $9a194f74559621d2$export$5e3ed85b946872a1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateFetchFileFail");
const $9a194f74559621d2$export$5db6383ad081f01e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateIncorrectHash");
const $9a194f74559621d2$export$92c199eb837d8df8 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateIncorrectSig");
const $9a194f74559621d2$export$85e0c017833c894c = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateYourApp");
const $9a194f74559621d2$export$84115f1b54c874b3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedDeviceNameChange");
const $9a194f74559621d2$export$3f4864efb1638333 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedAddress");
const $9a194f74559621d2$export$d777e0ef77faca34 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedFirmwareUpdate");
const $9a194f74559621d2$export$3d8a4f08cd3eb133 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedAllowManager");
const $9a194f74559621d2$export$db9b724c3524b5d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
const $9a194f74559621d2$export$65df6bdf4eb29653 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ExpertModeRequired");
const $9a194f74559621d2$export$9642f061c2494239 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportOpenUserCancelled");
const $9a194f74559621d2$export$fd71e3a51c4bf0ae = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportInterfaceNotAvailable");
const $9a194f74559621d2$export$d6cb63cda2c2b2a4 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportRaceCondition");
const $9a194f74559621d2$export$c0ffbdd94649bd06 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportWebUSBGestureRequired");
const $9a194f74559621d2$export$28149f687a2e30c9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransactionHasBeenValidatedError");
const $9a194f74559621d2$export$448663d307bde953 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportExchangeTimeoutError");
const $9a194f74559621d2$export$4800af3cc6204928 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceShouldStayInApp");
const $9a194f74559621d2$export$101490ec073327e1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WebsocketConnectionError");
const $9a194f74559621d2$export$219228963d86b069 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WebsocketConnectionFailed");
const $9a194f74559621d2$export$25b49ca0efdfe5d1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongDeviceForAccount");
const $9a194f74559621d2$export$63498b46122d8a23 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongAppForCurrency");
const $9a194f74559621d2$export$707f317a4761c46d = (0, $50105411ce29e10f$export$94baff7bf5134824)("ETHAddressNonEIP");
const $9a194f74559621d2$export$a5d8da2f27618c16 = (0, $50105411ce29e10f$export$94baff7bf5134824)("CantScanQRCode");
const $9a194f74559621d2$export$3f2d8a7775aab6cc = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeNotLoaded");
const $9a194f74559621d2$export$3ae46f8c8f45dbe7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeNotLoadedSwap");
const $9a194f74559621d2$export$ffbf6641e9ab88d3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeRequired");
const $9a194f74559621d2$export$53e797c2fa09aff3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeTooHigh");
const $9a194f74559621d2$export$cb0b645e3d7170ab = (0, $50105411ce29e10f$export$94baff7bf5134824)("PendingOperation");
const $9a194f74559621d2$export$2aca4567d80fd933 = (0, $50105411ce29e10f$export$94baff7bf5134824)("SyncError");
const $9a194f74559621d2$export$a2d6658d365c43df = (0, $50105411ce29e10f$export$94baff7bf5134824)("PairingFailed");
const $9a194f74559621d2$export$4400fa093e7d20ad = (0, $50105411ce29e10f$export$94baff7bf5134824)("PeerRemovedPairing");
const $9a194f74559621d2$export$3f7ba18f3c84cced = (0, $50105411ce29e10f$export$94baff7bf5134824)("GenuineCheckFailed");
const $9a194f74559621d2$export$437e6aac14cab3d9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPI4xx");
const $9a194f74559621d2$export$309835543e52bf92 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPI5xx");
const $9a194f74559621d2$export$c282cdb2f7fdc27a = (0, $50105411ce29e10f$export$94baff7bf5134824)("FirmwareOrAppUpdateRequired");
const $9a194f74559621d2$export$aba9024c0d586a15 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ReplacementTransactionUnderpriced");
const $9a194f74559621d2$export$51a1e1b4f21df9f4 = (0, $50105411ce29e10f$export$94baff7bf5134824)("OpReturnSizeLimit");
const $9a194f74559621d2$export$1d49177380419e3d = (0, $50105411ce29e10f$export$94baff7bf5134824)("DustLimit");
const $9a194f74559621d2$export$28f62a162580c9c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LanguageNotFound");
const $9a194f74559621d2$export$d3cadb9f4e1fa40d = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoDBPathGiven");
const $9a194f74559621d2$export$de46c919e379f03f = (0, $50105411ce29e10f$export$94baff7bf5134824)("DBWrongPassword");
const $9a194f74559621d2$export$e1c94c135b0a553e = (0, $50105411ce29e10f$export$94baff7bf5134824)("DBNotReset");
var $9a194f74559621d2$export$62e86095f76df800;
(function(HwTransportErrorType) {
    HwTransportErrorType["Unknown"] = "Unknown";
    HwTransportErrorType["LocationServicesDisabled"] = "LocationServicesDisabled";
    HwTransportErrorType["LocationServicesUnauthorized"] = "LocationServicesUnauthorized";
    HwTransportErrorType["BluetoothScanStartFailed"] = "BluetoothScanStartFailed";
})($9a194f74559621d2$export$62e86095f76df800 || ($9a194f74559621d2$export$62e86095f76df800 = {}));
class $9a194f74559621d2$export$ef5ffbe444ecd147 extends Error {
    constructor(type, message){
        super(message);
        this.name = "HwTransportError";
        this.type = type;
        // Needed as long as we target < ES6
        Object.setPrototypeOf(this, $9a194f74559621d2$export$ef5ffbe444ecd147.prototype);
    }
}
class $9a194f74559621d2$export$8e68de6fb26f2236 extends Error {
    constructor(message, id){
        const name = "TransportError";
        super(message || name);
        this.name = name;
        this.message = message;
        this.stack = new Error(message).stack;
        this.id = id;
    }
}
(0, $50105411ce29e10f$export$ff6248acd0c27a3f)("TransportError", (e)=>new $9a194f74559621d2$export$8e68de6fb26f2236(e.message, e.id));
const $9a194f74559621d2$export$efd5569f873811b1 = {
    ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
    ALGORITHM_NOT_SUPPORTED: 0x9484,
    CLA_NOT_SUPPORTED: 0x6e00,
    CODE_BLOCKED: 0x9840,
    CODE_NOT_INITIALIZED: 0x9802,
    COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
    CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
    CONTRADICTION_INVALIDATION: 0x9810,
    CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
    CUSTOM_IMAGE_BOOTLOADER: 0x662f,
    CUSTOM_IMAGE_EMPTY: 0x662e,
    FILE_ALREADY_EXISTS: 0x6a89,
    FILE_NOT_FOUND: 0x9404,
    GP_AUTH_FAILED: 0x6300,
    HALTED: 0x6faa,
    INCONSISTENT_FILE: 0x9408,
    INCORRECT_DATA: 0x6a80,
    INCORRECT_LENGTH: 0x6700,
    INCORRECT_P1_P2: 0x6b00,
    INS_NOT_SUPPORTED: 0x6d00,
    DEVICE_NOT_ONBOARDED: 0x6d07,
    DEVICE_NOT_ONBOARDED_2: 0x6611,
    INVALID_KCV: 0x9485,
    INVALID_OFFSET: 0x9402,
    LICENSING: 0x6f42,
    LOCKED_DEVICE: 0x5515,
    MAX_VALUE_REACHED: 0x9850,
    MEMORY_PROBLEM: 0x9240,
    MISSING_CRITICAL_PARAMETER: 0x6800,
    NO_EF_SELECTED: 0x9400,
    NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
    OK: 0x9000,
    PIN_REMAINING_ATTEMPTS: 0x63c0,
    REFERENCED_DATA_NOT_FOUND: 0x6a88,
    SECURITY_STATUS_NOT_SATISFIED: 0x6982,
    TECHNICAL_PROBLEM: 0x6f00,
    UNKNOWN_APDU: 0x6d02,
    USER_REFUSED_ON_DEVICE: 0x5501,
    NOT_ENOUGH_SPACE: 0x5102
};
function $9a194f74559621d2$export$799566c03457ebd5(code) {
    switch(code){
        // improve text of most common errors
        case 0x6700:
            return "Incorrect length";
        case 0x6800:
            return "Missing critical parameter";
        case 0x6982:
            return "Security not satisfied (dongle locked or have invalid access rights)";
        case 0x6985:
            return "Condition of use not satisfied (denied by the user?)";
        case 0x6a80:
            return "Invalid data received";
        case 0x6b00:
            return "Invalid parameter received";
        case 0x5515:
            return "Locked device";
    }
    if (0x6f00 <= code && code <= 0x6fff) return "Internal error, please report";
}
class $9a194f74559621d2$export$78917f4716d96cfe extends Error {
    /**
     * @param statusCode The error status code coming from a Transport implementation
     * @param options containing:
     *  - canBeMappedToChildError: enable the mapping of TransportStatusError to an error extending/inheriting from it
     *  . Ex: LockedDeviceError. Default to true.
     */ constructor(statusCode, { canBeMappedToChildError: canBeMappedToChildError = true } = {}){
        const statusText = Object.keys($9a194f74559621d2$export$efd5569f873811b1).find((k)=>$9a194f74559621d2$export$efd5569f873811b1[k] === statusCode) || "UNKNOWN_ERROR";
        const smsg = $9a194f74559621d2$export$799566c03457ebd5(statusCode) || statusText;
        const statusCodeStr = statusCode.toString(16);
        const message = `Ledger device: ${smsg} (0x${statusCodeStr})`;
        super(message);
        this.name = "TransportStatusError";
        this.statusCode = statusCode;
        this.statusText = statusText;
        Object.setPrototypeOf(this, $9a194f74559621d2$export$78917f4716d96cfe.prototype);
        // Maps to a LockedDeviceError
        if (canBeMappedToChildError && statusCode === $9a194f74559621d2$export$efd5569f873811b1.LOCKED_DEVICE) return new $9a194f74559621d2$export$1fb6667702a70644(message);
    }
}
class $9a194f74559621d2$export$1fb6667702a70644 extends $9a194f74559621d2$export$78917f4716d96cfe {
    constructor(message){
        super($9a194f74559621d2$export$efd5569f873811b1.LOCKED_DEVICE, {
            canBeMappedToChildError: false
        });
        if (message) this.message = message;
        this.name = "LockedDeviceError";
        Object.setPrototypeOf(this, $9a194f74559621d2$export$1fb6667702a70644.prototype);
    }
}
(0, $50105411ce29e10f$export$ff6248acd0c27a3f)("TransportStatusError", (e)=>new $9a194f74559621d2$export$78917f4716d96cfe(e.statusCode));



var $6ZWSX = parcelRequire("6ZWSX");
var $375818ecee1623c3$require$Buffer = $6ZWSX.Buffer;
var $375818ecee1623c3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $375818ecee1623c3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $375818ecee1623c3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $375818ecee1623c3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $375818ecee1623c3$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Transport defines the generic interface to share between node/u2f impl
 * A **Descriptor** is a parametric type that is up to be determined for the implementation.
 * it can be for instance an ID, an file path, a URL,...
 */ var $375818ecee1623c3$var$Transport = /** @class */ function() {
    function Transport() {
        var _this = this;
        this.exchangeTimeout = 30000;
        this.unresponsiveTimeout = 15000;
        this.deviceModel = null;
        this._events = new (0, (/*@__PURE__*/$parcel$interopDefault($5440e9199a418654$exports)))();
        /**
         * wrapper on top of exchange to simplify work of the implementation.
         * @param cla
         * @param ins
         * @param p1
         * @param p2
         * @param data
         * @param statusList is a list of accepted status code (shorts). [0x9000] by default
         * @return a Promise of response buffer
         */ this.send = function(cla, ins, p1, p2, data, statusList) {
            if (data === void 0) data = $375818ecee1623c3$require$Buffer.alloc(0);
            if (statusList === void 0) statusList = [
                (0, $9a194f74559621d2$export$efd5569f873811b1).OK
            ];
            return $375818ecee1623c3$var$__awaiter(_this, void 0, void 0, function() {
                var response, sw;
                return $375818ecee1623c3$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (data.length >= 256) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("data.length exceed 256 bytes limit. Got: " + data.length, "DataLengthTooBig");
                            return [
                                4 /*yield*/ ,
                                this.exchange($375818ecee1623c3$require$Buffer.concat([
                                    $375818ecee1623c3$require$Buffer.from([
                                        cla,
                                        ins,
                                        p1,
                                        p2
                                    ]),
                                    $375818ecee1623c3$require$Buffer.from([
                                        data.length
                                    ]),
                                    data
                                ]))
                            ];
                        case 1:
                            response = _a.sent();
                            sw = response.readUInt16BE(response.length - 2);
                            if (!statusList.some(function(s) {
                                return s === sw;
                            })) throw new (0, $9a194f74559621d2$export$78917f4716d96cfe)(sw);
                            return [
                                2 /*return*/ ,
                                response
                            ];
                    }
                });
            });
        };
        this.exchangeAtomicImpl = function(f) {
            return $375818ecee1623c3$var$__awaiter(_this, void 0, void 0, function() {
                var resolveBusy, busyPromise, unresponsiveReached, timeout, res;
                var _this = this;
                return $375818ecee1623c3$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.exchangeBusyPromise) throw new (0, $9a194f74559621d2$export$d6cb63cda2c2b2a4)("An action was already pending on the Ledger device. Please deny or reconnect.");
                            busyPromise = new Promise(function(r) {
                                resolveBusy = r;
                            });
                            this.exchangeBusyPromise = busyPromise;
                            unresponsiveReached = false;
                            timeout = setTimeout(function() {
                                unresponsiveReached = true;
                                _this.emit("unresponsive");
                            }, this.unresponsiveTimeout);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                f()
                            ];
                        case 2:
                            res = _a.sent();
                            if (unresponsiveReached) this.emit("responsive");
                            return [
                                2 /*return*/ ,
                                res
                            ];
                        case 3:
                            clearTimeout(timeout);
                            if (resolveBusy) resolveBusy();
                            this.exchangeBusyPromise = null;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this._appAPIlock = null;
    }
    /**
     * low level api to communicate with the device
     * This method is for implementations to implement but should not be directly called.
     * Instead, the recommanded way is to use send() method
     * @param apdu the data to send
     * @return a Promise of response data
     */ Transport.prototype.exchange = function(_apdu) {
        throw new Error("exchange not implemented");
    };
    /**
     * set the "scramble key" for the next exchanges with the device.
     * Each App can have a different scramble key and they internally will set it at instanciation.
     * @param key the scramble key
     */ Transport.prototype.setScrambleKey = function(_key) {};
    /**
     * close the exchange with the device.
     * @return a Promise that ends when the transport is closed.
     */ Transport.prototype.close = function() {
        return Promise.resolve();
    };
    /**
     * Listen to an event on an instance of transport.
     * Transport implementation can have specific events. Here is the common events:
     * * `"disconnect"` : triggered if Transport is disconnected
     */ Transport.prototype.on = function(eventName, cb) {
        this._events.on(eventName, cb);
    };
    /**
     * Stop listening to an event on an instance of transport.
     */ Transport.prototype.off = function(eventName, cb) {
        this._events.removeListener(eventName, cb);
    };
    Transport.prototype.emit = function(event) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        (_a = this._events).emit.apply(_a, $375818ecee1623c3$var$__spreadArray([
            event
        ], $375818ecee1623c3$var$__read(args), false));
    };
    /**
     * Enable or not logs of the binary exchange
     */ Transport.prototype.setDebugMode = function() {
        console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
    };
    /**
     * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
     */ Transport.prototype.setExchangeTimeout = function(exchangeTimeout) {
        this.exchangeTimeout = exchangeTimeout;
    };
    /**
     * Define the delay before emitting "unresponsive" on an exchange that does not respond
     */ Transport.prototype.setExchangeUnresponsiveTimeout = function(unresponsiveTimeout) {
        this.unresponsiveTimeout = unresponsiveTimeout;
    };
    /**
     * create() allows to open the first descriptor available or
     * throw if there is none or if timeout is reached.
     * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
     * @example
    TransportFoo.create().then(transport => ...)
     */ Transport.create = function(openTimeout, listenTimeout) {
        var _this = this;
        if (openTimeout === void 0) openTimeout = 3000;
        return new Promise(function(resolve, reject) {
            var found = false;
            var sub = _this.listen({
                next: function(e) {
                    found = true;
                    if (sub) sub.unsubscribe();
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    _this.open(e.descriptor, openTimeout).then(resolve, reject);
                },
                error: function(e) {
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    reject(e);
                },
                complete: function() {
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    if (!found) reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(_this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
                }
            });
            var listenTimeoutId = listenTimeout ? setTimeout(function() {
                sub.unsubscribe();
                reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(_this.ErrorMessage_ListenTimeout, "ListenTimeout"));
            }, listenTimeout) : null;
        });
    };
    Transport.prototype.decorateAppAPIMethods = function(self, methods, scrambleKey) {
        var e_1, _a;
        try {
            for(var methods_1 = $375818ecee1623c3$var$__values(methods), methods_1_1 = methods_1.next(); !methods_1_1.done; methods_1_1 = methods_1.next()){
                var methodName = methods_1_1.value;
                self[methodName] = this.decorateAppAPIMethod(methodName, self[methodName], self, scrambleKey);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (methods_1_1 && !methods_1_1.done && (_a = methods_1["return"])) _a.call(methods_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Transport.prototype.decorateAppAPIMethod = function(methodName, f, ctx, scrambleKey) {
        var _this = this;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return $375818ecee1623c3$var$__awaiter(_this, void 0, void 0, function() {
                var _appAPIlock;
                return $375818ecee1623c3$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _appAPIlock = this._appAPIlock;
                            if (_appAPIlock) return [
                                2 /*return*/ ,
                                Promise.reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Ledger Device is busy (lock " + _appAPIlock + ")", "TransportLocked"))
                            ];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            this._appAPIlock = methodName;
                            this.setScrambleKey(scrambleKey);
                            return [
                                4 /*yield*/ ,
                                f.apply(ctx, args)
                            ];
                        case 2:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 3:
                            this._appAPIlock = null;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
    };
    Transport.ErrorMessage_ListenTimeout = "No Ledger device found (timeout)";
    Transport.ErrorMessage_NoDeviceFound = "No Ledger device found";
    return Transport;
}();
var $375818ecee1623c3$export$2e2bcd8739ae039 = $375818ecee1623c3$var$Transport;


var $a5ff30f0873f7620$export$1e511d4a378977f5;
var $a5ff30f0873f7620$export$2e2bcd8739ae039;

var $6ZWSX = parcelRequire("6ZWSX");
var $a5ff30f0873f7620$require$Buffer = $6ZWSX.Buffer;
"use strict";
$a5ff30f0873f7620$export$1e511d4a378977f5 = true;

var $a5ff30f0873f7620$var$Tag = 0x05;
function $a5ff30f0873f7620$var$asUInt16BE(value) {
    var b = $a5ff30f0873f7620$require$Buffer.alloc(2);
    b.writeUInt16BE(value, 0);
    return b;
}
var $a5ff30f0873f7620$var$initialAcc = {
    data: $a5ff30f0873f7620$require$Buffer.alloc(0),
    dataLength: 0,
    sequence: 0
};
/**
 *
 */ var $a5ff30f0873f7620$var$createHIDframing = function(channel, packetSize) {
    return {
        makeBlocks: function(apdu) {
            var data = $a5ff30f0873f7620$require$Buffer.concat([
                $a5ff30f0873f7620$var$asUInt16BE(apdu.length),
                apdu
            ]);
            var blockSize = packetSize - 5;
            var nbBlocks = Math.ceil(data.length / blockSize);
            data = $a5ff30f0873f7620$require$Buffer.concat([
                data,
                $a5ff30f0873f7620$require$Buffer.alloc(nbBlocks * blockSize - data.length + 1).fill(0)
            ]);
            var blocks = [];
            for(var i = 0; i < nbBlocks; i++){
                var head = $a5ff30f0873f7620$require$Buffer.alloc(5);
                head.writeUInt16BE(channel, 0);
                head.writeUInt8($a5ff30f0873f7620$var$Tag, 2);
                head.writeUInt16BE(i, 3);
                var chunk = data.slice(i * blockSize, (i + 1) * blockSize);
                blocks.push($a5ff30f0873f7620$require$Buffer.concat([
                    head,
                    chunk
                ]));
            }
            return blocks;
        },
        reduceResponse: function(acc, chunk) {
            var _a = acc || $a5ff30f0873f7620$var$initialAcc, data = _a.data, dataLength = _a.dataLength, sequence = _a.sequence;
            if (chunk.readUInt16BE(0) !== channel) throw new $9a194f74559621d2$export$8e68de6fb26f2236("Invalid channel", "InvalidChannel");
            if (chunk.readUInt8(2) !== $a5ff30f0873f7620$var$Tag) throw new $9a194f74559621d2$export$8e68de6fb26f2236("Invalid tag", "InvalidTag");
            if (chunk.readUInt16BE(3) !== sequence) throw new $9a194f74559621d2$export$8e68de6fb26f2236("Invalid sequence", "InvalidSequence");
            if (!acc) dataLength = chunk.readUInt16BE(5);
            sequence++;
            var chunkData = chunk.slice(acc ? 5 : 7);
            data = $a5ff30f0873f7620$require$Buffer.concat([
                data,
                chunkData
            ]);
            if (data.length > dataLength) data = data.slice(0, dataLength);
            return {
                data: data,
                dataLength: dataLength,
                sequence: sequence
            };
        },
        getReducedResult: function(acc) {
            if (acc && acc.dataLength === acc.data.length) return acc.data;
        }
    };
};
$a5ff30f0873f7620$export$2e2bcd8739ae039 = $a5ff30f0873f7620$var$createHIDframing;


var $dbb9fc904636819d$exports = {};
// just pre-load all the stuff that index.js lazily exports

var $kGRcS = parcelRequire("kGRcS");

var $fJ45P = parcelRequire("fJ45P");
var $df90e8d1cf1cf055$exports = {};

var $i9RZm = parcelRequire("i9RZm");

var $fJ45P = parcelRequire("fJ45P");
var $df90e8d1cf1cf055$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;
var $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER = $fJ45P.MAX_SAFE_INTEGER;

var $kGRcS = parcelRequire("kGRcS");
var $df90e8d1cf1cf055$require$re = $kGRcS.safeRe;
var $df90e8d1cf1cf055$require$t = $kGRcS.t;
var $100fa442ed30ac34$exports = {};
// parse out just the options we care about
const $100fa442ed30ac34$var$looseOption = Object.freeze({
    loose: true
});
const $100fa442ed30ac34$var$emptyOpts = Object.freeze({});
const $100fa442ed30ac34$var$parseOptions = (options)=>{
    if (!options) return $100fa442ed30ac34$var$emptyOpts;
    if (typeof options !== "object") return $100fa442ed30ac34$var$looseOption;
    return options;
};
$100fa442ed30ac34$exports = $100fa442ed30ac34$var$parseOptions;


var $ed5e7d6476f836e9$exports = {};
const $ed5e7d6476f836e9$var$numeric = /^[0-9]+$/;
const $ed5e7d6476f836e9$var$compareIdentifiers = (a, b)=>{
    const anum = $ed5e7d6476f836e9$var$numeric.test(a);
    const bnum = $ed5e7d6476f836e9$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $ed5e7d6476f836e9$var$rcompareIdentifiers = (a, b)=>$ed5e7d6476f836e9$var$compareIdentifiers(b, a);
$ed5e7d6476f836e9$exports = {
    compareIdentifiers: $ed5e7d6476f836e9$var$compareIdentifiers,
    rcompareIdentifiers: $ed5e7d6476f836e9$var$rcompareIdentifiers
};


var $df90e8d1cf1cf055$require$compareIdentifiers = $ed5e7d6476f836e9$exports.compareIdentifiers;
class $df90e8d1cf1cf055$var$SemVer {
    constructor(version, options){
        options = $100fa442ed30ac34$exports(options);
        if (version instanceof $df90e8d1cf1cf055$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $df90e8d1cf1cf055$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$df90e8d1cf1cf055$require$MAX_LENGTH} characters`);
        $i9RZm("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.LOOSE] : $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join(".")}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $i9RZm("SemVer.compare", this.version, this.options, other);
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) {
            if (typeof other === "string" && other === this.version) return 0;
            other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        return $df90e8d1cf1cf055$require$compareIdentifiers(this.major, other.major) || $df90e8d1cf1cf055$require$compareIdentifiers(this.minor, other.minor) || $df90e8d1cf1cf055$require$compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $i9RZm("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $i9RZm("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        switch(release){
            case "premajor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "preminor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "prepatch":
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case "prerelease":
                if (this.prerelease.length === 0) this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            case "major":
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "minor":
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "patch":
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case "pre":
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (!identifier && identifierBase === false) throw new Error("invalid increment argument: identifier is empty");
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join(".") && identifierBase === false) throw new Error("invalid increment argument: identifier already exists");
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($df90e8d1cf1cf055$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join(".")}`;
        return this;
    }
}
$df90e8d1cf1cf055$exports = $df90e8d1cf1cf055$var$SemVer;



var $518bb137cbdf72c3$exports = {};

const $518bb137cbdf72c3$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $df90e8d1cf1cf055$exports) return version;
    try {
        return new $df90e8d1cf1cf055$exports(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
$518bb137cbdf72c3$exports = $518bb137cbdf72c3$var$parse;


var $c618592c32f826bd$exports = {};

const $c618592c32f826bd$var$valid = (version, options)=>{
    const v = $518bb137cbdf72c3$exports(version, options);
    return v ? v.version : null;
};
$c618592c32f826bd$exports = $c618592c32f826bd$var$valid;


var $889491f0ea5a6118$exports = {};

const $889491f0ea5a6118$var$clean = (version, options)=>{
    const s = $518bb137cbdf72c3$exports(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
};
$889491f0ea5a6118$exports = $889491f0ea5a6118$var$clean;


var $d4783bb52460fa90$exports = {};

const $d4783bb52460fa90$var$inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === "string") {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $df90e8d1cf1cf055$exports(version instanceof $df90e8d1cf1cf055$exports ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
$d4783bb52460fa90$exports = $d4783bb52460fa90$var$inc;


var $ab0877022a91d748$exports = {};

const $ab0877022a91d748$var$diff = (version1, version2)=>{
    const v1 = $518bb137cbdf72c3$exports(version1, null, true);
    const v2 = $518bb137cbdf72c3$exports(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return "major";
        // Otherwise it can be determined by checking the high version
        if (highVersion.patch) // anything higher than a patch bump would result in the wrong version
        return "patch";
        if (highVersion.minor) // anything higher than a minor bump would result in the wrong version
        return "minor";
        // bumping major/minor/patch all have same result
        return "major";
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? "pre" : "";
    if (v1.major !== v2.major) return prefix + "major";
    if (v1.minor !== v2.minor) return prefix + "minor";
    if (v1.patch !== v2.patch) return prefix + "patch";
    // high and low are preleases
    return "prerelease";
};
$ab0877022a91d748$exports = $ab0877022a91d748$var$diff;


var $3c98d7b64d202a78$exports = {};

const $3c98d7b64d202a78$var$major = (a, loose)=>new $df90e8d1cf1cf055$exports(a, loose).major;
$3c98d7b64d202a78$exports = $3c98d7b64d202a78$var$major;


var $6e90b5c2fe90feeb$exports = {};

const $6e90b5c2fe90feeb$var$minor = (a, loose)=>new $df90e8d1cf1cf055$exports(a, loose).minor;
$6e90b5c2fe90feeb$exports = $6e90b5c2fe90feeb$var$minor;


var $4c2948a32081632b$exports = {};

const $4c2948a32081632b$var$patch = (a, loose)=>new $df90e8d1cf1cf055$exports(a, loose).patch;
$4c2948a32081632b$exports = $4c2948a32081632b$var$patch;


var $93a6413aa1f64654$exports = {};

const $93a6413aa1f64654$var$prerelease = (version, options)=>{
    const parsed = $518bb137cbdf72c3$exports(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
$93a6413aa1f64654$exports = $93a6413aa1f64654$var$prerelease;


var $81994ac4c012d104$exports = {};

const $81994ac4c012d104$var$compare = (a, b, loose)=>new $df90e8d1cf1cf055$exports(a, loose).compare(new $df90e8d1cf1cf055$exports(b, loose));
$81994ac4c012d104$exports = $81994ac4c012d104$var$compare;


var $4d852d6325ac3f0a$exports = {};

const $4d852d6325ac3f0a$var$rcompare = (a, b, loose)=>$81994ac4c012d104$exports(b, a, loose);
$4d852d6325ac3f0a$exports = $4d852d6325ac3f0a$var$rcompare;


var $5341c4d7c3ddc057$exports = {};

const $5341c4d7c3ddc057$var$compareLoose = (a, b)=>$81994ac4c012d104$exports(a, b, true);
$5341c4d7c3ddc057$exports = $5341c4d7c3ddc057$var$compareLoose;


var $20d4c8016361ffad$exports = {};

const $20d4c8016361ffad$var$compareBuild = (a, b, loose)=>{
    const versionA = new $df90e8d1cf1cf055$exports(a, loose);
    const versionB = new $df90e8d1cf1cf055$exports(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
$20d4c8016361ffad$exports = $20d4c8016361ffad$var$compareBuild;


var $49bbf04266a7f106$exports = {};

const $49bbf04266a7f106$var$sort = (list, loose)=>list.sort((a, b)=>$20d4c8016361ffad$exports(a, b, loose));
$49bbf04266a7f106$exports = $49bbf04266a7f106$var$sort;


var $3c149acde0254244$exports = {};

const $3c149acde0254244$var$rsort = (list, loose)=>list.sort((a, b)=>$20d4c8016361ffad$exports(b, a, loose));
$3c149acde0254244$exports = $3c149acde0254244$var$rsort;


var $104422eefe356e5b$exports = {};

const $104422eefe356e5b$var$gt = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) > 0;
$104422eefe356e5b$exports = $104422eefe356e5b$var$gt;


var $f6d98cb923c33015$exports = {};

const $f6d98cb923c33015$var$lt = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) < 0;
$f6d98cb923c33015$exports = $f6d98cb923c33015$var$lt;


var $5e5d028df14dc03a$exports = {};

const $5e5d028df14dc03a$var$eq = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) === 0;
$5e5d028df14dc03a$exports = $5e5d028df14dc03a$var$eq;


var $3334214f1b360179$exports = {};

const $3334214f1b360179$var$neq = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) !== 0;
$3334214f1b360179$exports = $3334214f1b360179$var$neq;


var $c707a43d6c3b801a$exports = {};

const $c707a43d6c3b801a$var$gte = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) >= 0;
$c707a43d6c3b801a$exports = $c707a43d6c3b801a$var$gte;


var $aaf185a79a690d76$exports = {};

const $aaf185a79a690d76$var$lte = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) <= 0;
$aaf185a79a690d76$exports = $aaf185a79a690d76$var$lte;


var $2272a34159523aa5$exports = {};






const $2272a34159523aa5$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return $5e5d028df14dc03a$exports(a, b, loose);
        case "!=":
            return $3334214f1b360179$exports(a, b, loose);
        case ">":
            return $104422eefe356e5b$exports(a, b, loose);
        case ">=":
            return $c707a43d6c3b801a$exports(a, b, loose);
        case "<":
            return $f6d98cb923c33015$exports(a, b, loose);
        case "<=":
            return $aaf185a79a690d76$exports(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
$2272a34159523aa5$exports = $2272a34159523aa5$var$cmp;


var $1fceaff8ff23f299$exports = {};



var $kGRcS = parcelRequire("kGRcS");
var $1fceaff8ff23f299$require$re = $kGRcS.safeRe;
var $1fceaff8ff23f299$require$t = $kGRcS.t;
const $1fceaff8ff23f299$var$coerce = (version, options)=>{
    if (version instanceof $df90e8d1cf1cf055$exports) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCEFULL] : $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCERTLFULL] : $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || "0";
    const patch = match[4] || "0";
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : "";
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : "";
    return $518bb137cbdf72c3$exports(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
$1fceaff8ff23f299$exports = $1fceaff8ff23f299$var$coerce;


var $3d29c357640e9d06$exports = {};
const $3d29c357640e9d06$var$ANY = Symbol("SemVer ANY");
// hoisted class for cyclic dependency
class $3d29c357640e9d06$var$Comparator {
    static get ANY() {
        return $3d29c357640e9d06$var$ANY;
    }
    constructor(comp, options){
        options = $100fa442ed30ac34$exports(options);
        if (comp instanceof $3d29c357640e9d06$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(" ");
        $i9RZm("comparator", comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $3d29c357640e9d06$var$ANY) this.value = "";
        else this.value = this.operator + this.semver.version;
        $i9RZm("comp", this);
    }
    parse(comp) {
        const r = this.options.loose ? $3d29c357640e9d06$require$re[$3d29c357640e9d06$require$t.COMPARATORLOOSE] : $3d29c357640e9d06$require$re[$3d29c357640e9d06$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : "";
        if (this.operator === "=") this.operator = "";
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $3d29c357640e9d06$var$ANY;
        else this.semver = new $df90e8d1cf1cf055$exports(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $i9RZm("Comparator.test", version, this.options.loose);
        if (this.semver === $3d29c357640e9d06$var$ANY || version === $3d29c357640e9d06$var$ANY) return true;
        if (typeof version === "string") try {
            version = new $df90e8d1cf1cf055$exports(version, this.options);
        } catch (er) {
            return false;
        }
        return $2272a34159523aa5$exports(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $3d29c357640e9d06$var$Comparator)) throw new TypeError("a Comparator is required");
        if (this.operator === "") {
            if (this.value === "") return true;
            return new $36512a6be0346a51$exports(comp.value, options).test(this.value);
        } else if (comp.operator === "") {
            if (comp.value === "") return true;
            return new $36512a6be0346a51$exports(this.value, options).test(comp.semver);
        }
        options = $100fa442ed30ac34$exports(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === "<0.0.0-0" || comp.value === "<0.0.0-0")) return false;
        if (!options.includePrerelease && (this.value.startsWith("<0.0.0") || comp.value.startsWith("<0.0.0"))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith(">") && comp.operator.startsWith(">")) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith("<") && comp.operator.startsWith("<")) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes("=") && comp.operator.includes("=")) return true;
        // opposite directions less than
        if ($2272a34159523aa5$exports(this.semver, "<", comp.semver, options) && this.operator.startsWith(">") && comp.operator.startsWith("<")) return true;
        // opposite directions greater than
        if ($2272a34159523aa5$exports(this.semver, ">", comp.semver, options) && this.operator.startsWith("<") && comp.operator.startsWith(">")) return true;
        return false;
    }
}
$3d29c357640e9d06$exports = $3d29c357640e9d06$var$Comparator;


var $kGRcS = parcelRequire("kGRcS");
var $3d29c357640e9d06$require$re = $kGRcS.safeRe;
var $3d29c357640e9d06$require$t = $kGRcS.t;


var $i9RZm = parcelRequire("i9RZm");

var $36512a6be0346a51$exports = {};
// hoisted class for cyclic dependency
class $36512a6be0346a51$var$Range {
    constructor(range, options){
        options = $100fa442ed30ac34$exports(options);
        if (range instanceof $36512a6be0346a51$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $36512a6be0346a51$var$Range(range.raw, options);
        }
        if (range instanceof $3d29c357640e9d06$exports) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.format();
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().split(/\s+/).join(" ");
        // First, split on ||
        this.set = this.raw.split("||")// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$36512a6be0346a51$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $36512a6be0346a51$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.format();
    }
    format() {
        this.range = this.set.map((comps)=>comps.join(" ").trim()).join("||").trim();
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && $36512a6be0346a51$require$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $36512a6be0346a51$require$FLAG_LOOSE);
        const memoKey = memoOpts + ":" + range;
        const cached = $36512a6be0346a51$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.HYPHENRANGELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.HYPHENRANGE];
        range = range.replace(hr, $36512a6be0346a51$var$hyphenReplace(this.options.includePrerelease));
        $i9RZm("hyphen replace", range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.COMPARATORTRIM], $36512a6be0346a51$require$comparatorTrimReplace);
        $i9RZm("comparator trim", range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDETRIM], $36512a6be0346a51$require$tildeTrimReplace);
        $i9RZm("tilde trim", range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARETTRIM], $36512a6be0346a51$require$caretTrimReplace);
        $i9RZm("caret trim", range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(" ").map((comp)=>$36512a6be0346a51$var$parseComparator(comp, this.options)).join(" ").split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$36512a6be0346a51$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $i9RZm("loose invalid filter", comp, this.options);
            return !!comp.match($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.COMPARATORLOOSE]);
        });
        $i9RZm("range list", rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $3d29c357640e9d06$exports(comp, this.options));
        for (const comp of comparators){
            if ($36512a6be0346a51$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has("")) rangeMap.delete("");
        const result = [
            ...rangeMap.values()
        ];
        $36512a6be0346a51$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $36512a6be0346a51$var$Range)) throw new TypeError("a Range is required");
        return this.set.some((thisComparators)=>{
            return $36512a6be0346a51$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $36512a6be0346a51$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === "string") try {
            version = new $df90e8d1cf1cf055$exports(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($36512a6be0346a51$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
$36512a6be0346a51$exports = $36512a6be0346a51$var$Range;
var $849cd0fb8cde656f$exports = {};
"use strict";
var $3f3c3e91d91e9f6c$exports = {};
"use strict";
$3f3c3e91d91e9f6c$exports = $3f3c3e91d91e9f6c$var$Yallist;
$3f3c3e91d91e9f6c$var$Yallist.Node = $3f3c3e91d91e9f6c$var$Node;
$3f3c3e91d91e9f6c$var$Yallist.create = $3f3c3e91d91e9f6c$var$Yallist;
function $3f3c3e91d91e9f6c$var$Yallist(list) {
    var self = this;
    if (!(self instanceof $3f3c3e91d91e9f6c$var$Yallist)) self = new $3f3c3e91d91e9f6c$var$Yallist();
    self.tail = null;
    self.head = null;
    self.length = 0;
    if (list && typeof list.forEach === "function") list.forEach(function(item) {
        self.push(item);
    });
    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self.push(arguments[i]);
    return self;
}
$3f3c3e91d91e9f6c$var$Yallist.prototype.removeNode = function(node) {
    if (node.list !== this) throw new Error("removing node which does not belong to this list");
    var next = node.next;
    var prev = node.prev;
    if (next) next.prev = prev;
    if (prev) prev.next = next;
    if (node === this.head) this.head = next;
    if (node === this.tail) this.tail = prev;
    node.list.length--;
    node.next = null;
    node.prev = null;
    node.list = null;
    return next;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.unshiftNode = function(node) {
    if (node === this.head) return;
    if (node.list) node.list.removeNode(node);
    var head = this.head;
    node.list = this;
    node.next = head;
    if (head) head.prev = node;
    this.head = node;
    if (!this.tail) this.tail = node;
    this.length++;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.pushNode = function(node) {
    if (node === this.tail) return;
    if (node.list) node.list.removeNode(node);
    var tail = this.tail;
    node.list = this;
    node.prev = tail;
    if (tail) tail.next = node;
    this.tail = node;
    if (!this.head) this.head = node;
    this.length++;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.push = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$3f3c3e91d91e9f6c$var$push(this, arguments[i]);
    return this.length;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.unshift = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$3f3c3e91d91e9f6c$var$unshift(this, arguments[i]);
    return this.length;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.pop = function() {
    if (!this.tail) return undefined;
    var res = this.tail.value;
    this.tail = this.tail.prev;
    if (this.tail) this.tail.next = null;
    else this.head = null;
    this.length--;
    return res;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.shift = function() {
    if (!this.head) return undefined;
    var res = this.head.value;
    this.head = this.head.next;
    if (this.head) this.head.prev = null;
    else this.tail = null;
    this.length--;
    return res;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.forEach = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.head, i = 0; walker !== null; i++){
        fn.call(thisp, walker.value, i, this);
        walker = walker.next;
    }
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.forEachReverse = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
        fn.call(thisp, walker.value, i, this);
        walker = walker.prev;
    }
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.get = function(n) {
    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.next;
    if (i === n && walker !== null) return walker.value;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.getReverse = function(n) {
    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.prev;
    if (i === n && walker !== null) return walker.value;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.map = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $3f3c3e91d91e9f6c$var$Yallist();
    for(var walker = this.head; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.next;
    }
    return res;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.mapReverse = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $3f3c3e91d91e9f6c$var$Yallist();
    for(var walker = this.tail; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.prev;
    }
    return res;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.reduce = function(fn, initial) {
    var acc;
    var walker = this.head;
    if (arguments.length > 1) acc = initial;
    else if (this.head) {
        walker = this.head.next;
        acc = this.head.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = 0; walker !== null; i++){
        acc = fn(acc, walker.value, i);
        walker = walker.next;
    }
    return acc;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.reduceReverse = function(fn, initial) {
    var acc;
    var walker = this.tail;
    if (arguments.length > 1) acc = initial;
    else if (this.tail) {
        walker = this.tail.prev;
        acc = this.tail.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = this.length - 1; walker !== null; i--){
        acc = fn(acc, walker.value, i);
        walker = walker.prev;
    }
    return acc;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.toArray = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.head; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.next;
    }
    return arr;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.toArrayReverse = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.tail; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.prev;
    }
    return arr;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.slice = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $3f3c3e91d91e9f6c$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
    return ret;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.sliceReverse = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $3f3c3e91d91e9f6c$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
    return ret;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.splice = function(start, deleteCount, ...nodes) {
    if (start > this.length) start = this.length - 1;
    if (start < 0) start = this.length + start;
    for(var i = 0, walker = this.head; walker !== null && i < start; i++)walker = walker.next;
    var ret = [];
    for(var i = 0; walker && i < deleteCount; i++){
        ret.push(walker.value);
        walker = this.removeNode(walker);
    }
    if (walker === null) walker = this.tail;
    if (walker !== this.head && walker !== this.tail) walker = walker.prev;
    for(var i = 0; i < nodes.length; i++)walker = $3f3c3e91d91e9f6c$var$insert(this, walker, nodes[i]);
    return ret;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.reverse = function() {
    var head = this.head;
    var tail = this.tail;
    for(var walker = head; walker !== null; walker = walker.prev){
        var p = walker.prev;
        walker.prev = walker.next;
        walker.next = p;
    }
    this.head = tail;
    this.tail = head;
    return this;
};
function $3f3c3e91d91e9f6c$var$insert(self, node, value) {
    var inserted = node === self.head ? new $3f3c3e91d91e9f6c$var$Node(value, null, node, self) : new $3f3c3e91d91e9f6c$var$Node(value, node, node.next, self);
    if (inserted.next === null) self.tail = inserted;
    if (inserted.prev === null) self.head = inserted;
    self.length++;
    return inserted;
}
function $3f3c3e91d91e9f6c$var$push(self, item) {
    self.tail = new $3f3c3e91d91e9f6c$var$Node(item, self.tail, null, self);
    if (!self.head) self.head = self.tail;
    self.length++;
}
function $3f3c3e91d91e9f6c$var$unshift(self, item) {
    self.head = new $3f3c3e91d91e9f6c$var$Node(item, null, self.head, self);
    if (!self.tail) self.tail = self.head;
    self.length++;
}
function $3f3c3e91d91e9f6c$var$Node(value, prev, next, list) {
    if (!(this instanceof $3f3c3e91d91e9f6c$var$Node)) return new $3f3c3e91d91e9f6c$var$Node(value, prev, next, list);
    this.list = list;
    this.value = value;
    if (prev) {
        prev.next = this;
        this.prev = prev;
    } else this.prev = null;
    if (next) {
        next.prev = this;
        this.next = next;
    } else this.next = null;
}

try {
    // add if support for Symbol.iterator is present
    (parcelRequire("fcGo5"))($3f3c3e91d91e9f6c$var$Yallist);
} catch (er) {}


const $849cd0fb8cde656f$var$MAX = Symbol("max");
const $849cd0fb8cde656f$var$LENGTH = Symbol("length");
const $849cd0fb8cde656f$var$LENGTH_CALCULATOR = Symbol("lengthCalculator");
const $849cd0fb8cde656f$var$ALLOW_STALE = Symbol("allowStale");
const $849cd0fb8cde656f$var$MAX_AGE = Symbol("maxAge");
const $849cd0fb8cde656f$var$DISPOSE = Symbol("dispose");
const $849cd0fb8cde656f$var$NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
const $849cd0fb8cde656f$var$LRU_LIST = Symbol("lruList");
const $849cd0fb8cde656f$var$CACHE = Symbol("cache");
const $849cd0fb8cde656f$var$UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
const $849cd0fb8cde656f$var$naiveLength = ()=>1;
// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
class $849cd0fb8cde656f$var$LRUCache {
    constructor(options){
        if (typeof options === "number") options = {
            max: options
        };
        if (!options) options = {};
        if (options.max && (typeof options.max !== "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
        // Kind of weird to have a default max of Infinity, but oh well.
        const max = this[$849cd0fb8cde656f$var$MAX] = options.max || Infinity;
        const lc = options.length || $849cd0fb8cde656f$var$naiveLength;
        this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR] = typeof lc !== "function" ? $849cd0fb8cde656f$var$naiveLength : lc;
        this[$849cd0fb8cde656f$var$ALLOW_STALE] = options.stale || false;
        if (options.maxAge && typeof options.maxAge !== "number") throw new TypeError("maxAge must be a number");
        this[$849cd0fb8cde656f$var$MAX_AGE] = options.maxAge || 0;
        this[$849cd0fb8cde656f$var$DISPOSE] = options.dispose;
        this[$849cd0fb8cde656f$var$NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
        this[$849cd0fb8cde656f$var$UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
        this.reset();
    }
    // resize the cache when the max changes.
    set max(mL) {
        if (typeof mL !== "number" || mL < 0) throw new TypeError("max must be a non-negative number");
        this[$849cd0fb8cde656f$var$MAX] = mL || Infinity;
        $849cd0fb8cde656f$var$trim(this);
    }
    get max() {
        return this[$849cd0fb8cde656f$var$MAX];
    }
    set allowStale(allowStale) {
        this[$849cd0fb8cde656f$var$ALLOW_STALE] = !!allowStale;
    }
    get allowStale() {
        return this[$849cd0fb8cde656f$var$ALLOW_STALE];
    }
    set maxAge(mA) {
        if (typeof mA !== "number") throw new TypeError("maxAge must be a non-negative number");
        this[$849cd0fb8cde656f$var$MAX_AGE] = mA;
        $849cd0fb8cde656f$var$trim(this);
    }
    get maxAge() {
        return this[$849cd0fb8cde656f$var$MAX_AGE];
    }
    // resize the cache when the lengthCalculator changes.
    set lengthCalculator(lC) {
        if (typeof lC !== "function") lC = $849cd0fb8cde656f$var$naiveLength;
        if (lC !== this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR]) {
            this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR] = lC;
            this[$849cd0fb8cde656f$var$LENGTH] = 0;
            this[$849cd0fb8cde656f$var$LRU_LIST].forEach((hit)=>{
                hit.length = this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR](hit.value, hit.key);
                this[$849cd0fb8cde656f$var$LENGTH] += hit.length;
            });
        }
        $849cd0fb8cde656f$var$trim(this);
    }
    get lengthCalculator() {
        return this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR];
    }
    get length() {
        return this[$849cd0fb8cde656f$var$LENGTH];
    }
    get itemCount() {
        return this[$849cd0fb8cde656f$var$LRU_LIST].length;
    }
    rforEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$849cd0fb8cde656f$var$LRU_LIST].tail; walker !== null;){
            const prev = walker.prev;
            $849cd0fb8cde656f$var$forEachStep(this, fn, walker, thisp);
            walker = prev;
        }
    }
    forEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$849cd0fb8cde656f$var$LRU_LIST].head; walker !== null;){
            const next = walker.next;
            $849cd0fb8cde656f$var$forEachStep(this, fn, walker, thisp);
            walker = next;
        }
    }
    keys() {
        return this[$849cd0fb8cde656f$var$LRU_LIST].toArray().map((k)=>k.key);
    }
    values() {
        return this[$849cd0fb8cde656f$var$LRU_LIST].toArray().map((k)=>k.value);
    }
    reset() {
        if (this[$849cd0fb8cde656f$var$DISPOSE] && this[$849cd0fb8cde656f$var$LRU_LIST] && this[$849cd0fb8cde656f$var$LRU_LIST].length) this[$849cd0fb8cde656f$var$LRU_LIST].forEach((hit)=>this[$849cd0fb8cde656f$var$DISPOSE](hit.key, hit.value));
        this[$849cd0fb8cde656f$var$CACHE] = new Map() // hash of items by key
        ;
        this[$849cd0fb8cde656f$var$LRU_LIST] = new $3f3c3e91d91e9f6c$exports() // list of items in order of use recency
        ;
        this[$849cd0fb8cde656f$var$LENGTH] = 0 // length of items in the list
        ;
    }
    dump() {
        return this[$849cd0fb8cde656f$var$LRU_LIST].map((hit)=>$849cd0fb8cde656f$var$isStale(this, hit) ? false : {
                k: hit.key,
                v: hit.value,
                e: hit.now + (hit.maxAge || 0)
            }).toArray().filter((h)=>h);
    }
    dumpLru() {
        return this[$849cd0fb8cde656f$var$LRU_LIST];
    }
    set(key, value, maxAge) {
        maxAge = maxAge || this[$849cd0fb8cde656f$var$MAX_AGE];
        if (maxAge && typeof maxAge !== "number") throw new TypeError("maxAge must be a number");
        const now = maxAge ? Date.now() : 0;
        const len = this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR](value, key);
        if (this[$849cd0fb8cde656f$var$CACHE].has(key)) {
            if (len > this[$849cd0fb8cde656f$var$MAX]) {
                $849cd0fb8cde656f$var$del(this, this[$849cd0fb8cde656f$var$CACHE].get(key));
                return false;
            }
            const node = this[$849cd0fb8cde656f$var$CACHE].get(key);
            const item = node.value;
            // dispose of the old one before overwriting
            // split out into 2 ifs for better coverage tracking
            if (this[$849cd0fb8cde656f$var$DISPOSE]) {
                if (!this[$849cd0fb8cde656f$var$NO_DISPOSE_ON_SET]) this[$849cd0fb8cde656f$var$DISPOSE](key, item.value);
            }
            item.now = now;
            item.maxAge = maxAge;
            item.value = value;
            this[$849cd0fb8cde656f$var$LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            $849cd0fb8cde656f$var$trim(this);
            return true;
        }
        const hit = new $849cd0fb8cde656f$var$Entry(key, value, len, now, maxAge);
        // oversized objects fall out of cache automatically.
        if (hit.length > this[$849cd0fb8cde656f$var$MAX]) {
            if (this[$849cd0fb8cde656f$var$DISPOSE]) this[$849cd0fb8cde656f$var$DISPOSE](key, value);
            return false;
        }
        this[$849cd0fb8cde656f$var$LENGTH] += hit.length;
        this[$849cd0fb8cde656f$var$LRU_LIST].unshift(hit);
        this[$849cd0fb8cde656f$var$CACHE].set(key, this[$849cd0fb8cde656f$var$LRU_LIST].head);
        $849cd0fb8cde656f$var$trim(this);
        return true;
    }
    has(key) {
        if (!this[$849cd0fb8cde656f$var$CACHE].has(key)) return false;
        const hit = this[$849cd0fb8cde656f$var$CACHE].get(key).value;
        return !$849cd0fb8cde656f$var$isStale(this, hit);
    }
    get(key) {
        return $849cd0fb8cde656f$var$get(this, key, true);
    }
    peek(key) {
        return $849cd0fb8cde656f$var$get(this, key, false);
    }
    pop() {
        const node = this[$849cd0fb8cde656f$var$LRU_LIST].tail;
        if (!node) return null;
        $849cd0fb8cde656f$var$del(this, node);
        return node.value;
    }
    del(key) {
        $849cd0fb8cde656f$var$del(this, this[$849cd0fb8cde656f$var$CACHE].get(key));
    }
    load(arr) {
        // reset the cache
        this.reset();
        const now = Date.now();
        // A previous serialized cache has the most recent items first
        for(let l = arr.length - 1; l >= 0; l--){
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0) // the item was created without expiration in a non aged cache
            this.set(hit.k, hit.v);
            else {
                const maxAge = expiresAt - now;
                // dont add already expired items
                if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
            }
        }
    }
    prune() {
        this[$849cd0fb8cde656f$var$CACHE].forEach((value, key)=>$849cd0fb8cde656f$var$get(this, key, false));
    }
}
const $849cd0fb8cde656f$var$get = (self, key, doUse)=>{
    const node = self[$849cd0fb8cde656f$var$CACHE].get(key);
    if (node) {
        const hit = node.value;
        if ($849cd0fb8cde656f$var$isStale(self, hit)) {
            $849cd0fb8cde656f$var$del(self, node);
            if (!self[$849cd0fb8cde656f$var$ALLOW_STALE]) return undefined;
        } else if (doUse) {
            if (self[$849cd0fb8cde656f$var$UPDATE_AGE_ON_GET]) node.value.now = Date.now();
            self[$849cd0fb8cde656f$var$LRU_LIST].unshiftNode(node);
        }
        return hit.value;
    }
};
const $849cd0fb8cde656f$var$isStale = (self, hit)=>{
    if (!hit || !hit.maxAge && !self[$849cd0fb8cde656f$var$MAX_AGE]) return false;
    const diff = Date.now() - hit.now;
    return hit.maxAge ? diff > hit.maxAge : self[$849cd0fb8cde656f$var$MAX_AGE] && diff > self[$849cd0fb8cde656f$var$MAX_AGE];
};
const $849cd0fb8cde656f$var$trim = (self)=>{
    if (self[$849cd0fb8cde656f$var$LENGTH] > self[$849cd0fb8cde656f$var$MAX]) for(let walker = self[$849cd0fb8cde656f$var$LRU_LIST].tail; self[$849cd0fb8cde656f$var$LENGTH] > self[$849cd0fb8cde656f$var$MAX] && walker !== null;){
        // We know that we're about to delete this one, and also
        // what the next least recently used key will be, so just
        // go ahead and set it now.
        const prev = walker.prev;
        $849cd0fb8cde656f$var$del(self, walker);
        walker = prev;
    }
};
const $849cd0fb8cde656f$var$del = (self, node)=>{
    if (node) {
        const hit = node.value;
        if (self[$849cd0fb8cde656f$var$DISPOSE]) self[$849cd0fb8cde656f$var$DISPOSE](hit.key, hit.value);
        self[$849cd0fb8cde656f$var$LENGTH] -= hit.length;
        self[$849cd0fb8cde656f$var$CACHE].delete(hit.key);
        self[$849cd0fb8cde656f$var$LRU_LIST].removeNode(node);
    }
};
class $849cd0fb8cde656f$var$Entry {
    constructor(key, value, length, now, maxAge){
        this.key = key;
        this.value = value;
        this.length = length;
        this.now = now;
        this.maxAge = maxAge || 0;
    }
}
const $849cd0fb8cde656f$var$forEachStep = (self, fn, node, thisp)=>{
    let hit = node.value;
    if ($849cd0fb8cde656f$var$isStale(self, hit)) {
        $849cd0fb8cde656f$var$del(self, node);
        if (!self[$849cd0fb8cde656f$var$ALLOW_STALE]) hit = undefined;
    }
    if (hit) fn.call(thisp, hit.value, hit.key, self);
};
$849cd0fb8cde656f$exports = $849cd0fb8cde656f$var$LRUCache;


const $36512a6be0346a51$var$cache = new $849cd0fb8cde656f$exports({
    max: 1000
});



var $i9RZm = parcelRequire("i9RZm");


var $kGRcS = parcelRequire("kGRcS");
var $36512a6be0346a51$require$re = $kGRcS.safeRe;
var $36512a6be0346a51$require$t = $kGRcS.t;
var $36512a6be0346a51$require$comparatorTrimReplace = $kGRcS.comparatorTrimReplace;
var $36512a6be0346a51$require$tildeTrimReplace = $kGRcS.tildeTrimReplace;
var $36512a6be0346a51$require$caretTrimReplace = $kGRcS.caretTrimReplace;

var $fJ45P = parcelRequire("fJ45P");
var $36512a6be0346a51$require$FLAG_INCLUDE_PRERELEASE = $fJ45P.FLAG_INCLUDE_PRERELEASE;
var $36512a6be0346a51$require$FLAG_LOOSE = $fJ45P.FLAG_LOOSE;
const $36512a6be0346a51$var$isNullSet = (c)=>c.value === "<0.0.0-0";
const $36512a6be0346a51$var$isAny = (c)=>c.value === "";
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $36512a6be0346a51$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $36512a6be0346a51$var$parseComparator = (comp, options)=>{
    $i9RZm("comp", comp, options);
    comp = $36512a6be0346a51$var$replaceCarets(comp, options);
    $i9RZm("caret", comp);
    comp = $36512a6be0346a51$var$replaceTildes(comp, options);
    $i9RZm("tildes", comp);
    comp = $36512a6be0346a51$var$replaceXRanges(comp, options);
    $i9RZm("xrange", comp);
    comp = $36512a6be0346a51$var$replaceStars(comp, options);
    $i9RZm("stars", comp);
    return comp;
};
const $36512a6be0346a51$var$isX = (id)=>!id || id.toLowerCase() === "x" || id === "*";
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $36512a6be0346a51$var$replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceTilde(c, options)).join(" ");
};
const $36512a6be0346a51$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        $i9RZm("tilde", comp, _, M, m, p, pr);
        let ret;
        if ($36512a6be0346a51$var$isX(M)) ret = "";
        else if ($36512a6be0346a51$var$isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $i9RZm("replaceTilde pr", pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $i9RZm("tilde return", ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $36512a6be0346a51$var$replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceCaret(c, options)).join(" ");
};
const $36512a6be0346a51$var$replaceCaret = (comp, options)=>{
    $i9RZm("caret", comp, options);
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARETLOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARET];
    const z = options.includePrerelease ? "-0" : "";
    return comp.replace(r, (_, M, m, p, pr)=>{
        $i9RZm("caret", comp, _, M, m, p, pr);
        let ret;
        if ($36512a6be0346a51$var$isX(M)) ret = "";
        else if ($36512a6be0346a51$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(p)) {
            if (M === "0") ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $i9RZm("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $i9RZm("no pr");
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $i9RZm("caret return", ret);
        return ret;
    });
};
const $36512a6be0346a51$var$replaceXRanges = (comp, options)=>{
    $i9RZm("replaceXRanges", comp, options);
    return comp.split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceXRange(c, options)).join(" ");
};
const $36512a6be0346a51$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.XRANGELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $i9RZm("xRange", comp, ret, gtlt, M, m, p, pr);
        const xM = $36512a6be0346a51$var$isX(M);
        const xm = xM || $36512a6be0346a51$var$isX(m);
        const xp = xm || $36512a6be0346a51$var$isX(p);
        const anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === "<") pr = "-0";
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $i9RZm("xRange return", ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $36512a6be0346a51$var$replaceStars = (comp, options)=>{
    $i9RZm("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.STAR], "");
};
const $36512a6be0346a51$var$replaceGTE0 = (comp, options)=>{
    $i9RZm("replaceGTE0", comp, options);
    return comp.trim().replace($36512a6be0346a51$require$re[options.includePrerelease ? $36512a6be0346a51$require$t.GTE0PRE : $36512a6be0346a51$require$t.GTE0], "");
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
const $36512a6be0346a51$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb)=>{
        if ($36512a6be0346a51$var$isX(fM)) from = "";
        else if ($36512a6be0346a51$var$isX(fm)) from = `>=${fM}.0.0${incPr ? "-0" : ""}`;
        else if ($36512a6be0346a51$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? "-0" : ""}`;
        if ($36512a6be0346a51$var$isX(tM)) to = "";
        else if ($36512a6be0346a51$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $36512a6be0346a51$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $i9RZm(set[i].semver);
            if (set[i].semver === $3d29c357640e9d06$exports.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};





var $44370327d4e393bf$exports = {};

const $44370327d4e393bf$var$satisfies = (version, range, options)=>{
    try {
        range = new $36512a6be0346a51$exports(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
$44370327d4e393bf$exports = $44370327d4e393bf$var$satisfies;


var $6bf6930ad20f8979$exports = {};

// Mostly just for testing and legacy API reasons
const $6bf6930ad20f8979$var$toComparators = (range, options)=>new $36512a6be0346a51$exports(range, options).set.map((comp)=>comp.map((c)=>c.value).join(" ").trim().split(" "));
$6bf6930ad20f8979$exports = $6bf6930ad20f8979$var$toComparators;


var $2b2ac348dee0803e$exports = {};


const $2b2ac348dee0803e$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $36512a6be0346a51$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $df90e8d1cf1cf055$exports(max, options);
            }
        }
    });
    return max;
};
$2b2ac348dee0803e$exports = $2b2ac348dee0803e$var$maxSatisfying;


var $7a6650c8d62ec668$exports = {};


const $7a6650c8d62ec668$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $36512a6be0346a51$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $df90e8d1cf1cf055$exports(min, options);
            }
        }
    });
    return min;
};
$7a6650c8d62ec668$exports = $7a6650c8d62ec668$var$minSatisfying;


var $7389cc9c1db09b0d$exports = {};



const $7389cc9c1db09b0d$var$minVersion = (range, loose)=>{
    range = new $36512a6be0346a51$exports(range, loose);
    let minver = new $df90e8d1cf1cf055$exports("0.0.0");
    if (range.test(minver)) return minver;
    minver = new $df90e8d1cf1cf055$exports("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $df90e8d1cf1cf055$exports(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!setMin || $104422eefe356e5b$exports(compver, setMin)) setMin = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $104422eefe356e5b$exports(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
$7389cc9c1db09b0d$exports = $7389cc9c1db09b0d$var$minVersion;


var $16299f7793385cf3$exports = {};

const $16299f7793385cf3$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $36512a6be0346a51$exports(range, options).range || "*";
    } catch (er) {
        return null;
    }
};
$16299f7793385cf3$exports = $16299f7793385cf3$var$validRange;


var $546520af951b9b5a$exports = {};


const { ANY: $546520af951b9b5a$var$ANY } = $3d29c357640e9d06$exports;






const $546520af951b9b5a$var$outside = (version, range, hilo, options)=>{
    version = new $df90e8d1cf1cf055$exports(version, options);
    range = new $36512a6be0346a51$exports(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = $104422eefe356e5b$exports;
            ltefn = $aaf185a79a690d76$exports;
            ltfn = $f6d98cb923c33015$exports;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = $f6d98cb923c33015$exports;
            ltefn = $c707a43d6c3b801a$exports;
            ltfn = $104422eefe356e5b$exports;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($44370327d4e393bf$exports(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $546520af951b9b5a$var$ANY) comparator = new $3d29c357640e9d06$exports(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
$546520af951b9b5a$exports = $546520af951b9b5a$var$outside;


var $6e6f2ea8eb78962a$exports = {};
// Determine if version is greater than all the versions possible in the range.

const $6e6f2ea8eb78962a$var$gtr = (version, range, options)=>$546520af951b9b5a$exports(version, range, ">", options);
$6e6f2ea8eb78962a$exports = $6e6f2ea8eb78962a$var$gtr;


var $0d167156795b8123$exports = {};

// Determine if version is less than all the versions possible in the range
const $0d167156795b8123$var$ltr = (version, range, options)=>$546520af951b9b5a$exports(version, range, "<", options);
$0d167156795b8123$exports = $0d167156795b8123$var$ltr;


var $ff0b302dd979be82$exports = {};

const $ff0b302dd979be82$var$intersects = (r1, r2, options)=>{
    r1 = new $36512a6be0346a51$exports(r1, options);
    r2 = new $36512a6be0346a51$exports(r2, options);
    return r1.intersects(r2, options);
};
$ff0b302dd979be82$exports = $ff0b302dd979be82$var$intersects;


var $72b9b4c6a1649533$exports = {};
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.


$72b9b4c6a1649533$exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$81994ac4c012d104$exports(a, b, options));
    for (const version of v){
        const included = $44370327d4e393bf$exports(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push("*");
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(" || ");
    const original = typeof range.raw === "string" ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};


var $4a5bb988105271bd$exports = {};


const { ANY: $4a5bb988105271bd$var$ANY } = $3d29c357640e9d06$exports;


// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $4a5bb988105271bd$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $36512a6be0346a51$exports(sub, options);
    dom = new $36512a6be0346a51$exports(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $4a5bb988105271bd$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $4a5bb988105271bd$var$minimumVersionWithPreRelease = [
    new $3d29c357640e9d06$exports(">=0.0.0-0")
];
const $4a5bb988105271bd$var$minimumVersion = [
    new $3d29c357640e9d06$exports(">=0.0.0")
];
const $4a5bb988105271bd$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $4a5bb988105271bd$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $4a5bb988105271bd$var$ANY) return true;
        else if (options.includePrerelease) sub = $4a5bb988105271bd$var$minimumVersionWithPreRelease;
        else sub = $4a5bb988105271bd$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $4a5bb988105271bd$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $4a5bb988105271bd$var$minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === ">" || c.operator === ">=") gt = $4a5bb988105271bd$var$higherGT(gt, c, options);
        else if (c.operator === "<" || c.operator === "<=") lt = $4a5bb988105271bd$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $81994ac4c012d104$exports(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== ">=" || lt.operator !== "<=")) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$44370327d4e393bf$exports(eq, String(gt), options)) return null;
        if (lt && !$44370327d4e393bf$exports(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$44370327d4e393bf$exports(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === "<" && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === ">" || c.operator === ">=";
        hasDomLT = hasDomLT || c.operator === "<" || c.operator === "<=";
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === ">" || c.operator === ">=") {
                higher = $4a5bb988105271bd$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === ">=" && !$44370327d4e393bf$exports(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === "<" || c.operator === "<=") {
                lower = $4a5bb988105271bd$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === "<=" && !$44370327d4e393bf$exports(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $4a5bb988105271bd$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $81994ac4c012d104$exports(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $4a5bb988105271bd$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $81994ac4c012d104$exports(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
};
$4a5bb988105271bd$exports = $4a5bb988105271bd$var$subset;


$dbb9fc904636819d$exports = {
    parse: $518bb137cbdf72c3$exports,
    valid: $c618592c32f826bd$exports,
    clean: $889491f0ea5a6118$exports,
    inc: $d4783bb52460fa90$exports,
    diff: $ab0877022a91d748$exports,
    major: $3c98d7b64d202a78$exports,
    minor: $6e90b5c2fe90feeb$exports,
    patch: $4c2948a32081632b$exports,
    prerelease: $93a6413aa1f64654$exports,
    compare: $81994ac4c012d104$exports,
    rcompare: $4d852d6325ac3f0a$exports,
    compareLoose: $5341c4d7c3ddc057$exports,
    compareBuild: $20d4c8016361ffad$exports,
    sort: $49bbf04266a7f106$exports,
    rsort: $3c149acde0254244$exports,
    gt: $104422eefe356e5b$exports,
    lt: $f6d98cb923c33015$exports,
    eq: $5e5d028df14dc03a$exports,
    neq: $3334214f1b360179$exports,
    gte: $c707a43d6c3b801a$exports,
    lte: $aaf185a79a690d76$exports,
    cmp: $2272a34159523aa5$exports,
    coerce: $1fceaff8ff23f299$exports,
    Comparator: $3d29c357640e9d06$exports,
    Range: $36512a6be0346a51$exports,
    satisfies: $44370327d4e393bf$exports,
    toComparators: $6bf6930ad20f8979$exports,
    maxSatisfying: $2b2ac348dee0803e$exports,
    minSatisfying: $7a6650c8d62ec668$exports,
    minVersion: $7389cc9c1db09b0d$exports,
    validRange: $16299f7793385cf3$exports,
    outside: $546520af951b9b5a$exports,
    gtr: $6e6f2ea8eb78962a$exports,
    ltr: $0d167156795b8123$exports,
    intersects: $ff0b302dd979be82$exports,
    simplifyRange: $72b9b4c6a1649533$exports,
    subset: $4a5bb988105271bd$exports,
    SemVer: $df90e8d1cf1cf055$exports,
    re: $kGRcS.re,
    src: $kGRcS.src,
    tokens: $kGRcS.t,
    SEMVER_SPEC_VERSION: $fJ45P.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $fJ45P.RELEASE_TYPES,
    compareIdentifiers: $ed5e7d6476f836e9$exports.compareIdentifiers,
    rcompareIdentifiers: $ed5e7d6476f836e9$exports.rcompareIdentifiers
};


var $5dec73da4f32e22b$var$__assign = undefined && undefined.__assign || function() {
    $5dec73da4f32e22b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5dec73da4f32e22b$var$__assign.apply(this, arguments);
};
var $5dec73da4f32e22b$var$_a;
var $5dec73da4f32e22b$export$36f742de2ed7d90b = 0x01;
var $5dec73da4f32e22b$export$54bc2e040474338c = 0x02;
var $5dec73da4f32e22b$export$9368aec5a4b02506 = 0x04;
var $5dec73da4f32e22b$export$95f5e559ebc551b3 = 0x08;
var $5dec73da4f32e22b$export$18b064749618be01 = 0x10;
var $5dec73da4f32e22b$export$b8d24b2c0d9c5549;
(function(DeviceModelId) {
    DeviceModelId["blue"] = "blue";
    DeviceModelId["nanoS"] = "nanoS";
    DeviceModelId["nanoSP"] = "nanoSP";
    DeviceModelId["nanoX"] = "nanoX";
    DeviceModelId["nanoFTS"] = "nanoFTS";
})($5dec73da4f32e22b$export$b8d24b2c0d9c5549 || ($5dec73da4f32e22b$export$b8d24b2c0d9c5549 = {}));
var $5dec73da4f32e22b$var$devices = ($5dec73da4f32e22b$var$_a = {}, $5dec73da4f32e22b$var$_a[$5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue] = {
    id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue,
    productName: "Ledger\xa0Blue",
    productIdMM: 0x00,
    legacyUsbProductId: 0x0000,
    usbOnly: true,
    memorySize: 491520,
    masks: [
        0x31000000,
        0x31010000
    ],
    getBlockSize: function(_firwareVersion) {
        return 4096;
    }
}, $5dec73da4f32e22b$var$_a[$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS] = {
    id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS,
    productName: "Ledger\xa0Nano\xa0S",
    productIdMM: 0x10,
    legacyUsbProductId: 0x0001,
    usbOnly: true,
    memorySize: 327680,
    masks: [
        0x31100000
    ],
    getBlockSize: function(firmwareVersion) {
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).lt((_a = (0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).coerce(firmwareVersion)) !== null && _a !== void 0 ? _a : "", "2.0.0") ? 4096 : 2048;
    }
}, $5dec73da4f32e22b$var$_a[$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP] = {
    id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP,
    productName: "Ledger Nano S Plus",
    productIdMM: 0x50,
    legacyUsbProductId: 0x0005,
    usbOnly: true,
    memorySize: 1572864,
    masks: [
        0x33100000
    ],
    getBlockSize: function(_firmwareVersion) {
        return 32;
    }
}, $5dec73da4f32e22b$var$_a[$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX] = {
    id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX,
    productName: "Ledger\xa0Nano\xa0X",
    productIdMM: 0x40,
    legacyUsbProductId: 0x0004,
    usbOnly: false,
    memorySize: 2097152,
    masks: [
        0x33000000
    ],
    getBlockSize: function(_firwareVersion) {
        return 4096;
    },
    bluetoothSpec: [
        {
            serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
            notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
            writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
            writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
        }
    ]
}, $5dec73da4f32e22b$var$_a[$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoFTS] = {
    id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoFTS,
    productName: "Ledger\xa0Nano\xa0FTS",
    productIdMM: 0x60,
    legacyUsbProductId: 0x0006,
    usbOnly: false,
    memorySize: 2097152,
    masks: [
        0x33200000
    ],
    getBlockSize: function(_firwareVersion) {
        return 4096;
    },
    bluetoothSpec: [
        {
            serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
            notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
            writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
            writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
        }
    ]
}, $5dec73da4f32e22b$var$_a);
var $5dec73da4f32e22b$var$productMap = {
    Blue: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue,
    "Nano S": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS,
    "Nano S Plus": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP,
    "Nano X": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX,
    "Nano FTS": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoFTS
};
var $5dec73da4f32e22b$var$devicesList = Object.values($5dec73da4f32e22b$var$devices);
var $5dec73da4f32e22b$export$268c42a4ddec87f3 = 0x2c97;
var $5dec73da4f32e22b$export$289d48518583cbd7 = function(id) {
    var info = $5dec73da4f32e22b$var$devices[id];
    if (!info) throw new Error("device '" + id + "' does not exist");
    return info;
};
var $5dec73da4f32e22b$export$f656be11ec4fd95b = function(targetId) {
    var deviceModel = $5dec73da4f32e22b$var$devicesList.find(function(_a) {
        var masks = _a.masks;
        return masks.find(function(mask) {
            return (targetId & 0xffff0000) === mask;
        });
    });
    return deviceModel;
};
var $5dec73da4f32e22b$export$df8f4444a7c73154 = function(usbProductId) {
    var legacy = $5dec73da4f32e22b$var$devicesList.find(function(d) {
        return d.legacyUsbProductId === usbProductId;
    });
    if (legacy) return legacy;
    var mm = usbProductId >> 8;
    var deviceModel = $5dec73da4f32e22b$var$devicesList.find(function(d) {
        return d.productIdMM === mm;
    });
    return deviceModel;
};
var $5dec73da4f32e22b$export$dce0906e1912b553 = function(productName) {
    var deviceModel = $5dec73da4f32e22b$var$devicesList.find(function(d) {
        return d.id === $5dec73da4f32e22b$var$productMap[productName];
    });
    return deviceModel;
};
var $5dec73da4f32e22b$var$bluetoothServices = [];
var $5dec73da4f32e22b$var$serviceUuidToInfos = {};
for(var $5dec73da4f32e22b$var$id in $5dec73da4f32e22b$var$devices){
    var $5dec73da4f32e22b$var$deviceModel = $5dec73da4f32e22b$var$devices[$5dec73da4f32e22b$var$id];
    var $5dec73da4f32e22b$var$bluetoothSpec = $5dec73da4f32e22b$var$deviceModel.bluetoothSpec;
    if ($5dec73da4f32e22b$var$bluetoothSpec) for(var $5dec73da4f32e22b$var$i = 0; $5dec73da4f32e22b$var$i < $5dec73da4f32e22b$var$bluetoothSpec.length; $5dec73da4f32e22b$var$i++){
        var $5dec73da4f32e22b$var$spec = $5dec73da4f32e22b$var$bluetoothSpec[$5dec73da4f32e22b$var$i];
        $5dec73da4f32e22b$var$bluetoothServices.push($5dec73da4f32e22b$var$spec.serviceUuid);
        $5dec73da4f32e22b$var$serviceUuidToInfos[$5dec73da4f32e22b$var$spec.serviceUuid] = $5dec73da4f32e22b$var$serviceUuidToInfos[$5dec73da4f32e22b$var$spec.serviceUuid.replace(/-/g, "")] = $5dec73da4f32e22b$var$__assign({
            deviceModel: $5dec73da4f32e22b$var$deviceModel
        }, $5dec73da4f32e22b$var$spec);
    }
}
var $5dec73da4f32e22b$export$1f1251c1c71d84cf = function() {
    return $5dec73da4f32e22b$var$bluetoothServices;
};
var $5dec73da4f32e22b$export$8c98567a3882f79e = function(uuid) {
    return $5dec73da4f32e22b$var$serviceUuidToInfos[uuid.toLowerCase()];
};


let $fdd451dd43e0ce6f$var$id = 0;
const $fdd451dd43e0ce6f$var$subscribers = [];
const $fdd451dd43e0ce6f$export$bef1f36f5486a6a3 = (type, message, data)=>{
    const obj = {
        type: type,
        id: String(++$fdd451dd43e0ce6f$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    $fdd451dd43e0ce6f$var$dispatch(obj);
};
const $fdd451dd43e0ce6f$export$357889f174732d38 = ({ type: type, message: message, data: data, context: context })=>{
    const obj = {
        type: type,
        id: String(++$fdd451dd43e0ce6f$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    if (context) obj.context = context;
    $fdd451dd43e0ce6f$var$dispatch(obj);
};
class $fdd451dd43e0ce6f$export$c9a255a7b61db733 {
    constructor(type, context){
        this.type = type;
        this.context = context;
    }
    trace(message, data) {
        $fdd451dd43e0ce6f$export$357889f174732d38({
            type: this.type,
            message: message,
            data: data,
            context: this.context
        });
    }
    getContext() {
        return this.context;
    }
    setContext(context) {
        this.context = context;
    }
    updateContext(contextToAdd) {
        this.context = Object.assign(Object.assign({}, this.context), contextToAdd);
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = type;
    }
    /**
     * Create a new instance of the LocalTracer with an updated `type`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ withType(type) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(type, this.context);
    }
    /**
     * Create a new instance of the LocalTracer with a new `context`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     *
     * @param context A TraceContext, that can undefined to reset the context
     */ withContext(context) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(this.type, context);
    }
    /**
     * Create a new instance of the LocalTracer with an updated `context`,
     * on which an additional context is merged with the existing one.
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ withUpdatedContext(contextToAdd) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(this.type, Object.assign(Object.assign({}, this.context), contextToAdd));
    }
}
const $fdd451dd43e0ce6f$export$63174c828edd6ff8 = (cb)=>{
    $fdd451dd43e0ce6f$var$subscribers.push(cb);
    return ()=>{
        const i = $fdd451dd43e0ce6f$var$subscribers.indexOf(cb);
        if (i !== -1) {
            // equivalent of subscribers.splice(i, 1) // https://twitter.com/Rich_Harris/status/1125850391155965952
            $fdd451dd43e0ce6f$var$subscribers[i] = $fdd451dd43e0ce6f$var$subscribers[$fdd451dd43e0ce6f$var$subscribers.length - 1];
            $fdd451dd43e0ce6f$var$subscribers.pop();
        }
    };
};
function $fdd451dd43e0ce6f$var$dispatch(log) {
    for(let i = 0; i < $fdd451dd43e0ce6f$var$subscribers.length; i++)try {
        $fdd451dd43e0ce6f$var$subscribers[i](log);
    } catch (e) {
        console.error(e);
    }
}
if (typeof window !== "undefined") window.__ledgerLogsListen = $fdd451dd43e0ce6f$export$63174c828edd6ff8;




var $6ZWSX = parcelRequire("6ZWSX");
var $b95dc6f85d7a5443$require$Buffer = $6ZWSX.Buffer;
var $b95dc6f85d7a5443$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b95dc6f85d7a5443$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b95dc6f85d7a5443$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b95dc6f85d7a5443$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b95dc6f85d7a5443$var$ledgerDevices = [
    {
        vendorId: (0, $5dec73da4f32e22b$export$268c42a4ddec87f3)
    }
];
var $b95dc6f85d7a5443$var$isSupported = function() {
    return Promise.resolve(!!(window.navigator && window.navigator.hid));
};
var $b95dc6f85d7a5443$var$getHID = function() {
    // $FlowFixMe
    var hid = navigator.hid;
    if (!hid) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("navigator.hid is not supported", "HIDNotSupported");
    return hid;
};
function $b95dc6f85d7a5443$var$requestLedgerDevices() {
    return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function() {
        var device;
        return $b95dc6f85d7a5443$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b95dc6f85d7a5443$var$getHID().requestDevice({
                            filters: $b95dc6f85d7a5443$var$ledgerDevices
                        })
                    ];
                case 1:
                    device = _a.sent();
                    if (Array.isArray(device)) return [
                        2 /*return*/ ,
                        device
                    ];
                    return [
                        2 /*return*/ ,
                        [
                            device
                        ]
                    ];
            }
        });
    });
}
function $b95dc6f85d7a5443$var$getLedgerDevices() {
    return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function() {
        var devices;
        return $b95dc6f85d7a5443$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b95dc6f85d7a5443$var$getHID().getDevices()
                    ];
                case 1:
                    devices = _a.sent();
                    return [
                        2 /*return*/ ,
                        devices.filter(function(d) {
                            return d.vendorId === (0, $5dec73da4f32e22b$export$268c42a4ddec87f3);
                        })
                    ];
            }
        });
    });
}
function $b95dc6f85d7a5443$var$getFirstLedgerDevice() {
    return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function() {
        var existingDevices, devices;
        return $b95dc6f85d7a5443$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b95dc6f85d7a5443$var$getLedgerDevices()
                    ];
                case 1:
                    existingDevices = _a.sent();
                    if (existingDevices.length > 0) return [
                        2 /*return*/ ,
                        existingDevices[0]
                    ];
                    return [
                        4 /*yield*/ ,
                        $b95dc6f85d7a5443$var$requestLedgerDevices()
                    ];
                case 2:
                    devices = _a.sent();
                    return [
                        2 /*return*/ ,
                        devices[0]
                    ];
            }
        });
    });
}
/**
 * WebHID Transport implementation
 * @example
 * import TransportWebHID from "@ledgerhq/hw-transport-webhid";
 * ...
 * TransportWebHID.create().then(transport => ...)
 */ var $b95dc6f85d7a5443$var$TransportWebHID = /** @class */ function(_super) {
    $b95dc6f85d7a5443$var$__extends(TransportWebHID, _super);
    function TransportWebHID(device) {
        var _this = _super.call(this) || this;
        _this.channel = Math.floor(Math.random() * 0xffff);
        _this.packetSize = 64;
        _this.inputs = [];
        _this.read = function() {
            if (_this.inputs.length) return Promise.resolve(_this.inputs.shift());
            return new Promise(function(success) {
                _this.inputCallback = success;
            });
        };
        _this.onInputReport = function(e) {
            var buffer = $b95dc6f85d7a5443$require$Buffer.from(e.data.buffer);
            if (_this.inputCallback) {
                _this.inputCallback(buffer);
                _this.inputCallback = null;
            } else _this.inputs.push(buffer);
        };
        _this._disconnectEmitted = false;
        _this._emitDisconnect = function(e) {
            if (_this._disconnectEmitted) return;
            _this._disconnectEmitted = true;
            _this.emit("disconnect", e);
        };
        /**
         * Exchange with the device using APDU protocol.
         * @param apdu
         * @returns a promise of apdu response
         */ _this.exchange = function(apdu) {
            return $b95dc6f85d7a5443$var$__awaiter(_this, void 0, void 0, function() {
                var b;
                var _this = this;
                return $b95dc6f85d7a5443$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.exchangeAtomicImpl(function() {
                                    return $b95dc6f85d7a5443$var$__awaiter(_this, void 0, void 0, function() {
                                        var _a, channel, packetSize, framing, blocks, i, result, acc, buffer;
                                        return $b95dc6f85d7a5443$var$__generator(this, function(_b) {
                                            switch(_b.label){
                                                case 0:
                                                    _a = this, channel = _a.channel, packetSize = _a.packetSize;
                                                    (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", "=> " + apdu.toString("hex"));
                                                    framing = (0, $a5ff30f0873f7620$export$2e2bcd8739ae039)(channel, packetSize);
                                                    blocks = framing.makeBlocks(apdu);
                                                    i = 0;
                                                    _b.label = 1;
                                                case 1:
                                                    if (!(i < blocks.length)) return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.device.sendReport(0, blocks[i])
                                                    ];
                                                case 2:
                                                    _b.sent();
                                                    _b.label = 3;
                                                case 3:
                                                    i++;
                                                    return [
                                                        3 /*break*/ ,
                                                        1
                                                    ];
                                                case 4:
                                                    if (!!(result = framing.getReducedResult(acc))) return [
                                                        3 /*break*/ ,
                                                        6
                                                    ];
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.read()
                                                    ];
                                                case 5:
                                                    buffer = _b.sent();
                                                    acc = framing.reduceResponse(acc, buffer);
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 6:
                                                    (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", "<= " + result.toString("hex"));
                                                    return [
                                                        2 /*return*/ ,
                                                        result
                                                    ];
                                            }
                                        });
                                    });
                                })["catch"](function(e) {
                                    if (e && e.message && e.message.includes("write")) {
                                        _this._emitDisconnect(e);
                                        throw new (0, $9a194f74559621d2$export$2a60f41a2ed2742)(e.message);
                                    }
                                    throw e;
                                })
                            ];
                        case 1:
                            b = _a.sent();
                            return [
                                2 /*return*/ ,
                                b
                            ];
                    }
                });
            });
        };
        _this.device = device;
        _this.deviceModel = typeof device.productId === "number" ? (0, $5dec73da4f32e22b$export$df8f4444a7c73154)(device.productId) : undefined;
        device.addEventListener("inputreport", _this.onInputReport);
        return _this;
    }
    /**
     * Similar to create() except it will always display the device permission (even if some devices are already accepted).
     */ TransportWebHID.request = function() {
        return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function() {
            var _a, device;
            return $b95dc6f85d7a5443$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $b95dc6f85d7a5443$var$requestLedgerDevices()
                        ];
                    case 1:
                        _a = $b95dc6f85d7a5443$var$__read.apply(void 0, [
                            _b.sent(),
                            1
                        ]), device = _a[0];
                        return [
                            2 /*return*/ ,
                            TransportWebHID.open(device)
                        ];
                }
            });
        });
    };
    /**
     * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
     */ TransportWebHID.openConnected = function() {
        return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function() {
            var devices;
            return $b95dc6f85d7a5443$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $b95dc6f85d7a5443$var$getLedgerDevices()
                        ];
                    case 1:
                        devices = _a.sent();
                        if (devices.length === 0) return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            2 /*return*/ ,
                            TransportWebHID.open(devices[0])
                        ];
                }
            });
        });
    };
    /**
     * Create a Ledger transport with a HIDDevice
     */ TransportWebHID.open = function(device) {
        return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function() {
            var transport, onDisconnect;
            return $b95dc6f85d7a5443$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            device.open()
                        ];
                    case 1:
                        _a.sent();
                        transport = new TransportWebHID(device);
                        onDisconnect = function(e) {
                            if (device === e.device) {
                                $b95dc6f85d7a5443$var$getHID().removeEventListener("disconnect", onDisconnect);
                                transport._emitDisconnect(new (0, $9a194f74559621d2$export$1e42f3936938e063)());
                            }
                        };
                        $b95dc6f85d7a5443$var$getHID().addEventListener("disconnect", onDisconnect);
                        return [
                            2 /*return*/ ,
                            transport
                        ];
                }
            });
        });
    };
    /**
     * Release the transport device
     */ TransportWebHID.prototype.close = function() {
        return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function() {
            return $b95dc6f85d7a5443$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.exchangeBusyPromise
                        ];
                    case 1:
                        _a.sent();
                        this.device.removeEventListener("inputreport", this.onInputReport);
                        return [
                            4 /*yield*/ ,
                            this.device.close()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    TransportWebHID.prototype.setScrambleKey = function() {};
    /**
     * Check if WebUSB transport is supported.
     */ TransportWebHID.isSupported = $b95dc6f85d7a5443$var$isSupported;
    /**
     * List the WebUSB devices that was previously authorized by the user.
     */ TransportWebHID.list = $b95dc6f85d7a5443$var$getLedgerDevices;
    /**
     * Actively listen to WebUSB devices and emit ONE device
     * that was either accepted before, if not it will trigger the native permission UI.
     *
     * Important: it must be called in the context of a UI click!
     */ TransportWebHID.listen = function(observer) {
        var unsubscribed = false;
        $b95dc6f85d7a5443$var$getFirstLedgerDevice().then(function(device) {
            if (!device) observer.error(new (0, $9a194f74559621d2$export$9642f061c2494239)("Access denied to use Ledger device"));
            else if (!unsubscribed) {
                var deviceModel = typeof device.productId === "number" ? (0, $5dec73da4f32e22b$export$df8f4444a7c73154)(device.productId) : undefined;
                observer.next({
                    type: "add",
                    descriptor: device,
                    deviceModel: deviceModel
                });
                observer.complete();
            }
        }, function(error) {
            observer.error(new (0, $9a194f74559621d2$export$9642f061c2494239)(error.message));
        });
        function unsubscribe() {
            unsubscribed = true;
        }
        return {
            unsubscribe: unsubscribe
        };
    };
    return TransportWebHID;
}((0, $375818ecee1623c3$export$2e2bcd8739ae039));
var $b95dc6f85d7a5443$export$2e2bcd8739ae039 = $b95dc6f85d7a5443$var$TransportWebHID;




var $6ZWSX = parcelRequire("6ZWSX");
var $565c2a6f56aa7a90$require$Buffer = $6ZWSX.Buffer;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $565c2a6f56aa7a90$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
var $565c2a6f56aa7a90$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $565c2a6f56aa7a90$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $565c2a6f56aa7a90$var$global$f = // eslint-disable-next-line es-x/no-global-this -- safe
$565c2a6f56aa7a90$var$check(typeof globalThis == "object" && globalThis) || $565c2a6f56aa7a90$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$565c2a6f56aa7a90$var$check(typeof self == "object" && self) || $565c2a6f56aa7a90$var$check(typeof $565c2a6f56aa7a90$var$commonjsGlobal == "object" && $565c2a6f56aa7a90$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $565c2a6f56aa7a90$var$objectGetOwnPropertyDescriptor = {};
var $565c2a6f56aa7a90$var$fails$h = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $565c2a6f56aa7a90$var$fails$g = $565c2a6f56aa7a90$var$fails$h;
// Detect IE8's incomplete defineProperty implementation
var $565c2a6f56aa7a90$var$descriptors = !$565c2a6f56aa7a90$var$fails$g(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $565c2a6f56aa7a90$var$fails$f = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$functionBindNative = !$565c2a6f56aa7a90$var$fails$f(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $565c2a6f56aa7a90$var$NATIVE_BIND$2 = $565c2a6f56aa7a90$var$functionBindNative;
var $565c2a6f56aa7a90$var$call$9 = Function.prototype.call;
var $565c2a6f56aa7a90$var$functionCall = $565c2a6f56aa7a90$var$NATIVE_BIND$2 ? $565c2a6f56aa7a90$var$call$9.bind($565c2a6f56aa7a90$var$call$9) : function() {
    return $565c2a6f56aa7a90$var$call$9.apply($565c2a6f56aa7a90$var$call$9, arguments);
};
var $565c2a6f56aa7a90$var$objectPropertyIsEnumerable = {};
var $565c2a6f56aa7a90$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $565c2a6f56aa7a90$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $565c2a6f56aa7a90$var$NASHORN_BUG = $565c2a6f56aa7a90$var$getOwnPropertyDescriptor$2 && !$565c2a6f56aa7a90$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$565c2a6f56aa7a90$var$objectPropertyIsEnumerable.f = $565c2a6f56aa7a90$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $565c2a6f56aa7a90$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $565c2a6f56aa7a90$var$$propertyIsEnumerable;
var $565c2a6f56aa7a90$var$createPropertyDescriptor$4 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $565c2a6f56aa7a90$var$NATIVE_BIND$1 = $565c2a6f56aa7a90$var$functionBindNative;
var $565c2a6f56aa7a90$var$FunctionPrototype$2 = Function.prototype;
var $565c2a6f56aa7a90$var$bind = $565c2a6f56aa7a90$var$FunctionPrototype$2.bind;
var $565c2a6f56aa7a90$var$call$8 = $565c2a6f56aa7a90$var$FunctionPrototype$2.call;
var $565c2a6f56aa7a90$var$uncurryThis$i = $565c2a6f56aa7a90$var$NATIVE_BIND$1 && $565c2a6f56aa7a90$var$bind.bind($565c2a6f56aa7a90$var$call$8, $565c2a6f56aa7a90$var$call$8);
var $565c2a6f56aa7a90$var$functionUncurryThis = $565c2a6f56aa7a90$var$NATIVE_BIND$1 ? function(fn) {
    return fn && $565c2a6f56aa7a90$var$uncurryThis$i(fn);
} : function(fn) {
    return fn && function() {
        return $565c2a6f56aa7a90$var$call$8.apply(fn, arguments);
    };
};
var $565c2a6f56aa7a90$var$uncurryThis$h = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$toString$8 = $565c2a6f56aa7a90$var$uncurryThis$h({}.toString);
var $565c2a6f56aa7a90$var$stringSlice$3 = $565c2a6f56aa7a90$var$uncurryThis$h("".slice);
var $565c2a6f56aa7a90$var$classofRaw$1 = function(it) {
    return $565c2a6f56aa7a90$var$stringSlice$3($565c2a6f56aa7a90$var$toString$8(it), 8, -1);
};
var $565c2a6f56aa7a90$var$uncurryThis$g = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$fails$e = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$classof$5 = $565c2a6f56aa7a90$var$classofRaw$1;
var $565c2a6f56aa7a90$var$$Object$4 = Object;
var $565c2a6f56aa7a90$var$split = $565c2a6f56aa7a90$var$uncurryThis$g("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $565c2a6f56aa7a90$var$indexedObject = $565c2a6f56aa7a90$var$fails$e(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$565c2a6f56aa7a90$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $565c2a6f56aa7a90$var$classof$5(it) == "String" ? $565c2a6f56aa7a90$var$split(it, "") : $565c2a6f56aa7a90$var$$Object$4(it);
} : $565c2a6f56aa7a90$var$$Object$4;
var $565c2a6f56aa7a90$var$$TypeError$9 = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $565c2a6f56aa7a90$var$requireObjectCoercible$6 = function(it) {
    if (it == undefined) throw $565c2a6f56aa7a90$var$$TypeError$9("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $565c2a6f56aa7a90$var$IndexedObject = $565c2a6f56aa7a90$var$indexedObject;
var $565c2a6f56aa7a90$var$requireObjectCoercible$5 = $565c2a6f56aa7a90$var$requireObjectCoercible$6;
var $565c2a6f56aa7a90$var$toIndexedObject$5 = function(it) {
    return $565c2a6f56aa7a90$var$IndexedObject($565c2a6f56aa7a90$var$requireObjectCoercible$5(it));
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $565c2a6f56aa7a90$var$isCallable$h = function(argument) {
    return typeof argument == "function";
};
var $565c2a6f56aa7a90$var$isCallable$g = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$isObject$6 = function(it) {
    return typeof it == "object" ? it !== null : $565c2a6f56aa7a90$var$isCallable$g(it);
};
var $565c2a6f56aa7a90$var$global$e = $565c2a6f56aa7a90$var$global$f;
var $565c2a6f56aa7a90$var$isCallable$f = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$aFunction = function(argument) {
    return $565c2a6f56aa7a90$var$isCallable$f(argument) ? argument : undefined;
};
var $565c2a6f56aa7a90$var$getBuiltIn$5 = function(namespace, method) {
    return arguments.length < 2 ? $565c2a6f56aa7a90$var$aFunction($565c2a6f56aa7a90$var$global$e[namespace]) : $565c2a6f56aa7a90$var$global$e[namespace] && $565c2a6f56aa7a90$var$global$e[namespace][method];
};
var $565c2a6f56aa7a90$var$uncurryThis$f = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$objectIsPrototypeOf = $565c2a6f56aa7a90$var$uncurryThis$f({}.isPrototypeOf);
var $565c2a6f56aa7a90$var$getBuiltIn$4 = $565c2a6f56aa7a90$var$getBuiltIn$5;
var $565c2a6f56aa7a90$var$engineUserAgent = $565c2a6f56aa7a90$var$getBuiltIn$4("navigator", "userAgent") || "";
var $565c2a6f56aa7a90$var$global$d = $565c2a6f56aa7a90$var$global$f;
var $565c2a6f56aa7a90$var$userAgent = $565c2a6f56aa7a90$var$engineUserAgent;
var $565c2a6f56aa7a90$var$process = $565c2a6f56aa7a90$var$global$d.process;
var $565c2a6f56aa7a90$var$Deno = $565c2a6f56aa7a90$var$global$d.Deno;
var $565c2a6f56aa7a90$var$versions = $565c2a6f56aa7a90$var$process && $565c2a6f56aa7a90$var$process.versions || $565c2a6f56aa7a90$var$Deno && $565c2a6f56aa7a90$var$Deno.version;
var $565c2a6f56aa7a90$var$v8 = $565c2a6f56aa7a90$var$versions && $565c2a6f56aa7a90$var$versions.v8;
var $565c2a6f56aa7a90$var$match, $565c2a6f56aa7a90$var$version;
if ($565c2a6f56aa7a90$var$v8) {
    $565c2a6f56aa7a90$var$match = $565c2a6f56aa7a90$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $565c2a6f56aa7a90$var$version = $565c2a6f56aa7a90$var$match[0] > 0 && $565c2a6f56aa7a90$var$match[0] < 4 ? 1 : +($565c2a6f56aa7a90$var$match[0] + $565c2a6f56aa7a90$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$565c2a6f56aa7a90$var$version && $565c2a6f56aa7a90$var$userAgent) {
    $565c2a6f56aa7a90$var$match = $565c2a6f56aa7a90$var$userAgent.match(/Edge\/(\d+)/);
    if (!$565c2a6f56aa7a90$var$match || $565c2a6f56aa7a90$var$match[1] >= 74) {
        $565c2a6f56aa7a90$var$match = $565c2a6f56aa7a90$var$userAgent.match(/Chrome\/(\d+)/);
        if ($565c2a6f56aa7a90$var$match) $565c2a6f56aa7a90$var$version = +$565c2a6f56aa7a90$var$match[1];
    }
}
var $565c2a6f56aa7a90$var$engineV8Version = $565c2a6f56aa7a90$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $565c2a6f56aa7a90$var$V8_VERSION = $565c2a6f56aa7a90$var$engineV8Version;
var $565c2a6f56aa7a90$var$fails$d = $565c2a6f56aa7a90$var$fails$h;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $565c2a6f56aa7a90$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$565c2a6f56aa7a90$var$fails$d(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $565c2a6f56aa7a90$var$V8_VERSION && $565c2a6f56aa7a90$var$V8_VERSION < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $565c2a6f56aa7a90$var$NATIVE_SYMBOL$1 = $565c2a6f56aa7a90$var$nativeSymbol;
var $565c2a6f56aa7a90$var$useSymbolAsUid = $565c2a6f56aa7a90$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $565c2a6f56aa7a90$var$getBuiltIn$3 = $565c2a6f56aa7a90$var$getBuiltIn$5;
var $565c2a6f56aa7a90$var$isCallable$e = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$isPrototypeOf = $565c2a6f56aa7a90$var$objectIsPrototypeOf;
var $565c2a6f56aa7a90$var$USE_SYMBOL_AS_UID$1 = $565c2a6f56aa7a90$var$useSymbolAsUid;
var $565c2a6f56aa7a90$var$$Object$3 = Object;
var $565c2a6f56aa7a90$var$isSymbol$2 = $565c2a6f56aa7a90$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $565c2a6f56aa7a90$var$getBuiltIn$3("Symbol");
    return $565c2a6f56aa7a90$var$isCallable$e($Symbol) && $565c2a6f56aa7a90$var$isPrototypeOf($Symbol.prototype, $565c2a6f56aa7a90$var$$Object$3(it));
};
var $565c2a6f56aa7a90$var$$String$3 = String;
var $565c2a6f56aa7a90$var$tryToString$2 = function(argument) {
    try {
        return $565c2a6f56aa7a90$var$$String$3(argument);
    } catch (error) {
        return "Object";
    }
};
var $565c2a6f56aa7a90$var$isCallable$d = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$tryToString$1 = $565c2a6f56aa7a90$var$tryToString$2;
var $565c2a6f56aa7a90$var$$TypeError$8 = TypeError;
// `Assert: IsCallable(argument) is true`
var $565c2a6f56aa7a90$var$aCallable$1 = function(argument) {
    if ($565c2a6f56aa7a90$var$isCallable$d(argument)) return argument;
    throw $565c2a6f56aa7a90$var$$TypeError$8($565c2a6f56aa7a90$var$tryToString$1(argument) + " is not a function");
};
var $565c2a6f56aa7a90$var$aCallable = $565c2a6f56aa7a90$var$aCallable$1;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $565c2a6f56aa7a90$var$getMethod$2 = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $565c2a6f56aa7a90$var$aCallable(func);
};
var $565c2a6f56aa7a90$var$call$7 = $565c2a6f56aa7a90$var$functionCall;
var $565c2a6f56aa7a90$var$isCallable$c = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$isObject$5 = $565c2a6f56aa7a90$var$isObject$6;
var $565c2a6f56aa7a90$var$$TypeError$7 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $565c2a6f56aa7a90$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $565c2a6f56aa7a90$var$isCallable$c(fn = input.toString) && !$565c2a6f56aa7a90$var$isObject$5(val = $565c2a6f56aa7a90$var$call$7(fn, input))) return val;
    if ($565c2a6f56aa7a90$var$isCallable$c(fn = input.valueOf) && !$565c2a6f56aa7a90$var$isObject$5(val = $565c2a6f56aa7a90$var$call$7(fn, input))) return val;
    if (pref !== "string" && $565c2a6f56aa7a90$var$isCallable$c(fn = input.toString) && !$565c2a6f56aa7a90$var$isObject$5(val = $565c2a6f56aa7a90$var$call$7(fn, input))) return val;
    throw $565c2a6f56aa7a90$var$$TypeError$7("Can't convert object to primitive value");
};
var $565c2a6f56aa7a90$var$shared$4 = {
    exports: {}
};
var $565c2a6f56aa7a90$var$global$c = $565c2a6f56aa7a90$var$global$f;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $565c2a6f56aa7a90$var$defineProperty$4 = Object.defineProperty;
var $565c2a6f56aa7a90$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $565c2a6f56aa7a90$var$defineProperty$4($565c2a6f56aa7a90$var$global$c, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $565c2a6f56aa7a90$var$global$c[key] = value;
    }
    return value;
};
var $565c2a6f56aa7a90$var$global$b = $565c2a6f56aa7a90$var$global$f;
var $565c2a6f56aa7a90$var$defineGlobalProperty$2 = $565c2a6f56aa7a90$var$defineGlobalProperty$3;
var $565c2a6f56aa7a90$var$SHARED = "__core-js_shared__";
var $565c2a6f56aa7a90$var$store$3 = $565c2a6f56aa7a90$var$global$b[$565c2a6f56aa7a90$var$SHARED] || $565c2a6f56aa7a90$var$defineGlobalProperty$2($565c2a6f56aa7a90$var$SHARED, {});
var $565c2a6f56aa7a90$var$sharedStore = $565c2a6f56aa7a90$var$store$3;
var $565c2a6f56aa7a90$var$store$2 = $565c2a6f56aa7a90$var$sharedStore;
($565c2a6f56aa7a90$var$shared$4.exports = function(key, value) {
    return $565c2a6f56aa7a90$var$store$2[key] || ($565c2a6f56aa7a90$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $565c2a6f56aa7a90$var$requireObjectCoercible$4 = $565c2a6f56aa7a90$var$requireObjectCoercible$6;
var $565c2a6f56aa7a90$var$$Object$2 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $565c2a6f56aa7a90$var$toObject$2 = function(argument) {
    return $565c2a6f56aa7a90$var$$Object$2($565c2a6f56aa7a90$var$requireObjectCoercible$4(argument));
};
var $565c2a6f56aa7a90$var$uncurryThis$e = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$toObject$1 = $565c2a6f56aa7a90$var$toObject$2;
var $565c2a6f56aa7a90$var$hasOwnProperty = $565c2a6f56aa7a90$var$uncurryThis$e({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $565c2a6f56aa7a90$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $565c2a6f56aa7a90$var$hasOwnProperty($565c2a6f56aa7a90$var$toObject$1(it), key);
};
var $565c2a6f56aa7a90$var$uncurryThis$d = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$id = 0;
var $565c2a6f56aa7a90$var$postfix = Math.random();
var $565c2a6f56aa7a90$var$toString$7 = $565c2a6f56aa7a90$var$uncurryThis$d(1.0.toString);
var $565c2a6f56aa7a90$var$uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $565c2a6f56aa7a90$var$toString$7(++$565c2a6f56aa7a90$var$id + $565c2a6f56aa7a90$var$postfix, 36);
};
var $565c2a6f56aa7a90$var$global$a = $565c2a6f56aa7a90$var$global$f;
var $565c2a6f56aa7a90$var$shared$3 = $565c2a6f56aa7a90$var$shared$4.exports;
var $565c2a6f56aa7a90$var$hasOwn$8 = $565c2a6f56aa7a90$var$hasOwnProperty_1;
var $565c2a6f56aa7a90$var$uid$1 = $565c2a6f56aa7a90$var$uid$2;
var $565c2a6f56aa7a90$var$NATIVE_SYMBOL = $565c2a6f56aa7a90$var$nativeSymbol;
var $565c2a6f56aa7a90$var$USE_SYMBOL_AS_UID = $565c2a6f56aa7a90$var$useSymbolAsUid;
var $565c2a6f56aa7a90$var$WellKnownSymbolsStore = $565c2a6f56aa7a90$var$shared$3("wks");
var $565c2a6f56aa7a90$var$Symbol$2 = $565c2a6f56aa7a90$var$global$a.Symbol;
var $565c2a6f56aa7a90$var$symbolFor = $565c2a6f56aa7a90$var$Symbol$2 && $565c2a6f56aa7a90$var$Symbol$2["for"];
var $565c2a6f56aa7a90$var$createWellKnownSymbol = $565c2a6f56aa7a90$var$USE_SYMBOL_AS_UID ? $565c2a6f56aa7a90$var$Symbol$2 : $565c2a6f56aa7a90$var$Symbol$2 && $565c2a6f56aa7a90$var$Symbol$2.withoutSetter || $565c2a6f56aa7a90$var$uid$1;
var $565c2a6f56aa7a90$var$wellKnownSymbol$c = function(name) {
    if (!$565c2a6f56aa7a90$var$hasOwn$8($565c2a6f56aa7a90$var$WellKnownSymbolsStore, name) || !($565c2a6f56aa7a90$var$NATIVE_SYMBOL || typeof $565c2a6f56aa7a90$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($565c2a6f56aa7a90$var$NATIVE_SYMBOL && $565c2a6f56aa7a90$var$hasOwn$8($565c2a6f56aa7a90$var$Symbol$2, name)) $565c2a6f56aa7a90$var$WellKnownSymbolsStore[name] = $565c2a6f56aa7a90$var$Symbol$2[name];
        else if ($565c2a6f56aa7a90$var$USE_SYMBOL_AS_UID && $565c2a6f56aa7a90$var$symbolFor) $565c2a6f56aa7a90$var$WellKnownSymbolsStore[name] = $565c2a6f56aa7a90$var$symbolFor(description);
        else $565c2a6f56aa7a90$var$WellKnownSymbolsStore[name] = $565c2a6f56aa7a90$var$createWellKnownSymbol(description);
    }
    return $565c2a6f56aa7a90$var$WellKnownSymbolsStore[name];
};
var $565c2a6f56aa7a90$var$call$6 = $565c2a6f56aa7a90$var$functionCall;
var $565c2a6f56aa7a90$var$isObject$4 = $565c2a6f56aa7a90$var$isObject$6;
var $565c2a6f56aa7a90$var$isSymbol$1 = $565c2a6f56aa7a90$var$isSymbol$2;
var $565c2a6f56aa7a90$var$getMethod$1 = $565c2a6f56aa7a90$var$getMethod$2;
var $565c2a6f56aa7a90$var$ordinaryToPrimitive = $565c2a6f56aa7a90$var$ordinaryToPrimitive$1;
var $565c2a6f56aa7a90$var$wellKnownSymbol$b = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$$TypeError$6 = TypeError;
var $565c2a6f56aa7a90$var$TO_PRIMITIVE = $565c2a6f56aa7a90$var$wellKnownSymbol$b("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $565c2a6f56aa7a90$var$toPrimitive$1 = function(input, pref) {
    if (!$565c2a6f56aa7a90$var$isObject$4(input) || $565c2a6f56aa7a90$var$isSymbol$1(input)) return input;
    var exoticToPrim = $565c2a6f56aa7a90$var$getMethod$1(input, $565c2a6f56aa7a90$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $565c2a6f56aa7a90$var$call$6(exoticToPrim, input, pref);
        if (!$565c2a6f56aa7a90$var$isObject$4(result) || $565c2a6f56aa7a90$var$isSymbol$1(result)) return result;
        throw $565c2a6f56aa7a90$var$$TypeError$6("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $565c2a6f56aa7a90$var$ordinaryToPrimitive(input, pref);
};
var $565c2a6f56aa7a90$var$toPrimitive = $565c2a6f56aa7a90$var$toPrimitive$1;
var $565c2a6f56aa7a90$var$isSymbol = $565c2a6f56aa7a90$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $565c2a6f56aa7a90$var$toPropertyKey$3 = function(argument) {
    var key = $565c2a6f56aa7a90$var$toPrimitive(argument, "string");
    return $565c2a6f56aa7a90$var$isSymbol(key) ? key : key + "";
};
var $565c2a6f56aa7a90$var$global$9 = $565c2a6f56aa7a90$var$global$f;
var $565c2a6f56aa7a90$var$isObject$3 = $565c2a6f56aa7a90$var$isObject$6;
var $565c2a6f56aa7a90$var$document$1 = $565c2a6f56aa7a90$var$global$9.document;
// typeof document.createElement is 'object' in old IE
var $565c2a6f56aa7a90$var$EXISTS$1 = $565c2a6f56aa7a90$var$isObject$3($565c2a6f56aa7a90$var$document$1) && $565c2a6f56aa7a90$var$isObject$3($565c2a6f56aa7a90$var$document$1.createElement);
var $565c2a6f56aa7a90$var$documentCreateElement$2 = function(it) {
    return $565c2a6f56aa7a90$var$EXISTS$1 ? $565c2a6f56aa7a90$var$document$1.createElement(it) : {};
};
var $565c2a6f56aa7a90$var$DESCRIPTORS$8 = $565c2a6f56aa7a90$var$descriptors;
var $565c2a6f56aa7a90$var$fails$c = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$createElement = $565c2a6f56aa7a90$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $565c2a6f56aa7a90$var$ie8DomDefine = !$565c2a6f56aa7a90$var$DESCRIPTORS$8 && !$565c2a6f56aa7a90$var$fails$c(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($565c2a6f56aa7a90$var$createElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $565c2a6f56aa7a90$var$DESCRIPTORS$7 = $565c2a6f56aa7a90$var$descriptors;
var $565c2a6f56aa7a90$var$call$5 = $565c2a6f56aa7a90$var$functionCall;
var $565c2a6f56aa7a90$var$propertyIsEnumerableModule = $565c2a6f56aa7a90$var$objectPropertyIsEnumerable;
var $565c2a6f56aa7a90$var$createPropertyDescriptor$3 = $565c2a6f56aa7a90$var$createPropertyDescriptor$4;
var $565c2a6f56aa7a90$var$toIndexedObject$4 = $565c2a6f56aa7a90$var$toIndexedObject$5;
var $565c2a6f56aa7a90$var$toPropertyKey$2 = $565c2a6f56aa7a90$var$toPropertyKey$3;
var $565c2a6f56aa7a90$var$hasOwn$7 = $565c2a6f56aa7a90$var$hasOwnProperty_1;
var $565c2a6f56aa7a90$var$IE8_DOM_DEFINE$1 = $565c2a6f56aa7a90$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $565c2a6f56aa7a90$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$565c2a6f56aa7a90$var$objectGetOwnPropertyDescriptor.f = $565c2a6f56aa7a90$var$DESCRIPTORS$7 ? $565c2a6f56aa7a90$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $565c2a6f56aa7a90$var$toIndexedObject$4(O);
    P = $565c2a6f56aa7a90$var$toPropertyKey$2(P);
    if ($565c2a6f56aa7a90$var$IE8_DOM_DEFINE$1) try {
        return $565c2a6f56aa7a90$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($565c2a6f56aa7a90$var$hasOwn$7(O, P)) return $565c2a6f56aa7a90$var$createPropertyDescriptor$3(!$565c2a6f56aa7a90$var$call$5($565c2a6f56aa7a90$var$propertyIsEnumerableModule.f, O, P), O[P]);
};
var $565c2a6f56aa7a90$var$objectDefineProperty = {};
var $565c2a6f56aa7a90$var$DESCRIPTORS$6 = $565c2a6f56aa7a90$var$descriptors;
var $565c2a6f56aa7a90$var$fails$b = $565c2a6f56aa7a90$var$fails$h;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $565c2a6f56aa7a90$var$v8PrototypeDefineBug = $565c2a6f56aa7a90$var$DESCRIPTORS$6 && $565c2a6f56aa7a90$var$fails$b(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $565c2a6f56aa7a90$var$isObject$2 = $565c2a6f56aa7a90$var$isObject$6;
var $565c2a6f56aa7a90$var$$String$2 = String;
var $565c2a6f56aa7a90$var$$TypeError$5 = TypeError;
// `Assert: Type(argument) is Object`
var $565c2a6f56aa7a90$var$anObject$9 = function(argument) {
    if ($565c2a6f56aa7a90$var$isObject$2(argument)) return argument;
    throw $565c2a6f56aa7a90$var$$TypeError$5($565c2a6f56aa7a90$var$$String$2(argument) + " is not an object");
};
var $565c2a6f56aa7a90$var$DESCRIPTORS$5 = $565c2a6f56aa7a90$var$descriptors;
var $565c2a6f56aa7a90$var$IE8_DOM_DEFINE = $565c2a6f56aa7a90$var$ie8DomDefine;
var $565c2a6f56aa7a90$var$V8_PROTOTYPE_DEFINE_BUG$1 = $565c2a6f56aa7a90$var$v8PrototypeDefineBug;
var $565c2a6f56aa7a90$var$anObject$8 = $565c2a6f56aa7a90$var$anObject$9;
var $565c2a6f56aa7a90$var$toPropertyKey$1 = $565c2a6f56aa7a90$var$toPropertyKey$3;
var $565c2a6f56aa7a90$var$$TypeError$4 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $565c2a6f56aa7a90$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $565c2a6f56aa7a90$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $565c2a6f56aa7a90$var$ENUMERABLE = "enumerable";
var $565c2a6f56aa7a90$var$CONFIGURABLE$1 = "configurable";
var $565c2a6f56aa7a90$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$565c2a6f56aa7a90$var$objectDefineProperty.f = $565c2a6f56aa7a90$var$DESCRIPTORS$5 ? $565c2a6f56aa7a90$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $565c2a6f56aa7a90$var$anObject$8(O);
    P = $565c2a6f56aa7a90$var$toPropertyKey$1(P);
    $565c2a6f56aa7a90$var$anObject$8(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $565c2a6f56aa7a90$var$WRITABLE in Attributes && !Attributes[$565c2a6f56aa7a90$var$WRITABLE]) {
        var current = $565c2a6f56aa7a90$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$565c2a6f56aa7a90$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $565c2a6f56aa7a90$var$CONFIGURABLE$1 in Attributes ? Attributes[$565c2a6f56aa7a90$var$CONFIGURABLE$1] : current[$565c2a6f56aa7a90$var$CONFIGURABLE$1],
                enumerable: $565c2a6f56aa7a90$var$ENUMERABLE in Attributes ? Attributes[$565c2a6f56aa7a90$var$ENUMERABLE] : current[$565c2a6f56aa7a90$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $565c2a6f56aa7a90$var$$defineProperty(O, P, Attributes);
} : $565c2a6f56aa7a90$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $565c2a6f56aa7a90$var$anObject$8(O);
    P = $565c2a6f56aa7a90$var$toPropertyKey$1(P);
    $565c2a6f56aa7a90$var$anObject$8(Attributes);
    if ($565c2a6f56aa7a90$var$IE8_DOM_DEFINE) try {
        return $565c2a6f56aa7a90$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $565c2a6f56aa7a90$var$$TypeError$4("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $565c2a6f56aa7a90$var$DESCRIPTORS$4 = $565c2a6f56aa7a90$var$descriptors;
var $565c2a6f56aa7a90$var$definePropertyModule$4 = $565c2a6f56aa7a90$var$objectDefineProperty;
var $565c2a6f56aa7a90$var$createPropertyDescriptor$2 = $565c2a6f56aa7a90$var$createPropertyDescriptor$4;
var $565c2a6f56aa7a90$var$createNonEnumerableProperty$5 = $565c2a6f56aa7a90$var$DESCRIPTORS$4 ? function(object, key, value) {
    return $565c2a6f56aa7a90$var$definePropertyModule$4.f(object, key, $565c2a6f56aa7a90$var$createPropertyDescriptor$2(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $565c2a6f56aa7a90$var$makeBuiltIn$2 = {
    exports: {}
};
var $565c2a6f56aa7a90$var$DESCRIPTORS$3 = $565c2a6f56aa7a90$var$descriptors;
var $565c2a6f56aa7a90$var$hasOwn$6 = $565c2a6f56aa7a90$var$hasOwnProperty_1;
var $565c2a6f56aa7a90$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $565c2a6f56aa7a90$var$getDescriptor = $565c2a6f56aa7a90$var$DESCRIPTORS$3 && Object.getOwnPropertyDescriptor;
var $565c2a6f56aa7a90$var$EXISTS = $565c2a6f56aa7a90$var$hasOwn$6($565c2a6f56aa7a90$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $565c2a6f56aa7a90$var$PROPER = $565c2a6f56aa7a90$var$EXISTS && (function something() {}).name === "something";
var $565c2a6f56aa7a90$var$CONFIGURABLE = $565c2a6f56aa7a90$var$EXISTS && (!$565c2a6f56aa7a90$var$DESCRIPTORS$3 || $565c2a6f56aa7a90$var$DESCRIPTORS$3 && $565c2a6f56aa7a90$var$getDescriptor($565c2a6f56aa7a90$var$FunctionPrototype$1, "name").configurable);
var $565c2a6f56aa7a90$var$functionName = {
    EXISTS: $565c2a6f56aa7a90$var$EXISTS,
    PROPER: $565c2a6f56aa7a90$var$PROPER,
    CONFIGURABLE: $565c2a6f56aa7a90$var$CONFIGURABLE
};
var $565c2a6f56aa7a90$var$uncurryThis$c = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$isCallable$b = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$store$1 = $565c2a6f56aa7a90$var$sharedStore;
var $565c2a6f56aa7a90$var$functionToString = $565c2a6f56aa7a90$var$uncurryThis$c(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$565c2a6f56aa7a90$var$isCallable$b($565c2a6f56aa7a90$var$store$1.inspectSource)) $565c2a6f56aa7a90$var$store$1.inspectSource = function(it) {
    return $565c2a6f56aa7a90$var$functionToString(it);
};
var $565c2a6f56aa7a90$var$inspectSource$3 = $565c2a6f56aa7a90$var$store$1.inspectSource;
var $565c2a6f56aa7a90$var$global$8 = $565c2a6f56aa7a90$var$global$f;
var $565c2a6f56aa7a90$var$isCallable$a = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$inspectSource$2 = $565c2a6f56aa7a90$var$inspectSource$3;
var $565c2a6f56aa7a90$var$WeakMap$1 = $565c2a6f56aa7a90$var$global$8.WeakMap;
var $565c2a6f56aa7a90$var$nativeWeakMap = $565c2a6f56aa7a90$var$isCallable$a($565c2a6f56aa7a90$var$WeakMap$1) && /native code/.test($565c2a6f56aa7a90$var$inspectSource$2($565c2a6f56aa7a90$var$WeakMap$1));
var $565c2a6f56aa7a90$var$shared$2 = $565c2a6f56aa7a90$var$shared$4.exports;
var $565c2a6f56aa7a90$var$uid = $565c2a6f56aa7a90$var$uid$2;
var $565c2a6f56aa7a90$var$keys = $565c2a6f56aa7a90$var$shared$2("keys");
var $565c2a6f56aa7a90$var$sharedKey$3 = function(key) {
    return $565c2a6f56aa7a90$var$keys[key] || ($565c2a6f56aa7a90$var$keys[key] = $565c2a6f56aa7a90$var$uid(key));
};
var $565c2a6f56aa7a90$var$hiddenKeys$4 = {};
var $565c2a6f56aa7a90$var$NATIVE_WEAK_MAP = $565c2a6f56aa7a90$var$nativeWeakMap;
var $565c2a6f56aa7a90$var$global$7 = $565c2a6f56aa7a90$var$global$f;
var $565c2a6f56aa7a90$var$uncurryThis$b = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$isObject$1 = $565c2a6f56aa7a90$var$isObject$6;
var $565c2a6f56aa7a90$var$createNonEnumerableProperty$4 = $565c2a6f56aa7a90$var$createNonEnumerableProperty$5;
var $565c2a6f56aa7a90$var$hasOwn$5 = $565c2a6f56aa7a90$var$hasOwnProperty_1;
var $565c2a6f56aa7a90$var$shared$1 = $565c2a6f56aa7a90$var$sharedStore;
var $565c2a6f56aa7a90$var$sharedKey$2 = $565c2a6f56aa7a90$var$sharedKey$3;
var $565c2a6f56aa7a90$var$hiddenKeys$3 = $565c2a6f56aa7a90$var$hiddenKeys$4;
var $565c2a6f56aa7a90$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $565c2a6f56aa7a90$var$TypeError$1 = $565c2a6f56aa7a90$var$global$7.TypeError;
var $565c2a6f56aa7a90$var$WeakMap = $565c2a6f56aa7a90$var$global$7.WeakMap;
var $565c2a6f56aa7a90$var$set, $565c2a6f56aa7a90$var$get, $565c2a6f56aa7a90$var$has;
var $565c2a6f56aa7a90$var$enforce = function(it) {
    return $565c2a6f56aa7a90$var$has(it) ? $565c2a6f56aa7a90$var$get(it) : $565c2a6f56aa7a90$var$set(it, {});
};
var $565c2a6f56aa7a90$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$565c2a6f56aa7a90$var$isObject$1(it) || (state = $565c2a6f56aa7a90$var$get(it)).type !== TYPE) throw $565c2a6f56aa7a90$var$TypeError$1("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($565c2a6f56aa7a90$var$NATIVE_WEAK_MAP || $565c2a6f56aa7a90$var$shared$1.state) {
    var $565c2a6f56aa7a90$var$store = $565c2a6f56aa7a90$var$shared$1.state || ($565c2a6f56aa7a90$var$shared$1.state = new $565c2a6f56aa7a90$var$WeakMap());
    var $565c2a6f56aa7a90$var$wmget = $565c2a6f56aa7a90$var$uncurryThis$b($565c2a6f56aa7a90$var$store.get);
    var $565c2a6f56aa7a90$var$wmhas = $565c2a6f56aa7a90$var$uncurryThis$b($565c2a6f56aa7a90$var$store.has);
    var $565c2a6f56aa7a90$var$wmset = $565c2a6f56aa7a90$var$uncurryThis$b($565c2a6f56aa7a90$var$store.set);
    $565c2a6f56aa7a90$var$set = function(it, metadata) {
        if ($565c2a6f56aa7a90$var$wmhas($565c2a6f56aa7a90$var$store, it)) throw new $565c2a6f56aa7a90$var$TypeError$1($565c2a6f56aa7a90$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $565c2a6f56aa7a90$var$wmset($565c2a6f56aa7a90$var$store, it, metadata);
        return metadata;
    };
    $565c2a6f56aa7a90$var$get = function(it) {
        return $565c2a6f56aa7a90$var$wmget($565c2a6f56aa7a90$var$store, it) || {};
    };
    $565c2a6f56aa7a90$var$has = function(it) {
        return $565c2a6f56aa7a90$var$wmhas($565c2a6f56aa7a90$var$store, it);
    };
} else {
    var $565c2a6f56aa7a90$var$STATE = $565c2a6f56aa7a90$var$sharedKey$2("state");
    $565c2a6f56aa7a90$var$hiddenKeys$3[$565c2a6f56aa7a90$var$STATE] = true;
    $565c2a6f56aa7a90$var$set = function(it, metadata) {
        if ($565c2a6f56aa7a90$var$hasOwn$5(it, $565c2a6f56aa7a90$var$STATE)) throw new $565c2a6f56aa7a90$var$TypeError$1($565c2a6f56aa7a90$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $565c2a6f56aa7a90$var$createNonEnumerableProperty$4(it, $565c2a6f56aa7a90$var$STATE, metadata);
        return metadata;
    };
    $565c2a6f56aa7a90$var$get = function(it) {
        return $565c2a6f56aa7a90$var$hasOwn$5(it, $565c2a6f56aa7a90$var$STATE) ? it[$565c2a6f56aa7a90$var$STATE] : {};
    };
    $565c2a6f56aa7a90$var$has = function(it) {
        return $565c2a6f56aa7a90$var$hasOwn$5(it, $565c2a6f56aa7a90$var$STATE);
    };
}
var $565c2a6f56aa7a90$var$internalState = {
    set: $565c2a6f56aa7a90$var$set,
    get: $565c2a6f56aa7a90$var$get,
    has: $565c2a6f56aa7a90$var$has,
    enforce: $565c2a6f56aa7a90$var$enforce,
    getterFor: $565c2a6f56aa7a90$var$getterFor
};
var $565c2a6f56aa7a90$var$fails$a = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$isCallable$9 = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$hasOwn$4 = $565c2a6f56aa7a90$var$hasOwnProperty_1;
var $565c2a6f56aa7a90$var$DESCRIPTORS$2 = $565c2a6f56aa7a90$var$descriptors;
var $565c2a6f56aa7a90$var$CONFIGURABLE_FUNCTION_NAME$1 = $565c2a6f56aa7a90$var$functionName.CONFIGURABLE;
var $565c2a6f56aa7a90$var$inspectSource$1 = $565c2a6f56aa7a90$var$inspectSource$3;
var $565c2a6f56aa7a90$var$InternalStateModule$1 = $565c2a6f56aa7a90$var$internalState;
var $565c2a6f56aa7a90$var$enforceInternalState = $565c2a6f56aa7a90$var$InternalStateModule$1.enforce;
var $565c2a6f56aa7a90$var$getInternalState$2 = $565c2a6f56aa7a90$var$InternalStateModule$1.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $565c2a6f56aa7a90$var$defineProperty$3 = Object.defineProperty;
var $565c2a6f56aa7a90$var$CONFIGURABLE_LENGTH = $565c2a6f56aa7a90$var$DESCRIPTORS$2 && !$565c2a6f56aa7a90$var$fails$a(function() {
    return $565c2a6f56aa7a90$var$defineProperty$3(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $565c2a6f56aa7a90$var$TEMPLATE = String(String).split("String");
var $565c2a6f56aa7a90$var$makeBuiltIn$1 = $565c2a6f56aa7a90$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$565c2a6f56aa7a90$var$hasOwn$4(value, "name") || $565c2a6f56aa7a90$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($565c2a6f56aa7a90$var$DESCRIPTORS$2) $565c2a6f56aa7a90$var$defineProperty$3(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($565c2a6f56aa7a90$var$CONFIGURABLE_LENGTH && options && $565c2a6f56aa7a90$var$hasOwn$4(options, "arity") && value.length !== options.arity) $565c2a6f56aa7a90$var$defineProperty$3(value, "length", {
        value: options.arity
    });
    try {
        if (options && $565c2a6f56aa7a90$var$hasOwn$4(options, "constructor") && options.constructor) {
            if ($565c2a6f56aa7a90$var$DESCRIPTORS$2) $565c2a6f56aa7a90$var$defineProperty$3(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $565c2a6f56aa7a90$var$enforceInternalState(value);
    if (!$565c2a6f56aa7a90$var$hasOwn$4(state, "source")) state.source = $565c2a6f56aa7a90$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $565c2a6f56aa7a90$var$makeBuiltIn$1(function toString() {
    return $565c2a6f56aa7a90$var$isCallable$9(this) && $565c2a6f56aa7a90$var$getInternalState$2(this).source || $565c2a6f56aa7a90$var$inspectSource$1(this);
}, "toString");
var $565c2a6f56aa7a90$var$isCallable$8 = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$definePropertyModule$3 = $565c2a6f56aa7a90$var$objectDefineProperty;
var $565c2a6f56aa7a90$var$makeBuiltIn = $565c2a6f56aa7a90$var$makeBuiltIn$2.exports;
var $565c2a6f56aa7a90$var$defineGlobalProperty$1 = $565c2a6f56aa7a90$var$defineGlobalProperty$3;
var $565c2a6f56aa7a90$var$defineBuiltIn$4 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($565c2a6f56aa7a90$var$isCallable$8(value)) $565c2a6f56aa7a90$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $565c2a6f56aa7a90$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $565c2a6f56aa7a90$var$definePropertyModule$3.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $565c2a6f56aa7a90$var$objectGetOwnPropertyNames = {};
var $565c2a6f56aa7a90$var$ceil = Math.ceil;
var $565c2a6f56aa7a90$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $565c2a6f56aa7a90$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $565c2a6f56aa7a90$var$floor : $565c2a6f56aa7a90$var$ceil)(n);
};
var $565c2a6f56aa7a90$var$trunc = $565c2a6f56aa7a90$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $565c2a6f56aa7a90$var$toIntegerOrInfinity$3 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $565c2a6f56aa7a90$var$trunc(number);
};
var $565c2a6f56aa7a90$var$toIntegerOrInfinity$2 = $565c2a6f56aa7a90$var$toIntegerOrInfinity$3;
var $565c2a6f56aa7a90$var$max$1 = Math.max;
var $565c2a6f56aa7a90$var$min$3 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $565c2a6f56aa7a90$var$toAbsoluteIndex$2 = function(index, length) {
    var integer = $565c2a6f56aa7a90$var$toIntegerOrInfinity$2(index);
    return integer < 0 ? $565c2a6f56aa7a90$var$max$1(integer + length, 0) : $565c2a6f56aa7a90$var$min$3(integer, length);
};
var $565c2a6f56aa7a90$var$toIntegerOrInfinity$1 = $565c2a6f56aa7a90$var$toIntegerOrInfinity$3;
var $565c2a6f56aa7a90$var$min$2 = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $565c2a6f56aa7a90$var$toLength$3 = function(argument) {
    return argument > 0 ? $565c2a6f56aa7a90$var$min$2($565c2a6f56aa7a90$var$toIntegerOrInfinity$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $565c2a6f56aa7a90$var$toLength$2 = $565c2a6f56aa7a90$var$toLength$3;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $565c2a6f56aa7a90$var$lengthOfArrayLike$2 = function(obj) {
    return $565c2a6f56aa7a90$var$toLength$2(obj.length);
};
var $565c2a6f56aa7a90$var$toIndexedObject$3 = $565c2a6f56aa7a90$var$toIndexedObject$5;
var $565c2a6f56aa7a90$var$toAbsoluteIndex$1 = $565c2a6f56aa7a90$var$toAbsoluteIndex$2;
var $565c2a6f56aa7a90$var$lengthOfArrayLike$1 = $565c2a6f56aa7a90$var$lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $565c2a6f56aa7a90$var$createMethod$2 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $565c2a6f56aa7a90$var$toIndexedObject$3($this);
        var length = $565c2a6f56aa7a90$var$lengthOfArrayLike$1(O);
        var index = $565c2a6f56aa7a90$var$toAbsoluteIndex$1(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $565c2a6f56aa7a90$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $565c2a6f56aa7a90$var$createMethod$2(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $565c2a6f56aa7a90$var$createMethod$2(false)
};
var $565c2a6f56aa7a90$var$uncurryThis$a = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$hasOwn$3 = $565c2a6f56aa7a90$var$hasOwnProperty_1;
var $565c2a6f56aa7a90$var$toIndexedObject$2 = $565c2a6f56aa7a90$var$toIndexedObject$5;
var $565c2a6f56aa7a90$var$indexOf$1 = $565c2a6f56aa7a90$var$arrayIncludes.indexOf;
var $565c2a6f56aa7a90$var$hiddenKeys$2 = $565c2a6f56aa7a90$var$hiddenKeys$4;
var $565c2a6f56aa7a90$var$push$1 = $565c2a6f56aa7a90$var$uncurryThis$a([].push);
var $565c2a6f56aa7a90$var$objectKeysInternal = function(object, names) {
    var O = $565c2a6f56aa7a90$var$toIndexedObject$2(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$565c2a6f56aa7a90$var$hasOwn$3($565c2a6f56aa7a90$var$hiddenKeys$2, key) && $565c2a6f56aa7a90$var$hasOwn$3(O, key) && $565c2a6f56aa7a90$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($565c2a6f56aa7a90$var$hasOwn$3(O, key = names[i++])) ~$565c2a6f56aa7a90$var$indexOf$1(result, key) || $565c2a6f56aa7a90$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $565c2a6f56aa7a90$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $565c2a6f56aa7a90$var$internalObjectKeys$1 = $565c2a6f56aa7a90$var$objectKeysInternal;
var $565c2a6f56aa7a90$var$enumBugKeys$2 = $565c2a6f56aa7a90$var$enumBugKeys$3;
var $565c2a6f56aa7a90$var$hiddenKeys$1 = $565c2a6f56aa7a90$var$enumBugKeys$2.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$565c2a6f56aa7a90$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $565c2a6f56aa7a90$var$internalObjectKeys$1(O, $565c2a6f56aa7a90$var$hiddenKeys$1);
};
var $565c2a6f56aa7a90$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$565c2a6f56aa7a90$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $565c2a6f56aa7a90$var$getBuiltIn$2 = $565c2a6f56aa7a90$var$getBuiltIn$5;
var $565c2a6f56aa7a90$var$uncurryThis$9 = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$getOwnPropertyNamesModule = $565c2a6f56aa7a90$var$objectGetOwnPropertyNames;
var $565c2a6f56aa7a90$var$getOwnPropertySymbolsModule = $565c2a6f56aa7a90$var$objectGetOwnPropertySymbols;
var $565c2a6f56aa7a90$var$anObject$7 = $565c2a6f56aa7a90$var$anObject$9;
var $565c2a6f56aa7a90$var$concat = $565c2a6f56aa7a90$var$uncurryThis$9([].concat);
// all object keys, includes non-enumerable and symbols
var $565c2a6f56aa7a90$var$ownKeys$1 = $565c2a6f56aa7a90$var$getBuiltIn$2("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $565c2a6f56aa7a90$var$getOwnPropertyNamesModule.f($565c2a6f56aa7a90$var$anObject$7(it));
    var getOwnPropertySymbols = $565c2a6f56aa7a90$var$getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? $565c2a6f56aa7a90$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};
var $565c2a6f56aa7a90$var$hasOwn$2 = $565c2a6f56aa7a90$var$hasOwnProperty_1;
var $565c2a6f56aa7a90$var$ownKeys = $565c2a6f56aa7a90$var$ownKeys$1;
var $565c2a6f56aa7a90$var$getOwnPropertyDescriptorModule = $565c2a6f56aa7a90$var$objectGetOwnPropertyDescriptor;
var $565c2a6f56aa7a90$var$definePropertyModule$2 = $565c2a6f56aa7a90$var$objectDefineProperty;
var $565c2a6f56aa7a90$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $565c2a6f56aa7a90$var$ownKeys(source);
    var defineProperty = $565c2a6f56aa7a90$var$definePropertyModule$2.f;
    var getOwnPropertyDescriptor = $565c2a6f56aa7a90$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$565c2a6f56aa7a90$var$hasOwn$2(target, key) && !(exceptions && $565c2a6f56aa7a90$var$hasOwn$2(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $565c2a6f56aa7a90$var$fails$9 = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$isCallable$7 = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$replacement = /#|\.prototype\./;
var $565c2a6f56aa7a90$var$isForced$1 = function(feature, detection) {
    var value = $565c2a6f56aa7a90$var$data[$565c2a6f56aa7a90$var$normalize(feature)];
    return value == $565c2a6f56aa7a90$var$POLYFILL ? true : value == $565c2a6f56aa7a90$var$NATIVE ? false : $565c2a6f56aa7a90$var$isCallable$7(detection) ? $565c2a6f56aa7a90$var$fails$9(detection) : !!detection;
};
var $565c2a6f56aa7a90$var$normalize = $565c2a6f56aa7a90$var$isForced$1.normalize = function(string) {
    return String(string).replace($565c2a6f56aa7a90$var$replacement, ".").toLowerCase();
};
var $565c2a6f56aa7a90$var$data = $565c2a6f56aa7a90$var$isForced$1.data = {};
var $565c2a6f56aa7a90$var$NATIVE = $565c2a6f56aa7a90$var$isForced$1.NATIVE = "N";
var $565c2a6f56aa7a90$var$POLYFILL = $565c2a6f56aa7a90$var$isForced$1.POLYFILL = "P";
var $565c2a6f56aa7a90$var$isForced_1 = $565c2a6f56aa7a90$var$isForced$1;
var $565c2a6f56aa7a90$var$global$6 = $565c2a6f56aa7a90$var$global$f;
var $565c2a6f56aa7a90$var$getOwnPropertyDescriptor$1 = $565c2a6f56aa7a90$var$objectGetOwnPropertyDescriptor.f;
var $565c2a6f56aa7a90$var$createNonEnumerableProperty$3 = $565c2a6f56aa7a90$var$createNonEnumerableProperty$5;
var $565c2a6f56aa7a90$var$defineBuiltIn$3 = $565c2a6f56aa7a90$var$defineBuiltIn$4;
var $565c2a6f56aa7a90$var$defineGlobalProperty = $565c2a6f56aa7a90$var$defineGlobalProperty$3;
var $565c2a6f56aa7a90$var$copyConstructorProperties = $565c2a6f56aa7a90$var$copyConstructorProperties$1;
var $565c2a6f56aa7a90$var$isForced = $565c2a6f56aa7a90$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $565c2a6f56aa7a90$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $565c2a6f56aa7a90$var$global$6;
    else if (STATIC) target = $565c2a6f56aa7a90$var$global$6[TARGET] || $565c2a6f56aa7a90$var$defineGlobalProperty(TARGET, {});
    else target = ($565c2a6f56aa7a90$var$global$6[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $565c2a6f56aa7a90$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $565c2a6f56aa7a90$var$isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $565c2a6f56aa7a90$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $565c2a6f56aa7a90$var$createNonEnumerableProperty$3(sourceProperty, "sham", true);
        $565c2a6f56aa7a90$var$defineBuiltIn$3(target, key, sourceProperty, options);
    }
};
var $565c2a6f56aa7a90$var$wellKnownSymbol$a = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$TO_STRING_TAG$3 = $565c2a6f56aa7a90$var$wellKnownSymbol$a("toStringTag");
var $565c2a6f56aa7a90$var$test = {};
$565c2a6f56aa7a90$var$test[$565c2a6f56aa7a90$var$TO_STRING_TAG$3] = "z";
var $565c2a6f56aa7a90$var$toStringTagSupport = String($565c2a6f56aa7a90$var$test) === "[object z]";
var $565c2a6f56aa7a90$var$TO_STRING_TAG_SUPPORT = $565c2a6f56aa7a90$var$toStringTagSupport;
var $565c2a6f56aa7a90$var$isCallable$6 = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$classofRaw = $565c2a6f56aa7a90$var$classofRaw$1;
var $565c2a6f56aa7a90$var$wellKnownSymbol$9 = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$TO_STRING_TAG$2 = $565c2a6f56aa7a90$var$wellKnownSymbol$9("toStringTag");
var $565c2a6f56aa7a90$var$$Object$1 = Object;
// ES3 wrong here
var $565c2a6f56aa7a90$var$CORRECT_ARGUMENTS = $565c2a6f56aa7a90$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $565c2a6f56aa7a90$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $565c2a6f56aa7a90$var$classof$4 = $565c2a6f56aa7a90$var$TO_STRING_TAG_SUPPORT ? $565c2a6f56aa7a90$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $565c2a6f56aa7a90$var$tryGet(O = $565c2a6f56aa7a90$var$$Object$1(it), $565c2a6f56aa7a90$var$TO_STRING_TAG$2)) == "string" ? tag : $565c2a6f56aa7a90$var$CORRECT_ARGUMENTS ? $565c2a6f56aa7a90$var$classofRaw(O) : (result = $565c2a6f56aa7a90$var$classofRaw(O)) == "Object" && $565c2a6f56aa7a90$var$isCallable$6(O.callee) ? "Arguments" : result;
};
var $565c2a6f56aa7a90$var$classof$3 = $565c2a6f56aa7a90$var$classof$4;
var $565c2a6f56aa7a90$var$$String$1 = String;
var $565c2a6f56aa7a90$var$toString$6 = function(argument) {
    if ($565c2a6f56aa7a90$var$classof$3(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $565c2a6f56aa7a90$var$$String$1(argument);
};
var $565c2a6f56aa7a90$var$anObject$6 = $565c2a6f56aa7a90$var$anObject$9;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $565c2a6f56aa7a90$var$regexpFlags$1 = function() {
    var that = $565c2a6f56aa7a90$var$anObject$6(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $565c2a6f56aa7a90$var$fails$8 = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$global$5 = $565c2a6f56aa7a90$var$global$f;
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $565c2a6f56aa7a90$var$$RegExp$2 = $565c2a6f56aa7a90$var$global$5.RegExp;
var $565c2a6f56aa7a90$var$UNSUPPORTED_Y$2 = $565c2a6f56aa7a90$var$fails$8(function() {
    var re = $565c2a6f56aa7a90$var$$RegExp$2("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $565c2a6f56aa7a90$var$MISSED_STICKY = $565c2a6f56aa7a90$var$UNSUPPORTED_Y$2 || $565c2a6f56aa7a90$var$fails$8(function() {
    return !$565c2a6f56aa7a90$var$$RegExp$2("a", "y").sticky;
});
var $565c2a6f56aa7a90$var$BROKEN_CARET = $565c2a6f56aa7a90$var$UNSUPPORTED_Y$2 || $565c2a6f56aa7a90$var$fails$8(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $565c2a6f56aa7a90$var$$RegExp$2("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});
var $565c2a6f56aa7a90$var$regexpStickyHelpers = {
    BROKEN_CARET: $565c2a6f56aa7a90$var$BROKEN_CARET,
    MISSED_STICKY: $565c2a6f56aa7a90$var$MISSED_STICKY,
    UNSUPPORTED_Y: $565c2a6f56aa7a90$var$UNSUPPORTED_Y$2
};
var $565c2a6f56aa7a90$var$objectDefineProperties = {};
var $565c2a6f56aa7a90$var$internalObjectKeys = $565c2a6f56aa7a90$var$objectKeysInternal;
var $565c2a6f56aa7a90$var$enumBugKeys$1 = $565c2a6f56aa7a90$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $565c2a6f56aa7a90$var$objectKeys$1 = Object.keys || function keys(O) {
    return $565c2a6f56aa7a90$var$internalObjectKeys(O, $565c2a6f56aa7a90$var$enumBugKeys$1);
};
var $565c2a6f56aa7a90$var$DESCRIPTORS$1 = $565c2a6f56aa7a90$var$descriptors;
var $565c2a6f56aa7a90$var$V8_PROTOTYPE_DEFINE_BUG = $565c2a6f56aa7a90$var$v8PrototypeDefineBug;
var $565c2a6f56aa7a90$var$definePropertyModule$1 = $565c2a6f56aa7a90$var$objectDefineProperty;
var $565c2a6f56aa7a90$var$anObject$5 = $565c2a6f56aa7a90$var$anObject$9;
var $565c2a6f56aa7a90$var$toIndexedObject$1 = $565c2a6f56aa7a90$var$toIndexedObject$5;
var $565c2a6f56aa7a90$var$objectKeys = $565c2a6f56aa7a90$var$objectKeys$1;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$565c2a6f56aa7a90$var$objectDefineProperties.f = $565c2a6f56aa7a90$var$DESCRIPTORS$1 && !$565c2a6f56aa7a90$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $565c2a6f56aa7a90$var$anObject$5(O);
    var props = $565c2a6f56aa7a90$var$toIndexedObject$1(Properties);
    var keys = $565c2a6f56aa7a90$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$565c2a6f56aa7a90$var$definePropertyModule$1.f(O, key = keys[index++], props[key]);
    return O;
};
var $565c2a6f56aa7a90$var$getBuiltIn$1 = $565c2a6f56aa7a90$var$getBuiltIn$5;
var $565c2a6f56aa7a90$var$html$1 = $565c2a6f56aa7a90$var$getBuiltIn$1("document", "documentElement");
/* global ActiveXObject -- old IE, WSH */ var $565c2a6f56aa7a90$var$anObject$4 = $565c2a6f56aa7a90$var$anObject$9;
var $565c2a6f56aa7a90$var$definePropertiesModule = $565c2a6f56aa7a90$var$objectDefineProperties;
var $565c2a6f56aa7a90$var$enumBugKeys = $565c2a6f56aa7a90$var$enumBugKeys$3;
var $565c2a6f56aa7a90$var$hiddenKeys = $565c2a6f56aa7a90$var$hiddenKeys$4;
var $565c2a6f56aa7a90$var$html = $565c2a6f56aa7a90$var$html$1;
var $565c2a6f56aa7a90$var$documentCreateElement$1 = $565c2a6f56aa7a90$var$documentCreateElement$2;
var $565c2a6f56aa7a90$var$sharedKey$1 = $565c2a6f56aa7a90$var$sharedKey$3;
var $565c2a6f56aa7a90$var$GT = ">";
var $565c2a6f56aa7a90$var$LT = "<";
var $565c2a6f56aa7a90$var$PROTOTYPE = "prototype";
var $565c2a6f56aa7a90$var$SCRIPT = "script";
var $565c2a6f56aa7a90$var$IE_PROTO$1 = $565c2a6f56aa7a90$var$sharedKey$1("IE_PROTO");
var $565c2a6f56aa7a90$var$EmptyConstructor = function() {};
var $565c2a6f56aa7a90$var$scriptTag = function(content) {
    return $565c2a6f56aa7a90$var$LT + $565c2a6f56aa7a90$var$SCRIPT + $565c2a6f56aa7a90$var$GT + content + $565c2a6f56aa7a90$var$LT + "/" + $565c2a6f56aa7a90$var$SCRIPT + $565c2a6f56aa7a90$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $565c2a6f56aa7a90$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($565c2a6f56aa7a90$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $565c2a6f56aa7a90$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $565c2a6f56aa7a90$var$documentCreateElement$1("iframe");
    var JS = "java" + $565c2a6f56aa7a90$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $565c2a6f56aa7a90$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($565c2a6f56aa7a90$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $565c2a6f56aa7a90$var$activeXDocument;
var $565c2a6f56aa7a90$var$NullProtoObject = function() {
    try {
        $565c2a6f56aa7a90$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $565c2a6f56aa7a90$var$NullProtoObject = typeof document != "undefined" ? document.domain && $565c2a6f56aa7a90$var$activeXDocument ? $565c2a6f56aa7a90$var$NullProtoObjectViaActiveX($565c2a6f56aa7a90$var$activeXDocument) // old IE
     : $565c2a6f56aa7a90$var$NullProtoObjectViaIFrame() : $565c2a6f56aa7a90$var$NullProtoObjectViaActiveX($565c2a6f56aa7a90$var$activeXDocument); // WSH
    var length = $565c2a6f56aa7a90$var$enumBugKeys.length;
    while(length--)delete $565c2a6f56aa7a90$var$NullProtoObject[$565c2a6f56aa7a90$var$PROTOTYPE][$565c2a6f56aa7a90$var$enumBugKeys[length]];
    return $565c2a6f56aa7a90$var$NullProtoObject();
};
$565c2a6f56aa7a90$var$hiddenKeys[$565c2a6f56aa7a90$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $565c2a6f56aa7a90$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $565c2a6f56aa7a90$var$EmptyConstructor[$565c2a6f56aa7a90$var$PROTOTYPE] = $565c2a6f56aa7a90$var$anObject$4(O);
        result = new $565c2a6f56aa7a90$var$EmptyConstructor();
        $565c2a6f56aa7a90$var$EmptyConstructor[$565c2a6f56aa7a90$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$565c2a6f56aa7a90$var$IE_PROTO$1] = O;
    } else result = $565c2a6f56aa7a90$var$NullProtoObject();
    return Properties === undefined ? result : $565c2a6f56aa7a90$var$definePropertiesModule.f(result, Properties);
};
var $565c2a6f56aa7a90$var$fails$7 = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$global$4 = $565c2a6f56aa7a90$var$global$f;
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $565c2a6f56aa7a90$var$$RegExp$1 = $565c2a6f56aa7a90$var$global$4.RegExp;
var $565c2a6f56aa7a90$var$regexpUnsupportedDotAll = $565c2a6f56aa7a90$var$fails$7(function() {
    var re = $565c2a6f56aa7a90$var$$RegExp$1(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});
var $565c2a6f56aa7a90$var$fails$6 = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$global$3 = $565c2a6f56aa7a90$var$global$f;
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $565c2a6f56aa7a90$var$$RegExp = $565c2a6f56aa7a90$var$global$3.RegExp;
var $565c2a6f56aa7a90$var$regexpUnsupportedNcg = $565c2a6f56aa7a90$var$fails$6(function() {
    var re = $565c2a6f56aa7a90$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var $565c2a6f56aa7a90$var$call$4 = $565c2a6f56aa7a90$var$functionCall;
var $565c2a6f56aa7a90$var$uncurryThis$8 = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$toString$5 = $565c2a6f56aa7a90$var$toString$6;
var $565c2a6f56aa7a90$var$regexpFlags = $565c2a6f56aa7a90$var$regexpFlags$1;
var $565c2a6f56aa7a90$var$stickyHelpers$1 = $565c2a6f56aa7a90$var$regexpStickyHelpers;
var $565c2a6f56aa7a90$var$shared = $565c2a6f56aa7a90$var$shared$4.exports;
var $565c2a6f56aa7a90$var$create$2 = $565c2a6f56aa7a90$var$objectCreate;
var $565c2a6f56aa7a90$var$getInternalState$1 = $565c2a6f56aa7a90$var$internalState.get;
var $565c2a6f56aa7a90$var$UNSUPPORTED_DOT_ALL = $565c2a6f56aa7a90$var$regexpUnsupportedDotAll;
var $565c2a6f56aa7a90$var$UNSUPPORTED_NCG = $565c2a6f56aa7a90$var$regexpUnsupportedNcg;
var $565c2a6f56aa7a90$var$nativeReplace = $565c2a6f56aa7a90$var$shared("native-string-replace", String.prototype.replace);
var $565c2a6f56aa7a90$var$nativeExec = RegExp.prototype.exec;
var $565c2a6f56aa7a90$var$patchedExec = $565c2a6f56aa7a90$var$nativeExec;
var $565c2a6f56aa7a90$var$charAt$2 = $565c2a6f56aa7a90$var$uncurryThis$8("".charAt);
var $565c2a6f56aa7a90$var$indexOf = $565c2a6f56aa7a90$var$uncurryThis$8("".indexOf);
var $565c2a6f56aa7a90$var$replace$1 = $565c2a6f56aa7a90$var$uncurryThis$8("".replace);
var $565c2a6f56aa7a90$var$stringSlice$2 = $565c2a6f56aa7a90$var$uncurryThis$8("".slice);
var $565c2a6f56aa7a90$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $565c2a6f56aa7a90$var$call$4($565c2a6f56aa7a90$var$nativeExec, re1, "a");
    $565c2a6f56aa7a90$var$call$4($565c2a6f56aa7a90$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $565c2a6f56aa7a90$var$UNSUPPORTED_Y$1 = $565c2a6f56aa7a90$var$stickyHelpers$1.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $565c2a6f56aa7a90$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $565c2a6f56aa7a90$var$PATCH = $565c2a6f56aa7a90$var$UPDATES_LAST_INDEX_WRONG || $565c2a6f56aa7a90$var$NPCG_INCLUDED || $565c2a6f56aa7a90$var$UNSUPPORTED_Y$1 || $565c2a6f56aa7a90$var$UNSUPPORTED_DOT_ALL || $565c2a6f56aa7a90$var$UNSUPPORTED_NCG;
if ($565c2a6f56aa7a90$var$PATCH) $565c2a6f56aa7a90$var$patchedExec = function exec(string) {
    var re = this;
    var state = $565c2a6f56aa7a90$var$getInternalState$1(re);
    var str = $565c2a6f56aa7a90$var$toString$5(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $565c2a6f56aa7a90$var$call$4($565c2a6f56aa7a90$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $565c2a6f56aa7a90$var$UNSUPPORTED_Y$1 && re.sticky;
    var flags = $565c2a6f56aa7a90$var$call$4($565c2a6f56aa7a90$var$regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $565c2a6f56aa7a90$var$replace$1(flags, "y", "");
        if ($565c2a6f56aa7a90$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $565c2a6f56aa7a90$var$stringSlice$2(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $565c2a6f56aa7a90$var$charAt$2(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($565c2a6f56aa7a90$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($565c2a6f56aa7a90$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $565c2a6f56aa7a90$var$call$4($565c2a6f56aa7a90$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $565c2a6f56aa7a90$var$stringSlice$2(match.input, charsAdded);
            match[0] = $565c2a6f56aa7a90$var$stringSlice$2(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($565c2a6f56aa7a90$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($565c2a6f56aa7a90$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    $565c2a6f56aa7a90$var$call$4($565c2a6f56aa7a90$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $565c2a6f56aa7a90$var$create$2(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
var $565c2a6f56aa7a90$var$regexpExec$3 = $565c2a6f56aa7a90$var$patchedExec;
var $565c2a6f56aa7a90$var$$$3 = $565c2a6f56aa7a90$var$_export;
var $565c2a6f56aa7a90$var$exec$3 = $565c2a6f56aa7a90$var$regexpExec$3;
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$565c2a6f56aa7a90$var$$$3({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $565c2a6f56aa7a90$var$exec$3
}, {
    exec: $565c2a6f56aa7a90$var$exec$3
});
var $565c2a6f56aa7a90$var$NATIVE_BIND = $565c2a6f56aa7a90$var$functionBindNative;
var $565c2a6f56aa7a90$var$FunctionPrototype = Function.prototype;
var $565c2a6f56aa7a90$var$apply$1 = $565c2a6f56aa7a90$var$FunctionPrototype.apply;
var $565c2a6f56aa7a90$var$call$3 = $565c2a6f56aa7a90$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $565c2a6f56aa7a90$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($565c2a6f56aa7a90$var$NATIVE_BIND ? $565c2a6f56aa7a90$var$call$3.bind($565c2a6f56aa7a90$var$apply$1) : function() {
    return $565c2a6f56aa7a90$var$call$3.apply($565c2a6f56aa7a90$var$apply$1, arguments);
});
// TODO: Remove from `core-js@4` since it's moved to entry points
var $565c2a6f56aa7a90$var$uncurryThis$7 = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$defineBuiltIn$2 = $565c2a6f56aa7a90$var$defineBuiltIn$4;
var $565c2a6f56aa7a90$var$regexpExec$2 = $565c2a6f56aa7a90$var$regexpExec$3;
var $565c2a6f56aa7a90$var$fails$5 = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$wellKnownSymbol$8 = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$createNonEnumerableProperty$2 = $565c2a6f56aa7a90$var$createNonEnumerableProperty$5;
var $565c2a6f56aa7a90$var$SPECIES$1 = $565c2a6f56aa7a90$var$wellKnownSymbol$8("species");
var $565c2a6f56aa7a90$var$RegExpPrototype = RegExp.prototype;
var $565c2a6f56aa7a90$var$fixRegexpWellKnownSymbolLogic = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $565c2a6f56aa7a90$var$wellKnownSymbol$8(KEY);
    var DELEGATES_TO_SYMBOL = !$565c2a6f56aa7a90$var$fails$5(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$565c2a6f56aa7a90$var$fails$5(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$565c2a6f56aa7a90$var$SPECIES$1] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $565c2a6f56aa7a90$var$uncurryThis$7(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $565c2a6f56aa7a90$var$uncurryThis$7(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $565c2a6f56aa7a90$var$regexpExec$2 || $exec === $565c2a6f56aa7a90$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $565c2a6f56aa7a90$var$defineBuiltIn$2(String.prototype, KEY, methods[0]);
        $565c2a6f56aa7a90$var$defineBuiltIn$2($565c2a6f56aa7a90$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $565c2a6f56aa7a90$var$createNonEnumerableProperty$2($565c2a6f56aa7a90$var$RegExpPrototype[SYMBOL], "sham", true);
};
var $565c2a6f56aa7a90$var$isObject = $565c2a6f56aa7a90$var$isObject$6;
var $565c2a6f56aa7a90$var$classof$2 = $565c2a6f56aa7a90$var$classofRaw$1;
var $565c2a6f56aa7a90$var$wellKnownSymbol$7 = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$MATCH$1 = $565c2a6f56aa7a90$var$wellKnownSymbol$7("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var $565c2a6f56aa7a90$var$isRegexp = function(it) {
    var isRegExp;
    return $565c2a6f56aa7a90$var$isObject(it) && ((isRegExp = it[$565c2a6f56aa7a90$var$MATCH$1]) !== undefined ? !!isRegExp : $565c2a6f56aa7a90$var$classof$2(it) == "RegExp");
};
var $565c2a6f56aa7a90$var$uncurryThis$6 = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$fails$4 = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$isCallable$5 = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$classof$1 = $565c2a6f56aa7a90$var$classof$4;
var $565c2a6f56aa7a90$var$getBuiltIn = $565c2a6f56aa7a90$var$getBuiltIn$5;
var $565c2a6f56aa7a90$var$inspectSource = $565c2a6f56aa7a90$var$inspectSource$3;
var $565c2a6f56aa7a90$var$noop = function() {};
var $565c2a6f56aa7a90$var$empty = [];
var $565c2a6f56aa7a90$var$construct = $565c2a6f56aa7a90$var$getBuiltIn("Reflect", "construct");
var $565c2a6f56aa7a90$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $565c2a6f56aa7a90$var$exec$2 = $565c2a6f56aa7a90$var$uncurryThis$6($565c2a6f56aa7a90$var$constructorRegExp.exec);
var $565c2a6f56aa7a90$var$INCORRECT_TO_STRING = !$565c2a6f56aa7a90$var$constructorRegExp.exec($565c2a6f56aa7a90$var$noop);
var $565c2a6f56aa7a90$var$isConstructorModern = function isConstructor(argument) {
    if (!$565c2a6f56aa7a90$var$isCallable$5(argument)) return false;
    try {
        $565c2a6f56aa7a90$var$construct($565c2a6f56aa7a90$var$noop, $565c2a6f56aa7a90$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $565c2a6f56aa7a90$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$565c2a6f56aa7a90$var$isCallable$5(argument)) return false;
    switch($565c2a6f56aa7a90$var$classof$1(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $565c2a6f56aa7a90$var$INCORRECT_TO_STRING || !!$565c2a6f56aa7a90$var$exec$2($565c2a6f56aa7a90$var$constructorRegExp, $565c2a6f56aa7a90$var$inspectSource(argument));
    } catch (error) {
        return true;
    }
};
$565c2a6f56aa7a90$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $565c2a6f56aa7a90$var$isConstructor$1 = !$565c2a6f56aa7a90$var$construct || $565c2a6f56aa7a90$var$fails$4(function() {
    var called;
    return $565c2a6f56aa7a90$var$isConstructorModern($565c2a6f56aa7a90$var$isConstructorModern.call) || !$565c2a6f56aa7a90$var$isConstructorModern(Object) || !$565c2a6f56aa7a90$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $565c2a6f56aa7a90$var$isConstructorLegacy : $565c2a6f56aa7a90$var$isConstructorModern;
var $565c2a6f56aa7a90$var$isConstructor = $565c2a6f56aa7a90$var$isConstructor$1;
var $565c2a6f56aa7a90$var$tryToString = $565c2a6f56aa7a90$var$tryToString$2;
var $565c2a6f56aa7a90$var$$TypeError$3 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $565c2a6f56aa7a90$var$aConstructor$1 = function(argument) {
    if ($565c2a6f56aa7a90$var$isConstructor(argument)) return argument;
    throw $565c2a6f56aa7a90$var$$TypeError$3($565c2a6f56aa7a90$var$tryToString(argument) + " is not a constructor");
};
var $565c2a6f56aa7a90$var$anObject$3 = $565c2a6f56aa7a90$var$anObject$9;
var $565c2a6f56aa7a90$var$aConstructor = $565c2a6f56aa7a90$var$aConstructor$1;
var $565c2a6f56aa7a90$var$wellKnownSymbol$6 = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$SPECIES = $565c2a6f56aa7a90$var$wellKnownSymbol$6("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $565c2a6f56aa7a90$var$speciesConstructor$1 = function(O, defaultConstructor) {
    var C = $565c2a6f56aa7a90$var$anObject$3(O).constructor;
    var S;
    return C === undefined || (S = $565c2a6f56aa7a90$var$anObject$3(C)[$565c2a6f56aa7a90$var$SPECIES]) == undefined ? defaultConstructor : $565c2a6f56aa7a90$var$aConstructor(S);
};
var $565c2a6f56aa7a90$var$uncurryThis$5 = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$toIntegerOrInfinity = $565c2a6f56aa7a90$var$toIntegerOrInfinity$3;
var $565c2a6f56aa7a90$var$toString$4 = $565c2a6f56aa7a90$var$toString$6;
var $565c2a6f56aa7a90$var$requireObjectCoercible$3 = $565c2a6f56aa7a90$var$requireObjectCoercible$6;
var $565c2a6f56aa7a90$var$charAt$1 = $565c2a6f56aa7a90$var$uncurryThis$5("".charAt);
var $565c2a6f56aa7a90$var$charCodeAt = $565c2a6f56aa7a90$var$uncurryThis$5("".charCodeAt);
var $565c2a6f56aa7a90$var$stringSlice$1 = $565c2a6f56aa7a90$var$uncurryThis$5("".slice);
var $565c2a6f56aa7a90$var$createMethod$1 = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $565c2a6f56aa7a90$var$toString$4($565c2a6f56aa7a90$var$requireObjectCoercible$3($this));
        var position = $565c2a6f56aa7a90$var$toIntegerOrInfinity(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $565c2a6f56aa7a90$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $565c2a6f56aa7a90$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $565c2a6f56aa7a90$var$charAt$1(S, position) : first : CONVERT_TO_STRING ? $565c2a6f56aa7a90$var$stringSlice$1(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
var $565c2a6f56aa7a90$var$stringMultibyte = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $565c2a6f56aa7a90$var$createMethod$1(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $565c2a6f56aa7a90$var$createMethod$1(true)
};
var $565c2a6f56aa7a90$var$charAt = $565c2a6f56aa7a90$var$stringMultibyte.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var $565c2a6f56aa7a90$var$advanceStringIndex$1 = function(S, index, unicode) {
    return index + (unicode ? $565c2a6f56aa7a90$var$charAt(S, index).length : 1);
};
var $565c2a6f56aa7a90$var$toPropertyKey = $565c2a6f56aa7a90$var$toPropertyKey$3;
var $565c2a6f56aa7a90$var$definePropertyModule = $565c2a6f56aa7a90$var$objectDefineProperty;
var $565c2a6f56aa7a90$var$createPropertyDescriptor$1 = $565c2a6f56aa7a90$var$createPropertyDescriptor$4;
var $565c2a6f56aa7a90$var$createProperty$1 = function(object, key, value) {
    var propertyKey = $565c2a6f56aa7a90$var$toPropertyKey(key);
    if (propertyKey in object) $565c2a6f56aa7a90$var$definePropertyModule.f(object, propertyKey, $565c2a6f56aa7a90$var$createPropertyDescriptor$1(0, value));
    else object[propertyKey] = value;
};
var $565c2a6f56aa7a90$var$toAbsoluteIndex = $565c2a6f56aa7a90$var$toAbsoluteIndex$2;
var $565c2a6f56aa7a90$var$lengthOfArrayLike = $565c2a6f56aa7a90$var$lengthOfArrayLike$2;
var $565c2a6f56aa7a90$var$createProperty = $565c2a6f56aa7a90$var$createProperty$1;
var $565c2a6f56aa7a90$var$$Array = Array;
var $565c2a6f56aa7a90$var$max = Math.max;
var $565c2a6f56aa7a90$var$arraySliceSimple = function(O, start, end) {
    var length = $565c2a6f56aa7a90$var$lengthOfArrayLike(O);
    var k = $565c2a6f56aa7a90$var$toAbsoluteIndex(start, length);
    var fin = $565c2a6f56aa7a90$var$toAbsoluteIndex(end === undefined ? length : end, length);
    var result = $565c2a6f56aa7a90$var$$Array($565c2a6f56aa7a90$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$565c2a6f56aa7a90$var$createProperty(result, n, O[k]);
    result.length = n;
    return result;
};
var $565c2a6f56aa7a90$var$call$2 = $565c2a6f56aa7a90$var$functionCall;
var $565c2a6f56aa7a90$var$anObject$2 = $565c2a6f56aa7a90$var$anObject$9;
var $565c2a6f56aa7a90$var$isCallable$4 = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$classof = $565c2a6f56aa7a90$var$classofRaw$1;
var $565c2a6f56aa7a90$var$regexpExec$1 = $565c2a6f56aa7a90$var$regexpExec$3;
var $565c2a6f56aa7a90$var$$TypeError$2 = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var $565c2a6f56aa7a90$var$regexpExecAbstract = function(R, S) {
    var exec = R.exec;
    if ($565c2a6f56aa7a90$var$isCallable$4(exec)) {
        var result = $565c2a6f56aa7a90$var$call$2(exec, R, S);
        if (result !== null) $565c2a6f56aa7a90$var$anObject$2(result);
        return result;
    }
    if ($565c2a6f56aa7a90$var$classof(R) === "RegExp") return $565c2a6f56aa7a90$var$call$2($565c2a6f56aa7a90$var$regexpExec$1, R, S);
    throw $565c2a6f56aa7a90$var$$TypeError$2("RegExp#exec called on incompatible receiver");
};
var $565c2a6f56aa7a90$var$apply = $565c2a6f56aa7a90$var$functionApply;
var $565c2a6f56aa7a90$var$call$1 = $565c2a6f56aa7a90$var$functionCall;
var $565c2a6f56aa7a90$var$uncurryThis$4 = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$fixRegExpWellKnownSymbolLogic = $565c2a6f56aa7a90$var$fixRegexpWellKnownSymbolLogic;
var $565c2a6f56aa7a90$var$isRegExp$1 = $565c2a6f56aa7a90$var$isRegexp;
var $565c2a6f56aa7a90$var$anObject$1 = $565c2a6f56aa7a90$var$anObject$9;
var $565c2a6f56aa7a90$var$requireObjectCoercible$2 = $565c2a6f56aa7a90$var$requireObjectCoercible$6;
var $565c2a6f56aa7a90$var$speciesConstructor = $565c2a6f56aa7a90$var$speciesConstructor$1;
var $565c2a6f56aa7a90$var$advanceStringIndex = $565c2a6f56aa7a90$var$advanceStringIndex$1;
var $565c2a6f56aa7a90$var$toLength$1 = $565c2a6f56aa7a90$var$toLength$3;
var $565c2a6f56aa7a90$var$toString$3 = $565c2a6f56aa7a90$var$toString$6;
var $565c2a6f56aa7a90$var$getMethod = $565c2a6f56aa7a90$var$getMethod$2;
var $565c2a6f56aa7a90$var$arraySlice = $565c2a6f56aa7a90$var$arraySliceSimple;
var $565c2a6f56aa7a90$var$callRegExpExec = $565c2a6f56aa7a90$var$regexpExecAbstract;
var $565c2a6f56aa7a90$var$regexpExec = $565c2a6f56aa7a90$var$regexpExec$3;
var $565c2a6f56aa7a90$var$stickyHelpers = $565c2a6f56aa7a90$var$regexpStickyHelpers;
var $565c2a6f56aa7a90$var$fails$3 = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$UNSUPPORTED_Y = $565c2a6f56aa7a90$var$stickyHelpers.UNSUPPORTED_Y;
var $565c2a6f56aa7a90$var$MAX_UINT32 = 0xFFFFFFFF;
var $565c2a6f56aa7a90$var$min$1 = Math.min;
var $565c2a6f56aa7a90$var$$push = [].push;
var $565c2a6f56aa7a90$var$exec$1 = $565c2a6f56aa7a90$var$uncurryThis$4(/./.exec);
var $565c2a6f56aa7a90$var$push = $565c2a6f56aa7a90$var$uncurryThis$4($565c2a6f56aa7a90$var$$push);
var $565c2a6f56aa7a90$var$stringSlice = $565c2a6f56aa7a90$var$uncurryThis$4("".slice);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var $565c2a6f56aa7a90$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !$565c2a6f56aa7a90$var$fails$3(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = "ab".split(re);
    return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
});
// @@split logic
$565c2a6f56aa7a90$var$fixRegExpWellKnownSymbolLogic("split", function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit;
    if ("abbc".split(/(b)*/)[1] == "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
    "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    ".".split(/()()/).length > 1 || "".split(/.?/).length) // based on es5-shim implementation, need to rework it
    internalSplit = function(separator, limit) {
        var string = $565c2a6f56aa7a90$var$toString$3($565c2a6f56aa7a90$var$requireObjectCoercible$2(this));
        var lim = limit === undefined ? $565c2a6f56aa7a90$var$MAX_UINT32 : limit >>> 0;
        if (lim === 0) return [];
        if (separator === undefined) return [
            string
        ];
        // If `separator` is not a regex, use native split
        if (!$565c2a6f56aa7a90$var$isRegExp$1(separator)) return $565c2a6f56aa7a90$var$call$1(nativeSplit, string, separator, lim);
        var output = [];
        var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
        var lastLastIndex = 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + "g");
        var match, lastIndex, lastLength;
        while(match = $565c2a6f56aa7a90$var$call$1($565c2a6f56aa7a90$var$regexpExec, separatorCopy, string)){
            lastIndex = separatorCopy.lastIndex;
            if (lastIndex > lastLastIndex) {
                $565c2a6f56aa7a90$var$push(output, $565c2a6f56aa7a90$var$stringSlice(string, lastLastIndex, match.index));
                if (match.length > 1 && match.index < string.length) $565c2a6f56aa7a90$var$apply($565c2a6f56aa7a90$var$$push, output, $565c2a6f56aa7a90$var$arraySlice(match, 1));
                lastLength = match[0].length;
                lastLastIndex = lastIndex;
                if (output.length >= lim) break;
            }
            if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
        }
        if (lastLastIndex === string.length) {
            if (lastLength || !$565c2a6f56aa7a90$var$exec$1(separatorCopy, "")) $565c2a6f56aa7a90$var$push(output, "");
        } else $565c2a6f56aa7a90$var$push(output, $565c2a6f56aa7a90$var$stringSlice(string, lastLastIndex));
        return output.length > lim ? $565c2a6f56aa7a90$var$arraySlice(output, 0, lim) : output;
    };
    else if ("0".split(undefined, 0).length) internalSplit = function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $565c2a6f56aa7a90$var$call$1(nativeSplit, this, separator, limit);
    };
    else internalSplit = nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = $565c2a6f56aa7a90$var$requireObjectCoercible$2(this);
            var splitter = separator == undefined ? undefined : $565c2a6f56aa7a90$var$getMethod(separator, SPLIT);
            return splitter ? $565c2a6f56aa7a90$var$call$1(splitter, separator, O, limit) : $565c2a6f56aa7a90$var$call$1(internalSplit, $565c2a6f56aa7a90$var$toString$3(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = $565c2a6f56aa7a90$var$anObject$1(this);
            var S = $565c2a6f56aa7a90$var$toString$3(string);
            var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
            if (res.done) return res.value;
            var C = $565c2a6f56aa7a90$var$speciesConstructor(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + ($565c2a6f56aa7a90$var$UNSUPPORTED_Y ? "g" : "y");
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($565c2a6f56aa7a90$var$UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
            var lim = limit === undefined ? $565c2a6f56aa7a90$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $565c2a6f56aa7a90$var$callRegExpExec(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $565c2a6f56aa7a90$var$UNSUPPORTED_Y ? 0 : q;
                var z = $565c2a6f56aa7a90$var$callRegExpExec(splitter, $565c2a6f56aa7a90$var$UNSUPPORTED_Y ? $565c2a6f56aa7a90$var$stringSlice(S, q) : S);
                var e;
                if (z === null || (e = $565c2a6f56aa7a90$var$min$1($565c2a6f56aa7a90$var$toLength$1(splitter.lastIndex + ($565c2a6f56aa7a90$var$UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = $565c2a6f56aa7a90$var$advanceStringIndex(S, q, unicodeMatching);
                else {
                    $565c2a6f56aa7a90$var$push(A, $565c2a6f56aa7a90$var$stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        $565c2a6f56aa7a90$var$push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            $565c2a6f56aa7a90$var$push(A, $565c2a6f56aa7a90$var$stringSlice(S, p));
            return A;
        }
    ];
}, !$565c2a6f56aa7a90$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, $565c2a6f56aa7a90$var$UNSUPPORTED_Y);
var $565c2a6f56aa7a90$var$isRegExp = $565c2a6f56aa7a90$var$isRegexp;
var $565c2a6f56aa7a90$var$$TypeError$1 = TypeError;
var $565c2a6f56aa7a90$var$notARegexp = function(it) {
    if ($565c2a6f56aa7a90$var$isRegExp(it)) throw $565c2a6f56aa7a90$var$$TypeError$1("The method doesn't accept regular expressions");
    return it;
};
var $565c2a6f56aa7a90$var$wellKnownSymbol$5 = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$MATCH = $565c2a6f56aa7a90$var$wellKnownSymbol$5("match");
var $565c2a6f56aa7a90$var$correctIsRegexpLogic = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$565c2a6f56aa7a90$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};
var $565c2a6f56aa7a90$var$$$2 = $565c2a6f56aa7a90$var$_export;
var $565c2a6f56aa7a90$var$uncurryThis$3 = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$getOwnPropertyDescriptor = $565c2a6f56aa7a90$var$objectGetOwnPropertyDescriptor.f;
var $565c2a6f56aa7a90$var$toLength = $565c2a6f56aa7a90$var$toLength$3;
var $565c2a6f56aa7a90$var$toString$2 = $565c2a6f56aa7a90$var$toString$6;
var $565c2a6f56aa7a90$var$notARegExp = $565c2a6f56aa7a90$var$notARegexp;
var $565c2a6f56aa7a90$var$requireObjectCoercible$1 = $565c2a6f56aa7a90$var$requireObjectCoercible$6;
var $565c2a6f56aa7a90$var$correctIsRegExpLogic = $565c2a6f56aa7a90$var$correctIsRegexpLogic;
// eslint-disable-next-line es-x/no-string-prototype-endswith -- safe
var $565c2a6f56aa7a90$var$un$EndsWith = $565c2a6f56aa7a90$var$uncurryThis$3("".endsWith);
var $565c2a6f56aa7a90$var$slice = $565c2a6f56aa7a90$var$uncurryThis$3("".slice);
var $565c2a6f56aa7a90$var$min = Math.min;
var $565c2a6f56aa7a90$var$CORRECT_IS_REGEXP_LOGIC = $565c2a6f56aa7a90$var$correctIsRegExpLogic("endsWith");
// https://github.com/zloirock/core-js/pull/702
var $565c2a6f56aa7a90$var$MDN_POLYFILL_BUG = !$565c2a6f56aa7a90$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $565c2a6f56aa7a90$var$getOwnPropertyDescriptor(String.prototype, "endsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$565c2a6f56aa7a90$var$$$2({
    target: "String",
    proto: true,
    forced: !$565c2a6f56aa7a90$var$MDN_POLYFILL_BUG && !$565c2a6f56aa7a90$var$CORRECT_IS_REGEXP_LOGIC
}, {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $565c2a6f56aa7a90$var$toString$2($565c2a6f56aa7a90$var$requireObjectCoercible$1(this));
        $565c2a6f56aa7a90$var$notARegExp(searchString);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = that.length;
        var end = endPosition === undefined ? len : $565c2a6f56aa7a90$var$min($565c2a6f56aa7a90$var$toLength(endPosition), len);
        var search = $565c2a6f56aa7a90$var$toString$2(searchString);
        return $565c2a6f56aa7a90$var$un$EndsWith ? $565c2a6f56aa7a90$var$un$EndsWith(that, search, end) : $565c2a6f56aa7a90$var$slice(that, end - search.length, end) === search;
    }
});
// a string of all valid unicode whitespaces
var $565c2a6f56aa7a90$var$whitespaces$2 = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var $565c2a6f56aa7a90$var$uncurryThis$2 = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$requireObjectCoercible = $565c2a6f56aa7a90$var$requireObjectCoercible$6;
var $565c2a6f56aa7a90$var$toString$1 = $565c2a6f56aa7a90$var$toString$6;
var $565c2a6f56aa7a90$var$whitespaces$1 = $565c2a6f56aa7a90$var$whitespaces$2;
var $565c2a6f56aa7a90$var$replace = $565c2a6f56aa7a90$var$uncurryThis$2("".replace);
var $565c2a6f56aa7a90$var$whitespace = "[" + $565c2a6f56aa7a90$var$whitespaces$1 + "]";
var $565c2a6f56aa7a90$var$ltrim = RegExp("^" + $565c2a6f56aa7a90$var$whitespace + $565c2a6f56aa7a90$var$whitespace + "*");
var $565c2a6f56aa7a90$var$rtrim = RegExp($565c2a6f56aa7a90$var$whitespace + $565c2a6f56aa7a90$var$whitespace + "*$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $565c2a6f56aa7a90$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $565c2a6f56aa7a90$var$toString$1($565c2a6f56aa7a90$var$requireObjectCoercible($this));
        if (TYPE & 1) string = $565c2a6f56aa7a90$var$replace(string, $565c2a6f56aa7a90$var$ltrim, "");
        if (TYPE & 2) string = $565c2a6f56aa7a90$var$replace(string, $565c2a6f56aa7a90$var$rtrim, "");
        return string;
    };
};
var $565c2a6f56aa7a90$var$stringTrim = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $565c2a6f56aa7a90$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $565c2a6f56aa7a90$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $565c2a6f56aa7a90$var$createMethod(3)
};
var $565c2a6f56aa7a90$var$global$2 = $565c2a6f56aa7a90$var$global$f;
var $565c2a6f56aa7a90$var$fails$2 = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$uncurryThis$1 = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$toString = $565c2a6f56aa7a90$var$toString$6;
var $565c2a6f56aa7a90$var$trim = $565c2a6f56aa7a90$var$stringTrim.trim;
var $565c2a6f56aa7a90$var$whitespaces = $565c2a6f56aa7a90$var$whitespaces$2;
var $565c2a6f56aa7a90$var$$parseInt$1 = $565c2a6f56aa7a90$var$global$2.parseInt;
var $565c2a6f56aa7a90$var$Symbol$1 = $565c2a6f56aa7a90$var$global$2.Symbol;
var $565c2a6f56aa7a90$var$ITERATOR$3 = $565c2a6f56aa7a90$var$Symbol$1 && $565c2a6f56aa7a90$var$Symbol$1.iterator;
var $565c2a6f56aa7a90$var$hex = /^[+-]?0x/i;
var $565c2a6f56aa7a90$var$exec = $565c2a6f56aa7a90$var$uncurryThis$1($565c2a6f56aa7a90$var$hex.exec);
var $565c2a6f56aa7a90$var$FORCED = $565c2a6f56aa7a90$var$$parseInt$1($565c2a6f56aa7a90$var$whitespaces + "08") !== 8 || $565c2a6f56aa7a90$var$$parseInt$1($565c2a6f56aa7a90$var$whitespaces + "0x16") !== 22 || $565c2a6f56aa7a90$var$ITERATOR$3 && !$565c2a6f56aa7a90$var$fails$2(function() {
    $565c2a6f56aa7a90$var$$parseInt$1(Object($565c2a6f56aa7a90$var$ITERATOR$3));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var $565c2a6f56aa7a90$var$numberParseInt = $565c2a6f56aa7a90$var$FORCED ? function parseInt1(string, radix) {
    var S = $565c2a6f56aa7a90$var$trim($565c2a6f56aa7a90$var$toString(string));
    return $565c2a6f56aa7a90$var$$parseInt$1(S, radix >>> 0 || ($565c2a6f56aa7a90$var$exec($565c2a6f56aa7a90$var$hex, S) ? 16 : 10));
} : $565c2a6f56aa7a90$var$$parseInt$1;
var $565c2a6f56aa7a90$var$$$1 = $565c2a6f56aa7a90$var$_export;
var $565c2a6f56aa7a90$var$$parseInt = $565c2a6f56aa7a90$var$numberParseInt;
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$565c2a6f56aa7a90$var$$$1({
    global: true,
    forced: parseInt != $565c2a6f56aa7a90$var$$parseInt
}, {
    parseInt: $565c2a6f56aa7a90$var$$parseInt
});
var $565c2a6f56aa7a90$var$wellKnownSymbol$4 = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$create$1 = $565c2a6f56aa7a90$var$objectCreate;
var $565c2a6f56aa7a90$var$defineProperty$2 = $565c2a6f56aa7a90$var$objectDefineProperty.f;
var $565c2a6f56aa7a90$var$UNSCOPABLES = $565c2a6f56aa7a90$var$wellKnownSymbol$4("unscopables");
var $565c2a6f56aa7a90$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($565c2a6f56aa7a90$var$ArrayPrototype[$565c2a6f56aa7a90$var$UNSCOPABLES] == undefined) $565c2a6f56aa7a90$var$defineProperty$2($565c2a6f56aa7a90$var$ArrayPrototype, $565c2a6f56aa7a90$var$UNSCOPABLES, {
    configurable: true,
    value: $565c2a6f56aa7a90$var$create$1(null)
});
// add a key to Array.prototype[@@unscopables]
var $565c2a6f56aa7a90$var$addToUnscopables$1 = function(key) {
    $565c2a6f56aa7a90$var$ArrayPrototype[$565c2a6f56aa7a90$var$UNSCOPABLES][key] = true;
};
var $565c2a6f56aa7a90$var$iterators = {};
var $565c2a6f56aa7a90$var$fails$1 = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$correctPrototypeGetter = !$565c2a6f56aa7a90$var$fails$1(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $565c2a6f56aa7a90$var$hasOwn$1 = $565c2a6f56aa7a90$var$hasOwnProperty_1;
var $565c2a6f56aa7a90$var$isCallable$3 = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$toObject = $565c2a6f56aa7a90$var$toObject$2;
var $565c2a6f56aa7a90$var$sharedKey = $565c2a6f56aa7a90$var$sharedKey$3;
var $565c2a6f56aa7a90$var$CORRECT_PROTOTYPE_GETTER = $565c2a6f56aa7a90$var$correctPrototypeGetter;
var $565c2a6f56aa7a90$var$IE_PROTO = $565c2a6f56aa7a90$var$sharedKey("IE_PROTO");
var $565c2a6f56aa7a90$var$$Object = Object;
var $565c2a6f56aa7a90$var$ObjectPrototype = $565c2a6f56aa7a90$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $565c2a6f56aa7a90$var$objectGetPrototypeOf = $565c2a6f56aa7a90$var$CORRECT_PROTOTYPE_GETTER ? $565c2a6f56aa7a90$var$$Object.getPrototypeOf : function(O) {
    var object = $565c2a6f56aa7a90$var$toObject(O);
    if ($565c2a6f56aa7a90$var$hasOwn$1(object, $565c2a6f56aa7a90$var$IE_PROTO)) return object[$565c2a6f56aa7a90$var$IE_PROTO];
    var constructor = object.constructor;
    if ($565c2a6f56aa7a90$var$isCallable$3(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $565c2a6f56aa7a90$var$$Object ? $565c2a6f56aa7a90$var$ObjectPrototype : null;
};
var $565c2a6f56aa7a90$var$fails = $565c2a6f56aa7a90$var$fails$h;
var $565c2a6f56aa7a90$var$isCallable$2 = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$getPrototypeOf$1 = $565c2a6f56aa7a90$var$objectGetPrototypeOf;
var $565c2a6f56aa7a90$var$defineBuiltIn$1 = $565c2a6f56aa7a90$var$defineBuiltIn$4;
var $565c2a6f56aa7a90$var$wellKnownSymbol$3 = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$ITERATOR$2 = $565c2a6f56aa7a90$var$wellKnownSymbol$3("iterator");
var $565c2a6f56aa7a90$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $565c2a6f56aa7a90$var$IteratorPrototype$2, $565c2a6f56aa7a90$var$PrototypeOfArrayIteratorPrototype, $565c2a6f56aa7a90$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $565c2a6f56aa7a90$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $565c2a6f56aa7a90$var$arrayIterator)) $565c2a6f56aa7a90$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $565c2a6f56aa7a90$var$PrototypeOfArrayIteratorPrototype = $565c2a6f56aa7a90$var$getPrototypeOf$1($565c2a6f56aa7a90$var$getPrototypeOf$1($565c2a6f56aa7a90$var$arrayIterator));
        if ($565c2a6f56aa7a90$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $565c2a6f56aa7a90$var$IteratorPrototype$2 = $565c2a6f56aa7a90$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $565c2a6f56aa7a90$var$NEW_ITERATOR_PROTOTYPE = $565c2a6f56aa7a90$var$IteratorPrototype$2 == undefined || $565c2a6f56aa7a90$var$fails(function() {
    var test = {};
    // FF44- legacy iterators case
    return $565c2a6f56aa7a90$var$IteratorPrototype$2[$565c2a6f56aa7a90$var$ITERATOR$2].call(test) !== test;
});
if ($565c2a6f56aa7a90$var$NEW_ITERATOR_PROTOTYPE) $565c2a6f56aa7a90$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$565c2a6f56aa7a90$var$isCallable$2($565c2a6f56aa7a90$var$IteratorPrototype$2[$565c2a6f56aa7a90$var$ITERATOR$2])) $565c2a6f56aa7a90$var$defineBuiltIn$1($565c2a6f56aa7a90$var$IteratorPrototype$2, $565c2a6f56aa7a90$var$ITERATOR$2, function() {
    return this;
});
var $565c2a6f56aa7a90$var$iteratorsCore = {
    IteratorPrototype: $565c2a6f56aa7a90$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $565c2a6f56aa7a90$var$BUGGY_SAFARI_ITERATORS$1
};
var $565c2a6f56aa7a90$var$defineProperty$1 = $565c2a6f56aa7a90$var$objectDefineProperty.f;
var $565c2a6f56aa7a90$var$hasOwn = $565c2a6f56aa7a90$var$hasOwnProperty_1;
var $565c2a6f56aa7a90$var$wellKnownSymbol$2 = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$TO_STRING_TAG$1 = $565c2a6f56aa7a90$var$wellKnownSymbol$2("toStringTag");
var $565c2a6f56aa7a90$var$setToStringTag$2 = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$565c2a6f56aa7a90$var$hasOwn(target, $565c2a6f56aa7a90$var$TO_STRING_TAG$1)) $565c2a6f56aa7a90$var$defineProperty$1(target, $565c2a6f56aa7a90$var$TO_STRING_TAG$1, {
        configurable: true,
        value: TAG
    });
};
var $565c2a6f56aa7a90$var$IteratorPrototype$1 = $565c2a6f56aa7a90$var$iteratorsCore.IteratorPrototype;
var $565c2a6f56aa7a90$var$create = $565c2a6f56aa7a90$var$objectCreate;
var $565c2a6f56aa7a90$var$createPropertyDescriptor = $565c2a6f56aa7a90$var$createPropertyDescriptor$4;
var $565c2a6f56aa7a90$var$setToStringTag$1 = $565c2a6f56aa7a90$var$setToStringTag$2;
var $565c2a6f56aa7a90$var$Iterators$2 = $565c2a6f56aa7a90$var$iterators;
var $565c2a6f56aa7a90$var$returnThis$1 = function() {
    return this;
};
var $565c2a6f56aa7a90$var$createIteratorConstructor$1 = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $565c2a6f56aa7a90$var$create($565c2a6f56aa7a90$var$IteratorPrototype$1, {
        next: $565c2a6f56aa7a90$var$createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
    });
    $565c2a6f56aa7a90$var$setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
    $565c2a6f56aa7a90$var$Iterators$2[TO_STRING_TAG] = $565c2a6f56aa7a90$var$returnThis$1;
    return IteratorConstructor;
};
var $565c2a6f56aa7a90$var$isCallable$1 = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$$String = String;
var $565c2a6f56aa7a90$var$$TypeError = TypeError;
var $565c2a6f56aa7a90$var$aPossiblePrototype$1 = function(argument) {
    if (typeof argument == "object" || $565c2a6f56aa7a90$var$isCallable$1(argument)) return argument;
    throw $565c2a6f56aa7a90$var$$TypeError("Can't set " + $565c2a6f56aa7a90$var$$String(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $565c2a6f56aa7a90$var$uncurryThis = $565c2a6f56aa7a90$var$functionUncurryThis;
var $565c2a6f56aa7a90$var$anObject = $565c2a6f56aa7a90$var$anObject$9;
var $565c2a6f56aa7a90$var$aPossiblePrototype = $565c2a6f56aa7a90$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $565c2a6f56aa7a90$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $565c2a6f56aa7a90$var$uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $565c2a6f56aa7a90$var$anObject(O);
        $565c2a6f56aa7a90$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $565c2a6f56aa7a90$var$$ = $565c2a6f56aa7a90$var$_export;
var $565c2a6f56aa7a90$var$call = $565c2a6f56aa7a90$var$functionCall;
var $565c2a6f56aa7a90$var$FunctionName = $565c2a6f56aa7a90$var$functionName;
var $565c2a6f56aa7a90$var$isCallable = $565c2a6f56aa7a90$var$isCallable$h;
var $565c2a6f56aa7a90$var$createIteratorConstructor = $565c2a6f56aa7a90$var$createIteratorConstructor$1;
var $565c2a6f56aa7a90$var$getPrototypeOf = $565c2a6f56aa7a90$var$objectGetPrototypeOf;
var $565c2a6f56aa7a90$var$setPrototypeOf = $565c2a6f56aa7a90$var$objectSetPrototypeOf;
var $565c2a6f56aa7a90$var$setToStringTag = $565c2a6f56aa7a90$var$setToStringTag$2;
var $565c2a6f56aa7a90$var$createNonEnumerableProperty$1 = $565c2a6f56aa7a90$var$createNonEnumerableProperty$5;
var $565c2a6f56aa7a90$var$defineBuiltIn = $565c2a6f56aa7a90$var$defineBuiltIn$4;
var $565c2a6f56aa7a90$var$wellKnownSymbol$1 = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$Iterators$1 = $565c2a6f56aa7a90$var$iterators;
var $565c2a6f56aa7a90$var$IteratorsCore = $565c2a6f56aa7a90$var$iteratorsCore;
var $565c2a6f56aa7a90$var$PROPER_FUNCTION_NAME = $565c2a6f56aa7a90$var$FunctionName.PROPER;
var $565c2a6f56aa7a90$var$CONFIGURABLE_FUNCTION_NAME = $565c2a6f56aa7a90$var$FunctionName.CONFIGURABLE;
var $565c2a6f56aa7a90$var$IteratorPrototype = $565c2a6f56aa7a90$var$IteratorsCore.IteratorPrototype;
var $565c2a6f56aa7a90$var$BUGGY_SAFARI_ITERATORS = $565c2a6f56aa7a90$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $565c2a6f56aa7a90$var$ITERATOR$1 = $565c2a6f56aa7a90$var$wellKnownSymbol$1("iterator");
var $565c2a6f56aa7a90$var$KEYS = "keys";
var $565c2a6f56aa7a90$var$VALUES = "values";
var $565c2a6f56aa7a90$var$ENTRIES = "entries";
var $565c2a6f56aa7a90$var$returnThis = function() {
    return this;
};
var $565c2a6f56aa7a90$var$defineIterator$1 = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $565c2a6f56aa7a90$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$565c2a6f56aa7a90$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $565c2a6f56aa7a90$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $565c2a6f56aa7a90$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $565c2a6f56aa7a90$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$565c2a6f56aa7a90$var$ITERATOR$1] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$565c2a6f56aa7a90$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $565c2a6f56aa7a90$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($565c2a6f56aa7a90$var$getPrototypeOf(CurrentIteratorPrototype) !== $565c2a6f56aa7a90$var$IteratorPrototype) {
                if ($565c2a6f56aa7a90$var$setPrototypeOf) $565c2a6f56aa7a90$var$setPrototypeOf(CurrentIteratorPrototype, $565c2a6f56aa7a90$var$IteratorPrototype);
                else if (!$565c2a6f56aa7a90$var$isCallable(CurrentIteratorPrototype[$565c2a6f56aa7a90$var$ITERATOR$1])) $565c2a6f56aa7a90$var$defineBuiltIn(CurrentIteratorPrototype, $565c2a6f56aa7a90$var$ITERATOR$1, $565c2a6f56aa7a90$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $565c2a6f56aa7a90$var$setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($565c2a6f56aa7a90$var$PROPER_FUNCTION_NAME && DEFAULT == $565c2a6f56aa7a90$var$VALUES && nativeIterator && nativeIterator.name !== $565c2a6f56aa7a90$var$VALUES) {
        if ($565c2a6f56aa7a90$var$CONFIGURABLE_FUNCTION_NAME) $565c2a6f56aa7a90$var$createNonEnumerableProperty$1(IterablePrototype, "name", $565c2a6f56aa7a90$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $565c2a6f56aa7a90$var$call(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($565c2a6f56aa7a90$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($565c2a6f56aa7a90$var$KEYS),
            entries: getIterationMethod($565c2a6f56aa7a90$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($565c2a6f56aa7a90$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $565c2a6f56aa7a90$var$defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
        } else $565c2a6f56aa7a90$var$$({
            target: NAME,
            proto: true,
            forced: $565c2a6f56aa7a90$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$565c2a6f56aa7a90$var$ITERATOR$1] !== defaultIterator) $565c2a6f56aa7a90$var$defineBuiltIn(IterablePrototype, $565c2a6f56aa7a90$var$ITERATOR$1, defaultIterator, {
        name: DEFAULT
    });
    $565c2a6f56aa7a90$var$Iterators$1[NAME] = defaultIterator;
    return methods;
};
var $565c2a6f56aa7a90$var$toIndexedObject = $565c2a6f56aa7a90$var$toIndexedObject$5;
var $565c2a6f56aa7a90$var$addToUnscopables = $565c2a6f56aa7a90$var$addToUnscopables$1;
var $565c2a6f56aa7a90$var$Iterators = $565c2a6f56aa7a90$var$iterators;
var $565c2a6f56aa7a90$var$InternalStateModule = $565c2a6f56aa7a90$var$internalState;
var $565c2a6f56aa7a90$var$defineProperty = $565c2a6f56aa7a90$var$objectDefineProperty.f;
var $565c2a6f56aa7a90$var$defineIterator = $565c2a6f56aa7a90$var$defineIterator$1;
var $565c2a6f56aa7a90$var$DESCRIPTORS = $565c2a6f56aa7a90$var$descriptors;
var $565c2a6f56aa7a90$var$ARRAY_ITERATOR = "Array Iterator";
var $565c2a6f56aa7a90$var$setInternalState = $565c2a6f56aa7a90$var$InternalStateModule.set;
var $565c2a6f56aa7a90$var$getInternalState = $565c2a6f56aa7a90$var$InternalStateModule.getterFor($565c2a6f56aa7a90$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $565c2a6f56aa7a90$var$es_array_iterator = $565c2a6f56aa7a90$var$defineIterator(Array, "Array", function(iterated, kind) {
    $565c2a6f56aa7a90$var$setInternalState(this, {
        type: $565c2a6f56aa7a90$var$ARRAY_ITERATOR,
        target: $565c2a6f56aa7a90$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $565c2a6f56aa7a90$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $565c2a6f56aa7a90$var$values = $565c2a6f56aa7a90$var$Iterators.Arguments = $565c2a6f56aa7a90$var$Iterators.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$565c2a6f56aa7a90$var$addToUnscopables("keys");
$565c2a6f56aa7a90$var$addToUnscopables("values");
$565c2a6f56aa7a90$var$addToUnscopables("entries");
// V8 ~ Chrome 45- bug
if ($565c2a6f56aa7a90$var$DESCRIPTORS && $565c2a6f56aa7a90$var$values.name !== "values") try {
    $565c2a6f56aa7a90$var$defineProperty($565c2a6f56aa7a90$var$values, "name", {
        value: "values"
    });
} catch (error) {}
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $565c2a6f56aa7a90$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $565c2a6f56aa7a90$var$documentCreateElement = $565c2a6f56aa7a90$var$documentCreateElement$2;
var $565c2a6f56aa7a90$var$classList = $565c2a6f56aa7a90$var$documentCreateElement("span").classList;
var $565c2a6f56aa7a90$var$DOMTokenListPrototype$1 = $565c2a6f56aa7a90$var$classList && $565c2a6f56aa7a90$var$classList.constructor && $565c2a6f56aa7a90$var$classList.constructor.prototype;
var $565c2a6f56aa7a90$var$domTokenListPrototype = $565c2a6f56aa7a90$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $565c2a6f56aa7a90$var$DOMTokenListPrototype$1;
var $565c2a6f56aa7a90$var$global$1 = $565c2a6f56aa7a90$var$global$f;
var $565c2a6f56aa7a90$var$DOMIterables = $565c2a6f56aa7a90$var$domIterables;
var $565c2a6f56aa7a90$var$DOMTokenListPrototype = $565c2a6f56aa7a90$var$domTokenListPrototype;
var $565c2a6f56aa7a90$var$ArrayIteratorMethods = $565c2a6f56aa7a90$var$es_array_iterator;
var $565c2a6f56aa7a90$var$createNonEnumerableProperty = $565c2a6f56aa7a90$var$createNonEnumerableProperty$5;
var $565c2a6f56aa7a90$var$wellKnownSymbol = $565c2a6f56aa7a90$var$wellKnownSymbol$c;
var $565c2a6f56aa7a90$var$ITERATOR = $565c2a6f56aa7a90$var$wellKnownSymbol("iterator");
var $565c2a6f56aa7a90$var$TO_STRING_TAG = $565c2a6f56aa7a90$var$wellKnownSymbol("toStringTag");
var $565c2a6f56aa7a90$var$ArrayValues = $565c2a6f56aa7a90$var$ArrayIteratorMethods.values;
var $565c2a6f56aa7a90$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$565c2a6f56aa7a90$var$ITERATOR] !== $565c2a6f56aa7a90$var$ArrayValues) try {
            $565c2a6f56aa7a90$var$createNonEnumerableProperty(CollectionPrototype, $565c2a6f56aa7a90$var$ITERATOR, $565c2a6f56aa7a90$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$565c2a6f56aa7a90$var$ITERATOR] = $565c2a6f56aa7a90$var$ArrayValues;
        }
        if (!CollectionPrototype[$565c2a6f56aa7a90$var$TO_STRING_TAG]) $565c2a6f56aa7a90$var$createNonEnumerableProperty(CollectionPrototype, $565c2a6f56aa7a90$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($565c2a6f56aa7a90$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $565c2a6f56aa7a90$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $565c2a6f56aa7a90$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $565c2a6f56aa7a90$var$createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, $565c2a6f56aa7a90$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $565c2a6f56aa7a90$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $565c2a6f56aa7a90$var$COLLECTION_NAME in $565c2a6f56aa7a90$var$DOMIterables)$565c2a6f56aa7a90$var$handlePrototype($565c2a6f56aa7a90$var$global$1[$565c2a6f56aa7a90$var$COLLECTION_NAME] && $565c2a6f56aa7a90$var$global$1[$565c2a6f56aa7a90$var$COLLECTION_NAME].prototype, $565c2a6f56aa7a90$var$COLLECTION_NAME);
$565c2a6f56aa7a90$var$handlePrototype($565c2a6f56aa7a90$var$DOMTokenListPrototype, "DOMTokenList");
// - https://gist.github.com/Wollac/49f0c4e318e42f463b8306298dfb4f4a
// - https://github.com/LedgerHQ/app-near/blob/master/workdir/app-near/src/constants.h
const $565c2a6f56aa7a90$var$CLA = 0x80; // Always the same for Ledger.
const $565c2a6f56aa7a90$var$INS_SIGN = 0x02; // Sign
const $565c2a6f56aa7a90$var$INS_GET_PUBLIC_KEY = 0x04; // Get Public Key
const $565c2a6f56aa7a90$var$INS_GET_APP_VERSION = 0x06; // Get App Version
const $565c2a6f56aa7a90$var$P1_LAST = 0x80; // End of Bytes to Sign (finalize)
const $565c2a6f56aa7a90$var$P1_MORE = 0x00; // More bytes coming
const $565c2a6f56aa7a90$var$P1_IGNORE = 0x00;
const $565c2a6f56aa7a90$var$P2_IGNORE = 0x00; // Converts BIP32-compliant derivation path to a Buffer.
// More info here: https://github.com/LedgerHQ/ledger-live-common/blob/master/docs/derivation.md
function $565c2a6f56aa7a90$var$parseDerivationPath(derivationPath) {
    const parts = derivationPath.split("/");
    return $565c2a6f56aa7a90$require$Buffer.concat(parts.map((part)=>{
        return part.endsWith(`'`) ? Math.abs(parseInt(part.slice(0, -1))) | 0x80000000 : Math.abs(parseInt(part));
    }).map((i32)=>{
        return $565c2a6f56aa7a90$require$Buffer.from([
            i32 >> 24 & 0xff,
            i32 >> 16 & 0xff,
            i32 >> 8 & 0xff,
            i32 & 0xff
        ]);
    }));
} // TODO: Understand what this is exactly. What's so special about 87?
const $565c2a6f56aa7a90$var$networkId = "W".charCodeAt(0); // Not using TransportWebHID.isSupported as it's chosen to use a Promise...
const $565c2a6f56aa7a90$var$isLedgerSupported = ()=>{
    var _a;
    return !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.hid);
};
class $565c2a6f56aa7a90$var$LedgerClient {
    constructor(){
        this.transport = null;
        this.isConnected = ()=>{
            return Boolean(this.transport);
        };
        this.connect = ()=>$565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
                this.transport = yield (0, $b95dc6f85d7a5443$export$2e2bcd8739ae039).create();
                const handleDisconnect = ()=>{
                    var _a;
                    (_a = this.transport) === null || _a === void 0 || _a.off("disconnect", handleDisconnect);
                    this.transport = null;
                };
                this.transport.on("disconnect", handleDisconnect);
            });
        this.disconnect = ()=>$565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.transport) throw new Error("Device not connected");
                yield this.transport.close();
                this.transport = null;
            });
        this.setScrambleKey = (key)=>{
            if (!this.transport) throw new Error("Device not connected");
            this.transport.setScrambleKey(key);
        };
        this.on = (event, callback)=>{
            if (!this.transport) throw new Error("Device not connected");
            this.transport.on(event, callback);
            return {
                remove: ()=>{
                    var _a;
                    return (_a = this.transport) === null || _a === void 0 ? void 0 : _a.off(event, callback);
                }
            };
        };
        this.off = (event, callback)=>{
            if (!this.transport) throw new Error("Device not connected");
            this.transport.off(event, callback);
        };
        this.getVersion = ()=>$565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.transport) throw new Error("Device not connected");
                const res = yield this.transport.send($565c2a6f56aa7a90$var$CLA, $565c2a6f56aa7a90$var$INS_GET_APP_VERSION, $565c2a6f56aa7a90$var$P1_IGNORE, $565c2a6f56aa7a90$var$P2_IGNORE);
                const [major, minor, patch] = Array.from(res);
                return `${major}.${minor}.${patch}`;
            });
        this.getPublicKey = ({ derivationPath: derivationPath })=>$565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.transport) throw new Error("Device not connected");
                const res = yield this.transport.send($565c2a6f56aa7a90$var$CLA, $565c2a6f56aa7a90$var$INS_GET_PUBLIC_KEY, $565c2a6f56aa7a90$var$P2_IGNORE, $565c2a6f56aa7a90$var$networkId, $565c2a6f56aa7a90$var$parseDerivationPath(derivationPath));
                return $e9c96496ce82840e$exports.utils.serialize.base_encode(res.subarray(0, -2));
            });
        this.sign = ({ data: data, derivationPath: derivationPath })=>$565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.transport) throw new Error("Device not connected");
                 // NOTE: getVersion call resets state to avoid starting from partially filled buffer
                yield this.getVersion(); // 128 - 5 service bytes
                const CHUNK_SIZE = 123;
                const allData = $565c2a6f56aa7a90$require$Buffer.concat([
                    $565c2a6f56aa7a90$var$parseDerivationPath(derivationPath),
                    $565c2a6f56aa7a90$require$Buffer.from(data)
                ]);
                for(let offset = 0; offset < allData.length; offset += CHUNK_SIZE){
                    const isLastChunk = offset + CHUNK_SIZE >= allData.length;
                    const response = yield this.transport.send($565c2a6f56aa7a90$var$CLA, $565c2a6f56aa7a90$var$INS_SIGN, isLastChunk ? $565c2a6f56aa7a90$var$P1_LAST : $565c2a6f56aa7a90$var$P1_MORE, $565c2a6f56aa7a90$var$P2_IGNORE, $565c2a6f56aa7a90$require$Buffer.from(allData.subarray(offset, offset + CHUNK_SIZE)));
                    if (isLastChunk) return $565c2a6f56aa7a90$require$Buffer.from(response.subarray(0, -2));
                }
                throw new Error("Invalid data or derivation path");
            });
    }
}
var $565c2a6f56aa7a90$var$icon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsCAQAAADTdEb+AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAAFQkAABUJATOjLtcAAAAHdElNRQfmCBYRFRR5QOqTAAAE6UlEQVR42u3dPYtcZRzG4fvkRQxRNBhlQcEQED+HjY2wKa0stLCxsLS2FfHlC8TaVkhjnzRWqYw2IkGIkJBgQMgmu2NhfZbMMPc8szvXNeVwZv7POb+ZOXAGTgIAAAAAAAAAAAAAAAAAAAAAwOk3zT7zbj7M2dHjrW2VD/NDHo0eI8mr+TiXshg9xpoc5sf8tuxG13KYxal53M2V0UchSXIld4fvi/U9DnNtbqFnZnfBIoejj8Iabc9atmeSdaxl9rv3zDKvA89LWFQIiwphUSEsKoRFhbCoEBYVwqJCWFQIi4pdCevc6AG2cJKtXOa9/JSno4d/bmdyP49HD5EkeZzruZyj0WM8t/PZz956X3I/B8f8YeJmLoxeMxtwITePqeAg+3Mbrv5TuCs/ortt5aMsDyqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCpWvSf0NHrwNU+8GD3e1lrxSM+HdTufzX6fTbmXg9ErXsqFfJF3Zm7yPeVJvs6vo0fcSgf5KnuzH7uj3B494Giv5Jdjbpr9JO+NHvC02ZVzrEUOj3n2mZ/CdduVsNgwYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBAWFcKiQlhUCIsKYVEhLCqERYWwqBDW/xajBzhtzo0eYCtMeT1vbGRfHOZBno1e7iYIK0lezLf5N1P9fab8nY/yx+jlboKwkmTKWxt6p5fywujFboZzrM062pWzOWFRISwqhEWFsKgQFhXCokJYVAiLCmFRsSthTTk7eoQkybkNXJHcCvPXCt/O+7PZTbmXG3k6evglHORGfs/R4CmmPMw/o3fFUs7ng+zNXoY6ys/5c9mX3M9BFrOPW7k4es1LmrbkcbJczK1jKjjI/tyGq/674eRdSj15E2+HFffbrpxjsWHCokJYVAiLCmFRISwqhEWFsKgQFhXCokJYVAiLCmFRISwqhEWFsKgQFhXCokJYVAiLCmFRISwqhEWFsKgQFhXCokJYVAiLCmFRISwqhEWFsKgQFhXCokJYVAiLCmFRISwqhEWFsKgQFhXCokJYVAiLCmFRISwqhEWFsKgQFhWrhzX6/spswspHedVb917NdyfoZuNncj/f58HoMZK8ls9z+QR9KM/n6mobrhrWXj4dveal/JXrWxHWy/kkb44eYhN25Rzr2egBtnCSql0Jiw0TFhXCokJYVAiLCmFRISwqhEWFsKgQFhXComI+rClnRw+3Rtuzlu2ZZB1rmeaemv93w518eWp2wpSHeTR6iCTJo3yTS1mMHmNNDnNn9AgAAAAAAAAAAAAAAAAAAAAAAIz0H5C/bp2MgRJCAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTA4LTIyVDE3OjIwOjM2KzAwOjAwLb5rZQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0wOC0yMlQxNzoyMDozNiswMDowMFzj09kAAAAASUVORK5CYII=`;
const $565c2a6f56aa7a90$var$STORAGE_ACCOUNTS = "accounts";
const $565c2a6f56aa7a90$var$setupLedgerState = (storage)=>$565c2a6f56aa7a90$var$__awaiter(void 0, void 0, void 0, function*() {
        const accounts = yield storage.getItem($565c2a6f56aa7a90$var$STORAGE_ACCOUNTS);
        return {
            client: new $565c2a6f56aa7a90$var$LedgerClient(),
            subscriptions: [],
            accounts: accounts || []
        };
    });
const $565c2a6f56aa7a90$var$Ledger = ({ options: options, store: store, provider: provider, logger: logger, storage: storage, metadata: metadata })=>$565c2a6f56aa7a90$var$__awaiter(void 0, void 0, void 0, function*() {
        const _state = yield $565c2a6f56aa7a90$var$setupLedgerState(storage);
        const signer = {
            createKey: ()=>{
                throw new Error("Not implemented");
            },
            getPublicKey: (accountId)=>$565c2a6f56aa7a90$var$__awaiter(void 0, void 0, void 0, function*() {
                    const account = _state.accounts.find((a)=>a.accountId === accountId);
                    if (!account) throw new Error("Failed to find public key for account");
                    return $e9c96496ce82840e$exports.utils.PublicKey.from(account.publicKey);
                }),
            signMessage: (message, accountId)=>$565c2a6f56aa7a90$var$__awaiter(void 0, void 0, void 0, function*() {
                    const account = _state.accounts.find((a)=>a.accountId === accountId);
                    if (!account) throw new Error("Failed to find account for signing");
                    const signature = yield _state.client.sign({
                        data: message,
                        derivationPath: account.derivationPath
                    });
                    return {
                        signature: signature,
                        publicKey: $e9c96496ce82840e$exports.utils.PublicKey.from(account.publicKey)
                    };
                })
        };
        const getAccounts = ()=>{
            return _state.accounts.map((x)=>({
                    accountId: x.accountId,
                    publicKey: "ed25519:" + x.publicKey
                }));
        };
        const cleanup = ()=>{
            _state.subscriptions.forEach((subscription)=>subscription.remove());
            _state.subscriptions = [];
            _state.accounts = [];
            storage.removeItem($565c2a6f56aa7a90$var$STORAGE_ACCOUNTS);
        };
        const signOut = ()=>$565c2a6f56aa7a90$var$__awaiter(void 0, void 0, void 0, function*() {
                if (_state.client.isConnected()) yield _state.client.disconnect().catch((err)=>{
                    logger.log("Failed to disconnect device");
                    logger.error(err);
                });
                cleanup();
            });
        const connectLedgerDevice = ()=>$565c2a6f56aa7a90$var$__awaiter(void 0, void 0, void 0, function*() {
                if (_state.client.isConnected()) return;
                yield _state.client.connect();
            });
        const validateAccessKey = ({ accountId: accountId, publicKey: publicKey })=>{
            logger.log("validateAccessKey", {
                accountId: accountId,
                publicKey: publicKey
            });
            return provider.viewAccessKey({
                accountId: accountId,
                publicKey: publicKey
            }).then((accessKey)=>{
                logger.log("validateAccessKey:accessKey", {
                    accessKey: accessKey
                });
                if (accessKey.permission !== "FullAccess") throw new Error("Public key requires 'FullAccess' permission");
                return accessKey;
            }, (err)=>{
                if (err.type === "AccessKeyDoesNotExist") return null;
                throw err;
            });
        };
        const transformTransactions = (transactions)=>{
            const { contract: contract } = store.getState();
            if (!contract) throw new Error("Wallet not signed in");
            const account = (0, $5bb7220e37bd460f$export$13dd2e33a23839ad)(store.getState());
            if (!account) throw new Error("No active account");
            return transactions.map((transaction)=>{
                return {
                    signerId: transaction.signerId || account.accountId,
                    receiverId: transaction.receiverId || contract.contractId,
                    actions: transaction.actions
                };
            });
        };
        return {
            signIn ({ accounts: accounts }) {
                return $565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
                    const existingAccounts = getAccounts();
                    if (existingAccounts.length) return existingAccounts;
                    const ledgerAccounts = [];
                    for(let i = 0; i < accounts.length; i++){
                        const { derivationPath: derivationPath, accountId: accountId, publicKey: publicKey } = accounts[i];
                        const accessKey = yield validateAccessKey({
                            accountId: accountId,
                            publicKey: publicKey
                        });
                        if (!accessKey) throw new Error(`Public key is not registered with the account '${accountId}'.`);
                        ledgerAccounts.push({
                            accountId: accountId,
                            derivationPath: derivationPath,
                            publicKey: publicKey
                        });
                    }
                    yield storage.setItem($565c2a6f56aa7a90$var$STORAGE_ACCOUNTS, ledgerAccounts);
                    _state.accounts = ledgerAccounts;
                    return getAccounts();
                });
            },
            signOut: signOut,
            getAccounts () {
                return $565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
                    return getAccounts();
                });
            },
            verifyOwner ({ message: message }) {
                return $565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("Ledger:verifyOwner", {
                        message: message
                    });
                    throw new Error(`Method not supported by ${metadata.name}`);
                });
            },
            signAndSendTransaction ({ signerId: signerId, receiverId: receiverId, actions: actions }) {
                return $565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("signAndSendTransaction", {
                        signerId: signerId,
                        receiverId: receiverId,
                        actions: actions
                    });
                    if (!_state.accounts.length) throw new Error("Wallet not signed in");
                     // Note: Connection must be triggered by user interaction.
                    yield connectLedgerDevice();
                    const signedTransactions = yield (0, $5aa677c457ee63c9$export$6a7fdf2f99a9cf08)(transformTransactions([
                        {
                            signerId: signerId,
                            receiverId: receiverId,
                            actions: actions
                        }
                    ]), signer, options.network);
                    return provider.sendTransaction(signedTransactions[0]);
                });
            },
            signAndSendTransactions ({ transactions: transactions }) {
                return $565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("signAndSendTransactions", {
                        transactions: transactions
                    });
                    if (!_state.accounts.length) throw new Error("Wallet not signed in");
                     // Note: Connection must be triggered by user interaction.
                    yield connectLedgerDevice();
                    const signedTransactions = yield (0, $5aa677c457ee63c9$export$6a7fdf2f99a9cf08)(transformTransactions(transactions), signer, options.network);
                    const results = [];
                    for(let i = 0; i < signedTransactions.length; i++)results.push((yield provider.sendTransaction(signedTransactions[i])));
                    return results;
                });
            },
            getPublicKey (derivationPath) {
                return $565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
                    yield connectLedgerDevice();
                    return yield _state.client.getPublicKey({
                        derivationPath: derivationPath
                    });
                });
            }
        };
    });
function $565c2a6f56aa7a90$export$96cd127ba6f0e09e({ iconUrl: iconUrl = $565c2a6f56aa7a90$var$icon, deprecated: deprecated = false } = {}) {
    return ()=>$565c2a6f56aa7a90$var$__awaiter(this, void 0, void 0, function*() {
            const mobile = (0, $b5a8117fb009006e$exports.isMobile)();
            const supported = $565c2a6f56aa7a90$var$isLedgerSupported();
            if (mobile) return null;
            return {
                id: "ledger",
                type: "hardware",
                metadata: {
                    name: "Ledger",
                    description: "Protect crypto assets with the most popular hardware wallet.",
                    iconUrl: iconUrl,
                    deprecated: deprecated,
                    available: supported
                },
                init: $565c2a6f56aa7a90$var$Ledger
            };
        });
}




var $f9a22d5a80b70b70$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $f9a22d5a80b70b70$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $f9a22d5a80b70b70$var$global$m = // eslint-disable-next-line es-x/no-global-this -- safe
$f9a22d5a80b70b70$var$check(typeof globalThis == "object" && globalThis) || $f9a22d5a80b70b70$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$f9a22d5a80b70b70$var$check(typeof self == "object" && self) || $f9a22d5a80b70b70$var$check(typeof $f9a22d5a80b70b70$var$commonjsGlobal == "object" && $f9a22d5a80b70b70$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $f9a22d5a80b70b70$var$objectGetOwnPropertyDescriptor = {};
var $f9a22d5a80b70b70$var$fails$j = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $f9a22d5a80b70b70$var$fails$i = $f9a22d5a80b70b70$var$fails$j;
// Detect IE8's incomplete defineProperty implementation
var $f9a22d5a80b70b70$var$descriptors = !$f9a22d5a80b70b70$var$fails$i(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $f9a22d5a80b70b70$var$fails$h = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$functionBindNative = !$f9a22d5a80b70b70$var$fails$h(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $f9a22d5a80b70b70$var$NATIVE_BIND$3 = $f9a22d5a80b70b70$var$functionBindNative;
var $f9a22d5a80b70b70$var$call$i = Function.prototype.call;
var $f9a22d5a80b70b70$var$functionCall = $f9a22d5a80b70b70$var$NATIVE_BIND$3 ? $f9a22d5a80b70b70$var$call$i.bind($f9a22d5a80b70b70$var$call$i) : function() {
    return $f9a22d5a80b70b70$var$call$i.apply($f9a22d5a80b70b70$var$call$i, arguments);
};
var $f9a22d5a80b70b70$var$objectPropertyIsEnumerable = {};
var $f9a22d5a80b70b70$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $f9a22d5a80b70b70$var$NASHORN_BUG = $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$2 && !$f9a22d5a80b70b70$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$f9a22d5a80b70b70$var$objectPropertyIsEnumerable.f = $f9a22d5a80b70b70$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $f9a22d5a80b70b70$var$$propertyIsEnumerable;
var $f9a22d5a80b70b70$var$createPropertyDescriptor$3 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $f9a22d5a80b70b70$var$NATIVE_BIND$2 = $f9a22d5a80b70b70$var$functionBindNative;
var $f9a22d5a80b70b70$var$FunctionPrototype$2 = Function.prototype;
var $f9a22d5a80b70b70$var$bind$5 = $f9a22d5a80b70b70$var$FunctionPrototype$2.bind;
var $f9a22d5a80b70b70$var$call$h = $f9a22d5a80b70b70$var$FunctionPrototype$2.call;
var $f9a22d5a80b70b70$var$uncurryThis$j = $f9a22d5a80b70b70$var$NATIVE_BIND$2 && $f9a22d5a80b70b70$var$bind$5.bind($f9a22d5a80b70b70$var$call$h, $f9a22d5a80b70b70$var$call$h);
var $f9a22d5a80b70b70$var$functionUncurryThis = $f9a22d5a80b70b70$var$NATIVE_BIND$2 ? function(fn) {
    return fn && $f9a22d5a80b70b70$var$uncurryThis$j(fn);
} : function(fn) {
    return fn && function() {
        return $f9a22d5a80b70b70$var$call$h.apply(fn, arguments);
    };
};
var $f9a22d5a80b70b70$var$uncurryThis$i = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$toString$5 = $f9a22d5a80b70b70$var$uncurryThis$i({}.toString);
var $f9a22d5a80b70b70$var$stringSlice$4 = $f9a22d5a80b70b70$var$uncurryThis$i("".slice);
var $f9a22d5a80b70b70$var$classofRaw$1 = function(it) {
    return $f9a22d5a80b70b70$var$stringSlice$4($f9a22d5a80b70b70$var$toString$5(it), 8, -1);
};
var $f9a22d5a80b70b70$var$uncurryThis$h = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$fails$g = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$classof$6 = $f9a22d5a80b70b70$var$classofRaw$1;
var $f9a22d5a80b70b70$var$$Object$4 = Object;
var $f9a22d5a80b70b70$var$split = $f9a22d5a80b70b70$var$uncurryThis$h("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $f9a22d5a80b70b70$var$indexedObject = $f9a22d5a80b70b70$var$fails$g(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$f9a22d5a80b70b70$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $f9a22d5a80b70b70$var$classof$6(it) == "String" ? $f9a22d5a80b70b70$var$split(it, "") : $f9a22d5a80b70b70$var$$Object$4(it);
} : $f9a22d5a80b70b70$var$$Object$4;
var $f9a22d5a80b70b70$var$$TypeError$c = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $f9a22d5a80b70b70$var$requireObjectCoercible$4 = function(it) {
    if (it == undefined) throw $f9a22d5a80b70b70$var$$TypeError$c("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $f9a22d5a80b70b70$var$IndexedObject$1 = $f9a22d5a80b70b70$var$indexedObject;
var $f9a22d5a80b70b70$var$requireObjectCoercible$3 = $f9a22d5a80b70b70$var$requireObjectCoercible$4;
var $f9a22d5a80b70b70$var$toIndexedObject$5 = function(it) {
    return $f9a22d5a80b70b70$var$IndexedObject$1($f9a22d5a80b70b70$var$requireObjectCoercible$3(it));
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $f9a22d5a80b70b70$var$isCallable$m = function(argument) {
    return typeof argument == "function";
};
var $f9a22d5a80b70b70$var$isCallable$l = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$isObject$7 = function(it) {
    return typeof it == "object" ? it !== null : $f9a22d5a80b70b70$var$isCallable$l(it);
};
var $f9a22d5a80b70b70$var$global$l = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$isCallable$k = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$aFunction = function(argument) {
    return $f9a22d5a80b70b70$var$isCallable$k(argument) ? argument : undefined;
};
var $f9a22d5a80b70b70$var$getBuiltIn$8 = function(namespace, method) {
    return arguments.length < 2 ? $f9a22d5a80b70b70$var$aFunction($f9a22d5a80b70b70$var$global$l[namespace]) : $f9a22d5a80b70b70$var$global$l[namespace] && $f9a22d5a80b70b70$var$global$l[namespace][method];
};
var $f9a22d5a80b70b70$var$uncurryThis$g = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$objectIsPrototypeOf = $f9a22d5a80b70b70$var$uncurryThis$g({}.isPrototypeOf);
var $f9a22d5a80b70b70$var$getBuiltIn$7 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$engineUserAgent = $f9a22d5a80b70b70$var$getBuiltIn$7("navigator", "userAgent") || "";
var $f9a22d5a80b70b70$var$global$k = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$userAgent$3 = $f9a22d5a80b70b70$var$engineUserAgent;
var $f9a22d5a80b70b70$var$process$3 = $f9a22d5a80b70b70$var$global$k.process;
var $f9a22d5a80b70b70$var$Deno$1 = $f9a22d5a80b70b70$var$global$k.Deno;
var $f9a22d5a80b70b70$var$versions = $f9a22d5a80b70b70$var$process$3 && $f9a22d5a80b70b70$var$process$3.versions || $f9a22d5a80b70b70$var$Deno$1 && $f9a22d5a80b70b70$var$Deno$1.version;
var $f9a22d5a80b70b70$var$v8 = $f9a22d5a80b70b70$var$versions && $f9a22d5a80b70b70$var$versions.v8;
var $f9a22d5a80b70b70$var$match, $f9a22d5a80b70b70$var$version;
if ($f9a22d5a80b70b70$var$v8) {
    $f9a22d5a80b70b70$var$match = $f9a22d5a80b70b70$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $f9a22d5a80b70b70$var$version = $f9a22d5a80b70b70$var$match[0] > 0 && $f9a22d5a80b70b70$var$match[0] < 4 ? 1 : +($f9a22d5a80b70b70$var$match[0] + $f9a22d5a80b70b70$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$f9a22d5a80b70b70$var$version && $f9a22d5a80b70b70$var$userAgent$3) {
    $f9a22d5a80b70b70$var$match = $f9a22d5a80b70b70$var$userAgent$3.match(/Edge\/(\d+)/);
    if (!$f9a22d5a80b70b70$var$match || $f9a22d5a80b70b70$var$match[1] >= 74) {
        $f9a22d5a80b70b70$var$match = $f9a22d5a80b70b70$var$userAgent$3.match(/Chrome\/(\d+)/);
        if ($f9a22d5a80b70b70$var$match) $f9a22d5a80b70b70$var$version = +$f9a22d5a80b70b70$var$match[1];
    }
}
var $f9a22d5a80b70b70$var$engineV8Version = $f9a22d5a80b70b70$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $f9a22d5a80b70b70$var$V8_VERSION$1 = $f9a22d5a80b70b70$var$engineV8Version;
var $f9a22d5a80b70b70$var$fails$f = $f9a22d5a80b70b70$var$fails$j;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $f9a22d5a80b70b70$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$f9a22d5a80b70b70$var$fails$f(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $f9a22d5a80b70b70$var$V8_VERSION$1 && $f9a22d5a80b70b70$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $f9a22d5a80b70b70$var$NATIVE_SYMBOL$1 = $f9a22d5a80b70b70$var$nativeSymbol;
var $f9a22d5a80b70b70$var$useSymbolAsUid = $f9a22d5a80b70b70$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $f9a22d5a80b70b70$var$getBuiltIn$6 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$isCallable$j = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$isPrototypeOf$3 = $f9a22d5a80b70b70$var$objectIsPrototypeOf;
var $f9a22d5a80b70b70$var$USE_SYMBOL_AS_UID$1 = $f9a22d5a80b70b70$var$useSymbolAsUid;
var $f9a22d5a80b70b70$var$$Object$3 = Object;
var $f9a22d5a80b70b70$var$isSymbol$2 = $f9a22d5a80b70b70$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $f9a22d5a80b70b70$var$getBuiltIn$6("Symbol");
    return $f9a22d5a80b70b70$var$isCallable$j($Symbol) && $f9a22d5a80b70b70$var$isPrototypeOf$3($Symbol.prototype, $f9a22d5a80b70b70$var$$Object$3(it));
};
var $f9a22d5a80b70b70$var$$String$3 = String;
var $f9a22d5a80b70b70$var$tryToString$4 = function(argument) {
    try {
        return $f9a22d5a80b70b70$var$$String$3(argument);
    } catch (error) {
        return "Object";
    }
};
var $f9a22d5a80b70b70$var$isCallable$i = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$tryToString$3 = $f9a22d5a80b70b70$var$tryToString$4;
var $f9a22d5a80b70b70$var$$TypeError$b = TypeError;
// `Assert: IsCallable(argument) is true`
var $f9a22d5a80b70b70$var$aCallable$7 = function(argument) {
    if ($f9a22d5a80b70b70$var$isCallable$i(argument)) return argument;
    throw $f9a22d5a80b70b70$var$$TypeError$b($f9a22d5a80b70b70$var$tryToString$3(argument) + " is not a function");
};
var $f9a22d5a80b70b70$var$aCallable$6 = $f9a22d5a80b70b70$var$aCallable$7;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $f9a22d5a80b70b70$var$getMethod$4 = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $f9a22d5a80b70b70$var$aCallable$6(func);
};
var $f9a22d5a80b70b70$var$call$g = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$isCallable$h = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$isObject$6 = $f9a22d5a80b70b70$var$isObject$7;
var $f9a22d5a80b70b70$var$$TypeError$a = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $f9a22d5a80b70b70$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $f9a22d5a80b70b70$var$isCallable$h(fn = input.toString) && !$f9a22d5a80b70b70$var$isObject$6(val = $f9a22d5a80b70b70$var$call$g(fn, input))) return val;
    if ($f9a22d5a80b70b70$var$isCallable$h(fn = input.valueOf) && !$f9a22d5a80b70b70$var$isObject$6(val = $f9a22d5a80b70b70$var$call$g(fn, input))) return val;
    if (pref !== "string" && $f9a22d5a80b70b70$var$isCallable$h(fn = input.toString) && !$f9a22d5a80b70b70$var$isObject$6(val = $f9a22d5a80b70b70$var$call$g(fn, input))) return val;
    throw $f9a22d5a80b70b70$var$$TypeError$a("Can't convert object to primitive value");
};
var $f9a22d5a80b70b70$var$shared$4 = {
    exports: {}
};
var $f9a22d5a80b70b70$var$global$j = $f9a22d5a80b70b70$var$global$m;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $f9a22d5a80b70b70$var$defineProperty$5 = Object.defineProperty;
var $f9a22d5a80b70b70$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $f9a22d5a80b70b70$var$defineProperty$5($f9a22d5a80b70b70$var$global$j, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $f9a22d5a80b70b70$var$global$j[key] = value;
    }
    return value;
};
var $f9a22d5a80b70b70$var$global$i = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$defineGlobalProperty$2 = $f9a22d5a80b70b70$var$defineGlobalProperty$3;
var $f9a22d5a80b70b70$var$SHARED = "__core-js_shared__";
var $f9a22d5a80b70b70$var$store$3 = $f9a22d5a80b70b70$var$global$i[$f9a22d5a80b70b70$var$SHARED] || $f9a22d5a80b70b70$var$defineGlobalProperty$2($f9a22d5a80b70b70$var$SHARED, {});
var $f9a22d5a80b70b70$var$sharedStore = $f9a22d5a80b70b70$var$store$3;
var $f9a22d5a80b70b70$var$store$2 = $f9a22d5a80b70b70$var$sharedStore;
($f9a22d5a80b70b70$var$shared$4.exports = function(key, value) {
    return $f9a22d5a80b70b70$var$store$2[key] || ($f9a22d5a80b70b70$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $f9a22d5a80b70b70$var$requireObjectCoercible$2 = $f9a22d5a80b70b70$var$requireObjectCoercible$4;
var $f9a22d5a80b70b70$var$$Object$2 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $f9a22d5a80b70b70$var$toObject$4 = function(argument) {
    return $f9a22d5a80b70b70$var$$Object$2($f9a22d5a80b70b70$var$requireObjectCoercible$2(argument));
};
var $f9a22d5a80b70b70$var$uncurryThis$f = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$toObject$3 = $f9a22d5a80b70b70$var$toObject$4;
var $f9a22d5a80b70b70$var$hasOwnProperty = $f9a22d5a80b70b70$var$uncurryThis$f({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $f9a22d5a80b70b70$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $f9a22d5a80b70b70$var$hasOwnProperty($f9a22d5a80b70b70$var$toObject$3(it), key);
};
var $f9a22d5a80b70b70$var$uncurryThis$e = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$id = 0;
var $f9a22d5a80b70b70$var$postfix = Math.random();
var $f9a22d5a80b70b70$var$toString$4 = $f9a22d5a80b70b70$var$uncurryThis$e(1.0.toString);
var $f9a22d5a80b70b70$var$uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $f9a22d5a80b70b70$var$toString$4(++$f9a22d5a80b70b70$var$id + $f9a22d5a80b70b70$var$postfix, 36);
};
var $f9a22d5a80b70b70$var$global$h = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$shared$3 = $f9a22d5a80b70b70$var$shared$4.exports;
var $f9a22d5a80b70b70$var$hasOwn$a = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$uid$1 = $f9a22d5a80b70b70$var$uid$2;
var $f9a22d5a80b70b70$var$NATIVE_SYMBOL = $f9a22d5a80b70b70$var$nativeSymbol;
var $f9a22d5a80b70b70$var$USE_SYMBOL_AS_UID = $f9a22d5a80b70b70$var$useSymbolAsUid;
var $f9a22d5a80b70b70$var$WellKnownSymbolsStore = $f9a22d5a80b70b70$var$shared$3("wks");
var $f9a22d5a80b70b70$var$Symbol$1 = $f9a22d5a80b70b70$var$global$h.Symbol;
var $f9a22d5a80b70b70$var$symbolFor = $f9a22d5a80b70b70$var$Symbol$1 && $f9a22d5a80b70b70$var$Symbol$1["for"];
var $f9a22d5a80b70b70$var$createWellKnownSymbol = $f9a22d5a80b70b70$var$USE_SYMBOL_AS_UID ? $f9a22d5a80b70b70$var$Symbol$1 : $f9a22d5a80b70b70$var$Symbol$1 && $f9a22d5a80b70b70$var$Symbol$1.withoutSetter || $f9a22d5a80b70b70$var$uid$1;
var $f9a22d5a80b70b70$var$wellKnownSymbol$g = function(name) {
    if (!$f9a22d5a80b70b70$var$hasOwn$a($f9a22d5a80b70b70$var$WellKnownSymbolsStore, name) || !($f9a22d5a80b70b70$var$NATIVE_SYMBOL || typeof $f9a22d5a80b70b70$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($f9a22d5a80b70b70$var$NATIVE_SYMBOL && $f9a22d5a80b70b70$var$hasOwn$a($f9a22d5a80b70b70$var$Symbol$1, name)) $f9a22d5a80b70b70$var$WellKnownSymbolsStore[name] = $f9a22d5a80b70b70$var$Symbol$1[name];
        else if ($f9a22d5a80b70b70$var$USE_SYMBOL_AS_UID && $f9a22d5a80b70b70$var$symbolFor) $f9a22d5a80b70b70$var$WellKnownSymbolsStore[name] = $f9a22d5a80b70b70$var$symbolFor(description);
        else $f9a22d5a80b70b70$var$WellKnownSymbolsStore[name] = $f9a22d5a80b70b70$var$createWellKnownSymbol(description);
    }
    return $f9a22d5a80b70b70$var$WellKnownSymbolsStore[name];
};
var $f9a22d5a80b70b70$var$call$f = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$isObject$5 = $f9a22d5a80b70b70$var$isObject$7;
var $f9a22d5a80b70b70$var$isSymbol$1 = $f9a22d5a80b70b70$var$isSymbol$2;
var $f9a22d5a80b70b70$var$getMethod$3 = $f9a22d5a80b70b70$var$getMethod$4;
var $f9a22d5a80b70b70$var$ordinaryToPrimitive = $f9a22d5a80b70b70$var$ordinaryToPrimitive$1;
var $f9a22d5a80b70b70$var$wellKnownSymbol$f = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$$TypeError$9 = TypeError;
var $f9a22d5a80b70b70$var$TO_PRIMITIVE = $f9a22d5a80b70b70$var$wellKnownSymbol$f("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $f9a22d5a80b70b70$var$toPrimitive$1 = function(input, pref) {
    if (!$f9a22d5a80b70b70$var$isObject$5(input) || $f9a22d5a80b70b70$var$isSymbol$1(input)) return input;
    var exoticToPrim = $f9a22d5a80b70b70$var$getMethod$3(input, $f9a22d5a80b70b70$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $f9a22d5a80b70b70$var$call$f(exoticToPrim, input, pref);
        if (!$f9a22d5a80b70b70$var$isObject$5(result) || $f9a22d5a80b70b70$var$isSymbol$1(result)) return result;
        throw $f9a22d5a80b70b70$var$$TypeError$9("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $f9a22d5a80b70b70$var$ordinaryToPrimitive(input, pref);
};
var $f9a22d5a80b70b70$var$toPrimitive = $f9a22d5a80b70b70$var$toPrimitive$1;
var $f9a22d5a80b70b70$var$isSymbol = $f9a22d5a80b70b70$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $f9a22d5a80b70b70$var$toPropertyKey$2 = function(argument) {
    var key = $f9a22d5a80b70b70$var$toPrimitive(argument, "string");
    return $f9a22d5a80b70b70$var$isSymbol(key) ? key : key + "";
};
var $f9a22d5a80b70b70$var$global$g = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$isObject$4 = $f9a22d5a80b70b70$var$isObject$7;
var $f9a22d5a80b70b70$var$document$3 = $f9a22d5a80b70b70$var$global$g.document;
// typeof document.createElement is 'object' in old IE
var $f9a22d5a80b70b70$var$EXISTS$1 = $f9a22d5a80b70b70$var$isObject$4($f9a22d5a80b70b70$var$document$3) && $f9a22d5a80b70b70$var$isObject$4($f9a22d5a80b70b70$var$document$3.createElement);
var $f9a22d5a80b70b70$var$documentCreateElement$2 = function(it) {
    return $f9a22d5a80b70b70$var$EXISTS$1 ? $f9a22d5a80b70b70$var$document$3.createElement(it) : {};
};
var $f9a22d5a80b70b70$var$DESCRIPTORS$a = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$fails$e = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$createElement$1 = $f9a22d5a80b70b70$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $f9a22d5a80b70b70$var$ie8DomDefine = !$f9a22d5a80b70b70$var$DESCRIPTORS$a && !$f9a22d5a80b70b70$var$fails$e(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($f9a22d5a80b70b70$var$createElement$1("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $f9a22d5a80b70b70$var$DESCRIPTORS$9 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$call$e = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$propertyIsEnumerableModule$1 = $f9a22d5a80b70b70$var$objectPropertyIsEnumerable;
var $f9a22d5a80b70b70$var$createPropertyDescriptor$2 = $f9a22d5a80b70b70$var$createPropertyDescriptor$3;
var $f9a22d5a80b70b70$var$toIndexedObject$4 = $f9a22d5a80b70b70$var$toIndexedObject$5;
var $f9a22d5a80b70b70$var$toPropertyKey$1 = $f9a22d5a80b70b70$var$toPropertyKey$2;
var $f9a22d5a80b70b70$var$hasOwn$9 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$IE8_DOM_DEFINE$1 = $f9a22d5a80b70b70$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f9a22d5a80b70b70$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$f9a22d5a80b70b70$var$objectGetOwnPropertyDescriptor.f = $f9a22d5a80b70b70$var$DESCRIPTORS$9 ? $f9a22d5a80b70b70$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $f9a22d5a80b70b70$var$toIndexedObject$4(O);
    P = $f9a22d5a80b70b70$var$toPropertyKey$1(P);
    if ($f9a22d5a80b70b70$var$IE8_DOM_DEFINE$1) try {
        return $f9a22d5a80b70b70$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($f9a22d5a80b70b70$var$hasOwn$9(O, P)) return $f9a22d5a80b70b70$var$createPropertyDescriptor$2(!$f9a22d5a80b70b70$var$call$e($f9a22d5a80b70b70$var$propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var $f9a22d5a80b70b70$var$objectDefineProperty = {};
var $f9a22d5a80b70b70$var$DESCRIPTORS$8 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$fails$d = $f9a22d5a80b70b70$var$fails$j;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $f9a22d5a80b70b70$var$v8PrototypeDefineBug = $f9a22d5a80b70b70$var$DESCRIPTORS$8 && $f9a22d5a80b70b70$var$fails$d(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $f9a22d5a80b70b70$var$isObject$3 = $f9a22d5a80b70b70$var$isObject$7;
var $f9a22d5a80b70b70$var$$String$2 = String;
var $f9a22d5a80b70b70$var$$TypeError$8 = TypeError;
// `Assert: Type(argument) is Object`
var $f9a22d5a80b70b70$var$anObject$e = function(argument) {
    if ($f9a22d5a80b70b70$var$isObject$3(argument)) return argument;
    throw $f9a22d5a80b70b70$var$$TypeError$8($f9a22d5a80b70b70$var$$String$2(argument) + " is not an object");
};
var $f9a22d5a80b70b70$var$DESCRIPTORS$7 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$IE8_DOM_DEFINE = $f9a22d5a80b70b70$var$ie8DomDefine;
var $f9a22d5a80b70b70$var$V8_PROTOTYPE_DEFINE_BUG$1 = $f9a22d5a80b70b70$var$v8PrototypeDefineBug;
var $f9a22d5a80b70b70$var$anObject$d = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$toPropertyKey = $f9a22d5a80b70b70$var$toPropertyKey$2;
var $f9a22d5a80b70b70$var$$TypeError$7 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $f9a22d5a80b70b70$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f9a22d5a80b70b70$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f9a22d5a80b70b70$var$ENUMERABLE = "enumerable";
var $f9a22d5a80b70b70$var$CONFIGURABLE$1 = "configurable";
var $f9a22d5a80b70b70$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$f9a22d5a80b70b70$var$objectDefineProperty.f = $f9a22d5a80b70b70$var$DESCRIPTORS$7 ? $f9a22d5a80b70b70$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $f9a22d5a80b70b70$var$anObject$d(O);
    P = $f9a22d5a80b70b70$var$toPropertyKey(P);
    $f9a22d5a80b70b70$var$anObject$d(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $f9a22d5a80b70b70$var$WRITABLE in Attributes && !Attributes[$f9a22d5a80b70b70$var$WRITABLE]) {
        var current = $f9a22d5a80b70b70$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$f9a22d5a80b70b70$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $f9a22d5a80b70b70$var$CONFIGURABLE$1 in Attributes ? Attributes[$f9a22d5a80b70b70$var$CONFIGURABLE$1] : current[$f9a22d5a80b70b70$var$CONFIGURABLE$1],
                enumerable: $f9a22d5a80b70b70$var$ENUMERABLE in Attributes ? Attributes[$f9a22d5a80b70b70$var$ENUMERABLE] : current[$f9a22d5a80b70b70$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $f9a22d5a80b70b70$var$$defineProperty(O, P, Attributes);
} : $f9a22d5a80b70b70$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $f9a22d5a80b70b70$var$anObject$d(O);
    P = $f9a22d5a80b70b70$var$toPropertyKey(P);
    $f9a22d5a80b70b70$var$anObject$d(Attributes);
    if ($f9a22d5a80b70b70$var$IE8_DOM_DEFINE) try {
        return $f9a22d5a80b70b70$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $f9a22d5a80b70b70$var$$TypeError$7("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $f9a22d5a80b70b70$var$DESCRIPTORS$6 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$definePropertyModule$4 = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$createPropertyDescriptor$1 = $f9a22d5a80b70b70$var$createPropertyDescriptor$3;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty$5 = $f9a22d5a80b70b70$var$DESCRIPTORS$6 ? function(object, key, value) {
    return $f9a22d5a80b70b70$var$definePropertyModule$4.f(object, key, $f9a22d5a80b70b70$var$createPropertyDescriptor$1(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $f9a22d5a80b70b70$var$makeBuiltIn$2 = {
    exports: {}
};
var $f9a22d5a80b70b70$var$DESCRIPTORS$5 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$hasOwn$8 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f9a22d5a80b70b70$var$getDescriptor = $f9a22d5a80b70b70$var$DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;
var $f9a22d5a80b70b70$var$EXISTS = $f9a22d5a80b70b70$var$hasOwn$8($f9a22d5a80b70b70$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $f9a22d5a80b70b70$var$PROPER = $f9a22d5a80b70b70$var$EXISTS && (function something() {}).name === "something";
var $f9a22d5a80b70b70$var$CONFIGURABLE = $f9a22d5a80b70b70$var$EXISTS && (!$f9a22d5a80b70b70$var$DESCRIPTORS$5 || $f9a22d5a80b70b70$var$DESCRIPTORS$5 && $f9a22d5a80b70b70$var$getDescriptor($f9a22d5a80b70b70$var$FunctionPrototype$1, "name").configurable);
var $f9a22d5a80b70b70$var$functionName = {
    EXISTS: $f9a22d5a80b70b70$var$EXISTS,
    PROPER: $f9a22d5a80b70b70$var$PROPER,
    CONFIGURABLE: $f9a22d5a80b70b70$var$CONFIGURABLE
};
var $f9a22d5a80b70b70$var$uncurryThis$d = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$isCallable$g = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$store$1 = $f9a22d5a80b70b70$var$sharedStore;
var $f9a22d5a80b70b70$var$functionToString = $f9a22d5a80b70b70$var$uncurryThis$d(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$f9a22d5a80b70b70$var$isCallable$g($f9a22d5a80b70b70$var$store$1.inspectSource)) $f9a22d5a80b70b70$var$store$1.inspectSource = function(it) {
    return $f9a22d5a80b70b70$var$functionToString(it);
};
var $f9a22d5a80b70b70$var$inspectSource$4 = $f9a22d5a80b70b70$var$store$1.inspectSource;
var $f9a22d5a80b70b70$var$global$f = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$isCallable$f = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$inspectSource$3 = $f9a22d5a80b70b70$var$inspectSource$4;
var $f9a22d5a80b70b70$var$WeakMap$1 = $f9a22d5a80b70b70$var$global$f.WeakMap;
var $f9a22d5a80b70b70$var$nativeWeakMap = $f9a22d5a80b70b70$var$isCallable$f($f9a22d5a80b70b70$var$WeakMap$1) && /native code/.test($f9a22d5a80b70b70$var$inspectSource$3($f9a22d5a80b70b70$var$WeakMap$1));
var $f9a22d5a80b70b70$var$shared$2 = $f9a22d5a80b70b70$var$shared$4.exports;
var $f9a22d5a80b70b70$var$uid = $f9a22d5a80b70b70$var$uid$2;
var $f9a22d5a80b70b70$var$keys = $f9a22d5a80b70b70$var$shared$2("keys");
var $f9a22d5a80b70b70$var$sharedKey$3 = function(key) {
    return $f9a22d5a80b70b70$var$keys[key] || ($f9a22d5a80b70b70$var$keys[key] = $f9a22d5a80b70b70$var$uid(key));
};
var $f9a22d5a80b70b70$var$hiddenKeys$4 = {};
var $f9a22d5a80b70b70$var$NATIVE_WEAK_MAP = $f9a22d5a80b70b70$var$nativeWeakMap;
var $f9a22d5a80b70b70$var$global$e = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$uncurryThis$c = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$isObject$2 = $f9a22d5a80b70b70$var$isObject$7;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty$4 = $f9a22d5a80b70b70$var$createNonEnumerableProperty$5;
var $f9a22d5a80b70b70$var$hasOwn$7 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$shared$1 = $f9a22d5a80b70b70$var$sharedStore;
var $f9a22d5a80b70b70$var$sharedKey$2 = $f9a22d5a80b70b70$var$sharedKey$3;
var $f9a22d5a80b70b70$var$hiddenKeys$3 = $f9a22d5a80b70b70$var$hiddenKeys$4;
var $f9a22d5a80b70b70$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $f9a22d5a80b70b70$var$TypeError$2 = $f9a22d5a80b70b70$var$global$e.TypeError;
var $f9a22d5a80b70b70$var$WeakMap = $f9a22d5a80b70b70$var$global$e.WeakMap;
var $f9a22d5a80b70b70$var$set$1, $f9a22d5a80b70b70$var$get, $f9a22d5a80b70b70$var$has;
var $f9a22d5a80b70b70$var$enforce = function(it) {
    return $f9a22d5a80b70b70$var$has(it) ? $f9a22d5a80b70b70$var$get(it) : $f9a22d5a80b70b70$var$set$1(it, {});
};
var $f9a22d5a80b70b70$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$f9a22d5a80b70b70$var$isObject$2(it) || (state = $f9a22d5a80b70b70$var$get(it)).type !== TYPE) throw $f9a22d5a80b70b70$var$TypeError$2("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($f9a22d5a80b70b70$var$NATIVE_WEAK_MAP || $f9a22d5a80b70b70$var$shared$1.state) {
    var $f9a22d5a80b70b70$var$store = $f9a22d5a80b70b70$var$shared$1.state || ($f9a22d5a80b70b70$var$shared$1.state = new $f9a22d5a80b70b70$var$WeakMap());
    var $f9a22d5a80b70b70$var$wmget = $f9a22d5a80b70b70$var$uncurryThis$c($f9a22d5a80b70b70$var$store.get);
    var $f9a22d5a80b70b70$var$wmhas = $f9a22d5a80b70b70$var$uncurryThis$c($f9a22d5a80b70b70$var$store.has);
    var $f9a22d5a80b70b70$var$wmset = $f9a22d5a80b70b70$var$uncurryThis$c($f9a22d5a80b70b70$var$store.set);
    $f9a22d5a80b70b70$var$set$1 = function(it, metadata) {
        if ($f9a22d5a80b70b70$var$wmhas($f9a22d5a80b70b70$var$store, it)) throw new $f9a22d5a80b70b70$var$TypeError$2($f9a22d5a80b70b70$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $f9a22d5a80b70b70$var$wmset($f9a22d5a80b70b70$var$store, it, metadata);
        return metadata;
    };
    $f9a22d5a80b70b70$var$get = function(it) {
        return $f9a22d5a80b70b70$var$wmget($f9a22d5a80b70b70$var$store, it) || {};
    };
    $f9a22d5a80b70b70$var$has = function(it) {
        return $f9a22d5a80b70b70$var$wmhas($f9a22d5a80b70b70$var$store, it);
    };
} else {
    var $f9a22d5a80b70b70$var$STATE = $f9a22d5a80b70b70$var$sharedKey$2("state");
    $f9a22d5a80b70b70$var$hiddenKeys$3[$f9a22d5a80b70b70$var$STATE] = true;
    $f9a22d5a80b70b70$var$set$1 = function(it, metadata) {
        if ($f9a22d5a80b70b70$var$hasOwn$7(it, $f9a22d5a80b70b70$var$STATE)) throw new $f9a22d5a80b70b70$var$TypeError$2($f9a22d5a80b70b70$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $f9a22d5a80b70b70$var$createNonEnumerableProperty$4(it, $f9a22d5a80b70b70$var$STATE, metadata);
        return metadata;
    };
    $f9a22d5a80b70b70$var$get = function(it) {
        return $f9a22d5a80b70b70$var$hasOwn$7(it, $f9a22d5a80b70b70$var$STATE) ? it[$f9a22d5a80b70b70$var$STATE] : {};
    };
    $f9a22d5a80b70b70$var$has = function(it) {
        return $f9a22d5a80b70b70$var$hasOwn$7(it, $f9a22d5a80b70b70$var$STATE);
    };
}
var $f9a22d5a80b70b70$var$internalState = {
    set: $f9a22d5a80b70b70$var$set$1,
    get: $f9a22d5a80b70b70$var$get,
    has: $f9a22d5a80b70b70$var$has,
    enforce: $f9a22d5a80b70b70$var$enforce,
    getterFor: $f9a22d5a80b70b70$var$getterFor
};
var $f9a22d5a80b70b70$var$fails$c = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$isCallable$e = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$hasOwn$6 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$DESCRIPTORS$4 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$CONFIGURABLE_FUNCTION_NAME$1 = $f9a22d5a80b70b70$var$functionName.CONFIGURABLE;
var $f9a22d5a80b70b70$var$inspectSource$2 = $f9a22d5a80b70b70$var$inspectSource$4;
var $f9a22d5a80b70b70$var$InternalStateModule$2 = $f9a22d5a80b70b70$var$internalState;
var $f9a22d5a80b70b70$var$enforceInternalState = $f9a22d5a80b70b70$var$InternalStateModule$2.enforce;
var $f9a22d5a80b70b70$var$getInternalState$2 = $f9a22d5a80b70b70$var$InternalStateModule$2.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $f9a22d5a80b70b70$var$defineProperty$4 = Object.defineProperty;
var $f9a22d5a80b70b70$var$CONFIGURABLE_LENGTH = $f9a22d5a80b70b70$var$DESCRIPTORS$4 && !$f9a22d5a80b70b70$var$fails$c(function() {
    return $f9a22d5a80b70b70$var$defineProperty$4(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $f9a22d5a80b70b70$var$TEMPLATE = String(String).split("String");
var $f9a22d5a80b70b70$var$makeBuiltIn$1 = $f9a22d5a80b70b70$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$f9a22d5a80b70b70$var$hasOwn$6(value, "name") || $f9a22d5a80b70b70$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($f9a22d5a80b70b70$var$DESCRIPTORS$4) $f9a22d5a80b70b70$var$defineProperty$4(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($f9a22d5a80b70b70$var$CONFIGURABLE_LENGTH && options && $f9a22d5a80b70b70$var$hasOwn$6(options, "arity") && value.length !== options.arity) $f9a22d5a80b70b70$var$defineProperty$4(value, "length", {
        value: options.arity
    });
    try {
        if (options && $f9a22d5a80b70b70$var$hasOwn$6(options, "constructor") && options.constructor) {
            if ($f9a22d5a80b70b70$var$DESCRIPTORS$4) $f9a22d5a80b70b70$var$defineProperty$4(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $f9a22d5a80b70b70$var$enforceInternalState(value);
    if (!$f9a22d5a80b70b70$var$hasOwn$6(state, "source")) state.source = $f9a22d5a80b70b70$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $f9a22d5a80b70b70$var$makeBuiltIn$1(function toString() {
    return $f9a22d5a80b70b70$var$isCallable$e(this) && $f9a22d5a80b70b70$var$getInternalState$2(this).source || $f9a22d5a80b70b70$var$inspectSource$2(this);
}, "toString");
var $f9a22d5a80b70b70$var$isCallable$d = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$definePropertyModule$3 = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$makeBuiltIn = $f9a22d5a80b70b70$var$makeBuiltIn$2.exports;
var $f9a22d5a80b70b70$var$defineGlobalProperty$1 = $f9a22d5a80b70b70$var$defineGlobalProperty$3;
var $f9a22d5a80b70b70$var$defineBuiltIn$7 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($f9a22d5a80b70b70$var$isCallable$d(value)) $f9a22d5a80b70b70$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $f9a22d5a80b70b70$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $f9a22d5a80b70b70$var$definePropertyModule$3.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $f9a22d5a80b70b70$var$objectGetOwnPropertyNames = {};
var $f9a22d5a80b70b70$var$ceil = Math.ceil;
var $f9a22d5a80b70b70$var$floor$1 = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $f9a22d5a80b70b70$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $f9a22d5a80b70b70$var$floor$1 : $f9a22d5a80b70b70$var$ceil)(n);
};
var $f9a22d5a80b70b70$var$trunc = $f9a22d5a80b70b70$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $f9a22d5a80b70b70$var$toIntegerOrInfinity$4 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $f9a22d5a80b70b70$var$trunc(number);
};
var $f9a22d5a80b70b70$var$toIntegerOrInfinity$3 = $f9a22d5a80b70b70$var$toIntegerOrInfinity$4;
var $f9a22d5a80b70b70$var$max$1 = Math.max;
var $f9a22d5a80b70b70$var$min$2 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $f9a22d5a80b70b70$var$toAbsoluteIndex$1 = function(index, length) {
    var integer = $f9a22d5a80b70b70$var$toIntegerOrInfinity$3(index);
    return integer < 0 ? $f9a22d5a80b70b70$var$max$1(integer + length, 0) : $f9a22d5a80b70b70$var$min$2(integer, length);
};
var $f9a22d5a80b70b70$var$toIntegerOrInfinity$2 = $f9a22d5a80b70b70$var$toIntegerOrInfinity$4;
var $f9a22d5a80b70b70$var$min$1 = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $f9a22d5a80b70b70$var$toLength$2 = function(argument) {
    return argument > 0 ? $f9a22d5a80b70b70$var$min$1($f9a22d5a80b70b70$var$toIntegerOrInfinity$2(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $f9a22d5a80b70b70$var$toLength$1 = $f9a22d5a80b70b70$var$toLength$2;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $f9a22d5a80b70b70$var$lengthOfArrayLike$2 = function(obj) {
    return $f9a22d5a80b70b70$var$toLength$1(obj.length);
};
var $f9a22d5a80b70b70$var$toIndexedObject$3 = $f9a22d5a80b70b70$var$toIndexedObject$5;
var $f9a22d5a80b70b70$var$toAbsoluteIndex = $f9a22d5a80b70b70$var$toAbsoluteIndex$1;
var $f9a22d5a80b70b70$var$lengthOfArrayLike$1 = $f9a22d5a80b70b70$var$lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $f9a22d5a80b70b70$var$createMethod$1 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $f9a22d5a80b70b70$var$toIndexedObject$3($this);
        var length = $f9a22d5a80b70b70$var$lengthOfArrayLike$1(O);
        var index = $f9a22d5a80b70b70$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $f9a22d5a80b70b70$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f9a22d5a80b70b70$var$createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f9a22d5a80b70b70$var$createMethod$1(false)
};
var $f9a22d5a80b70b70$var$uncurryThis$b = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$hasOwn$5 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$toIndexedObject$2 = $f9a22d5a80b70b70$var$toIndexedObject$5;
var $f9a22d5a80b70b70$var$indexOf$1 = $f9a22d5a80b70b70$var$arrayIncludes.indexOf;
var $f9a22d5a80b70b70$var$hiddenKeys$2 = $f9a22d5a80b70b70$var$hiddenKeys$4;
var $f9a22d5a80b70b70$var$push$1 = $f9a22d5a80b70b70$var$uncurryThis$b([].push);
var $f9a22d5a80b70b70$var$objectKeysInternal = function(object, names) {
    var O = $f9a22d5a80b70b70$var$toIndexedObject$2(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$f9a22d5a80b70b70$var$hasOwn$5($f9a22d5a80b70b70$var$hiddenKeys$2, key) && $f9a22d5a80b70b70$var$hasOwn$5(O, key) && $f9a22d5a80b70b70$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($f9a22d5a80b70b70$var$hasOwn$5(O, key = names[i++])) ~$f9a22d5a80b70b70$var$indexOf$1(result, key) || $f9a22d5a80b70b70$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $f9a22d5a80b70b70$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $f9a22d5a80b70b70$var$internalObjectKeys$1 = $f9a22d5a80b70b70$var$objectKeysInternal;
var $f9a22d5a80b70b70$var$enumBugKeys$2 = $f9a22d5a80b70b70$var$enumBugKeys$3;
var $f9a22d5a80b70b70$var$hiddenKeys$1 = $f9a22d5a80b70b70$var$enumBugKeys$2.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$f9a22d5a80b70b70$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $f9a22d5a80b70b70$var$internalObjectKeys$1(O, $f9a22d5a80b70b70$var$hiddenKeys$1);
};
var $f9a22d5a80b70b70$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$f9a22d5a80b70b70$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $f9a22d5a80b70b70$var$getBuiltIn$5 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$uncurryThis$a = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$getOwnPropertyNamesModule = $f9a22d5a80b70b70$var$objectGetOwnPropertyNames;
var $f9a22d5a80b70b70$var$getOwnPropertySymbolsModule$1 = $f9a22d5a80b70b70$var$objectGetOwnPropertySymbols;
var $f9a22d5a80b70b70$var$anObject$c = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$concat$2 = $f9a22d5a80b70b70$var$uncurryThis$a([].concat);
// all object keys, includes non-enumerable and symbols
var $f9a22d5a80b70b70$var$ownKeys$1 = $f9a22d5a80b70b70$var$getBuiltIn$5("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f9a22d5a80b70b70$var$getOwnPropertyNamesModule.f($f9a22d5a80b70b70$var$anObject$c(it));
    var getOwnPropertySymbols = $f9a22d5a80b70b70$var$getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? $f9a22d5a80b70b70$var$concat$2(keys, getOwnPropertySymbols(it)) : keys;
};
var $f9a22d5a80b70b70$var$hasOwn$4 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$ownKeys = $f9a22d5a80b70b70$var$ownKeys$1;
var $f9a22d5a80b70b70$var$getOwnPropertyDescriptorModule = $f9a22d5a80b70b70$var$objectGetOwnPropertyDescriptor;
var $f9a22d5a80b70b70$var$definePropertyModule$2 = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $f9a22d5a80b70b70$var$ownKeys(source);
    var defineProperty = $f9a22d5a80b70b70$var$definePropertyModule$2.f;
    var getOwnPropertyDescriptor = $f9a22d5a80b70b70$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$f9a22d5a80b70b70$var$hasOwn$4(target, key) && !(exceptions && $f9a22d5a80b70b70$var$hasOwn$4(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $f9a22d5a80b70b70$var$fails$b = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$isCallable$c = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$replacement = /#|\.prototype\./;
var $f9a22d5a80b70b70$var$isForced$2 = function(feature, detection) {
    var value = $f9a22d5a80b70b70$var$data[$f9a22d5a80b70b70$var$normalize(feature)];
    return value == $f9a22d5a80b70b70$var$POLYFILL ? true : value == $f9a22d5a80b70b70$var$NATIVE ? false : $f9a22d5a80b70b70$var$isCallable$c(detection) ? $f9a22d5a80b70b70$var$fails$b(detection) : !!detection;
};
var $f9a22d5a80b70b70$var$normalize = $f9a22d5a80b70b70$var$isForced$2.normalize = function(string) {
    return String(string).replace($f9a22d5a80b70b70$var$replacement, ".").toLowerCase();
};
var $f9a22d5a80b70b70$var$data = $f9a22d5a80b70b70$var$isForced$2.data = {};
var $f9a22d5a80b70b70$var$NATIVE = $f9a22d5a80b70b70$var$isForced$2.NATIVE = "N";
var $f9a22d5a80b70b70$var$POLYFILL = $f9a22d5a80b70b70$var$isForced$2.POLYFILL = "P";
var $f9a22d5a80b70b70$var$isForced_1 = $f9a22d5a80b70b70$var$isForced$2;
var $f9a22d5a80b70b70$var$global$d = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$1 = $f9a22d5a80b70b70$var$objectGetOwnPropertyDescriptor.f;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty$3 = $f9a22d5a80b70b70$var$createNonEnumerableProperty$5;
var $f9a22d5a80b70b70$var$defineBuiltIn$6 = $f9a22d5a80b70b70$var$defineBuiltIn$7;
var $f9a22d5a80b70b70$var$defineGlobalProperty = $f9a22d5a80b70b70$var$defineGlobalProperty$3;
var $f9a22d5a80b70b70$var$copyConstructorProperties = $f9a22d5a80b70b70$var$copyConstructorProperties$1;
var $f9a22d5a80b70b70$var$isForced$1 = $f9a22d5a80b70b70$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $f9a22d5a80b70b70$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $f9a22d5a80b70b70$var$global$d;
    else if (STATIC) target = $f9a22d5a80b70b70$var$global$d[TARGET] || $f9a22d5a80b70b70$var$defineGlobalProperty(TARGET, {});
    else target = ($f9a22d5a80b70b70$var$global$d[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $f9a22d5a80b70b70$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $f9a22d5a80b70b70$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $f9a22d5a80b70b70$var$createNonEnumerableProperty$3(sourceProperty, "sham", true);
        $f9a22d5a80b70b70$var$defineBuiltIn$6(target, key, sourceProperty, options);
    }
};
var $f9a22d5a80b70b70$var$internalObjectKeys = $f9a22d5a80b70b70$var$objectKeysInternal;
var $f9a22d5a80b70b70$var$enumBugKeys$1 = $f9a22d5a80b70b70$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $f9a22d5a80b70b70$var$objectKeys$2 = Object.keys || function keys(O) {
    return $f9a22d5a80b70b70$var$internalObjectKeys(O, $f9a22d5a80b70b70$var$enumBugKeys$1);
};
var $f9a22d5a80b70b70$var$DESCRIPTORS$3 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$uncurryThis$9 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$call$d = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$fails$a = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$objectKeys$1 = $f9a22d5a80b70b70$var$objectKeys$2;
var $f9a22d5a80b70b70$var$getOwnPropertySymbolsModule = $f9a22d5a80b70b70$var$objectGetOwnPropertySymbols;
var $f9a22d5a80b70b70$var$propertyIsEnumerableModule = $f9a22d5a80b70b70$var$objectPropertyIsEnumerable;
var $f9a22d5a80b70b70$var$toObject$2 = $f9a22d5a80b70b70$var$toObject$4;
var $f9a22d5a80b70b70$var$IndexedObject = $f9a22d5a80b70b70$var$indexedObject;
// eslint-disable-next-line es-x/no-object-assign -- safe
var $f9a22d5a80b70b70$var$$assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var $f9a22d5a80b70b70$var$defineProperty$3 = Object.defineProperty;
var $f9a22d5a80b70b70$var$concat$1 = $f9a22d5a80b70b70$var$uncurryThis$9([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $f9a22d5a80b70b70$var$objectAssign = !$f9a22d5a80b70b70$var$$assign || $f9a22d5a80b70b70$var$fails$a(function() {
    // should have correct order of operations (Edge bug)
    if ($f9a22d5a80b70b70$var$DESCRIPTORS$3 && $f9a22d5a80b70b70$var$$assign({
        b: 1
    }, $f9a22d5a80b70b70$var$$assign($f9a22d5a80b70b70$var$defineProperty$3({}, "a", {
        enumerable: true,
        get: function() {
            $f9a22d5a80b70b70$var$defineProperty$3(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es-x/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $f9a22d5a80b70b70$var$$assign({}, A)[symbol] != 7 || $f9a22d5a80b70b70$var$objectKeys$1($f9a22d5a80b70b70$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $f9a22d5a80b70b70$var$toObject$2(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $f9a22d5a80b70b70$var$getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = $f9a22d5a80b70b70$var$propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = $f9a22d5a80b70b70$var$IndexedObject(arguments[index++]);
        var keys = getOwnPropertySymbols ? $f9a22d5a80b70b70$var$concat$1($f9a22d5a80b70b70$var$objectKeys$1(S), getOwnPropertySymbols(S)) : $f9a22d5a80b70b70$var$objectKeys$1(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$f9a22d5a80b70b70$var$DESCRIPTORS$3 || $f9a22d5a80b70b70$var$call$d(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $f9a22d5a80b70b70$var$$assign;
var $f9a22d5a80b70b70$var$$$8 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$assign = $f9a22d5a80b70b70$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$f9a22d5a80b70b70$var$$$8({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $f9a22d5a80b70b70$var$assign
}, {
    assign: $f9a22d5a80b70b70$var$assign
});
var $f9a22d5a80b70b70$var$wellKnownSymbol$e = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$TO_STRING_TAG$3 = $f9a22d5a80b70b70$var$wellKnownSymbol$e("toStringTag");
var $f9a22d5a80b70b70$var$test = {};
$f9a22d5a80b70b70$var$test[$f9a22d5a80b70b70$var$TO_STRING_TAG$3] = "z";
var $f9a22d5a80b70b70$var$toStringTagSupport = String($f9a22d5a80b70b70$var$test) === "[object z]";
var $f9a22d5a80b70b70$var$TO_STRING_TAG_SUPPORT = $f9a22d5a80b70b70$var$toStringTagSupport;
var $f9a22d5a80b70b70$var$isCallable$b = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$classofRaw = $f9a22d5a80b70b70$var$classofRaw$1;
var $f9a22d5a80b70b70$var$wellKnownSymbol$d = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$TO_STRING_TAG$2 = $f9a22d5a80b70b70$var$wellKnownSymbol$d("toStringTag");
var $f9a22d5a80b70b70$var$$Object$1 = Object;
// ES3 wrong here
var $f9a22d5a80b70b70$var$CORRECT_ARGUMENTS = $f9a22d5a80b70b70$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $f9a22d5a80b70b70$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $f9a22d5a80b70b70$var$classof$5 = $f9a22d5a80b70b70$var$TO_STRING_TAG_SUPPORT ? $f9a22d5a80b70b70$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $f9a22d5a80b70b70$var$tryGet(O = $f9a22d5a80b70b70$var$$Object$1(it), $f9a22d5a80b70b70$var$TO_STRING_TAG$2)) == "string" ? tag : $f9a22d5a80b70b70$var$CORRECT_ARGUMENTS ? $f9a22d5a80b70b70$var$classofRaw(O) : (result = $f9a22d5a80b70b70$var$classofRaw(O)) == "Object" && $f9a22d5a80b70b70$var$isCallable$b(O.callee) ? "Arguments" : result;
};
var $f9a22d5a80b70b70$var$classof$4 = $f9a22d5a80b70b70$var$classof$5;
var $f9a22d5a80b70b70$var$$String$1 = String;
var $f9a22d5a80b70b70$var$toString$3 = function(argument) {
    if ($f9a22d5a80b70b70$var$classof$4(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $f9a22d5a80b70b70$var$$String$1(argument);
};
var $f9a22d5a80b70b70$var$anObject$b = $f9a22d5a80b70b70$var$anObject$e;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $f9a22d5a80b70b70$var$regexpFlags$1 = function() {
    var that = $f9a22d5a80b70b70$var$anObject$b(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $f9a22d5a80b70b70$var$call$c = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$hasOwn$3 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$isPrototypeOf$2 = $f9a22d5a80b70b70$var$objectIsPrototypeOf;
var $f9a22d5a80b70b70$var$regExpFlags = $f9a22d5a80b70b70$var$regexpFlags$1;
var $f9a22d5a80b70b70$var$RegExpPrototype$2 = RegExp.prototype;
var $f9a22d5a80b70b70$var$regexpGetFlags = function(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $f9a22d5a80b70b70$var$RegExpPrototype$2) && !$f9a22d5a80b70b70$var$hasOwn$3(R, "flags") && $f9a22d5a80b70b70$var$isPrototypeOf$2($f9a22d5a80b70b70$var$RegExpPrototype$2, R) ? $f9a22d5a80b70b70$var$call$c($f9a22d5a80b70b70$var$regExpFlags, R) : flags;
};
var $f9a22d5a80b70b70$var$PROPER_FUNCTION_NAME$1 = $f9a22d5a80b70b70$var$functionName.PROPER;
var $f9a22d5a80b70b70$var$defineBuiltIn$5 = $f9a22d5a80b70b70$var$defineBuiltIn$7;
var $f9a22d5a80b70b70$var$anObject$a = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$$toString = $f9a22d5a80b70b70$var$toString$3;
var $f9a22d5a80b70b70$var$fails$9 = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$getRegExpFlags = $f9a22d5a80b70b70$var$regexpGetFlags;
var $f9a22d5a80b70b70$var$TO_STRING = "toString";
var $f9a22d5a80b70b70$var$RegExpPrototype$1 = RegExp.prototype;
var $f9a22d5a80b70b70$var$n$ToString = $f9a22d5a80b70b70$var$RegExpPrototype$1[$f9a22d5a80b70b70$var$TO_STRING];
var $f9a22d5a80b70b70$var$NOT_GENERIC = $f9a22d5a80b70b70$var$fails$9(function() {
    return $f9a22d5a80b70b70$var$n$ToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $f9a22d5a80b70b70$var$INCORRECT_NAME = $f9a22d5a80b70b70$var$PROPER_FUNCTION_NAME$1 && $f9a22d5a80b70b70$var$n$ToString.name != $f9a22d5a80b70b70$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($f9a22d5a80b70b70$var$NOT_GENERIC || $f9a22d5a80b70b70$var$INCORRECT_NAME) $f9a22d5a80b70b70$var$defineBuiltIn$5(RegExp.prototype, $f9a22d5a80b70b70$var$TO_STRING, function toString() {
    var R = $f9a22d5a80b70b70$var$anObject$a(this);
    var pattern = $f9a22d5a80b70b70$var$$toString(R.source);
    var flags = $f9a22d5a80b70b70$var$$toString($f9a22d5a80b70b70$var$getRegExpFlags(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});
var $f9a22d5a80b70b70$var$objectDefineProperties = {};
var $f9a22d5a80b70b70$var$DESCRIPTORS$2 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$V8_PROTOTYPE_DEFINE_BUG = $f9a22d5a80b70b70$var$v8PrototypeDefineBug;
var $f9a22d5a80b70b70$var$definePropertyModule$1 = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$anObject$9 = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$toIndexedObject$1 = $f9a22d5a80b70b70$var$toIndexedObject$5;
var $f9a22d5a80b70b70$var$objectKeys = $f9a22d5a80b70b70$var$objectKeys$2;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$f9a22d5a80b70b70$var$objectDefineProperties.f = $f9a22d5a80b70b70$var$DESCRIPTORS$2 && !$f9a22d5a80b70b70$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $f9a22d5a80b70b70$var$anObject$9(O);
    var props = $f9a22d5a80b70b70$var$toIndexedObject$1(Properties);
    var keys = $f9a22d5a80b70b70$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$f9a22d5a80b70b70$var$definePropertyModule$1.f(O, key = keys[index++], props[key]);
    return O;
};
var $f9a22d5a80b70b70$var$getBuiltIn$4 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$html$2 = $f9a22d5a80b70b70$var$getBuiltIn$4("document", "documentElement");
/* global ActiveXObject -- old IE, WSH */ var $f9a22d5a80b70b70$var$anObject$8 = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$definePropertiesModule = $f9a22d5a80b70b70$var$objectDefineProperties;
var $f9a22d5a80b70b70$var$enumBugKeys = $f9a22d5a80b70b70$var$enumBugKeys$3;
var $f9a22d5a80b70b70$var$hiddenKeys = $f9a22d5a80b70b70$var$hiddenKeys$4;
var $f9a22d5a80b70b70$var$html$1 = $f9a22d5a80b70b70$var$html$2;
var $f9a22d5a80b70b70$var$documentCreateElement$1 = $f9a22d5a80b70b70$var$documentCreateElement$2;
var $f9a22d5a80b70b70$var$sharedKey$1 = $f9a22d5a80b70b70$var$sharedKey$3;
var $f9a22d5a80b70b70$var$GT = ">";
var $f9a22d5a80b70b70$var$LT = "<";
var $f9a22d5a80b70b70$var$PROTOTYPE = "prototype";
var $f9a22d5a80b70b70$var$SCRIPT = "script";
var $f9a22d5a80b70b70$var$IE_PROTO$1 = $f9a22d5a80b70b70$var$sharedKey$1("IE_PROTO");
var $f9a22d5a80b70b70$var$EmptyConstructor = function() {};
var $f9a22d5a80b70b70$var$scriptTag = function(content) {
    return $f9a22d5a80b70b70$var$LT + $f9a22d5a80b70b70$var$SCRIPT + $f9a22d5a80b70b70$var$GT + content + $f9a22d5a80b70b70$var$LT + "/" + $f9a22d5a80b70b70$var$SCRIPT + $f9a22d5a80b70b70$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $f9a22d5a80b70b70$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($f9a22d5a80b70b70$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f9a22d5a80b70b70$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $f9a22d5a80b70b70$var$documentCreateElement$1("iframe");
    var JS = "java" + $f9a22d5a80b70b70$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $f9a22d5a80b70b70$var$html$1.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($f9a22d5a80b70b70$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $f9a22d5a80b70b70$var$activeXDocument;
var $f9a22d5a80b70b70$var$NullProtoObject = function() {
    try {
        $f9a22d5a80b70b70$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $f9a22d5a80b70b70$var$NullProtoObject = typeof document != "undefined" ? document.domain && $f9a22d5a80b70b70$var$activeXDocument ? $f9a22d5a80b70b70$var$NullProtoObjectViaActiveX($f9a22d5a80b70b70$var$activeXDocument) // old IE
     : $f9a22d5a80b70b70$var$NullProtoObjectViaIFrame() : $f9a22d5a80b70b70$var$NullProtoObjectViaActiveX($f9a22d5a80b70b70$var$activeXDocument); // WSH
    var length = $f9a22d5a80b70b70$var$enumBugKeys.length;
    while(length--)delete $f9a22d5a80b70b70$var$NullProtoObject[$f9a22d5a80b70b70$var$PROTOTYPE][$f9a22d5a80b70b70$var$enumBugKeys[length]];
    return $f9a22d5a80b70b70$var$NullProtoObject();
};
$f9a22d5a80b70b70$var$hiddenKeys[$f9a22d5a80b70b70$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $f9a22d5a80b70b70$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f9a22d5a80b70b70$var$EmptyConstructor[$f9a22d5a80b70b70$var$PROTOTYPE] = $f9a22d5a80b70b70$var$anObject$8(O);
        result = new $f9a22d5a80b70b70$var$EmptyConstructor();
        $f9a22d5a80b70b70$var$EmptyConstructor[$f9a22d5a80b70b70$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f9a22d5a80b70b70$var$IE_PROTO$1] = O;
    } else result = $f9a22d5a80b70b70$var$NullProtoObject();
    return Properties === undefined ? result : $f9a22d5a80b70b70$var$definePropertiesModule.f(result, Properties);
};
var $f9a22d5a80b70b70$var$wellKnownSymbol$c = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$create$2 = $f9a22d5a80b70b70$var$objectCreate;
var $f9a22d5a80b70b70$var$defineProperty$2 = $f9a22d5a80b70b70$var$objectDefineProperty.f;
var $f9a22d5a80b70b70$var$UNSCOPABLES = $f9a22d5a80b70b70$var$wellKnownSymbol$c("unscopables");
var $f9a22d5a80b70b70$var$ArrayPrototype$1 = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($f9a22d5a80b70b70$var$ArrayPrototype$1[$f9a22d5a80b70b70$var$UNSCOPABLES] == undefined) $f9a22d5a80b70b70$var$defineProperty$2($f9a22d5a80b70b70$var$ArrayPrototype$1, $f9a22d5a80b70b70$var$UNSCOPABLES, {
    configurable: true,
    value: $f9a22d5a80b70b70$var$create$2(null)
});
// add a key to Array.prototype[@@unscopables]
var $f9a22d5a80b70b70$var$addToUnscopables$1 = function(key) {
    $f9a22d5a80b70b70$var$ArrayPrototype$1[$f9a22d5a80b70b70$var$UNSCOPABLES][key] = true;
};
var $f9a22d5a80b70b70$var$iterators = {};
var $f9a22d5a80b70b70$var$fails$8 = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$correctPrototypeGetter = !$f9a22d5a80b70b70$var$fails$8(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $f9a22d5a80b70b70$var$hasOwn$2 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$isCallable$a = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$toObject$1 = $f9a22d5a80b70b70$var$toObject$4;
var $f9a22d5a80b70b70$var$sharedKey = $f9a22d5a80b70b70$var$sharedKey$3;
var $f9a22d5a80b70b70$var$CORRECT_PROTOTYPE_GETTER = $f9a22d5a80b70b70$var$correctPrototypeGetter;
var $f9a22d5a80b70b70$var$IE_PROTO = $f9a22d5a80b70b70$var$sharedKey("IE_PROTO");
var $f9a22d5a80b70b70$var$$Object = Object;
var $f9a22d5a80b70b70$var$ObjectPrototype = $f9a22d5a80b70b70$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $f9a22d5a80b70b70$var$objectGetPrototypeOf = $f9a22d5a80b70b70$var$CORRECT_PROTOTYPE_GETTER ? $f9a22d5a80b70b70$var$$Object.getPrototypeOf : function(O) {
    var object = $f9a22d5a80b70b70$var$toObject$1(O);
    if ($f9a22d5a80b70b70$var$hasOwn$2(object, $f9a22d5a80b70b70$var$IE_PROTO)) return object[$f9a22d5a80b70b70$var$IE_PROTO];
    var constructor = object.constructor;
    if ($f9a22d5a80b70b70$var$isCallable$a(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $f9a22d5a80b70b70$var$$Object ? $f9a22d5a80b70b70$var$ObjectPrototype : null;
};
var $f9a22d5a80b70b70$var$fails$7 = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$isCallable$9 = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$getPrototypeOf$1 = $f9a22d5a80b70b70$var$objectGetPrototypeOf;
var $f9a22d5a80b70b70$var$defineBuiltIn$4 = $f9a22d5a80b70b70$var$defineBuiltIn$7;
var $f9a22d5a80b70b70$var$wellKnownSymbol$b = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$ITERATOR$5 = $f9a22d5a80b70b70$var$wellKnownSymbol$b("iterator");
var $f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $f9a22d5a80b70b70$var$IteratorPrototype$2, $f9a22d5a80b70b70$var$PrototypeOfArrayIteratorPrototype, $f9a22d5a80b70b70$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $f9a22d5a80b70b70$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $f9a22d5a80b70b70$var$arrayIterator)) $f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $f9a22d5a80b70b70$var$PrototypeOfArrayIteratorPrototype = $f9a22d5a80b70b70$var$getPrototypeOf$1($f9a22d5a80b70b70$var$getPrototypeOf$1($f9a22d5a80b70b70$var$arrayIterator));
        if ($f9a22d5a80b70b70$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $f9a22d5a80b70b70$var$IteratorPrototype$2 = $f9a22d5a80b70b70$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $f9a22d5a80b70b70$var$NEW_ITERATOR_PROTOTYPE = $f9a22d5a80b70b70$var$IteratorPrototype$2 == undefined || $f9a22d5a80b70b70$var$fails$7(function() {
    var test = {};
    // FF44- legacy iterators case
    return $f9a22d5a80b70b70$var$IteratorPrototype$2[$f9a22d5a80b70b70$var$ITERATOR$5].call(test) !== test;
});
if ($f9a22d5a80b70b70$var$NEW_ITERATOR_PROTOTYPE) $f9a22d5a80b70b70$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$f9a22d5a80b70b70$var$isCallable$9($f9a22d5a80b70b70$var$IteratorPrototype$2[$f9a22d5a80b70b70$var$ITERATOR$5])) $f9a22d5a80b70b70$var$defineBuiltIn$4($f9a22d5a80b70b70$var$IteratorPrototype$2, $f9a22d5a80b70b70$var$ITERATOR$5, function() {
    return this;
});
var $f9a22d5a80b70b70$var$iteratorsCore = {
    IteratorPrototype: $f9a22d5a80b70b70$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS$1
};
var $f9a22d5a80b70b70$var$defineProperty$1 = $f9a22d5a80b70b70$var$objectDefineProperty.f;
var $f9a22d5a80b70b70$var$hasOwn$1 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$wellKnownSymbol$a = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$TO_STRING_TAG$1 = $f9a22d5a80b70b70$var$wellKnownSymbol$a("toStringTag");
var $f9a22d5a80b70b70$var$setToStringTag$3 = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$f9a22d5a80b70b70$var$hasOwn$1(target, $f9a22d5a80b70b70$var$TO_STRING_TAG$1)) $f9a22d5a80b70b70$var$defineProperty$1(target, $f9a22d5a80b70b70$var$TO_STRING_TAG$1, {
        configurable: true,
        value: TAG
    });
};
var $f9a22d5a80b70b70$var$IteratorPrototype$1 = $f9a22d5a80b70b70$var$iteratorsCore.IteratorPrototype;
var $f9a22d5a80b70b70$var$create$1 = $f9a22d5a80b70b70$var$objectCreate;
var $f9a22d5a80b70b70$var$createPropertyDescriptor = $f9a22d5a80b70b70$var$createPropertyDescriptor$3;
var $f9a22d5a80b70b70$var$setToStringTag$2 = $f9a22d5a80b70b70$var$setToStringTag$3;
var $f9a22d5a80b70b70$var$Iterators$4 = $f9a22d5a80b70b70$var$iterators;
var $f9a22d5a80b70b70$var$returnThis$1 = function() {
    return this;
};
var $f9a22d5a80b70b70$var$createIteratorConstructor$1 = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $f9a22d5a80b70b70$var$create$1($f9a22d5a80b70b70$var$IteratorPrototype$1, {
        next: $f9a22d5a80b70b70$var$createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
    });
    $f9a22d5a80b70b70$var$setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
    $f9a22d5a80b70b70$var$Iterators$4[TO_STRING_TAG] = $f9a22d5a80b70b70$var$returnThis$1;
    return IteratorConstructor;
};
var $f9a22d5a80b70b70$var$isCallable$8 = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$$String = String;
var $f9a22d5a80b70b70$var$$TypeError$6 = TypeError;
var $f9a22d5a80b70b70$var$aPossiblePrototype$1 = function(argument) {
    if (typeof argument == "object" || $f9a22d5a80b70b70$var$isCallable$8(argument)) return argument;
    throw $f9a22d5a80b70b70$var$$TypeError$6("Can't set " + $f9a22d5a80b70b70$var$$String(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $f9a22d5a80b70b70$var$uncurryThis$8 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$anObject$7 = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$aPossiblePrototype = $f9a22d5a80b70b70$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $f9a22d5a80b70b70$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $f9a22d5a80b70b70$var$uncurryThis$8(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $f9a22d5a80b70b70$var$anObject$7(O);
        $f9a22d5a80b70b70$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $f9a22d5a80b70b70$var$$$7 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$call$b = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$FunctionName = $f9a22d5a80b70b70$var$functionName;
var $f9a22d5a80b70b70$var$isCallable$7 = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$createIteratorConstructor = $f9a22d5a80b70b70$var$createIteratorConstructor$1;
var $f9a22d5a80b70b70$var$getPrototypeOf = $f9a22d5a80b70b70$var$objectGetPrototypeOf;
var $f9a22d5a80b70b70$var$setPrototypeOf$1 = $f9a22d5a80b70b70$var$objectSetPrototypeOf;
var $f9a22d5a80b70b70$var$setToStringTag$1 = $f9a22d5a80b70b70$var$setToStringTag$3;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty$2 = $f9a22d5a80b70b70$var$createNonEnumerableProperty$5;
var $f9a22d5a80b70b70$var$defineBuiltIn$3 = $f9a22d5a80b70b70$var$defineBuiltIn$7;
var $f9a22d5a80b70b70$var$wellKnownSymbol$9 = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$Iterators$3 = $f9a22d5a80b70b70$var$iterators;
var $f9a22d5a80b70b70$var$IteratorsCore = $f9a22d5a80b70b70$var$iteratorsCore;
var $f9a22d5a80b70b70$var$PROPER_FUNCTION_NAME = $f9a22d5a80b70b70$var$FunctionName.PROPER;
var $f9a22d5a80b70b70$var$CONFIGURABLE_FUNCTION_NAME = $f9a22d5a80b70b70$var$FunctionName.CONFIGURABLE;
var $f9a22d5a80b70b70$var$IteratorPrototype = $f9a22d5a80b70b70$var$IteratorsCore.IteratorPrototype;
var $f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS = $f9a22d5a80b70b70$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $f9a22d5a80b70b70$var$ITERATOR$4 = $f9a22d5a80b70b70$var$wellKnownSymbol$9("iterator");
var $f9a22d5a80b70b70$var$KEYS = "keys";
var $f9a22d5a80b70b70$var$VALUES = "values";
var $f9a22d5a80b70b70$var$ENTRIES = "entries";
var $f9a22d5a80b70b70$var$returnThis = function() {
    return this;
};
var $f9a22d5a80b70b70$var$defineIterator$1 = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $f9a22d5a80b70b70$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $f9a22d5a80b70b70$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $f9a22d5a80b70b70$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $f9a22d5a80b70b70$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$f9a22d5a80b70b70$var$ITERATOR$4] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $f9a22d5a80b70b70$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($f9a22d5a80b70b70$var$getPrototypeOf(CurrentIteratorPrototype) !== $f9a22d5a80b70b70$var$IteratorPrototype) {
                if ($f9a22d5a80b70b70$var$setPrototypeOf$1) $f9a22d5a80b70b70$var$setPrototypeOf$1(CurrentIteratorPrototype, $f9a22d5a80b70b70$var$IteratorPrototype);
                else if (!$f9a22d5a80b70b70$var$isCallable$7(CurrentIteratorPrototype[$f9a22d5a80b70b70$var$ITERATOR$4])) $f9a22d5a80b70b70$var$defineBuiltIn$3(CurrentIteratorPrototype, $f9a22d5a80b70b70$var$ITERATOR$4, $f9a22d5a80b70b70$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $f9a22d5a80b70b70$var$setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($f9a22d5a80b70b70$var$PROPER_FUNCTION_NAME && DEFAULT == $f9a22d5a80b70b70$var$VALUES && nativeIterator && nativeIterator.name !== $f9a22d5a80b70b70$var$VALUES) {
        if ($f9a22d5a80b70b70$var$CONFIGURABLE_FUNCTION_NAME) $f9a22d5a80b70b70$var$createNonEnumerableProperty$2(IterablePrototype, "name", $f9a22d5a80b70b70$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $f9a22d5a80b70b70$var$call$b(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($f9a22d5a80b70b70$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($f9a22d5a80b70b70$var$KEYS),
            entries: getIterationMethod($f9a22d5a80b70b70$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $f9a22d5a80b70b70$var$defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
        } else $f9a22d5a80b70b70$var$$$7({
            target: NAME,
            proto: true,
            forced: $f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$f9a22d5a80b70b70$var$ITERATOR$4] !== defaultIterator) $f9a22d5a80b70b70$var$defineBuiltIn$3(IterablePrototype, $f9a22d5a80b70b70$var$ITERATOR$4, defaultIterator, {
        name: DEFAULT
    });
    $f9a22d5a80b70b70$var$Iterators$3[NAME] = defaultIterator;
    return methods;
};
var $f9a22d5a80b70b70$var$toIndexedObject = $f9a22d5a80b70b70$var$toIndexedObject$5;
var $f9a22d5a80b70b70$var$addToUnscopables = $f9a22d5a80b70b70$var$addToUnscopables$1;
var $f9a22d5a80b70b70$var$Iterators$2 = $f9a22d5a80b70b70$var$iterators;
var $f9a22d5a80b70b70$var$InternalStateModule$1 = $f9a22d5a80b70b70$var$internalState;
var $f9a22d5a80b70b70$var$defineProperty = $f9a22d5a80b70b70$var$objectDefineProperty.f;
var $f9a22d5a80b70b70$var$defineIterator = $f9a22d5a80b70b70$var$defineIterator$1;
var $f9a22d5a80b70b70$var$DESCRIPTORS$1 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$ARRAY_ITERATOR = "Array Iterator";
var $f9a22d5a80b70b70$var$setInternalState$1 = $f9a22d5a80b70b70$var$InternalStateModule$1.set;
var $f9a22d5a80b70b70$var$getInternalState$1 = $f9a22d5a80b70b70$var$InternalStateModule$1.getterFor($f9a22d5a80b70b70$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $f9a22d5a80b70b70$var$es_array_iterator = $f9a22d5a80b70b70$var$defineIterator(Array, "Array", function(iterated, kind) {
    $f9a22d5a80b70b70$var$setInternalState$1(this, {
        type: $f9a22d5a80b70b70$var$ARRAY_ITERATOR,
        target: $f9a22d5a80b70b70$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $f9a22d5a80b70b70$var$getInternalState$1(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $f9a22d5a80b70b70$var$values = $f9a22d5a80b70b70$var$Iterators$2.Arguments = $f9a22d5a80b70b70$var$Iterators$2.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$f9a22d5a80b70b70$var$addToUnscopables("keys");
$f9a22d5a80b70b70$var$addToUnscopables("values");
$f9a22d5a80b70b70$var$addToUnscopables("entries");
// V8 ~ Chrome 45- bug
if ($f9a22d5a80b70b70$var$DESCRIPTORS$1 && $f9a22d5a80b70b70$var$values.name !== "values") try {
    $f9a22d5a80b70b70$var$defineProperty($f9a22d5a80b70b70$var$values, "name", {
        value: "values"
    });
} catch (error) {}
var $f9a22d5a80b70b70$var$classof$3 = $f9a22d5a80b70b70$var$classofRaw$1;
var $f9a22d5a80b70b70$var$global$c = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$engineIsNode = $f9a22d5a80b70b70$var$classof$3($f9a22d5a80b70b70$var$global$c.process) == "process";
var $f9a22d5a80b70b70$var$getBuiltIn$3 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$definePropertyModule = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$wellKnownSymbol$8 = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$DESCRIPTORS = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$SPECIES$3 = $f9a22d5a80b70b70$var$wellKnownSymbol$8("species");
var $f9a22d5a80b70b70$var$setSpecies$1 = function(CONSTRUCTOR_NAME) {
    var Constructor = $f9a22d5a80b70b70$var$getBuiltIn$3(CONSTRUCTOR_NAME);
    var defineProperty = $f9a22d5a80b70b70$var$definePropertyModule.f;
    if ($f9a22d5a80b70b70$var$DESCRIPTORS && Constructor && !Constructor[$f9a22d5a80b70b70$var$SPECIES$3]) defineProperty(Constructor, $f9a22d5a80b70b70$var$SPECIES$3, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};
var $f9a22d5a80b70b70$var$isPrototypeOf$1 = $f9a22d5a80b70b70$var$objectIsPrototypeOf;
var $f9a22d5a80b70b70$var$$TypeError$5 = TypeError;
var $f9a22d5a80b70b70$var$anInstance$1 = function(it, Prototype) {
    if ($f9a22d5a80b70b70$var$isPrototypeOf$1(Prototype, it)) return it;
    throw $f9a22d5a80b70b70$var$$TypeError$5("Incorrect invocation");
};
var $f9a22d5a80b70b70$var$uncurryThis$7 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$fails$6 = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$isCallable$6 = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$classof$2 = $f9a22d5a80b70b70$var$classof$5;
var $f9a22d5a80b70b70$var$getBuiltIn$2 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$inspectSource$1 = $f9a22d5a80b70b70$var$inspectSource$4;
var $f9a22d5a80b70b70$var$noop = function() {};
var $f9a22d5a80b70b70$var$empty = [];
var $f9a22d5a80b70b70$var$construct = $f9a22d5a80b70b70$var$getBuiltIn$2("Reflect", "construct");
var $f9a22d5a80b70b70$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $f9a22d5a80b70b70$var$exec$1 = $f9a22d5a80b70b70$var$uncurryThis$7($f9a22d5a80b70b70$var$constructorRegExp.exec);
var $f9a22d5a80b70b70$var$INCORRECT_TO_STRING = !$f9a22d5a80b70b70$var$constructorRegExp.exec($f9a22d5a80b70b70$var$noop);
var $f9a22d5a80b70b70$var$isConstructorModern = function isConstructor(argument) {
    if (!$f9a22d5a80b70b70$var$isCallable$6(argument)) return false;
    try {
        $f9a22d5a80b70b70$var$construct($f9a22d5a80b70b70$var$noop, $f9a22d5a80b70b70$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $f9a22d5a80b70b70$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$f9a22d5a80b70b70$var$isCallable$6(argument)) return false;
    switch($f9a22d5a80b70b70$var$classof$2(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $f9a22d5a80b70b70$var$INCORRECT_TO_STRING || !!$f9a22d5a80b70b70$var$exec$1($f9a22d5a80b70b70$var$constructorRegExp, $f9a22d5a80b70b70$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$f9a22d5a80b70b70$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $f9a22d5a80b70b70$var$isConstructor$1 = !$f9a22d5a80b70b70$var$construct || $f9a22d5a80b70b70$var$fails$6(function() {
    var called;
    return $f9a22d5a80b70b70$var$isConstructorModern($f9a22d5a80b70b70$var$isConstructorModern.call) || !$f9a22d5a80b70b70$var$isConstructorModern(Object) || !$f9a22d5a80b70b70$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $f9a22d5a80b70b70$var$isConstructorLegacy : $f9a22d5a80b70b70$var$isConstructorModern;
var $f9a22d5a80b70b70$var$isConstructor = $f9a22d5a80b70b70$var$isConstructor$1;
var $f9a22d5a80b70b70$var$tryToString$2 = $f9a22d5a80b70b70$var$tryToString$4;
var $f9a22d5a80b70b70$var$$TypeError$4 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $f9a22d5a80b70b70$var$aConstructor$1 = function(argument) {
    if ($f9a22d5a80b70b70$var$isConstructor(argument)) return argument;
    throw $f9a22d5a80b70b70$var$$TypeError$4($f9a22d5a80b70b70$var$tryToString$2(argument) + " is not a constructor");
};
var $f9a22d5a80b70b70$var$anObject$6 = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$aConstructor = $f9a22d5a80b70b70$var$aConstructor$1;
var $f9a22d5a80b70b70$var$wellKnownSymbol$7 = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$SPECIES$2 = $f9a22d5a80b70b70$var$wellKnownSymbol$7("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $f9a22d5a80b70b70$var$speciesConstructor$1 = function(O, defaultConstructor) {
    var C = $f9a22d5a80b70b70$var$anObject$6(O).constructor;
    var S;
    return C === undefined || (S = $f9a22d5a80b70b70$var$anObject$6(C)[$f9a22d5a80b70b70$var$SPECIES$2]) == undefined ? defaultConstructor : $f9a22d5a80b70b70$var$aConstructor(S);
};
var $f9a22d5a80b70b70$var$NATIVE_BIND$1 = $f9a22d5a80b70b70$var$functionBindNative;
var $f9a22d5a80b70b70$var$FunctionPrototype = Function.prototype;
var $f9a22d5a80b70b70$var$apply$2 = $f9a22d5a80b70b70$var$FunctionPrototype.apply;
var $f9a22d5a80b70b70$var$call$a = $f9a22d5a80b70b70$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $f9a22d5a80b70b70$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($f9a22d5a80b70b70$var$NATIVE_BIND$1 ? $f9a22d5a80b70b70$var$call$a.bind($f9a22d5a80b70b70$var$apply$2) : function() {
    return $f9a22d5a80b70b70$var$call$a.apply($f9a22d5a80b70b70$var$apply$2, arguments);
});
var $f9a22d5a80b70b70$var$uncurryThis$6 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$aCallable$5 = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$NATIVE_BIND = $f9a22d5a80b70b70$var$functionBindNative;
var $f9a22d5a80b70b70$var$bind$4 = $f9a22d5a80b70b70$var$uncurryThis$6($f9a22d5a80b70b70$var$uncurryThis$6.bind);
// optional / simple context binding
var $f9a22d5a80b70b70$var$functionBindContext = function(fn, that) {
    $f9a22d5a80b70b70$var$aCallable$5(fn);
    return that === undefined ? fn : $f9a22d5a80b70b70$var$NATIVE_BIND ? $f9a22d5a80b70b70$var$bind$4(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $f9a22d5a80b70b70$var$uncurryThis$5 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$arraySlice$1 = $f9a22d5a80b70b70$var$uncurryThis$5([].slice);
var $f9a22d5a80b70b70$var$$TypeError$3 = TypeError;
var $f9a22d5a80b70b70$var$validateArgumentsLength$1 = function(passed, required) {
    if (passed < required) throw $f9a22d5a80b70b70$var$$TypeError$3("Not enough arguments");
    return passed;
};
var $f9a22d5a80b70b70$var$userAgent$2 = $f9a22d5a80b70b70$var$engineUserAgent;
var $f9a22d5a80b70b70$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($f9a22d5a80b70b70$var$userAgent$2);
var $f9a22d5a80b70b70$var$global$b = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$apply$1 = $f9a22d5a80b70b70$var$functionApply;
var $f9a22d5a80b70b70$var$bind$3 = $f9a22d5a80b70b70$var$functionBindContext;
var $f9a22d5a80b70b70$var$isCallable$5 = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$hasOwn = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$fails$5 = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$html = $f9a22d5a80b70b70$var$html$2;
var $f9a22d5a80b70b70$var$arraySlice = $f9a22d5a80b70b70$var$arraySlice$1;
var $f9a22d5a80b70b70$var$createElement = $f9a22d5a80b70b70$var$documentCreateElement$2;
var $f9a22d5a80b70b70$var$validateArgumentsLength = $f9a22d5a80b70b70$var$validateArgumentsLength$1;
var $f9a22d5a80b70b70$var$IS_IOS$1 = $f9a22d5a80b70b70$var$engineIsIos;
var $f9a22d5a80b70b70$var$IS_NODE$2 = $f9a22d5a80b70b70$var$engineIsNode;
var $f9a22d5a80b70b70$var$set = $f9a22d5a80b70b70$var$global$b.setImmediate;
var $f9a22d5a80b70b70$var$clear = $f9a22d5a80b70b70$var$global$b.clearImmediate;
var $f9a22d5a80b70b70$var$process$2 = $f9a22d5a80b70b70$var$global$b.process;
var $f9a22d5a80b70b70$var$Dispatch = $f9a22d5a80b70b70$var$global$b.Dispatch;
var $f9a22d5a80b70b70$var$Function$1 = $f9a22d5a80b70b70$var$global$b.Function;
var $f9a22d5a80b70b70$var$MessageChannel = $f9a22d5a80b70b70$var$global$b.MessageChannel;
var $f9a22d5a80b70b70$var$String$1 = $f9a22d5a80b70b70$var$global$b.String;
var $f9a22d5a80b70b70$var$counter = 0;
var $f9a22d5a80b70b70$var$queue$1 = {};
var $f9a22d5a80b70b70$var$ONREADYSTATECHANGE = "onreadystatechange";
var $f9a22d5a80b70b70$var$location, $f9a22d5a80b70b70$var$defer, $f9a22d5a80b70b70$var$channel, $f9a22d5a80b70b70$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $f9a22d5a80b70b70$var$location = $f9a22d5a80b70b70$var$global$b.location;
} catch (error) {}
var $f9a22d5a80b70b70$var$run = function(id) {
    if ($f9a22d5a80b70b70$var$hasOwn($f9a22d5a80b70b70$var$queue$1, id)) {
        var fn = $f9a22d5a80b70b70$var$queue$1[id];
        delete $f9a22d5a80b70b70$var$queue$1[id];
        fn();
    }
};
var $f9a22d5a80b70b70$var$runner = function(id) {
    return function() {
        $f9a22d5a80b70b70$var$run(id);
    };
};
var $f9a22d5a80b70b70$var$listener = function(event) {
    $f9a22d5a80b70b70$var$run(event.data);
};
var $f9a22d5a80b70b70$var$post = function(id) {
    // old engines have not location.origin
    $f9a22d5a80b70b70$var$global$b.postMessage($f9a22d5a80b70b70$var$String$1(id), $f9a22d5a80b70b70$var$location.protocol + "//" + $f9a22d5a80b70b70$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$f9a22d5a80b70b70$var$set || !$f9a22d5a80b70b70$var$clear) {
    $f9a22d5a80b70b70$var$set = function setImmediate(handler) {
        $f9a22d5a80b70b70$var$validateArgumentsLength(arguments.length, 1);
        var fn = $f9a22d5a80b70b70$var$isCallable$5(handler) ? handler : $f9a22d5a80b70b70$var$Function$1(handler);
        var args = $f9a22d5a80b70b70$var$arraySlice(arguments, 1);
        $f9a22d5a80b70b70$var$queue$1[++$f9a22d5a80b70b70$var$counter] = function() {
            $f9a22d5a80b70b70$var$apply$1(fn, undefined, args);
        };
        $f9a22d5a80b70b70$var$defer($f9a22d5a80b70b70$var$counter);
        return $f9a22d5a80b70b70$var$counter;
    };
    $f9a22d5a80b70b70$var$clear = function clearImmediate(id) {
        delete $f9a22d5a80b70b70$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($f9a22d5a80b70b70$var$IS_NODE$2) $f9a22d5a80b70b70$var$defer = function(id) {
        $f9a22d5a80b70b70$var$process$2.nextTick($f9a22d5a80b70b70$var$runner(id));
    };
    else if ($f9a22d5a80b70b70$var$Dispatch && $f9a22d5a80b70b70$var$Dispatch.now) $f9a22d5a80b70b70$var$defer = function(id) {
        $f9a22d5a80b70b70$var$Dispatch.now($f9a22d5a80b70b70$var$runner(id));
    };
    else if ($f9a22d5a80b70b70$var$MessageChannel && !$f9a22d5a80b70b70$var$IS_IOS$1) {
        $f9a22d5a80b70b70$var$channel = new $f9a22d5a80b70b70$var$MessageChannel();
        $f9a22d5a80b70b70$var$port = $f9a22d5a80b70b70$var$channel.port2;
        $f9a22d5a80b70b70$var$channel.port1.onmessage = $f9a22d5a80b70b70$var$listener;
        $f9a22d5a80b70b70$var$defer = $f9a22d5a80b70b70$var$bind$3($f9a22d5a80b70b70$var$port.postMessage, $f9a22d5a80b70b70$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($f9a22d5a80b70b70$var$global$b.addEventListener && $f9a22d5a80b70b70$var$isCallable$5($f9a22d5a80b70b70$var$global$b.postMessage) && !$f9a22d5a80b70b70$var$global$b.importScripts && $f9a22d5a80b70b70$var$location && $f9a22d5a80b70b70$var$location.protocol !== "file:" && !$f9a22d5a80b70b70$var$fails$5($f9a22d5a80b70b70$var$post)) {
        $f9a22d5a80b70b70$var$defer = $f9a22d5a80b70b70$var$post;
        $f9a22d5a80b70b70$var$global$b.addEventListener("message", $f9a22d5a80b70b70$var$listener, false);
    // IE8-
    } else if ($f9a22d5a80b70b70$var$ONREADYSTATECHANGE in $f9a22d5a80b70b70$var$createElement("script")) $f9a22d5a80b70b70$var$defer = function(id) {
        $f9a22d5a80b70b70$var$html.appendChild($f9a22d5a80b70b70$var$createElement("script"))[$f9a22d5a80b70b70$var$ONREADYSTATECHANGE] = function() {
            $f9a22d5a80b70b70$var$html.removeChild(this);
            $f9a22d5a80b70b70$var$run(id);
        };
    };
    else $f9a22d5a80b70b70$var$defer = function(id) {
        setTimeout($f9a22d5a80b70b70$var$runner(id), 0);
    };
}
var $f9a22d5a80b70b70$var$task$1 = {
    set: $f9a22d5a80b70b70$var$set,
    clear: $f9a22d5a80b70b70$var$clear
};
var $f9a22d5a80b70b70$var$userAgent$1 = $f9a22d5a80b70b70$var$engineUserAgent;
var $f9a22d5a80b70b70$var$global$a = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($f9a22d5a80b70b70$var$userAgent$1) && $f9a22d5a80b70b70$var$global$a.Pebble !== undefined;
var $f9a22d5a80b70b70$var$userAgent = $f9a22d5a80b70b70$var$engineUserAgent;
var $f9a22d5a80b70b70$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($f9a22d5a80b70b70$var$userAgent);
var $f9a22d5a80b70b70$var$global$9 = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$bind$2 = $f9a22d5a80b70b70$var$functionBindContext;
var $f9a22d5a80b70b70$var$getOwnPropertyDescriptor = $f9a22d5a80b70b70$var$objectGetOwnPropertyDescriptor.f;
var $f9a22d5a80b70b70$var$macrotask = $f9a22d5a80b70b70$var$task$1.set;
var $f9a22d5a80b70b70$var$IS_IOS = $f9a22d5a80b70b70$var$engineIsIos;
var $f9a22d5a80b70b70$var$IS_IOS_PEBBLE = $f9a22d5a80b70b70$var$engineIsIosPebble;
var $f9a22d5a80b70b70$var$IS_WEBOS_WEBKIT = $f9a22d5a80b70b70$var$engineIsWebosWebkit;
var $f9a22d5a80b70b70$var$IS_NODE$1 = $f9a22d5a80b70b70$var$engineIsNode;
var $f9a22d5a80b70b70$var$MutationObserver = $f9a22d5a80b70b70$var$global$9.MutationObserver || $f9a22d5a80b70b70$var$global$9.WebKitMutationObserver;
var $f9a22d5a80b70b70$var$document$2 = $f9a22d5a80b70b70$var$global$9.document;
var $f9a22d5a80b70b70$var$process$1 = $f9a22d5a80b70b70$var$global$9.process;
var $f9a22d5a80b70b70$var$Promise$1 = $f9a22d5a80b70b70$var$global$9.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $f9a22d5a80b70b70$var$queueMicrotaskDescriptor = $f9a22d5a80b70b70$var$getOwnPropertyDescriptor($f9a22d5a80b70b70$var$global$9, "queueMicrotask");
var $f9a22d5a80b70b70$var$queueMicrotask = $f9a22d5a80b70b70$var$queueMicrotaskDescriptor && $f9a22d5a80b70b70$var$queueMicrotaskDescriptor.value;
var $f9a22d5a80b70b70$var$flush, $f9a22d5a80b70b70$var$head, $f9a22d5a80b70b70$var$last, $f9a22d5a80b70b70$var$notify$1, $f9a22d5a80b70b70$var$toggle, $f9a22d5a80b70b70$var$node, $f9a22d5a80b70b70$var$promise, $f9a22d5a80b70b70$var$then;
// modern engines have queueMicrotask method
if (!$f9a22d5a80b70b70$var$queueMicrotask) {
    $f9a22d5a80b70b70$var$flush = function() {
        var parent, fn;
        if ($f9a22d5a80b70b70$var$IS_NODE$1 && (parent = $f9a22d5a80b70b70$var$process$1.domain)) parent.exit();
        while($f9a22d5a80b70b70$var$head){
            fn = $f9a22d5a80b70b70$var$head.fn;
            $f9a22d5a80b70b70$var$head = $f9a22d5a80b70b70$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($f9a22d5a80b70b70$var$head) $f9a22d5a80b70b70$var$notify$1();
                else $f9a22d5a80b70b70$var$last = undefined;
                throw error;
            }
        }
        $f9a22d5a80b70b70$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$f9a22d5a80b70b70$var$IS_IOS && !$f9a22d5a80b70b70$var$IS_NODE$1 && !$f9a22d5a80b70b70$var$IS_WEBOS_WEBKIT && $f9a22d5a80b70b70$var$MutationObserver && $f9a22d5a80b70b70$var$document$2) {
        $f9a22d5a80b70b70$var$toggle = true;
        $f9a22d5a80b70b70$var$node = $f9a22d5a80b70b70$var$document$2.createTextNode("");
        new $f9a22d5a80b70b70$var$MutationObserver($f9a22d5a80b70b70$var$flush).observe($f9a22d5a80b70b70$var$node, {
            characterData: true
        });
        $f9a22d5a80b70b70$var$notify$1 = function() {
            $f9a22d5a80b70b70$var$node.data = $f9a22d5a80b70b70$var$toggle = !$f9a22d5a80b70b70$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$f9a22d5a80b70b70$var$IS_IOS_PEBBLE && $f9a22d5a80b70b70$var$Promise$1 && $f9a22d5a80b70b70$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $f9a22d5a80b70b70$var$promise = $f9a22d5a80b70b70$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $f9a22d5a80b70b70$var$promise.constructor = $f9a22d5a80b70b70$var$Promise$1;
        $f9a22d5a80b70b70$var$then = $f9a22d5a80b70b70$var$bind$2($f9a22d5a80b70b70$var$promise.then, $f9a22d5a80b70b70$var$promise);
        $f9a22d5a80b70b70$var$notify$1 = function() {
            $f9a22d5a80b70b70$var$then($f9a22d5a80b70b70$var$flush);
        };
    // Node.js without promises
    } else if ($f9a22d5a80b70b70$var$IS_NODE$1) $f9a22d5a80b70b70$var$notify$1 = function() {
        $f9a22d5a80b70b70$var$process$1.nextTick($f9a22d5a80b70b70$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $f9a22d5a80b70b70$var$macrotask = $f9a22d5a80b70b70$var$bind$2($f9a22d5a80b70b70$var$macrotask, $f9a22d5a80b70b70$var$global$9);
        $f9a22d5a80b70b70$var$notify$1 = function() {
            $f9a22d5a80b70b70$var$macrotask($f9a22d5a80b70b70$var$flush);
        };
    }
}
var $f9a22d5a80b70b70$var$microtask$1 = $f9a22d5a80b70b70$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($f9a22d5a80b70b70$var$last) $f9a22d5a80b70b70$var$last.next = task;
    if (!$f9a22d5a80b70b70$var$head) {
        $f9a22d5a80b70b70$var$head = task;
        $f9a22d5a80b70b70$var$notify$1();
    }
    $f9a22d5a80b70b70$var$last = task;
};
var $f9a22d5a80b70b70$var$global$8 = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$hostReportErrors$1 = function(a, b) {
    var console = $f9a22d5a80b70b70$var$global$8.console;
    if (console && console.error) arguments.length == 1 ? console.error(a) : console.error(a, b);
};
var $f9a22d5a80b70b70$var$perform$3 = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $f9a22d5a80b70b70$var$Queue$1 = function() {
    this.head = null;
    this.tail = null;
};
$f9a22d5a80b70b70$var$Queue$1.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $f9a22d5a80b70b70$var$queue = $f9a22d5a80b70b70$var$Queue$1;
var $f9a22d5a80b70b70$var$global$7 = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$promiseNativeConstructor = $f9a22d5a80b70b70$var$global$7.Promise;
var $f9a22d5a80b70b70$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $f9a22d5a80b70b70$var$global$6 = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$NativePromiseConstructor$3 = $f9a22d5a80b70b70$var$promiseNativeConstructor;
var $f9a22d5a80b70b70$var$isCallable$4 = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$isForced = $f9a22d5a80b70b70$var$isForced_1;
var $f9a22d5a80b70b70$var$inspectSource = $f9a22d5a80b70b70$var$inspectSource$4;
var $f9a22d5a80b70b70$var$wellKnownSymbol$6 = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$IS_BROWSER = $f9a22d5a80b70b70$var$engineIsBrowser;
var $f9a22d5a80b70b70$var$V8_VERSION = $f9a22d5a80b70b70$var$engineV8Version;
$f9a22d5a80b70b70$var$NativePromiseConstructor$3 && $f9a22d5a80b70b70$var$NativePromiseConstructor$3.prototype;
var $f9a22d5a80b70b70$var$SPECIES$1 = $f9a22d5a80b70b70$var$wellKnownSymbol$6("species");
var $f9a22d5a80b70b70$var$SUBCLASSING = false;
var $f9a22d5a80b70b70$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $f9a22d5a80b70b70$var$isCallable$4($f9a22d5a80b70b70$var$global$6.PromiseRejectionEvent);
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$5 = $f9a22d5a80b70b70$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $f9a22d5a80b70b70$var$inspectSource($f9a22d5a80b70b70$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($f9a22d5a80b70b70$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $f9a22d5a80b70b70$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($f9a22d5a80b70b70$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $f9a22d5a80b70b70$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$f9a22d5a80b70b70$var$SPECIES$1] = FakePromise;
    $f9a22d5a80b70b70$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$f9a22d5a80b70b70$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $f9a22d5a80b70b70$var$IS_BROWSER && !$f9a22d5a80b70b70$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $f9a22d5a80b70b70$var$promiseConstructorDetection = {
    CONSTRUCTOR: $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $f9a22d5a80b70b70$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $f9a22d5a80b70b70$var$SUBCLASSING
};
var $f9a22d5a80b70b70$var$newPromiseCapability$2 = {};
var $f9a22d5a80b70b70$var$aCallable$4 = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $f9a22d5a80b70b70$var$aCallable$4(resolve);
    this.reject = $f9a22d5a80b70b70$var$aCallable$4(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$f9a22d5a80b70b70$var$newPromiseCapability$2.f = function(C) {
    return new $f9a22d5a80b70b70$var$PromiseCapability(C);
};
var $f9a22d5a80b70b70$var$$$6 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$IS_NODE = $f9a22d5a80b70b70$var$engineIsNode;
var $f9a22d5a80b70b70$var$global$5 = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$call$9 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$defineBuiltIn$2 = $f9a22d5a80b70b70$var$defineBuiltIn$7;
var $f9a22d5a80b70b70$var$setPrototypeOf = $f9a22d5a80b70b70$var$objectSetPrototypeOf;
var $f9a22d5a80b70b70$var$setToStringTag = $f9a22d5a80b70b70$var$setToStringTag$3;
var $f9a22d5a80b70b70$var$setSpecies = $f9a22d5a80b70b70$var$setSpecies$1;
var $f9a22d5a80b70b70$var$aCallable$3 = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$isCallable$3 = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$isObject$1 = $f9a22d5a80b70b70$var$isObject$7;
var $f9a22d5a80b70b70$var$anInstance = $f9a22d5a80b70b70$var$anInstance$1;
var $f9a22d5a80b70b70$var$speciesConstructor = $f9a22d5a80b70b70$var$speciesConstructor$1;
var $f9a22d5a80b70b70$var$task = $f9a22d5a80b70b70$var$task$1.set;
var $f9a22d5a80b70b70$var$microtask = $f9a22d5a80b70b70$var$microtask$1;
var $f9a22d5a80b70b70$var$hostReportErrors = $f9a22d5a80b70b70$var$hostReportErrors$1;
var $f9a22d5a80b70b70$var$perform$2 = $f9a22d5a80b70b70$var$perform$3;
var $f9a22d5a80b70b70$var$Queue = $f9a22d5a80b70b70$var$queue;
var $f9a22d5a80b70b70$var$InternalStateModule = $f9a22d5a80b70b70$var$internalState;
var $f9a22d5a80b70b70$var$NativePromiseConstructor$2 = $f9a22d5a80b70b70$var$promiseNativeConstructor;
var $f9a22d5a80b70b70$var$PromiseConstructorDetection = $f9a22d5a80b70b70$var$promiseConstructorDetection;
var $f9a22d5a80b70b70$var$newPromiseCapabilityModule$3 = $f9a22d5a80b70b70$var$newPromiseCapability$2;
var $f9a22d5a80b70b70$var$PROMISE = "Promise";
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$4 = $f9a22d5a80b70b70$var$PromiseConstructorDetection.CONSTRUCTOR;
var $f9a22d5a80b70b70$var$NATIVE_PROMISE_REJECTION_EVENT = $f9a22d5a80b70b70$var$PromiseConstructorDetection.REJECTION_EVENT;
var $f9a22d5a80b70b70$var$NATIVE_PROMISE_SUBCLASSING = $f9a22d5a80b70b70$var$PromiseConstructorDetection.SUBCLASSING;
var $f9a22d5a80b70b70$var$getInternalPromiseState = $f9a22d5a80b70b70$var$InternalStateModule.getterFor($f9a22d5a80b70b70$var$PROMISE);
var $f9a22d5a80b70b70$var$setInternalState = $f9a22d5a80b70b70$var$InternalStateModule.set;
var $f9a22d5a80b70b70$var$NativePromisePrototype$1 = $f9a22d5a80b70b70$var$NativePromiseConstructor$2 && $f9a22d5a80b70b70$var$NativePromiseConstructor$2.prototype;
var $f9a22d5a80b70b70$var$PromiseConstructor = $f9a22d5a80b70b70$var$NativePromiseConstructor$2;
var $f9a22d5a80b70b70$var$PromisePrototype = $f9a22d5a80b70b70$var$NativePromisePrototype$1;
var $f9a22d5a80b70b70$var$TypeError$1 = $f9a22d5a80b70b70$var$global$5.TypeError;
var $f9a22d5a80b70b70$var$document$1 = $f9a22d5a80b70b70$var$global$5.document;
var $f9a22d5a80b70b70$var$process = $f9a22d5a80b70b70$var$global$5.process;
var $f9a22d5a80b70b70$var$newPromiseCapability$1 = $f9a22d5a80b70b70$var$newPromiseCapabilityModule$3.f;
var $f9a22d5a80b70b70$var$newGenericPromiseCapability = $f9a22d5a80b70b70$var$newPromiseCapability$1;
var $f9a22d5a80b70b70$var$DISPATCH_EVENT = !!($f9a22d5a80b70b70$var$document$1 && $f9a22d5a80b70b70$var$document$1.createEvent && $f9a22d5a80b70b70$var$global$5.dispatchEvent);
var $f9a22d5a80b70b70$var$UNHANDLED_REJECTION = "unhandledrejection";
var $f9a22d5a80b70b70$var$REJECTION_HANDLED = "rejectionhandled";
var $f9a22d5a80b70b70$var$PENDING = 0;
var $f9a22d5a80b70b70$var$FULFILLED = 1;
var $f9a22d5a80b70b70$var$REJECTED = 2;
var $f9a22d5a80b70b70$var$HANDLED = 1;
var $f9a22d5a80b70b70$var$UNHANDLED = 2;
var $f9a22d5a80b70b70$var$Internal, $f9a22d5a80b70b70$var$OwnPromiseCapability, $f9a22d5a80b70b70$var$PromiseWrapper, $f9a22d5a80b70b70$var$nativeThen;
// helpers
var $f9a22d5a80b70b70$var$isThenable = function(it) {
    var then;
    return $f9a22d5a80b70b70$var$isObject$1(it) && $f9a22d5a80b70b70$var$isCallable$3(then = it.then) ? then : false;
};
var $f9a22d5a80b70b70$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $f9a22d5a80b70b70$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $f9a22d5a80b70b70$var$UNHANDLED) $f9a22d5a80b70b70$var$onHandleUnhandled(state);
                state.rejection = $f9a22d5a80b70b70$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($f9a22d5a80b70b70$var$TypeError$1("Promise-chain cycle"));
            else if (then = $f9a22d5a80b70b70$var$isThenable(result)) $f9a22d5a80b70b70$var$call$9(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $f9a22d5a80b70b70$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $f9a22d5a80b70b70$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$f9a22d5a80b70b70$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $f9a22d5a80b70b70$var$onUnhandled(state);
    });
};
var $f9a22d5a80b70b70$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($f9a22d5a80b70b70$var$DISPATCH_EVENT) {
        event = $f9a22d5a80b70b70$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $f9a22d5a80b70b70$var$global$5.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$f9a22d5a80b70b70$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $f9a22d5a80b70b70$var$global$5["on" + name])) handler(event);
    else if (name === $f9a22d5a80b70b70$var$UNHANDLED_REJECTION) $f9a22d5a80b70b70$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $f9a22d5a80b70b70$var$onUnhandled = function(state) {
    $f9a22d5a80b70b70$var$call$9($f9a22d5a80b70b70$var$task, $f9a22d5a80b70b70$var$global$5, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $f9a22d5a80b70b70$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $f9a22d5a80b70b70$var$perform$2(function() {
                if ($f9a22d5a80b70b70$var$IS_NODE) $f9a22d5a80b70b70$var$process.emit("unhandledRejection", value, promise);
                else $f9a22d5a80b70b70$var$dispatchEvent($f9a22d5a80b70b70$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $f9a22d5a80b70b70$var$IS_NODE || $f9a22d5a80b70b70$var$isUnhandled(state) ? $f9a22d5a80b70b70$var$UNHANDLED : $f9a22d5a80b70b70$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $f9a22d5a80b70b70$var$isUnhandled = function(state) {
    return state.rejection !== $f9a22d5a80b70b70$var$HANDLED && !state.parent;
};
var $f9a22d5a80b70b70$var$onHandleUnhandled = function(state) {
    $f9a22d5a80b70b70$var$call$9($f9a22d5a80b70b70$var$task, $f9a22d5a80b70b70$var$global$5, function() {
        var promise = state.facade;
        if ($f9a22d5a80b70b70$var$IS_NODE) $f9a22d5a80b70b70$var$process.emit("rejectionHandled", promise);
        else $f9a22d5a80b70b70$var$dispatchEvent($f9a22d5a80b70b70$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $f9a22d5a80b70b70$var$bind$1 = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $f9a22d5a80b70b70$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $f9a22d5a80b70b70$var$REJECTED;
    $f9a22d5a80b70b70$var$notify(state, true);
};
var $f9a22d5a80b70b70$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $f9a22d5a80b70b70$var$TypeError$1("Promise can't be resolved itself");
        var then = $f9a22d5a80b70b70$var$isThenable(value);
        if (then) $f9a22d5a80b70b70$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $f9a22d5a80b70b70$var$call$9(then, value, $f9a22d5a80b70b70$var$bind$1($f9a22d5a80b70b70$var$internalResolve, wrapper, state), $f9a22d5a80b70b70$var$bind$1($f9a22d5a80b70b70$var$internalReject, wrapper, state));
            } catch (error) {
                $f9a22d5a80b70b70$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $f9a22d5a80b70b70$var$FULFILLED;
            $f9a22d5a80b70b70$var$notify(state, false);
        }
    } catch (error) {
        $f9a22d5a80b70b70$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $f9a22d5a80b70b70$var$PromiseConstructor = function Promise1(executor) {
        $f9a22d5a80b70b70$var$anInstance(this, $f9a22d5a80b70b70$var$PromisePrototype);
        $f9a22d5a80b70b70$var$aCallable$3(executor);
        $f9a22d5a80b70b70$var$call$9($f9a22d5a80b70b70$var$Internal, this);
        var state = $f9a22d5a80b70b70$var$getInternalPromiseState(this);
        try {
            executor($f9a22d5a80b70b70$var$bind$1($f9a22d5a80b70b70$var$internalResolve, state), $f9a22d5a80b70b70$var$bind$1($f9a22d5a80b70b70$var$internalReject, state));
        } catch (error) {
            $f9a22d5a80b70b70$var$internalReject(state, error);
        }
    };
    $f9a22d5a80b70b70$var$PromisePrototype = $f9a22d5a80b70b70$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $f9a22d5a80b70b70$var$Internal = function Promise1(executor) {
        $f9a22d5a80b70b70$var$setInternalState(this, {
            type: $f9a22d5a80b70b70$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $f9a22d5a80b70b70$var$Queue(),
            rejection: false,
            state: $f9a22d5a80b70b70$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $f9a22d5a80b70b70$var$Internal.prototype = $f9a22d5a80b70b70$var$defineBuiltIn$2($f9a22d5a80b70b70$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $f9a22d5a80b70b70$var$getInternalPromiseState(this);
        var reaction = $f9a22d5a80b70b70$var$newPromiseCapability$1($f9a22d5a80b70b70$var$speciesConstructor(this, $f9a22d5a80b70b70$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $f9a22d5a80b70b70$var$isCallable$3(onFulfilled) ? onFulfilled : true;
        reaction.fail = $f9a22d5a80b70b70$var$isCallable$3(onRejected) && onRejected;
        reaction.domain = $f9a22d5a80b70b70$var$IS_NODE ? $f9a22d5a80b70b70$var$process.domain : undefined;
        if (state.state == $f9a22d5a80b70b70$var$PENDING) state.reactions.add(reaction);
        else $f9a22d5a80b70b70$var$microtask(function() {
            $f9a22d5a80b70b70$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $f9a22d5a80b70b70$var$OwnPromiseCapability = function() {
        var promise = new $f9a22d5a80b70b70$var$Internal();
        var state = $f9a22d5a80b70b70$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $f9a22d5a80b70b70$var$bind$1($f9a22d5a80b70b70$var$internalResolve, state);
        this.reject = $f9a22d5a80b70b70$var$bind$1($f9a22d5a80b70b70$var$internalReject, state);
    };
    $f9a22d5a80b70b70$var$newPromiseCapabilityModule$3.f = $f9a22d5a80b70b70$var$newPromiseCapability$1 = function(C) {
        return C === $f9a22d5a80b70b70$var$PromiseConstructor || C === $f9a22d5a80b70b70$var$PromiseWrapper ? new $f9a22d5a80b70b70$var$OwnPromiseCapability(C) : $f9a22d5a80b70b70$var$newGenericPromiseCapability(C);
    };
    if ($f9a22d5a80b70b70$var$isCallable$3($f9a22d5a80b70b70$var$NativePromiseConstructor$2) && $f9a22d5a80b70b70$var$NativePromisePrototype$1 !== Object.prototype) {
        $f9a22d5a80b70b70$var$nativeThen = $f9a22d5a80b70b70$var$NativePromisePrototype$1.then;
        if (!$f9a22d5a80b70b70$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $f9a22d5a80b70b70$var$defineBuiltIn$2($f9a22d5a80b70b70$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $f9a22d5a80b70b70$var$PromiseConstructor(function(resolve, reject) {
                $f9a22d5a80b70b70$var$call$9($f9a22d5a80b70b70$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $f9a22d5a80b70b70$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($f9a22d5a80b70b70$var$setPrototypeOf) $f9a22d5a80b70b70$var$setPrototypeOf($f9a22d5a80b70b70$var$NativePromisePrototype$1, $f9a22d5a80b70b70$var$PromisePrototype);
    }
}
$f9a22d5a80b70b70$var$$$6({
    global: true,
    constructor: true,
    wrap: true,
    forced: $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $f9a22d5a80b70b70$var$PromiseConstructor
});
$f9a22d5a80b70b70$var$setToStringTag($f9a22d5a80b70b70$var$PromiseConstructor, $f9a22d5a80b70b70$var$PROMISE, false);
$f9a22d5a80b70b70$var$setSpecies($f9a22d5a80b70b70$var$PROMISE);
var $f9a22d5a80b70b70$var$wellKnownSymbol$5 = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$Iterators$1 = $f9a22d5a80b70b70$var$iterators;
var $f9a22d5a80b70b70$var$ITERATOR$3 = $f9a22d5a80b70b70$var$wellKnownSymbol$5("iterator");
var $f9a22d5a80b70b70$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
var $f9a22d5a80b70b70$var$isArrayIteratorMethod$1 = function(it) {
    return it !== undefined && ($f9a22d5a80b70b70$var$Iterators$1.Array === it || $f9a22d5a80b70b70$var$ArrayPrototype[$f9a22d5a80b70b70$var$ITERATOR$3] === it);
};
var $f9a22d5a80b70b70$var$classof$1 = $f9a22d5a80b70b70$var$classof$5;
var $f9a22d5a80b70b70$var$getMethod$2 = $f9a22d5a80b70b70$var$getMethod$4;
var $f9a22d5a80b70b70$var$Iterators = $f9a22d5a80b70b70$var$iterators;
var $f9a22d5a80b70b70$var$wellKnownSymbol$4 = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$ITERATOR$2 = $f9a22d5a80b70b70$var$wellKnownSymbol$4("iterator");
var $f9a22d5a80b70b70$var$getIteratorMethod$2 = function(it) {
    if (it != undefined) return $f9a22d5a80b70b70$var$getMethod$2(it, $f9a22d5a80b70b70$var$ITERATOR$2) || $f9a22d5a80b70b70$var$getMethod$2(it, "@@iterator") || $f9a22d5a80b70b70$var$Iterators[$f9a22d5a80b70b70$var$classof$1(it)];
};
var $f9a22d5a80b70b70$var$call$8 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$aCallable$2 = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$anObject$5 = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$tryToString$1 = $f9a22d5a80b70b70$var$tryToString$4;
var $f9a22d5a80b70b70$var$getIteratorMethod$1 = $f9a22d5a80b70b70$var$getIteratorMethod$2;
var $f9a22d5a80b70b70$var$$TypeError$2 = TypeError;
var $f9a22d5a80b70b70$var$getIterator$1 = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $f9a22d5a80b70b70$var$getIteratorMethod$1(argument) : usingIterator;
    if ($f9a22d5a80b70b70$var$aCallable$2(iteratorMethod)) return $f9a22d5a80b70b70$var$anObject$5($f9a22d5a80b70b70$var$call$8(iteratorMethod, argument));
    throw $f9a22d5a80b70b70$var$$TypeError$2($f9a22d5a80b70b70$var$tryToString$1(argument) + " is not iterable");
};
var $f9a22d5a80b70b70$var$call$7 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$anObject$4 = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$getMethod$1 = $f9a22d5a80b70b70$var$getMethod$4;
var $f9a22d5a80b70b70$var$iteratorClose$1 = function(iterator, kind, value) {
    var innerResult, innerError;
    $f9a22d5a80b70b70$var$anObject$4(iterator);
    try {
        innerResult = $f9a22d5a80b70b70$var$getMethod$1(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $f9a22d5a80b70b70$var$call$7(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $f9a22d5a80b70b70$var$anObject$4(innerResult);
    return value;
};
var $f9a22d5a80b70b70$var$bind = $f9a22d5a80b70b70$var$functionBindContext;
var $f9a22d5a80b70b70$var$call$6 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$anObject$3 = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$tryToString = $f9a22d5a80b70b70$var$tryToString$4;
var $f9a22d5a80b70b70$var$isArrayIteratorMethod = $f9a22d5a80b70b70$var$isArrayIteratorMethod$1;
var $f9a22d5a80b70b70$var$lengthOfArrayLike = $f9a22d5a80b70b70$var$lengthOfArrayLike$2;
var $f9a22d5a80b70b70$var$isPrototypeOf = $f9a22d5a80b70b70$var$objectIsPrototypeOf;
var $f9a22d5a80b70b70$var$getIterator = $f9a22d5a80b70b70$var$getIterator$1;
var $f9a22d5a80b70b70$var$getIteratorMethod = $f9a22d5a80b70b70$var$getIteratorMethod$2;
var $f9a22d5a80b70b70$var$iteratorClose = $f9a22d5a80b70b70$var$iteratorClose$1;
var $f9a22d5a80b70b70$var$$TypeError$1 = TypeError;
var $f9a22d5a80b70b70$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $f9a22d5a80b70b70$var$ResultPrototype = $f9a22d5a80b70b70$var$Result.prototype;
var $f9a22d5a80b70b70$var$iterate$2 = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $f9a22d5a80b70b70$var$bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $f9a22d5a80b70b70$var$iteratorClose(iterator, "normal", condition);
        return new $f9a22d5a80b70b70$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $f9a22d5a80b70b70$var$anObject$3(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $f9a22d5a80b70b70$var$getIteratorMethod(iterable);
        if (!iterFn) throw $f9a22d5a80b70b70$var$$TypeError$1($f9a22d5a80b70b70$var$tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($f9a22d5a80b70b70$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = $f9a22d5a80b70b70$var$lengthOfArrayLike(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $f9a22d5a80b70b70$var$isPrototypeOf($f9a22d5a80b70b70$var$ResultPrototype, result)) return result;
            }
            return new $f9a22d5a80b70b70$var$Result(false);
        }
        iterator = $f9a22d5a80b70b70$var$getIterator(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $f9a22d5a80b70b70$var$call$6(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $f9a22d5a80b70b70$var$iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $f9a22d5a80b70b70$var$isPrototypeOf($f9a22d5a80b70b70$var$ResultPrototype, result)) return result;
    }
    return new $f9a22d5a80b70b70$var$Result(false);
};
var $f9a22d5a80b70b70$var$wellKnownSymbol$3 = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$ITERATOR$1 = $f9a22d5a80b70b70$var$wellKnownSymbol$3("iterator");
var $f9a22d5a80b70b70$var$SAFE_CLOSING = false;
try {
    var $f9a22d5a80b70b70$var$called = 0;
    var $f9a22d5a80b70b70$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$f9a22d5a80b70b70$var$called++
            };
        },
        "return": function() {
            $f9a22d5a80b70b70$var$SAFE_CLOSING = true;
        }
    };
    $f9a22d5a80b70b70$var$iteratorWithReturn[$f9a22d5a80b70b70$var$ITERATOR$1] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($f9a22d5a80b70b70$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $f9a22d5a80b70b70$var$checkCorrectnessOfIteration$1 = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$f9a22d5a80b70b70$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$f9a22d5a80b70b70$var$ITERATOR$1] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $f9a22d5a80b70b70$var$NativePromiseConstructor$1 = $f9a22d5a80b70b70$var$promiseNativeConstructor;
var $f9a22d5a80b70b70$var$checkCorrectnessOfIteration = $f9a22d5a80b70b70$var$checkCorrectnessOfIteration$1;
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$3 = $f9a22d5a80b70b70$var$promiseConstructorDetection.CONSTRUCTOR;
var $f9a22d5a80b70b70$var$promiseStaticsIncorrectIteration = $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$f9a22d5a80b70b70$var$checkCorrectnessOfIteration(function(iterable) {
    $f9a22d5a80b70b70$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $f9a22d5a80b70b70$var$$$5 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$call$5 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$aCallable$1 = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$newPromiseCapabilityModule$2 = $f9a22d5a80b70b70$var$newPromiseCapability$2;
var $f9a22d5a80b70b70$var$perform$1 = $f9a22d5a80b70b70$var$perform$3;
var $f9a22d5a80b70b70$var$iterate$1 = $f9a22d5a80b70b70$var$iterate$2;
var $f9a22d5a80b70b70$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $f9a22d5a80b70b70$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$f9a22d5a80b70b70$var$$$5({
    target: "Promise",
    stat: true,
    forced: $f9a22d5a80b70b70$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $f9a22d5a80b70b70$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $f9a22d5a80b70b70$var$perform$1(function() {
            var $promiseResolve = $f9a22d5a80b70b70$var$aCallable$1(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $f9a22d5a80b70b70$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $f9a22d5a80b70b70$var$call$5($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $f9a22d5a80b70b70$var$$$4 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$2 = $f9a22d5a80b70b70$var$promiseConstructorDetection.CONSTRUCTOR;
var $f9a22d5a80b70b70$var$NativePromiseConstructor = $f9a22d5a80b70b70$var$promiseNativeConstructor;
var $f9a22d5a80b70b70$var$getBuiltIn$1 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$isCallable$2 = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$defineBuiltIn$1 = $f9a22d5a80b70b70$var$defineBuiltIn$7;
var $f9a22d5a80b70b70$var$NativePromisePrototype = $f9a22d5a80b70b70$var$NativePromiseConstructor && $f9a22d5a80b70b70$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$f9a22d5a80b70b70$var$$$4({
    target: "Promise",
    proto: true,
    forced: $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($f9a22d5a80b70b70$var$isCallable$2($f9a22d5a80b70b70$var$NativePromiseConstructor)) {
    var $f9a22d5a80b70b70$var$method = $f9a22d5a80b70b70$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($f9a22d5a80b70b70$var$NativePromisePrototype["catch"] !== $f9a22d5a80b70b70$var$method) $f9a22d5a80b70b70$var$defineBuiltIn$1($f9a22d5a80b70b70$var$NativePromisePrototype, "catch", $f9a22d5a80b70b70$var$method, {
        unsafe: true
    });
}
var $f9a22d5a80b70b70$var$$$3 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$call$4 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$aCallable = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$newPromiseCapabilityModule$1 = $f9a22d5a80b70b70$var$newPromiseCapability$2;
var $f9a22d5a80b70b70$var$perform = $f9a22d5a80b70b70$var$perform$3;
var $f9a22d5a80b70b70$var$iterate = $f9a22d5a80b70b70$var$iterate$2;
var $f9a22d5a80b70b70$var$PROMISE_STATICS_INCORRECT_ITERATION = $f9a22d5a80b70b70$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$f9a22d5a80b70b70$var$$$3({
    target: "Promise",
    stat: true,
    forced: $f9a22d5a80b70b70$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $f9a22d5a80b70b70$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $f9a22d5a80b70b70$var$perform(function() {
            var $promiseResolve = $f9a22d5a80b70b70$var$aCallable(C.resolve);
            $f9a22d5a80b70b70$var$iterate(iterable, function(promise) {
                $f9a22d5a80b70b70$var$call$4($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $f9a22d5a80b70b70$var$$$2 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$call$3 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$newPromiseCapabilityModule = $f9a22d5a80b70b70$var$newPromiseCapability$2;
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$1 = $f9a22d5a80b70b70$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$f9a22d5a80b70b70$var$$$2({
    target: "Promise",
    stat: true,
    forced: $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $f9a22d5a80b70b70$var$newPromiseCapabilityModule.f(this);
        $f9a22d5a80b70b70$var$call$3(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $f9a22d5a80b70b70$var$anObject$2 = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$isObject = $f9a22d5a80b70b70$var$isObject$7;
var $f9a22d5a80b70b70$var$newPromiseCapability = $f9a22d5a80b70b70$var$newPromiseCapability$2;
var $f9a22d5a80b70b70$var$promiseResolve$1 = function(C, x) {
    $f9a22d5a80b70b70$var$anObject$2(C);
    if ($f9a22d5a80b70b70$var$isObject(x) && x.constructor === C) return x;
    var promiseCapability = $f9a22d5a80b70b70$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $f9a22d5a80b70b70$var$$$1 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$getBuiltIn = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR = $f9a22d5a80b70b70$var$promiseConstructorDetection.CONSTRUCTOR;
var $f9a22d5a80b70b70$var$promiseResolve = $f9a22d5a80b70b70$var$promiseResolve$1;
$f9a22d5a80b70b70$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$f9a22d5a80b70b70$var$$$1({
    target: "Promise",
    stat: true,
    forced: $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $f9a22d5a80b70b70$var$promiseResolve(this, x);
    }
});
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $f9a22d5a80b70b70$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $f9a22d5a80b70b70$var$documentCreateElement = $f9a22d5a80b70b70$var$documentCreateElement$2;
var $f9a22d5a80b70b70$var$classList = $f9a22d5a80b70b70$var$documentCreateElement("span").classList;
var $f9a22d5a80b70b70$var$DOMTokenListPrototype$1 = $f9a22d5a80b70b70$var$classList && $f9a22d5a80b70b70$var$classList.constructor && $f9a22d5a80b70b70$var$classList.constructor.prototype;
var $f9a22d5a80b70b70$var$domTokenListPrototype = $f9a22d5a80b70b70$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $f9a22d5a80b70b70$var$DOMTokenListPrototype$1;
var $f9a22d5a80b70b70$var$global$4 = $f9a22d5a80b70b70$var$global$m;
var $f9a22d5a80b70b70$var$DOMIterables = $f9a22d5a80b70b70$var$domIterables;
var $f9a22d5a80b70b70$var$DOMTokenListPrototype = $f9a22d5a80b70b70$var$domTokenListPrototype;
var $f9a22d5a80b70b70$var$ArrayIteratorMethods = $f9a22d5a80b70b70$var$es_array_iterator;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty$1 = $f9a22d5a80b70b70$var$createNonEnumerableProperty$5;
var $f9a22d5a80b70b70$var$wellKnownSymbol$2 = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$ITERATOR = $f9a22d5a80b70b70$var$wellKnownSymbol$2("iterator");
var $f9a22d5a80b70b70$var$TO_STRING_TAG = $f9a22d5a80b70b70$var$wellKnownSymbol$2("toStringTag");
var $f9a22d5a80b70b70$var$ArrayValues = $f9a22d5a80b70b70$var$ArrayIteratorMethods.values;
var $f9a22d5a80b70b70$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$f9a22d5a80b70b70$var$ITERATOR] !== $f9a22d5a80b70b70$var$ArrayValues) try {
            $f9a22d5a80b70b70$var$createNonEnumerableProperty$1(CollectionPrototype, $f9a22d5a80b70b70$var$ITERATOR, $f9a22d5a80b70b70$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$f9a22d5a80b70b70$var$ITERATOR] = $f9a22d5a80b70b70$var$ArrayValues;
        }
        if (!CollectionPrototype[$f9a22d5a80b70b70$var$TO_STRING_TAG]) $f9a22d5a80b70b70$var$createNonEnumerableProperty$1(CollectionPrototype, $f9a22d5a80b70b70$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($f9a22d5a80b70b70$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $f9a22d5a80b70b70$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $f9a22d5a80b70b70$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $f9a22d5a80b70b70$var$createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, $f9a22d5a80b70b70$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $f9a22d5a80b70b70$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $f9a22d5a80b70b70$var$COLLECTION_NAME in $f9a22d5a80b70b70$var$DOMIterables)$f9a22d5a80b70b70$var$handlePrototype($f9a22d5a80b70b70$var$global$4[$f9a22d5a80b70b70$var$COLLECTION_NAME] && $f9a22d5a80b70b70$var$global$4[$f9a22d5a80b70b70$var$COLLECTION_NAME].prototype, $f9a22d5a80b70b70$var$COLLECTION_NAME);
$f9a22d5a80b70b70$var$handlePrototype($f9a22d5a80b70b70$var$DOMTokenListPrototype, "DOMTokenList");
var $f9a22d5a80b70b70$var$fails$4 = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$global$3 = $f9a22d5a80b70b70$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $f9a22d5a80b70b70$var$$RegExp$2 = $f9a22d5a80b70b70$var$global$3.RegExp;
var $f9a22d5a80b70b70$var$UNSUPPORTED_Y$1 = $f9a22d5a80b70b70$var$fails$4(function() {
    var re = $f9a22d5a80b70b70$var$$RegExp$2("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $f9a22d5a80b70b70$var$MISSED_STICKY = $f9a22d5a80b70b70$var$UNSUPPORTED_Y$1 || $f9a22d5a80b70b70$var$fails$4(function() {
    return !$f9a22d5a80b70b70$var$$RegExp$2("a", "y").sticky;
});
var $f9a22d5a80b70b70$var$BROKEN_CARET = $f9a22d5a80b70b70$var$UNSUPPORTED_Y$1 || $f9a22d5a80b70b70$var$fails$4(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $f9a22d5a80b70b70$var$$RegExp$2("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});
var $f9a22d5a80b70b70$var$regexpStickyHelpers = {
    BROKEN_CARET: $f9a22d5a80b70b70$var$BROKEN_CARET,
    MISSED_STICKY: $f9a22d5a80b70b70$var$MISSED_STICKY,
    UNSUPPORTED_Y: $f9a22d5a80b70b70$var$UNSUPPORTED_Y$1
};
var $f9a22d5a80b70b70$var$fails$3 = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$global$2 = $f9a22d5a80b70b70$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $f9a22d5a80b70b70$var$$RegExp$1 = $f9a22d5a80b70b70$var$global$2.RegExp;
var $f9a22d5a80b70b70$var$regexpUnsupportedDotAll = $f9a22d5a80b70b70$var$fails$3(function() {
    var re = $f9a22d5a80b70b70$var$$RegExp$1(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});
var $f9a22d5a80b70b70$var$fails$2 = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$global$1 = $f9a22d5a80b70b70$var$global$m;
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $f9a22d5a80b70b70$var$$RegExp = $f9a22d5a80b70b70$var$global$1.RegExp;
var $f9a22d5a80b70b70$var$regexpUnsupportedNcg = $f9a22d5a80b70b70$var$fails$2(function() {
    var re = $f9a22d5a80b70b70$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var $f9a22d5a80b70b70$var$call$2 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$uncurryThis$4 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$toString$2 = $f9a22d5a80b70b70$var$toString$3;
var $f9a22d5a80b70b70$var$regexpFlags = $f9a22d5a80b70b70$var$regexpFlags$1;
var $f9a22d5a80b70b70$var$stickyHelpers = $f9a22d5a80b70b70$var$regexpStickyHelpers;
var $f9a22d5a80b70b70$var$shared = $f9a22d5a80b70b70$var$shared$4.exports;
var $f9a22d5a80b70b70$var$create = $f9a22d5a80b70b70$var$objectCreate;
var $f9a22d5a80b70b70$var$getInternalState = $f9a22d5a80b70b70$var$internalState.get;
var $f9a22d5a80b70b70$var$UNSUPPORTED_DOT_ALL = $f9a22d5a80b70b70$var$regexpUnsupportedDotAll;
var $f9a22d5a80b70b70$var$UNSUPPORTED_NCG = $f9a22d5a80b70b70$var$regexpUnsupportedNcg;
var $f9a22d5a80b70b70$var$nativeReplace = $f9a22d5a80b70b70$var$shared("native-string-replace", String.prototype.replace);
var $f9a22d5a80b70b70$var$nativeExec = RegExp.prototype.exec;
var $f9a22d5a80b70b70$var$patchedExec = $f9a22d5a80b70b70$var$nativeExec;
var $f9a22d5a80b70b70$var$charAt$3 = $f9a22d5a80b70b70$var$uncurryThis$4("".charAt);
var $f9a22d5a80b70b70$var$indexOf = $f9a22d5a80b70b70$var$uncurryThis$4("".indexOf);
var $f9a22d5a80b70b70$var$replace$1 = $f9a22d5a80b70b70$var$uncurryThis$4("".replace);
var $f9a22d5a80b70b70$var$stringSlice$3 = $f9a22d5a80b70b70$var$uncurryThis$4("".slice);
var $f9a22d5a80b70b70$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$nativeExec, re1, "a");
    $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $f9a22d5a80b70b70$var$UNSUPPORTED_Y = $f9a22d5a80b70b70$var$stickyHelpers.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $f9a22d5a80b70b70$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $f9a22d5a80b70b70$var$PATCH = $f9a22d5a80b70b70$var$UPDATES_LAST_INDEX_WRONG || $f9a22d5a80b70b70$var$NPCG_INCLUDED || $f9a22d5a80b70b70$var$UNSUPPORTED_Y || $f9a22d5a80b70b70$var$UNSUPPORTED_DOT_ALL || $f9a22d5a80b70b70$var$UNSUPPORTED_NCG;
if ($f9a22d5a80b70b70$var$PATCH) $f9a22d5a80b70b70$var$patchedExec = function exec(string) {
    var re = this;
    var state = $f9a22d5a80b70b70$var$getInternalState(re);
    var str = $f9a22d5a80b70b70$var$toString$2(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $f9a22d5a80b70b70$var$UNSUPPORTED_Y && re.sticky;
    var flags = $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $f9a22d5a80b70b70$var$replace$1(flags, "y", "");
        if ($f9a22d5a80b70b70$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $f9a22d5a80b70b70$var$stringSlice$3(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $f9a22d5a80b70b70$var$charAt$3(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($f9a22d5a80b70b70$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($f9a22d5a80b70b70$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $f9a22d5a80b70b70$var$stringSlice$3(match.input, charsAdded);
            match[0] = $f9a22d5a80b70b70$var$stringSlice$3(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($f9a22d5a80b70b70$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($f9a22d5a80b70b70$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $f9a22d5a80b70b70$var$create(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
var $f9a22d5a80b70b70$var$regexpExec$2 = $f9a22d5a80b70b70$var$patchedExec;
var $f9a22d5a80b70b70$var$$ = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$exec = $f9a22d5a80b70b70$var$regexpExec$2;
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$f9a22d5a80b70b70$var$$({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $f9a22d5a80b70b70$var$exec
}, {
    exec: $f9a22d5a80b70b70$var$exec
});
// TODO: Remove from `core-js@4` since it's moved to entry points
var $f9a22d5a80b70b70$var$uncurryThis$3 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$defineBuiltIn = $f9a22d5a80b70b70$var$defineBuiltIn$7;
var $f9a22d5a80b70b70$var$regexpExec$1 = $f9a22d5a80b70b70$var$regexpExec$2;
var $f9a22d5a80b70b70$var$fails$1 = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$wellKnownSymbol$1 = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty = $f9a22d5a80b70b70$var$createNonEnumerableProperty$5;
var $f9a22d5a80b70b70$var$SPECIES = $f9a22d5a80b70b70$var$wellKnownSymbol$1("species");
var $f9a22d5a80b70b70$var$RegExpPrototype = RegExp.prototype;
var $f9a22d5a80b70b70$var$fixRegexpWellKnownSymbolLogic = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $f9a22d5a80b70b70$var$wellKnownSymbol$1(KEY);
    var DELEGATES_TO_SYMBOL = !$f9a22d5a80b70b70$var$fails$1(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$f9a22d5a80b70b70$var$fails$1(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$f9a22d5a80b70b70$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $f9a22d5a80b70b70$var$uncurryThis$3(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $f9a22d5a80b70b70$var$uncurryThis$3(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $f9a22d5a80b70b70$var$regexpExec$1 || $exec === $f9a22d5a80b70b70$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $f9a22d5a80b70b70$var$defineBuiltIn(String.prototype, KEY, methods[0]);
        $f9a22d5a80b70b70$var$defineBuiltIn($f9a22d5a80b70b70$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $f9a22d5a80b70b70$var$createNonEnumerableProperty($f9a22d5a80b70b70$var$RegExpPrototype[SYMBOL], "sham", true);
};
var $f9a22d5a80b70b70$var$uncurryThis$2 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$toIntegerOrInfinity$1 = $f9a22d5a80b70b70$var$toIntegerOrInfinity$4;
var $f9a22d5a80b70b70$var$toString$1 = $f9a22d5a80b70b70$var$toString$3;
var $f9a22d5a80b70b70$var$requireObjectCoercible$1 = $f9a22d5a80b70b70$var$requireObjectCoercible$4;
var $f9a22d5a80b70b70$var$charAt$2 = $f9a22d5a80b70b70$var$uncurryThis$2("".charAt);
var $f9a22d5a80b70b70$var$charCodeAt = $f9a22d5a80b70b70$var$uncurryThis$2("".charCodeAt);
var $f9a22d5a80b70b70$var$stringSlice$2 = $f9a22d5a80b70b70$var$uncurryThis$2("".slice);
var $f9a22d5a80b70b70$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $f9a22d5a80b70b70$var$toString$1($f9a22d5a80b70b70$var$requireObjectCoercible$1($this));
        var position = $f9a22d5a80b70b70$var$toIntegerOrInfinity$1(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $f9a22d5a80b70b70$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $f9a22d5a80b70b70$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $f9a22d5a80b70b70$var$charAt$2(S, position) : first : CONVERT_TO_STRING ? $f9a22d5a80b70b70$var$stringSlice$2(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
var $f9a22d5a80b70b70$var$stringMultibyte = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $f9a22d5a80b70b70$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $f9a22d5a80b70b70$var$createMethod(true)
};
var $f9a22d5a80b70b70$var$charAt$1 = $f9a22d5a80b70b70$var$stringMultibyte.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var $f9a22d5a80b70b70$var$advanceStringIndex$1 = function(S, index, unicode) {
    return index + (unicode ? $f9a22d5a80b70b70$var$charAt$1(S, index).length : 1);
};
var $f9a22d5a80b70b70$var$uncurryThis$1 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$toObject = $f9a22d5a80b70b70$var$toObject$4;
var $f9a22d5a80b70b70$var$floor = Math.floor;
var $f9a22d5a80b70b70$var$charAt = $f9a22d5a80b70b70$var$uncurryThis$1("".charAt);
var $f9a22d5a80b70b70$var$replace = $f9a22d5a80b70b70$var$uncurryThis$1("".replace);
var $f9a22d5a80b70b70$var$stringSlice$1 = $f9a22d5a80b70b70$var$uncurryThis$1("".slice);
var $f9a22d5a80b70b70$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $f9a22d5a80b70b70$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var $f9a22d5a80b70b70$var$getSubstitution$1 = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $f9a22d5a80b70b70$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $f9a22d5a80b70b70$var$toObject(namedCaptures);
        symbols = $f9a22d5a80b70b70$var$SUBSTITUTION_SYMBOLS;
    }
    return $f9a22d5a80b70b70$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($f9a22d5a80b70b70$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $f9a22d5a80b70b70$var$stringSlice$1(str, 0, position);
            case "'":
                return $f9a22d5a80b70b70$var$stringSlice$1(str, tailPos);
            case "<":
                capture = namedCaptures[$f9a22d5a80b70b70$var$stringSlice$1(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $f9a22d5a80b70b70$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $f9a22d5a80b70b70$var$charAt(ch, 1) : captures[f - 1] + $f9a22d5a80b70b70$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};
var $f9a22d5a80b70b70$var$call$1 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$anObject$1 = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$isCallable$1 = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$classof = $f9a22d5a80b70b70$var$classofRaw$1;
var $f9a22d5a80b70b70$var$regexpExec = $f9a22d5a80b70b70$var$regexpExec$2;
var $f9a22d5a80b70b70$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var $f9a22d5a80b70b70$var$regexpExecAbstract = function(R, S) {
    var exec = R.exec;
    if ($f9a22d5a80b70b70$var$isCallable$1(exec)) {
        var result = $f9a22d5a80b70b70$var$call$1(exec, R, S);
        if (result !== null) $f9a22d5a80b70b70$var$anObject$1(result);
        return result;
    }
    if ($f9a22d5a80b70b70$var$classof(R) === "RegExp") return $f9a22d5a80b70b70$var$call$1($f9a22d5a80b70b70$var$regexpExec, R, S);
    throw $f9a22d5a80b70b70$var$$TypeError("RegExp#exec called on incompatible receiver");
};
var $f9a22d5a80b70b70$var$apply = $f9a22d5a80b70b70$var$functionApply;
var $f9a22d5a80b70b70$var$call = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$uncurryThis = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$fixRegExpWellKnownSymbolLogic = $f9a22d5a80b70b70$var$fixRegexpWellKnownSymbolLogic;
var $f9a22d5a80b70b70$var$fails = $f9a22d5a80b70b70$var$fails$j;
var $f9a22d5a80b70b70$var$anObject = $f9a22d5a80b70b70$var$anObject$e;
var $f9a22d5a80b70b70$var$isCallable = $f9a22d5a80b70b70$var$isCallable$m;
var $f9a22d5a80b70b70$var$toIntegerOrInfinity = $f9a22d5a80b70b70$var$toIntegerOrInfinity$4;
var $f9a22d5a80b70b70$var$toLength = $f9a22d5a80b70b70$var$toLength$2;
var $f9a22d5a80b70b70$var$toString = $f9a22d5a80b70b70$var$toString$3;
var $f9a22d5a80b70b70$var$requireObjectCoercible = $f9a22d5a80b70b70$var$requireObjectCoercible$4;
var $f9a22d5a80b70b70$var$advanceStringIndex = $f9a22d5a80b70b70$var$advanceStringIndex$1;
var $f9a22d5a80b70b70$var$getMethod = $f9a22d5a80b70b70$var$getMethod$4;
var $f9a22d5a80b70b70$var$getSubstitution = $f9a22d5a80b70b70$var$getSubstitution$1;
var $f9a22d5a80b70b70$var$regExpExec = $f9a22d5a80b70b70$var$regexpExecAbstract;
var $f9a22d5a80b70b70$var$wellKnownSymbol = $f9a22d5a80b70b70$var$wellKnownSymbol$g;
var $f9a22d5a80b70b70$var$REPLACE = $f9a22d5a80b70b70$var$wellKnownSymbol("replace");
var $f9a22d5a80b70b70$var$max = Math.max;
var $f9a22d5a80b70b70$var$min = Math.min;
var $f9a22d5a80b70b70$var$concat = $f9a22d5a80b70b70$var$uncurryThis([].concat);
var $f9a22d5a80b70b70$var$push = $f9a22d5a80b70b70$var$uncurryThis([].push);
var $f9a22d5a80b70b70$var$stringIndexOf = $f9a22d5a80b70b70$var$uncurryThis("".indexOf);
var $f9a22d5a80b70b70$var$stringSlice = $f9a22d5a80b70b70$var$uncurryThis("".slice);
var $f9a22d5a80b70b70$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $f9a22d5a80b70b70$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $f9a22d5a80b70b70$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$f9a22d5a80b70b70$var$REPLACE]) return /./[$f9a22d5a80b70b70$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $f9a22d5a80b70b70$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$f9a22d5a80b70b70$var$fails(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$f9a22d5a80b70b70$var$fixRegExpWellKnownSymbolLogic("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $f9a22d5a80b70b70$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $f9a22d5a80b70b70$var$requireObjectCoercible(this);
            var replacer = searchValue == undefined ? undefined : $f9a22d5a80b70b70$var$getMethod(searchValue, $f9a22d5a80b70b70$var$REPLACE);
            return replacer ? $f9a22d5a80b70b70$var$call(replacer, searchValue, O, replaceValue) : $f9a22d5a80b70b70$var$call(nativeReplace, $f9a22d5a80b70b70$var$toString(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $f9a22d5a80b70b70$var$anObject(this);
            var S = $f9a22d5a80b70b70$var$toString(string);
            if (typeof replaceValue == "string" && $f9a22d5a80b70b70$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $f9a22d5a80b70b70$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $f9a22d5a80b70b70$var$isCallable(replaceValue);
            if (!functionalReplace) replaceValue = $f9a22d5a80b70b70$var$toString(replaceValue);
            var global1 = rx.global;
            if (global1) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $f9a22d5a80b70b70$var$regExpExec(rx, S);
                if (result === null) break;
                $f9a22d5a80b70b70$var$push(results, result);
                if (!global1) break;
                var matchStr = $f9a22d5a80b70b70$var$toString(result[0]);
                if (matchStr === "") rx.lastIndex = $f9a22d5a80b70b70$var$advanceStringIndex(S, $f9a22d5a80b70b70$var$toLength(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $f9a22d5a80b70b70$var$toString(result[0]);
                var position = $f9a22d5a80b70b70$var$max($f9a22d5a80b70b70$var$min($f9a22d5a80b70b70$var$toIntegerOrInfinity(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$f9a22d5a80b70b70$var$push(captures, $f9a22d5a80b70b70$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $f9a22d5a80b70b70$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $f9a22d5a80b70b70$var$push(replacerArgs, namedCaptures);
                    var replacement = $f9a22d5a80b70b70$var$toString($f9a22d5a80b70b70$var$apply(replaceValue, undefined, replacerArgs));
                } else replacement = $f9a22d5a80b70b70$var$getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $f9a22d5a80b70b70$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $f9a22d5a80b70b70$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$f9a22d5a80b70b70$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$f9a22d5a80b70b70$var$REPLACE_KEEPS_$0 || $f9a22d5a80b70b70$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f9a22d5a80b70b70$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
var $f9a22d5a80b70b70$var$icon = `data:image/png;base64,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`;
const $f9a22d5a80b70b70$var$resolveWalletUrl = (network, walletUrl)=>{
    if (walletUrl) return walletUrl;
    switch(network.networkId){
        case "mainnet":
            return "https://app.mynearwallet.com";
        case "testnet":
            return "https://testnet.mynearwallet.com";
        default:
            throw new Error("Invalid wallet url");
    }
};
const $f9a22d5a80b70b70$var$setupWalletState = (params, network)=>$f9a22d5a80b70b70$var$__awaiter(void 0, void 0, void 0, function*() {
        const keyStore = new $e9c96496ce82840e$exports.keyStores.BrowserLocalStorageKeyStore();
        const near = yield $e9c96496ce82840e$exports.connect(Object.assign(Object.assign({
            keyStore: keyStore,
            walletUrl: params.walletUrl
        }, network), {
            headers: {}
        }));
        const wallet = new $e9c96496ce82840e$exports.WalletConnection(near, "near_app");
        return {
            wallet: wallet,
            keyStore: keyStore
        };
    });
const $f9a22d5a80b70b70$var$MyNearWallet = ({ metadata: metadata, options: options, store: store, params: params, logger: logger })=>$f9a22d5a80b70b70$var$__awaiter(void 0, void 0, void 0, function*() {
        const _state = yield $f9a22d5a80b70b70$var$setupWalletState(params, options.network);
        const getAccounts = ()=>$f9a22d5a80b70b70$var$__awaiter(void 0, void 0, void 0, function*() {
                const accountId = _state.wallet.getAccountId();
                const account = _state.wallet.account();
                if (!accountId || !account) return [];
                const publicKey = yield account.connection.signer.getPublicKey(account.accountId, options.network.networkId);
                return [
                    {
                        accountId: accountId,
                        publicKey: publicKey ? publicKey.toString() : ""
                    }
                ];
            });
        const transformTransactions = (transactions)=>$f9a22d5a80b70b70$var$__awaiter(void 0, void 0, void 0, function*() {
                const account = _state.wallet.account();
                const { networkId: networkId, signer: signer, provider: provider } = account.connection;
                const localKey = yield signer.getPublicKey(account.accountId, networkId);
                return Promise.all(transactions.map((transaction, index)=>$f9a22d5a80b70b70$var$__awaiter(void 0, void 0, void 0, function*() {
                        const actions = transaction.actions.map((action)=>(0, $5aa677c457ee63c9$export$309c7a02b0b0bc62)(action));
                        const accessKey = yield account.accessKeyForTransaction(transaction.receiverId, actions, localKey);
                        if (!accessKey) throw new Error(`Failed to find matching key for transaction sent to ${transaction.receiverId}`);
                        const block = yield provider.block({
                            finality: "final"
                        });
                        return $e9c96496ce82840e$exports.transactions.createTransaction(account.accountId, $e9c96496ce82840e$exports.utils.PublicKey.from(accessKey.public_key), transaction.receiverId, accessKey.access_key.nonce + index + 1, actions, $e9c96496ce82840e$exports.utils.serialize.base_decode(block.header.hash));
                    })));
            });
        return {
            signIn ({ contractId: contractId, methodNames: methodNames, successUrl: successUrl, failureUrl: failureUrl }) {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    const existingAccounts = yield getAccounts();
                    if (existingAccounts.length) return existingAccounts;
                    yield _state.wallet.requestSignIn({
                        contractId: contractId,
                        methodNames: methodNames,
                        successUrl: successUrl,
                        failureUrl: failureUrl
                    });
                    return getAccounts();
                });
            },
            signOut () {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    if (_state.wallet.isSignedIn()) _state.wallet.signOut();
                });
            },
            getAccounts () {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    return getAccounts();
                });
            },
            verifyOwner ({ message: message, callbackUrl: callbackUrl, meta: meta }) {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("verifyOwner", {
                        message: message
                    });
                    const account = _state.wallet.account();
                    if (!account) throw new Error("Wallet not signed in");
                    const locationUrl = typeof window !== "undefined" ? window.location.href : "";
                    const url = callbackUrl || locationUrl;
                    if (!url) throw new Error(`The callbackUrl is missing for ${metadata.name}`);
                    const encodedUrl = encodeURIComponent(url);
                    const extraMeta = meta ? `&meta=${meta}` : "";
                    window.location.replace(`${params.walletUrl}/verify-owner?message=${message}&callbackUrl=${encodedUrl}${extraMeta}`);
                    return;
                });
            },
            signAndSendTransaction ({ signerId: signerId, receiverId: receiverId, actions: actions, callbackUrl: callbackUrl }) {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("signAndSendTransaction", {
                        signerId: signerId,
                        receiverId: receiverId,
                        actions: actions,
                        callbackUrl: callbackUrl
                    });
                    const { contract: contract } = store.getState();
                    if (!_state.wallet.isSignedIn() || !contract) throw new Error("Wallet not signed in");
                    const account = _state.wallet.account();
                    return account["signAndSendTransaction"]({
                        receiverId: receiverId || contract.contractId,
                        actions: actions.map((action)=>(0, $5aa677c457ee63c9$export$309c7a02b0b0bc62)(action)),
                        walletCallbackUrl: callbackUrl
                    });
                });
            },
            signAndSendTransactions ({ transactions: transactions, callbackUrl: callbackUrl }) {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("signAndSendTransactions", {
                        transactions: transactions,
                        callbackUrl: callbackUrl
                    });
                    if (!_state.wallet.isSignedIn()) throw new Error("Wallet not signed in");
                    return _state.wallet.requestSignTransactions({
                        transactions: yield transformTransactions(transactions),
                        callbackUrl: callbackUrl
                    });
                });
            },
            buildImportAccountsUrl () {
                return `${params.walletUrl}/batch-import`;
            }
        };
    });
function $f9a22d5a80b70b70$export$173acaf083c7f609({ walletUrl: walletUrl, iconUrl: iconUrl = $f9a22d5a80b70b70$var$icon, deprecated: deprecated = false, successUrl: successUrl = "", failureUrl: failureUrl = "" } = {}) {
    return ()=>$f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
            return {
                id: "my-near-wallet",
                type: "browser",
                metadata: {
                    name: "MyNearWallet",
                    description: "NEAR wallet to store, buy, send and stake assets for DeFi.",
                    iconUrl: iconUrl,
                    deprecated: deprecated,
                    available: true,
                    successUrl: successUrl,
                    failureUrl: failureUrl
                },
                init: (options)=>{
                    return $f9a22d5a80b70b70$var$MyNearWallet(Object.assign(Object.assign({}, options), {
                        params: {
                            walletUrl: $f9a22d5a80b70b70$var$resolveWalletUrl(options.options.network, walletUrl)
                        }
                    }));
                }
            };
        });
}



var $6ZWSX = parcelRequire("6ZWSX");
var $2a31d1ee984c816f$require$Buffer = $6ZWSX.Buffer;
const $2a31d1ee984c816f$var$THIRTY_TGAS = "30000000000000";
const $2a31d1ee984c816f$var$NO_DEPOSIT = "0";
class $2a31d1ee984c816f$export$bcca3ea514774656 {
    walletSelector;
    wallet;
    network;
    createAccessKeyFor;
    constructor({ createAccessKeyFor: createAccessKeyFor, network: network = "testnet" }){
        // Login to a wallet passing a contractId will create a local
        // key, so the user skips signing non-payable transactions.
        // Omitting the accountId will result in the user being
        // asked to sign all transactions.
        this.createAccessKeyFor = createAccessKeyFor;
        this.network = network;
    }
    // To be called when the website loads
    async startUp() {
        this.walletSelector = await (0, $5bb7220e37bd460f$export$f9bdc9e9de5b988e)({
            network: this.network,
            modules: [
                (0, $f9a22d5a80b70b70$export$173acaf083c7f609)({
                    iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ea1b12ab6682ab47$exports)))
                }),
                (0, $565c2a6f56aa7a90$export$96cd127ba6f0e09e)({
                    iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($d8854490a0ef0108$exports)))
                })
            ]
        });
        const isSignedIn = this.walletSelector.isSignedIn();
        if (isSignedIn) {
            this.wallet = await this.walletSelector.wallet();
            this.accountId = this.walletSelector.store.getState().accounts[0].accountId;
        }
        return isSignedIn;
    }
    // Sign-in method
    signIn() {
        const description = "Please select a wallet to sign in.";
        const modal = (0, $6daeff2c8e1d7f1b$export$60f0f9f4cfa9469a)(this.walletSelector, {
            contractId: this.createAccessKeyFor,
            description: description
        });
        modal.show();
    }
    // Sign-out method
    signOut() {
        this.wallet.signOut();
        this.wallet = this.accountId = this.createAccessKeyFor = null;
        window.location.replace(window.location.origin + window.location.pathname);
    }
    // Make a read-only call to retrieve information from the network
    async viewMethod({ contractId: contractId, method: method, args: args = {} }) {
        const { network: network } = this.walletSelector.options;
        const provider = new (0, $e9c96496ce82840e$exports.providers).JsonRpcProvider({
            url: network.nodeUrl
        });
        let res = await provider.query({
            request_type: "call_function",
            account_id: contractId,
            method_name: method,
            args_base64: $2a31d1ee984c816f$require$Buffer.from(JSON.stringify(args)).toString("base64"),
            finality: "optimistic"
        });
        return JSON.parse($2a31d1ee984c816f$require$Buffer.from(res.result).toString());
    }
    // Call a method that changes the contract's state
    async callMethod({ contractId: contractId, method: method, args: args = {}, gas: gas = $2a31d1ee984c816f$var$THIRTY_TGAS, deposit: deposit = $2a31d1ee984c816f$var$NO_DEPOSIT }) {
        // Sign a transaction with the "FunctionCall" action
        const outcome = await this.wallet.signAndSendTransaction({
            signerId: this.accountId,
            receiverId: contractId,
            actions: [
                {
                    type: "FunctionCall",
                    params: {
                        methodName: method,
                        args: args,
                        gas: gas,
                        deposit: deposit
                    }
                }
            ]
        });
        return (0, $e9c96496ce82840e$exports.providers).getTransactionLastResult(outcome);
    }
    // Get transaction result from the network
    async getTransactionResult(txhash) {
        const { network: network } = this.walletSelector.options;
        const provider = new (0, $e9c96496ce82840e$exports.providers).JsonRpcProvider({
            url: network.nodeUrl
        });
        // Retrieve transaction result from the network
        const transaction = await provider.txStatus(txhash, "unnused");
        return (0, $e9c96496ce82840e$exports.providers).getTransactionLastResult(transaction);
    }
}


const $dad545c909cfec2d$var$CONTRACT = "donation-app.testnet";
// When creating the wallet you can choose to create an access key, so the user
// can skip signing non-payable methods when interacting with the contract
const $dad545c909cfec2d$var$wallet = new (0, $2a31d1ee984c816f$export$bcca3ea514774656)("");
// Abstract the logic of interacting with the contract to simplify your project
const $dad545c909cfec2d$var$contract = new (0, $5ef75267231851bc$export$8517d80acf00e19a)({
    contractId: $dad545c909cfec2d$var$CONTRACT,
    walletToUse: $dad545c909cfec2d$var$wallet
});
// Setup on page load
window.onload = async ()=>{
    const isSignedIn = await $dad545c909cfec2d$var$wallet.startUp();
    if (isSignedIn) $dad545c909cfec2d$var$signedInFlow();
    else $dad545c909cfec2d$var$signedOutFlow();
    $dad545c909cfec2d$var$fetchBeneficiary();
    $dad545c909cfec2d$var$getAndShowDonations();
};
// On submit, get the greeting and send it to the contract
document.querySelector("form").onsubmit = async (event)=>{
    event.preventDefault();
    // get elements from the form using their id attribute
    const { fieldset: fieldset, donation: donation } = event.target.elements;
    // disable the form while the value gets updated on-chain
    fieldset.disabled = true;
    try {
        await $dad545c909cfec2d$var$contract.donate(donation.value);
    } catch (e) {
        alert("Something went wrong! Maybe you need to sign out and back in? Check your browser console for more info.");
        throw e;
    }
    // re-enable the form, whether the call succeeded or failed
    fieldset.disabled = false;
};
document.querySelector("#sign-in-button").onclick = ()=>{
    $dad545c909cfec2d$var$wallet.signIn();
};
document.querySelector("#sign-out-button").onclick = ()=>{
    $dad545c909cfec2d$var$wallet.signOut();
};
async function $dad545c909cfec2d$var$fetchBeneficiary() {
    // Get greeting from the contract
    // const currentGreeting = await contract.getBeneficiaryName();
    const total_amount = await $dad545c909cfec2d$var$contract.get_total_amount();
    const total_donors = await $dad545c909cfec2d$var$contract.number_of_donors();
    const currentGreeting = await $dad545c909cfec2d$var$contract.getBeneficiaryName();
    const description = await $dad545c909cfec2d$var$contract.get_description();
    document.getElementById("total-amount-donated").innerHTML = total_amount + " \u24C3";
    document.getElementById("number_of_donors").innerHTML = total_donors;
    // Set all elements marked as greeting with the current greeting
    document.querySelectorAll("[data-behavior=beneficiary]").forEach((el)=>{
        el.innerText = currentGreeting;
        el.value = currentGreeting;
    });
    document.querySelector(".donation-description").innerHTML = description;
}
// Display the signed-out-flow container
function $dad545c909cfec2d$var$signedOutFlow() {
    document.querySelector(".signed-out-flow").style.display = "block";
}
async function $dad545c909cfec2d$var$signedInFlow() {
    // Displaying the signed in flow container
    document.querySelectorAll(".signed-in-flow").forEach((elem)=>elem.style.display = "block");
    // Check if there is a transaction hash in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const txhash = urlParams.get("transactionHashes");
    if (txhash !== null) {
        // Get result from the transaction
        let result = await $dad545c909cfec2d$var$contract.getDonationFromTransaction(txhash);
        document.querySelector("[data-behavior=donation-so-far]").innerText = result;
        // show notification
        document.querySelector("[data-behavior=notification]").style.display = "block";
        // remove notification again after css animation completes
        setTimeout(()=>{
            document.querySelector("[data-behavior=notification]").style.display = "none";
        }, 11000);
    }
}
async function $dad545c909cfec2d$var$getAndShowDonations() {
    document.getElementById("donations-table").innerHTML = "Loading ....";
    // Load last 10 donations
    let donations = await $dad545c909cfec2d$var$contract.latestDonations();
    console.log(donations);
    let top_donors = await $dad545c909cfec2d$var$contract.topDonors();
    document.getElementById("donations-table").innerHTML = "";
    document.getElementById("top-donars-table").innerHTML = "";
    donations.forEach((elem)=>{
        let tr = document.createElement("tr");
        tr.innerHTML = `
      <tr>
        <th scope="row">${elem.account_id}</th>
        <td>${elem.total_amount}</td>
      </tr>
    `;
        document.getElementById("donations-table").appendChild(tr);
    });
    top_donors.forEach((elem)=>{
        let tr = document.createElement("tr");
        tr.innerHTML = `
      <tr>
        <th scope="row">${elem.account_id}</th>
        <td>${elem.total_amount}</td>
      </tr>
    `;
        document.getElementById("top-donars-table").appendChild(tr);
    });
}
let $dad545c909cfec2d$var$get_donation = document.getElementById("get-donation-button").onclick = async function() {
    const a = document.getElementById("inputPassword2");
    console.log(a.value);
    let account_id = a.value;
    let donation = await $dad545c909cfec2d$var$contract.getDonationFromAccount(account_id);
    document.getElementById("get-donation").innerHTML = donation.concat(" \u24C3");
    console.log(donation);
};
window.set_donation = async function(amount) {
    let data = await fetch("https://api.coingecko.com/api/v3/simple/price?ids=near&vs_currencies=usd").then((response)=>response.json());
    const near2usd = data["near"]["usd"];
    const amount_in_near = amount / near2usd;
    const rounded_two_decimals = Math.round(amount_in_near * 100) / 100;
    document.querySelector("#donation").value = rounded_two_decimals;
};


//# sourceMappingURL=index.d16bb9ad.js.map
